(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire55c8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire55c8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ef6Fp", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\x00") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("jowe3", function(module, exports) {
module.exports = JSON.parse('[{"CODE":"STS3006","TITLE":"Basic Competitive Coding - I","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"CHY1001","TITLE":"Chemistry & Environmental Studies","TYPE":"LO","CREDITS":4,"SLOT":"E1"},{"CODE":"CHY1005","TITLE":"Industrial Chemistry for Engineers","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1"},{"CODE":"CHY1005","TITLE":"Industrial Chemistry for Engineers","TYPE":"TH","CREDITS":4,"SLOT":"G2+TG2"},{"CODE":"CHY1005","TITLE":"Industrial Chemistry for Engineers","TYPE":"TH","CREDITS":4,"SLOT":"G1+TG1"},{"CODE":"CHY1006","TITLE":"Corrosion Science and Engineering","TYPE":"TH","CREDITS":4,"SLOT":"E2+TE2"},{"CODE":"CHY1006","TITLE":"Corrosion Science and Engineering","TYPE":"TH","CREDITS":4,"SLOT":"F2+TF2"},{"CODE":"CHY1006","TITLE":"Corrosion Science and Engineering","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1"},{"CODE":"CHY1007","TITLE":"Energy Materials and Their Applications","TYPE":"TH","CREDITS":4,"SLOT":"B2+TB2"},{"CODE":"CHY1007","TITLE":"Energy Materials and Their Applications","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2"},{"CODE":"CHY1007","TITLE":"Energy Materials and Their Applications","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1"},{"CODE":"CHY2001","TITLE":"Chemical and Biosensors","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2"},{"CODE":"CHY2002","TITLE":"Organic Electronics","TYPE":"TH","CREDITS":4,"SLOT":"B2+TB2"},{"CODE":"CHY2002","TITLE":"Organic Electronics","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"Prof.Sukanta Nayak","VENUE":"110 - CB"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"Prof.Manisha Maity ","VENUE":"219-CB"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"B2+TB2+TBB2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"B2+TB2+TBB2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"B2+TB2+TBB2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2"},{"CODE":"MAT1007","TITLE":"Discrete Mathematics","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2"},{"CODE":"MAT1007","TITLE":"Discrete Mathematics","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1"},{"CODE":"MAT1007","TITLE":"Discrete Mathematics","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1"},{"CODE":"MAT1007","TITLE":"Discrete Mathematics","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1"},{"CODE":"MAT1007","TITLE":"Discrete Mathematics","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2"},{"CODE":"MAT1007","TITLE":"Discrete Mathematics","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1"},{"CODE":"MAT1007","TITLE":"Discrete Mathematics","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"Prof.Venkatarajam M","VENUE":"226 - CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"Prof.Venkatarajam M","VENUE":"G15- CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"MAT2001","TITLE":"Numerical Methods for Engineers","SLOT":"C1"},{"CODE":"MAT2001","TITLE":"Numerical Methods for Engineers","SLOT":"E1"},{"CODE":"MAT2001","TITLE":"Numerical Methods for Engineers","SLOT":"E2"},{"CODE":"MAT2002","TITLE":"Complex Variables and Partial Differential Equations","SLOT":"A2+TA2"},{"CODE":"MAT2002","TITLE":"Complex Variables and Partial Differential Equations","SLOT":"A1+TA1"},{"CODE":"MAT2003","TITLE":"Optimization Techniques","SLOT":"A2+TA2"},{"CODE":"MAT2005","TITLE":"Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"MAT2005","TITLE":"Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"MAT2009","TITLE":"Computational Statistics","SLOT":"F1+TF1"},{"CODE":"MAT2009","TITLE":"Computational Statistics","SLOT":"A1+TA1"},{"CODE":"MAT2009","TITLE":"Computational Statistics","SLOT":"C2+TC2"},{"CODE":"MAT2011","TITLE":"Graph Theory and Applications","SLOT":"C2+TC2"},{"CODE":"PHY2004","TITLE":"Optoelectronics","SLOT":"G2+TG2"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"Prof.Ganesh Kotagiri","VENUE":" 230 - CB"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"PHY2006","TITLE":"Solar Photovoltaics : Fundamentals and Technologies","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"PHY2006","TITLE":"Solar Photovoltaics : Fundamentals and Technologies","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"ETL","CREDITS":3,"SLOT":"E1"},{"CODE":"CSE1008","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1"},{"CODE":"CSE1008","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+G1+TA1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+G1+TA1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+G1+TA1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+G1+TA1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+G1+TA1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+G1+TA1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+G1+TA1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1+TBB1+TG1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1+TBB1+TG1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1+TBB1+TG1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1+TBB1+TG1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1+TBB1+TG1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1+TBB1+TG1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1+TBB1+TG1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1+TBB1+TG1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1+TBB1+TG1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1+TBB1+TG1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1+TBB1+TG1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1+TBB1+TG1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+G2+TA2","FACULTY":"Prof.Naga Jagadesh Bommagani -\\n","VENUE":"110-CB"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+G2+TA2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+G2+TA2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+G2+TA2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+G2+TA2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+G2+TA2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+G2+TA2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+G2+TA2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2+TBB2+TG2","FACULTY":"Prof.Bharathi V C","VENUE":"G09 - CB"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2+TBB2+TG2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2+TBB2+TG2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2+TBB2+TG2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2+TBB2+TG2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2+TBB2+TG2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2+TBB2+TG2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2+TBB2+TG2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2+TBB2+TG2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2+TBB2+TG2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2+TBB2+TG2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2+TBB2+TG2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+G1+TA1"},{"CODE":"CSE2009","TITLE":"Soft Computing","SLOT":"C1+TC1"},{"CODE":"CSE2009","TITLE":"Soft Computing","SLOT":"D2+TD2"},{"CODE":"CSE2010","TITLE":"Secure Coding","SLOT":"C2+TC2"},{"CODE":"CSE2011","TITLE":"Cyber Security and Digital Forensics","SLOT":"D2+TD2"},{"CODE":"CSE3001","TITLE":"Agile Development Process","SLOT":"F1+TF1"},{"CODE":"CSE3001","TITLE":"Agile Development Process","SLOT":"A2+TA2"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"CSE3008","TITLE":"Introduction to Machine Learning","SLOT":"D2+TD2"},{"CODE":"CSE3008","TITLE":"Introduction to Machine Learning","SLOT":"C1+TC1"},{"CODE":"CSE3009","TITLE":"No SQL Databases","SLOT":"A2+TA2"},{"CODE":"CSE3012","TITLE":"Network Security","SLOT":"D2+TD2"},{"CODE":"CSE3018","TITLE":"Software Configuration Management","SLOT":"F2+TF2"},{"CODE":"CSE3019","TITLE":"Software Quality and Reliability","SLOT":"B2+TB2"},{"CODE":"CSE3019","TITLE":"Software Quality and Reliability","SLOT":"E1+TE1"},{"CODE":"CSE3020","TITLE":"Product Definition and Validation","SLOT":"F2+TF2"},{"CODE":"CSE4005","TITLE":"Data Warehousing and Data Mining","SLOT":"B2+TB2"},{"CODE":"CSE4006","TITLE":"Deep Learning","SLOT":"G2+TG2"},{"CODE":"CSE4018","TITLE":"Computer Vision and Robotics","TYPE":"ETL","SLOT":"D1+TD1"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","SLOT":"B1+TB1"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","SLOT":"E1+TE1"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","SLOT":"B2+TB2"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","SLOT":"E2+TE2"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","SLOT":"B1+TB1"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","SLOT":"E1+TE1"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","SLOT":"A1+G1+TA1"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","SLOT":"B1+TB1+TBB1+TG1"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","SLOT":"A2+G2+TA2"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","SLOT":"B2+TB2+TBB2+TG2"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","SLOT":"A1+G1+TA1"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","SLOT":"B1+TB1+TBB1+TG1"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","SLOT":"A2+G2+TA2"},{"CODE":"SWE2002","TITLE":"Human Computer Interaction","SLOT":"G1+TG1"},{"CODE":"SWE2003","TITLE":"Requirements Engineering Management","SLOT":"C2+TC2"},{"CODE":"SWE2004","TITLE":"Software Design and Architecture","SLOT":"B1+TB1"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"C1+TC1"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"F1+TF1"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"C2+TC2"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"F2+TF2"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"C1+TC1"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"F1+TF1"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"F2+TF2"},{"CODE":"SWE2007","TITLE":"Fundamentals of Operating Systems","SLOT":"A2+TA2"},{"CODE":"SWE2008","TITLE":"Object Oriented Analysis and Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"SWE2008","TITLE":"Object Oriented Analysis and Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","SLOT":"F1+TF1"},{"CODE":"SWE3002","TITLE":"Software Project Management","SLOT":"D1+TD1"},{"CODE":"SWE3004","TITLE":"Front End Design and Testing","SLOT":"A2+TA2"},{"CODE":"SWE3004","TITLE":"Front End Design and Testing","SLOT":"A1+TA1"},{"CODE":"SWE4001","TITLE":"Internet and Web Technologies","SLOT":"C1+TC1"},{"CODE":"SWE4001","TITLE":"Internet and Web Technologies","SLOT":"F2+TF2"},{"CODE":"SWE4002","TITLE":"Software Testing","SLOT":"E1+TE1"},{"CODE":"SWE4003","TITLE":"Concepts of Mobile Application Development","SLOT":"D2+TD2"},{"CODE":"SWE4003","TITLE":"Concepts of Mobile Application Development","SLOT":"D1+TD1"},{"CODE":"SWE4004","TITLE":"Cloud Computing and its Applications","SLOT":"C1+TC1"},{"CODE":"SWE4005","TITLE":"Storage Technologies and Management","SLOT":"G1+TG1"},{"CODE":"CSE2013","TITLE":"Information Theory and Coding","SLOT":"B1+TB1+TBB1"},{"CODE":"CSE3031","TITLE":"Mobile Computing","SLOT":"G1+TG1"},{"CODE":"CSE4033","TITLE":"IT Project Management","SLOT":"E1"},{"CODE":"CSE3006","TITLE":"Data Visualization","SLOT":"E2+TE2"},{"CODE":"CSE4011","TITLE":"Internet of Things","SLOT":"C2+TC2"},{"CODE":"CSE4012","TITLE":"UI UX User Experience Design","SLOT":"B1+TB1"},{"CODE":"CSE4012","TITLE":"UI UX User Experience Design","SLOT":"A2+TA2"},{"CODE":"ECE4007","TITLE":"IoT System Architecture","SLOT":"G1"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","SLOT":"G1+TG1"},{"CODE":"ECE1010","TITLE":"Probability and Random Processes","SLOT":"A1+TA1+TAA1"},{"CODE":"ECE1010","TITLE":"Probability and Random Processes","SLOT":"A2+TA2+TAA2"},{"CODE":"ECE1010","TITLE":"Probability and Random Processes","SLOT":"B1+TB1+TBB1"},{"CODE":"ECE1010","TITLE":"Probability and Random Processes","SLOT":"B2+TB2+TBB2"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"Prof.Sudha Ellison Mathe -\\n","VENUE":"G18-CB"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"B2+TB2+TBB2"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"B2+TB2+TBB2"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"Prof.Ashish Gupta","VENUE":"G15 - CB"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"B2+TB2+TBB2"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2"},{"CODE":"ECE2007","TITLE":"Digital Signal Processing","SLOT":"B1+TB1"},{"CODE":"ECE3008","TITLE":"Neural Networks and Fuzzy Systems","SLOT":"D1+TD1+TDD1"},{"CODE":"ECE3009","TITLE":"Power Electronic Converters","SLOT":"C1+TC1"},{"CODE":"ECE4002","TITLE":"Wireless and Mobile Communications","SLOT":"A1+TA1"},{"CODE":"PHY1002","TITLE":"Semiconductor Device Physics","SLOT":"C1+TC1+TCC1"},{"CODE":"PHY1002","TITLE":"Semiconductor Device Physics","SLOT":"C2+TC2+TCC2"},{"CODE":"PHY1002","TITLE":"Semiconductor Device Physics","SLOT":"D1+TD1+TDD1"},{"CODE":"PHY1002","TITLE":"Semiconductor Device Physics","SLOT":"D2+TD2+TDD2"},{"CODE":"MEC2003","TITLE":"Strength of Materials","SLOT":"B1+TB1"},{"CODE":"MEC2004","TITLE":"Fluid Mechanics","SLOT":"D1+TD1"},{"CODE":"MEC2007","TITLE":"Introduction to Mechanical Engineering Design Process","SLOT":"C1+TC1"},{"CODE":"MEC3012","TITLE":"Additive Manufacturing","SLOT":"A1+TA1"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"B1+TB1"},{"CODE":"ENG1015","TITLE":"Introduction to 20th Century European Literature in Translation","SLOT":"A1+TA1"},{"CODE":"ENG3001","TITLE":"Introduction to Translation Studies","SLOT":"A2+TA2"},{"CODE":"ENG3004","TITLE":"Introducing Linguistics","SLOT":"F1"},{"CODE":"FRL1004","TITLE":"Basic Spanish","TYPE":"TH","SLOT":"F1"},{"CODE":"FRL2004","TITLE":"Korean for Beginners","TYPE":"TH","SLOT":"F1"},{"CODE":"FRL2004","TITLE":"Korean for Beginners","TYPE":"TH","SLOT":"F2"},{"CODE":"INL1001","TITLE":"Functional Hindi for non-Hindi Speakers","TYPE":"TH","SLOT":"G2"},{"CODE":"MAT2004","TITLE":"Applied Optimization Techniques","SLOT":"D1+TD1"},{"CODE":"STS1002","TITLE":"Fundamentals of Aptitude","SLOT":"D2+TD2"},{"CODE":"STS1002","TITLE":"Fundamentals of Aptitude","SLOT":"C1+TC1"},{"CODE":"STS1002","TITLE":"Fundamentals of Aptitude","SLOT":"D1+TD1"},{"CODE":"STS1002","TITLE":"Fundamentals of Aptitude","SLOT":"D1+TD1"},{"CODE":"STS1002","TITLE":"Fundamentals of Aptitude","SLOT":"A2+TA2"},{"CODE":"STS1002","TITLE":"Fundamentals of Aptitude","SLOT":"C2+TC2","FACULTY":"Prof.Sumanth","VENUE":"110 - CB"},{"CODE":"STS1002","TITLE":"Fundamentals of Aptitude","SLOT":"A1+TA1"},{"CODE":"STS1008","TITLE":"Arithmetic Problem Solving Skills","SLOT":"D2+TD2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"Prof.Musthaq","VENUE":"219 - CB"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS2008","TITLE":"Numerical Ability and Cognitive Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"STS2008","TITLE":"Numerical Ability and Cognitive Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS2008","TITLE":"Numerical Ability and Cognitive Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"STS2008","TITLE":"Numerical Ability and Cognitive Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"STS2008","TITLE":"Numerical Ability and Cognitive Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"STS2008","TITLE":"Numerical Ability and Cognitive Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS2008","TITLE":"Numerical Ability and Cognitive Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS2008","TITLE":"Numerical Ability and Cognitive Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS3004","TITLE":"Introduction to Programming Skills","TYPE":"TH","SLOT":"F2+TF2"},{"CODE":"ENG1001","TITLE":"English for Essential Communication","TYPE":"ETL","CREDITS":2,"SLOT":"F1"},{"CODE":"ENG1002","TITLE":"English for Effective Communication","TYPE":"ETL","CREDITS":2,"SLOT":"F2"},{"CODE":"ENG1005","TITLE":"Basic Communication in English","TYPE":"ETL","CREDITS":2,"SLOT":"F1"},{"CODE":"ENG1006","TITLE":"Functional Communication in English","TYPE":"ETL","CREDITS":2,"SLOT":"F2"},{"CODE":"ENG2001","TITLE":"English for Professional Communication","TYPE":"ETL","CREDITS":2,"SLOT":"E2"},{"CODE":"ENG2004","TITLE":"Advanced Professional Communication","TYPE":"ETL","CREDITS":2,"SLOT":"E2"},{"CODE":"FRL1001","TITLE":"Basic French","TYPE":"TH","SLOT":"F2"},{"CODE":"FRL1001","TITLE":"Basic French","TYPE":"TH","SLOT":"G2"},{"CODE":"FRL1001","TITLE":"Basic French","TYPE":"TH","SLOT":"G1"},{"CODE":"FRL1005","TITLE":"German for Beginners","TYPE":"TH","SLOT":"E1"},{"CODE":"FRL1005","TITLE":"German for Beginners","TYPE":"TH","SLOT":"E2"},{"CODE":"FRL1005","TITLE":"German for Beginners","TYPE":"TH","SLOT":"G2"},{"CODE":"FRL2003","TITLE":"French for Engineers","SLOT":"E1+TE1"},{"CODE":"INL1101","TITLE":"Foundations of Hindi Language","TYPE":"TH","SLOT":"E2"},{"CODE":"LIB1001","TITLE":"Anthropology \u2013 An Introduction","SLOT":"A1+TA1"},{"CODE":"LIB1003","TITLE":"Psychology - An Introduction","SLOT":"B1+TB1"},{"CODE":"LIB1007","TITLE":"Gender Studies - An Introduction","SLOT":"B2"},{"CODE":"LIB1014","TITLE":"Pursuit of Happiness","SLOT":"C1+TC1"},{"CODE":"LIB2003","TITLE":"Geography of Asia and Sub-Saharan Africa","SLOT":"F1+TF1"},{"CODE":"LIB2004","TITLE":"Ancient Indian History","SLOT":"A1+TA1+TAA1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","SLOT":"G2+TG2"},{"CODE":"HUM1002","TITLE":"Personal Finance for Engineers","TYPE":"TH","SLOT":"F2"},{"CODE":"HUM2003","TITLE":"Fundamentals of Cost and Management Accounting","SLOT":"A1+TA1+TAA1"},{"CODE":"MGT1002","TITLE":"Lean Start-up Management","SLOT":"E2+TE2"},{"CODE":"MGT1002","TITLE":"Lean Start-up Management","SLOT":"D1+TD1"},{"CODE":"MGT1005","TITLE":"Fundamentals of Creativity and Innovation Management","TYPE":"TH","SLOT":"C1"},{"CODE":"MGT1007","TITLE":"Economics for Engineers","SLOT":"D2+TD2"},{"CODE":"MGT1008","TITLE":"Accounting and Finance for Engineers","SLOT":"B2+TB2"},{"CODE":"MGT1011","TITLE":"Fundamentals of Business Strategy","SLOT":"B1+TB1"},{"CODE":"MGT1015","TITLE":"Fundamentals of Consumer Behaviour","SLOT":"E2+TE2"},{"CODE":"MGT1019","TITLE":"Fundamentals of Project Management","SLOT":"A2+TA2"},{"CODE":"MGT1023","TITLE":"Fundamentals of Human Resource Management","SLOT":"E1+TE1"},{"CODE":"MGT1037","TITLE":"Introduction to Management","SLOT":"E2+TE2"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"F2"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"F2"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"F1"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"E1"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"E1"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"F1"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"E2"},{"CODE":"MGT2016","TITLE":"Essentials of Marketing Management","SLOT":"D1+TD1+TDD1"},{"CODE":"MGT2019","TITLE":"Introduction to Business Environment","SLOT":"D2+TD2+TDD2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MR.ZUBER BASHA SHAIK -","VENUE":"G11-CB"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"Prof.Pradeep Singh","VENUE":"213 - CB"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"LAW1001","TITLE":"Law, Internet and Society","SLOT":"G1+TG1"},{"CODE":"LAW1002","TITLE":"Competition Law for Engineers","SLOT":"F2+TF2"},{"CODE":"LAW1002","TITLE":"Competition Law for Engineers","SLOT":"C2+TC2"},{"CODE":"LAW1003","TITLE":"Human Rights and Criminal Justice System","SLOT":"G2+TG2"},{"CODE":"LAW1005","TITLE":"Introduction to Indian Constitution","SLOT":"D1+TD1"},{"CODE":"LAW1005","TITLE":"Introduction to Indian Constitution","SLOT":"F1+TF1"},{"CODE":"LAW1008","TITLE":"Intellectual Property Law for Engineers","TYPE":"TH","SLOT":"D1+TD1+TDD1"},{"CODE":"LAW1008","TITLE":"Intellectual Property Law for Engineers","TYPE":"TH","SLOT":"C2+TC2+TCC2"},{"CODE":"LAW2001","TITLE":"Business and Human Rights","SLOT":"E2+TE2"},{"CODE":"MGT1029","TITLE":"Basic Law for Engineers","SLOT":"D2+TD2"},{"CODE":"MGT1029","TITLE":"Basic Law for Engineers","SLOT":"F1+TF1"},{"CODE":"STS3006","TITLE":"Basic Competitive Coding - I","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"STS3006","TITLE":"Basic Competitive Coding - I","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"STS3006","TITLE":"Basic Competitive Coding - I","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS3006","TITLE":"Basic Competitive Coding - I","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS3006","TITLE":"Basic Competitive Coding - I","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS3006","TITLE":"Basic Competitive Coding - I","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"CHY1001","TITLE":"Environmental Studies","TYPE":"TH","SLOT":"G2"},{"CODE":"CHY1005","TITLE":"Industrial Chemistry for Engineers","SLOT":"F1+TFF1"},{"CODE":"CHY1006","TITLE":"Corrosion Science and Engineering","SLOT":"E1+TEE1"},{"CODE":"CHY1007","TITLE":"Energy Materials and Their Applications","SLOT":"D1+TD1"},{"CODE":"CHY2001","TITLE":"Chemical and Biosensors","SLOT":"D2+TD2"},{"CODE":"CHY2002","TITLE":"Organic Electronics","SLOT":"E1+TE1"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"Prof.Sudhakar Matle","VENUE":"315-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"Prof.Chandan Kumar Thakur","VENUE":"G18-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"Prof.Komandla Mahipal Reddy","VENUE":"G16-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"Prof.Peeyush Singh","VENUE":"317-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"Prof.Manisha Maity","VENUE":"220-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"Prof.Manisha Maity","VENUE":"231-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"Prof.Phani Kumar Meduri","VENUE":"G12-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"Prof.Shah Parth Mukeshbhai","VENUE":"322-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"Prof.Lisna PC","VENUE":"G13-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"Prof.Francis P","VENUE":"315-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"Prof.Faizan Danish","VENUE":"424-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"Prof.Chandan Kumar Thakur","VENUE":"G18-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"Prof.Sudhakar Matle","VENUE":"325-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"Prof.Santunu Mandal","VENUE":"G17-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"Prof.Piu Kundu","VENUE":"318B-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"Prof.Sudhakar Matle","VENUE":"325-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"AASTHA MADONNA SATHE","VENUE":"323-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"Prof.Ranjan Kumar","VENUE":"231-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"Prof.Sukanta Nayak","VENUE":"312-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"Prof.Sukanta Nayak","VENUE":"G14-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"Prof.Komandla Mahipal Reddy","VENUE":"316-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"Prof.Davala Ravi Kumar","VENUE":"G17-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"Prof.Arun Kumar Yadav","VENUE":"314-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"Prof.Piu Kundu","VENUE":"313-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"Prof.Yada NanduKumar","VENUE":"322-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"Prof.Davala Ravi Kumar","VENUE":"423-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"DR.SUBHASIS PANDA","VENUE":"424-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"DR.ALKA MUNJAL","VENUE":"G15-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"DR.ANKIT","VENUE":"317-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"DR.ALKA MUNJAL","VENUE":"317-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"DR.HABIBA KHATUN","VENUE":"G15-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"Prof.Rajashekar Naraveni","VENUE":"317-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"Prof.Shah Parth Mukeshbhai","VENUE":"113-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"DR.HABIBA KHATUN","VENUE":"317-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"DR.NIMAI SARKAR","VENUE":"425-CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"DR.SAISTA TABSSUM","VENUE":"316-CB"},{"CODE":"MAT2001","TITLE":"Numerical Methods for Engineers","SLOT":"F2"},{"CODE":"MAT2001","TITLE":"Numerical Methods for Engineers","SLOT":"G1"},{"CODE":"MAT2002","TITLE":"Complex Variables and Partial Differential Equations","SLOT":"D2+TD2"},{"CODE":"MAT2002","TITLE":"Complex Variables and Partial Differential Equations","SLOT":"D1+TD1"},{"CODE":"MAT2003","TITLE":"Optimization Techniques","SLOT":"G1+TG1"},{"CODE":"MAT2003","TITLE":"Optimization Techniques","SLOT":"E2+TE2"},{"CODE":"MAT2005","TITLE":"Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"MAT2005","TITLE":"Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"MAT2005","TITLE":"Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"MAT2011","TITLE":"Graph Theory and Applications","SLOT":"D1+TD1"},{"CODE":"MAT2011","TITLE":"Graph Theory and Applications","SLOT":"D2+TD2"},{"CODE":"MAT2013","TITLE":"Financial Mathematics","SLOT":"D1+TD1+TDD1"},{"CODE":"PHY2004","TITLE":"Optoelectronics","SLOT":"D1+TD1"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"PHY2006","TITLE":"Solar Photovoltaics : Fundamentals and Technologies","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"Prof.Lakshmi Sowjanya Pali","VENUE":"324 - CB"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"ETL","CREDITS":4,"SLOT":"D1"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"ETL","CREDITS":4,"SLOT":"E1"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"ETL","CREDITS":4,"SLOT":"F1"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"ETL","CREDITS":4,"SLOT":"D2"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"ETL","CREDITS":4,"SLOT":"E2"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"ETL","CREDITS":4,"SLOT":"F2","FACULTY":"Potu Bharat ","VENUE":"316-CB"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"ETL","CREDITS":4,"SLOT":"G1"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"ETL","CREDITS":4,"SLOT":"G2"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"ETL","CREDITS":4,"SLOT":"F1"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"ETL","CREDITS":4,"SLOT":"F2"},{"CODE":"CSE1007","TITLE":"Introduction to Cryptography","TYPE":"ETL","CREDITS":4,"SLOT":"D1+TD1","FACULTY":"Prof.Saroj Kumar Panigraphy","VENUE":"G13 - CB"},{"CODE":"CSE1007","TITLE":"Introduction to Cryptography","TYPE":"ETL","CREDITS":4,"SLOT":"D2+TD2","FACULTY":"Prof.Saroj Kumar Panigraphy","VENUE":"112 - CB"},{"CODE":"CSE2003","TITLE":"Requirements Engineering Management","SLOT":"D1+TD1"},{"CODE":"CSE2003","TITLE":"Requirements Engineering Management","SLOT":"D2+TD2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"Prof.Anitha Rani Palakayala","VENUE":"214 - CB"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"Prof.Selva Kumar S ","VENUE":"113 - CB"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"Pulipati Nagaraju","VENUE":"114-CB"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"Prof.Radha Mohan Pattanayak","VENUE":"113 - CB"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"TAALAM NAGA RAJU","VENUE":"114-CB"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE2011","TITLE":"Cyber Security and Digital Forensics","SLOT":"C1+TC1"},{"CODE":"CSE2011","TITLE":"Cyber Security and Digital Forensics","SLOT":"C2+TC2"},{"CODE":"CSE2012","TITLE":"Knowledge Representation and Reasoning","SLOT":"F1+TFF1"},{"CODE":"CSE2012","TITLE":"Knowledge Representation and Reasoning","SLOT":"F2+TF2"},{"CODE":"CSE2012","TITLE":"Knowledge Representation and Reasoning","SLOT":"C1+TC1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"E2+TEE2"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"F2+TFF2"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"DEVEE SIVA PRASAD DULAM","VENUE":"G15 - CB"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"E1+TEE1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"F1+TFF1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"PROF.CH KIRAN KUMAR","VENUE":"G12 - CB"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"DEVEE SIVA PRASAD DULAM","VENUE":"G15 - CB"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"DEVEE SIVA PRASAD DULAM","VENUE":"G15 - CB"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"Prof.Sanket Mishra","VENUE":"220 - CB"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"Spandana Mande ","VENUE":"G13-CB"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"Prof.Arunkumar Balakrishnan","VENUE":"225 - CB"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"Prof.Bommareddy Lokesh","VENUE":"231 - CB"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"CSE3008","TITLE":"Introduction to Machine Learning","SLOT":"E2+TE2"},{"CODE":"CSE3008","TITLE":"Introduction to Machine Learning","SLOT":"D1+TD1"},{"CODE":"CSE3009","TITLE":"No SQL Databases","SLOT":"G2+TG2"},{"CODE":"CSE3009","TITLE":"No SQL Databases","SLOT":"D1+TD1"},{"CODE":"CSE3009","TITLE":"No SQL Databases","SLOT":"D2+TD2"},{"CODE":"CSE3009","TITLE":"No SQL Databases","SLOT":"E1+TE1"},{"CODE":"CSE3009","TITLE":"No SQL Databases","SLOT":"E2+TE2"},{"CODE":"CSE3011","TITLE":"Network Programming","SLOT":"F1+TF1"},{"CODE":"CSE3011","TITLE":"Network Programming","SLOT":"C2+TC2"},{"CODE":"CSE3011","TITLE":"Network Programming","SLOT":"G1+TG1"},{"CODE":"CSE3012","TITLE":"Network Security","SLOT":"D1+TD1"},{"CODE":"CSE3012","TITLE":"Network Security","SLOT":"D2+TD2"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"F2+TFF2"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"G1+TG1"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"G2+TG2"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"D1+TD1"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"E1+TEE1"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"E2+TEE2"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"C1+TC1"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"C2+TC2"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"D1+TD1"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"D2+TD2"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"G1+TG1"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"F1+TF1"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"F2+TF2"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"F1+TFF1"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"G2+TG2"},{"CODE":"CSE3016","TITLE":"Cloud Computing and Security","SLOT":"F1+TF1"},{"CODE":"CSE3017","TITLE":"Cloud Big Data Analytics","SLOT":"D2+TD2"},{"CODE":"CSE3018","TITLE":"Software Configuration Management","SLOT":"B2+TB2"},{"CODE":"CSE3018","TITLE":"Software Configuration Management","SLOT":"C1+TC1"},{"CODE":"CSE3033","TITLE":"Software Verification and Validation","SLOT":"E1+TE1"},{"CODE":"CSE4001","TITLE":"Cloud Computing","SLOT":"D1+TD1"},{"CODE":"CSE4001","TITLE":"Cloud Computing","SLOT":"D2+TD2"},{"CODE":"CSE4001","TITLE":"Cloud Computing","SLOT":"E1+TE1"},{"CODE":"CSE4001","TITLE":"Cloud Computing","SLOT":"E2+TE2"},{"CODE":"CSE4005","TITLE":"Data Warehousing and Data Mining","SLOT":"D1+TD1"},{"CODE":"CSE4005","TITLE":"Data Warehousing and Data Mining","SLOT":"D2+TD2"},{"CODE":"CSE4005","TITLE":"Data Warehousing and Data Mining","SLOT":"E1+TE1"},{"CODE":"CSE4005","TITLE":"Data Warehousing and Data Mining","SLOT":"E2+TE2"},{"CODE":"CSE4008","TITLE":"Social Network Analysis","SLOT":"F2+TF2"},{"CODE":"CSE4008","TITLE":"Social Network Analysis","SLOT":"G1+TG1"},{"CODE":"CSE4008","TITLE":"Social Network Analysis","SLOT":"C2+TC2"},{"CODE":"CSE4008","TITLE":"Social Network Analysis","SLOT":"E2+TEE2"},{"CODE":"CSE4008","TITLE":"Social Network Analysis","SLOT":"F1+TF1"},{"CODE":"CSE4016","TITLE":"Database Administration","SLOT":"F2+TFF2"},{"CODE":"CSE4016","TITLE":"Database Administration","SLOT":"F1+TF1"},{"CODE":"CSE4016","TITLE":"Database Administration","SLOT":"E2+TEE2"},{"CODE":"CSE4019","TITLE":"Applications of Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"CSE4019","TITLE":"Applications of Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"CSE4019","TITLE":"Applications of Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"CSE4019","TITLE":"Applications of Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"F2+TFF2"},{"CODE":"CSE4019","TITLE":"Applications of Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"E2+TEE2"},{"CODE":"CSE4031","TITLE":"Web Application Security","SLOT":"E1+TEE1"},{"CODE":"CSE4031","TITLE":"Web Application Security","SLOT":"E2+TEE2"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","SLOT":"C1+TC1"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","SLOT":"C2+TC2"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","SLOT":"D1+TD1"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","SLOT":"D2+TD2"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","SLOT":"E1+TE1"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","SLOT":"E2+TEE2"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","SLOT":"F1+TF1"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","SLOT":"F2+TFF2"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","SLOT":"D1+TD1"},{"CODE":"CSE4040","TITLE":"Mining Massive Data Sets","SLOT":"D2+TD2"},{"CODE":"CSE4040","TITLE":"Mining Massive Data Sets","SLOT":"E2+TE2"},{"CODE":"CSE4040","TITLE":"Mining Massive Data Sets","SLOT":"E1+TE1"},{"CODE":"CSE4042","TITLE":"Blockchain Platforms and Applications","SLOT":"E1+TEE1"},{"CODE":"CSE4044","TITLE":"Software Defined Networks and Network Function Virtualization","SLOT":"D1+TD1"},{"CODE":"ECE3001","TITLE":"Linear Integrated Circuits and Applications","SLOT":"A1+TA1"},{"CODE":"ECE3001","TITLE":"Linear Integrated Circuits and Applications","SLOT":"A2+TA2"},{"CODE":"ECE3001","TITLE":"Linear Integrated Circuits and Applications","SLOT":"B1+TB1"},{"CODE":"SWE2002","TITLE":"Human Computer Interaction","SLOT":"E1+TEE1"},{"CODE":"SWE2002","TITLE":"Human Computer Interaction","SLOT":"E2+TEE2"},{"CODE":"SWE2002","TITLE":"Human Computer Interaction","SLOT":"F1+TFF1"},{"CODE":"SWE2002","TITLE":"Human Computer Interaction","SLOT":"F2+TFF2"},{"CODE":"SWE2004","TITLE":"Software Design and Architecture","SLOT":"C1+TC1"},{"CODE":"SWE2004","TITLE":"Software Design and Architecture","SLOT":"C2+TC2"},{"CODE":"SWE2004","TITLE":"Software Design and Architecture","SLOT":"A2+TA2"},{"CODE":"SWE2004","TITLE":"Software Design and Architecture","SLOT":"B2+TB2"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"A1+TA1"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"B1+TB1"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"C1+TC1"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"A2+TA2"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"B2+TB2"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"C2+TC2"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"A1+TA1"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","SLOT":"A1+TA1"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","SLOT":"B1+TB1"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","SLOT":"C1+TC1"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","SLOT":"A2+TA2"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","SLOT":"B2+TB2"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","SLOT":"C2+TC2"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","SLOT":"B1+TB1"},{"CODE":"SWE3002","TITLE":"Software Project Management","SLOT":"F1+TFF1"},{"CODE":"SWE3002","TITLE":"Software Project Management","SLOT":"D1+TD1"},{"CODE":"SWE3002","TITLE":"Software Project Management","SLOT":"D2+TD2"},{"CODE":"SWE3002","TITLE":"Software Project Management","SLOT":"F2+TFF2"},{"CODE":"SWE3003","TITLE":"Information and System Security","SLOT":"D1+TD1"},{"CODE":"SWE3003","TITLE":"Information and System Security","SLOT":"E2+TEE2"},{"CODE":"SWE3003","TITLE":"Information and System Security","SLOT":"D2+TD2"},{"CODE":"SWE3003","TITLE":"Information and System Security","SLOT":"F2+TFF2"},{"CODE":"SWE3005","TITLE":"Principles of Design Patterns","SLOT":"B1+TB1"},{"CODE":"SWE3005","TITLE":"Principles of Design Patterns","SLOT":"B2+TB2"},{"CODE":"SWE4002","TITLE":"Software Testing","SLOT":"A1+TA1"},{"CODE":"SWE4002","TITLE":"Software Testing","SLOT":"A2+TA2"},{"CODE":"SWE4006","TITLE":"Advanced Server Side Programming","SLOT":"A1+TA1"},{"CODE":"SWE4006","TITLE":"Advanced Server Side Programming","SLOT":"A2+TA2"},{"CODE":"CSE2006","TITLE":"Computer Graphics","SLOT":"F2+TFF2"},{"CODE":"CSE2013","TITLE":"Information Theory and Coding","SLOT":"C2+TC2+TCC2"},{"CODE":"CSE2013","TITLE":"Information Theory and Coding","SLOT":"C1+TC1+TCC1"},{"CODE":"CSE2013","TITLE":"Information Theory and Coding","SLOT":"D1+TD1+TDD1"},{"CODE":"CSE2013","TITLE":"Information Theory and Coding","SLOT":"D2+TD2+TDD2"},{"CODE":"CSE2013","TITLE":"Information Theory and Coding","SLOT":"D1+TD1+TDD1"},{"CODE":"LIB1013","TITLE":"Introduction to Comics and Graphic Narratives","SLOT":"D1+TD1"},{"CODE":"LIB3001","TITLE":"Applications of Moral Philosophy","SLOT":"F1+TF1"},{"CODE":"LIB3001","TITLE":"Applications of Moral Philosophy","SLOT":"E2+TE2"},{"CODE":"SWE4010","TITLE":"Formal Language and Automata Theory","SLOT":"B1+TB1+TBB1"},{"CODE":"SWE4010","TITLE":"Formal Language and Automata Theory","SLOT":"B2+TB2+TBB2"},{"CODE":"CSE3006","TITLE":"Data Visualization","SLOT":"C1+TC1"},{"CODE":"CSE3006","TITLE":"Data Visualization","SLOT":"C2+TC2"},{"CODE":"CSE3006","TITLE":"Data Visualization","SLOT":"D1+TD1"},{"CODE":"CSE3013","TITLE":"Secure Group Communications","SLOT":"G2+TG2"},{"CODE":"CSE3013","TITLE":"Secure Group Communications","SLOT":"D1+TD1"},{"CODE":"CSE3013","TITLE":"Secure Group Communications","SLOT":"D2+TD2"},{"CODE":"CSE4011","TITLE":"Internet of Things","SLOT":"F1+TF1"},{"CODE":"CSE1020","TITLE":"Procedural Programming Using C","SLOT":"G1"},{"CODE":"CSE1020","TITLE":"Procedural Programming Using C","SLOT":"G2"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","SLOT":"F2+TF2"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","SLOT":"C1+TC1"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","SLOT":"C2+TC2"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","SLOT":"G2+TG2"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","SLOT":"G1+TG1"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","SLOT":"D2+TD2"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","SLOT":"E2+TE2"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","SLOT":"F1+TF1"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","SLOT":"E1+TE1"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","SLOT":"E1+TE1"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","SLOT":"D1+TD1"},{"CODE":"ECE1007","TITLE":"Sensor Systems","SLOT":"E1+TEE1"},{"CODE":"ECE1008","TITLE":"Sensors and Control Systems","SLOT":"C1+TC1"},{"CODE":"ECE1011","TITLE":"Hybrid and Electric Vehicles","SLOT":"D1+TD1+TDD1"},{"CODE":"ECE2001","TITLE":"Analog Devices and Circuits","SLOT":"A1+TA1"},{"CODE":"ECE2001","TITLE":"Analog Devices and Circuits","SLOT":"A2+TA2"},{"CODE":"ECE2001","TITLE":"Analog Devices and Circuits","SLOT":"C1+TC1"},{"CODE":"ECE2005","TITLE":"Signals and Systems","SLOT":"B1+TB1+TBB1"},{"CODE":"ECE2005","TITLE":"Signals and Systems","SLOT":"B2+TB2+TBB2"},{"CODE":"ECE2005","TITLE":"Signals and Systems","SLOT":"A1+TA1+TAA1"},{"CODE":"ECE2006","TITLE":"Communication Systems","SLOT":"B1+TB1"},{"CODE":"ECE2006","TITLE":"Communication Systems","SLOT":"B2+TB2"},{"CODE":"ECE2006","TITLE":"Communication Systems","SLOT":"A1+TA1"},{"CODE":"ECE2007","TITLE":"Digital Signal Processing","SLOT":"D2+TD2"},{"CODE":"ECE2014","TITLE":"Microprocessors and Microcontrollers","SLOT":"C1+TC1"},{"CODE":"ECE2014","TITLE":"Microprocessors and Microcontrollers","SLOT":"C2+TC2"},{"CODE":"ECE2014","TITLE":"Microprocessors and Microcontrollers","SLOT":"B1+TB1"},{"CODE":"ECE2015","TITLE":"Computer Architecture","SLOT":"A1+TA1+TAA1"},{"CODE":"ECE2015","TITLE":"Computer Architecture","SLOT":"A2+TA2+TAA2"},{"CODE":"ECE2015","TITLE":"Computer Architecture","SLOT":"B1+TB1+TBB1"},{"CODE":"ECE2015","TITLE":"Computer Architecture","SLOT":"B2+TB2+TBB2"},{"CODE":"ECE3005","TITLE":"CMOS VLSI Design","SLOT":"F1+TFF1"},{"CODE":"ECE3006","TITLE":"HDL Verification and Methodology","SLOT":"E1+TEE1"},{"CODE":"ECE3010","TITLE":"Speech processing","SLOT":"C1+TC1"},{"CODE":"ECE4003","TITLE":"Embedded Programming","SLOT":"F2+TFF2"},{"CODE":"ECE4004","TITLE":"Automotive Electrical and Electronic systems","SLOT":"D2+TD2+TDD2"},{"CODE":"ECE4005","TITLE":"SOC Design","SLOT":"C2+TC2"},{"CODE":"ECE4006","TITLE":"Analog IC Design","SLOT":"E2+TEE2"},{"CODE":"ECE4011","TITLE":"Robotics and Automation","SLOT":"D1+TD1+TDD1"},{"CODE":"ECE4017","TITLE":"IoT Domain Analyst","SLOT":"E2"},{"CODE":"ECE4018","TITLE":"Image Analysis and Computer Vision","SLOT":"F1+TFF1"},{"CODE":"MEC1006","TITLE":"Introduction to Robotics","SLOT":"D2+TD2"},{"CODE":"MEC2002","TITLE":"Thermodynamics","SLOT":"B2+TB2+TBB2"},{"CODE":"MEC2005","TITLE":"Fundamentals of Manufacturing Processes","SLOT":"A2+TA2"},{"CODE":"MEC2008","TITLE":"Product Design and Development","SLOT":"D1+TD1+TDD1"},{"CODE":"MEC2021","TITLE":"Mechatronics","SLOT":"D2+TD2+TDD2"},{"CODE":"MEC3001","TITLE":"Heat and Mass Transfer","SLOT":"A1+TA1"},{"CODE":"MEC3002","TITLE":"Theory of Machines","SLOT":"C2+TC2"},{"CODE":"MEC3005","TITLE":"Automation in Manufacturing","SLOT":"C2+TC2"},{"CODE":"MEC3010","TITLE":"Renewable Source of Energy","SLOT":"F2+TF2"},{"CODE":"MEC3011","TITLE":"Operations Research","SLOT":"E1+TEE1"},{"CODE":"MEC3012","TITLE":"Additive Manufacturing","SLOT":"F1+TFF1"},{"CODE":"MEC3027","TITLE":"Robot Dynamics","SLOT":"D1+TD1+TDD1"},{"CODE":"MEC4003","TITLE":"Internal Combustion Engines","SLOT":"B1+TB1"},{"CODE":"MEC4008","TITLE":"Automobile Engineering","SLOT":"C1+TC1"},{"CODE":"ENG1016","TITLE":"Climate Fiction- Narratives to Save the World!","SLOT":"C1+TC1"},{"CODE":"ENG1017","TITLE":"Film Appreciation","SLOT":"E1+TE1"},{"CODE":"ENG1018","TITLE":"Introduction to Fashion and Technology","SLOT":"F2+TF2"},{"CODE":"ENG1019","TITLE":"Introduction to Storytelling in Business & Entrepreneurship","SLOT":"G2+TG2"},{"CODE":"ENG2011","TITLE":"Revisiting Shakespearean Dramas","SLOT":"G1+TG1"},{"CODE":"ENG2014","TITLE":"Decoding Television in the Digital Age","SLOT":"D2+TD2"},{"CODE":"ENG3001","TITLE":"Introduction to Translation Studies","SLOT":"C2+TC2"},{"CODE":"ENG3004","TITLE":"Introducing Linguistics","SLOT":"F2"},{"CODE":"FRL1004","TITLE":"Basic Spanish","SLOT":"E2"},{"CODE":"FRL1004","TITLE":"Basic Spanish","SLOT":"G2"},{"CODE":"FRL1004","TITLE":"Basic Spanish","SLOT":"F1"},{"CODE":"FRL1004","TITLE":"Basic Spanish","SLOT":"E1"},{"CODE":"FRL2004","TITLE":"Korean for Beginners","SLOT":"E2"},{"CODE":"FRL2004","TITLE":"Korean for Beginners","SLOT":"G1"},{"CODE":"FRL2004","TITLE":"Korean for Beginners","SLOT":"F1"},{"CODE":"INL1001","TITLE":"Functional Hindi for non-Hindi Speakers","SLOT":"G2"},{"CODE":"INL1001","TITLE":"Functional Hindi for non-Hindi Speakers","SLOT":"E1"},{"CODE":"FRL1001","TITLE":"Basic French","SLOT":"G1"},{"CODE":"FRL1001","TITLE":"Basic French","SLOT":"G2"},{"CODE":"FRL1001","TITLE":"Basic French","SLOT":"E2","FACULTY":"Prof.Carlin Pouamou","VENUE":"110 - CB"},{"CODE":"FRL1001","TITLE":"Basic French","SLOT":"F2"},{"CODE":"FRL1005","TITLE":"German for Beginners","SLOT":"E2"},{"CODE":"FRL1005","TITLE":"German for Beginners","SLOT":"G1"},{"CODE":"FRL1005","TITLE":"German for Beginners","SLOT":"E1"},{"CODE":"FRL1005","TITLE":"German for Beginners","SLOT":"G1"},{"CODE":"HUM1012","TITLE":"Engineering Economics","SLOT":"E2+TE2"},{"CODE":"HUM1012","TITLE":"Engineering Economics","SLOT":"D1+TD1"},{"CODE":"HUM1012","TITLE":"Engineering Economics","SLOT":"D2+TD2"},{"CODE":"HUM2010","TITLE":"Gender Economics","SLOT":"G1+TG1"},{"CODE":"HUM2106","TITLE":"History of Contemporary India","SLOT":"B2+TB2+TBB2"},{"CODE":"LIB1001","TITLE":"Anthropology \u2013 An Introduction","SLOT":"G1+TG1"},{"CODE":"LIB1014","TITLE":"Pursuit of Happiness","SLOT":"F1+TF1"},{"CODE":"LIB1014","TITLE":"Pursuit of Happiness","SLOT":"F2+TF2"},{"CODE":"LIB1019","TITLE":"Dynamics of Gender Psychology","SLOT":"F1+TF1"},{"CODE":"LIB1019","TITLE":"Dynamics of Gender Psychology","SLOT":"E2+TE2"},{"CODE":"LIB1020","TITLE":"Basic Psychology for Engineers","SLOT":"D2+TD2"},{"CODE":"LIB1020","TITLE":"Basic Psychology for Engineers","SLOT":"E1+TE1"},{"CODE":"LIB2003","TITLE":"Geography of Asia and Sub-Saharan Africa","SLOT":"F2+TF2"},{"CODE":"LIB2004","TITLE":"Ancient India History","SLOT":"C2+TC2+TCC2"},{"CODE":"LIB2007","TITLE":"The Aesthetics of Performing Arts","SLOT":"C1+TC1+TCC1"},{"CODE":"LIB2010","TITLE":"Food & Literature","SLOT":"E2+TE2"},{"CODE":"LIB2015","TITLE":"Design Psychology","SLOT":"G1+TG1"},{"CODE":"LIB2016","TITLE":"Human Factors Psychology","SLOT":"C2+TC2"},{"CODE":"LIB2106","TITLE":"Language, Mind and Logic: Scientific Spectrum","SLOT":"E1+TEE1"},{"CODE":"STS1007","TITLE":"Arithmetic Problem Solving","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS1007","TITLE":"Arithmetic Problem Solving","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS1007","TITLE":"Arithmetic Problem Solving","TYPE":"TH","CREDITS":3,"SLOT":"E2+TEE2"},{"CODE":"STS1007","TITLE":"Arithmetic Problem Solving","TYPE":"TH","CREDITS":3,"SLOT":"F2+TFF2"},{"CODE":"STS1007","TITLE":"Arithmetic Problem Solving","TYPE":"TH","CREDITS":3,"SLOT":"E1+TEE1"},{"CODE":"STS1007","TITLE":"Arithmetic Problem Solving","TYPE":"TH","CREDITS":3,"SLOT":"F1+TFF1"},{"CODE":"STS1007","TITLE":"Arithmetic Problem Solving","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"STS2003","TITLE":"Aptitude and Reasoning Skills","TYPE":"TH","SLOT":"F2+TFF2"},{"CODE":"STS2003","TITLE":"Aptitude and Reasoning Skills","TYPE":"TH","SLOT":"D2+TD2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E1+TEE1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F1+TFF1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E2+TEE2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F2+TFF2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS2009","TITLE":"Arithmetic Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E1+TEE1"},{"CODE":"STS2009","TITLE":"Arithmetic Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E2+TEE2"},{"CODE":"STS2009","TITLE":"Arithmetic Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F1+TFF1"},{"CODE":"STS2009","TITLE":"Arithmetic Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"F2+TFF2"},{"CODE":"STS4003","TITLE":"Enhancing Programming Ability","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"E1+TEE1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"E2+TEE2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"F2+TFF2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"F1+TFF1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"F2+TFF2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"E1+TEE1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"E2+TEE2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"F1+TFF1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"HUM1002","TITLE":"Personal Finance for Engineers","SLOT":"E1"},{"CODE":"HUM1005","TITLE":"Introduction to Cost Accounting","SLOT":"G2+TG2"},{"CODE":"HUM2003","TITLE":"Fundamentals of Cost and Management Accounting","SLOT":"C2+TC2+TCC2"},{"CODE":"MGT1002","TITLE":"Lean Start-up Management","SLOT":"G2+TG2"},{"CODE":"MGT1002","TITLE":"Lean Start-up Management","SLOT":"E1+TE1"},{"CODE":"MGT1002","TITLE":"Lean Start-up Management","SLOT":"E2+TE2"},{"CODE":"MGT1014","TITLE":"Fundamentals of Brand Management","SLOT":"E2+TE2"},{"CODE":"MGT1015","TITLE":"Fundamentals of Consumer Behaviour","SLOT":"G1+TG1"},{"CODE":"MGT1015","TITLE":"Fundamentals of Consumer Behaviour","SLOT":"G2+TG2"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"E1"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"F1"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"G1","FACULTY":"DR.G.SOMA SEKHAR","VENUE":"G13 - CB"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"E2"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"F2"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"G2"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"E1"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"F1"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"E2"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"F2"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"G2"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"E1"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"F1"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"G1"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"E2"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"F2"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"G2","FACULTY":"Krishnasamy","VENUE":"225-CB"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"G1"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"G1"},{"CODE":"MGT1042","TITLE":"Financial and Management Accounting","SLOT":"F1+TFF1"},{"CODE":"MGT2006","TITLE":"Fundamentals of Financial Management","SLOT":"F1+TFF1"},{"CODE":"MGT2006","TITLE":"Fundamentals of Financial Management","SLOT":"G2+TG2"},{"CODE":"MGT2014","TITLE":"Fundamentals of Marketing Management","SLOT":"E2+TE2"},{"CODE":"MGT2014","TITLE":"Fundamentals of Marketing Management","SLOT":"C1+TC1"},{"CODE":"MGT2016","TITLE":"Essentials of Marketing Management","SLOT":"D1+TD1+TDD1"},{"CODE":"MGT2016","TITLE":"Essentials of Marketing Management","SLOT":"D2+TD2+TDD2"},{"CODE":"MGT3004","TITLE":"Fundamentals of Operations and Supply Chain Management","SLOT":"G1+TG1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"Muthu Krishnammal ","VENUE":"G14-CB"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"G2+TG2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"E1+TE1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"F2+TF2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"LAW1001","TITLE":"Law, Internet and Society","SLOT":"E2+TEE2"},{"CODE":"LAW1003","TITLE":"Human Rights and Criminal Justice System","SLOT":"G2+TG2"},{"CODE":"LAW1005","TITLE":"Introduction to Indian Constitution","SLOT":"F2+TFF2"},{"CODE":"MGT1029","TITLE":"Basic Law for Engineers","SLOT":"D2+TD2"},{"CODE":"MGT1029","TITLE":"Basic Law for Engineers","SLOT":"E1+TEE1"},{"CODE":"CHY1001","TITLE":"Environmental Studies","SLOT":"A+TA"},{"CODE":"CHY1004","TITLE":"Engineering Chemistry","SLOT":"C+TC"},{"CODE":"CHY1005","TITLE":"Industrial Chemistry for Engineers","SLOT":"A+TA+TAA"},{"CODE":"CHY1006","TITLE":"Corrosion Science and Engineering","SLOT":"C+TC+TCC"},{"CODE":"CHY2001","TITLE":"Chemical and Biosensors","SLOT":"A+TA+TAA"},{"CODE":"CSE1007","TITLE":"Introduction to Cryptography","SLOT":"B+TB+TBB"},{"CODE":"CSE1008","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA"},{"CODE":"CSE1012","TITLE":"Problem Solving using Python","TYPE":"ETL","CREDITS":3,"SLOT":"C+TC+TCC"},{"CODE":"CSE1012","TITLE":"Problem Solving using Python","TYPE":"ETL","CREDITS":3,"SLOT":"A+TA+TAA"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A+TA+TAA"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"B+TB+TBB"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"C+TC+TCC"},{"CODE":"CSE2005","TITLE":"Object Oriented Programming","TYPE":"ETL","CREDITS":3,"SLOT":"B+TB+TBB"},{"CODE":"CSE2005","TITLE":"Object Oriented Programming","TYPE":"ETL","CREDITS":3,"SLOT":"A+TA+TAA"},{"CODE":"CSE2005","TITLE":"Object Oriented Programming","TYPE":"ETL","CREDITS":3,"SLOT":"C+TC+TCC","FACULTY":"Dr. Sanjeev Kumar Dwivedi","VENUE":"415 - AB1"},{"CODE":"CSE2005","TITLE":"Object Oriented Programming","TYPE":"ETL","CREDITS":3,"SLOT":"C+TC+TCC"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"A+TA+TAA"},{"CODE":"CSE2008","TITLE":"Operating Systems","TYPE":"ETL","CREDITS":4,"SLOT":"C+TC+TCC"},{"CODE":"CSE2014","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":4,"SLOT":"A+TA+TAA"},{"CODE":"CSE2018","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C+TC+TCC"},{"CODE":"CSE2019","TITLE":"Machine Learning","TYPE":"ETL","SLOT":"C+TC+TCC"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"B+TB+TBB"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"B+TB+TBB"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A+TA+TAA"},{"CODE":"CSE3008","TITLE":"Introduction to Machine Learning","SLOT":"C+TC+TCC"},{"CODE":"CSE4002","TITLE":"Mobile Application Development","SLOT":"B+TB+TBB"},{"CODE":"CSE4005","TITLE":"Data Warehousing and Data Mining","SLOT":"C+TC+TCC"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","SLOT":"A+TA+TAA"},{"CODE":"ECE1002","TITLE":"Fundamentals of Electrical and Electronics Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A+TA+TAA"},{"CODE":"ECE1003","TITLE":"Digital Logic Design","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"Prof.Chandan Nayak","VENUE":"317 - CB"},{"CODE":"ECE1003","TITLE":"Digital Logic Design","TYPE":"ETL","CREDITS":3,"SLOT":"B+TB"},{"CODE":"ECE1003","TITLE":"Digital Logic Design","TYPE":"ETL","CREDITS":3,"SLOT":"C+TC"},{"CODE":"ECE1006","TITLE":"Digital Logic and Microprocessors","SLOT":"B+TB+TBB"},{"CODE":"ECE1006","TITLE":"Digital Logic and Microprocessors","SLOT":"C+TC+TCC"},{"CODE":"ECE1007","TITLE":"Sensor Systems","SLOT":"A+TA+TAA"},{"CODE":"ECE2001","TITLE":"Analog Devices and Circuits","SLOT":"C+TC+TCC"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB"},{"CODE":"ECE2003","TITLE":"Control Systems Engineering","SLOT":"B+TB+TBB"},{"CODE":"ECE2004","TITLE":"Microcontrollers and Interfacing","SLOT":"C+TC+TCC"},{"CODE":"ECE2005","TITLE":"Signals and Systems","SLOT":"C+TC+TCC"},{"CODE":"ECE2010","TITLE":"Digital System Design for ASICs and FPGAs","SLOT":"B+TB+TBB"},{"CODE":"ECE2014","TITLE":"Microprocessors and Microcontrollers","SLOT":"B+TB+TBB"},{"CODE":"ECE2015","TITLE":"Computer Architecture","SLOT":"A+TA+TAA"},{"CODE":"ECE2015","TITLE":"Computer Architecture","SLOT":"B+TB+TBB"},{"CODE":"ECE3001","TITLE":"Linear Integrated Circuits and Applications","SLOT":"A+TA+TAA"},{"CODE":"ECE3018","TITLE":"IoT Fundamentals","SLOT":"B+TB"},{"CODE":"ENG2001","TITLE":"English for Professional Communication","SLOT":"C+TC"},{"CODE":"ENG3004","TITLE":"Introducing Linguistics","SLOT":"B+TB"},{"CODE":"FRL1001","TITLE":"Basic French","SLOT":"B+TB"},{"CODE":"FRL1001","TITLE":"Basic French","SLOT":"A+TA"},{"CODE":"HUM1002","TITLE":"Personal Finance for Engineers","SLOT":"B+TB"},{"CODE":"LAW1005","TITLE":"Introduction to Indian Constitution","SLOT":"B+TB+TBB"},{"CODE":"LIB1001","TITLE":"Anthropology \u2013 An Introduction","SLOT":"B+TB+TBB"},{"CODE":"LIB1014","TITLE":"Pursuit of Happiness","SLOT":"C+TC+TCC"},{"CODE":"MAT1002","TITLE":"Applications of differential and difference equations","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB"},{"CODE":"MAT1002","TITLE":"Applications of differential and difference equations","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB"},{"CODE":"MAT1002","TITLE":"Applications of differential and difference equations","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB"},{"CODE":"MAT1002","TITLE":"Applications of differential and difference equations","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA"},{"CODE":"MAT1002","TITLE":"Applications of differential and difference equations","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA"},{"CODE":"MAT1002","TITLE":"Applications of differential and difference equations","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA"},{"CODE":"MAT1002","TITLE":"Applications of differential and difference equations","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC"},{"CODE":"MAT1002","TITLE":"Applications of differential and difference equations","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC"},{"CODE":"MAT1002","TITLE":"Applications of differential and difference equations","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC"},{"CODE":"MAT1002","TITLE":"Applications of differential and difference equations","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB"},{"CODE":"MAT1002","TITLE":"Applications of differential and difference equations","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB"},{"CODE":"MAT1007","TITLE":"Discrete Mathematics","SLOT":"B+TB+TBB"},{"CODE":"MAT1009","TITLE":"Applied Linear Algebra","SLOT":"C+TC+TCC"},{"CODE":"MAT1009","TITLE":"Applied Linear Algebra","SLOT":"B+TB+TBB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C+TC+TCC"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"A+TA+TAA"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"B+TB+TBB"},{"CODE":"MAT1014","TITLE":"Fundamental Statistics","SLOT":"A+TA+TAA"},{"CODE":"MEC2002","TITLE":"Thermodynamics","SLOT":"A+TA+TAA"},{"CODE":"MEC2004","TITLE":"Fluid Mechanics","SLOT":"B+TB+TBB"},{"CODE":"MEC2005","TITLE":"Fundamentals of Manufacturing Processes","SLOT":"C+TC+TCC"},{"CODE":"MEC2016","TITLE":"Robot Kinematics and Dynamics","SLOT":"B+TB+TBB"},{"CODE":"MEC3004","TITLE":"Machine Design","SLOT":"B+TB+TBB"},{"CODE":"MEC3026","TITLE":"Robot Kinematics","SLOT":"B+TB+TBB"},{"CODE":"MEC4008","TITLE":"Automobile Engineering","SLOT":"C+TC+TCC"},{"CODE":"MGT1002","TITLE":"Lean Start-up Management","SLOT":"A+TA+TAA"},{"CODE":"MGT1005","TITLE":"Fundamentals of Creativity and Innovation Management","SLOT":"B+TB"},{"CODE":"MGT1020","TITLE":"Fundamentals of Services Marketing","SLOT":"A+TA+TAA"},{"CODE":"MGT1031","TITLE":"Fundamentals of Management","SLOT":"A+TA"},{"CODE":"MGT2016","TITLE":"Essentials of Marketing Management","SLOT":"A+TA+TAA"},{"CODE":"MGT3001","TITLE":"Services Science and Service Operational Management","SLOT":"B+TB"},{"CODE":"MGT3004","TITLE":"Fundamentals of Operations and Supply Chain Management","SLOT":"C+TC+TCC"},{"CODE":"PHY1002","TITLE":"Semiconductor Device Physics","SLOT":"C+TC+TCC"},{"CODE":"PHY2003","TITLE":"Condensed Matter Physics","SLOT":"B+TB+TBB"},{"CODE":"PHY2004","TITLE":"Optoelectronics","SLOT":"A+TA+TAA"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"C+TC+TCC"},{"CODE":"PHY4204","TITLE":"Quantum Mechanics - II","SLOT":"A+TA+TAA"},{"CODE":"STS1001","TITLE":"Introduction to Business Communication","SLOT":"B+TB+TBB"},{"CODE":"STS1002","TITLE":"Fundamentals of Aptitude","SLOT":"B+TB+TBB"},{"CODE":"STS1007","TITLE":"Arithmetic problem solving","TYPE":"LO","CREDITS":3,"SLOT":"A+TA+TAA"},{"CODE":"STS1007","TITLE":"Arithmetic problem solving","TYPE":"LO","CREDITS":3,"SLOT":"B+TB+TBB"},{"CODE":"STS1007","TITLE":"Arithmetic problem solving","TYPE":"LO","CREDITS":3,"SLOT":"C+TC+TCC"},{"CODE":"STS1009","TITLE":"Introduction to Quantitative, Logical and Verbal Ability","SLOT":"C+TC+TCC"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"A+TA+TAA"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"B+TB+TBB"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"C+TC+TCC"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"C+TC+TCC"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"C+TC+TCC"},{"CODE":"STS3006","TITLE":"Basic Competitive Coding - I","TYPE":"TH","CREDITS":3,"SLOT":"C+TC+TCC"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","TYPE":"TH","CREDITS":3,"SLOT":"A+TA+TAA"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","SLOT":"A+TA+TAA"},{"CODE":"SWE2005","TITLE":"Concepts of Object Oriented Programming","SLOT":"A+TA+TAA"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"B+TB+TBB"},{"CODE":"SWE2007","TITLE":"Fundamentals of Operating Systems","SLOT":"C+TC+TCC"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","SLOT":"A+TA+TAA"},{"CODE":"SWE4001","TITLE":"Internet and Web Technologies","SLOT":"B+TB+TBB"},{"CODE":"SWE4003","TITLE":"Concepts of Mobile Application Development","SLOT":"C+TC+TCC"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"TH","CREDITS":3,"SLOT":"A+TA+TAA"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"TH","CREDITS":3,"SLOT":"C+TC+TCC"},{"CODE":"CHY1004","TITLE":"Engineering Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CHY1004","TITLE":"Engineering Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE1007","TITLE":"Introduction to Cryptography","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE1007","TITLE":"Introduction to Cryptography","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE1007","TITLE":"Introduction to Cryptography","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE1012","TITLE":"Problem Solving using Python","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE1012","TITLE":"Problem Solving using Python","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE1012","TITLE":"Problem Solving using Python","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE1012","TITLE":"Problem Solving using Python","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L47+L4"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE2005","TITLE":"Object Oriented Programming","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE2005","TITLE":"Object Oriented Programming","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE2005","TITLE":"Object Oriented Programming","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE2005","TITLE":"Object Oriented Programming","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE2005","TITLE":"Object Oriented Programming","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE2005","TITLE":"Object Oriented Programming","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE2005","TITLE":"Object Oriented Programming","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE2005","TITLE":"Object Oriented Programming","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE2008","TITLE":"Operating Systems","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE2008","TITLE":"Operating Systems","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE2014","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE2014","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE2018","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE2018","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE2019","TITLE":"Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE2019","TITLE":"Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE3008","TITLE":"Introduction to Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE3008","TITLE":"Introduction to Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE4002","TITLE":"Mobile Application Development","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE4002","TITLE":"Mobile Application Development","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE4005","TITLE":"Data Warehousing and Data Mining","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE4005","TITLE":"Data Warehousing and Data Mining","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"ECE1002","TITLE":"Fundamentals of Electrical and Electronics Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"ECE1002","TITLE":"Fundamentals of Electrical and Electronics Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"ECE1003","TITLE":"Digital Logic Design","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"ECE1003","TITLE":"Digital Logic Design","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"ECE1003","TITLE":"Digital Logic Design","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"ECE1003","TITLE":"Digital Logic Design","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"ECE1003","TITLE":"Digital Logic Design","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"ECE1003","TITLE":"Digital Logic Design","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"ECE1006","TITLE":"Digital Logic and Microprocessors","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"ECE1006","TITLE":"Digital Logic and Microprocessors","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"ECE1006","TITLE":"Digital Logic and Microprocessors","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"ECE1006","TITLE":"Digital Logic and Microprocessors","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"ECE1007","TITLE":"Sensor Systems","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"ECE1007","TITLE":"Sensor Systems","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"ECE2001","TITLE":"Analog Devices and Circuits","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"ECE2001","TITLE":"Analog Devices and Circuits","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"ECE2003","TITLE":"Control Systems Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"ECE2003","TITLE":"Control Systems Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"ECE2004","TITLE":"Microcontrollers and Interfacing","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"ECE2004","TITLE":"Microcontrollers and Interfacing","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"ECE2010","TITLE":"Digital System Design for ASICs and FPGAs","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"ECE2010","TITLE":"Digital System Design for ASICs and FPGAs","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"ECE2014","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"ECE2014","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"ECE3001","TITLE":"Linear Integrated Circuits and Applications","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"ECE3001","TITLE":"Linear Integrated Circuits and Applications","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"ECE3018","TITLE":"IoT Fundamentals","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"ECE3018","TITLE":"IoT Fundamentals","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"ENG2001","TITLE":"English for Professional Communication","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"ENG2001","TITLE":"English for Professional Communication","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"MAT1014","TITLE":"Fundamental Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"MAT1014","TITLE":"Fundamental Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"MEC2004","TITLE":"Fluid Mechanics","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"MEC2004","TITLE":"Fluid Mechanics","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"MEC2005","TITLE":"Fundamentals of Manufacturing Processes","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"MEC2005","TITLE":"Fundamentals of Manufacturing Processes","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"MEC2016","TITLE":"Robot Kinematics and Dynamics","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"MEC2016","TITLE":"Robot Kinematics and Dynamics","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"MEC3004","TITLE":"Machine Design","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"MEC3004","TITLE":"Machine Design","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"MEC4008","TITLE":"Automobile Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"MEC4008","TITLE":"Automobile Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L31+L32"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L43+L44"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"SWE2005","TITLE":"Concepts of Object Oriented Programming","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"SWE2005","TITLE":"Concepts of Object Oriented Programming","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"SWE2007","TITLE":"Fundamentals of Operating Systems","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"SWE2007","TITLE":"Fundamentals of Operating Systems","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"SWE2007","TITLE":"Fundamentals of Operating Systems","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"SWE2007","TITLE":"Fundamentals of Operating Systems","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"SWE4001","TITLE":"Internet and Web Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"SWE4001","TITLE":"Internet and Web Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"SWE4003","TITLE":"Concepts of Mobile Application Development","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"SWE4003","TITLE":"Concepts of Mobile Application Development","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L59+L60"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SPANDANA MANDE","VENUE":"301 - CB"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"CSE2010","TITLE":"Secure Coding","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"CSE2011","TITLE":"Cyber Security and Digital Forensics","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"CSE3001","TITLE":"Agile Development Process","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE3001","TITLE":"Agile Development Process","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE3008","TITLE":"Introduction to Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"CSE3008","TITLE":"Introduction to Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"CSE3009","TITLE":"No SQL Databases","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"CSE3012","TITLE":"Network Security","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"CSE4018","TITLE":"Computer Vision and Robotics","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"SWE2007","TITLE":"Fundamentals of Operating Systems","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"SWE2008","TITLE":"Object Oriented Analysis and Design","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"SWE2008","TITLE":"Object Oriented Analysis and Design","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"SWE3004","TITLE":"Front End Design and Testing","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"SWE3004","TITLE":"Front End Design and Testing","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"SWE4001","TITLE":"Internet and Web Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"SWE4001","TITLE":"Internet and Web Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"SWE4001","TITLE":"Internet and Web Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"SWE4002","TITLE":"Software Testing","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"SWE4003","TITLE":"Concepts of Mobile Application Development","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"SWE4003","TITLE":"Concepts of Mobile Application Development","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"SWE4003","TITLE":"Concepts of Mobile Application Development","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE4033","TITLE":"IT Project Management","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"CSE3006","TITLE":"Data Visualization","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE4012","TITLE":"UI UX User Experience Design","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE4012","TITLE":"UI UX User Experience Design","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"ECE2007","TITLE":"Digital Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"ECE3009","TITLE":"Power Electronic Converters","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"MEC2003","TITLE":"Strength of Materials","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"MEC2003","TITLE":"Strength of Materials","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"MEC2004","TITLE":"Fluid Mechanics","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"MEC2004","TITLE":"Fluid Mechanics","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"MEC3012","TITLE":"Additive Manufacturing","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"MAT2004","TITLE":"Applied Optimization Techniques","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"ENG1001","TITLE":"English for Essential Communication","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"ENG1002","TITLE":"English for Effective Communication","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"ENG1005","TITLE":"Basic Communication in English","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"ENG1006","TITLE":"Functional Communication in English","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"ENG2001","TITLE":"English for Professional Communication","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"ENG2004","TITLE":"Advanced Professional Communication","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L7+L8"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L19+L20"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L25+L26"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L35+L36"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L41+L42"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L29+L30"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L3+L4"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L9+L10"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L27+L28"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L21+L22"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L15+L16"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L23+L24"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L31+L32"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L33+L34"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L37+L38"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L39+L40"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L43+L44"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L49+L50"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L55+L56"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18","FACULTY":"RAMESH PRASAD PANDA","VENUE":"122 - CB"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"MAT2001","TITLE":"Numerical Methods for Engineers","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"MAT2001","TITLE":"Numerical Methods for Engineers","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"MAT2003","TITLE":"Optimization Techniques","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"MAT2003","TITLE":"Optimization Techniques","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"CSE1007","TITLE":"Introduction to Cryptography","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"CSE1007","TITLE":"Introduction to Cryptography","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"YENUMALA SANKARARAO","VENUE":"301 - CB"},{"CODE":"CSE1007","TITLE":"Introduction to Cryptography","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"Prof.Sandipan Maiti","VENUE":"101 - CB"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"YENUMALA SANKARARAO","VENUE":"102 - CB"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"Prof.Pulipati Nagaraju","VENUE":"301 - CB"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE2011","TITLE":"Cyber Security and Digital Forensics","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"CSE2011","TITLE":"Cyber Security and Digital Forensics","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE2011","TITLE":"Cyber Security and Digital Forensics","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"Prof.Manomita Chakraborty","VENUE":"301 - AB-2"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"MOHAN ARAVA","VENUE":"307 - CB"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18","FACULTY":"Prof.Sanket Mishra","VENUE":"105 - CB"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"Prof.Sunil Kumar Singh","VENUE":"102 - CB"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"CSE3008","TITLE":"Introduction to Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"CSE3008","TITLE":"Introduction to Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"CSE3009","TITLE":"No SQL Databases","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"CSE3009","TITLE":"No SQL Databases","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26"},{"CODE":"CSE3009","TITLE":"No SQL Databases","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30"},{"CODE":"CSE3009","TITLE":"No SQL Databases","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE3009","TITLE":"No SQL Databases","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"CSE3011","TITLE":"Network Programming","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE3011","TITLE":"Network Programming","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"CSE3011","TITLE":"Network Programming","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"CSE3012","TITLE":"Network Security","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26"},{"CODE":"CSE3012","TITLE":"Network Security","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"CSE4005","TITLE":"Data Warehousing and Data Mining","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"CSE4005","TITLE":"Data Warehousing and Data Mining","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26"},{"CODE":"CSE4005","TITLE":"Data Warehousing and Data Mining","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"CSE4005","TITLE":"Data Warehousing and Data Mining","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"CSE4008","TITLE":"Social Network Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"CSE4008","TITLE":"Social Network Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"CSE4008","TITLE":"Social Network Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE4008","TITLE":"Social Network Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"CSE4008","TITLE":"Social Network Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"CSE4016","TITLE":"Database Administration","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"CSE4016","TITLE":"Database Administration","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"CSE4016","TITLE":"Database Administration","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"CSE4031","TITLE":"Web Application Security","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"CSE4031","TITLE":"Web Application Security","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"CSE4040","TITLE":"Mining Massive Data Sets","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"CSE4040","TITLE":"Mining Massive Data Sets","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"CSE4040","TITLE":"Mining Massive Data Sets","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"CSE4042","TITLE":"Blockchain Platforms and Applications","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"CSE4044","TITLE":"Software Defined Networks and Network Function Virtualization","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"ECE3001","TITLE":"Linear Integrated Circuits and Applications","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"ECE3001","TITLE":"Linear Integrated Circuits and Applications","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"ECE3001","TITLE":"Linear Integrated Circuits and Applications","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"ECE3001","TITLE":"Linear Integrated Circuits and Applications","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50"},{"CODE":"SWE2006","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"SWE3005","TITLE":"Principles of Design Patterns","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"SWE3005","TITLE":"Principles of Design Patterns","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"SWE3005","TITLE":"Principles of Design Patterns","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"SWE4002","TITLE":"Software Testing","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"SWE4002","TITLE":"Software Testing","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30"},{"CODE":"SWE4002","TITLE":"Software Testing","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"SWE4006","TITLE":"Advanced Server Side Programming","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46"},{"CODE":"SWE4006","TITLE":"Advanced Server Side Programming","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30"},{"CODE":"SWE4006","TITLE":"Advanced Server Side Programming","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"CSE2006","TITLE":"Computer Graphics","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"CSE3006","TITLE":"Data Visualization","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"CSE3006","TITLE":"Data Visualization","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"CSE3006","TITLE":"Data Visualization","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54"},{"CODE":"CSE3006","TITLE":"Data Visualization","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8"},{"CODE":"CSE3013","TITLE":"Secure Group Communications","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"CSE3013","TITLE":"Secure Group Communications","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE3013","TITLE":"Secure Group Communications","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE1020","TITLE":"Procedural Programming Using C","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"CSE1020","TITLE":"Procedural Programming Using C","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"CSE1020","TITLE":"Procedural Programming Using C","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L17+L18"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48"},{"CODE":"ECE1007","TITLE":"Sensor Systems","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"ECE1008","TITLE":"Sensors and Control Systems","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"ECE2001","TITLE":"Analog Devices and Circuits","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"ECE2001","TITLE":"Analog Devices and Circuits","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8"},{"CODE":"ECE2001","TITLE":"Analog Devices and Circuits","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36"},{"CODE":"ECE2001","TITLE":"Analog Devices and Circuits","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"ECE2006","TITLE":"Communication Systems","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"ECE2006","TITLE":"Communication Systems","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24"},{"CODE":"ECE2006","TITLE":"Communication Systems","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56"},{"CODE":"ECE2006","TITLE":"Communication Systems","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"ECE2007","TITLE":"Digital Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12"},{"CODE":"ECE2014","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"ECE2014","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"ECE2014","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"ECE2014","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44"},{"CODE":"ECE3005","TITLE":"CMOS VLSI Design","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"ECE3006","TITLE":"HDL Verification and Methodology","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32"},{"CODE":"ECE3010","TITLE":"Speech processing","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"ECE4003","TITLE":"Embedded Programming","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28"},{"CODE":"ECE4005","TITLE":"SOC Design","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22"},{"CODE":"ECE4006","TITLE":"Analog IC Design","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4"},{"CODE":"ECE4017","TITLE":"IoT Domain Analyst","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30"},{"CODE":"ECE4018","TITLE":"Image Analysis and Computer Vision","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52"},{"CODE":"MEC1002","TITLE":"Engineering Graphics","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14+L21+L22"},{"CODE":"MEC2005","TITLE":"Fundamentals of Manufacturing Processes","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"MEC2005","TITLE":"Fundamentals of Manufacturing Processes","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"MEC3001","TITLE":"Heat and Mass Transfer","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38"},{"CODE":"MEC3002","TITLE":"Theory of Machines","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2"},{"CODE":"MEC3002","TITLE":"Theory of Machines","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6"},{"CODE":"MEC3005","TITLE":"Automation in Manufacturing","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"MEC3012","TITLE":"Additive Manufacturing","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42"},{"CODE":"MEC4003","TITLE":"Internal Combustion Engines","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34"},{"CODE":"MEC4008","TITLE":"Automobile Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L37+L38"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L29+L30"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L43+L44"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L3+L4"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L9+L10"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L15+L16"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L27+L28"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L39+L40"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L21+L22"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L43+L44"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L49+L50"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L55+L56"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L35+L36"}]');

});

parcelRegister("4n35S", function(module, exports) {
module.exports = JSON.parse('[{"CODE":"STS3006","TITLE":"Basic Competitive Coding - I","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"CHY1001","TITLE":"Chemistry & Environmental Studies","TYPE":"LO","CREDITS":4,"SLOT":"E1"},{"CODE":"CHY1005","TITLE":"Industrial Chemistry for Engineers","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1"},{"CODE":"CHY1006","TITLE":"Corrosion Science and Engineering","TYPE":"TH","CREDITS":4,"SLOT":"E2+TE2"},{"CODE":"CHY1007","TITLE":"Energy Materials and Their Applications","TYPE":"TH","CREDITS":4,"SLOT":"B2+TB2"},{"CODE":"CHY2001","TITLE":"Chemical and Biosensors","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2"},{"CODE":"CHY2002","TITLE":"Organic Electronics","TYPE":"TH","CREDITS":4,"SLOT":"B2+TB2"},{"CODE":"MAT1003","TITLE":"Discrete Mathematical Structures","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"Prof.Sukanta Nayak","VENUE":"110 - CB"},{"CODE":"MAT1007","TITLE":"Discrete Mathematics","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2"},{"CODE":"MAT1011","TITLE":"Applied Statistics","TYPE":"ETL","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"Prof.Venkatarajam M","VENUE":"226 - CB"},{"CODE":"MAT2001","TITLE":"Numerical Methods for Engineers","SLOT":"C1"},{"CODE":"MAT2002","TITLE":"Complex Variables and Partial Differential Equations","SLOT":"A2+TA2"},{"CODE":"MAT2003","TITLE":"Optimization Techniques","SLOT":"A2+TA2"},{"CODE":"MAT2005","TITLE":"Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"MAT2009","TITLE":"Computational Statistics","SLOT":"F1+TF1"},{"CODE":"MAT2011","TITLE":"Graph Theory and Applications","SLOT":"C2+TC2"},{"CODE":"PHY2004","TITLE":"Optoelectronics","SLOT":"G2+TG2"},{"CODE":"PHY2005","TITLE":"Introduction to Nanotechnology","TYPE":"ETL","CREDITS":3,"SLOT":"C1+TC1"},{"CODE":"PHY2006","TITLE":"Solar Photovoltaics : Fundamentals and Technologies","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"CSE1006","TITLE":"Foundations for Data Analytics","TYPE":"ETL","CREDITS":3,"SLOT":"E1"},{"CODE":"CSE1008","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1"},{"CODE":"CSE2001","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"A1+G1+TA1"},{"CODE":"CSE2009","TITLE":"Soft Computing","SLOT":"C1+TC1"},{"CODE":"CSE2010","TITLE":"Secure Coding","SLOT":"C2+TC2"},{"CODE":"CSE2011","TITLE":"Cyber Security and Digital Forensics","SLOT":"D2+TD2"},{"CODE":"CSE3001","TITLE":"Agile Development Process","SLOT":"F1+TF1"},{"CODE":"CSE3002","TITLE":"Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE3003","TITLE":"Computer Networks","TYPE":"ETL","CREDITS":3,"SLOT":"G1+TG1"},{"CODE":"CSE3004","TITLE":"Design and Analysis of Algorithms","TYPE":"ETL","CREDITS":3,"SLOT":"F1+TF1"},{"CODE":"CSE3008","TITLE":"Introduction to Machine Learning","SLOT":"D2+TD2"},{"CODE":"CSE3009","TITLE":"No SQL Databases","SLOT":"A2+TA2"},{"CODE":"CSE3012","TITLE":"Network Security","SLOT":"D2+TD2"},{"CODE":"CSE3018","TITLE":"Software Configuration Management","SLOT":"F2+TF2"},{"CODE":"CSE3019","TITLE":"Software Quality and Reliability","SLOT":"B2+TB2"},{"CODE":"CSE3020","TITLE":"Product Definition and Validation","SLOT":"F2+TF2"},{"CODE":"CSE4005","TITLE":"Data Warehousing and Data Mining","SLOT":"B2+TB2"},{"CODE":"CSE4006","TITLE":"Deep Learning","SLOT":"G2+TG2"},{"CODE":"CSE4018","TITLE":"Computer Vision and Robotics","TYPE":"ETL","SLOT":"D1+TD1"},{"CODE":"SWE1002","TITLE":"Principles of Software Engineering","SLOT":"B1+TB1"},{"CODE":"SWE2001","TITLE":"Data Structures and its Applications","SLOT":"A1+G1+TA1"},{"CODE":"SWE2002","TITLE":"Human Computer Interaction","SLOT":"G1+TG1"},{"CODE":"SWE2003","TITLE":"Requirements Engineering Management","SLOT":"C2+TC2"},{"CODE":"SWE2004","TITLE":"Software Design and Architecture","SLOT":"B1+TB1"},{"CODE":"SWE2006","TITLE":"Database Systems","SLOT":"C1+TC1"},{"CODE":"SWE2007","TITLE":"Fundamentals of Operating Systems","SLOT":"A2+TA2"},{"CODE":"SWE2008","TITLE":"Object Oriented Analysis and Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"SWE3001","TITLE":"Introduction to Computer Networks","SLOT":"F1+TF1"},{"CODE":"SWE3002","TITLE":"Software Project Management","SLOT":"D1+TD1"},{"CODE":"SWE3004","TITLE":"Front End Design and Testing","SLOT":"A2+TA2"},{"CODE":"SWE4001","TITLE":"Internet and Web Technologies","SLOT":"C1+TC1"},{"CODE":"SWE4002","TITLE":"Software Testing","SLOT":"E1+TE1"},{"CODE":"SWE4003","TITLE":"Concepts of Mobile Application Development","SLOT":"D2+TD2"},{"CODE":"SWE4004","TITLE":"Cloud Computing and its Applications","SLOT":"C1+TC1"},{"CODE":"SWE4005","TITLE":"Storage Technologies and Management","SLOT":"G1+TG1"},{"CODE":"CSE2013","TITLE":"Information Theory and Coding","SLOT":"B1+TB1+TBB1"},{"CODE":"CSE3031","TITLE":"Mobile Computing","SLOT":"G1+TG1"},{"CODE":"CSE4033","TITLE":"IT Project Management","SLOT":"E1"},{"CODE":"CSE3006","TITLE":"Data Visualization","SLOT":"E2+TE2"},{"CODE":"CSE4011","TITLE":"Internet of Things","SLOT":"C2+TC2"},{"CODE":"CSE4012","TITLE":"UI UX User Experience Design","SLOT":"B1+TB1"},{"CODE":"ECE4007","TITLE":"IoT System Architecture","SLOT":"G1"},{"CODE":"CSE4007","TITLE":"Digital Image Processing","SLOT":"G1+TG1"},{"CODE":"ECE1010","TITLE":"Probability and Random Processes","SLOT":"A1+TA1+TAA1"},{"CODE":"ECE2002","TITLE":"Computer Organization and Architecture","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1"},{"CODE":"ECE2007","TITLE":"Digital Signal Processing","SLOT":"B1+TB1"},{"CODE":"ECE3008","TITLE":"Neural Networks and Fuzzy Systems","SLOT":"D1+TD1+TDD1"},{"CODE":"ECE3009","TITLE":"Power Electronic Converters","SLOT":"C1+TC1"},{"CODE":"ECE4002","TITLE":"Wireless and Mobile Communications","SLOT":"A1+TA1"},{"CODE":"PHY1002","TITLE":"Semiconductor Device Physics","SLOT":"C1+TC1+TCC1"},{"CODE":"MEC2003","TITLE":"Strength of Materials","SLOT":"B1+TB1"},{"CODE":"MEC2004","TITLE":"Fluid Mechanics","SLOT":"D1+TD1"},{"CODE":"MEC2007","TITLE":"Introduction to Mechanical Engineering Design Process","SLOT":"C1+TC1"},{"CODE":"MEC3012","TITLE":"Additive Manufacturing","SLOT":"A1+TA1"},{"CODE":"CSE3015","TITLE":"Natural Language Processing","SLOT":"B1+TB1"},{"CODE":"ENG1015","TITLE":"Introduction to 20th Century European Literature in Translation","SLOT":"A1+TA1"},{"CODE":"ENG3001","TITLE":"Introduction to Translation Studies","SLOT":"A2+TA2"},{"CODE":"ENG3004","TITLE":"Introducing Linguistics","SLOT":"F1"},{"CODE":"FRL1004","TITLE":"Basic Spanish","TYPE":"TH","SLOT":"F1"},{"CODE":"FRL2004","TITLE":"Korean for Beginners","TYPE":"TH","SLOT":"F1"},{"CODE":"INL1001","TITLE":"Functional Hindi for non-Hindi Speakers","TYPE":"TH","SLOT":"G2"},{"CODE":"MAT2004","TITLE":"Applied Optimization Techniques","SLOT":"D1+TD1"},{"CODE":"STS1002","TITLE":"Fundamentals of Aptitude","SLOT":"D2+TD2"},{"CODE":"STS1008","TITLE":"Arithmetic Problem Solving Skills","SLOT":"D2+TD2"},{"CODE":"STS2006","TITLE":"Getting Started to Skill Enhancement","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1"},{"CODE":"STS2008","TITLE":"Numerical Ability and Cognitive Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"STS3004","TITLE":"Introduction to Programming Skills","TYPE":"TH","SLOT":"F2+TF2"},{"CODE":"ENG1001","TITLE":"English for Essential Communication","TYPE":"ETL","CREDITS":2,"SLOT":"F1"},{"CODE":"ENG1002","TITLE":"English for Effective Communication","TYPE":"ETL","CREDITS":2,"SLOT":"F2"},{"CODE":"ENG1005","TITLE":"Basic Communication in English","TYPE":"ETL","CREDITS":2,"SLOT":"F1"},{"CODE":"ENG1006","TITLE":"Functional Communication in English","TYPE":"ETL","CREDITS":2,"SLOT":"F2"},{"CODE":"ENG2001","TITLE":"English for Professional Communication","TYPE":"ETL","CREDITS":2,"SLOT":"E2"},{"CODE":"ENG2004","TITLE":"Advanced Professional Communication","TYPE":"ETL","CREDITS":2,"SLOT":"E2"},{"CODE":"FRL1001","TITLE":"Basic French","TYPE":"TH","SLOT":"F2"},{"CODE":"FRL1005","TITLE":"German for Beginners","TYPE":"TH","SLOT":"E1"},{"CODE":"FRL2003","TITLE":"French for Engineers","SLOT":"E1+TE1"},{"CODE":"INL1101","TITLE":"Foundations of Hindi Language","TYPE":"TH","SLOT":"E2"},{"CODE":"LIB1001","TITLE":"Anthropology \u2013 An Introduction","SLOT":"A1+TA1"},{"CODE":"LIB1003","TITLE":"Psychology - An Introduction","SLOT":"B1+TB1"},{"CODE":"LIB1007","TITLE":"Gender Studies - An Introduction","SLOT":"B2"},{"CODE":"LIB1014","TITLE":"Pursuit of Happiness","SLOT":"C1+TC1"},{"CODE":"LIB2003","TITLE":"Geography of Asia and Sub-Saharan Africa","SLOT":"F1+TF1"},{"CODE":"LIB2004","TITLE":"Ancient Indian History","SLOT":"A1+TA1+TAA1"},{"CODE":"STS4005","TITLE":"Basic Competitive Coding - II","SLOT":"G2+TG2"},{"CODE":"HUM1002","TITLE":"Personal Finance for Engineers","TYPE":"TH","SLOT":"F2"},{"CODE":"HUM2003","TITLE":"Fundamentals of Cost and Management Accounting","SLOT":"A1+TA1+TAA1"},{"CODE":"MGT1002","TITLE":"Lean Start-up Management","SLOT":"E2+TE2"},{"CODE":"MGT1005","TITLE":"Fundamentals of Creativity and Innovation Management","TYPE":"TH","SLOT":"C1"},{"CODE":"MGT1007","TITLE":"Economics for Engineers","SLOT":"D2+TD2"},{"CODE":"MGT1008","TITLE":"Accounting and Finance for Engineers","SLOT":"B2+TB2"},{"CODE":"MGT1011","TITLE":"Fundamentals of Business Strategy","SLOT":"B1+TB1"},{"CODE":"MGT1015","TITLE":"Fundamentals of Consumer Behaviour","SLOT":"E2+TE2"},{"CODE":"MGT1019","TITLE":"Fundamentals of Project Management","SLOT":"A2+TA2"},{"CODE":"MGT1023","TITLE":"Fundamentals of Human Resource Management","SLOT":"E1+TE1"},{"CODE":"MGT1037","TITLE":"Introduction to Management","SLOT":"E2+TE2"},{"CODE":"MGT1040","TITLE":"Entrepreneurship","TYPE":"LO","CREDITS":2,"SLOT":"F2"},{"CODE":"MGT2016","TITLE":"Essentials of Marketing Management","SLOT":"D1+TD1+TDD1"},{"CODE":"MGT2019","TITLE":"Introduction to Business Environment","SLOT":"D2+TD2+TDD2"},{"CODE":"TEC3001","TITLE":"Design Thinking","TYPE":"LO","CREDITS":3,"SLOT":"C2+TC2"},{"CODE":"LAW1001","TITLE":"Law, Internet and Society","SLOT":"G1+TG1"},{"CODE":"LAW1002","TITLE":"Competition Law for Engineers","SLOT":"F2+TF2"},{"CODE":"LAW1003","TITLE":"Human Rights and Criminal Justice System","SLOT":"G2+TG2"},{"CODE":"LAW1005","TITLE":"Introduction to Indian Constitution","SLOT":"D1+TD1"},{"CODE":"LAW1008","TITLE":"Intellectual Property Law for Engineers","TYPE":"TH","SLOT":"D1+TD1+TDD1"},{"CODE":"LAW2001","TITLE":"Business and Human Rights","SLOT":"E2+TE2"},{"CODE":"MGT1029","TITLE":"Basic Law for Engineers","SLOT":"D2+TD2"},{"CODE":"CHY1001","TITLE":"Environmental Studies","TYPE":"TH","SLOT":"G2"},{"CODE":"MAT2013","TITLE":"Financial Mathematics","SLOT":"D1+TD1+TDD1"},{"CODE":"CSE1005","TITLE":"Software Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2"},{"CODE":"CSE1007","TITLE":"Introduction to Cryptography","TYPE":"ETL","CREDITS":4,"SLOT":"D1+TD1","FACULTY":"Prof.Saroj Kumar Panigraphy","VENUE":"G13 - CB"},{"CODE":"CSE2003","TITLE":"Requirements Engineering Management","SLOT":"D1+TD1"},{"CODE":"CSE2007","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"A1+TA1"},{"CODE":"CSE2012","TITLE":"Knowledge Representation and Reasoning","SLOT":"F1+TFF1"},{"CODE":"CSE3011","TITLE":"Network Programming","SLOT":"F1+TF1"},{"CODE":"CSE3016","TITLE":"Cloud Computing and Security","SLOT":"F1+TF1"},{"CODE":"CSE3017","TITLE":"Cloud Big Data Analytics","SLOT":"D2+TD2"},{"CODE":"CSE3033","TITLE":"Software Verification and Validation","SLOT":"E1+TE1"},{"CODE":"CSE4001","TITLE":"Cloud Computing","SLOT":"D1+TD1"},{"CODE":"CSE4008","TITLE":"Social Network Analysis","SLOT":"F2+TF2"},{"CODE":"CSE4016","TITLE":"Database Administration","SLOT":"F2+TFF2"},{"CODE":"CSE4019","TITLE":"Applications of Artificial Intelligence","TYPE":"ETL","CREDITS":3,"SLOT":"E2+TE2"},{"CODE":"CSE4031","TITLE":"Web Application Security","SLOT":"E1+TEE1"},{"CODE":"CSE4037","TITLE":"Reinforcement Learning","SLOT":"C1+TC1"},{"CODE":"CSE4040","TITLE":"Mining Massive Data Sets","SLOT":"D2+TD2"},{"CODE":"CSE4042","TITLE":"Blockchain Platforms and Applications","SLOT":"E1+TEE1"},{"CODE":"CSE4044","TITLE":"Software Defined Networks and Network Function Virtualization","SLOT":"D1+TD1"},{"CODE":"ECE3001","TITLE":"Linear Integrated Circuits and Applications","SLOT":"A1+TA1"},{"CODE":"SWE3003","TITLE":"Information and System Security","SLOT":"D1+TD1"},{"CODE":"SWE3005","TITLE":"Principles of Design Patterns","SLOT":"B1+TB1"},{"CODE":"SWE4006","TITLE":"Advanced Server Side Programming","SLOT":"A1+TA1"},{"CODE":"CSE2006","TITLE":"Computer Graphics","SLOT":"F2+TFF2"},{"CODE":"LIB1013","TITLE":"Introduction to Comics and Graphic Narratives","SLOT":"D1+TD1"},{"CODE":"LIB3001","TITLE":"Applications of Moral Philosophy","SLOT":"F1+TF1"},{"CODE":"SWE4010","TITLE":"Formal Language and Automata Theory","SLOT":"B1+TB1+TBB1"},{"CODE":"CSE3013","TITLE":"Secure Group Communications","SLOT":"G2+TG2"},{"CODE":"CSE1020","TITLE":"Procedural Programming Using C","SLOT":"G1"},{"CODE":"ECE1007","TITLE":"Sensor Systems","SLOT":"E1+TEE1"},{"CODE":"ECE1008","TITLE":"Sensors and Control Systems","SLOT":"C1+TC1"},{"CODE":"ECE1011","TITLE":"Hybrid and Electric Vehicles","SLOT":"D1+TD1+TDD1"},{"CODE":"ECE2001","TITLE":"Analog Devices and Circuits","SLOT":"A1+TA1"},{"CODE":"ECE2005","TITLE":"Signals and Systems","SLOT":"B1+TB1+TBB1"},{"CODE":"ECE2006","TITLE":"Communication Systems","SLOT":"B1+TB1"},{"CODE":"ECE2014","TITLE":"Microprocessors and Microcontrollers","SLOT":"C1+TC1"},{"CODE":"ECE2015","TITLE":"Computer Architecture","SLOT":"A1+TA1+TAA1"},{"CODE":"ECE3005","TITLE":"CMOS VLSI Design","SLOT":"F1+TFF1"},{"CODE":"ECE3006","TITLE":"HDL Verification and Methodology","SLOT":"E1+TEE1"},{"CODE":"ECE3010","TITLE":"Speech processing","SLOT":"C1+TC1"},{"CODE":"ECE4003","TITLE":"Embedded Programming","SLOT":"F2+TFF2"},{"CODE":"ECE4004","TITLE":"Automotive Electrical and Electronic systems","SLOT":"D2+TD2+TDD2"},{"CODE":"ECE4005","TITLE":"SOC Design","SLOT":"C2+TC2"},{"CODE":"ECE4006","TITLE":"Analog IC Design","SLOT":"E2+TEE2"},{"CODE":"ECE4011","TITLE":"Robotics and Automation","SLOT":"D1+TD1+TDD1"},{"CODE":"ECE4017","TITLE":"IoT Domain Analyst","SLOT":"E2"},{"CODE":"ECE4018","TITLE":"Image Analysis and Computer Vision","SLOT":"F1+TFF1"},{"CODE":"MEC1006","TITLE":"Introduction to Robotics","SLOT":"D2+TD2"},{"CODE":"MEC2002","TITLE":"Thermodynamics","SLOT":"B2+TB2+TBB2"},{"CODE":"MEC2005","TITLE":"Fundamentals of Manufacturing Processes","SLOT":"A2+TA2"},{"CODE":"MEC2008","TITLE":"Product Design and Development","SLOT":"D1+TD1+TDD1"},{"CODE":"MEC2021","TITLE":"Mechatronics","SLOT":"D2+TD2+TDD2"},{"CODE":"MEC3001","TITLE":"Heat and Mass Transfer","SLOT":"A1+TA1"},{"CODE":"MEC3002","TITLE":"Theory of Machines","SLOT":"C2+TC2"},{"CODE":"MEC3005","TITLE":"Automation in Manufacturing","SLOT":"C2+TC2"},{"CODE":"MEC3010","TITLE":"Renewable Source of Energy","SLOT":"F2+TF2"},{"CODE":"MEC3011","TITLE":"Operations Research","SLOT":"E1+TEE1"},{"CODE":"MEC3027","TITLE":"Robot Dynamics","SLOT":"D1+TD1+TDD1"},{"CODE":"MEC4003","TITLE":"Internal Combustion Engines","SLOT":"B1+TB1"},{"CODE":"MEC4008","TITLE":"Automobile Engineering","SLOT":"C1+TC1"},{"CODE":"ENG1016","TITLE":"Climate Fiction- Narratives to Save the World!","SLOT":"C1+TC1"},{"CODE":"ENG1017","TITLE":"Film Appreciation","SLOT":"E1+TE1"},{"CODE":"ENG1018","TITLE":"Introduction to Fashion and Technology","SLOT":"F2+TF2"},{"CODE":"ENG1019","TITLE":"Introduction to Storytelling in Business & Entrepreneurship","SLOT":"G2+TG2"},{"CODE":"ENG2011","TITLE":"Revisiting Shakespearean Dramas","SLOT":"G1+TG1"},{"CODE":"ENG2014","TITLE":"Decoding Television in the Digital Age","SLOT":"D2+TD2"},{"CODE":"HUM1012","TITLE":"Engineering Economics","SLOT":"E2+TE2"},{"CODE":"HUM2010","TITLE":"Gender Economics","SLOT":"G1+TG1"},{"CODE":"HUM2106","TITLE":"History of Contemporary India","SLOT":"B2+TB2+TBB2"},{"CODE":"LIB1019","TITLE":"Dynamics of Gender Psychology","SLOT":"F1+TF1"},{"CODE":"LIB1020","TITLE":"Basic Psychology for Engineers","SLOT":"D2+TD2"},{"CODE":"LIB2004","TITLE":"Ancient India History","SLOT":"C2+TC2+TCC2"},{"CODE":"LIB2007","TITLE":"The Aesthetics of Performing Arts","SLOT":"C1+TC1+TCC1"},{"CODE":"LIB2010","TITLE":"Food & Literature","SLOT":"E2+TE2"},{"CODE":"LIB2015","TITLE":"Design Psychology","SLOT":"G1+TG1"},{"CODE":"LIB2016","TITLE":"Human Factors Psychology","SLOT":"C2+TC2"},{"CODE":"LIB2106","TITLE":"Language, Mind and Logic: Scientific Spectrum","SLOT":"E1+TEE1"},{"CODE":"STS1007","TITLE":"Arithmetic Problem Solving","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1"},{"CODE":"STS2003","TITLE":"Aptitude and Reasoning Skills","TYPE":"TH","SLOT":"F2+TFF2"},{"CODE":"STS2007","TITLE":"Enhancing Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"STS2009","TITLE":"Arithmetic Problem Solving Skills","TYPE":"TH","CREDITS":3,"SLOT":"E1+TEE1"},{"CODE":"STS4003","TITLE":"Enhancing Programming Ability","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2"},{"CODE":"HUM1005","TITLE":"Introduction to Cost Accounting","SLOT":"G2+TG2"},{"CODE":"MGT1014","TITLE":"Fundamentals of Brand Management","SLOT":"E2+TE2"},{"CODE":"MGT1042","TITLE":"Financial and Management Accounting","SLOT":"F1+TFF1"},{"CODE":"MGT2006","TITLE":"Fundamentals of Financial Management","SLOT":"F1+TFF1"},{"CODE":"MGT2014","TITLE":"Fundamentals of Marketing Management","SLOT":"E2+TE2"},{"CODE":"MGT3004","TITLE":"Fundamentals of Operations and Supply Chain Management","SLOT":"G1+TG1"},{"CODE":"CHY1004","TITLE":"Engineering Chemistry","SLOT":"C+TC"},{"CODE":"CSE1012","TITLE":"Problem Solving using Python","TYPE":"ETL","CREDITS":3,"SLOT":"C+TC+TCC"},{"CODE":"CSE2005","TITLE":"Object Oriented Programming","TYPE":"ETL","CREDITS":3,"SLOT":"B+TB+TBB"},{"CODE":"CSE2008","TITLE":"Operating Systems","TYPE":"ETL","CREDITS":4,"SLOT":"C+TC+TCC"},{"CODE":"CSE2014","TITLE":"Data Structures and Algorithms","TYPE":"ETL","CREDITS":4,"SLOT":"A+TA+TAA"},{"CODE":"CSE2018","TITLE":"Database Management Systems","TYPE":"ETL","CREDITS":3,"SLOT":"C+TC+TCC"},{"CODE":"CSE2019","TITLE":"Machine Learning","TYPE":"ETL","SLOT":"C+TC+TCC"},{"CODE":"CSE4002","TITLE":"Mobile Application Development","SLOT":"B+TB+TBB"},{"CODE":"ECE1002","TITLE":"Fundamentals of Electrical and Electronics Engineering","TYPE":"ETL","CREDITS":3,"SLOT":"A+TA+TAA"},{"CODE":"ECE1003","TITLE":"Digital Logic Design","TYPE":"ETL","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"Prof.Chandan Nayak","VENUE":"317 - CB"},{"CODE":"ECE1006","TITLE":"Digital Logic and Microprocessors","SLOT":"B+TB+TBB"},{"CODE":"ECE2003","TITLE":"Control Systems Engineering","SLOT":"B+TB+TBB"},{"CODE":"ECE2004","TITLE":"Microcontrollers and Interfacing","SLOT":"C+TC+TCC"},{"CODE":"ECE2010","TITLE":"Digital System Design for ASICs and FPGAs","SLOT":"B+TB+TBB"},{"CODE":"ECE3018","TITLE":"IoT Fundamentals","SLOT":"B+TB"},{"CODE":"MAT1002","TITLE":"Applications of differential and difference equations","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB"},{"CODE":"MAT1009","TITLE":"Applied Linear Algebra","SLOT":"C+TC+TCC"},{"CODE":"MAT1014","TITLE":"Fundamental Statistics","SLOT":"A+TA+TAA"},{"CODE":"MEC2016","TITLE":"Robot Kinematics and Dynamics","SLOT":"B+TB+TBB"},{"CODE":"MEC3004","TITLE":"Machine Design","SLOT":"B+TB+TBB"},{"CODE":"MEC3026","TITLE":"Robot Kinematics","SLOT":"B+TB+TBB"},{"CODE":"MGT1020","TITLE":"Fundamentals of Services Marketing","SLOT":"A+TA+TAA"},{"CODE":"MGT1031","TITLE":"Fundamentals of Management","SLOT":"A+TA"},{"CODE":"MGT3001","TITLE":"Services Science and Service Operational Management","SLOT":"B+TB"},{"CODE":"PHY2003","TITLE":"Condensed Matter Physics","SLOT":"B+TB+TBB"},{"CODE":"PHY4204","TITLE":"Quantum Mechanics - II","SLOT":"A+TA+TAA"},{"CODE":"STS1001","TITLE":"Introduction to Business Communication","SLOT":"B+TB+TBB"},{"CODE":"STS1007","TITLE":"Arithmetic problem solving","TYPE":"LO","CREDITS":3,"SLOT":"A+TA+TAA"},{"CODE":"STS1009","TITLE":"Introduction to Quantitative, Logical and Verbal Ability","SLOT":"C+TC+TCC"},{"CODE":"SWE2005","TITLE":"Concepts of Object Oriented Programming","SLOT":"A+TA+TAA"},{"CODE":"MGT1001","TITLE":"Ethics and Values","TYPE":"LO","CREDITS":2,"SLOT":"L31+L32"},{"CODE":"MEC1002","TITLE":"Engineering Graphics","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14+L21+L22"}]');

});

parcelRegister("6V6Os", function(module, exports) {
module.exports = JSON.parse('[{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E2+TE2","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E2+TE2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E2+TE2","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E2+TE2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E2+TE2","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E2+TE2","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E2+TE2","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E2+TE2","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E2+TE2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"E2+TE2","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"D1+TD1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"D1+TD1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"D1+TD1","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"D2+TD2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"D2+TD2","FACULTY":"FACE (APT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"D1+TD1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F1+TF1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F1+TF1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F1+TF1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F1+TF1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F1+TF1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F1+TF1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F1+TF1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F2+TF2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F2+TF2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F2+TF2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F2+TF2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F2+TF2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D2+TD2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D2+TD2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D2+TD2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D2+TD2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D2+TD2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D2+TD2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D2+TD2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D2+TD2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D2+TD2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D2+TD2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D2+TD2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D2+TD2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C1+TC1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C1+TC1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C1+TC1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C1+TC1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C1+TC1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C2+TC2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C2+TC2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C2+TC2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D2+TD2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D2+TD2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"D1+TD1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C1+TC1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C1+TC1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C1+TC1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C1+TC1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C1+TC1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C1+TC1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C1+TC1","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C2+TC2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C2+TC2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C2+TC2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C2+TC2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C2+TC2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C2+TC2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C2+TC2","FACULTY":"FACE (APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C1+TC1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"C2+TC2","FACULTY":"FACE (APT)"},{"CODE":"IASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"IASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"FACE (APT)"},{"CODE":"IASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"IASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"IASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"B2+TB2","FACULTY":"FACE (APT)"},{"CODE":"IASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"B2+TB2","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"ISTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"E1+TE1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"ISTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"E1+TE1","FACULTY":"FACE (APT)"},{"CODE":"ISTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"E2+TE2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"ISTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"E2+TE2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"ISTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"E1+TE1","FACULTY":"FACE (APT)"},{"CODE":"MASTS501","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice I","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"MASTS502","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"MASTS502","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"MASTS502","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"MASTS601","TITLE":"Competitive Coding I","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"MASTS601","TITLE":"Competitive Coding I","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"FACE (APT)"},{"CODE":"MASTS601","TITLE":"Competitive Coding I","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"MASTS602","TITLE":"Competitive Coding II","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"FACE (APT)"},{"CODE":"PASTS501","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice I","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"PASTS501","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice I","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"PASTS602","TITLE":"Competitive Coding II","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"FACE (APT)"},{"CODE":"PASTS602","TITLE":"Competitive Coding II","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"FACE (APT)"},{"CODE":"STS4022","TITLE":"Preparation for Employment","TYPE":"TH","CREDITS":1,"SLOT":"C1+TC1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"STS4022","TITLE":"Preparation for Employment","TYPE":"TH","CREDITS":1,"SLOT":"C1+TC1","FACULTY":"FACE (APT)"},{"CODE":"STS4022","TITLE":"Preparation for Employment","TYPE":"TH","CREDITS":1,"SLOT":"C2+TC2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"UASTS102","TITLE":"Quantitative Skills","TYPE":"TH","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"USTS302P","TITLE":"Advanced Competitive Coding-II","TYPE":"TH","CREDITS":2,"SLOT":"B1+TB1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MAHALAKSH\\r\\nMI S"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MAHALAKSH\\r\\nMI S"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"MAHALAKSH\\r\\nMI S"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"MAHALAKSH\\r\\nMI S"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"AROCKIASAM\\r\\nY S"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"AROCKIASAM\\r\\nY S"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"AROCKIASAM\\r\\nY S"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"AROCKIASAM\\r\\nY S"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KRISHNENDU\\r\\nBISWAS"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"KRISHNENDU\\r\\nBISWAS"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KRISHNENDU\\r\\nBISWAS"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"KRISHNENDU\\r\\nBISWAS"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MILIND SHRINIVAS\\r\\nDANGATE"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MILIND SHRINIVAS\\r\\nDANGATE"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"MILIND\\r\\nSHRINIVAS DANGATE"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"MILIND SHRINIVAS\\r\\nDANGATE"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"JAYANTA\\r\\nPARUI"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"JAYANTA\\r\\nPARUI"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KARTHIKA PICHAIMUTH\\r\\nU"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"KARTHIKA PICHAIMUTH\\r\\nU"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RAMACHAND\\r\\nRAN G"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"RAMACHAND\\r\\nRAN G"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAMACHAND\\r\\nRAN G"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54","FACULTY":"RAMACHAND\\r\\nRAN G"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KIRAN KUMAR TADI"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"KIRAN KUMAR TADI"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KIRAN KUMAR TADI"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"KIRAN KUMAR TADI"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"GANESAN\\r\\nPANDIAN"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"GANESAN\\r\\nPANDIAN"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"GANESAN\\r\\nPANDIAN"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"GANESAN\\r\\nPANDIAN"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUBHAYAN\\r\\nDEY"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SUBHAYAN\\r\\nDEY"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SUBHAYAN\\r\\nDEY"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SUBHAYAN\\r\\nDEY"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SAHELI\\r\\nKARMAKAR"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SAHELI\\r\\nKARMAKAR"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SAHELI\\r\\nKARMAKAR"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SAHELI\\r\\nKARMAKAR"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ARULMANI S"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"ARULMANI S"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ARULMANI S"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"PERUMAL D"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"PERUMAL D"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"PERUMAL D"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"PERUMAL D"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48","FACULTY":"ARULMANI S"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VINU MOHAN A M"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"VINU MOHAN A M"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"VINU MOHAN A M"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"VINU MOHAN A M"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BUTHANAPA LLI RAMAKRISHN\\r\\nA"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"BUTHANAPA LLI RAMAKRISHN\\r\\nA"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"BUTHANAPA LLI RAMAKRISHN\\r\\nA"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"BUTHANAPA LLI RAMAKRISHN\\r\\nA"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"LAKKOJI\\r\\nSATISH"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"LAKKOJI\\r\\nSATISH"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"LAKKOJI\\r\\nSATISH"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"LAKKOJI\\r\\nSATISH"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"FATEH VEER\\r\\nSINGH"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"FATEH VEER\\r\\nSINGH"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"FATEH VEER\\r\\nSINGH"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"FATEH VEER\\r\\nSINGH"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JAYANTA\\r\\nPARUI"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"JAYANTA\\r\\nPARUI"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KARTHIKA PICHAIMUTH\\r\\nU"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"KARTHIKA PICHAIMUTH\\r\\nU"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SANTOSH G"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SANTOSH G"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SANTOSH G"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SANTOSH G"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SARAVANAK\\r\\nUMAR R"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SARAVANAK\\r\\nUMAR R"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SHYAMAPAD\\r\\nA NANDI"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SHYAMAPAD\\r\\nA NANDI"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SIVASUBRAM\\r\\nANIAN R"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"SIVASUBRAM\\r\\nANIAN R"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SUJOY\\r\\nSARKAR"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SUJOY\\r\\nSARKAR"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SUNIT\\r\\nKUMAR"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SUNIT\\r\\nKUMAR"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"RAJENDRA\\r\\nKUMAR K"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"RAJENDRA\\r\\nKUMAR K"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"BUTHANAPA LLI RAMAKRISHN\\r\\nA"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"BUTHANAPA LLI RAMAKRISHN\\r\\nA"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VINU MOHAN A M"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"VINU MOHAN A M"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SHYAMAPAD\\r\\nA NANDI"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54","FACULTY":"SHYAMAPAD\\r\\nA NANDI"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ILAIYARAJA\\r\\nPERUMAL"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"ILAIYARAJA\\r\\nPERUMAL"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"RAJESHKUM\\r\\nAR T"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"RAJESHKUM\\r\\nAR T"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SUJOY\\r\\nSARKAR"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"LAKKOJI\\r\\nSATISH"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"LAKKOJI\\r\\nSATISH"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SIVASUBRAM\\r\\nANIAN R"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SIVASUBRAM\\r\\nANIAN R"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SUJOY\\r\\nSARKAR"},{"CODE":"BACSE108","TITLE":"Mathematical Foundations of Quantum Technologies","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SAROJ\\r\\nKUMAR DASH"},{"CODE":"BACSE109","TITLE":"Foundations of Quantum\\r\\nMechanics and Technologies","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"DAYASINDHU\\r\\nDEY"},{"CODE":"BAMAT101","TITLE":"Multivariable Calculus and\\r\\nDifferential Equations","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PADMAJA N"},{"CODE":"BAMAT101","TITLE":"Multivariable Calculus and\\r\\nDifferential Equations","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"PADMAJA N"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"KRISHNA\\r\\nKUMAR B"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SANDIP\\r\\nDALUI"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"BALAJI"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"HANNAH\\r\\nGRACE G"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"ASHISH KUMAR\\r\\nNANDI"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SURATH\\r\\nGHOSH"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SOUMENDU\\r\\nROY"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"ABHISHEK KUMAR\\r\\nSINGH"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"KARTHIK S"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"BASUA DEBANANDA"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"PRABHAKAR\\r\\nV"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"BHARANIDHA\\r\\nRAN R"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SANKARSAN\\r\\nTARAI"},{"CODE":"BAMAT202","TITLE":"Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PANKAJ\\r\\nSHUKLA"},{"CODE":"BAMAT202","TITLE":"Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SAURABH CHANDRA\\r\\nMAURY"},{"CODE":"BAMAT202","TITLE":"Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VIJAY KUMAR\\r\\nP"},{"CODE":"BAMAT202","TITLE":"Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"BALAJI"},{"CODE":"BAMAT202","TITLE":"Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ASHISH KUMAR\\r\\nNANDI"},{"CODE":"BAMAT202","TITLE":"Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MINI GHOSH"},{"CODE":"BAMAT202","TITLE":"Linear Algebra","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SAURABH\\r\\nCHANDRA MAURY"},{"CODE":"BAMAT202","TITLE":"Linear Algebra","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"PANKAJ\\r\\nSHUKLA"},{"CODE":"BAMAT202","TITLE":"Linear Algebra","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"VIJAY KUMAR\\r\\nP"},{"CODE":"BAMAT202","TITLE":"Linear Algebra","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"MINI GHOSH"},{"CODE":"BAMAT202","TITLE":"Linear Algebra","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"BALAJI"},{"CODE":"BAMAT202","TITLE":"Linear Algebra","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"ASHISH KUMAR\\r\\nNANDI"},{"CODE":"BAMAT203","TITLE":"Linear Algebra and Dynamical\\r\\nSystems","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"RADHA S"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"VIDHYA V"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"KALYAN\\r\\nMANNA"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SAURABH\\r\\nCHANDRA MAURY"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"ASHIS BERA"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SAGITHYA T"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"MEGALA M"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"FATHIMA SAFIKAA S N"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"OM NAMHA\\r\\nSHIVAY"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"UMA MAHESWARI\\r\\nS"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"DHANASEKA\\r\\nR S"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"RAJESH KUMAR MOHAPATRA"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"MUTHUNAG\\r\\nAI"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"NATHIYA N"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"RAJIVGANTHI CHINNATHA MBI"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"PAVITHRA R"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"DEVI YAMINI\\r\\nS"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"PROSENJIT\\r\\nPAUL"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"DHIVYA P"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SAURABH CHANDRA\\r\\nMAURY"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SAGITHYA T"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"OM NAMHA\\r\\nSHIVAY"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"PADMAJA N"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"ANKIT\\r\\nKUMAR"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"KOMAL\\r\\nKUMAR"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"AMIT KUMAR RAHUL"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"RUPCHAND SUTRADHAR"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"KARTHICK G"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"PULAK\\r\\nKONAR"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"KARTHICK G"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SANDIP SAHA"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"MOHD IMRAN IDRISI"},{"CODE":"BAMAT206","TITLE":"Linear Algebra and Integral Transforms","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD 1","FACULTY":"AVINASH KUMAR\\r\\nMITTAL"},{"CODE":"BAMAT206","TITLE":"Linear Algebra and Integral\\r\\nTransforms","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"POULOMI DE"},{"CODE":"BAMAT206","TITLE":"Linear Algebra and Integral\\r\\nTransforms","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"P MOHAN"},{"CODE":"BAMAT206","TITLE":"Linear Algebra and Integral\\r\\nTransforms","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"RAJEEB\\r\\nRANJAN"},{"CODE":"BAMAT206","TITLE":"Linear Algebra and Integral\\r\\nTransforms","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"NAZEER\\r\\nANSARI"},{"CODE":"BAMAT206","TITLE":"Linear Algebra and Integral\\r\\nTransforms","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"SANDIP\\r\\nKUMAR DAS"},{"CODE":"BAMAT206","TITLE":"Linear Algebra and Integral\\r\\nTransforms","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"PANKAJ\\r\\nSHUKLA"},{"CODE":"BAMAT206","TITLE":"Linear Algebra and Integral\\r\\nTransforms","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"SOMNATH\\r\\nBERA"},{"CODE":"BAMAT206","TITLE":"Linear Algebra and Integral\\r\\nTransforms","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"VIJAY KUMAR\\r\\nP"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PAVITHRA R"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SETHUKUMA\\r\\nRASAMY"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"JAYAGOPAL R"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"DHIVYA P"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"BASUA DEBANANDA"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAJIVGANTHI CHINNATHA MBI"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"DURGAPRAS\\r\\nAD P"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ABHISHEK KUMAR\\r\\nSINGH"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SANDIP SAHA"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RADHA S"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SRIRAMAN R"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MOHANA N"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"DEVI YAMINI\\r\\nS"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"THANGARAJ\\r\\nM"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MEGALA M"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"FATHIMA SAFIKAA S N"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"KARTHICK G"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MOHD IMRAN IDRISI"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SOMNATH\\r\\nBERA"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"OM NAMHA\\r\\nSHIVAY"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MYTHILI G Y"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SAROJ KUMAR\\r\\nDASH"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"KRISHNA\\r\\nKUMAR B"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"MANIMARAN\\r\\nJ"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SARANYA G"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SANKARSAN\\r\\nTARAI"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"AVINASH KUMAR\\r\\nMITTAL"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SANDIP\\r\\nDALUI"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PULAK\\r\\nKONAR"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"RAJESH\\r\\nKUMAR MOHAPATRA"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"NAZEER\\r\\nANSARI"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"MUTHUNAG\\r\\nAI"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"THARASI DILLESWAR\\r\\nRAO"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"JAGANATHA\\r\\nN B"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"BERIN\\r\\nGREENI A"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"POULOMI DE"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KALYAN\\r\\nMANNA"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"FATHIMA SAFIKAA S N"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ASHIS BERA"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MEGALA M"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"N RAMESH\\r\\nBABU"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SHARATH\\r\\nJOSE"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAJEEB\\r\\nRANJAN"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"RAJIVGANTHI CHINNATHA MBI"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SANDIP SAHA"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"DURGAPRAS\\r\\nAD P"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"PAVITHRA R"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SETHUKUMA\\r\\nRASAMY"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"BASUA DEBANANDA"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RADHA S"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"ABHISHEK\\r\\nKUMAR SINGH"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"DHIVYA P"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"JAYAGOPAL R"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"MOHANA N"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"FATHIMA SAFIKAA S N"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"MYTHILI G Y"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"KARTHICK G"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"MOHD IMRAN IDRISI"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"OM NAMHA\\r\\nSHIVAY"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"DEVI YAMINI\\r\\nS"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SRIRAMAN R"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SOMNATH\\r\\nBERA"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"MEGALA M"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SANKARSAN\\r\\nTARAI"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SANDIP\\r\\nDALUI"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"KRISHNA\\r\\nKUMAR B"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"PULAK\\r\\nKONAR"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"AVINASH\\r\\nKUMAR MITTAL"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"MUTHUNAG\\r\\nAI"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"RAJESH KUMAR\\r\\nMOHAPATRA"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SARANYA G"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"NAZEER\\r\\nANSARI"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"MANIMARAN\\r\\nJ"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SAROJ KUMAR\\r\\nDASH"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"JAGANATHA\\r\\nN B"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"ASHIS BERA"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"KALYAN\\r\\nMANNA"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"BERIN\\r\\nGREENI A"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"POULOMI DE"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"MEGALA M"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SHARATH\\r\\nJOSE"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"RAJEEB\\r\\nRANJAN"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"THARASI\\r\\nDILLESWAR RAO"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"N RAMESH\\r\\nBABU"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"FATHIMA SAFIKAA S N"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PROSENJIT\\r\\nPAUL"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"BHARANIDHA\\r\\nRAN R"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SRUTHA\\r\\nKEERTHI B"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PROSENJIT\\r\\nPAUL"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"BHARANIDHA\\r\\nRAN R"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SRUTHA\\r\\nKEERTHI B"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SANDIP\\r\\nKUMAR DAS"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"REVATHI G K"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"REVATHI G K"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"SANDIP\\r\\nKUMAR DAS"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"JAYAGOPAL R"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"JAYAGOPAL R"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"THANGARAJ\\r\\nM"},{"CODE":"BAMAT211","TITLE":"Probability Theory and Statistical\\r\\nInference","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"LAKSHMANA\\r\\nN S"},{"CODE":"BAMAT211","TITLE":"Probability Theory and Statistical\\r\\nInference","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"LAKSHMANA\\r\\nN S"},{"CODE":"BAPHY101","TITLE":"Applied Physics for Engineers","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"DEBOTTAM\\r\\nNANDI"},{"CODE":"BAPHY102","TITLE":"Physics for Biologist","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KARTHIKEYA\\r\\nN S"},{"CODE":"BAPHY102","TITLE":"Physics for Biologist","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KARTHIKEYA\\r\\nN S"},{"CODE":"BAPHY102","TITLE":"Physics for Biologist","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"KARTHIKEYA\\r\\nN S"},{"CODE":"BAPHY102","TITLE":"Physics for Biologist","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"KARTHIKEYA\\r\\nN S"},{"CODE":"BAPHY103","TITLE":"Physics and Mechanics for\\r\\nEngineers","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SANJIT DAS"},{"CODE":"BAPHY103","TITLE":"Physics and Mechanics for\\r\\nEngineers","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAJESH\\r\\nGOSWAMI"},{"CODE":"BAPHY103","TITLE":"Physics and Mechanics for\\r\\nEngineers","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SANJIT DAS"},{"CODE":"BAPHY103","TITLE":"Physics and Mechanics for\\r\\nEngineers","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"RAJESH\\r\\nGOSWAMI"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PUNITHAVEL\\r\\nAN N"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"PUNITHAVEL\\r\\nAN N"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GOPINATH\\r\\nMUDHANA"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MAYUKH RAJ GANGOPADH YAY"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PARASURAM\\r\\nAN E"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JITENDRA NARAYAN\\r\\nDASH"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAJASEKARA\\r\\nKUMAR V"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAVI KUMAR BIROJU"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"A KALAI\\r\\nPRIYA"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SARGAM"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PRIYANGA K"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SESHAN G"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"KANAL\\r\\nELAMPARITH I B"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"GOPINATH\\r\\nMUDHANA"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MAYUKH RAJ\\r\\nGANGOPADH YAY"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PARASURAM\\r\\nAN E"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"JITENDRA\\r\\nNARAYAN DASH"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"RAJASEKARA\\r\\nKUMAR V"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"RAVI KUMAR BIROJU"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"A KALAI\\r\\nPRIYA"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SARGAM"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"PRIYANGA K"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"SESHAN G"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"KANAL ELAMPARITH\\r\\nI B"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"NAVAMATHA\\r\\nVAN R"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"PUNITHAVEL\\r\\nAN N"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"GOPINATH\\r\\nMUDHANA"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DEBOTTAM\\r\\nNANDI"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MAYUKH RAJ GANGOPADH YAY"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"PARASURAM\\r\\nAN E"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"JITENDRA NARAYAN\\r\\nDASH"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAVI KUMAR BIROJU"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAJESH\\r\\nGOSWAMI"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KORLEPARA DIVYA\\r\\nBHARATHI"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"A KALAI\\r\\nPRIYA"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"PRIYANGA K"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KANAL\\r\\nELAMPARITH I B"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"NAVAMATHA\\r\\nVAN R"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"PUNITHAVEL\\r\\nAN N"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"GOPINATH\\r\\nMUDHANA"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"DEBOTTAM\\r\\nNANDI"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"MAYUKH RAJ GANGOPADH YAY"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"PARASURAM\\r\\nAN E"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"JITENDRA NARAYAN\\r\\nDASH"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"RAVI KUMAR BIROJU"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"RAJESH\\r\\nGOSWAMI"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"KORLEPARA\\r\\nDIVYA BHARATHI"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"A KALAI\\r\\nPRIYA"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"PRIYANGA K"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"KANAL\\r\\nELAMPARITH I B"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SESHAN G"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SARGAM"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SESHAN G"},{"CODE":"BAPHY106","TITLE":"Foundations of Quantum\\r\\nMechanics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RAMKUMAR\\r\\nM C"},{"CODE":"BAPHY106","TITLE":"Foundations of Quantum\\r\\nMechanics","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"RAMKUMAR\\r\\nM C"},{"CODE":"BAPHY106","TITLE":"Foundations of Quantum\\r\\nMechanics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAMKUMAR\\r\\nM C"},{"CODE":"BAPHY106","TITLE":"Foundations of Quantum\\r\\nMechanics","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"RAMKUMAR\\r\\nM C"},{"CODE":"BAPHY106","TITLE":"Foundations of Quantum\\r\\nMechanics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SHALINI M G"},{"CODE":"BAPHY106","TITLE":"Foundations of Quantum\\r\\nMechanics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SHALINI M G"},{"CODE":"BAPHY106","TITLE":"Foundations of Quantum\\r\\nMechanics","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SHALINI M G"},{"CODE":"BAPHY106","TITLE":"Foundations of Quantum\\r\\nMechanics","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SHALINI M G"},{"CODE":"BAPHY106","TITLE":"Foundations of Quantum\\r\\nMechanics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"CAROLINE\\r\\nPONRAJ"},{"CODE":"BAPHY106","TITLE":"Foundations of Quantum\\r\\nMechanics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"CAROLINE\\r\\nPONRAJ"},{"CODE":"BAPHY106","TITLE":"Foundations of Quantum\\r\\nMechanics","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"CAROLINE\\r\\nPONRAJ"},{"CODE":"BAPHY106","TITLE":"Foundations of Quantum\\r\\nMechanics","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"CAROLINE\\r\\nPONRAJ"},{"CODE":"BAPHY107","TITLE":"Physics of Semiconductor\\r\\nDevices","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"A KALAI\\r\\nPRIYA"},{"CODE":"BAPHY109","TITLE":"Physics of Materials in Textile\\r\\nand Fashion","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MANIKANDA\\r\\nN N"},{"CODE":"BAPHY109","TITLE":"Physics of Materials in Textile\\r\\nand Fashion","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"MANIKANDA\\r\\nN N"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"SAHELI\\r\\nKARMAKAR"},{"CODE":"BMAT102L","TITLE":"Differential Equations and\\r\\nTransforms","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"SARANYA G"},{"CODE":"BMAT102L","TITLE":"Differential Equations and\\r\\nTransforms","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"SARANYA G"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"DURGAPRAS\\r\\nAD P"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SHARATH\\r\\nJOSE"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KARTHIK S"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"VIDHYA V"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"KARTHIK S"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"VIDHYA V"},{"CODE":"BMAT205L","TITLE":"Discrete Mathematics and Graph\\r\\nTheory","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"BERIN\\r\\nGREENI A"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NAVAMATHA\\r\\nVAN R"},{"CODE":"IACHY101","TITLE":"Environmental Sciences","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"RAJENDRA\\r\\nKUMAR K"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KOMAL\\r\\nKUMAR"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RUPCHAND SUTRADHAR"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"BALAMURUG\\r\\nAN B J"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SAGITHYA T"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"KOMAL\\r\\nKUMAR"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RUPCHAND SUTRADHAR"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"P MOHAN"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"AMIT KUMAR RAHUL"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ANKIT\\r\\nKUMAR"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAJEEB\\r\\nRANJAN"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"P MOHAN"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SOUMENDU\\r\\nROY"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SOUMENDU\\r\\nROY"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SAGITHYA T"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"KOMAL\\r\\nKUMAR"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"RUPCHAND SUTRADHAR"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"BALAMURUG\\r\\nAN B J"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"RUPCHAND SUTRADHAR"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"ANKIT\\r\\nKUMAR"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"AMIT KUMAR RAHUL"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"P MOHAN"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"RAJEEB\\r\\nRANJAN"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"P MOHAN"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"KOMAL\\r\\nKUMAR"},{"CODE":"IAPHY101","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"G VINITHA"},{"CODE":"IAPHY101","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"G VINITHA"},{"CODE":"IAPHY101","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JUSTIN RAJ"},{"CODE":"IAPHY101","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"JUSTIN RAJ"},{"CODE":"IAPHY101","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"R. D.\\r\\nEITHIRAJ"},{"CODE":"IAPHY101","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"R. D.\\r\\nEITHIRAJ"},{"CODE":"IAPHY101","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"AJITHA B"},{"CODE":"IAPHY101","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"AJITHA B"},{"CODE":"IAPHY101","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"JUSTIN RAJ"},{"CODE":"IAPHY101","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"JUSTIN RAJ"},{"CODE":"IAPHY101","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"AJITHA B"},{"CODE":"IAPHY101","TITLE":"Engineering Physics","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"AJITHA B"},{"CODE":"ICHY102N","TITLE":"Environmental Sciences","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"ARULMANI S"},{"CODE":"IMAT201L","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"MINI GHOSH"},{"CODE":"IMAT201L","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"BHARANIDHA\\r\\nRAN R"},{"CODE":"IMAT201L","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"SRIRAMAN R"},{"CODE":"PCHY699J","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"PMDS699J","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"PMDS699J","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"PPHY699J","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"UACHY103","TITLE":"Environmental Sciences","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"PERUMAL D"},{"CODE":"UAMAT102","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"REVATHI G K"},{"CODE":"UHUM151N","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"ALAN G"},{"CODE":"USSC153N","TITLE":"Essence of Traditional\\r\\nKnowledge","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"AJITH I"},{"CODE":"BABIT101","TITLE":"Biochemistry","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SIVAKAMAVA\\r\\nLLI J"},{"CODE":"BABIT101","TITLE":"Biochemistry","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"JAYARAMAN\\r\\nG"},{"CODE":"BABIT101","TITLE":"Biochemistry","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SIVAKAMAVA\\r\\nLLI J"},{"CODE":"BABIT101","TITLE":"Biochemistry","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SIVAKAMAVA\\r\\nLLI J"},{"CODE":"BABIT101","TITLE":"Biochemistry","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"JAYARAMAN\\r\\nG"},{"CODE":"BABIT101","TITLE":"Biochemistry","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"JAYARAMAN\\r\\nG"},{"CODE":"BABIT102","TITLE":"Microbiology","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"UNNIKRISHN\\r\\nAN B S"},{"CODE":"BABIT102","TITLE":"Microbiology","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"YASHAVANT\\r\\nH P R"},{"CODE":"BABIT102","TITLE":"Microbiology","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"UNNIKRISHN\\r\\nAN B S"},{"CODE":"BABIT102","TITLE":"Microbiology","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"YASHAVANT\\r\\nH P R"},{"CODE":"BABIT102","TITLE":"Microbiology","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"UNNIKRISHN\\r\\nAN B S"},{"CODE":"BABIT102","TITLE":"Microbiology","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"YASHAVANT\\r\\nH P R"},{"CODE":"BACLE103","TITLE":"Mechanics of Solids","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ARUN\\r\\nKUMAR A"},{"CODE":"BACLE103","TITLE":"Mechanics of Solids","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"YAMINI\\r\\nSREEVALLI I"},{"CODE":"BACLE103","TITLE":"Mechanics of Solids","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"ARUN\\r\\nKUMAR A"},{"CODE":"BACLE103","TITLE":"Mechanics of Solids","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"ARUN\\r\\nKUMAR A"},{"CODE":"BACLE103","TITLE":"Mechanics of Solids","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"YAMINI\\r\\nSREEVALLI I"},{"CODE":"BACLE103","TITLE":"Mechanics of Solids","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"YAMINI\\r\\nSREEVALLI I"},{"CODE":"BACLE104","TITLE":"Waste Management","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SABUMON P\\r\\nC"},{"CODE":"BACLE104","TITLE":"Waste Management","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KARTHIKEYA\\r\\nN K"},{"CODE":"BACLE203","TITLE":"Structural Analysis","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"YAMINI\\r\\nSREEVALLI I"},{"CODE":"BACLE204","TITLE":"Transportation Engineering","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VENKADAVA\\r\\nRAHAN"},{"CODE":"BACLE204","TITLE":"Transportation Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"VENKADAVA\\r\\nRAHAN"},{"CODE":"BACLE204","TITLE":"Transportation Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"VENKADAVA\\r\\nRAHAN"},{"CODE":"BACLE207","TITLE":"Artificial Intelligence and Machine Learning in Civil\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VASUGI K"},{"CODE":"BACLE207","TITLE":"Artificial Intelligence and Machine Learning in Civil\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"VASUGI K"},{"CODE":"BACLE301","TITLE":"Construction Materials and\\r\\nTechniques","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"HELEN\\r\\nSANTHI M"},{"CODE":"BACLE301","TITLE":"Construction Materials and\\r\\nTechniques","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"KARTHIYAINI\\r\\nS"},{"CODE":"BACLE313","TITLE":"Environmental Impact Assessment","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"K PALANIVELU"},{"CODE":"BACLE315","TITLE":"Air and Noise pollution control","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ANJALI GOPAKUMAR"},{"CODE":"BACLE319","TITLE":"Essentials for Data Science and\\r\\nAI for Civil Engineers","TYPE":"TH","CREDITS":2,"SLOT":"TB1+TG1","FACULTY":"LT2"},{"CODE":"BACLE417","TITLE":"Sustainability Practices in Design\\r\\nof Buildings","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"LT1"},{"CODE":"BAHUM104","TITLE":"Professional Practices and\\r\\nConstruction Ethics","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"SHANMUGA\\r\\nSUNDARAM"},{"CODE":"BCLE211L","TITLE":"Urban Planning and\\r\\nDevelopment","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SABUMON P\\r\\nC"},{"CODE":"BCLE212L","TITLE":"Natural Disaster Mitigation and\\r\\nManagement","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MOHAN K"},{"CODE":"BCLE214L","TITLE":"Global Warming","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ARUN\\r\\nKUMAR A"},{"CODE":"BCLE214L","TITLE":"Global Warming","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"VENKADAVA\\r\\nRAHAN"},{"CODE":"BCLE215L","TITLE":"Waste Management","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SENTHILPAN\\r\\nDIAN M"},{"CODE":"BCLE215L","TITLE":"Waste Management","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ANJALI GOPAKUMAR"},{"CODE":"BCLE216L","TITLE":"Water Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ELAVENIL S"},{"CODE":"BCLE216L","TITLE":"Water Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MOHAN K"},{"CODE":"BCLE306L","TITLE":"Water Resources Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SARAVANAN\\r\\nK"},{"CODE":"BCLE306P","TITLE":"Water Resources Engineering\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SARAVANAN\\r\\nK"},{"CODE":"BCLE308L","TITLE":"Design of Steel Structures","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KARTHIYAINI\\r\\nS"},{"CODE":"BCLE308P","TITLE":"Steel Structures Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"KARTHIYAINI\\r\\nS"},{"CODE":"BCLE309L","TITLE":"Estimating and Costing","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"VASUGI V"},{"CODE":"BCLE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BCLE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"ICLE499J","TITLE":"Project II / Internship(one\\r\\nsemester)","TYPE":"TH","CREDITS":20,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"ICLE499J","TITLE":"Project II / Internship(one\\r\\nsemester)","TYPE":"TH","CREDITS":20,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"MASTE504","TITLE":"Advanced Design of Steel\\r\\nStructures","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"VASUGI K"},{"CODE":"MASTE505","TITLE":"Finite element analysis","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KARTHIKEYA\\r\\nN K"},{"CODE":"MASTE505","TITLE":"Finite element analysis","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"KARTHIKEYA\\r\\nN K"},{"CODE":"MASTE602","TITLE":"Advanced Concrete Materials\\r\\nand Technology","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SENTHILPAN\\r\\nDIAN M"},{"CODE":"MASTE602","TITLE":"Advanced Concrete Materials\\r\\nand Technology","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SENTHILPAN\\r\\nDIAN M"},{"CODE":"MASTE604","TITLE":"Earthquake Resistant Design","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"HELEN\\r\\nSANTHI M"},{"CODE":"MASTE608","TITLE":"Prefabricated Structures","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ELAVENIL S"},{"CODE":"MASTE699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MASTE699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L55+L5 6","FACULTY":"CHENDUR KUMARAN R"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L23+L24+L37+\\r\\nL38","FACULTY":"ANIK\\r\\nGOSWAMI"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L11+L1\\r\\n2","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L7+L8+L19+L2\\r\\n0","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L11+L1\\r\\n2","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L21+L2 2","FACULTY":"ANGELINE EZHILARASI G"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L9+L10","FACULTY":"ANGELINE EZHILARASI G"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L31+L32+L49+ L50","FACULTY":"ABRAHAM SUDHARSON\\r\\nPONRAJ"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L11+L12+L15+ L16","FACULTY":"ABRAHAM SUDHARSON\\r\\nPONRAJ"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L7+L8+L21+L2\\r\\n2","FACULTY":"ARIVARASI A"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L45+L46+L57+ L58","FACULTY":"JEETASHREE APARAJEETA"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L37+L38+L55+ L56","FACULTY":"SHEENA CHRISTABEL\\r\\nPRAVIN"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L23+L24+L27+ L28","FACULTY":"BIBHUTI BHUSAN\\r\\nPRADHAN"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L3+L4+L13+L1\\r\\n4","FACULTY":"KIRUTHIKA V"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L9+L10","FACULTY":"SHEENA CHRISTABEL\\r\\nPRAVIN"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L37+L3 8","FACULTY":"BIBHUTI BHUSAN\\r\\nPRADHAN"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L39+L40+L55+\\r\\nL56","FACULTY":"HARIHARAN I"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L31+L32+L55+\\r\\nL56","FACULTY":"ARIVARASI A"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L7+L8+L15+L1 6","FACULTY":"JEETASHREE APARAJEETA"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L37+L38+L49+ L50","FACULTY":"JEETASHREE APARAJEETA"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L11+L12+L43+\\r\\nL44","FACULTY":"HARIHARAN I"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L23+L24+L37+\\r\\nL38","FACULTY":"KIRUTHIKA V"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L9+L10+L27+L\\r\\n28","FACULTY":"KIRUTHIKA V"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L9+L10","FACULTY":"MANIGANDA\\r\\nN M"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L31+L32+L49+\\r\\nL50","FACULTY":"MANIGANDA\\r\\nN M"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L3+L4+L19+L2 0","FACULTY":"BIBHUTI\\r\\nBHUSAN PRADHAN"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NITHYA DARISINI  P S"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NIVEDITA M"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PADMAVATH\\r\\nY T V"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"S A AMUTHA JEEVAKUMAR I"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ASHA JERLIN\\r\\nM"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"CHRISTOPHE R COLUMBUS C"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"REVATHI A R"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KISHOR KISAN INGLE"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SANTHI V"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VIDHYA\\r\\nLAKSHMI M"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JOSHUA SUNDER DAVID\\r\\nREDDIPOGU"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SUHAIL K"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"NITHYA DARISINI  P S"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"NIVEDITA M"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"PADMAVATH\\r\\nY T V"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"S A AMUTHA JEEVAKUMAR I"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"ASHA JERLIN\\r\\nM"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"CHRISTOPHE R COLUMBUS C"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"REVATHI A R"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SANTHI V"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"VIDHYA\\r\\nLAKSHMI M"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"JOSHUA SUNDER DAVID\\r\\nREDDIPOGU"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SUHAIL K"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"HARINI S"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"NIVEDITA M"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PADMAVATH\\r\\nY T V"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"S A AMUTHA JEEVAKUMAR I"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"ASHA JERLIN\\r\\nM"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"CHRISTOPHE R COLUMBUS C"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"REVATHI A R"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"KISHOR KISAN INGLE"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SANTHI V"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"VIDHYA\\r\\nLAKSHMI M"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"JOSHUA SUNDER DAVID\\r\\nREDDIPOGU"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SUHAIL K"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"HARINI S"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"NIVEDITA M"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"PADMAVATH\\r\\nY T V"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"S A AMUTHA JEEVAKUMAR I"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"ASHA JERLIN\\r\\nM"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"CHRISTOPHE R COLUMBUS C"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"REVATHI A R"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"KISHOR KISAN INGLE"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SANTHI V"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"VIDHYA\\r\\nLAKSHMI M"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54","FACULTY":"JOSHUA SUNDER DAVID\\r\\nREDDIPOGU"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54","FACULTY":"SUHAIL K"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"KISHOR KISAN INGLE"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"A2","FACULTY":"MOHAMED\\r\\nIMRAN A"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L13+L14+L25+\\r\\nL26","FACULTY":"MOHAMED\\r\\nIMRAN A"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"SRIMATHI  R"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L11+L1\\r\\n2","FACULTY":"SRIMATHI  R"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"ANUSOOYA G"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"MANSOOR\\r\\nHUSSAIN D"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"DINAKARAN\\r\\nM"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"MUTHUKUM\\r\\nARAN K"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"PALANI THANARAJ K"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"SIVAKAMI R"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"KARTHIKEYA\\r\\nN N"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"MANIKANDA\\r\\nN P"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"MARIMUTHU\\r\\nM"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"OMANA J"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"JOHNSI R"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"RAMESH\\r\\nKANNAN R"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"JEIPRATHA P\\r\\nN"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"BALAJI V"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"THOMAS ABRAHAM J\\r\\nV"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"GANALA\\r\\nSANTOSHI"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SHREE\\r\\nPRAKASH"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"KANCHANA\\r\\nDEVI V"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"BENILA S"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"LOGESHWARI\\r\\nV"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"KABILAN K"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SHEELA LAVANYA J M"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"DHARINI R"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"MATHIARASI\\r\\nB"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"MANSOOR\\r\\nHUSSAIN D"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"SIVAKAMI R"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"MANIKANDA\\r\\nN P"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"OMANA J"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"KANCHANA\\r\\nDEVI V"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L31+L32+L57+\\r\\nL58","FACULTY":"DINAKARAN\\r\\nM"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"JEIPRATHA P\\r\\nN"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"THOMAS\\r\\nABRAHAM J V"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L31+L32+L55+ L56","FACULTY":"PALANI THANARAJ K"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"GANALA\\r\\nSANTOSHI"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L43+L4\\r\\n4","FACULTY":"KARTHIKEYA\\r\\nN N"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L33+L34+L55+\\r\\nL56","FACULTY":"MARIMUTHU\\r\\nM"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"JAYASUDHA\\r\\nM"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"LTI SCOPE1"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"KABILAN K"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L45+L46+L55+\\r\\nL56","FACULTY":"JOHNSI R"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"PRABHA B"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L33+L34+L51+\\r\\nL52","FACULTY":"BALAJI V"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"MANJULA V"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L43+L4\\r\\n4","FACULTY":"SHREE\\r\\nPRAKASH"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"AARTHI B"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"DHARINI R"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"YOGESH C"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L45+L46+L55+\\r\\nL56","FACULTY":"BENILA S"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"BENILA S"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"KARTHIKEYA\\r\\nN N"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L37+L38+L49+\\r\\nL50","FACULTY":"LOGESHWARI\\r\\nV"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"PALANI THANARAJ K"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"MARIMUTHU\\r\\nM"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"DINAKARAN\\r\\nM"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"R JOTHI"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"SHREE\\r\\nPRAKASH"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L11+L12+L23+\\r\\nL24","FACULTY":"MATHIARASI\\r\\nB"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"JEYAMANI D"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"KAJA MOHIDEEN A"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L3+L4+L21+L2\\r\\n2","FACULTY":"R JOTHI"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L15+L1\\r\\n6","FACULTY":"DINAKARAN\\r\\nM"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L3+L4+L19+L2\\r\\n0","FACULTY":"YOGESH C"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L3+L4+L25+L2 6","FACULTY":"PALANI THANARAJ K"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L9+L10+L19+L 20","FACULTY":"KAJA MOHIDEEN A"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L13+L14+L27+\\r\\nL28","FACULTY":"KARTHIKEYA\\r\\nN N"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L13+L14+L27+\\r\\nL28","FACULTY":"MARIMUTHU\\r\\nM"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L7+L8+L25+L2\\r\\n6","FACULTY":"JEYAMANI D"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L15+L1\\r\\n6","FACULTY":"SHREE\\r\\nPRAKASH"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L13+L14+L25+\\r\\nL26","FACULTY":"BENILA S"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L13+L14+L27+\\r\\nL28","FACULTY":"DHARINI R"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L29+L30+L39+ L40","FACULTY":"THOMAS ABRAHAM J\\r\\nV"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L43+L4\\r\\n4","FACULTY":"ANUSOOYA G"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L29+L30+L39+\\r\\nL40","FACULTY":"GANALA\\r\\nSANTOSHI"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L11+L12+L49+\\r\\nL50","FACULTY":"MANSOOR\\r\\nHUSSAIN D"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L23+L24+L37+\\r\\nL38","FACULTY":"SIVAKAMI R"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L11+L12+L51+\\r\\nL52","FACULTY":"MUTHUKUM\\r\\nARAN K"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L29+L30+L31+\\r\\nL32","FACULTY":"MANIKANDA\\r\\nN P"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L39+L40+L51+\\r\\nL52","FACULTY":"OMANA J"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L15+L1 6","FACULTY":"THOMAS ABRAHAM J\\r\\nV"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L3+L4+L19+L2\\r\\n0","FACULTY":"KANCHANA\\r\\nDEVI V"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L13+L14+L27+\\r\\nL28","FACULTY":"JAYASUDHA\\r\\nM"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L15+L1\\r\\n6","FACULTY":"GANALA\\r\\nSANTOSHI"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L9+L10+L21+L\\r\\n22","FACULTY":"KABILAN K"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L3+L4+L19+L2\\r\\n0","FACULTY":"SIVAKAMI R"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L7+L8+L21+L2\\r\\n2","FACULTY":"PRABHA B"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L7+L8+L21+L2\\r\\n2","FACULTY":"MANIKANDA\\r\\nN P"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L7+L8+L21+L2\\r\\n2","FACULTY":"JEIPRATHA P\\r\\nN"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L15+L1\\r\\n6","FACULTY":"OMANA J"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L29+L30+L31+\\r\\nL32","FACULTY":"KANCHANA\\r\\nDEVI V"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L15+L1\\r\\n6","FACULTY":"MANSOOR\\r\\nHUSSAIN D"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L39+L40+L51+\\r\\nL52","FACULTY":"KABILAN K"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L33+L34+L55+\\r\\nL56","FACULTY":"RAMESH\\r\\nKANNAN R"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L11+L12+L49+\\r\\nL50","FACULTY":"JEIPRATHA P\\r\\nN"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L25+L2\\r\\n6","FACULTY":"MANJULA V"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L3+L4+L7+L8","FACULTY":"AARTHI B"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L15+L1\\r\\n6","FACULTY":"LTI SCOPE1"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L37+L38+L57+ L58","FACULTY":"SHEELA LAVANYA J M"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L23+L24+L33+\\r\\nL34","FACULTY":"DHARINI R"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"S JAHANGEER SIDIQ"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L43+L4 4","FACULTY":"S JAHANGEER SIDIQ"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"S JAHANGEER SIDIQ"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L15+L1 6","FACULTY":"S JAHANGEER SIDIQ"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SIVARAMAKR ISHNAN N"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L45+L46+L55+ L56","FACULTY":"SIVARAMAKR ISHNAN N"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"SIVARAMAKR ISHNAN N"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L13+L14+L27+ L28","FACULTY":"SIVARAMAKR ISHNAN N"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"AARTHI D"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"AARTHI D"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L31+L32+L49+\\r\\nL50","FACULTY":"AARTHI D"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L3+L4+L23+L2\\r\\n4","FACULTY":"AARTHI D"},{"CODE":"BACSE106","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ANIK\\r\\nGOSWAMI"},{"CODE":"BACSE106","TITLE":"Operating Systems","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"ANIK\\r\\nGOSWAMI"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"KARMEL A"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"SUGANYA G"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"JANI\\r\\nANBARASI L"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"JANI\\r\\nANBARASI L"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"PRAKASH P"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"KALAIPRIYAN\\r\\nT"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"SURESHKUM\\r\\nAR WI WI"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"SURESHKUM\\r\\nAR WI WI"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"MARIA ANU\\r\\nV"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"MODIGARI\\r\\nNARENDRA"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"AMUTHA S"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"SANDHYA"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"SANDHYA"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"SUBITHA D"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"SAKTHIVEL R"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"SAKTHIVEL R"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"KSHMA\\r\\nTRIVEDI"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD 1","FACULTY":"MADURA\\r\\nMEENAKSHI R"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD 2","FACULTY":"MADURA MEENAKSHI\\r\\nR"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"MODIGARI\\r\\nNARENDRA"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"AMUTHA S"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"SUBITHA D"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"SARITA\\r\\nKUMARI"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"SARITA\\r\\nKUMARI"},{"CODE":"BACSE202","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PARKAVI K"},{"CODE":"BACSE202","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"PARKAVI K"},{"CODE":"BACSE202","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"LTI SCOPE2"},{"CODE":"BACSE202","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"LTI SCOPE2"},{"CODE":"BACSE202","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BACSE202","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BACSE202","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PARKAVI K"},{"CODE":"BACSE202","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"PARKAVI K"},{"CODE":"BACSE202","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"LTI SCOPE3"},{"CODE":"BACSE202","TITLE":"Database Systems","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"LTI SCOPE3"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PRADEEP K V"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PRADEEP K V"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ANANDAN P"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RAVICHANDR\\r\\nAN M"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SUDHA A"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"A SWAMINATH\\r\\nAN"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RADHA R"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NOEL JEYGAR ROBERT V"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"DEEPA NIVETHIKA S"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SANGEETHA\\r\\nN"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MAHESWARI\\r\\nP"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PRAVIN\\r\\nRENOLD A"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SHYAMALA L"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"ANANDAN P"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"RAVICHANDR\\r\\nAN M"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SUDHA A"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"A\\r\\nSWAMINATH AN"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"RADHA R"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"NOEL JEYGAR ROBERT V"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"DEEPA NIVETHIKA S"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SANGEETHA\\r\\nN"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"MAHESWARI\\r\\nP"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"PRAVIN\\r\\nRENOLD A"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SHYAMALA L"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PRIYANKA\\r\\nMISHRA"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"ANANDAN P"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PRAVIN\\r\\nRENOLD A"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RAVICHANDR\\r\\nAN M"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SIVAKUMAR\\r\\nP"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"A SWAMINATH\\r\\nAN"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RADHA R"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"NOEL JEYGAR ROBERT V"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"AMRIT PAL"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SANGEETHA\\r\\nN"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MAHESWARI\\r\\nP"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"PRIYANKA\\r\\nMISHRA"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"ANANDAN P"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"PRAVIN\\r\\nRENOLD A"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"RAVICHANDR\\r\\nAN M"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SIVAKUMAR\\r\\nP"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"A\\r\\nSWAMINATH AN"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"RADHA R"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"NOEL JEYGAR ROBERT V"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"AMRIT PAL"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SANGEETHA\\r\\nN"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"MAHESWARI\\r\\nP"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SIVAGAMI\\r\\nM"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SIVAGAMI\\r\\nM"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RUKMANI P"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"RUKMANI P"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BHAVADHARI\\r\\nNI R M"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"BHAVADHARI\\r\\nNI R M"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MONICA K M"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"MONICA K M"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SRIMATHI C"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"SRIMATHI C"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"DHIVYA R"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"DHIVYA R"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"PRADEEP\\r\\nKUMAR  T S"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"PRADEEP\\r\\nKUMAR  T S"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SRIMATHI C"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SRIMATHI C"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DHIVYA R"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"DHIVYA R"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SIVAGAMI\\r\\nM"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SIVAGAMI\\r\\nM"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RUKMANI P"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"RUKMANI P"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"BHAVADHARI\\r\\nNI R M"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"BHAVADHARI\\r\\nNI R M"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MONICA K M"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"MONICA K M"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"HEMANTH C"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"HEMANTH C"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"HEMANTH C"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"HEMANTH C"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PRASANNA\\r\\nBHARATHI S"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"PRASANNA\\r\\nBHARATHI S"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"LATHA P"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"LATHA P"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VENKATESAN\\r\\nC"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"VENKATESAN\\r\\nC"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"A. K\\r\\nILAVARASI"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ALOK\\r\\nCHAUHAN"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RISHIKESHAN\\r\\nC A"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SUGUNA"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"BRINDHA S"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"REENA ROY R"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PRAVEEN JOE\\r\\nI R"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"GANESH N"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SUGANYA R"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VIVEKANAND\\r\\nAN M"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ELAKIYA E"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"A. K\\r\\nILAVARASI"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"ALOK\\r\\nCHAUHAN"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"RISHIKESHAN\\r\\nC A"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SUGUNA"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"BRINDHA S"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"REENA ROY R"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"PRAVEEN JOE\\r\\nI R"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"GANESH N"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SUGANYA R"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"VIVEKANAND\\r\\nAN M"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"ELAKIYA E"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"A. K\\r\\nILAVARASI"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ALOK\\r\\nCHAUHAN"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"RISHIKESHAN\\r\\nC A"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SUGUNA"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"KAVITHA D"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"BRINDHA S"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"VIVEKANAND\\r\\nAN M"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"REENA ROY R"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PRAVEEN JOE\\r\\nI R"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SUGANYA R"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ELAKIYA E"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"A. K\\r\\nILAVARASI"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"ALOK\\r\\nCHAUHAN"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"RISHIKESHAN\\r\\nC A"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SUGUNA"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"KAVITHA D"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"BRINDHA S"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"VIVEKANAND\\r\\nAN M"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"REENA ROY R"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"PRAVEEN JOE\\r\\nI R"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SUGANYA R"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"ELAKIYA E"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NEELANARAY\\r\\nANAN V"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SIVABALAKRI\\r\\nSHNAN M"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"V. SAKTHIVEL"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VIJAYAKUMA\\r\\nR K P"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PRADEEP K"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"OM KUMAR\\r\\nC U"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"NEELANARAY\\r\\nANAN V"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SIVABALAKRI\\r\\nSHNAN M"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"V. SAKTHIVEL"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"VIJAYAKUMA\\r\\nR K P"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"PRADEEP K"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"OM KUMAR\\r\\nC U"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SHERLY A"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAJAKUMAR\\r\\nR"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SIVABALAKRI\\r\\nSHNAN M"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"PRADEEP K"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VIJAYAKUMA\\r\\nR K P"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"OM KUMAR\\r\\nC U"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SHERLY A"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"RAJAKUMAR\\r\\nR"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SIVABALAKRI\\r\\nSHNAN M"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"PRADEEP K"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"VIJAYAKUMA\\r\\nR K P"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"OM KUMAR\\r\\nC U"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KAVITHA D"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"KAVITHA D"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MAHESWARI S"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAJESH KUMAR"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"V BRINDHA"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RENTA CHINTALA\\r\\nBHARGAVI"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"D JEYA MALA"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MAHESWARI S"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAJESH KUMAR"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"V BRINDHA"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"RENTA\\r\\nCHINTALA BHARGAVI"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"D JEYA MALA"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MAHESWARI S"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RENTA CHINTALA\\r\\nBHARGAVI"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"MAHESWARI S"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"RENTA CHINTALA\\r\\nBHARGAVI"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RABINDRA KUMAR\\r\\nSINGH"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RAJESH M"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"PRIYADARSHI NI J"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SRIDHAR R"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"PANDIYARAJ U V"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"DOMINIC SAVIO M"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"LAKSHMI\\r\\nHARIKA PALIVELA"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KAVITHA J C"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"LEKSHMI K"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KAVIPRIYA G"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SELLAM V"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"TAHIR MUJTABA"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"RABINDRA KUMAR\\r\\nSINGH"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"RAJESH M"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"PRIYADARSHI NI J"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SRIDHAR R"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"PANDIYARAJ U V"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"DOMINIC SAVIO M"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"KAVITHA J C"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"LEKSHMI K"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"KAVIPRIYA G"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SELLAM V"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"TAHIR MUJTABA"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RABINDRA KUMAR\\r\\nSINGH"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAJESH M"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"PRIYADARSHI NI J"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SRIDHAR R"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"D JEYA MALA"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"PANDIYARAJ U V"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"DOMINIC SAVIO M"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"LAKSHMI HARIKA\\r\\nPALIVELA"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KAVITHA J C"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"LEKSHMI K"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KAVIPRIYA G"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SELLAM V"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"TAHIR MUJTABA"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"RABINDRA\\r\\nKUMAR SINGH"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"RAJESH M"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"PRIYADARSHI NI J"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SRIDHAR R"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"D JEYA MALA"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"PANDIYARAJ U V"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"DOMINIC SAVIO M"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"LAKSHMI\\r\\nHARIKA PALIVELA"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"KAVITHA J C"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"LEKSHMI K"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"KAVIPRIYA G"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SELLAM V"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"TAHIR MUJTABA"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"LAKSHMI HARIKA\\r\\nPALIVELA"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SATHIYA NARAYANAN\\r\\nS"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SATHIYA\\r\\nNARAYANAN S"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"LOGESH R"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ROHITH G"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ROHITH G"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"LOGESH R"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"ASHOK MONDAL"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"ASHOK MONDAL"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"NITISH KATAL"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"NITISH KATAL"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"KHADAR\\r\\nNAWAS K"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"VIJAYALAKSH\\r\\nMI A"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"DEVI K"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"SIVARANJANI\\r\\nN"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"POORNIMA S"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"SUJATHA M"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"RAJIV\\r\\nVINCENT"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"SARANYA G"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"DEVI K"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"VIJAYALAKSH\\r\\nMI A"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"SUJATHA M"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"POORNIMA S"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"SIVARANJANI\\r\\nN"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"RAJIV\\r\\nVINCENT"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"SARANYA G"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BACSE211","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MUTHUKUM ARAN K"},{"CODE":"BACSE211","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"AKKARAPAKA M SUNEESH\\r\\nJACOB"},{"CODE":"BACSE211","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"EDWARD JERO"},{"CODE":"BACSE211","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"AKKARAPAKA M SUNEESH JACOB"},{"CODE":"BACSE211","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"PRABHA B"},{"CODE":"BACSE211","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"MUTHUKUM ARAN K"},{"CODE":"BACSE211","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"AKKARAPAKA\\r\\nM SUNEESH JACOB"},{"CODE":"BACSE211","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"EDWARD JERO"},{"CODE":"BACSE211","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"AKKARAPAKA M SUNEESH JACOB"},{"CODE":"BACSE211","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"PRABHA B"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"S . A.\\r\\nSAJIDHA"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BHUVANESW\\r\\nARI"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VALARMATHI SUDHAKAR"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MANIMEGAL\\r\\nAI T"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ABINAYA S"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SHRUTI\\r\\nMISHRA"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"KANNIGA\\r\\nDEVI R"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"S . A.\\r\\nSAJIDHA"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"BHUVANESW\\r\\nARI"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"VALARMATHI SUDHAKAR"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"MANIMEGAL\\r\\nAI T"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"ABINAYA S"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SHRUTI\\r\\nMISHRA"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"KANNIGA\\r\\nDEVI R"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"S . A.\\r\\nSAJIDHA"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"JANAKI\\r\\nMEENA M"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"BHUVANESW\\r\\nARI"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VALARMATHI SUDHAKAR"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MANIMEGAL\\r\\nAI T"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ABINAYA S"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KANNIGA\\r\\nDEVI R"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"S . A.\\r\\nSAJIDHA"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"JANAKI\\r\\nMEENA M"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"BHUVANESW\\r\\nARI"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"VALARMATHI SUDHAKAR"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"MANIMEGAL\\r\\nAI T"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"ABINAYA S"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"KANNIGA\\r\\nDEVI R"},{"CODE":"BACSE312","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VIJAYAKUMA\\r\\nR P"},{"CODE":"BACSE312","TITLE":"Embedded Systems","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"VIJAYAKUMA\\r\\nR P"},{"CODE":"BACSE319","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NITHYANAND\\r\\nAM P"},{"CODE":"BACSE319","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUBBULAKSH\\r\\nMI P"},{"CODE":"BACSE319","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"NITHYANAND\\r\\nAM P"},{"CODE":"BACSE319","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SUBBULAKSH\\r\\nMI P"},{"CODE":"BACSE319","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SIVAKUMAR\\r\\nP"},{"CODE":"BACSE319","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SIVAKUMAR\\r\\nP"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SRITAMA\\r\\nROY"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"REVATHI S"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MANOJ\\r\\nKUMAR R"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"GUGA PRIYA\\r\\nG"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PRAKASH V"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ABRAHAM\\r\\nSUDHARSON PONRAJ"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"CHANTHINI\\r\\nBASKAR"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SINDHUJA M"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SOFANA\\r\\nREKA S"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MANIMARAN\\r\\nP"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"KARTHIKEYA\\r\\nN P R"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"REVATHI S"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"MANOJ\\r\\nKUMAR R"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SRITAMA\\r\\nROY"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"GUGA PRIYA\\r\\nG"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"PRAKASH V"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"ABRAHAM\\r\\nSUDHARSON PONRAJ"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"CHANTHINI\\r\\nBASKAR"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"SINDHUJA M"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SOFANA\\r\\nREKA S"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"MANIMARAN\\r\\nP"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"KARTHIKEYA\\r\\nN P R"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"FLORENCE GNANA POOVATHY J"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"KARTHIKEYA\\r\\nN P R"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"GUGA PRIYA\\r\\nG"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"CHANTHINI\\r\\nBASKAR"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SHARON\\r\\nGIFTSY A L"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"REVATHI S"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SINDHUJA M"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"MANIMARAN\\r\\nP"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SATHEESH\\r\\nKUMAR T"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"PUGAZHENT\\r\\nHI R"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SRITAMA\\r\\nROY"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"E\\r\\nMANIKANDA N"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"FLORENCE\\r\\nGNANA POOVATHY J"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"KARTHIKEYA\\r\\nN P R"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"GUGA PRIYA\\r\\nG"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"CHANTHINI\\r\\nBASKAR"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SHARON\\r\\nGIFTSY A L"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"REVATHI S"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SINDHUJA M"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"MANIMARAN\\r\\nP"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48","FACULTY":"SATHEESH\\r\\nKUMAR T"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L59+L60","FACULTY":"PUGAZHENT\\r\\nHI R"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L59+L60","FACULTY":"SRITAMA\\r\\nROY"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48","FACULTY":"E MANIKANDA\\r\\nN"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SANDHYA P"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SANDHYA P"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ANUBHA\\r\\nPEARLINE S"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"ANUBHA\\r\\nPEARLINE S"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SENTHIL PRAKASH P N"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SENTHIL PRAKASH P N"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SARANYA M"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"SARANYA M"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SENTHIL PRAKASH P N"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SANDHYA P"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SANDHYA P"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"ANUBHA\\r\\nPEARLINE S"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"ANUBHA\\r\\nPEARLINE S"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SARANYA M"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SENTHIL PRAKASH P N"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SARANYA M"},{"CODE":"BACSE342","TITLE":"Game Design and Development","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAJKUMAR R"},{"CODE":"BACSE342","TITLE":"Game Design and Development","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"RAJKUMAR R"},{"CODE":"BACSE342","TITLE":"Game Design and Development","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RAJKUMAR R"},{"CODE":"BACSE342","TITLE":"Game Design and Development","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"RAJKUMAR R"},{"CODE":"BACSE342","TITLE":"Game Design and Development","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RATHNA R"},{"CODE":"BACSE342","TITLE":"Game Design and Development","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"RATHNA R"},{"CODE":"BACSE344","TITLE":"Cloud Infrastructure and\\r\\nArchitecture","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"PARVATHY A\\r\\nK"},{"CODE":"BACSE344","TITLE":"Cloud Infrastructure and\\r\\nArchitecture","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"PARVATHY A\\r\\nK"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"PRABHAKAR\\r\\nAN R"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"PRABHAKAR\\r\\nAN R"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"PRIYADARSHI\\r\\nNI R R"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"PRIYADARSHI\\r\\nNI R R"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SELVAM D"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SELVAM D"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"THANIKACHA\\r\\nLAM V"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"THANIKACHA\\r\\nLAM V"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"BHULAKSHMI\\r\\nBONTHU"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"BHULAKSHMI\\r\\nBONTHU"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MEIGNANAM\\r\\nOORTHI D"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"MEIGNANAM\\r\\nOORTHI D"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"PRABHAKAR\\r\\nAN R"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"PRABHAKAR\\r\\nAN R"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"THANIKACHA\\r\\nLAM V"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"THANIKACHA\\r\\nLAM V"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MEIGNANAM\\r\\nOORTHI D"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"PRIYADARSHI\\r\\nNI R R"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"PRIYADARSHI\\r\\nNI R R"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SELVAM D"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SELVAM D"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"BHULAKSHMI\\r\\nBONTHU"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"BHULAKSHMI\\r\\nBONTHU"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"MEIGNANAM\\r\\nOORTHI D"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"D1","FACULTY":"HEMILA\\r\\nREXLINE D"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented\\r\\nProgramming Lab","TYPE":"LO","CREDITS":2,"SLOT":"L29+L30+L33+\\r\\nL34","FACULTY":"HEMILA\\r\\nREXLINE D"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"JENILA LIVINGSTON\\r\\nL M"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"LO","CREDITS":2,"SLOT":"L29+L30+L31+ L32","FACULTY":"JENILA LIVINGSTON\\r\\nL M"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"LENINISHA\\r\\nSHANMUGA M"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"LO","CREDITS":2,"SLOT":"L31+L32+L55+ L56","FACULTY":"LENINISHA SHANMUGA\\r\\nM"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"TH","CREDITS":1,"SLOT":"TA2","FACULTY":"KRITHIGA R"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L21+L2\\r\\n2","FACULTY":"KRITHIGA R"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"TH","CREDITS":1,"SLOT":"TD1","FACULTY":"PREETHA\\r\\nEVANGELINE D"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"LO","CREDITS":2,"SLOT":"L29+L30+L39+ L40","FACULTY":"PREETHA\\r\\nEVANGELINE D"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"TH","CREDITS":1,"SLOT":"TE2","FACULTY":"PREETHA EVANGELINE\\r\\nD"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L13+L1 4","FACULTY":"PREETHA\\r\\nEVANGELINE D"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of\\r\\nAlgorithms","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SENTHIL\\r\\nKUMAR R"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of\\r\\nAlgorithms Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SENTHIL\\r\\nKUMAR R"},{"CODE":"BCSE206L","TITLE":"Foundations of Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GEETHA S"},{"CODE":"BCSE206L","TITLE":"Foundations of Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"GEETHA S"},{"CODE":"BCSE206L","TITLE":"Foundations of Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PAVITHRA L K"},{"CODE":"BCSE206L","TITLE":"Foundations of Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"PAVITHRA L K"},{"CODE":"BCSE206L","TITLE":"Foundations of Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUDHEER\\r\\nKUMAR E"},{"CODE":"BCSE206L","TITLE":"Foundations of Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ABISHI\\r\\nCHOWDHUR Y"},{"CODE":"BCSE206L","TITLE":"Foundations of Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ABISHI CHOWDHUR\\r\\nY"},{"CODE":"BCSE206L","TITLE":"Foundations of Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"PADMA J"},{"CODE":"BCSE206L","TITLE":"Foundations of Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"HELEN\\r\\nVIJITHA P"},{"CODE":"BCSE208L","TITLE":"Data Mining","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BCSE208L","TITLE":"Data Mining","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SHARMILADE\\r\\nVI S"},{"CODE":"BCSE208L","TITLE":"Data Mining","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"PARVATHI R"},{"CODE":"BCSE208P","TITLE":"Data Mining Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BCSE208P","TITLE":"Data Mining Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SHARMILADE\\r\\nVI S"},{"CODE":"BCSE208P","TITLE":"Data Mining Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"PARVATHI R"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SHERLY A"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VERGIN RAJA SAROBIN M"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"JEGANNATHA\\r\\nN L"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SHERLY A"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"VERGIN RAJA SAROBIN M"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"JEGANNATHA\\r\\nN L"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ANIK\\r\\nGOSWAMI"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"PRAKASH B"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"B V A N S S PRABHAKAR\\r\\nRAO"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SUDHARSON\\r\\nS"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"REVATHI M"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MALINI\\r\\nDEEPIKA M"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"PRAKASH B"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"B V A N S S PRABHAKAR\\r\\nRAO"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SUDHARSON\\r\\nS"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"KULANDAI\\r\\nJOSEPHINE JULINA J"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"REVATHI M"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MALINI\\r\\nDEEPIKA M"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"JAYANTHI R"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"JAYANTHI R"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"ANIK\\r\\nGOSWAMI"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"PRAKASH B"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"B V A N S S PRABHAKAR\\r\\nRAO"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"SUDHARSON\\r\\nS"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"REVATHI M"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"MALINI\\r\\nDEEPIKA M"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"B V A N S S PRABHAKAR\\r\\nRAO"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SUDHARSON\\r\\nS"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"KULANDAI\\r\\nJOSEPHINE JULINA J"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"REVATHI M"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"MALINI\\r\\nDEEPIKA M"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"PRAKASH B"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"JAYANTHI R"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"JAYANTHI R"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SHOLA USHA\\r\\nRANI"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SHOLA USHA\\r\\nRANI"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VIJAYAPRABA\\r\\nKARAN K"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SOFTYA\\r\\nSEBASTIAN"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SAMBATH M"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SAMBATH M"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SHOLA USHA\\r\\nRANI"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SHOLA USHA\\r\\nRANI"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"VIJAYAPRABA\\r\\nKARAN K"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SOFTYA\\r\\nSEBASTIAN"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SAMBATH M"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SAMBATH M"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SARAVANAN\\r\\nP"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SRITAMA\\r\\nROY"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"DHANUSH R"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KIRAN\\r\\nKUMAR M"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"LATHA P"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SUHASINI S"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MOHAMMED\\r\\nAARIF K O"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"DHANUSH R"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"LATHA P"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SUHASINI S"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"MOHAMMED\\r\\nAARIF K O"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"VENKATESAN\\r\\nC"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VENKATESAN\\r\\nC"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SINDHU RAVINDRAN"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SINDHU RAVINDRAN"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KRITHIGA R"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"TRILOK NATH PANDEY"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"TRILOK NATH PANDEY"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"KRITHIGA R"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SENTHIL\\r\\nKUMAR A M"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SENTHIL\\r\\nKUMAR A M"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KANIMOZHI S"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"KANIMOZHI S"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PREMANAND\\r\\nV"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PREMANAND\\r\\nV"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PREM\\r\\nSANKAR"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SHARMILADE\\r\\nVI S"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SHARMILADE\\r\\nVI S"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KUMARAN K"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"KUMARAN K"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PRETHIJA G"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PRETHIJA G"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VIJAYARAJ J"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"VIJAYARAJ J"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RANJITH R"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RANJITH R"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAJARAJESW\\r\\nARI S"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"POONKODI\\r\\nM"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MALINI A"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"POONKODI\\r\\nM"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MALINI A"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MANAS RANJAN\\r\\nPRUSTY"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BALRAJ E"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MANJU G"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAMA PARVATHY L"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JOE DHANITH P R"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAJA M"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SREEJA P S"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NATARAJAN\\r\\nB"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VENKATRAM\\r\\nAN S"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"BALRAJ E"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MANJU G"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAMA PARVATHY L"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"JOE DHANITH P R"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAJA M"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SREEJA P S"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"NATARAJAN\\r\\nB"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"PANKAJA\\r\\nLAKSHMI P"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MERCY RAJASELVI\\r\\nBEAULAH P"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ARAVINDKU\\r\\nMAR S"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RATHNA R"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"LAKSHMANA\\r\\nN K"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MERCY RAJASELVI\\r\\nBEAULAH P"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"KIRUTHIKA S"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RADHIKA R"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"ARAVINDKU\\r\\nMAR S"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"LAKSHMANA\\r\\nN K"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RADHIKA R"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SHIVANI\\r\\nGUPTA"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SHIVANI\\r\\nGUPTA"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"INDIRA B"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"K UMA MAHESWARI"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"K UMA MAHESWARI"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"INDIRA B"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"MANAS\\r\\nRANJAN PRUSTY"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"BALRAJ E"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"MANJU G"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"RAMA PARVATHY L"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"JOE DHANITH P R"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"RAJA M"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SREEJA P S"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"NATARAJAN\\r\\nB"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"VENKATRAM\\r\\nAN S"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"BALRAJ E"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"MANJU G"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"RAMA PARVATHY L"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"JOE DHANITH P R"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"RAJA M"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SREEJA P S"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"NATARAJAN\\r\\nB"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"PANKAJA\\r\\nLAKSHMI P"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MERCY\\r\\nRAJASELVI BEAULAH P"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"ARAVINDKU\\r\\nMAR S"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"RATHNA R"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"LAKSHMANA\\r\\nN K"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"MERCY\\r\\nRAJASELVI BEAULAH P"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"KIRUTHIKA S"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"LAKSHMANA\\r\\nN K"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"ARAVINDKU\\r\\nMAR S"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"RADHIKA R"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"RADHIKA R"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SHIVANI\\r\\nGUPTA"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SHIVANI\\r\\nGUPTA"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"INDIRA B"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"K UMA MAHESWARI"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"K UMA MAHESWARI"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"INDIRA B"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KARTHIKA V"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"KARTHIKA V"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ILAVENDHAN\\r\\nA"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SOBITHA\\r\\nAHILA S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"JANNATH\\r\\nNISHA O S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KARTHIKA S K"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MALATHI D"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SANKARI M"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"AFRUZA\\r\\nBEGUM"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network Security","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SANDOSH SAKKARAPAN\\r\\nI"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network Security","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"INDRA PRIYADHARS\\r\\nHINI S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network Security","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ROLLA\\r\\nSUBRAHMAN YAM"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RENUKA DEVI\\r\\nS"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SOBITHA\\r\\nAHILA S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"JANNATH\\r\\nNISHA O S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"AFRUZA\\r\\nBEGUM"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"MALATHI D"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network Security","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ROLLA SUBRAHMAN\\r\\nYAM"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ILAVENDHAN\\r\\nA"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"KARTHIKA S K"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network Security","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"INDRA PRIYADHARS\\r\\nHINI S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network Security","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SANDOSH SAKKARAPAN\\r\\nI"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MARY\\r\\nSHAMALA L"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ANITA X"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"BALASARAS\\r\\nWATHI V R"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"T RAJA SREE"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SENDHIL R"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAJESH R"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SARAVANAN\\r\\nP"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VALARMATHI\\r\\nK"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"LINDA\\r\\nJOSEPH"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"MARY\\r\\nSHAMALA L"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"VATCHALA S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ANITA X"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"BALASARAS\\r\\nWATHI V R"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"T RAJA SREE"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SENDHIL R"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"RAJESH R"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SARAVANAN\\r\\nP"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"VALARMATHI\\r\\nK"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"LINDA\\r\\nJOSEPH"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SANKARI M"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VATCHALA S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"KARTHIKA V"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"KARTHIKA V"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ILAVENDHAN\\r\\nA"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SOBITHA\\r\\nAHILA S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"JANNATH\\r\\nNISHA O S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"KARTHIKA S K"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"MALATHI D"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SANKARI M"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"AFRUZA\\r\\nBEGUM"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network Security Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SANDOSH SAKKARAPAN\\r\\nI"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network Security Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"INDRA PRIYADHARS\\r\\nHINI S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network Security Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ROLLA\\r\\nSUBRAHMAN YAM"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"RENUKA DEVI\\r\\nS"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network Security Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"INDRA\\r\\nPRIYADHARS HINI S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network Security Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SANDOSH\\r\\nSAKKARAPAN I"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"ILAVENDHAN\\r\\nA"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SOBITHA\\r\\nAHILA S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"MALATHI D"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"JANNATH\\r\\nNISHA O S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"AFRUZA\\r\\nBEGUM"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network Security Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"ROLLA SUBRAHMAN\\r\\nYAM"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"KARTHIKA S K"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"MARY\\r\\nSHAMALA L"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"ANITA X"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"BALASARAS\\r\\nWATHI V R"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"T RAJA SREE"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SENDHIL R"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"RAJESH R"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SARAVANAN\\r\\nP"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"VALARMATHI\\r\\nK"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"LINDA\\r\\nJOSEPH"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"MARY\\r\\nSHAMALA L"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"VATCHALA S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"VATCHALA S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"ANITA X"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"BALASARAS\\r\\nWATHI V R"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"T RAJA SREE"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SENDHIL R"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"RAJESH R"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SARAVANAN\\r\\nP"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"VALARMATHI\\r\\nK"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"LINDA\\r\\nJOSEPH"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SANKARI M"},{"CODE":"BCSE317L","TITLE":"Information Security","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PADMANABA\\r\\nN R"},{"CODE":"BCSE317L","TITLE":"Information Security","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"PADMANABA\\r\\nN R"},{"CODE":"BCSE317L","TITLE":"Information Security","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"E INIYA\\r\\nNEHRU"},{"CODE":"BCSE317L","TITLE":"Information Security","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"E INIYA\\r\\nNEHRU"},{"CODE":"BCSE318L","TITLE":"Data Privacy","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"DHANALAKS\\r\\nHMI R"},{"CODE":"BCSE318L","TITLE":"Data Privacy","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DHANALAKS\\r\\nHMI R"},{"CODE":"BCSE325L","TITLE":"Introduction to Bitcoin","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BENIL T"},{"CODE":"BCSE325L","TITLE":"Introduction to Bitcoin","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"BENIL T"},{"CODE":"BCSE325L","TITLE":"Introduction to Bitcoin","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SRISAKTHI SARAVANAN"},{"CODE":"BCSE325L","TITLE":"Introduction to Bitcoin","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SRISAKTHI SARAVANAN"},{"CODE":"BCSE331L","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"MALINI A"},{"CODE":"BCSE331P","TITLE":"Exploratory Data Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MALINI A"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SWEETLIN HEMALATHA\\r\\nC"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SHRIDEVI S"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"AARTHI B"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SARASWATHI\\r\\nD"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KAJA MOHIDEEN A"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MATHIARASI\\r\\nB"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"TULASI PRASAD\\r\\nSARIKI"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RAJALAKSHM\\r\\nI R"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"ASWIGA R V"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KARTHIK R"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SUGANTHI K"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SWEETLIN HEMALATHA\\r\\nC"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SHRIDEVI S"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"AARTHI B"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"SARASWATHI\\r\\nD"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"KAJA MOHIDEEN A"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"MATHIARASI\\r\\nB"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"TULASI\\r\\nPRASAD SARIKI"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"RAJALAKSHM\\r\\nI R"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"ASWIGA R V"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"KARTHIK R"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SUGANTHI K"},{"CODE":"BCSE340L","TITLE":"Penetration Testing and\\r\\nVulnerability Assessment","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PRASAD M"},{"CODE":"BCSE340L","TITLE":"Penetration Testing and\\r\\nVulnerability Assessment","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"RENJITH P N"},{"CODE":"BCSE340L","TITLE":"Penetration Testing and\\r\\nVulnerability Assessment","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"RENJITH P N"},{"CODE":"BCSE340P","TITLE":"Penetration Testing and Vulnerability Assessment Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PRASAD M"},{"CODE":"BCSE340P","TITLE":"Penetration Testing and Vulnerability Assessment Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"RENJITH P N"},{"CODE":"BCSE340P","TITLE":"Penetration Testing and Vulnerability Assessment Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"RENJITH P N"},{"CODE":"BCSE401L","TITLE":"Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ABHIJIT\\r\\nMISHRA"},{"CODE":"BCSE401L","TITLE":"Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"ABHIJIT\\r\\nMISHRA"},{"CODE":"BCSE402L","TITLE":"Big Data Analytics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ELAKYA R"},{"CODE":"BCSE402L","TITLE":"Big Data Analytics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ELAKYA R"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programming","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JENILA LIVINGSTON\\r\\nL M"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programming","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"JENILA\\r\\nLIVINGSTON L M"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programming","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"LENINISHA\\r\\nSHANMUGA M"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programming","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"LENINISHA SHANMUGA\\r\\nM"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programming","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JOSHAN\\r\\nATHANESIOU S J"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programming","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"JOSHAN ATHANESIOU\\r\\nS J"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programming","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VALLIDEVI K"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programming","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VALLIDEVI K"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programming","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SUDHEER\\r\\nKUMAR E"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programming","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SUDHEER\\r\\nKUMAR E"},{"CODE":"BCSE406L","TITLE":"NoSQL Databases","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SUSEELA S"},{"CODE":"BCSE406L","TITLE":"NoSQL Databases","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SUSEELA S"},{"CODE":"BCSE406L","TITLE":"NoSQL Databases","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VIGNESH U"},{"CODE":"BCSE406L","TITLE":"NoSQL Databases","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"VIGNESH U"},{"CODE":"BCSE406L","TITLE":"NoSQL Databases","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BCSE407L","TITLE":"Computer vision","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VIJAYARAJAN\\r\\nR"},{"CODE":"BCSE407L","TITLE":"Computer vision","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"VIJAYARAJAN\\r\\nR"},{"CODE":"BCSE408L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PRIYAADHAR\\r\\nSHINI M"},{"CODE":"BCSE408L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"PRIYAADHAR\\r\\nSHINI M"},{"CODE":"BCSE408L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"TAMILARASI\\r\\nK"},{"CODE":"BCSE408L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"LTI SCOPE2"},{"CODE":"BCSE408L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"TAMILARASI\\r\\nK"},{"CODE":"BCSE408L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PREMANAND\\r\\nV"},{"CODE":"BCSE408L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"S VIGNESHWA\\r\\nRI"},{"CODE":"BCSE408L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"S\\r\\nVIGNESHWA RI"},{"CODE":"BCSE408L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PAVITHRA S"},{"CODE":"BCSE409L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUDHAKARA\\r\\nN G"},{"CODE":"BCSE409L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SUDHAKARA\\r\\nN G"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MALATHI G"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"PRASSANNA J"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"DEEPIKA\\r\\nROSELIND J"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"DEEPIKA\\r\\nROSELIND J"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ANITA\\r\\nCHRISTALINE J"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"ANITA\\r\\nCHRISTALINE J"},{"CODE":"BCSE417L","TITLE":"Machine vision","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAJARAJESW\\r\\nARI S"},{"CODE":"BCSE417L","TITLE":"Machine vision","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ASNATH\\r\\nVICTY PHAMILA Y"},{"CODE":"BCSE417L","TITLE":"Machine vision","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"RAJARAJESW\\r\\nARI S"},{"CODE":"BCSE417L","TITLE":"Machine vision","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SK AYESHA"},{"CODE":"BCSE417P","TITLE":"Machine Vision Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAJARAJESW\\r\\nARI S"},{"CODE":"BCSE417P","TITLE":"Machine Vision Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ASNATH VICTY\\r\\nPHAMILA Y"},{"CODE":"BCSE417P","TITLE":"Machine Vision Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"RAJARAJESW\\r\\nARI S"},{"CODE":"BCSE417P","TITLE":"Machine Vision Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SK AYESHA"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intelligence","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"RAJIV\\r\\nVINCENT"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intelligence","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"MODIGARI\\r\\nNARENDRA"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intelligence","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"AHADIT A.B"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intelligence","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"DEVI K"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intelligence","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"SARANYA G"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intelligence","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"POORNIMA S"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intelligence","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"KULANDAI\\r\\nJOSEPHINE JULINA J"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intelligence","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"KULANDAI JOSEPHINE\\r\\nJULINA J"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intelligence","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BCSE419L","TITLE":"Speech and Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"BHARADWAJ\\r\\nA KUMAR"},{"CODE":"BCSE419L","TITLE":"Speech and Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"AHADIT A.B"},{"CODE":"BCSE419L","TITLE":"Speech and Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SUJITHRA @\\r\\nKANMANI R"},{"CODE":"BCSE419L","TITLE":"Speech and Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"AHADIT A.B"},{"CODE":"BCSE419L","TITLE":"Speech and Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SUJITHRA @\\r\\nKANMANI R"},{"CODE":"BCSE419P","TITLE":"Speech and Language Processing\\r\\nlab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"BHARADWAJ\\r\\nA KUMAR"},{"CODE":"BCSE419P","TITLE":"Speech and Language Processing\\r\\nlab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"AHADIT A.B"},{"CODE":"BCSE419P","TITLE":"Speech and Language Processing\\r\\nlab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"AHADIT A.B"},{"CODE":"BCSE419P","TITLE":"Speech and Language Processing\\r\\nlab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SUJITHRA @\\r\\nKANMANI R"},{"CODE":"BCSE419P","TITLE":"Speech and Language Processing\\r\\nlab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SUJITHRA @\\r\\nKANMANI R"},{"CODE":"BCSE421L","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ARUNKUMAR V"},{"CODE":"BCSE421L","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"ARUNKUMAR V"},{"CODE":"BCSE421L","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"UMESH K"},{"CODE":"BCSE421L","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"UMESH K"},{"CODE":"BCSE423L","TITLE":"Robot Programming","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"SARANYARAJ\\r\\nD"},{"CODE":"BCSE423L","TITLE":"Robot Programming","TYPE":"TH","CREDITS":2,"SLOT":"A2","FACULTY":"SARANYARAJ\\r\\nD"},{"CODE":"BCSE423P","TITLE":"Robot Programming Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SARANYARAJ\\r\\nD"},{"CODE":"BCSE423P","TITLE":"Robot Programming Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SARANYARAJ\\r\\nD"},{"CODE":"BCSE425L","TITLE":"Robotic Perception","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PREM\\r\\nSANKAR"},{"CODE":"BCSE425P","TITLE":"Robotic Perception Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"PREM\\r\\nSANKAR"},{"CODE":"BCSE427L","TITLE":"Cognitive Robotics","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"ARUNKUMAR\\r\\nV"},{"CODE":"BCSE427L","TITLE":"Cognitive Robotics","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"PAVITHRA S"},{"CODE":"BCSE427L","TITLE":"Cognitive Robotics","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"PAVITHRA S"},{"CODE":"BCSE427L","TITLE":"Cognitive Robotics","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"REKHA D"},{"CODE":"BCSE427P","TITLE":"Cognitive Robotics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"ARUNKUMAR\\r\\nV"},{"CODE":"BCSE427P","TITLE":"Cognitive Robotics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PAVITHRA S"},{"CODE":"BCSE427P","TITLE":"Cognitive Robotics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"PAVITHRA S"},{"CODE":"BCSE427P","TITLE":"Cognitive Robotics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"REKHA D"},{"CODE":"BCSE428L","TITLE":"Autonomous Drones","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SATHIAN D"},{"CODE":"BCSE428L","TITLE":"Autonomous Drones","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"MARIA ANU\\r\\nV"},{"CODE":"BCSE428L","TITLE":"Autonomous Drones","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"SUVIDHA RUPESH\\r\\nKUMAR"},{"CODE":"BCSE428L","TITLE":"Autonomous Drones","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"VASANTHAK\\r\\nUMAR S"},{"CODE":"BCSE428L","TITLE":"Autonomous Drones","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"VASANTHAK\\r\\nUMAR S"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SATHIAN D"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SATHIAN D"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"MARIA ANU\\r\\nV"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"MARIA ANU\\r\\nV"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SUVIDHA RUPESH\\r\\nKUMAR"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SUVIDHA\\r\\nRUPESH KUMAR"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"VASANTHAK\\r\\nUMAR S"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"VASANTHAK\\r\\nUMAR S"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"VASANTHAK\\r\\nUMAR S"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"VASANTHAK\\r\\nUMAR S"},{"CODE":"BCSE429L","TITLE":"Cyber Physical Systems Design","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"PRADEEP\\r\\nKUMAR  T S"},{"CODE":"BCSE429P","TITLE":"Cyber Physical System Design\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PRADEEP\\r\\nKUMAR  T S"},{"CODE":"BCSE438L","TITLE":"Malware Analysis and Mitigation\\r\\nTechniques","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUBBULAKSH\\r\\nMI T"},{"CODE":"BCSE438L","TITLE":"Malware Analysis and Mitigation\\r\\nTechniques","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JAYASUDHA\\r\\nM"},{"CODE":"BCSE438L","TITLE":"Malware Analysis and Mitigation\\r\\nTechniques","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SUBBULAKSH\\r\\nMI T"},{"CODE":"BCSE438P","TITLE":"Malware Analysis and Mitigation\\r\\nTechniques Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SUBBULAKSH\\r\\nMI T"},{"CODE":"BCSE438P","TITLE":"Malware Analysis and Mitigation\\r\\nTechniques Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"JAYASUDHA\\r\\nM"},{"CODE":"BCSE438P","TITLE":"Malware Analysis and Mitigation\\r\\nTechniques Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SUBBULAKSH\\r\\nMI T"},{"CODE":"BCSE440L","TITLE":"System Security","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VIJAYAKUMA\\r\\nR K P"},{"CODE":"BCSE441L","TITLE":"Artificial Intelligence for\\r\\nCybersecurity","TYPE":"TH","CREDITS":2,"SLOT":"D1","FACULTY":"PADMANABA\\r\\nN R"},{"CODE":"BCSE441L","TITLE":"Artificial Intelligence for\\r\\nCybersecurity","TYPE":"TH","CREDITS":2,"SLOT":"D1","FACULTY":"JAI VINITA L"},{"CODE":"BCSE441L","TITLE":"Artificial Intelligence for\\r\\nCybersecurity","TYPE":"TH","CREDITS":2,"SLOT":"D2","FACULTY":"JAI VINITA L"},{"CODE":"BCSE441P","TITLE":"Artificial Intelligence for\\r\\nCybersecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"PADMANABA\\r\\nN R"},{"CODE":"BCSE441P","TITLE":"Artificial Intelligence for\\r\\nCybersecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"JAI VINITA L"},{"CODE":"BCSE441P","TITLE":"Artificial Intelligence for\\r\\nCybersecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"JAI VINITA L"},{"CODE":"BCSE442L","TITLE":"Cyber Threat Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"V. MUTHUMANI\\r\\nKANDAN"},{"CODE":"BCSE442L","TITLE":"Cyber Threat Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"V. MUTHUMANI\\r\\nKANDAN"},{"CODE":"BCSE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BCSE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"CSE1908","TITLE":"Capstone Project","TYPE":"TH","CREDITS":16,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"CSE1908","TITLE":"Capstone Project","TYPE":"TH","CREDITS":16,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"CSE3091","TITLE":"Cloud Ecosystem","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"CSE3091","TITLE":"Cloud Ecosystem","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"CSE3505","TITLE":"Foundations of Data Analytics","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"TRILOK NATH PANDEY"},{"CODE":"CSE3505","TITLE":"Foundations of Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"TRILOK NATH PANDEY"},{"CODE":"CSE3505","TITLE":"Foundations of Data Analytics","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"TRILOK NATH PANDEY"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"PADMA J"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"PADMA J"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"PADMA J"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"VIJAYARAJ J"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"VIJAYARAJ J"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"VIJAYARAJ J"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"PADMA J"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"PADMA J"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"PADMA J"},{"CODE":"CSE4047","TITLE":"Cloud Application Development","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"KOWSIGAN\\r\\nM"},{"CODE":"CSE4047","TITLE":"Cloud Application Development","TYPE":"TH","CREDITS":2,"SLOT":"B2","FACULTY":"KOWSIGAN\\r\\nM"},{"CODE":"CSE4047","TITLE":"Cloud Application Development","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"KOWSIGAN\\r\\nM"},{"CODE":"CSE4047","TITLE":"Cloud Application Development","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"KOWSIGAN\\r\\nM"},{"CODE":"CSE4047","TITLE":"Cloud Application Development","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"KOWSIGAN\\r\\nM"},{"CODE":"CSE4047","TITLE":"Cloud Application Development","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"KOWSIGAN\\r\\nM"},{"CODE":"CSE4067","TITLE":"Bioinformatics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"HEMALATHA\\r\\nK"},{"CODE":"CSE4067","TITLE":"Bioinformatics","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"HEMALATHA\\r\\nK"},{"CODE":"CSE4067","TITLE":"Bioinformatics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"HEMALATHA\\r\\nK"},{"CODE":"CSE4067","TITLE":"Bioinformatics","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"HEMALATHA\\r\\nK"},{"CODE":"CSE4069","TITLE":"Social Media Analytics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JAYARAM B"},{"CODE":"CSE4069","TITLE":"Social Media Analytics","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"JAYARAM B"},{"CODE":"IACSE201","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"DEEPIKA R"},{"CODE":"IACSE201","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"UMA MAHESWARI\\r\\nJ"},{"CODE":"IACSE201","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"UMA MAHESWARI\\r\\nJ"},{"CODE":"IACSE201","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"MANORANJIT\\r\\nHAM M"},{"CODE":"IACSE201","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SUDHA C"},{"CODE":"IACSE201","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"SUDHA C"},{"CODE":"IACSE201","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L43+L4\\r\\n4","FACULTY":"DEEPIKA R"},{"CODE":"IACSE201","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L43+L4 4","FACULTY":"UMA MAHESWARI\\r\\nJ"},{"CODE":"IACSE201","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L13+L14+L25+ L26","FACULTY":"UMA MAHESWARI\\r\\nJ"},{"CODE":"IACSE201","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L23+L2\\r\\n4","FACULTY":"MANORANJIT\\r\\nHAM M"},{"CODE":"IACSE201","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L23+L2\\r\\n4","FACULTY":"SUDHA C"},{"CODE":"IACSE201","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"LO","CREDITS":2,"SLOT":"L13+L14+L25+\\r\\nL26","FACULTY":"SUDHA C"},{"CODE":"IACSI101","TITLE":"Data Structures and Algorithms","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"S. BHARATHI RAJA"},{"CODE":"IACSI101","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"S. BHARATHI RAJA"},{"CODE":"IACSI101","TITLE":"Data Structures and Algorithms","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"NISHA  V.M"},{"CODE":"IACSI101","TITLE":"Data Structures and Algorithms","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"NISHA  V.M"},{"CODE":"IACSI101","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"NISHA  V.M"},{"CODE":"IACSI101","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"NISHA  V.M"},{"CODE":"IACSI202","TITLE":"Digital Logic and Computer\\r\\nDesign","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SATHYA SREE\\r\\nJ"},{"CODE":"IACSI202","TITLE":"Digital Logic and Computer\\r\\nDesign","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"USHA RANI S"},{"CODE":"IACSI202","TITLE":"Digital Logic and Computer\\r\\nDesign","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SATHYA SREE\\r\\nJ"},{"CODE":"IACSI202","TITLE":"Digital Logic and Computer\\r\\nDesign","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SATHYA SREE\\r\\nJ"},{"CODE":"IACSI202","TITLE":"Digital Logic and Computer\\r\\nDesign","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"USHA RANI S"},{"CODE":"IACSI202","TITLE":"Digital Logic and Computer\\r\\nDesign","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SATHYA SREE\\r\\nJ"},{"CODE":"IACSI301","TITLE":"Microprocessors and\\r\\nMicrocontrollers","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"CHITRA K"},{"CODE":"IACSI301","TITLE":"Microprocessors and\\r\\nMicrocontrollers","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"JAGANNATH\\r\\nM"},{"CODE":"IACSI301","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"RICHARDS JOE STANISLAUS"},{"CODE":"IACSI301","TITLE":"Microprocessors and\\r\\nMicrocontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"CHITRA K"},{"CODE":"IACSI301","TITLE":"Microprocessors and\\r\\nMicrocontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"JAGANNATH\\r\\nM"},{"CODE":"IACSI301","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"RICHARDS JOE STANISLAUS"},{"CODE":"IACSI302","TITLE":"Data Communication and Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"APPALARAJU MURALIDHA R"},{"CODE":"IACSI302","TITLE":"Data Communication and Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"APPALARAJU MURALIDHA R"},{"CODE":"IACSI302","TITLE":"Data Communication and\\r\\nComputer Networks","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SRIDEVI S"},{"CODE":"IACSI302","TITLE":"Data Communication and\\r\\nComputer Networks","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"V BRINDHA"},{"CODE":"IACSI302","TITLE":"Data Communication and\\r\\nComputer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SRIDEVI S"},{"CODE":"IACSI302","TITLE":"Data Communication and\\r\\nComputer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"V BRINDHA"},{"CODE":"IACSI306","TITLE":"Software Engineering Principles\\r\\nand Practices","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"NACHIYAPPA\\r\\nN S"},{"CODE":"IACSI306","TITLE":"Software Engineering Principles\\r\\nand Practices","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"JOHANAN\\r\\nJOYSINGH S"},{"CODE":"IACSI306","TITLE":"Software Engineering Principles\\r\\nand Practices","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"JOHANAN\\r\\nJOYSINGH S"},{"CODE":"IACSI306","TITLE":"Software Engineering Principles\\r\\nand Practices","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"NACHIYAPPA\\r\\nN S"},{"CODE":"IACSI306","TITLE":"Software Engineering Principles\\r\\nand Practices","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"JOHANAN\\r\\nJOYSINGH S"},{"CODE":"IACSI306","TITLE":"Software Engineering Principles\\r\\nand Practices","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"JOHANAN\\r\\nJOYSINGH S"},{"CODE":"IAMDI403","TITLE":"Data Mining","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MAHESWARI\\r\\nN"},{"CODE":"IAMDI403","TITLE":"Data Mining","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ASWIGA R V"},{"CODE":"IAMDI403","TITLE":"Data Mining","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MAHESWARI\\r\\nN"},{"CODE":"IAMDI403","TITLE":"Data Mining","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"MAHESWARI\\r\\nN"},{"CODE":"IAMDI403","TITLE":"Data Mining","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ASWIGA R V"},{"CODE":"IAMDI403","TITLE":"Data Mining","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"MAHESWARI\\r\\nN"},{"CODE":"IASWE101","TITLE":"Digital Logic and Microprocessor","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"B. NAGAJAYANT\\r\\nHI"},{"CODE":"IASWE101","TITLE":"Digital Logic and Microprocessor","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SASITHRADE\\r\\nVI. A"},{"CODE":"IASWE101","TITLE":"Digital Logic and Microprocessor","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"B. NAGAJAYANT\\r\\nHI"},{"CODE":"IASWE101","TITLE":"Digital Logic and Microprocessor","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"B. NAGAJAYANT\\r\\nHI"},{"CODE":"IASWE101","TITLE":"Digital Logic and Microprocessor","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SASITHRADE\\r\\nVI. A"},{"CODE":"IASWE101","TITLE":"Digital Logic and Microprocessor","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"B. NAGAJAYANT\\r\\nHI"},{"CODE":"IASWE102","TITLE":"Software Engineering","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"BERIN SHALU\\r\\nS"},{"CODE":"IASWE102","TITLE":"Software Engineering","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"IASWE102","TITLE":"Software Engineering","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"IASWE204","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAJALAKSHM\\r\\nI R"},{"CODE":"IASWE204","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KUMAR R"},{"CODE":"IASWE204","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"KUMAR R"},{"CODE":"IASWE204","TITLE":"Operating Systems","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAJALAKSHM\\r\\nI R"},{"CODE":"IASWE204","TITLE":"Operating Systems","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"KUMAR R"},{"CODE":"IASWE204","TITLE":"Operating Systems","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"KUMAR R"},{"CODE":"IASWE205","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ABDUL\\r\\nQUADIR MD"},{"CODE":"IASWE205","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"M. BRAVEEN"},{"CODE":"IASWE205","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"M. BRAVEEN"},{"CODE":"IASWE205","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"ABDUL\\r\\nQUADIR MD"},{"CODE":"IASWE205","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"M. BRAVEEN"},{"CODE":"IASWE205","TITLE":"Artificial Intelligence","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"M. BRAVEEN"},{"CODE":"IASWE207","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MENAKA\\r\\nPUSHPA A"},{"CODE":"IASWE207","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PUNITHA K"},{"CODE":"IASWE207","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"PUNITHA K"},{"CODE":"IASWE207","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"MENAKA\\r\\nPUSHPA A"},{"CODE":"IASWE207","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"PUNITHA K"},{"CODE":"IASWE207","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"PUNITHA K"},{"CODE":"IASWE208","TITLE":"Software Architecture and\\r\\nDesign","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"KUMAR K"},{"CODE":"IASWE208","TITLE":"Software Architecture and\\r\\nDesign","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"RAMA\\r\\nPRABHA K P"},{"CODE":"IASWE208","TITLE":"Software Architecture and\\r\\nDesign","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"KUMAR K"},{"CODE":"IBSA304L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"DEEPA NIVETHIKA S"},{"CODE":"IBSA304L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PRADEEP K V"},{"CODE":"IBSA304P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"DEEPA NIVETHIKA S"},{"CODE":"IBSA304P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"PRADEEP K V"},{"CODE":"IBSA305L","TITLE":"Big Data Frameworks","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SIVA PRIYA M\\r\\nS"},{"CODE":"IBSA305L","TITLE":"Big Data Frameworks","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SUGANESHW\\r\\nARI G"},{"CODE":"IBSA305P","TITLE":"Big Data Frameworks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SIVA PRIYA M\\r\\nS"},{"CODE":"IBSA305P","TITLE":"Big Data Frameworks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SUGANESHW\\r\\nARI G"},{"CODE":"IBSA310L","TITLE":"Network Security and\\r\\nCryptography Fundamentals","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"GANESAN R"},{"CODE":"IBSA409L","TITLE":"Social Media Analytics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"S\\r\\nVIGNESHWA RI"},{"CODE":"IMGT302L","TITLE":"Marketing Management","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SHAMAL S"},{"CODE":"IMGT302L","TITLE":"Marketing Management","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ARCHANA\\r\\nSINGH"},{"CODE":"IMGT401L","TITLE":"Organisational Behaviour","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"S DIVYA"},{"CODE":"IMGT401L","TITLE":"Organisational Behaviour","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"PRIYADHARS\\r\\nHINI V"},{"CODE":"ISWE206L","TITLE":"Web Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SANDEEP KUMAR\\r\\nSATAPATHY"},{"CODE":"ISWE206P","TITLE":"Web Technologies Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SANDEEP\\r\\nKUMAR SATAPATHY"},{"CODE":"ISWE210L","TITLE":"R for Data Science","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"ABISHI CHOWDHUR\\r\\nY"},{"CODE":"ISWE305L","TITLE":"Software Testing","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"GANESH N"},{"CODE":"ISWE305P","TITLE":"Software Testing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"GANESH N"},{"CODE":"ISWE307L","TITLE":"Digital Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JOSHAN ATHANESIOU\\r\\nS J"},{"CODE":"ISWE307L","TITLE":"Digital Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MALATHI G"},{"CODE":"ISWE307L","TITLE":"Digital Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"MALATHI G"},{"CODE":"ISWE309L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SENTHIL\\r\\nKUMAR A M"},{"CODE":"ISWE310L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ILAKIYASELV\\r\\nAN N"},{"CODE":"ISWE310L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"HELEN\\r\\nVIJITHA P"},{"CODE":"ISWE310L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ILAKIYASELV\\r\\nAN N"},{"CODE":"ISWE310L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"HELEN\\r\\nVIJITHA P"},{"CODE":"ISWE314L","TITLE":"Social Network Analysis","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SINDHU RAVINDRAN"},{"CODE":"ISWE402L","TITLE":"Software Metrics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"UMAMAHES\\r\\nWARI E"},{"CODE":"ISWE402L","TITLE":"Software Metrics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"UMAMAHES\\r\\nWARI E"},{"CODE":"ISWE402L","TITLE":"Software Metrics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SRINIVASA\\r\\nPERUMAL R"},{"CODE":"ISWE403L","TITLE":"Software Configuration\\r\\nManagement","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAMA\\r\\nPRABHA K P"},{"CODE":"ISWE403L","TITLE":"Software Configuration\\r\\nManagement","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RAMA\\r\\nPRABHA K P"},{"CODE":"ISWE403L","TITLE":"Software Configuration\\r\\nManagement","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"DHAVAKUMA\\r\\nR P"},{"CODE":"ISWE410L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"PRETHIJA G"},{"CODE":"ISWE410L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"M. PREMALATH\\r\\nA"},{"CODE":"ISWE410L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"ISWE410P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"PRETHIJA G"},{"CODE":"ISWE410P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"M.\\r\\nPREMALATH A"},{"CODE":"ISWE410P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"ISWE411L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ELAKYA R"},{"CODE":"ISWE411L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"BALRAJ E"},{"CODE":"ISWE412L","TITLE":"Block Chain Technologies","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BENIL T"},{"CODE":"ISWE416L","TITLE":"Big Data Analytics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PATTABIRAM\\r\\nAN V"},{"CODE":"ISWE416L","TITLE":"Big Data Analytics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"TAMILARASI\\r\\nK"},{"CODE":"ISWE417L","TITLE":"Quantum Computing","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KOWSIGAN\\r\\nM"},{"CODE":"ISWE421L","TITLE":"Cognitive Computing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JAYARAM B"},{"CODE":"ISWE421L","TITLE":"Cognitive Computing","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"JAYARAM B"},{"CODE":"ISWE425L","TITLE":"Game Theory and its\\r\\nApplications","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"UMESH K"},{"CODE":"MACSE513","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ANUSHA K"},{"CODE":"MACSE513","TITLE":"Computer Networks","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"ANUSHA K"},{"CODE":"MACSE622","TITLE":"Data Engineering and\\r\\nVisualization","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"AMRIT PAL"},{"CODE":"MACSE622","TITLE":"Data Engineering and\\r\\nVisualization","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"AMRIT PAL"},{"CODE":"MACSE623","TITLE":"Text and Speech Analytics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ILAKIYASELV\\r\\nAN N"},{"CODE":"MACSE624","TITLE":"Big Data Frameworks and\\r\\nTechnologies","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SUGANESHW\\r\\nARI G"},{"CODE":"MACSE624","TITLE":"Big Data Frameworks and\\r\\nTechnologies","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SUGANESHW\\r\\nARI G"},{"CODE":"MACSE628","TITLE":"Data Privacy and Security","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"JAI VINITA L"},{"CODE":"MACSE629","TITLE":"Deep Learning and Reinforcement Learning","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"A.\\r\\nNAYEEMULL A KHAN"},{"CODE":"MACSE629","TITLE":"Deep Learning and Reinforcement Learning","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"A. NAYEEMULL\\r\\nA KHAN"},{"CODE":"MACSE630","TITLE":"Generative AI and Large\\r\\nLanguage Models","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BHARADWAJ\\r\\nA KUMAR"},{"CODE":"MACSE630","TITLE":"Generative AI and Large\\r\\nLanguage Models","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"BHARADWAJ\\r\\nA KUMAR"},{"CODE":"MACSE632","TITLE":"Multi-Task and Meta Learning","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"KUMARAN K"},{"CODE":"MACSE634","TITLE":"Responsible Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"PREETHA\\r\\nEVANGELINE D"},{"CODE":"MACSE636","TITLE":"Cybersecurity","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VALLIDEVI K"},{"CODE":"MACSE638","TITLE":"Software Engineering and Modeling","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SATHYARAJA SEKARAN K"},{"CODE":"MACSE639","TITLE":"DevOps","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GAYATHRI\\r\\nDEVI S"},{"CODE":"MACSE639","TITLE":"DevOps","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"GAYATHRI\\r\\nDEVI S"},{"CODE":"MACSE640","TITLE":"Full Stack Application and\\r\\nDevelopment","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RAJKUMAR S"},{"CODE":"MACSE640","TITLE":"Full Stack Application and\\r\\nDevelopment","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"RAJKUMAR S"},{"CODE":"MACSE698","TITLE":"Internship I/ Dissertation I","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MACSE698","TITLE":"Internship I/ Dissertation I","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"MACSE699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MACSE699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"MCSE699J","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MCSE699J","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"MGT3007","TITLE":"Retail  Analytics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ARSHIYA FATHIMA M\\r\\nS"},{"CODE":"MGT3007","TITLE":"Retail  Analytics","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"ARSHIYA FATHIMA M\\r\\nS"},{"CODE":"MGT4002","TITLE":"Investment and Banking\\r\\nanalytics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUJATHA\\r\\nMANOHAR"},{"CODE":"MGT4002","TITLE":"Investment and Banking\\r\\nanalytics","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"SUJATHA\\r\\nMANOHAR"},{"CODE":"MGT4002","TITLE":"Investment and Banking\\r\\nanalytics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"BHAVANI J"},{"CODE":"MGT4002","TITLE":"Investment and Banking\\r\\nanalytics","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"BHAVANI J"},{"CODE":"PAMCA504","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"GRACELINE\\r\\nJASMINE S"},{"CODE":"PAMCA504","TITLE":"Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"GRACELINE\\r\\nJASMINE S"},{"CODE":"PAMCA504","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RAJALAKSHM\\r\\nI V"},{"CODE":"PAMCA504","TITLE":"Machine Learning","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"RAJALAKSHM\\r\\nI V"},{"CODE":"PAMCA505","TITLE":"Software Engineering","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"DHAVAKUMA\\r\\nR P"},{"CODE":"PAMCA505","TITLE":"Software Engineering","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"DHAVAKUMA\\r\\nR P"},{"CODE":"PAMCA506","TITLE":"Full Stack Web Development","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAJKUMAR S"},{"CODE":"PAMCA506","TITLE":"Full Stack Web Development","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAJKUMAR S"},{"CODE":"PAMCA506","TITLE":"Full Stack Web Development","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"NACHIYAPPA\\r\\nN S"},{"CODE":"PAMCA506","TITLE":"Full Stack Web Development","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"NACHIYAPPA\\r\\nN S"},{"CODE":"PAMCA601","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SOFTYA\\r\\nSEBASTIAN"},{"CODE":"PAMCA604","TITLE":"Cybersecurity","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"MENAKA\\r\\nPUSHPA A"},{"CODE":"PAMCA605","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"YOGESH C"},{"CODE":"PAMCA605","TITLE":"Deep Learning","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"YOGESH C"},{"CODE":"PAMCA606","TITLE":"Generative AI","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"PRAKASH P"},{"CODE":"PAMCA606","TITLE":"Generative AI","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"PRAKASH P"},{"CODE":"PAMCA699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"PAMCA699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"SWE2017","TITLE":"Parallel Programming","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MANJULA V"},{"CODE":"SWE2017","TITLE":"Parallel Programming","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"RENUKA DEVI\\r\\nR"},{"CODE":"SWE2017","TITLE":"Parallel Programming","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"MANJULA V"},{"CODE":"SWE2017","TITLE":"Parallel Programming","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"RENUKA DEVI\\r\\nR"},{"CODE":"SWE4009","TITLE":"Linux Programming","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SHOLA USHA\\r\\nRANI"},{"CODE":"SWE4009","TITLE":"Linux Programming","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SHOLA USHA\\r\\nRANI"},{"CODE":"UACSA104","TITLE":"Object Oriented Programming","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"POONKODI\\r\\nM"},{"CODE":"UACSA104","TITLE":"Object Oriented Programming","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"POONKODI\\r\\nM"},{"CODE":"UACSA105","TITLE":"Data Structures and Algorithms","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"UMMITY SRINIVASA\\r\\nRAO"},{"CODE":"UACSA105","TITLE":"Data Structures and Algorithms","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"UMMITY\\r\\nSRINIVASA RAO"},{"CODE":"UACSA106","TITLE":"Database Management Systems","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"R JOTHI"},{"CODE":"UACSA106","TITLE":"Database Management Systems","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"R JOTHI"},{"CODE":"UCSC205L","TITLE":"Web Development","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUVIDHA RUPESH\\r\\nKUMAR"},{"CODE":"UCSC205P","TITLE":"Web Development Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SUVIDHA\\r\\nRUPESH KUMAR"},{"CODE":"UCSC225L","TITLE":"Cyber Security","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"V. MUTHUMANI\\r\\nKANDAN"},{"CODE":"UCSC226L","TITLE":"Animation and VFX","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PRIYAADHAR\\r\\nSHINI M"},{"CODE":"UCSC312L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAJALAKSHM\\r\\nI V"},{"CODE":"UCSC312P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAJALAKSHM\\r\\nI V"},{"CODE":"UCSC313L","TITLE":"Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KIRUTHIKA S"},{"CODE":"UCSC313P","TITLE":"Image Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"KIRUTHIKA S"},{"CODE":"UCSC317L","TITLE":"Big Data Technologies","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIVA PRIYA M\\r\\nS"},{"CODE":"UCSC317P","TITLE":"Big Data Technologies Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SIVA PRIYA M\\r\\nS"},{"CODE":"UCSC318L","TITLE":"Exploratory Data Analytics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VIGNESH U"},{"CODE":"UCSC318P","TITLE":"Exploratory Data Analytics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"VIGNESH U"},{"CODE":"UCSC398J","TITLE":"Project","TYPE":"TH","CREDITS":4,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"UCSC398J","TITLE":"Project","TYPE":"TH","CREDITS":4,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PREMALATH\\r\\nA L"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"PREMALATH\\r\\nA L"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BINU BEN\\r\\nJOSE D R"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"BINU BEN\\r\\nJOSE D R"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"BINU BEN\\r\\nJOSE D R"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"BINU BEN\\r\\nJOSE D R"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ARAVIND C K"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"ARAVIND C K"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"ARAVIND C K"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"ARAVIND C K"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MEERA P S"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"MEERA P S"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MEERA P S"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"MEERA P S"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JYOTISMITA\\r\\nMISHRA"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"JYOTISMITA\\r\\nMISHRA"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"JYOTISMITA\\r\\nMISHRA"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"JYOTISMITA\\r\\nMISHRA"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KAMAL C"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"KAMAL C"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"KAMAL C"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"KAMAL C"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PRITAM\\r\\nBHOWMIK"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"PRITAM\\r\\nBHOWMIK"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KRISHNA\\r\\nKUMBA"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"KRISHNA\\r\\nKUMBA"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SEBINA\\r\\nYESMIN"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SEBINA\\r\\nYESMIN"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SEBINA\\r\\nYESMIN"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SEBINA\\r\\nYESMIN"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MORLA LAKSHMI SIVA SAI\\r\\nKUMAR"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"MORLA LAKSHMI SIVA SAI\\r\\nKUMAR"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"GANESH M"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"GANESH M"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"D V SUDARSANRE\\r\\nDDY"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"D V SUDARSANRE\\r\\nDDY"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RUPA\\r\\nMISHRA"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"RUPA\\r\\nMISHRA"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"NAWIN RA"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"NAWIN RA"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ARNAB PAL"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"ARNAB PAL"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"ARNAB PAL"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"ARNAB PAL"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JANANI C"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"JANANI C"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MITHU\\r\\nSARKAR"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"MITHU\\r\\nSARKAR"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"LAVANYA V"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"LAVANYA V"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"LAVANYA V"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"LAVANYA V"},{"CODE":"BAEEE102","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PEER\\r\\nFATHIMA A"},{"CODE":"BAEEE102","TITLE":"Circuit Theory","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"PEER\\r\\nFATHIMA A"},{"CODE":"BAEEE102","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PREMALATH\\r\\nA L"},{"CODE":"BAEEE102","TITLE":"Circuit Theory","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PREMALATH\\r\\nA L"},{"CODE":"BAEEE102","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SUBBULEKSH\\r\\nMI D"},{"CODE":"BAEEE102","TITLE":"Circuit Theory","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SUBBULEKSH\\r\\nMI D"},{"CODE":"BAEEE102","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"DEEPA T"},{"CODE":"BAEEE102","TITLE":"Circuit Theory","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"DEEPA T"},{"CODE":"BAEEE102","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MEENAKSHI J"},{"CODE":"BAEEE102","TITLE":"Circuit Theory","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"MEENAKSHI J"},{"CODE":"BAEEE102","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MOHAMED\\r\\nIMRAN A"},{"CODE":"BAEEE102","TITLE":"Circuit Theory","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MOHAMED\\r\\nIMRAN A"},{"CODE":"BAEEE201","TITLE":"Digital Electronics","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"NITHYA VENKATESAN"},{"CODE":"BAEEE201","TITLE":"Digital Electronics","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"NITHYA VENKATESAN"},{"CODE":"BAEEE201","TITLE":"Digital Electronics","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"FEBIN DAYA J\\r\\nL"},{"CODE":"BAEEE201","TITLE":"Digital Electronics","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"FEBIN DAYA J\\r\\nL"},{"CODE":"BAEEE201","TITLE":"Digital Electronics","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"GNANA SWATHIKA O\\r\\nV"},{"CODE":"BAEEE201","TITLE":"Digital Electronics","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"D V SUDARSANRE\\r\\nDDY"},{"CODE":"BAEEE201","TITLE":"Digital Electronics","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"D V SUDARSANRE\\r\\nDDY"},{"CODE":"BAEEE201","TITLE":"Digital Electronics","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"GNANA SWATHIKA O\\r\\nV"},{"CODE":"BAEEE203","TITLE":"Microcontrollers and Embedded\\r\\nProgramming","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VIJAYAPRIYA\\r\\nR"},{"CODE":"BAEEE203","TITLE":"Microcontrollers and Embedded Programming","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"INAYATHULL AAH ABDUL KAREEM"},{"CODE":"BAEEE203","TITLE":"Microcontrollers and Embedded\\r\\nProgramming","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"VIJAYAPRIYA\\r\\nR"},{"CODE":"BAEEE203","TITLE":"Microcontrollers and Embedded Programming","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"INAYATHULL\\r\\nAAH ABDUL KAREEM"},{"CODE":"BAEEE204","TITLE":"Electromagnetic Field Theory","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD 2","FACULTY":"CHENDUR KUMARAN R"},{"CODE":"BAEEE204","TITLE":"Electromagnetic Field Theory","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"MEENAKSHI J"},{"CODE":"BAEEE204","TITLE":"Electromagnetic Field Theory","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD 1","FACULTY":"ANANTHA KRISHNAN V"},{"CODE":"BAEEE204","TITLE":"Electromagnetic Field Theory","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"JANANI C"},{"CODE":"BAEEE205","TITLE":"Power Systems Engineering","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"ARUL R"},{"CODE":"BAEEE205","TITLE":"Power Systems Engineering","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"KURUSEELAN\\r\\nS"},{"CODE":"BAEEE205","TITLE":"Power Systems Engineering","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"SUBHENDU\\r\\nSEKHAR SAHOO"},{"CODE":"BAEEE205","TITLE":"Power Systems Engineering","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"PRITAM\\r\\nBHOWMIK"},{"CODE":"BAEEE206","TITLE":"Electrical Machines","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"JANANI C"},{"CODE":"BAEEE206","TITLE":"Electrical Machines","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"JANANI C"},{"CODE":"BAEEE207","TITLE":"Measurements and\\r\\nInstrumentation","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KAMAL C"},{"CODE":"BAEEE207","TITLE":"Measurements and\\r\\nInstrumentation","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"KAMAL C"},{"CODE":"BAEEE207","TITLE":"Measurements and Instrumentation","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ANANTHA KRISHNAN V"},{"CODE":"BAEEE207","TITLE":"Measurements and Instrumentation","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"ANANTHA KRISHNAN V"},{"CODE":"BAEEE207","TITLE":"Measurements and\\r\\nInstrumentation","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SEBINA\\r\\nYESMIN"},{"CODE":"BAEEE207","TITLE":"Measurements and\\r\\nInstrumentation","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SEBINA\\r\\nYESMIN"},{"CODE":"BAEEE207","TITLE":"Measurements and\\r\\nInstrumentation","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SWETHA R\\r\\nKUMAR"},{"CODE":"BAEEE207","TITLE":"Measurements and\\r\\nInstrumentation","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SWETHA R\\r\\nKUMAR"},{"CODE":"BAEEE208","TITLE":"Probability and Stochastic Processes","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"CHENDUR KUMARAN R"},{"CODE":"BAEEE301","TITLE":"Power Electronics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KANIMOZHI\\r\\nG"},{"CODE":"BAEEE301","TITLE":"Power Electronics","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"KANIMOZHI\\r\\nG"},{"CODE":"BAEEE301","TITLE":"Power Electronics","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"KANIMOZHI\\r\\nG"},{"CODE":"BAEEE301","TITLE":"Power Electronics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ARAVIND C K"},{"CODE":"BAEEE301","TITLE":"Power Electronics","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"ARAVIND C K"},{"CODE":"BAEEE301","TITLE":"Power Electronics","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ARAVIND C K"},{"CODE":"BAEEE301","TITLE":"Power Electronics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"BALAMURUG\\r\\nAN P"},{"CODE":"BAEEE301","TITLE":"Power Electronics","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"BALAMURUG\\r\\nAN P"},{"CODE":"BAEEE301","TITLE":"Power Electronics","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"BALAMURUG\\r\\nAN P"},{"CODE":"BAEEE301","TITLE":"Power Electronics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JAYAPRAGAS\\r\\nH R"},{"CODE":"BAEEE301","TITLE":"Power Electronics","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"JAYAPRAGAS\\r\\nH R"},{"CODE":"BAEEE301","TITLE":"Power Electronics","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"JAYAPRAGAS\\r\\nH R"},{"CODE":"BAEEE302","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"IYSWARYA ANNAPOORA\\r\\nNI K"},{"CODE":"BAEEE302","TITLE":"Digital Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"IYSWARYA ANNAPOORA\\r\\nNI K"},{"CODE":"BAEEE302","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"UMAYAL C"},{"CODE":"BAEEE302","TITLE":"Digital Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"UMAYAL C"},{"CODE":"BAEEE302","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"ANGELINE EZHILARASI G"},{"CODE":"BAEEE302","TITLE":"Digital Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"ANGELINE EZHILARASI G"},{"CODE":"BAEEE302","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SUBHENDU\\r\\nSEKHAR SAHOO"},{"CODE":"BAEEE302","TITLE":"Digital Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SUBHENDU\\r\\nSEKHAR SAHOO"},{"CODE":"BAEEE304","TITLE":"Power Electronics and Drives","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"M. PRABHAKAR"},{"CODE":"BAEEE304","TITLE":"Power Electronics and Drives","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"M. PRABHAKAR"},{"CODE":"BAEEE304","TITLE":"Power Electronics and Drives","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"M. PRABHAKAR"},{"CODE":"BAEEE305","TITLE":"Electric Power Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MITHU\\r\\nSARKAR"},{"CODE":"BAEEE305","TITLE":"Electric Power Systems","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"MITHU\\r\\nSARKAR"},{"CODE":"BAEEE305","TITLE":"Electric Power Systems","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"MITHU\\r\\nSARKAR"},{"CODE":"BAEEE306","TITLE":"Artificial Intelligence and Machine Learning for Electrical\\r\\nApplications","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SITHARTHAN R"},{"CODE":"BAEEE306","TITLE":"Artificial Intelligence and\\r\\nMachine Learning for Electrical Applications","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SENTHIL KUMAR R"},{"CODE":"BAEEE306","TITLE":"Artificial Intelligence and\\r\\nMachine Learning for Electrical Applications","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KRISHNA KUMBA"},{"CODE":"BAEEE306","TITLE":"Artificial Intelligence and Machine Learning for Electrical\\r\\nApplications","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ARNAB PAL"},{"CODE":"BAEEE306","TITLE":"Artificial Intelligence and\\r\\nMachine Learning for Electrical Applications","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SITHARTHAN R"},{"CODE":"BAEEE306","TITLE":"Artificial Intelligence and Machine Learning for Electrical\\r\\nApplications","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"SENTHIL KUMAR R"},{"CODE":"BAEEE306","TITLE":"Artificial Intelligence and Machine Learning for Electrical\\r\\nApplications","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48","FACULTY":"KRISHNA KUMBA"},{"CODE":"BAEEE306","TITLE":"Artificial Intelligence and Machine Learning for Electrical\\r\\nApplications","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"ARNAB PAL"},{"CODE":"BECS201L","TITLE":"Semiconductor Devices and Circuits","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ANANTHA KRISHNAN V"},{"CODE":"BECS201P","TITLE":"Semiconductor Devices and Circuits Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"ANANTHA KRISHNAN V"},{"CODE":"BECS305E","TITLE":"AI and ML for Electrical Systems","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"SRI REVATHI\\r\\nB"},{"CODE":"BECS305E","TITLE":"AI and ML for Electrical Systems","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SRI REVATHI\\r\\nB"},{"CODE":"BECS498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BECS498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"BEEE102L","TITLE":"Basic Electrical and Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SWETHA R\\r\\nKUMAR"},{"CODE":"BEEE102P","TITLE":"Basic Electrical and Electronics\\r\\nEngineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SWETHA R\\r\\nKUMAR"},{"CODE":"BEEE205L","TITLE":"Electronic Devices and Circuits","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"D V\\r\\nSUDARSANRE DDY"},{"CODE":"BEEE205P","TITLE":"Electronic Devices and Circuits Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"D V SUDARSANRE\\r\\nDDY"},{"CODE":"BEEE210L","TITLE":"Electrical Machine Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"UMAYAL C"},{"CODE":"BEEE211E","TITLE":"VLSI Design","TYPE":"TH","CREDITS":2,"SLOT":"F2","FACULTY":"BINDU B"},{"CODE":"BEEE211E","TITLE":"VLSI Design","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"BINDU B"},{"CODE":"BEEE213L","TITLE":"Embedded Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"INAYATHULL AAH ABDUL KAREEM"},{"CODE":"BEEE214L","TITLE":"Electrical Machines and Drives","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RUPA\\r\\nMISHRA"},{"CODE":"BEEE214P","TITLE":"Electrical Machines and Drives\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"RUPA\\r\\nMISHRA"},{"CODE":"BEEE215L","TITLE":"DC Machines and Transformers","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"SUBHENDU SEKHAR\\r\\nSAHOO"},{"CODE":"BEEE215P","TITLE":"DC Machines and Transformers Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SUBHENDU SEKHAR\\r\\nSAHOO"},{"CODE":"BEEE306L","TITLE":"Power Systems Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VAITHILINGA\\r\\nM C"},{"CODE":"BEEE306L","TITLE":"Power Systems Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MEERA P S"},{"CODE":"BEEE306L","TITLE":"Power Systems Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ANGALAESW\\r\\nARI S"},{"CODE":"BEEE306L","TITLE":"Power Systems Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"LAVANYA V"},{"CODE":"BEEE306P","TITLE":"Power Systems Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"VAITHILINGA\\r\\nM C"},{"CODE":"BEEE306P","TITLE":"Power Systems Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"MEERA P S"},{"CODE":"BEEE306P","TITLE":"Power Systems Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"ANGALAESW\\r\\nARI S"},{"CODE":"BEEE306P","TITLE":"Power Systems Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"LAVANYA V"},{"CODE":"BEEE307L","TITLE":"Electric Drives","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"BINU BEN\\r\\nJOSE D R"},{"CODE":"BEEE307L","TITLE":"Electric Drives","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SRI RAMALAKSH\\r\\nMI P"},{"CODE":"BEEE307L","TITLE":"Electric Drives","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"NILANJAN\\r\\nTEWARI"},{"CODE":"BEEE307L","TITLE":"Electric Drives","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"JYOTISMITA\\r\\nMISHRA"},{"CODE":"BEEE307P","TITLE":"Power Electronics and Drives Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"BINU BEN\\r\\nJOSE D R"},{"CODE":"BEEE307P","TITLE":"Power Electronics and Drives Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SRI\\r\\nRAMALAKSH MI P"},{"CODE":"BEEE307P","TITLE":"Power Electronics and Drives Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"NILANJAN\\r\\nTEWARI"},{"CODE":"BEEE307P","TITLE":"Power Electronics and Drives Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"JYOTISMITA\\r\\nMISHRA"},{"CODE":"BEEE308L","TITLE":"Communication Systems","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PRITAM\\r\\nBHOWMIK"},{"CODE":"BEEE308L","TITLE":"Communication Systems","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"MITHU\\r\\nSARKAR"},{"CODE":"BEEE308L","TITLE":"Communication Systems","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"KRISHNA\\r\\nKUMBA"},{"CODE":"BEEE308L","TITLE":"Communication Systems","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"NAWIN RA"},{"CODE":"BEEE311L","TITLE":"Design of Electrical Installations","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"PEER\\r\\nFATHIMA A"},{"CODE":"BEEE314L","TITLE":"Hybrid and Electric Vehicles","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SREEDEVI V T"},{"CODE":"BEEE405L","TITLE":"Renewable Energy Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SENTHIL\\r\\nKUMAR N"},{"CODE":"BEEE409L","TITLE":"Robotics and Control","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SWETHA R\\r\\nKUMAR"},{"CODE":"BEEE410L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JAMUNA K"},{"CODE":"BEEE411L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SRI REVATHI\\r\\nB"},{"CODE":"BEEE412L","TITLE":"Sensors and Actuators","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"RANJITH R"},{"CODE":"BEEE412P","TITLE":"Sensors and Actuators Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"RANJITH R"},{"CODE":"BEEE423E","TITLE":"Industrial IoT","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MORLA LAKSHMI SIVA SAI\\r\\nKUMAR"},{"CODE":"BEEE423E","TITLE":"Industrial IoT","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MORLA LAKSHMI SIVA SAI\\r\\nKUMAR"},{"CODE":"BEEE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BEEE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"BEIE301L","TITLE":"Biomedical Instrumentation","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SUBBULEKSH\\r\\nMI D"},{"CODE":"MAELM504","TITLE":"Electric Motor Drives","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NILANJAN\\r\\nTEWARI"},{"CODE":"MAELM504","TITLE":"Electric Motor Drives","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"NILANJAN\\r\\nTEWARI"},{"CODE":"MAELM601","TITLE":"Artificial Intelligence for Electric\\r\\nMobility","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"HEMAMALINI"},{"CODE":"MAELM601","TITLE":"Artificial Intelligence for Electric\\r\\nMobility","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"HEMAMALINI"},{"CODE":"MAELM603","TITLE":"Electric Energy Storage Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"BALAMURUG\\r\\nAN P"},{"CODE":"MAELM604","TITLE":"Connected and Autonomous\\r\\nVehicles","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"NAWIN RA"},{"CODE":"MAELM607","TITLE":"Automotive Functional Safety","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"LENIN N C"},{"CODE":"MAELM699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MAELM699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"BAECE101","TITLE":"Signals and Systems","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"ASHIS\\r\\nTRIPATHY"},{"CODE":"BAECE101","TITLE":"Signals and Systems","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"SANKAR\\r\\nGANESH"},{"CODE":"BAECE101","TITLE":"Signals and Systems","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"KULDEEP\\r\\nYADAV"},{"CODE":"BAECE101","TITLE":"Signals and Systems","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"KULDEEP\\r\\nYADAV"},{"CODE":"BAECE101","TITLE":"Signals and Systems","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD 1","FACULTY":"AKASH KUMAR\\r\\nPRADHAN"},{"CODE":"BAECE101","TITLE":"Signals and Systems","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD 2","FACULTY":"AKASH KUMAR\\r\\nPRADHAN"},{"CODE":"BAECE101","TITLE":"Signals and Systems","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"RENIKUNTA\\r\\nMALLAIAH"},{"CODE":"BAECE101","TITLE":"Signals and Systems","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"RENIKUNTA\\r\\nMALLAIAH"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUBHASHINI\\r\\nN"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SUBHASHINI\\r\\nN"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"IDAYACHAND\\r\\nRAN G"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"IDAYACHAND\\r\\nRAN G"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RAVI TIWARI"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAVI TIWARI"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUKRITI"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MANMOHAN\\r\\nSHARMA"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SUBHASHINI\\r\\nN"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SUBHASHINI\\r\\nN"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"IDAYACHAND\\r\\nRAN G"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"IDAYACHAND\\r\\nRAN G"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"RAVI TIWARI"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"MANMOHAN\\r\\nSHARMA"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"RAVI TIWARI"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SUKRITI"},{"CODE":"BAECE103","TITLE":"Network Theory","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"SUBHASHINI\\r\\nN"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RUPA\\r\\nMISHRA"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"RUPA\\r\\nMISHRA"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"GANESH M"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"GANESH M"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RANJEET\\r\\nKUMAR"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RANJEET\\r\\nKUMAR"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SOURABH\\r\\nPAUL"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer Architecture","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"JEAN JENIFER NESAM J"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SUMAN\\r\\nSAHA"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SUMAN\\r\\nSAHA"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"RANJEET\\r\\nKUMAR"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"RANJEET\\r\\nKUMAR"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SOURABH\\r\\nPAUL"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer Architecture","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"JEAN JENIFER NESAM J"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SUMAN\\r\\nSAHA"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SUMAN\\r\\nSAHA"},{"CODE":"BAECE202","TITLE":"Engineering Electromagnetics","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"USHA KIRAN KOMMURI"},{"CODE":"BAECE202","TITLE":"Engineering Electromagnetics","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"USHA KIRAN KOMMURI"},{"CODE":"BAECE202","TITLE":"Engineering Electromagnetics","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"NIRAJ\\r\\nKUMAR"},{"CODE":"BAECE202","TITLE":"Engineering Electromagnetics","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"NIRAJ\\r\\nKUMAR"},{"CODE":"BAECE202","TITLE":"Engineering Electromagnetics","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ANITH\\r\\nNELLERI"},{"CODE":"BAECE202","TITLE":"Engineering Electromagnetics","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"ANITH\\r\\nNELLERI"},{"CODE":"BAECE202","TITLE":"Engineering Electromagnetics","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"THIRIPURASU\\r\\nNDARI D"},{"CODE":"BAECE202","TITLE":"Engineering Electromagnetics","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"RICHARDS JOE STANISLAUS"},{"CODE":"BAECE202","TITLE":"Engineering Electromagnetics","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"JITENDRA\\r\\nTAHALYANI"},{"CODE":"BAECE202","TITLE":"Engineering Electromagnetics","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"JITENDRA\\r\\nTAHALYANI"},{"CODE":"BAECE204","TITLE":"Microcontrollers and Embedded C Programming","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JOHN SAHAYA RANI\\r\\nALEX"},{"CODE":"BAECE204","TITLE":"Microcontrollers and Embedded\\r\\nC Programming","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"VIGNESWAR\\r\\nAN T"},{"CODE":"BAECE204","TITLE":"Microcontrollers and Embedded\\r\\nC Programming","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MUTHULAKS\\r\\nHMI S"},{"CODE":"BAECE204","TITLE":"Microcontrollers and Embedded\\r\\nC Programming","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MUTHULAKS\\r\\nHMI S"},{"CODE":"BAECE204","TITLE":"Microcontrollers and Embedded\\r\\nC Programming","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"BALAKRISHN\\r\\nAN R"},{"CODE":"BAECE204","TITLE":"Microcontrollers and Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"JOHN\\r\\nSAHAYA RANI ALEX"},{"CODE":"BAECE204","TITLE":"Microcontrollers and Embedded\\r\\nC Programming","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"VIGNESWAR\\r\\nAN T"},{"CODE":"BAECE204","TITLE":"Microcontrollers and Embedded\\r\\nC Programming","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"MUTHULAKS\\r\\nHMI S"},{"CODE":"BAECE204","TITLE":"Microcontrollers and Embedded\\r\\nC Programming","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"BALAKRISHN\\r\\nAN R"},{"CODE":"BAECE204","TITLE":"Microcontrollers and Embedded\\r\\nC Programming","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MUTHULAKS\\r\\nHMI S"},{"CODE":"BAECE206","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAMESH R"},{"CODE":"BAECE206","TITLE":"Digital Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"RAMESH R"},{"CODE":"BAECE207","TITLE":"Analog and Digital Communication Systems","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAVI PRAKASH\\r\\nDWIVEDI"},{"CODE":"BAECE207","TITLE":"Analog and Digital\\r\\nCommunication Systems","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SRIVATSAN K"},{"CODE":"BAECE207","TITLE":"Analog and Digital\\r\\nCommunication Systems","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SRIVATSAN K"},{"CODE":"BAECE207","TITLE":"Analog and Digital\\r\\nCommunication Systems","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"P NIRMALA"},{"CODE":"BAECE207","TITLE":"Analog and Digital\\r\\nCommunication Systems","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"P NIRMALA"},{"CODE":"BAECE207","TITLE":"Analog and Digital Communication Systems","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"PRANABA KUMAR\\r\\nMISHRO"},{"CODE":"BAECE207","TITLE":"Analog and Digital Communication Systems","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"PRANABA KUMAR\\r\\nMISHRO"},{"CODE":"BAECE207","TITLE":"Analog and Digital Communication Systems","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"RAVI PRAKASH\\r\\nDWIVEDI"},{"CODE":"BAECE207","TITLE":"Analog and Digital\\r\\nCommunication Systems","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SRIVATSAN K"},{"CODE":"BAECE207","TITLE":"Analog and Digital\\r\\nCommunication Systems","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SRIVATSAN K"},{"CODE":"BAECE207","TITLE":"Analog and Digital\\r\\nCommunication Systems","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"P NIRMALA"},{"CODE":"BAECE207","TITLE":"Analog and Digital\\r\\nCommunication Systems","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"P NIRMALA"},{"CODE":"BAECE207","TITLE":"Analog and Digital Communication Systems","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PRANABA\\r\\nKUMAR MISHRO"},{"CODE":"BAECE207","TITLE":"Analog and Digital Communication Systems","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"PRANABA KUMAR\\r\\nMISHRO"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PRIYANKA\\r\\nDAS"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"UPENDER P"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PRIYANKA\\r\\nDAS"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"AMIT KUMAR"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PRASAD JONES CHRISTYDASS\\r\\nS"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PRASAD JONES CHRISTYDASS\\r\\nS"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SAURABH KUMAR SRIVASTAVA"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"UPENDER P"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"PRIYANKA\\r\\nDAS"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"PRIYANKA\\r\\nDAS"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave\\r\\nEngineering","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"AMIT KUMAR"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"PRASAD JONES CHRISTYDASS\\r\\nS"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"PRASAD JONES CHRISTYDASS\\r\\nS"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SAURABH\\r\\nKUMAR SRIVASTAVA"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"AUGUSTA\\r\\nSOPHY BEULET P"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MANIKANDA\\r\\nN P"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"MANIKANDA\\r\\nN P"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PAPANASAM\\r\\nE"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"B PRASHANTH\\r\\nKUMAR"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"B\\r\\nPRASHANTH KUMAR"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"G LAKSHMI\\r\\nPRIYA"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RAJU PATEL"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RAJU PATEL"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SARAVANA\\r\\nKUMAR R"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SARAVANA\\r\\nKUMAR R"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ANISHA NATARAJAN"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"AUGUSTA\\r\\nSOPHY BEULET P"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MANIKANDA\\r\\nN P"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"MANIKANDA\\r\\nN P"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"RAJU PATEL"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"B PRASHANTH\\r\\nKUMAR"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"B\\r\\nPRASHANTH KUMAR"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"RAJU PATEL"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SARAVANA\\r\\nKUMAR R"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SARAVANA\\r\\nKUMAR R"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"ANISHA NATARAJAN"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"G LAKSHMI\\r\\nPRIYA"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"PAPANASAM\\r\\nE"},{"CODE":"BAECE309","TITLE":"Speech Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MOHANAPRA\\r\\nSAD K"},{"CODE":"BAECE309","TITLE":"Speech Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"S SHOBA"},{"CODE":"BAECE309","TITLE":"Speech Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SUKRITI"},{"CODE":"BAECE309","TITLE":"Speech Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MOHANAPRA\\r\\nSAD K"},{"CODE":"BAECE309","TITLE":"Speech Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"S SHOBA"},{"CODE":"BAECE309","TITLE":"Speech Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SUKRITI"},{"CODE":"BAECE310","TITLE":"Image and Vision Techniques","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ANNIS\\r\\nFATHIMA A"},{"CODE":"BAECE310","TITLE":"Image and Vision Techniques","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ANNIS\\r\\nFATHIMA A"},{"CODE":"BAECE310","TITLE":"Image and Vision Techniques","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"DHEEREN KU MAHAPATRA"},{"CODE":"BAECE310","TITLE":"Image and Vision Techniques","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DHEEREN KU MAHAPATRA"},{"CODE":"BAECE310","TITLE":"Image and Vision Techniques","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"ANNIS\\r\\nFATHIMA A"},{"CODE":"BAECE310","TITLE":"Image and Vision Techniques","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"ANNIS\\r\\nFATHIMA A"},{"CODE":"BAECE310","TITLE":"Image and Vision Techniques","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"DHEEREN KU MAHAPATRA"},{"CODE":"BAECE310","TITLE":"Image and Vision Techniques","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"DHEEREN KU MAHAPATRA"},{"CODE":"BAEVD101","TITLE":"Electronic Devices","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"TANMOY\\r\\nMAJUMDER"},{"CODE":"BAEVD101","TITLE":"Electronic Devices","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MD\\r\\nSADULLAH"},{"CODE":"BAEVD101","TITLE":"Electronic Devices","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"TANMOY\\r\\nMAJUMDER"},{"CODE":"BAEVD101","TITLE":"Electronic Devices","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"MD\\r\\nSADULLAH"},{"CODE":"BAEVD102","TITLE":"Digital System Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SAURAV\\r\\nGUPTA"},{"CODE":"BAEVD102","TITLE":"Digital System Design","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"UPENDER P"},{"CODE":"BAEVD102","TITLE":"Digital System Design","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SAURAV\\r\\nGUPTA"},{"CODE":"BAEVD102","TITLE":"Digital System Design","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"UPENDER P"},{"CODE":"BAEVD202","TITLE":"Computer Architecture","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ARIVARASI A"},{"CODE":"BAEVD202","TITLE":"Computer Architecture","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"PRASANNA\\r\\nBHARATHI S"},{"CODE":"BAEVD204","TITLE":"Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"CHANDRASEK\\r\\nARAN N"},{"CODE":"BAEVD204","TITLE":"Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"CHANDRASEK\\r\\nARAN N"},{"CODE":"BAEVD204","TITLE":"Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SUCHETHA M"},{"CODE":"BAEVD204","TITLE":"Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ASHIS\\r\\nTRIPATHY"},{"CODE":"BAEVD204","TITLE":"Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PRAVEEN\\r\\nJARAUT"},{"CODE":"BAEVD204","TITLE":"Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"PRAVEEN\\r\\nJARAUT"},{"CODE":"BAEVD204","TITLE":"Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"CHANDRASEK\\r\\nARAN N"},{"CODE":"BAEVD204","TITLE":"Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"CHANDRASEK\\r\\nARAN N"},{"CODE":"BAEVD204","TITLE":"Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SUCHETHA M"},{"CODE":"BAEVD204","TITLE":"Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"ASHIS\\r\\nTRIPATHY"},{"CODE":"BAEVD204","TITLE":"Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"PRAVEEN\\r\\nJARAUT"},{"CODE":"BAEVD204","TITLE":"Signal Processing","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"PRAVEEN\\r\\nJARAUT"},{"CODE":"BAEVD205","TITLE":"VLSI Circuit Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SASIPRIYA P"},{"CODE":"BAEVD205","TITLE":"VLSI Circuit Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAVI SANKAR\\r\\nA"},{"CODE":"BAEVD205","TITLE":"VLSI Circuit Design","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SASIPRIYA P"},{"CODE":"BAEVD205","TITLE":"VLSI Circuit Design","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"RAVI SANKAR\\r\\nA"},{"CODE":"BAEVD305","TITLE":"CAD for IC Design","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"REENA\\r\\nMONICA P"},{"CODE":"BAEVD305","TITLE":"CAD for IC Design","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"UMADEVI S"},{"CODE":"BAEVD403","TITLE":"Device Modeling and\\r\\nCharacterization Techniques","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"LAKSHMI B"},{"CODE":"BAEVD403","TITLE":"Device Modeling and\\r\\nCharacterization Techniques","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BINDU B"},{"CODE":"BAEVD403","TITLE":"Device Modeling and\\r\\nCharacterization Techniques","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"LAKSHMI B"},{"CODE":"BAEVD403","TITLE":"Device Modeling and\\r\\nCharacterization Techniques","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"BINDU B"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RANJEET\\r\\nKUMAR"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"RANJEET\\r\\nKUMAR"},{"CODE":"BECE201L","TITLE":"Electronic Materials and devices","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"CHANDRASEK\\r\\nARAN N"},{"CODE":"BECE205L","TITLE":"Engineering Electromagnetics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"THIRIPURASU\\r\\nNDARI D"},{"CODE":"BECE206L","TITLE":"Analog Circuits","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RAJU PATEL"},{"CODE":"BECE206P","TITLE":"Analog Circuits Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAJU PATEL"},{"CODE":"BECE303L","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SHAIK AHMADSAID\\r\\nULU"},{"CODE":"BECE303P","TITLE":"VLSI System Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SHAIK\\r\\nAHMADSAID ULU"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and\\r\\nMachine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"VYDEKI D"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and\\r\\nMachine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VIJAYARAJAN\\r\\nR"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and\\r\\nMachine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SUDHAKARA\\r\\nN G"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and\\r\\nMachine Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ABHIJIT\\r\\nMISHRA"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and\\r\\nMachine Learning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"PRAVEEN\\r\\nJARAUT"},{"CODE":"BECE310L","TITLE":"Satellite Communications","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RALPH SAMUEL THANGARAJ"},{"CODE":"BECE310L","TITLE":"Satellite Communications","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RALPH SAMUEL THANGARAJ"},{"CODE":"BECE310L","TITLE":"Satellite Communications","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUHASINI S"},{"CODE":"BECE310L","TITLE":"Satellite Communications","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"AMIT KUMAR"},{"CODE":"BECE311L","TITLE":"Radar Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SAURABH KUMAR SRIVASTAVA"},{"CODE":"BECE311L","TITLE":"Radar Systems","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SAURABH KUMAR SRIVASTAVA"},{"CODE":"BECE311L","TITLE":"Radar Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"DESU\\r\\nMOULIKA"},{"CODE":"BECE311L","TITLE":"Radar Systems","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"DESU\\r\\nMOULIKA"},{"CODE":"BECE312L","TITLE":"Robotics and Automation","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VELMATHI G"},{"CODE":"BECE312L","TITLE":"Robotics and Automation","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"VELMATHI G"},{"CODE":"BECE312L","TITLE":"Robotics and Automation","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MANMOHAN\\r\\nSHARMA"},{"CODE":"BECE312L","TITLE":"Robotics and Automation","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MANMOHAN\\r\\nSHARMA"},{"CODE":"BECE312L","TITLE":"Robotics and Automation","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MOHAMMED\\r\\nAARIF K O"},{"CODE":"BECE313L","TITLE":"Information Theory and Coding","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RALPH\\r\\nSAMUEL THANGARAJ"},{"CODE":"BECE313L","TITLE":"Information Theory and Coding","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"KULDEEP\\r\\nYADAV"},{"CODE":"BECE317L","TITLE":"Wireless and Mobile\\r\\nCommunications","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RAMESH R"},{"CODE":"BECE317L","TITLE":"Wireless and Mobile\\r\\nCommunications","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RAMESH R"},{"CODE":"BECE317L","TITLE":"Wireless and Mobile\\r\\nCommunications","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VETRIVELAN\\r\\nP"},{"CODE":"BECE317L","TITLE":"Wireless and Mobile\\r\\nCommunications","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"USHA RANI S"},{"CODE":"BECE317L","TITLE":"Wireless and Mobile\\r\\nCommunications","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MARKKANDA\\r\\nN S"},{"CODE":"BECE317L","TITLE":"Wireless and Mobile\\r\\nCommunications","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"MARKKANDA\\r\\nN S"},{"CODE":"BECE317L","TITLE":"Wireless and Mobile\\r\\nCommunications","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ILAVARASAN\\r\\nT"},{"CODE":"BECE317L","TITLE":"Wireless and Mobile\\r\\nCommunications","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ILAVARASAN\\r\\nT"},{"CODE":"BECE317P","TITLE":"Wireless and Mobile\\r\\nCommunications Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"RAMESH R"},{"CODE":"BECE317P","TITLE":"Wireless and Mobile\\r\\nCommunications Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"RAMESH R"},{"CODE":"BECE317P","TITLE":"Wireless and Mobile\\r\\nCommunications Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"VETRIVELAN\\r\\nP"},{"CODE":"BECE317P","TITLE":"Wireless and Mobile\\r\\nCommunications Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"MARKKANDA\\r\\nN S"},{"CODE":"BECE317P","TITLE":"Wireless and Mobile\\r\\nCommunications Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"USHA RANI S"},{"CODE":"BECE317P","TITLE":"Wireless and Mobile\\r\\nCommunications Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"ILAVARASAN\\r\\nT"},{"CODE":"BECE317P","TITLE":"Wireless and Mobile\\r\\nCommunications Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"ILAVARASAN\\r\\nT"},{"CODE":"BECE317P","TITLE":"Wireless and Mobile\\r\\nCommunications Lab","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48","FACULTY":"MARKKANDA\\r\\nN S"},{"CODE":"BECE318L","TITLE":"Optical Fiber Communications","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BRINTHA\\r\\nTHERESE  A"},{"CODE":"BECE318L","TITLE":"Optical Fiber Communications","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"BRINTHA\\r\\nTHERESE  A"},{"CODE":"BECE318L","TITLE":"Optical Fiber Communications","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SANGEETHA\\r\\nR G"},{"CODE":"BECE318L","TITLE":"Optical Fiber Communications","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SANGEETHA\\r\\nR G"},{"CODE":"BECE318L","TITLE":"Optical Fiber Communications","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SIVASUBRAM\\r\\nANIAN A"},{"CODE":"BECE318L","TITLE":"Optical Fiber Communications","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SIVASUBRAM\\r\\nANIAN A"},{"CODE":"BECE318L","TITLE":"Optical Fiber Communications","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"S SELVENDRAN"},{"CODE":"BECE318L","TITLE":"Optical Fiber Communications","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"V.R BALAJI"},{"CODE":"BECE318P","TITLE":"Optical Fiber Communications\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"BRINTHA\\r\\nTHERESE  A"},{"CODE":"BECE318P","TITLE":"Optical Fiber Communications\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SANGEETHA\\r\\nR G"},{"CODE":"BECE318P","TITLE":"Optical Fiber Communications\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SANGEETHA\\r\\nR G"},{"CODE":"BECE318P","TITLE":"Optical Fiber Communications\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SIVASUBRAM\\r\\nANIAN A"},{"CODE":"BECE318P","TITLE":"Optical Fiber Communications\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SIVASUBRAM\\r\\nANIAN A"},{"CODE":"BECE318P","TITLE":"Optical Fiber Communications Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"S SELVENDRAN"},{"CODE":"BECE318P","TITLE":"Optical Fiber Communications\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"V.R BALAJI"},{"CODE":"BECE318P","TITLE":"Optical Fiber Communications\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"BRINTHA\\r\\nTHERESE  A"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"SUMATHI V"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SUMATHI V"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"A2","FACULTY":"SRIMATHI  R"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SRIMATHI  R"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"A2","FACULTY":"VIJAYAPRIYA\\r\\nR"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"VIJAYAPRIYA\\r\\nR"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"INAYATHULL AAH ABDUL KAREEM"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"INAYATHULL AAH ABDUL\\r\\nKAREEM"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"MORLA LAKSHMI SIVA SAI\\r\\nKUMAR"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"MORLA LAKSHMI SIVA SAI\\r\\nKUMAR"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"VIGNESWAR\\r\\nAN T"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"VIGNESWAR\\r\\nAN T"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"BERLIN\\r\\nHENCY V"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"BERLIN\\r\\nHENCY V"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"VYDEKI D"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"VYDEKI D"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"CHANDRAMA ULESHWAR\\r\\nROY"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"CHANDRAMA\\r\\nULESHWAR ROY"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"KIRAN\\r\\nKUMAR M"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"KIRAN\\r\\nKUMAR M"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"MANIGANDA\\r\\nN M"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"AKASH KUMAR\\r\\nPRADHAN"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"JITENDRA\\r\\nTAHALYANI"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"RENIKUNTA\\r\\nMALLAIAH"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"VIGNESWAR\\r\\nAN T"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"VIGNESWAR\\r\\nAN T"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"BERLIN\\r\\nHENCY V"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"BERLIN\\r\\nHENCY V"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"VYDEKI D"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"VYDEKI D"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"CHANDRAMA ULESHWAR\\r\\nROY"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"CHANDRAMA\\r\\nULESHWAR ROY"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"MANIGANDA\\r\\nN M"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"KIRAN\\r\\nKUMAR M"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"KIRAN\\r\\nKUMAR M"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"AKASH\\r\\nKUMAR PRADHAN"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"JITENDRA\\r\\nTAHALYANI"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"RENIKUNTA\\r\\nMALLAIAH"},{"CODE":"BECE401L","TITLE":"Computer Communications and\\r\\nNetworks","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KALAIVANAN\\r\\nK"},{"CODE":"BECE401L","TITLE":"Computer Communications and\\r\\nNetworks","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"KALAIVANAN\\r\\nK"},{"CODE":"BECE401L","TITLE":"Computer Communications and Networks","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"S SIVAKUMAR"},{"CODE":"BECE401L","TITLE":"Computer Communications and Networks","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"S SIVAKUMAR"},{"CODE":"BECE401L","TITLE":"Computer Communications and\\r\\nNetworks","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SARANYA\\r\\nNAIR M"},{"CODE":"BECE401L","TITLE":"Computer Communications and\\r\\nNetworks","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SARANYA\\r\\nNAIR M"},{"CODE":"BECE401L","TITLE":"Computer Communications and\\r\\nNetworks","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JAYA\\r\\nVIGNESH T"},{"CODE":"BECE401L","TITLE":"Computer Communications and\\r\\nNetworks","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"JAYA\\r\\nVIGNESH T"},{"CODE":"BECE401P","TITLE":"Computer Communications and\\r\\nNetworks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"KALAIVANAN\\r\\nK"},{"CODE":"BECE401P","TITLE":"Computer Communications and\\r\\nNetworks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"KALAIVANAN\\r\\nK"},{"CODE":"BECE401P","TITLE":"Computer Communications and Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"S SIVAKUMAR"},{"CODE":"BECE401P","TITLE":"Computer Communications and Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"S SIVAKUMAR"},{"CODE":"BECE401P","TITLE":"Computer Communications and\\r\\nNetworks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SARANYA\\r\\nNAIR M"},{"CODE":"BECE401P","TITLE":"Computer Communications and\\r\\nNetworks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SARANYA\\r\\nNAIR M"},{"CODE":"BECE401P","TITLE":"Computer Communications and\\r\\nNetworks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"JAYA\\r\\nVIGNESH T"},{"CODE":"BECE401P","TITLE":"Computer Communications and\\r\\nNetworks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"JAYA\\r\\nVIGNESH T"},{"CODE":"BECE402L","TITLE":"Communication for Cyber\\r\\nPhysical Systems","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"HEMALATHA\\r\\nK"},{"CODE":"BECE402L","TITLE":"Communication for Cyber\\r\\nPhysical Systems","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"SUSEELA S"},{"CODE":"BECE402P","TITLE":"Communication for Cyber\\r\\nPhysical Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"HEMALATHA\\r\\nK"},{"CODE":"BECE402P","TITLE":"Communication for Cyber\\r\\nPhysical Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SUSEELA S"},{"CODE":"BECE407E","TITLE":"ASIC Design","TYPE":"TH","CREDITS":2,"SLOT":"D1","FACULTY":"PRITAM\\r\\nBHATTACHAR JEE"},{"CODE":"BECE407E","TITLE":"ASIC Design","TYPE":"TH","CREDITS":2,"SLOT":"D2","FACULTY":"PRITAM BHATTACHAR\\r\\nJEE"},{"CODE":"BECE407E","TITLE":"ASIC Design","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"PRITAM BHATTACHAR\\r\\nJEE"},{"CODE":"BECE407E","TITLE":"ASIC Design","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"PRITAM BHATTACHAR\\r\\nJEE"},{"CODE":"BECE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BECE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"BECM301L","TITLE":"Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DEEPA T"},{"CODE":"BECM301P","TITLE":"Signal Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"DEEPA T"},{"CODE":"BECM498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BECM498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"BEVD304L","TITLE":"CMOS Analog IC Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MD\\r\\nSADULLAH"},{"CODE":"BEVD304L","TITLE":"CMOS Analog IC Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"ANISHA NATARAJAN"},{"CODE":"BEVD304P","TITLE":"CMOS Analog IC Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"MD\\r\\nSADULLAH"},{"CODE":"BEVD304P","TITLE":"CMOS Analog IC Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"ANISHA NATARAJAN"},{"CODE":"BEVD305L","TITLE":"VLSI Technology","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUNIL\\r\\nKUMAR PRADHAN"},{"CODE":"BEVD305L","TITLE":"VLSI Technology","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SRIDHAR C"},{"CODE":"BEVD305P","TITLE":"VLSI Technology Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SUNIL KUMAR\\r\\nPRADHAN"},{"CODE":"BEVD305P","TITLE":"VLSI Technology Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SRIDHAR C"},{"CODE":"BEVD308L","TITLE":"Low Power VLSI Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RAHUL NARASIMHA\\r\\nN A"},{"CODE":"BEVD308L","TITLE":"Low Power VLSI Design","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RAHUL\\r\\nNARASIMHA N A"},{"CODE":"BEVD309L","TITLE":"Testing of VLSI Circuits","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PAPANASAM\\r\\nE"},{"CODE":"BEVD310L","TITLE":"Embedded System Design with\\r\\nFPGA","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"HARIHARAN I"},{"CODE":"BEVD310L","TITLE":"Embedded System Design with FPGA","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"JEAN JENIFER NESAM J"},{"CODE":"BEVD408L","TITLE":"Verification Methodologies","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SAKTHIVEL S\\r\\nM"},{"CODE":"BEVD498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BEVD498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"MAEDS504","TITLE":"In-Vehicle Networking","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"JAYA\\r\\nVIGNESH T"},{"CODE":"MAEDS505","TITLE":"Real Time Operating System","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"DHANUSH R"},{"CODE":"MAEDS505","TITLE":"Real Time Operating System","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"DHANUSH R"},{"CODE":"MAEDS606","TITLE":"Intelligent IoT System Design and\\r\\nArchitecture","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"VELMATHI G"},{"CODE":"MAEDS611","TITLE":"5G and Next Generation Wireless Systems for Embedded\\r\\nApplications","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"DESU MOULIKA"},{"CODE":"MAEDS613","TITLE":"Wireless and Mobile\\r\\nCommunication for Embedded Applications","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"BERLIN HENCY V"},{"CODE":"MAEDS699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MAEDS699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"MAVLD505","TITLE":"ASIC Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PRATHIBA A"},{"CODE":"MAVLD505","TITLE":"ASIC Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PRITAM\\r\\nBHATTACHAR JEE"},{"CODE":"MAVLD505","TITLE":"ASIC Design","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"PRATHIBA A"},{"CODE":"MAVLD505","TITLE":"ASIC Design","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"PRITAM BHATTACHAR\\r\\nJEE"},{"CODE":"MAVLD506","TITLE":"VLSI Testing and Testability","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RAVI V"},{"CODE":"MAVLD506","TITLE":"VLSI Testing and Testability","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SRIDHAR C"},{"CODE":"MAVLD506","TITLE":"VLSI Testing and Testability","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"RAVI V"},{"CODE":"MAVLD506","TITLE":"VLSI Testing and Testability","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48","FACULTY":"SRIDHAR C"},{"CODE":"MAVLD602","TITLE":"Low Power IC Design","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RAHUL\\r\\nNARASIMHA N A"},{"CODE":"MAVLD602","TITLE":"Low Power IC Design","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"CHANDRAMA ULESHWAR\\r\\nROY"},{"CODE":"MAVLD603","TITLE":"VLSI Verification Methodologies","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SAKTHIVEL S\\r\\nM"},{"CODE":"MAVLD603","TITLE":"VLSI Verification Methodologies","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"BISWAJIT\\r\\nJENA"},{"CODE":"MAVLD603","TITLE":"VLSI Verification Methodologies","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SAKTHIVEL S\\r\\nM"},{"CODE":"MAVLD603","TITLE":"VLSI Verification Methodologies","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"BISWAJIT\\r\\nJENA"},{"CODE":"MAVLD605","TITLE":"System-on-Chip Design","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"ANITA\\r\\nANGELINE"},{"CODE":"MAVLD605","TITLE":"System-on-Chip Design","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"ANANIAH\\r\\nDURAI S"},{"CODE":"MAVLD699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MAVLD699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"MEDS699J","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MEDS699J","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"BABMH101","TITLE":"Electronic Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"A BHARATHI SANKAR"},{"CODE":"BABMH101","TITLE":"Electronic Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SOUMYA RANJAN MAHAPATRO"},{"CODE":"BABMH101","TITLE":"Electronic Systems","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SHAIK AHMADSAID\\r\\nULU"},{"CODE":"BABMH101","TITLE":"Electronic Systems","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"A BHARATHI SANKAR"},{"CODE":"BABMH101","TITLE":"Electronic Systems","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SOUMYA RANJAN MAHAPATRO"},{"CODE":"BABMH101","TITLE":"Electronic Systems","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SHAIK AHMADSAID\\r\\nULU"},{"CODE":"BABMH201","TITLE":"Electric Drives and Fluid Power","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SANTHOSH N"},{"CODE":"BABMH201","TITLE":"Electric Drives and Fluid Power","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MOGANA\\r\\nPRIYA C"},{"CODE":"BABMH201","TITLE":"Electric Drives and Fluid Power","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SANTHOSH N"},{"CODE":"BABMH201","TITLE":"Electric Drives and Fluid Power","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SANTHOSH N"},{"CODE":"BABMH201","TITLE":"Electric Drives and Fluid Power","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SANTHOSH N"},{"CODE":"BABMH201","TITLE":"Electric Drives and Fluid Power","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"MOGANA\\r\\nPRIYA C"},{"CODE":"BABMH201","TITLE":"Electric Drives and Fluid Power","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"MOGANA\\r\\nPRIYA C"},{"CODE":"BABMH201","TITLE":"Electric Drives and Fluid Power","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SANTHOSH N"},{"CODE":"BABMH201","TITLE":"Electric Drives and Fluid Power","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SANTHOSH N"},{"CODE":"BABMH204","TITLE":"Machine Vision","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MATHIYAZHA\\r\\nGAN R"},{"CODE":"BABMH204","TITLE":"Machine Vision","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BONDA ATCHUTA GANESH\\r\\nYUVA RAJU"},{"CODE":"BABMH204","TITLE":"Machine Vision","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MATHIYAZHA\\r\\nGAN R"},{"CODE":"BABMH204","TITLE":"Machine Vision","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"MATHIYAZHA\\r\\nGAN R"},{"CODE":"BABMH204","TITLE":"Machine Vision","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"MATHIYAZHA\\r\\nGAN R"},{"CODE":"BABMH204","TITLE":"Machine Vision","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"BONDA ATCHUTA GANESH\\r\\nYUVA RAJU"},{"CODE":"BABMH204","TITLE":"Machine Vision","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"BONDA ATCHUTA GANESH\\r\\nYUVA RAJU"},{"CODE":"BABMH204","TITLE":"Machine Vision","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"MATHIYAZHA\\r\\nGAN R"},{"CODE":"BABMH204","TITLE":"Machine Vision","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"MATHIYAZHA\\r\\nGAN R"},{"CODE":"BABMH301","TITLE":"Systems and Control","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SARAVANAK\\r\\nUMAR D"},{"CODE":"BABMH301","TITLE":"Systems and Control","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ELANGO M"},{"CODE":"BABMH301","TITLE":"Systems and Control","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"ABHISHEK\\r\\nRUDRA PAL"},{"CODE":"BABMH301","TITLE":"Systems and Control","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SARAVANAK\\r\\nUMAR D"},{"CODE":"BABMH301","TITLE":"Systems and Control","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ELANGO M"},{"CODE":"BABMH301","TITLE":"Systems and Control","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"ABHISHEK\\r\\nRUDRA PAL"},{"CODE":"BAHUM102","TITLE":"Ethics in Engineering","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SENTHIL\\r\\nKUMAR M"},{"CODE":"BAHUM102","TITLE":"Ethics in Engineering","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"SENTHIL\\r\\nKUMAR M"},{"CODE":"BAHUM102","TITLE":"Ethics in Engineering","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"DEVAPRAKAS\\r\\nAM D"},{"CODE":"BAHUM102","TITLE":"Ethics in Engineering","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"DEVAPRAKAS\\r\\nAM D"},{"CODE":"BAHUM102","TITLE":"Ethics in Engineering","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"ANNAMALAI\\r\\nK"},{"CODE":"BAHUM102","TITLE":"Ethics in Engineering","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"LENIN BABU\\r\\nM C"},{"CODE":"BAHUM102","TITLE":"Ethics in Engineering","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"JEYANTHI S"},{"CODE":"BAHUM102","TITLE":"Ethics in Engineering","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"AROCKIA SELVAKUMA\\r\\nR"},{"CODE":"BAMEE101","TITLE":"Manufacturing Processes","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ANSHUMAN\\r\\nDAS"},{"CODE":"BAMEE101","TITLE":"Manufacturing Processes","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NARAYANAN\\r\\nR"},{"CODE":"BAMEE101","TITLE":"Manufacturing Processes","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MANOJ\\r\\nKUMAR R"},{"CODE":"BAMEE101","TITLE":"Manufacturing Processes","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"MANOJ\\r\\nKUMAR R"},{"CODE":"BAMEE101","TITLE":"Manufacturing Processes","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"MANOJ\\r\\nKUMAR R"},{"CODE":"BAMEE101","TITLE":"Manufacturing Processes","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"NARAYANAN\\r\\nR"},{"CODE":"BAMEE101","TITLE":"Manufacturing Processes","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"NARAYANAN\\r\\nR"},{"CODE":"BAMEE101","TITLE":"Manufacturing Processes","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"ANSHUMAN\\r\\nDAS"},{"CODE":"BAMEE101","TITLE":"Manufacturing Processes","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"ANSHUMAN\\r\\nDAS"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"CHRISTO\\r\\nMICHAEL T"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ANAND KUMAR\\r\\nAGRAWAL"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"BHUPESH\\r\\nSINGH KATIYAR"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"LAKSHMI\\r\\nPATHI JAKKAMPUTI"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"TAPAN KUMAR\\r\\nMAHANTA"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JEYANTHI S"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"CHRISTO\\r\\nMICHAEL T"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"CHRISTO\\r\\nMICHAEL T"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"ANAND KUMAR\\r\\nAGRAWAL"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"ANAND\\r\\nKUMAR AGRAWAL"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"BHUPESH SINGH\\r\\nKATIYAR"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"BHUPESH SINGH\\r\\nKATIYAR"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"TAPAN KUMAR\\r\\nMAHANTA"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"TAPAN KUMAR\\r\\nMAHANTA"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"JEYANTHI S"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"LAKSHMI PATHI JAKKAMPUTI"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"LAKSHMI PATHI JAKKAMPUTI"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"JEYANTHI S"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SAURABH\\r\\nYADAV"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"IMMANUEL\\r\\nSELWYN RAJ A"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MANAVALLA SREEKANTH"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"FEROSKHAN\\r\\nM"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"HARISH R"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SAURABH\\r\\nYADAV"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SAURABH\\r\\nYADAV"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"IMMANUEL\\r\\nSELWYN RAJ A"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"IMMANUEL SELWYN RAJ\\r\\nA"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"MANAVALLA SREEKANTH"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"MANAVALLA SREEKANTH"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"FEROSKHAN\\r\\nM"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"FEROSKHAN\\r\\nM"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"HARISH R"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"HARISH R"},{"CODE":"BAMEE205","TITLE":"Engineering Innovation and Modelling","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"AYUB\\r\\nAHMED JANVEKAR"},{"CODE":"BAMEE205","TITLE":"Engineering Innovation and Modelling","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"AYUB\\r\\nAHMED JANVEKAR"},{"CODE":"BAMEE205","TITLE":"Engineering Innovation and\\r\\nModelling","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"SASIKUMAR\\r\\nM"},{"CODE":"BAMEE205","TITLE":"Engineering Innovation and\\r\\nModelling","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"SASIKUMAR\\r\\nM"},{"CODE":"BAMEE205","TITLE":"Engineering Innovation and\\r\\nModelling","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"MOHAN R"},{"CODE":"BAMEE205","TITLE":"Engineering Innovation and\\r\\nModelling","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"ANNAMALAI\\r\\nK"},{"CODE":"BAMEE205","TITLE":"Engineering Innovation and\\r\\nModelling","TYPE":"LO","CREDITS":2,"SLOT":"L15+L16+L25+\\r\\nL26","FACULTY":"ANNAMALAI\\r\\nK"},{"CODE":"BAMEE205","TITLE":"Engineering Innovation and Modelling","TYPE":"LO","CREDITS":2,"SLOT":"L13+L14+L21+ L22","FACULTY":"AYUB AHMED\\r\\nJANVEKAR"},{"CODE":"BAMEE205","TITLE":"Engineering Innovation and\\r\\nModelling","TYPE":"LO","CREDITS":2,"SLOT":"L11+L12+L33+\\r\\nL34","FACULTY":"SASIKUMAR\\r\\nM"},{"CODE":"BAMEE205","TITLE":"Engineering Innovation and\\r\\nModelling","TYPE":"LO","CREDITS":2,"SLOT":"L3+L4+L21+L2\\r\\n2","FACULTY":"SASIKUMAR\\r\\nM"},{"CODE":"BAMEE205","TITLE":"Engineering Innovation and Modelling","TYPE":"LO","CREDITS":2,"SLOT":"L27+L28+L45+ L46","FACULTY":"AYUB AHMED\\r\\nJANVEKAR"},{"CODE":"BAMEE205","TITLE":"Engineering Innovation and\\r\\nModelling","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L55+L5\\r\\n6","FACULTY":"MOHAN R"},{"CODE":"BAMEE208","TITLE":"Additive Manufacturing: Processes and Design","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAGHUKIRAN NADIMPALLI"},{"CODE":"BAMEE208","TITLE":"Additive Manufacturing:\\r\\nProcesses and Design","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PRADEEP N"},{"CODE":"BAMEE208","TITLE":"Additive Manufacturing:\\r\\nProcesses and Design","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PRADEEP N"},{"CODE":"BAMEE208","TITLE":"Additive Manufacturing:\\r\\nProcesses and Design","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"JAFFERSON J\\r\\nM"},{"CODE":"BAMEE208","TITLE":"Additive Manufacturing:\\r\\nProcesses and Design","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"MANOJ\\r\\nKUMAR R"},{"CODE":"BAMEE208","TITLE":"Additive Manufacturing: Processes and Design","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"RAGHUKIRAN NADIMPALLI"},{"CODE":"BAMEE208","TITLE":"Additive Manufacturing:\\r\\nProcesses and Design","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"PRADEEP N"},{"CODE":"BAMEE208","TITLE":"Additive Manufacturing:\\r\\nProcesses and Design","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"PRADEEP N"},{"CODE":"BAMEE208","TITLE":"Additive Manufacturing:\\r\\nProcesses and Design","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"JAFFERSON J\\r\\nM"},{"CODE":"BAMEE208","TITLE":"Additive Manufacturing:\\r\\nProcesses and Design","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"MANOJ\\r\\nKUMAR R"},{"CODE":"BAMEE303","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BALAJI B"},{"CODE":"BAMEE303","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"N.GOBINATH"},{"CODE":"BAMEE303","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SHENBAGA\\r\\nVELU P"},{"CODE":"BAMEE303","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"N.GOBINATH"},{"CODE":"BAMEE303","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"L PAVAN\\r\\nKALYAN"},{"CODE":"BAMEE303","TITLE":"Control Systems","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"BALAJI B"},{"CODE":"BAMEE303","TITLE":"Control Systems","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"N.GOBINATH"},{"CODE":"BAMEE303","TITLE":"Control Systems","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"SHENBAGA\\r\\nVELU P"},{"CODE":"BAMEE303","TITLE":"Control Systems","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"N.GOBINATH"},{"CODE":"BAMEE303","TITLE":"Control Systems","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"L PAVAN\\r\\nKALYAN"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of\\r\\nMachines","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KRISHANU\\r\\nGANGULY"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of Machines","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SREEKANTH DONDAPATI"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of\\r\\nMachines","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JANARDHAN\\r\\nREDDY  K"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of\\r\\nMachines","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"AWANI\\r\\nBHUSHAN"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of\\r\\nMachines","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"TEJDEEP G"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of Machines","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SREEKANTH DONDAPATI"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of Machines","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SREEKANTH DONDAPATI"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of\\r\\nMachines","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"JANARDHAN\\r\\nREDDY  K"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of\\r\\nMachines","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"JANARDHAN\\r\\nREDDY  K"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of\\r\\nMachines","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"TEJDEEP G"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of\\r\\nMachines","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"TEJDEEP G"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of\\r\\nMachines","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"KRISHANU\\r\\nGANGULY"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of\\r\\nMachines","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"KRISHANU\\r\\nGANGULY"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of\\r\\nMachines","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"AWANI\\r\\nBHUSHAN"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of\\r\\nMachines","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"AWANI\\r\\nBHUSHAN"},{"CODE":"BAMEE316","TITLE":"Climate Change and Sustainable\\r\\nDevelopment","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"JOSEPH\\r\\nDANIEL"},{"CODE":"BAMEE316","TITLE":"Climate Change and Sustainable\\r\\nDevelopment","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"JOSEPH\\r\\nDANIEL"},{"CODE":"BAMEE318","TITLE":"Vehicle Systems Engineering","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"TAMIL\\r\\nSELVAN P"},{"CODE":"BAMEE318","TITLE":"Vehicle Systems Engineering","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SENTHIL\\r\\nKUMAR M"},{"CODE":"BAMEE318","TITLE":"Vehicle Systems Engineering","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"TAMIL\\r\\nSELVAN P"},{"CODE":"BAMEE318","TITLE":"Vehicle Systems Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"TAMIL\\r\\nSELVAN P"},{"CODE":"BAMEE318","TITLE":"Vehicle Systems Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"TAMIL\\r\\nSELVAN P"},{"CODE":"BAMEE318","TITLE":"Vehicle Systems Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SENTHIL\\r\\nKUMAR M"},{"CODE":"BAMEE318","TITLE":"Vehicle Systems Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SENTHIL\\r\\nKUMAR M"},{"CODE":"BAMEE318","TITLE":"Vehicle Systems Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"TAMIL\\r\\nSELVAN P"},{"CODE":"BAMEE318","TITLE":"Vehicle Systems Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"TAMIL\\r\\nSELVAN P"},{"CODE":"BAMEE320","TITLE":"Vehicle Dynamics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"LENIN BABU\\r\\nM C"},{"CODE":"BAMEE320","TITLE":"Vehicle Dynamics","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"LENIN BABU\\r\\nM C"},{"CODE":"BAMEE320","TITLE":"Vehicle Dynamics","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"LENIN BABU\\r\\nM C"},{"CODE":"BAMEE322","TITLE":"Industrial Engineering","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"GAJANAND\\r\\nGUPTA"},{"CODE":"BAMEE322","TITLE":"Industrial Engineering","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"GAJANAND\\r\\nGUPTA"},{"CODE":"BAMEE338","TITLE":"Introduction to Aeronautics","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"VINAYAGAM\\r\\nURTHY G"},{"CODE":"BMEE203L","TITLE":"Engineering Thermodynamics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"PRITAM DAS"},{"CODE":"BMEE205E","TITLE":"Renewable Energy Systems","TYPE":"TH","CREDITS":2,"SLOT":"F2","FACULTY":"PRITAM DAS"},{"CODE":"BMEE205E","TITLE":"Renewable Energy Systems","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"PRITAM DAS"},{"CODE":"BMEE205E","TITLE":"Renewable Energy Systems","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"PRITAM DAS"},{"CODE":"BMEE206P","TITLE":"Machine Drawing Lab","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L11+L1\\r\\n2","FACULTY":"MOHAN R"},{"CODE":"BMEE210L","TITLE":"Mechatronics and Measurement\\r\\nSystems","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"DEIVANATHA\\r\\nN R"},{"CODE":"BMEE210L","TITLE":"Mechatronics and Measurement\\r\\nSystems","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GIRIDHARAN\\r\\nA"},{"CODE":"BMEE210L","TITLE":"Mechatronics and Measurement\\r\\nSystems","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DEIVANATHA\\r\\nN R"},{"CODE":"BMEE210L","TITLE":"Mechatronics and Measurement\\r\\nSystems","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"GIRIDHARAN\\r\\nA"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurement\\r\\nSystems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"DEIVANATHA\\r\\nN R"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurement\\r\\nSystems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"DEIVANATHA\\r\\nN R"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurement\\r\\nSystems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"GIRIDHARAN\\r\\nA"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurement\\r\\nSystems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"GIRIDHARAN\\r\\nA"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurement\\r\\nSystems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"DEIVANATHA\\r\\nN R"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurement\\r\\nSystems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"DEIVANATHA\\r\\nN R"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurement\\r\\nSystems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"GIRIDHARAN\\r\\nA"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurement\\r\\nSystems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"GIRIDHARAN\\r\\nA"},{"CODE":"BMEE212L","TITLE":"Quality Control and\\r\\nImprovement","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PONNUSAMY\\r\\nP"},{"CODE":"BMEE212L","TITLE":"Quality Control and\\r\\nImprovement","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PONNUSAMY\\r\\nP"},{"CODE":"BMEE215L","TITLE":"Engineering Optimization","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"THANGARAJ\\r\\nM"},{"CODE":"BMEE215L","TITLE":"Engineering Optimization","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"MANIMARAN\\r\\nJ"},{"CODE":"BMEE215L","TITLE":"Engineering Optimization","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"MYTHILI G Y"},{"CODE":"BMEE215L","TITLE":"Engineering Optimization","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"JAGANATHA\\r\\nN B"},{"CODE":"BMEE215L","TITLE":"Engineering Optimization","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"PARTHIBAN V"},{"CODE":"BMEE215L","TITLE":"Engineering Optimization","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"THANGARAJ\\r\\nM"},{"CODE":"BMEE215L","TITLE":"Engineering Optimization","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"DAVID\\r\\nMAXIM GURURAJ A"},{"CODE":"BMEE215L","TITLE":"Engineering Optimization","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"SETHUKUMA\\r\\nRASAMY"},{"CODE":"BMEE302L","TITLE":"Metal Casting and Welding","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ANSHUMAN\\r\\nDAS"},{"CODE":"BMEE302P","TITLE":"Metal Casting and Welding Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ANSHUMAN\\r\\nDAS"},{"CODE":"BMEE306L","TITLE":"Computer Aided Design and Finite Element Analysis","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"DAVIDSON JEBASEELAN"},{"CODE":"BMEE306L","TITLE":"Computer Aided Design and Finite Element Analysis","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"TAPAN\\r\\nKUMAR MAHANTA"},{"CODE":"BMEE306L","TITLE":"Computer Aided Design and\\r\\nFinite Element Analysis","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"TEJDEEP G"},{"CODE":"BMEE306L","TITLE":"Computer Aided Design and\\r\\nFinite Element Analysis","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"BHASKARA\\r\\nRAO"},{"CODE":"BMEE306L","TITLE":"Computer Aided Design and\\r\\nFinite Element Analysis","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VENKATACHA\\r\\nLAM G"},{"CODE":"BMEE306P","TITLE":"Computer Aided Design and\\r\\nFinite Element Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"VENKATACHA\\r\\nLAM G"},{"CODE":"BMEE306P","TITLE":"Computer Aided Design and Finite Element Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"DAVIDSON JEBASEELAN"},{"CODE":"BMEE306P","TITLE":"Computer Aided Design and Finite Element Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"TAPAN\\r\\nKUMAR MAHANTA"},{"CODE":"BMEE306P","TITLE":"Computer Aided Design and\\r\\nFinite Element Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"TEJDEEP G"},{"CODE":"BMEE306P","TITLE":"Computer Aided Design and\\r\\nFinite Element Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"BHASKARA\\r\\nRAO"},{"CODE":"BMEE309L","TITLE":"Lean Manufacturing","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"JOHN RAJAN\\r\\nA"},{"CODE":"BMEE310L","TITLE":"Supply Chain Management","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"VIVEKANAND\\r\\nA A S"},{"CODE":"BMEE326L","TITLE":"Power Plant Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KARUNAMUR\\r\\nTHY K"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles\\r\\nTechnology","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"SHYAM\\r\\nKUMAR M B"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles\\r\\nTechnology","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"VENUGOPAL\\r\\nT"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles\\r\\nTechnology","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SHYAM\\r\\nKUMAR M B"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles\\r\\nTechnology","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SHYAM\\r\\nKUMAR M B"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles\\r\\nTechnology","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"VENUGOPAL\\r\\nT"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles\\r\\nTechnology","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"VENUGOPAL\\r\\nT"},{"CODE":"BMEE404L","TITLE":"Design of Transmission Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"KRISHANU\\r\\nGANGULY"},{"CODE":"BMEE407L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"DEVAPRAKAS\\r\\nAM D"},{"CODE":"BMEE409E","TITLE":"Computational Fluid Dynamics","TYPE":"TH","CREDITS":2,"SLOT":"D1","FACULTY":"SIVAKUMAR\\r\\nR"},{"CODE":"BMEE409E","TITLE":"Computational Fluid Dynamics","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SIVAKUMAR\\r\\nR"},{"CODE":"BMEE418L","TITLE":"Materials for Electric and Hybrid\\r\\nElectric Vehicles","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RADHA R"},{"CODE":"BMEE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BMEE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"BMHA302L","TITLE":"Industrial Automation","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SAKTHIVEL G"},{"CODE":"BMHA302L","TITLE":"Industrial Automation","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ELANGO M"},{"CODE":"BMHA302L","TITLE":"Industrial Automation","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MAHESWARI\\r\\nC"},{"CODE":"BMHA302P","TITLE":"Industrial Automation Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SAKTHIVEL G"},{"CODE":"BMHA302P","TITLE":"Industrial Automation Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SAKTHIVEL G"},{"CODE":"BMHA302P","TITLE":"Industrial Automation Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"ELANGO M"},{"CODE":"BMHA302P","TITLE":"Industrial Automation Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"ELANGO M"},{"CODE":"BMHA302P","TITLE":"Industrial Automation Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"MAHESWARI\\r\\nC"},{"CODE":"BMHA302P","TITLE":"Industrial Automation Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"MAHESWARI\\r\\nC"},{"CODE":"BMHA303L","TITLE":"Industrial Robotics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"L PAVAN\\r\\nKALYAN"},{"CODE":"BMHA303L","TITLE":"Industrial Robotics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ABHISHEK\\r\\nRUDRA PAL"},{"CODE":"BMHA303L","TITLE":"Industrial Robotics","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"AROCKIA\\r\\nSELVAKUMA R"},{"CODE":"BMHA303P","TITLE":"Industrial Robotics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"L PAVAN\\r\\nKALYAN"},{"CODE":"BMHA303P","TITLE":"Industrial Robotics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"L PAVAN\\r\\nKALYAN"},{"CODE":"BMHA303P","TITLE":"Industrial Robotics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ABHISHEK\\r\\nRUDRA PAL"},{"CODE":"BMHA303P","TITLE":"Industrial Robotics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"ABHISHEK\\r\\nRUDRA PAL"},{"CODE":"BMHA303P","TITLE":"Industrial Robotics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"AROCKIA SELVAKUMA\\r\\nR"},{"CODE":"BMHA303P","TITLE":"Industrial Robotics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"AROCKIA SELVAKUMA\\r\\nR"},{"CODE":"BMHA311L","TITLE":"Additive Manufacturing","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"DR.PADMAN ABHAN R M"},{"CODE":"BMHA312L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SARAVANAK\\r\\nUMAR D"},{"CODE":"BMHA313E","TITLE":"Driver Assistance Systems and Autonomous Vehicles","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"G\\r\\nMURALIMOH AN"},{"CODE":"BMHA313E","TITLE":"Driver Assistance Systems and Autonomous Vehicles","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"G MURALIMOH\\r\\nAN"},{"CODE":"BMHA313E","TITLE":"Driver Assistance Systems and Autonomous Vehicles","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"G MURALIMOH\\r\\nAN"},{"CODE":"BMHA315L","TITLE":"Augmented Reality and Haptics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ESWARAN M"},{"CODE":"BMHA315L","TITLE":"Augmented Reality and Haptics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"ESWARAN M"},{"CODE":"BMHA316L","TITLE":"Machinery Condition Monitoring","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JEGADEESHW\\r\\nARAN R"},{"CODE":"BMHA401L","TITLE":"Computer Integrated\\r\\nManufacturing","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"GAJANAND\\r\\nGUPTA"},{"CODE":"BMHA401P","TITLE":"Computer Integrated\\r\\nManufacturing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"GAJANAND\\r\\nGUPTA"},{"CODE":"BMHA498J","TITLE":"Project-II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BMHA498J","TITLE":"Project-II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"MACDM699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MACDM699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"MAMHA50","TITLE":"Industrial Automation","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MAHESWARI\\r\\nC"},{"CODE":"MAMHA50","TITLE":"Industrial Automation","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"MAHESWARI\\r\\nC"},{"CODE":"MAMHA50","TITLE":"Artificial Intelligence for\\r\\nMechatronics","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"SUGUMARAN\\r\\nV"},{"CODE":"MAMHA60","TITLE":"Machine Vision for Mechatronics","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"BONDA ATCHUTA GANESH\\r\\nYUVA RAJU"},{"CODE":"MAMHA60","TITLE":"Machine Vision for Mechatronics","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"BONDA ATCHUTA GANESH\\r\\nYUVA RAJU"},{"CODE":"MAMHA60","TITLE":"Industrial Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"PRADEEP N"},{"CODE":"MAMHA61","TITLE":"Virtual and Augmented Reality\\r\\nTechnologies","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ESWARAN M"},{"CODE":"MAMHA69","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MAMHA69","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"BACHY101","TITLE":"Environmental Sciences","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"KIRAN KUMAR TADI"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ALAMELU C"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"ALAMELU C"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUBBU\\r\\nLAKSHMI M"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SUBBU\\r\\nLAKSHMI M"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RASHMI\\r\\nREKHA BORAH"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"RASHMI\\r\\nREKHA BORAH"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VIJAYALAKSH\\r\\nMI V"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"VIJAYALAKSH\\r\\nMI V"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"MANALI\\r\\nKARMAKAR"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"MANALI\\r\\nKARMAKAR"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PATCHAINAY\\r\\nAGI S"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"PATCHAINAY\\r\\nAGI S"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"JAISHREE KARTHIGA R\\r\\nK"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"JAISHREE KARTHIGA R\\r\\nK"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"BHUVANESW\\r\\nARI G"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"BHUVANESW\\r\\nARI G"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ALAN G"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"JAISHREE KARTHIGA R\\r\\nK"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"JAISHREE\\r\\nKARTHIGA R K"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"AJITH I"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PREETHA R"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PREETHA R"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"DEVI\\r\\nMEENAKSHI K"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"DEVI MEENAKSHI\\r\\nK"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAJITHA K"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIVAKAMI B"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"DIVYA\\r\\nMURALEEDH ARAN"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"GANESH NAGARAO\\r\\nCHILKE"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SHAHANAS PUNNILATH\\r\\nSHANAVAS"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"RASHMI REKHA\\r\\nBORAH"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SIVAKAMI B"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"AKAITAB\\r\\nMUKHERJEE"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ANUJA RAJ"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PREETHA R"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"PREETHA R"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAJASEKARA\\r\\nN V"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"RAJASEKARA\\r\\nN V"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"KEERTHANA\\r\\nS"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"KEERTHANA\\r\\nS"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAJITHA K"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"RAJITHA K"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"LEKSHMY U K"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"LEKSHMY U K"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"AKAITAB\\r\\nMUKHERJEE"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"AKAITAB\\r\\nMUKHERJEE"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUNANDA\\r\\nKAR"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SUNANDA\\r\\nKAR"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"CHITHRA G K"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"CHITHRA G K"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SUNANDA\\r\\nKAR"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SUNANDA\\r\\nKAR"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ANUJA RAJ"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"ANUJA RAJ"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"DAISY\\r\\nGOHAIN"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"DAISY\\r\\nGOHAIN"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DIVYA MURALEEDH\\r\\nARAN"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"DIVYA MURALEEDH\\r\\nARAN"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"LEKSHMY U K"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"LEKSHMY U K"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DAISY\\r\\nGOHAIN"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"DAISY\\r\\nGOHAIN"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SHAHANAS\\r\\nPUNNILATH SHANAVAS"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SHAHANAS PUNNILATH\\r\\nSHANAVAS"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KEERTHANA\\r\\nS"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"KEERTHANA\\r\\nS"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MANALI\\r\\nKARMAKAR"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"MANALI\\r\\nKARMAKAR"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"ALAN G"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"AJITH I"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"RAJITHA K"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SIVAKAMI B"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"DIVYA MURALEEDH\\r\\nARAN"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"GANESH NAGARAO\\r\\nCHILKE"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SHAHANAS PUNNILATH\\r\\nSHANAVAS"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"RASHMI REKHA\\r\\nBORAH"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ANUJA RAJ"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48","FACULTY":"AKAITAB\\r\\nMUKHERJEE"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SIVAKAMI B"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"SAVARIAH\\r\\nXAVIER Y C"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SAVARIAH\\r\\nXAVIER Y C"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"TRISHA"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"TRISHA"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE2","FACULTY":"SAVARIAH\\r\\nXAVIER Y C"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SAVARIAH\\r\\nXAVIER Y C"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE2","FACULTY":"SHALINI\\r\\nSUPRIYA"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SHALINI\\r\\nSUPRIYA"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE2","FACULTY":"TRISHA"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"TRISHA"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE2","FACULTY":"INL-\\r\\nSPANISH01"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"INL-\\r\\nSPANISH01"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"SAVARIAH\\r\\nXAVIER Y C"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"SAVARIAH\\r\\nXAVIER Y C"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"SHALINI\\r\\nSUPRIYA"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"SHALINI\\r\\nSUPRIYA"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"TRISHA"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"TRISHA"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA2","FACULTY":"SHALINI\\r\\nSUPRIYA"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SHALINI\\r\\nSUPRIYA"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA2","FACULTY":"INL-\\r\\nSPANISH01"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"INL-\\r\\nSPANISH01"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"GOVINDARAJ\\r\\nAN P"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"GOVINDARAJ\\r\\nAN P"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"CLARISSE\\r\\nROUABAH"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"CLARISSE\\r\\nROUABAH"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"LOKESH\\r\\nBISHNOI"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"LOKESH\\r\\nBISHNOI"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"PRIYA SINGH"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"PRIYA SINGH"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"INL-\\r\\nFRENCH01"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"INL-\\r\\nFRENCH01"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE2","FACULTY":"GOVINDARAJ\\r\\nAN P"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"GOVINDARAJ\\r\\nAN P"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE2","FACULTY":"CLARISSE\\r\\nROUABAH"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"CLARISSE\\r\\nROUABAH"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE2","FACULTY":"LOKESH\\r\\nBISHNOI"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"LOKESH\\r\\nBISHNOI"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE2","FACULTY":"FOREIN LANGUAGE -\\r\\nFRENCH 3"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"FOREIN\\r\\nLANGUAGE - FRENCH 3"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"PRIYA SINGH"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48","FACULTY":"PRIYA SINGH"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"INL-\\r\\nFRENCH01"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54","FACULTY":"INL-\\r\\nFRENCH01"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"FOREIN LANGUAGE -\\r\\nFRENCH 3"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"FOREIN\\r\\nLANGUAGE - FRENCH 3"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA2","FACULTY":"LOKESH\\r\\nBISHNOI"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"LOKESH\\r\\nBISHNOI"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA2","FACULTY":"PRIYA SINGH"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"PRIYA SINGH"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA2","FACULTY":"INL-\\r\\nFRENCH01"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"INL-\\r\\nFRENCH01"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA2","FACULTY":"INL-\\r\\nFRENCH02"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"INL-\\r\\nFRENCH02"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA2","FACULTY":"FOREIN\\r\\nLANGUAGE - FRENCH 3"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"FOREIN LANGUAGE -\\r\\nFRENCH 3"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"JAMUNARAN\\r\\nI M"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"JAMUNARAN\\r\\nI M"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"SUGUMAR G"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SUGUMAR G"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"VEENA PANI"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"VEENA PANI"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE2","FACULTY":"SUGUMAR G"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SUGUMAR G"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE2","FACULTY":"ASHUTOSH KUMAR\\r\\nTRIPATHI"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ASHUTOSH KUMAR\\r\\nTRIPATHI"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE2","FACULTY":"VEENA PANI"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"VEENA PANI"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE2","FACULTY":"INL-\\r\\nGERMAN02"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"INL-\\r\\nGERMAN02"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"JAMUNARAN\\r\\nI M"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"JAMUNARAN\\r\\nI M"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"SUGUMAR G"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SUGUMAR G"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"ASHUTOSH KUMAR\\r\\nTRIPATHI"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54","FACULTY":"ASHUTOSH KUMAR\\r\\nTRIPATHI"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"INL-\\r\\nGERMAN02"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"INL-\\r\\nGERMAN02"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA2","FACULTY":"JAMUNARAN\\r\\nI M"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"JAMUNARAN\\r\\nI M"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA2","FACULTY":"ASHUTOSH\\r\\nKUMAR TRIPATHI"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"ASHUTOSH KUMAR\\r\\nTRIPATHI"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA2","FACULTY":"VEENA PANI"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"VEENA PANI"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA2","FACULTY":"INL-\\r\\nGERMAN02"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"INL-\\r\\nGERMAN02"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA2","FACULTY":"INL-\\r\\nGERMAN01"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"INL-\\r\\nGERMAN01"},{"CODE":"BAHUM101","TITLE":"India Studies","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"VIJAYALAKSH\\r\\nMI V"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"RAJKUMAR R"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"B V A N S S\\r\\nPRABHAKAR RAO"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"VIJAYALAKSH\\r\\nMI A"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"SIVAKAMAVA\\r\\nLLI J"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"YASHAVANT\\r\\nH P R"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"SARANYARAJ\\r\\nD"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"SUJATHA M"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"MEIGNANAM\\r\\nOORTHI D"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"PARVATHY A\\r\\nK"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"SIVARANJANI\\r\\nN"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"UNNIKRISHN\\r\\nAN B S"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"SIVAKAMAVA\\r\\nLLI J"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"SURESHKUM\\r\\nAR WI WI"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"SARITA\\r\\nKUMARI"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"JANI\\r\\nANBARASI L"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"YASHAVANT\\r\\nH P R"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"SANDHYA"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"SUBITHA D"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"SAKTHIVEL R"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"UNNIKRISHN\\r\\nAN B S"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"MADURA MEENAKSHI\\r\\nR"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"AMUTHA S"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"AKKARAPAKA M SUNEESH JACOB"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SUGUMARAN\\r\\nV"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SREEKANTH DONDAPATI"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"MANIMARAN\\r\\nR"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"PRITAM DAS"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"IMMANUEL SELWYN RAJ\\r\\nA"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"IMMANUEL SELWYN RAJ\\r\\nA"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"MANIMARAN\\r\\nR"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"SUGUMARAN\\r\\nV"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"SREEKANTH DONDAPATI"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"PONNUSAMY\\r\\nP"},{"CODE":"BAHUM106","TITLE":"Micro Economics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SHALINA\\r\\nSUSAN MATHEW"},{"CODE":"BAHUM106","TITLE":"Micro Economics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MAGULSHA\\r\\nGEORGE"},{"CODE":"BAHUM106","TITLE":"Micro Economics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"MAGULSHA\\r\\nGEORGE"},{"CODE":"BAHUM106","TITLE":"Micro Economics","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"MUHAMMED NAJEEB K K"},{"CODE":"BAHUM106","TITLE":"Micro Economics","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"AISHWARYA\\r\\nV"},{"CODE":"BAHUM106","TITLE":"Micro Economics","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"NIRANJANA\\r\\nG"},{"CODE":"BAHUM107","TITLE":"Macro Economics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SATHIS\\r\\nKUMAR G"},{"CODE":"BAHUM107","TITLE":"Macro Economics","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"NIRANJANA\\r\\nG"},{"CODE":"BAHUM107","TITLE":"Macro Economics","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"CEPHAS\\r\\nPRAKASH RAJA R C"},{"CODE":"BAHUM107","TITLE":"Macro Economics","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"AISHWARYA\\r\\nV"},{"CODE":"BAHUM107","TITLE":"Macro Economics","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"CEPHAS\\r\\nPRAKASH RAJA R C"},{"CODE":"BAHUM108","TITLE":"Public Policy and Administration","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ARUN\\r\\nKUMAR G"},{"CODE":"BAHUM108","TITLE":"Public Policy and Administration","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"TARANG\\r\\nMAHAJAN"},{"CODE":"BAHUM108","TITLE":"Public Policy and Administration","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ARUN\\r\\nKUMAR G"},{"CODE":"BAHUM108","TITLE":"Public Policy and Administration","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RAJEESH C S"},{"CODE":"BAHUM109","TITLE":"Principles of Sociology","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"BINU\\r\\nSAHAYAM D"},{"CODE":"BAHUM109","TITLE":"Principles of Sociology","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"TIWARI MAHALAXMI SHIVSHANKA\\r\\nR"},{"CODE":"BAHUM109","TITLE":"Principles of Sociology","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"FARSANA KP"},{"CODE":"BAHUM109","TITLE":"Principles of Sociology","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"TIWARI MAHALAXMI SHIVSHANKA R"},{"CODE":"BAHUM109","TITLE":"Principles of Sociology","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ROOPESH O\\r\\nB"},{"CODE":"BAHUM109","TITLE":"Principles of Sociology","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"FARSANA KP"},{"CODE":"BAHUM109","TITLE":"Principles of Sociology","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"BINU\\r\\nSAHAYAM D"},{"CODE":"BAHUM109","TITLE":"Principles of Sociology","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"ROOPESH O\\r\\nB"},{"CODE":"BAHUM110","TITLE":"Sustainability and Society","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ROOPESH O\\r\\nB"},{"CODE":"BAHUM110","TITLE":"Sustainability and Society","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"BINU\\r\\nSAHAYAM D"},{"CODE":"BAHUM110","TITLE":"Sustainability and Society","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"TIWARI MAHALAXMI SHIVSHANKA R"},{"CODE":"BAHUM110","TITLE":"Sustainability and Society","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ROOPESH O\\r\\nB"},{"CODE":"BAHUM110","TITLE":"Sustainability and Society","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"BINU\\r\\nSAHAYAM D"},{"CODE":"BAHUM110","TITLE":"Sustainability and Society","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"BHUVANESW\\r\\nARI R"},{"CODE":"BAHUM110","TITLE":"Sustainability and Society","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"TIWARI MAHALAXMI SHIVSHANKA R"},{"CODE":"BAHUM110","TITLE":"Sustainability and Society","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"BHUVANESW\\r\\nARI R"},{"CODE":"BAHUM111","TITLE":"Introduction to Psychology","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MAHARISHI R"},{"CODE":"BAHUM111","TITLE":"Introduction to Psychology","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"VIJAYABANU\\r\\nU"},{"CODE":"BAHUM111","TITLE":"Introduction to Psychology","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SARANYA T S"},{"CODE":"BAHUM111","TITLE":"Introduction to Psychology","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"MAHARISHI R"},{"CODE":"BAHUM112","TITLE":"Psychology in Everyday Life","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"DURGA R P"},{"CODE":"BAHUM113","TITLE":"Indigenous Narratives and\\r\\nKnowledge Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ANUJA RAJ"},{"CODE":"BAHUM113","TITLE":"Indigenous Narratives and\\r\\nKnowledge Systems","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"LEKSHMY U K"},{"CODE":"BAHUM114","TITLE":"Literature Through Films","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SUNANDA\\r\\nKAR"},{"CODE":"BAHUM114","TITLE":"Literature Through Films","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VINEETH RADHAKRISH\\r\\nNAN"},{"CODE":"BAHUM114","TITLE":"Literature Through Films","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SHAHANAS\\r\\nPUNNILATH SHANAVAS"},{"CODE":"BAHUM114","TITLE":"Literature Through Films","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"MANALI\\r\\nKARMAKAR"},{"CODE":"BAHUM115","TITLE":"Science Fiction Stories of Tomorrow","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RASHMI REKHA\\r\\nBORAH"},{"CODE":"BAHUM115","TITLE":"Science Fiction Stories of Tomorrow","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"LUKE GERARD\\r\\nCHRISTIE"},{"CODE":"BAHUM115","TITLE":"Science Fiction Stories of\\r\\nTomorrow","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"RAJITHA K"},{"CODE":"BAHUM117","TITLE":"Indian writing in English","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SIVAKAMI B"},{"CODE":"BAHUM117","TITLE":"Indian writing in English","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"KEERTHANA\\r\\nS"},{"CODE":"BAHUM117","TITLE":"Indian writing in English","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ALAN G"},{"CODE":"BAHUM117","TITLE":"Indian writing in English","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PREETHA R"},{"CODE":"BAHUM117","TITLE":"Indian writing in English","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"DIVYA MURALEEDH\\r\\nARAN"},{"CODE":"BAHUM119","TITLE":"International Relations","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"GOKUL K S"},{"CODE":"BAHUM119","TITLE":"International Relations","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"ANJALI POPLI"},{"CODE":"BAHUM251","TITLE":"Indian Constitution","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"TARANG\\r\\nMAHAJAN"},{"CODE":"BAHUM251","TITLE":"Indian Constitution","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"TARANG\\r\\nMAHAJAN"},{"CODE":"BAHUM251","TITLE":"Indian Constitution","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ARUN\\r\\nKUMAR G"},{"CODE":"BAHUM251","TITLE":"Indian Constitution","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"ARUN\\r\\nKUMAR G"},{"CODE":"BAJAP101","TITLE":"Japanese Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"M JAYASHREE\\r\\nDASS"},{"CODE":"BAJAP101","TITLE":"Japanese Level I","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"M\\r\\nJAYASHREE DASS"},{"CODE":"BAJAP101","TITLE":"Japanese Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE2","FACULTY":"M JAYASHREE\\r\\nDASS"},{"CODE":"BAJAP101","TITLE":"Japanese Level I","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"M JAYASHREE\\r\\nDASS"},{"CODE":"BAJAP101","TITLE":"Japanese Level I","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"M JAYASHREE\\r\\nDASS"},{"CODE":"BAJAP101","TITLE":"Japanese Level I","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"M\\r\\nJAYASHREE DASS"},{"CODE":"BAKOR101","TITLE":"Basic Korean \xe2\u20AC\u201C Level 1 (??\\r\\n???1)","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"JINYOUNG\\r\\nKIM"},{"CODE":"BAKOR101","TITLE":"Basic Korean \xe2\u20AC\u201C Level 1 (??\\r\\n???1)","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"JINYOUNG\\r\\nKIM"},{"CODE":"BAKOR101","TITLE":"Basic Korean \xe2\u20AC\u201C Level 1 (??\\r\\n???1)","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"JINYOUNG\\r\\nKIM"},{"CODE":"BAKOR101","TITLE":"Basic Korean \xe2\u20AC\u201C Level 1 (??\\r\\n???1)","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"JINYOUNG\\r\\nKIM"},{"CODE":"BENG101L","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"HARSHA V"},{"CODE":"BENG101P","TITLE":"Technical English\\r\\nCommunication Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"HARSHA V"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SUBBU\\r\\nLAKSHMI M"},{"CODE":"BHUM101N","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"VIJAYALAKSH\\r\\nMI V"},{"CODE":"BSSC101N","TITLE":"Essence of Traditional\\r\\nKnowledge","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"ROOPESH O\\r\\nB"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"BERTILA A"},{"CODE":"IAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ALAN G"},{"CODE":"IAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"ALAN G"},{"CODE":"IAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MANALI\\r\\nKARMAKAR"},{"CODE":"IAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"MANALI\\r\\nKARMAKAR"},{"CODE":"IAESP101","TITLE":"Spanish Level I","TYPE":"TH","CREDITS":1,"SLOT":"TB2","FACULTY":"INL-\\r\\nSPANISH01"},{"CODE":"IAESP101","TITLE":"Spanish Level I","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"INL-\\r\\nSPANISH01"},{"CODE":"IAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TB1","FACULTY":"INL-\\r\\nFRENCH02"},{"CODE":"IAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"INL-\\r\\nFRENCH02"},{"CODE":"IAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TB2","FACULTY":"INL-\\r\\nFRENCH02"},{"CODE":"IAFRE101","TITLE":"French Level I","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"INL-\\r\\nFRENCH02"},{"CODE":"IAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TB1","FACULTY":"INL-\\r\\nGERMAN01"},{"CODE":"IAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"INL-\\r\\nGERMAN01"},{"CODE":"IAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TB1","FACULTY":"INL-\\r\\nGERMAN02"},{"CODE":"IAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L59+L60","FACULTY":"INL-\\r\\nGERMAN02"},{"CODE":"IAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TB2","FACULTY":"INL-\\r\\nGERMAN01"},{"CODE":"IAGER101","TITLE":"German Level I","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"INL-\\r\\nGERMAN01"},{"CODE":"IAHUM101","TITLE":"India Studies","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"BINU\\r\\nSAHAYAM D"},{"CODE":"IHUM101N","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"BINU\\r\\nSAHAYAM D"},{"CODE":"IHUM202L","TITLE":"Rural Development","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VIJAYALAKSH\\r\\nMI V"},{"CODE":"ISSC101N","TITLE":"Essence of Traditional Knowledge","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"TIWARI MAHALAXMI SHIVSHANKA\\r\\nR"},{"CODE":"ISSC102N","TITLE":"Indian Constitution","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"HELEN P\\r\\nAZYU"},{"CODE":"UAENG102","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"RAJASEKARA\\r\\nN V"},{"CODE":"UAENG102","TITLE":"Technical English\\r\\nCommunication","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"RAJASEKARA\\r\\nN V"},{"CODE":"UAFRE101","TITLE":"French","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"GOVINDARAJ\\r\\nAN P"},{"CODE":"BAFST103","TITLE":"Garment Production Machinery","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"VASANTH\\r\\nKUMAR"},{"CODE":"BAFST103","TITLE":"Garment Production Machinery","TYPE":"LO","CREDITS":2,"SLOT":"L9+L10+L29+L\\r\\n30","FACULTY":"VASANTH\\r\\nKUMAR"},{"CODE":"BAFST201","TITLE":"Fashion Illustration","TYPE":"LO","CREDITS":4,"SLOT":"L25+L26+L37+ L38+L39+L40+\\r\\nL55+L56","FACULTY":"CHARMINI B"},{"CODE":"BAFST205","TITLE":"Sports and Recreational Textiles","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RATHINAMO\\r\\nORTHY R"},{"CODE":"BAFST205","TITLE":"Sports and Recreational Textiles","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"RATHINAMO\\r\\nORTHY R"},{"CODE":"BAFST206","TITLE":"Pattern Making and Garment\\r\\nConstruction II","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"MAANVIZHI\\r\\nM"},{"CODE":"BAFST206","TITLE":"Pattern Making and Garment\\r\\nConstruction II","TYPE":"LO","CREDITS":2,"SLOT":"L37+L38+L49+\\r\\nL50","FACULTY":"MAANVIZHI\\r\\nM"},{"CODE":"BAFST302","TITLE":"Fashion Psychology","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"MAANVIZHI\\r\\nM"},{"CODE":"BAFST302","TITLE":"Fashion Psychology","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"CHARMINI B"},{"CODE":"BAFST316","TITLE":"Global Fashion Marketing and\\r\\nMerchandising","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"RATHINAMO\\r\\nORTHY R"},{"CODE":"BAFST323","TITLE":"Fashion Accessories","TYPE":"TH","CREDITS":2,"SLOT":"D1","FACULTY":"N. GAYATHRI"},{"CODE":"BAFST323","TITLE":"Fashion Accessories","TYPE":"LO","CREDITS":2,"SLOT":"L31+L32+L55+\\r\\nL56","FACULTY":"N. GAYATHRI"},{"CODE":"BFST103L","TITLE":"Apparel Machineries","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VASANTH\\r\\nKUMAR"},{"CODE":"BFST210E","TITLE":"Visual Merchandising","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SAROJ K M"},{"CODE":"BFST401L","TITLE":"Textile Processing and Finishing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SELVAKUMA\\r\\nR"},{"CODE":"BFST401P","TITLE":"Textile Processing and Finishing\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SELVAKUMA\\r\\nR"},{"CODE":"BFST402L","TITLE":"Fabric Structure and Design\\r\\nAnalysis","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"PALANI\\r\\nRAJAN T"},{"CODE":"BFST402P","TITLE":"Fabric Structure and Design\\r\\nAnalysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PALANI\\r\\nRAJAN T"},{"CODE":"BFST403P","TITLE":"Computer Aided Garment Design Lab","TYPE":"LO","CREDITS":3,"SLOT":"L5+L6+L31+L3 2+L49+L50","FACULTY":"RAJA\\r\\nBALASARAS WATHI S"},{"CODE":"BFST404L","TITLE":"Retail Management","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VASANTH\\r\\nKUMAR"},{"CODE":"BFST498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BFST498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"PAT"},{"CODE":"MMA3099","TITLE":"Capstone Project","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BAHUM202","TITLE":"Security Analysis and Portfolio Management","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MOHD\\r\\nHAMMAD NAEEM"},{"CODE":"BAHUM202","TITLE":"Security Analysis and Portfolio\\r\\nManagement","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"BUVANESH C"},{"CODE":"BAHUM202","TITLE":"Security Analysis and Portfolio\\r\\nManagement","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"AHMAD\\r\\nHASAN"},{"CODE":"BAHUM202","TITLE":"Security Analysis and Portfolio Management","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"MOHD NADEEM\\r\\nBHAT"},{"CODE":"BAHUM203","TITLE":"Options, Futures, and Derivatives","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RAJESH A D J"},{"CODE":"BAHUM203","TITLE":"Options, Futures, and Derivatives","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"MOHD HAMMAD\\r\\nNAEEM"},{"CODE":"BAHUM203","TITLE":"Options, Futures, and Derivatives","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MARIA EVELYN\\r\\nJUCUNDA M"},{"CODE":"BAHUM204","TITLE":"Fixed Income Securities","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"BUVANESH C"},{"CODE":"BAHUM204","TITLE":"Fixed Income Securities","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"MARIA EVELYN\\r\\nJUCUNDA M"},{"CODE":"BAHUM204","TITLE":"Fixed Income Securities","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SHAIK\\r\\nSALEEM"},{"CODE":"BAMGT211","TITLE":"Negotiation and Selling: Tactics\\r\\nand Practice","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"BALAJI J"},{"CODE":"BAMGT213","TITLE":"Content and Brand Storytelling","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SHAMAL S"},{"CODE":"BAMGT215","TITLE":"Emotional Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"NISHA R"},{"CODE":"BAMGT215","TITLE":"Emotional Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SRILALITHA R"},{"CODE":"BAMGT217","TITLE":"FinTech","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SUDARSANA\\r\\nM S K"},{"CODE":"BAMGT217","TITLE":"FinTech","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"AHMAD\\r\\nHASAN"},{"CODE":"BAMGT221","TITLE":"Personal Wealth Management","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MANU JOSE"},{"CODE":"BAMGT221","TITLE":"Personal Wealth Management","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"CARLIN JEMIMAH G J"},{"CODE":"BAMGT221","TITLE":"Personal Wealth Management","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"CARLIN JEMIMAH G J"},{"CODE":"BAMGT221","TITLE":"Personal Wealth Management","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"AHMAD\\r\\nHASAN"},{"CODE":"BMGT101L","TITLE":"Principles of Management","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"NISHA R"},{"CODE":"BMGT101L","TITLE":"Principles of Management","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SREEYA B"},{"CODE":"BMGT101L","TITLE":"Principles of Management","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAJKUMAR MURUGESAN"},{"CODE":"BMGT101L","TITLE":"Principles of Management","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"BHARATH\\r\\nSANKAR S"},{"CODE":"BMGT101L","TITLE":"Principles of Management","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"BUVANESH C"},{"CODE":"BMGT102L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ARCHANA\\r\\nSINGH"},{"CODE":"BMGT102L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUMATHI G\\r\\nN"},{"CODE":"BMGT102L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SRILALITHA R"},{"CODE":"BMGT102L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"REKHAPRIYA DHARSHINI A"},{"CODE":"BMGT103L","TITLE":"Organizational Behavior","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SUMATHI G\\r\\nN"},{"CODE":"BMGT103L","TITLE":"Organizational Behavior","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"PRIYADHARS\\r\\nHINI V"},{"CODE":"BMGT103L","TITLE":"Organizational Behavior","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"REKHAPRIYA DHARSHINI A"},{"CODE":"BMGT104L","TITLE":"Marketing Management","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ANURADHA\\r\\nA"},{"CODE":"BMGT104L","TITLE":"Marketing Management","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ANURADHA\\r\\nA"},{"CODE":"BMGT104L","TITLE":"Marketing Management","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MALAY\\r\\nBHATTACHAR JEE"},{"CODE":"BMGT105L","TITLE":"Consumer Behavior","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KISHORE\\r\\nTHOMAS JOHN"},{"CODE":"BMGT105L","TITLE":"Consumer Behavior","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ANBUMATHI\\r\\nR"},{"CODE":"BMGT106L","TITLE":"Digital Marketing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SHAMAL S"},{"CODE":"BMGT106L","TITLE":"Digital Marketing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"PADMAVATH\\r\\nY C"},{"CODE":"BMGT106L","TITLE":"Digital Marketing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ARCHANA\\r\\nSINGH"},{"CODE":"BMGT107L","TITLE":"Business Analytics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ANBUMATHI\\r\\nR"},{"CODE":"BMGT107L","TITLE":"Business Analytics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUDARSANA\\r\\nM S K"},{"CODE":"BMGT107L","TITLE":"Business Analytics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"REEVES\\r\\nWESLEY J"},{"CODE":"BMGT107L","TITLE":"Business Analytics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"BALAJI J"},{"CODE":"BMGT107L","TITLE":"Business Analytics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SUDARSANA\\r\\nM S K"},{"CODE":"MGT3006","TITLE":"Neuro Marketing","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"THANGARAJA ARUMUGAM"},{"CODE":"MGT3006","TITLE":"Neuro Marketing","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"THANGARAJA ARUMUGAM"},{"CODE":"MGT3006","TITLE":"Neuro Marketing","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"KISHORE THOMAS\\r\\nJOHN"},{"CODE":"MGT3006","TITLE":"Neuro Marketing","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"KISHORE THOMAS\\r\\nJOHN"},{"CODE":"MGT3013","TITLE":"Risk and Fraud Analytics","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAJESH A D J"},{"CODE":"MGT3013","TITLE":"Risk and Fraud Analytics","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"RAJESH A D J"},{"CODE":"MGT3014","TITLE":"Operations Analytics","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"VADIVEL S M"},{"CODE":"MGT3014","TITLE":"Operations Analytics","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"VADIVEL S M"},{"CODE":"MGT3014","TITLE":"Operations Analytics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RIJAS B M"},{"CODE":"MGT3014","TITLE":"Operations Analytics","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"RIJAS B M"},{"CODE":"MGT3015","TITLE":"Supply Chain Analytics","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RIJAS B M"},{"CODE":"MGT3015","TITLE":"Supply Chain Analytics","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"RIJAS B M"},{"CODE":"BAHUM205","TITLE":"Intellectual Property Rights and\\r\\nthe Law","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"BILAL A\\r\\nNAZEER"},{"CODE":"BAHUM205","TITLE":"Intellectual Property Rights and\\r\\nthe Law","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SONY RAJ S S"},{"CODE":"BAHUM205","TITLE":"Intellectual Property Rights and\\r\\nthe Law","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SHERIN\\r\\nPRIYAN"},{"CODE":"BAHUM205","TITLE":"Intellectual Property Rights and\\r\\nthe Law","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"POOJA"},{"CODE":"BAHUM205","TITLE":"Intellectual Property Rights and\\r\\nthe Law","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"HELEN P\\r\\nAZYU"},{"CODE":"MASTS505","TITLE":"Professional Soft Skills","TYPE":"TH","CREDITS":3,"SLOT":"I2+N1+U4","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"MASTS602","TITLE":"Competitive Coding II","TYPE":"TH","CREDITS":3,"SLOT":"I3+M1+N2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"PASTS501","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice I","TYPE":"TH","CREDITS":3,"SLOT":"I2+N1+U4","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"PASTS501","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice I","TYPE":"TH","CREDITS":3,"SLOT":"I2+N1+U4","FACULTY":"FACE (APT)"},{"CODE":"PASTS501","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice I","TYPE":"TH","CREDITS":3,"SLOT":"I8+N7+U10","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"PASTS502","TITLE":"Qualitative and Quantitative\\r\\nSkills II","TYPE":"TH","CREDITS":3,"SLOT":"I2+N1+U4","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"PASTS601","TITLE":"Competitive Coding I","TYPE":"TH","CREDITS":3,"SLOT":"I3+M1+N2","FACULTY":"FACE (APT)"},{"CODE":"PASTS602","TITLE":"Competitive Coding II","TYPE":"TH","CREDITS":3,"SLOT":"I3+M1+N2","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"PASTS602","TITLE":"Competitive Coding II","TYPE":"TH","CREDITS":3,"SLOT":"I3+M1+N2","FACULTY":"FACE (APT)"},{"CODE":"PASTS602","TITLE":"Competitive Coding II","TYPE":"TH","CREDITS":3,"SLOT":"I9+M7+N8","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"UASTS102","TITLE":"Quantitative Skills","TYPE":"TH","CREDITS":1,"SLOT":"M4+R2+U1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"UASTS102","TITLE":"Quantitative Skills","TYPE":"TH","CREDITS":1,"SLOT":"I3+N3+U3","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"PACHY503","TITLE":"Organic Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"M8+N8+R8","FACULTY":"SARAVANAK\\r\\nUMAR R"},{"CODE":"PACHY503","TITLE":"Organic Chemistry","TYPE":"TH","CREDITS":1,"SLOT":"U7+U8","FACULTY":"SARAVANAK\\r\\nUMAR R"},{"CODE":"PACHY504","TITLE":"Molecular Spectroscopy","TYPE":"TH","CREDITS":4,"SLOT":"I1+M2+R2+U1","FACULTY":"BALAMURALI\\r\\nM M"},{"CODE":"PACHY506","TITLE":"Analytical Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"I2+M3+U3","FACULTY":"ILAIYARAJA\\r\\nPERUMAL"},{"CODE":"PACHY506","TITLE":"Analytical Chemistry","TYPE":"TH","CREDITS":1,"SLOT":"I5+I6","FACULTY":"ILAIYARAJA\\r\\nPERUMAL"},{"CODE":"PACHY507","TITLE":"Computational Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"M5+N2+R5","FACULTY":"RAJESHKUM\\r\\nAR T"},{"CODE":"PACHY507","TITLE":"Computational Chemistry","TYPE":"TH","CREDITS":1,"SLOT":"U5+U6","FACULTY":"RAJESHKUM\\r\\nAR T"},{"CODE":"PACHY621","TITLE":"Organometallic Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"I7+M4+R1","FACULTY":"SUNIT\\r\\nKUMAR"},{"CODE":"PAMDS503","TITLE":"Statistical Inference","TYPE":"TH","CREDITS":3,"SLOT":"N4+R3+U2","FACULTY":"UMA MAHESWARI\\r\\nS"},{"CODE":"PAMDS503","TITLE":"Statistical Inference","TYPE":"TH","CREDITS":1,"SLOT":"I7+I8","FACULTY":"UMA\\r\\nMAHESWARI S"},{"CODE":"PAMDS503","TITLE":"Statistical Inference","TYPE":"TH","CREDITS":3,"SLOT":"M3+N8+R5","FACULTY":"MANIVANNA\\r\\nN A"},{"CODE":"PAMDS503","TITLE":"Statistical Inference","TYPE":"TH","CREDITS":1,"SLOT":"U1+U2","FACULTY":"MANIVANNA\\r\\nN A"},{"CODE":"PAMDS503","TITLE":"Statistical Inference","TYPE":"TH","CREDITS":3,"SLOT":"M10+N10+R1\\r\\n0","FACULTY":"PARTHIBAN V"},{"CODE":"PAMDS503","TITLE":"Statistical Inference","TYPE":"TH","CREDITS":1,"SLOT":"M3+M4","FACULTY":"PARTHIBAN V"},{"CODE":"PAMDS505","TITLE":"Data Mining and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"M4+R1+U6","FACULTY":"SURATH\\r\\nGHOSH"},{"CODE":"PAMDS505","TITLE":"Data Mining and Machine\\r\\nLearning","TYPE":"TH","CREDITS":1,"SLOT":"M7+M8","FACULTY":"SURATH\\r\\nGHOSH"},{"CODE":"PAMDS505","TITLE":"Data Mining and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"I4+R3+U3","FACULTY":"KALYANI\\r\\nDESIKAN"},{"CODE":"PAMDS505","TITLE":"Data Mining and Machine\\r\\nLearning","TYPE":"TH","CREDITS":1,"SLOT":"M5+M6","FACULTY":"KALYANI\\r\\nDESIKAN"},{"CODE":"PAMDS505","TITLE":"Data Mining and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"I7+R9+U9","FACULTY":"HANNAH\\r\\nGRACE G"},{"CODE":"PAMDS505","TITLE":"Data Mining and Machine\\r\\nLearning","TYPE":"TH","CREDITS":1,"SLOT":"I3+I4","FACULTY":"HANNAH\\r\\nGRACE G"},{"CODE":"PAMDS506","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"I5+M3+R5","FACULTY":"FELIX A"},{"CODE":"PAMDS506","TITLE":"Deep Learning","TYPE":"TH","CREDITS":1,"SLOT":"N7+N8","FACULTY":"FELIX A"},{"CODE":"PAMDS506","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"M8+N7+R8","FACULTY":"DHANASEKA\\r\\nR S"},{"CODE":"PAMDS506","TITLE":"Deep Learning","TYPE":"TH","CREDITS":1,"SLOT":"I5+I6","FACULTY":"DHANASEKA\\r\\nR S"},{"CODE":"PAMDS506","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"M9+R8+U8","FACULTY":"DAVID\\r\\nMAXIM GURURAJ A"},{"CODE":"PAMDS506","TITLE":"Deep Learning","TYPE":"TH","CREDITS":1,"SLOT":"U3+U4","FACULTY":"DAVID MAXIM\\r\\nGURURAJ A"},{"CODE":"PAMDS605","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":4,"SLOT":"I1+N3+R4+U5","FACULTY":"KALIYAPPAN\\r\\nM"},{"CODE":"PAMDS606","TITLE":"Data Structures and Algorithms","TYPE":"TH","CREDITS":3,"SLOT":"I1+R4+U5","FACULTY":"NATHIYA N"},{"CODE":"PAMDS606","TITLE":"Data Structures and Algorithms","TYPE":"TH","CREDITS":1,"SLOT":"R7+R8","FACULTY":"NATHIYA N"},{"CODE":"PAMDS609","TITLE":"Generative AI","TYPE":"TH","CREDITS":4,"SLOT":"I4+M2+R2+U3","FACULTY":"KALIYAPPAN\\r\\nM"},{"CODE":"PAMDS609","TITLE":"Generative AI","TYPE":"TH","CREDITS":4,"SLOT":"I8+M2+N4+R2","FACULTY":"N RAMESH\\r\\nBABU"},{"CODE":"PAMDS609","TITLE":"Generative AI","TYPE":"TH","CREDITS":4,"SLOT":"M8+N9+R7+U\\r\\n7","FACULTY":"KALYANI\\r\\nDESIKAN"},{"CODE":"PAPHY503","TITLE":"Classical Electrodynamics","TYPE":"TH","CREDITS":4,"SLOT":"I3+N3+R6+U5","FACULTY":"SANJIT DAS"},{"CODE":"PAPHY505","TITLE":"Statistical Mechanics","TYPE":"TH","CREDITS":4,"SLOT":"M3+M4+N2+R 4","FACULTY":"KORLEPARA\\r\\nDIVYA BHARATHI"},{"CODE":"PAPHY506","TITLE":"Solid State Physics","TYPE":"TH","CREDITS":3,"SLOT":"M2+R3+U3","FACULTY":"ATANU\\r\\nDUTTA"},{"CODE":"PAPHY506","TITLE":"Solid State Physics","TYPE":"TH","CREDITS":1,"SLOT":"M7+M8","FACULTY":"ATANU\\r\\nDUTTA"},{"CODE":"PAPHY602","TITLE":"Nuclear Physics","TYPE":"TH","CREDITS":3,"SLOT":"I6+N4+R5","FACULTY":"DAYASINDHU\\r\\nDEY"},{"CODE":"PAPHY603","TITLE":"Atomic and Molecular Physics","TYPE":"TH","CREDITS":3,"SLOT":"I5+M6+R2","FACULTY":"MANIKANDA\\r\\nN N"},{"CODE":"PAPHY619","TITLE":"Physics of Nanotechnology","TYPE":"TH","CREDITS":3,"SLOT":"I4+M5+U2","FACULTY":"JOHN\\r\\nKENNEDY  L"},{"CODE":"PCHY625P","TITLE":"General Organic & Inorganic\\r\\nChemistry Lab","TYPE":"TH","CREDITS":2,"SLOT":"I7+I8+I9+I10","FACULTY":"SARAVANAK\\r\\nUMAR R"},{"CODE":"PMDS501L","TITLE":"Applied Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"I4+N3+U7","FACULTY":"SETHUKUMA\\r\\nRASAMY"},{"CODE":"PMDS503L","TITLE":"Statistical Inference","TYPE":"TH","CREDITS":2,"SLOT":"I2+M5","FACULTY":"MANIVANNA\\r\\nN A"},{"CODE":"PMDS504L","TITLE":"Regression Analysis and Predictive Models","TYPE":"TH","CREDITS":3,"SLOT":"N3+R2+U1","FACULTY":"UMA MAHESWARI\\r\\nS"},{"CODE":"PMDS505L","TITLE":"Data Mining and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"I8+R8+U8","FACULTY":"HANNAH\\r\\nGRACE G"},{"CODE":"PMDS605L","TITLE":"Data Structures and Algorithms","TYPE":"TH","CREDITS":3,"SLOT":"I3+N2+U2","FACULTY":"NATHIYA N"},{"CODE":"PMDS606L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"N7+R8+U8","FACULTY":"KALIYAPPAN\\r\\nM"},{"CODE":"PMDS607L","TITLE":"Optimization Techniques","TYPE":"TH","CREDITS":3,"SLOT":"I5+N4+U3","FACULTY":"MANIMARAN\\r\\nJ"},{"CODE":"UACHY101","TITLE":"Environmental Sciences","TYPE":"TH","CREDITS":2,"SLOT":"R3+U2","FACULTY":"SHYAMAPAD\\r\\nA NANDI"},{"CODE":"UAECH203","TITLE":"Mathematics for Economics II","TYPE":"TH","CREDITS":4,"SLOT":"I2+N1+R5+U4","FACULTY":"MUHAMMED NAJEEB K K"},{"CODE":"UCHY101L","TITLE":"Environmental Science","TYPE":"TH","CREDITS":2,"SLOT":"R5+U5","FACULTY":"SUBHAYAN\\r\\nDEY"},{"CODE":"UCHY101L","TITLE":"Environmental Science","TYPE":"TH","CREDITS":2,"SLOT":"R5+U5","FACULTY":"JAYANTA\\r\\nPARUI"},{"CODE":"MACSE505","TITLE":"Deep Learning and Gen AI","TYPE":"TH","CREDITS":3,"SLOT":"I4+M4+N4","FACULTY":"VIJAYAPRABA\\r\\nKARAN K"},{"CODE":"MACSE505","TITLE":"Deep Learning and Gen AI","TYPE":"TH","CREDITS":1,"SLOT":"I7+I8","FACULTY":"VIJAYAPRABA\\r\\nKARAN K"},{"CODE":"MACSE506","TITLE":"Distributed Data Processing","TYPE":"TH","CREDITS":3,"SLOT":"R6+R7+R8","FACULTY":"LTI SCOPE1"},{"CODE":"MACSE506","TITLE":"Distributed Data Processing","TYPE":"TH","CREDITS":1,"SLOT":"R9+R10","FACULTY":"LTI SCOPE1"},{"CODE":"MACSE509","TITLE":"Applied Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"M2+N4+U5","FACULTY":"KHADAR\\r\\nNAWAS K"},{"CODE":"MACSE509","TITLE":"Applied Deep Learning","TYPE":"TH","CREDITS":1,"SLOT":"I5+I6","FACULTY":"KHADAR\\r\\nNAWAS K"},{"CODE":"MACSE510","TITLE":"Generative AI with Large\\r\\nLanguage Models","TYPE":"TH","CREDITS":3,"SLOT":"M6+N3+R6","FACULTY":"JANAKI\\r\\nMEENA M"},{"CODE":"MACSE510","TITLE":"Generative AI with Large\\r\\nLanguage Models","TYPE":"TH","CREDITS":1,"SLOT":"M3+M4","FACULTY":"JANAKI\\r\\nMEENA M"},{"CODE":"MACSE601","TITLE":"Application Architecture and\\r\\nDeployment","TYPE":"TH","CREDITS":3,"SLOT":"R3+R4+R5","FACULTY":"LTI SCOPE1"},{"CODE":"MACSE601","TITLE":"Application Architecture and\\r\\nDeployment","TYPE":"TH","CREDITS":1,"SLOT":"R1+R2","FACULTY":"LTI SCOPE1"},{"CODE":"MACSE604","TITLE":"Edge Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"I5+M3+N7","FACULTY":"RAJESH\\r\\nKUMAR"},{"CODE":"MACSE604","TITLE":"Edge Intelligence","TYPE":"TH","CREDITS":1,"SLOT":"M5+M6","FACULTY":"RAJESH\\r\\nKUMAR"},{"CODE":"MACSE605","TITLE":"Large Language Models","TYPE":"TH","CREDITS":4,"SLOT":"U1+U2+U3+U\\r\\n5","FACULTY":"LTI SCOPE1"},{"CODE":"MACSE609","TITLE":"Security for Data Science","TYPE":"TH","CREDITS":3,"SLOT":"M7+N8+U3","FACULTY":"SRISAKTHI SARAVANAN"},{"CODE":"MACSE611","TITLE":"Healthcare Analytics","TYPE":"TH","CREDITS":3,"SLOT":"I7+M5+N7","FACULTY":"SANGEETHA\\r\\nN"},{"CODE":"UCSC227E","TITLE":"Python Programming","TYPE":"TH","CREDITS":3,"SLOT":"I3+M1+U5","FACULTY":"RENUKA DEVI\\r\\nR"},{"CODE":"UCSC227E","TITLE":"Python Programming","TYPE":"TH","CREDITS":1,"SLOT":"I7+I8","FACULTY":"RENUKA DEVI\\r\\nR"},{"CODE":"HUM1022","TITLE":"Psychology in Everyday Life","TYPE":"TH","CREDITS":2,"SLOT":"I4+M6","FACULTY":"SAROJ K M"},{"CODE":"HUM1022","TITLE":"Psychology in Everyday Life","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"SAROJ K M"},{"CODE":"STS2012","TITLE":"Aptitude and Reasoning Skills","TYPE":"TH","CREDITS":1,"SLOT":"M4+R2+U1","FACULTY":"FACE (APT)"},{"CODE":"UAECH106","TITLE":"Econometrics I","TYPE":"TH","CREDITS":3,"SLOT":"M5+R4+U3","FACULTY":"MALLIKA\\r\\nSINHA"},{"CODE":"UAECH201","TITLE":"Microeconomics II","TYPE":"TH","CREDITS":4,"SLOT":"I5+M3+N4+R3","FACULTY":"SHALINA SUSAN\\r\\nMATHEW"},{"CODE":"UAECH202","TITLE":"Macroeconomics II","TYPE":"TH","CREDITS":4,"SLOT":"I3+M1+N2+U5","FACULTY":"SATHIS\\r\\nKUMAR G"},{"CODE":"UAENG102","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":2,"SLOT":"I1+N2","FACULTY":"AJITH I"},{"CODE":"UAENG102","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":1,"SLOT":"U5+U6","FACULTY":"AJITH I"},{"CODE":"UAENG102","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":2,"SLOT":"M3+R1","FACULTY":"BHUVANESW\\r\\nARI G"},{"CODE":"UAENG102","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":1,"SLOT":"I3+I4","FACULTY":"BHUVANESW\\r\\nARI G"},{"CODE":"UAFRE101","TITLE":"French","TYPE":"TH","CREDITS":3,"SLOT":"I4+M2+N3","FACULTY":"LOKESH\\r\\nBISHNOI"},{"CODE":"UBBH151L","TITLE":"Verbal Reasoning","TYPE":"TH","CREDITS":1,"SLOT":"R3","FACULTY":"PATCHAINAY\\r\\nAGI S"},{"CODE":"UBBH151L","TITLE":"Verbal Reasoning","TYPE":"TH","CREDITS":1,"SLOT":"R3","FACULTY":"CHITHRA G K"},{"CODE":"UBBH151L","TITLE":"Verbal Reasoning","TYPE":"TH","CREDITS":1,"SLOT":"N3","FACULTY":"ALAMELU C"},{"CODE":"UCCH102L","TITLE":"Macro Economics","TYPE":"TH","CREDITS":4,"SLOT":"I3+M1+N2+U5","FACULTY":"MUHAMMED NAJEEB K K"},{"CODE":"UCCH102L","TITLE":"Macro Economics","TYPE":"TH","CREDITS":4,"SLOT":"I3+M1+N2+U5","FACULTY":"URJANI CHAKRAVART\\r\\nY"},{"CODE":"UCSC229E","TITLE":"Structured Query Language (SQL)","TYPE":"TH","CREDITS":3,"SLOT":"I4+M2+N3","FACULTY":"GAYATHRI\\r\\nDEVI S"},{"CODE":"UCSC229E","TITLE":"Structured Query Language (SQL)","TYPE":"TH","CREDITS":1,"SLOT":"N7+N8","FACULTY":"GAYATHRI\\r\\nDEVI S"},{"CODE":"UCSC232E","TITLE":"Analytics with Excel","TYPE":"TH","CREDITS":1,"SLOT":"R5","FACULTY":"SHALINA\\r\\nSUSAN MATHEW"},{"CODE":"UCSC232E","TITLE":"Analytics with Excel","TYPE":"TH","CREDITS":2,"SLOT":"M7+M8+U9+ U10","FACULTY":"SHALINA SUSAN\\r\\nMATHEW"},{"CODE":"UECH206E","TITLE":"Applied Economic Research","TYPE":"TH","CREDITS":1,"SLOT":"U4","FACULTY":"MALLIKA\\r\\nSINHA"},{"CODE":"UECH206E","TITLE":"Applied Economic Research","TYPE":"TH","CREDITS":3,"SLOT":"N1+N2+R1+R2\\r\\n+U7+U8","FACULTY":"MALLIKA\\r\\nSINHA"},{"CODE":"UECH401L","TITLE":"Advanced Research Methods\\r\\nEconomics","TYPE":"TH","CREDITS":4,"SLOT":"M4+N3+R3+U\\r\\n5","FACULTY":"MALLIKA\\r\\nSINHA"},{"CODE":"UECH402L","TITLE":"Economics of Entrepreneurship","TYPE":"TH","CREDITS":4,"SLOT":"I1+M6+R2+U6","FACULTY":"SARADHA\\r\\nRAJKUMAR"},{"CODE":"UECH403L","TITLE":"Economics of Sustainability","TYPE":"TH","CREDITS":4,"SLOT":"I5+M3+N4+R1","FACULTY":"SARADHA\\r\\nRAJKUMAR"},{"CODE":"UECH404E","TITLE":"Primary Data Analyses for\\r\\nEconomics","TYPE":"TH","CREDITS":2,"SLOT":"I4+M5","FACULTY":"MAGULSHA\\r\\nGEORGE"},{"CODE":"UECH404E","TITLE":"Primary Data Analyses for\\r\\nEconomics","TYPE":"TH","CREDITS":2,"SLOT":"R9+R10+U1+U\\r\\n2","FACULTY":"MAGULSHA\\r\\nGEORGE"},{"CODE":"UECH405E","TITLE":"Secondary Data Analyses for\\r\\nEconomics","TYPE":"TH","CREDITS":2,"SLOT":"I3+N2","FACULTY":"JAYARAJ R"},{"CODE":"UECH405E","TITLE":"Secondary Data Analyses for\\r\\nEconomics","TYPE":"TH","CREDITS":2,"SLOT":"M1+M2+R7+R\\r\\n8","FACULTY":"JAYARAJ R"},{"CODE":"UENG104L","TITLE":"Writing Across Context","TYPE":"TH","CREDITS":2,"SLOT":"M2+N3","FACULTY":"PATCHAINAY\\r\\nAGI S"},{"CODE":"UENG104L","TITLE":"Writing Across Context","TYPE":"TH","CREDITS":2,"SLOT":"M2+N3","FACULTY":"CHITHRA G K"},{"CODE":"UENG104L","TITLE":"Writing Across Context","TYPE":"TH","CREDITS":2,"SLOT":"M5+R3","FACULTY":"ALAMELU C"},{"CODE":"UFRE102L","TITLE":"French","TYPE":"TH","CREDITS":3,"SLOT":"I2+N1+U4","FACULTY":"PRIYA SINGH"},{"CODE":"UHUM106E","TITLE":"Data Analysis and Visualization","TYPE":"TH","CREDITS":2,"SLOT":"R4+U3","FACULTY":"URJANI CHAKRAVART\\r\\nY"},{"CODE":"UHUM106E","TITLE":"Data Analysis and Visualization","TYPE":"TH","CREDITS":1,"SLOT":"I1+I2","FACULTY":"URJANI CHAKRAVART\\r\\nY"},{"CODE":"ULAS108L","TITLE":"Gender Studies","TYPE":"TH","CREDITS":4,"SLOT":"M4+N5+R2+U 1","FACULTY":"DEVI\\r\\nMEENAKSHI K"},{"CODE":"ULAS108L","TITLE":"Gender Studies","TYPE":"TH","CREDITS":4,"SLOT":"I5+M3+N4+R1","FACULTY":"SUBBU\\r\\nLAKSHMI M"},{"CODE":"FSD1001","TITLE":"Fibre to Fabric","TYPE":"TH","CREDITS":3,"SLOT":"M2+R6+U3","FACULTY":"S.VINUSOWN\\r\\nDARYA"},{"CODE":"FSD2003","TITLE":"Childrens wear and Womens wear","TYPE":"TH","CREDITS":4,"SLOT":"I1+I2+I3+M1+ M2+M3+N3+\\r\\nN4","FACULTY":"RAJESH KUMAR K"},{"CODE":"FSD2010","TITLE":"Textile Processing and Finishing","TYPE":"TH","CREDITS":3,"SLOT":"I4+M6+R5","FACULTY":"SELVAKUMA\\r\\nR"},{"CODE":"FSD2010","TITLE":"Textile Processing and Finishing","TYPE":"TH","CREDITS":1,"SLOT":"I7+I8","FACULTY":"SELVAKUMA\\r\\nR"},{"CODE":"FSD2020","TITLE":"Psychology of fashion","TYPE":"TH","CREDITS":3,"SLOT":"I6+R3+U5","FACULTY":"BHUVANESH\\r\\nWARI MOHAN"},{"CODE":"FSD2021","TITLE":"Fashion forecasting and trend\\r\\nanalysis","TYPE":"TH","CREDITS":3,"SLOT":"I6+R3+U5","FACULTY":"RAJESH\\r\\nKUMAR K"},{"CODE":"FSD2023","TITLE":"Fashion Photography and\\r\\nmodelling","TYPE":"TH","CREDITS":3,"SLOT":"N1+R1+U2","FACULTY":"JESICA\\r\\nROSHIMA A"},{"CODE":"FSD2023","TITLE":"Fashion Photography and\\r\\nmodelling","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"JESICA\\r\\nROSHIMA A"},{"CODE":"FSD2026","TITLE":"Fashion Marketing and\\r\\nManagement","TYPE":"TH","CREDITS":3,"SLOT":"M5+R4+U6","FACULTY":"S.VINUSOWN\\r\\nDARYA"},{"CODE":"FSD3001","TITLE":"Digital Fashion Illustration","TYPE":"TH","CREDITS":3,"SLOT":"N2+N3+N4+R\\r\\n1+R2+R3","FACULTY":"S.VINUSOWN\\r\\nDARYA"},{"CODE":"FSD3005","TITLE":"Textile and Apparel Testing","TYPE":"TH","CREDITS":2,"SLOT":"N2+U3","FACULTY":"BHUVANESH\\r\\nWARI MOHAN"},{"CODE":"FSD3005","TITLE":"Textile and Apparel Testing","TYPE":"TH","CREDITS":2,"SLOT":"N7+N8+U7+U 8","FACULTY":"BHUVANESH WARI\\r\\nMOHAN"},{"CODE":"UAFSD102","TITLE":"Fashion Narratives","TYPE":"TH","CREDITS":3,"SLOT":"I6+M1+U4","FACULTY":"SAROJ K M"},{"CODE":"UAFSD102","TITLE":"Fashion Narratives","TYPE":"TH","CREDITS":1,"SLOT":"M7+M8","FACULTY":"SAROJ K M"},{"CODE":"UAFSD105","TITLE":"Indian Indigenous Textiles","TYPE":"TH","CREDITS":4,"SLOT":"I1+M2+R2+U1","FACULTY":"BANUMATHY\\r\\nS"},{"CODE":"UAFSD201","TITLE":"Textile Studies II","TYPE":"TH","CREDITS":2,"SLOT":"I2+U3","FACULTY":"RAJA\\r\\nBALASARAS WATHI S"},{"CODE":"UAFSD201","TITLE":"Textile Studies II","TYPE":"TH","CREDITS":2,"SLOT":"N1+N2+N3+N 4","FACULTY":"RAJA BALASARAS\\r\\nWATHI S"},{"CODE":"UAFSD205","TITLE":"Design Studio II: Components Construction and Kids Wear","TYPE":"TH","CREDITS":4,"SLOT":"M4+M5+M6+ R4+R5+R6+U5\\r\\n+U6","FACULTY":"JESICA ROSHIMA A"},{"CODE":"MGT1018","TITLE":"Consumer Behaviour","TYPE":"TH","CREDITS":3,"SLOT":"I5+R6+U4","FACULTY":"BANUMATHY\\r\\nS"},{"CODE":"PAMBA508","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"I5+R6+U6","FACULTY":"REKHAPRIYA DHARSHINI A"},{"CODE":"PAMBA508","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"I4+I5+U5","FACULTY":"SUMATHI G\\r\\nN"},{"CODE":"PAMBA509","TITLE":"Operations Management","TYPE":"TH","CREDITS":3,"SLOT":"I1+M2+N3","FACULTY":"STEPHAN THANGAIAH"},{"CODE":"PAMBA509","TITLE":"Operations Management","TYPE":"TH","CREDITS":3,"SLOT":"I2+M1+N1","FACULTY":"JOSEPH JEYA ANAND  S"},{"CODE":"PAMBA510","TITLE":"Business Research Methods","TYPE":"TH","CREDITS":3,"SLOT":"I1+M2+N3","FACULTY":"THANGARAJA ARUMUGAM"},{"CODE":"PAMBA510","TITLE":"Business Research Methods","TYPE":"TH","CREDITS":3,"SLOT":"I3+M4+N2","FACULTY":"REEVES\\r\\nWESLEY J"},{"CODE":"PAMBA511","TITLE":"Financial Management","TYPE":"TH","CREDITS":3,"SLOT":"I4+R5+U5","FACULTY":"SHARON\\r\\nSOPHIA"},{"CODE":"PAMBA511","TITLE":"Financial Management","TYPE":"TH","CREDITS":3,"SLOT":"I3+M4+U6","FACULTY":"MARIA\\r\\nEVELYN JUCUNDA M"},{"CODE":"PAMBA512","TITLE":"Business Analytics","TYPE":"TH","CREDITS":2,"SLOT":"M5+M6","FACULTY":"PADMAVATH\\r\\nY C"},{"CODE":"PAMBA512","TITLE":"Business Analytics","TYPE":"TH","CREDITS":1,"SLOT":"R1+R2","FACULTY":"PADMAVATH\\r\\nY C"},{"CODE":"PAMBA512","TITLE":"Business Analytics","TYPE":"TH","CREDITS":2,"SLOT":"N7+N8","FACULTY":"ASI VASU DEVA REDDY"},{"CODE":"PAMBA512","TITLE":"Business Analytics","TYPE":"TH","CREDITS":1,"SLOT":"M7+M8","FACULTY":"ASI VASU DEVA REDDY"},{"CODE":"PAMBA513","TITLE":"Strategic Management and\\r\\nSustainable Business","TYPE":"TH","CREDITS":3,"SLOT":"N4+R4+U4","FACULTY":"SAJU B"},{"CODE":"PAMBA513","TITLE":"Strategic Management and Sustainable Business","TYPE":"TH","CREDITS":3,"SLOT":"I7+M6+U8","FACULTY":"STEPHAN THANGAIAH"},{"CODE":"PAMBA514","TITLE":"Entrepreneurship and Design\\r\\nThinking","TYPE":"TH","CREDITS":3,"SLOT":"I7+M3+R8","FACULTY":"SUJATHA\\r\\nMANOHAR"},{"CODE":"PAMBA514","TITLE":"Entrepreneurship and Design\\r\\nThinking","TYPE":"TH","CREDITS":3,"SLOT":"I6+M3+U7","FACULTY":"S DIVYA"},{"CODE":"UBBH104L","TITLE":"Business Law and Ethics","TYPE":"TH","CREDITS":4,"SLOT":"I6+I9+M8+U9","FACULTY":"CHITRA DEVI\\r\\nA"},{"CODE":"UBBH104L","TITLE":"Business Law and Ethics","TYPE":"TH","CREDITS":4,"SLOT":"I8+M9+N5+U8","FACULTY":"CHITRA DEVI\\r\\nA"},{"CODE":"UBBH106L","TITLE":"Management Accounting","TYPE":"TH","CREDITS":4,"SLOT":"N7+R9+U4+U\\r\\n8","FACULTY":"CHITRA DEVI\\r\\nN"},{"CODE":"UBBH106L","TITLE":"Management Accounting","TYPE":"TH","CREDITS":4,"SLOT":"I5+M7+N9+U7","FACULTY":"SREEYA B"},{"CODE":"UBBH107L","TITLE":"Macro Economics","TYPE":"TH","CREDITS":4,"SLOT":"I1+M6+R4+U3","FACULTY":"ALLI P"},{"CODE":"UBBH107L","TITLE":"Macro Economics","TYPE":"TH","CREDITS":4,"SLOT":"I1+M6+R4+U3","FACULTY":"JAYARAJ R"},{"CODE":"UBBH152L","TITLE":"Quantitative Reasoning","TYPE":"TH","CREDITS":1,"SLOT":"N5","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"UBBH152L","TITLE":"Quantitative Reasoning","TYPE":"TH","CREDITS":1,"SLOT":"N5","FACULTY":"FACE (APT)"},{"CODE":"UBBH158P","TITLE":"Equity Market Analytics","TYPE":"TH","CREDITS":1,"SLOT":"U1+U2","FACULTY":"SREEYA B"},{"CODE":"UBBH158P","TITLE":"Equity Market Analytics","TYPE":"TH","CREDITS":1,"SLOT":"N1+N2","FACULTY":"SREEYA B"},{"CODE":"UBBH158P","TITLE":"Equity Market Analytics","TYPE":"TH","CREDITS":1,"SLOT":"I3+I4","FACULTY":"BUVANESH C"},{"CODE":"UBBH158P","TITLE":"Equity Market Analytics","TYPE":"TH","CREDITS":1,"SLOT":"R5+R6","FACULTY":"MARIA EVELYN\\r\\nJUCUNDA M"},{"CODE":"UBBH206E","TITLE":"Business Analytics & AI","TYPE":"TH","CREDITS":3,"SLOT":"M3+N4+R1","FACULTY":"REEVES\\r\\nWESLEY J"},{"CODE":"UBBH206E","TITLE":"Business Analytics & AI","TYPE":"TH","CREDITS":1,"SLOT":"U5+U6","FACULTY":"REEVES\\r\\nWESLEY J"},{"CODE":"UBBH206E","TITLE":"Business Analytics & AI","TYPE":"TH","CREDITS":3,"SLOT":"I4+M4+U1","FACULTY":"ANU C H"},{"CODE":"UBBH206E","TITLE":"Business Analytics & AI","TYPE":"TH","CREDITS":1,"SLOT":"U3+U4","FACULTY":"ANU C H"},{"CODE":"UBBH208L","TITLE":"Managing People & Teams at\\r\\nWork","TYPE":"TH","CREDITS":4,"SLOT":"I6+M2+N2+U4","FACULTY":"NISHA R"},{"CODE":"UBBH209L","TITLE":"Managing Innovation","TYPE":"TH","CREDITS":4,"SLOT":"I7+I8+M1+M2","FACULTY":"TISHA MERIAM\\r\\nCHERIAN"},{"CODE":"UBBH213L","TITLE":"Brand Strategies","TYPE":"TH","CREDITS":4,"SLOT":"I7+M1+M7+R 9","FACULTY":"MALAY BHATTACHAR\\r\\nJEE"},{"CODE":"UBBH214L","TITLE":"Digital and Social Media Marketing","TYPE":"TH","CREDITS":4,"SLOT":"I6+M2+N2+U4","FACULTY":"SUDHEER MUHAMMED\\r\\nK M"},{"CODE":"UBBH217E","TITLE":"Advanced Statistics for Data\\r\\nScience","TYPE":"TH","CREDITS":3,"SLOT":"M8+N9+U8","FACULTY":"ANBUMATHI\\r\\nR"},{"CODE":"UBBH217E","TITLE":"Advanced Statistics for Data\\r\\nScience","TYPE":"TH","CREDITS":1,"SLOT":"M5+M6","FACULTY":"ANBUMATHI\\r\\nR"},{"CODE":"UBBH218E","TITLE":"Programming in Python","TYPE":"TH","CREDITS":3,"SLOT":"I1+I2+U7","FACULTY":"BHARATH\\r\\nSANKAR S"},{"CODE":"UBBH218E","TITLE":"Programming in Python","TYPE":"TH","CREDITS":1,"SLOT":"R7+R8","FACULTY":"BHARATH\\r\\nSANKAR S"},{"CODE":"UBBH301L","TITLE":"Strategic Management","TYPE":"TH","CREDITS":4,"SLOT":"I2+M1+N2+U6","FACULTY":"RAJKUMAR MURUGESAN"},{"CODE":"UBBH302L","TITLE":"Business Research Methods","TYPE":"TH","CREDITS":4,"SLOT":"M4+M5+N4+ N5","FACULTY":"ASI VASU DEVA REDDY"},{"CODE":"UBBH303L","TITLE":"Entrepreneurship","TYPE":"TH","CREDITS":4,"SLOT":"I3+N3+R3+U1","FACULTY":"SUJATHA\\r\\nMANOHAR"},{"CODE":"UBBH304L","TITLE":"Global Business Environment","TYPE":"TH","CREDITS":4,"SLOT":"I4+M8+R5+U5","FACULTY":"JOSEPH JEYA ANAND  S"},{"CODE":"UBBH321L","TITLE":"Application of Mathematics in Business","TYPE":"TH","CREDITS":4,"SLOT":"I5+M7+N9+U7","FACULTY":"TISHA MERIAM\\r\\nCHERIAN"},{"CODE":"UBBH321L","TITLE":"Application of Mathematics in Business","TYPE":"TH","CREDITS":4,"SLOT":"I4+M8+R8+R9","FACULTY":"TISHA MERIAM\\r\\nCHERIAN"},{"CODE":"UBBH497J","TITLE":"Co-Op","TYPE":"TH","CREDITS":8,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"UCCH104L","TITLE":"Business Laws","TYPE":"TH","CREDITS":4,"SLOT":"I1+M6+N6+U2","FACULTY":"BHAVANI J"},{"CODE":"UCCH104L","TITLE":"Business Laws","TYPE":"TH","CREDITS":4,"SLOT":"I5+M7+N1+R5","FACULTY":"BHAVANI J"},{"CODE":"UCCH107L","TITLE":"Corporate Accounting","TYPE":"TH","CREDITS":4,"SLOT":"I2+N1+R5+U4","FACULTY":"SIVAKUMAR\\r\\nK"},{"CODE":"UCCH107L","TITLE":"Corporate Accounting","TYPE":"TH","CREDITS":4,"SLOT":"I1+M6+N6+U2","FACULTY":"SIVAKUMAR\\r\\nK"},{"CODE":"UCCH202L","TITLE":"Cost Accounting","TYPE":"TH","CREDITS":4,"SLOT":"I5+M7+N9+U7","FACULTY":"WASI\\r\\nYAZDANI"},{"CODE":"UCCH202L","TITLE":"Cost Accounting","TYPE":"TH","CREDITS":4,"SLOT":"I9+N8+R9+U3","FACULTY":"RAJESH A D J"},{"CODE":"UCCH205L","TITLE":"Marketing Management","TYPE":"TH","CREDITS":4,"SLOT":"I1+M6+N8+R4","FACULTY":"SUDHEER\\r\\nMUHAMMED K M"},{"CODE":"UCCH205L","TITLE":"Marketing Management","TYPE":"TH","CREDITS":4,"SLOT":"N4+R8+U5+U 8","FACULTY":"ARSHIYA FATHIMA M\\r\\nS"},{"CODE":"UCCH206L","TITLE":"Investment Analysis and\\r\\nPortfolio Management","TYPE":"TH","CREDITS":4,"SLOT":"M3+N7+R7+U\\r\\n9","FACULTY":"SIVAKUMAR\\r\\nK"},{"CODE":"UCCH206L","TITLE":"Investment Analysis and\\r\\nPortfolio Management","TYPE":"TH","CREDITS":4,"SLOT":"I2+M1+N2+U6","FACULTY":"CHITRA DEVI\\r\\nN"},{"CODE":"UCCH208L","TITLE":"Financial Statement Analysis and\\r\\nReporting","TYPE":"TH","CREDITS":4,"SLOT":"I2+M2+R2+U7","FACULTY":"MANU JOSE"},{"CODE":"UCCH214L","TITLE":"Auditing and Corporate\\r\\nGovernance","TYPE":"TH","CREDITS":4,"SLOT":"I5+M7+N1+R5","FACULTY":"MEENAKSHI\\r\\nSANKARAN"},{"CODE":"UCCH214L","TITLE":"Auditing and Corporate\\r\\nGovernance","TYPE":"TH","CREDITS":4,"SLOT":"I3+M1+R1+U4","FACULTY":"MEENAKSHI\\r\\nSANKARAN"},{"CODE":"UCCH301L","TITLE":"Business Research Methods","TYPE":"TH","CREDITS":4,"SLOT":"I4+M4+R4+U1","FACULTY":"BHAVANI J"},{"CODE":"UCCH302L","TITLE":"Strategic Management","TYPE":"TH","CREDITS":4,"SLOT":"I1+M7+R3+U3","FACULTY":"RAJKUMAR MURUGESAN"},{"CODE":"UCCH303L","TITLE":"Operations Management","TYPE":"TH","CREDITS":4,"SLOT":"I5+M3+N4+R1","FACULTY":"WAQAS NIAZI"},{"CODE":"UCCH304L","TITLE":"FinTech","TYPE":"TH","CREDITS":4,"SLOT":"M5+N9+R7+U\\r\\n2","FACULTY":"MEENAKSHI\\r\\nSANKARAN"},{"CODE":"UCCH305L","TITLE":"Entrepreneurship","TYPE":"TH","CREDITS":4,"SLOT":"I2+N1+R5+U4","FACULTY":"MEKHALA\\r\\nANTONY"},{"CODE":"UCCH497J","TITLE":"Co-Op","TYPE":"TH","CREDITS":8,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"UCSC214E","TITLE":"Basic Data Visualization","TYPE":"TH","CREDITS":1,"SLOT":"N7","FACULTY":"ARSHIYA FATHIMA M\\r\\nS"},{"CODE":"UCSC214E","TITLE":"Basic Data Visualization","TYPE":"TH","CREDITS":2,"SLOT":"I3+I4+M3+M4","FACULTY":"ARSHIYA FATHIMA M\\r\\nS"},{"CODE":"UCSC214E","TITLE":"Basic Data Visualization","TYPE":"TH","CREDITS":1,"SLOT":"U2","FACULTY":"KISHORE THOMAS\\r\\nJOHN"},{"CODE":"UCSC214E","TITLE":"Basic Data Visualization","TYPE":"TH","CREDITS":2,"SLOT":"I5+I6+M5+M6","FACULTY":"KISHORE\\r\\nTHOMAS JOHN"},{"CODE":"UCSC214E","TITLE":"Basic Data Visualization","TYPE":"TH","CREDITS":1,"SLOT":"I5","FACULTY":"ANU C H"},{"CODE":"UCSC214E","TITLE":"Basic Data Visualization","TYPE":"TH","CREDITS":2,"SLOT":"N7+N8+R5+R6","FACULTY":"ANU C H"},{"CODE":"UECH211L","TITLE":"Security Analysis and Portfolio\\r\\nManagement","TYPE":"TH","CREDITS":4,"SLOT":"I6+M5+R3+U2","FACULTY":"SHARON\\r\\nSOPHIA"},{"CODE":"ULAS106L","TITLE":"Sociology","TYPE":"TH","CREDITS":4,"SLOT":"M4+N5+R2+U\\r\\n1","FACULTY":"FARSANA KP"},{"CODE":"UABVI105","TITLE":"Scripting and Storyboarding","TYPE":"TH","CREDITS":4,"SLOT":"R5+R6","FACULTY":"SITHARA P V"},{"CODE":"UABVI105","TITLE":"Scripting and Storyboarding","TYPE":"TH","CREDITS":4,"SLOT":"I5+I6+M5+M6","FACULTY":"SITHARA P V"},{"CODE":"UABVI106","TITLE":"Photography","TYPE":"TH","CREDITS":4,"SLOT":"R3+R4","FACULTY":"PADMANABH\\r\\nAN T"},{"CODE":"UABVI106","TITLE":"Photography","TYPE":"TH","CREDITS":4,"SLOT":"M1+M2+N7+\\r\\nN8","FACULTY":"PADMANABH\\r\\nAN T"},{"CODE":"UABVI107","TITLE":"Visual Arts","TYPE":"TH","CREDITS":4,"SLOT":"U1+U2","FACULTY":"SITHARA P V"},{"CODE":"UABVI107","TITLE":"Visual Arts","TYPE":"TH","CREDITS":4,"SLOT":"M3+M4+R1+R\\r\\n2","FACULTY":"SITHARA P V"},{"CODE":"UAMMA10","TITLE":"Character and Environmental\\r\\nDesign","TYPE":"TH","CREDITS":4,"SLOT":"R5+R6","FACULTY":"THOMAS\\r\\nSMILES K"},{"CODE":"UAMMA10","TITLE":"Character and Environmental\\r\\nDesign","TYPE":"TH","CREDITS":4,"SLOT":"I5+I6+M5+M6","FACULTY":"THOMAS\\r\\nSMILES K"},{"CODE":"UAMMA10","TITLE":"Graphic Design I","TYPE":"TH","CREDITS":4,"SLOT":"U1+U2","FACULTY":"THOMAS\\r\\nSMILES K"},{"CODE":"UAMMA10","TITLE":"Graphic Design I","TYPE":"TH","CREDITS":4,"SLOT":"M1+M2+R1+R\\r\\n2","FACULTY":"THOMAS\\r\\nSMILES K"},{"CODE":"UAMMA10","TITLE":"Photography","TYPE":"TH","CREDITS":4,"SLOT":"M7+M8","FACULTY":"GAYATHRI V"},{"CODE":"UAMMA10","TITLE":"Photography","TYPE":"TH","CREDITS":4,"SLOT":"R7+R8+U7+U8","FACULTY":"GAYATHRI V"},{"CODE":"UAMMA10","TITLE":"Scripting and Storyboarding","TYPE":"TH","CREDITS":4,"SLOT":"M3+M4","FACULTY":"GAYATHRI V"},{"CODE":"UAMMA10","TITLE":"Scripting and Storyboarding","TYPE":"TH","CREDITS":4,"SLOT":"I7+I8+R3+R4","FACULTY":"GAYATHRI V"},{"CODE":"TESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"SLOT":"TCCC+TDDD","FACULTY":"SAVARIAH\\r\\nXAVIER Y C"},{"CODE":"TESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"SLOT":"TCCC+TDDD","FACULTY":"SHALINI\\r\\nSUPRIYA"},{"CODE":"TESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"SLOT":"TCCC+TDDD","FACULTY":"TRISHA"},{"CODE":"TFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"TCCC+TDDD","FACULTY":"INL-\\r\\nFRENCH01"},{"CODE":"TFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"TCCC+TDDD","FACULTY":"FOREIN LANGUAGE -\\r\\nFRENCH 3"},{"CODE":"TLAW103L","TITLE":"Law of Contracts","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"KESAVAMOO\\r\\nRTHY R"},{"CODE":"TLAW103L","TITLE":"Law of Contracts","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"LALITH\\r\\nKUMAR J"},{"CODE":"TLAW103L","TITLE":"Law of Contracts","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"SHARMILA M\\r\\nS"},{"CODE":"TLAW103L","TITLE":"Law of Contracts","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"DULUNG\\r\\nSENGUPTA"},{"CODE":"TLAW103L","TITLE":"Law of Contracts","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"SWARLATA\\r\\nPANDEY"},{"CODE":"TLAW104L","TITLE":"Environmental Law","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"RESHMA\\r\\nSURESH"},{"CODE":"TLAW104L","TITLE":"Environmental Law","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"SHINSA P\\r\\nMATHEW"},{"CODE":"TLAW104L","TITLE":"Environmental Law","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"SWARLATA\\r\\nPANDEY"},{"CODE":"TLAW104L","TITLE":"Environmental Law","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"CHANDRIKA\\r\\nMEHTA"},{"CODE":"TLAW161L","TITLE":"Colonialism in India","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"SHASHIKANT\\r\\nSAURAV"},{"CODE":"TLAW161L","TITLE":"Colonialism in India","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"BILAL A\\r\\nNAZEER"},{"CODE":"TLAW162L","TITLE":"Principles of Modern\\r\\nGovernment","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"GOKUL K S"},{"CODE":"TLAW162L","TITLE":"Principles of Modern\\r\\nGovernment","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"GOKUL K S"},{"CODE":"TLAW182L","TITLE":"English for Lawyers","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"S VIJAYALAKSH\\r\\nMI"},{"CODE":"TLAW182L","TITLE":"English for Lawyers","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"VINEETH\\r\\nRADHAKRISH NAN"},{"CODE":"TLAW182L","TITLE":"English for Lawyers","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"VINEETH\\r\\nRADHAKRISH NAN"},{"CODE":"TLAW182L","TITLE":"English for Lawyers","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"LUKE GERARD\\r\\nCHRISTIE"},{"CODE":"TLAW182L","TITLE":"English for Lawyers","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"LUKE\\r\\nGERARD CHRISTIE"},{"CODE":"TLAW184L","TITLE":"Financial Management","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"WASI\\r\\nYAZDANI"},{"CODE":"TLAW184L","TITLE":"Financial Management","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"MOHD\\r\\nNADEEM BHAT"},{"CODE":"TLAW184L","TITLE":"Financial Management","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"CARLIN JEMIMAH G J"},{"CODE":"TLAW188L","TITLE":"Financial Accounting","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"WASI\\r\\nYAZDANI"},{"CODE":"TLAW188L","TITLE":"Financial Accounting","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"MOHD NADEEM\\r\\nBHAT"},{"CODE":"TLAW188L","TITLE":"Financial Accounting","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"RAJA SINGH"},{"CODE":"TLAW202L","TITLE":"Law of Crimes- I","TYPE":"TH","CREDITS":4,"SLOT":"E+TE","FACULTY":"ASWATHY SUKUMARAN"},{"CODE":"TLAW202L","TITLE":"Law of Crimes- I","TYPE":"TH","CREDITS":4,"SLOT":"E+TE","FACULTY":"ABHISHEK\\r\\nRAJ"},{"CODE":"TLAW202L","TITLE":"Law of Crimes- I","TYPE":"TH","CREDITS":4,"SLOT":"E+TE","FACULTY":"GANESAN K"},{"CODE":"TLAW202L","TITLE":"Law of Crimes- I","TYPE":"TH","CREDITS":4,"SLOT":"E+TE","FACULTY":"BIJOY\\r\\nSHARMA"},{"CODE":"TLAW202L","TITLE":"Law of Crimes- I","TYPE":"TH","CREDITS":4,"SLOT":"E+TE","FACULTY":"RESHMA\\r\\nSURESH"},{"CODE":"TLAW206L","TITLE":"Labour and Industrial Law I","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"VIJAYENDRA\\r\\nKUMAR M"},{"CODE":"TLAW206L","TITLE":"Labour and Industrial Law I","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"KOWSHIKAA\\r\\nA S"},{"CODE":"TLAW206L","TITLE":"Labour and Industrial Law I","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"MANJARI\\r\\nSUGIRTHA A"},{"CODE":"TLAW206L","TITLE":"Labour and Industrial Law I","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"BERTILA A"},{"CODE":"TLAW206L","TITLE":"Labour and Industrial Law I","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"POURNA\\r\\nDHEVI N"},{"CODE":"TLAW207L","TITLE":"Jurisprudence","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"ZAKKARIYA T\\r\\nH"},{"CODE":"TLAW207L","TITLE":"Jurisprudence","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"MRUDHUL M\\r\\nSHENOY"},{"CODE":"TLAW207L","TITLE":"Jurisprudence","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"SHANTHI\\r\\nKRISHNA"},{"CODE":"TLAW207L","TITLE":"Jurisprudence","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"ADITYA S"},{"CODE":"TLAW207L","TITLE":"Jurisprudence","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"ARJUN PHILIP GEORGE"},{"CODE":"TLAW261L","TITLE":"Political Thought: Indian and\\r\\nWestern","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"APD"},{"CODE":"TLAW261L","TITLE":"Political Thought: Indian and\\r\\nWestern","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"APD"},{"CODE":"TLAW262L","TITLE":"Public Finance Theory and\\r\\nPractice","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"ARUNA R"},{"CODE":"TLAW262L","TITLE":"Public Finance Theory and\\r\\nPractice","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"ARUNA R"},{"CODE":"TLAW263L","TITLE":"Law and Social Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"SANTHOSH  V"},{"CODE":"TLAW263L","TITLE":"Law and Social Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"KUMAR\\r\\nMUKUL CHOUDHARY"},{"CODE":"TLAW264L","TITLE":"Public Administration","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"RAJEESH C S"},{"CODE":"TLAW264L","TITLE":"Public Administration","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"RAJEESH C S"},{"CODE":"TLAW281L","TITLE":"Operational Research","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"VADIVEL S M"},{"CODE":"TLAW281L","TITLE":"Operational Research","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"WAQAS NIAZI"},{"CODE":"TLAW281L","TITLE":"Operational Research","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"RIJAS B M"},{"CODE":"TLAW283L","TITLE":"Marketing Management","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"ANU C H"},{"CODE":"TLAW283L","TITLE":"Marketing Management","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"SUDHEER\\r\\nMUHAMMED K M"},{"CODE":"TLAW283L","TITLE":"Marketing Management","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"MALAY\\r\\nBHATTACHAR JEE"},{"CODE":"TLAW284L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"SRILALITHA R"},{"CODE":"TLAW284L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"PRIYADHARS\\r\\nHINI V"},{"CODE":"TLAW284L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"BHARATH\\r\\nSANKAR S"},{"CODE":"TLAW303L","TITLE":"Family Law-II","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"AMBIKA R\\r\\nNAIR"},{"CODE":"TLAW303L","TITLE":"Family Law-II","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"P C ABIRAMI"},{"CODE":"TLAW303L","TITLE":"Family Law-II","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"ESAKKI\\r\\nAMMAL K"},{"CODE":"TLAW303L","TITLE":"Family Law-II","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"VIJAYENDRA\\r\\nKUMAR M"},{"CODE":"TLAW303L","TITLE":"Family Law-II","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"KUMAR MUKUL CHOUDHARY"},{"CODE":"TLAW305L","TITLE":"Public International Law","TYPE":"TH","CREDITS":3,"SLOT":"F+TF","FACULTY":"PREMA E"},{"CODE":"TLAW305L","TITLE":"Public International Law","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"PREMA E"},{"CODE":"TLAW305L","TITLE":"Public International Law","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"K KAMBAN\\r\\nSOCRETES"},{"CODE":"TLAW305L","TITLE":"Public International Law","TYPE":"TH","CREDITS":3,"SLOT":"F+TF","FACULTY":"SEZOLU\\r\\nNYEKHA"},{"CODE":"TLAW305L","TITLE":"Public International Law","TYPE":"TH","CREDITS":3,"SLOT":"C+TC","FACULTY":"KAVI\\r\\nSHANKAR"},{"CODE":"TLAW305L","TITLE":"Public International Law","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SEZOLU\\r\\nNYEKHA"},{"CODE":"TLAW305L","TITLE":"Public International Law","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"KAVI\\r\\nSHANKAR"},{"CODE":"TLAW305L","TITLE":"Public International Law","TYPE":"TH","CREDITS":3,"SLOT":"C+TC","FACULTY":"K KAMBAN\\r\\nSOCRETES"},{"CODE":"TLAW307L","TITLE":"Property Law","TYPE":"TH","CREDITS":3,"SLOT":"E+TE","FACULTY":"AMBIKA R\\r\\nNAIR"},{"CODE":"TLAW307L","TITLE":"Property Law","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"AMBIKA R\\r\\nNAIR"},{"CODE":"TLAW307L","TITLE":"Property Law","TYPE":"TH","CREDITS":3,"SLOT":"E+TE","FACULTY":"P C ABIRAMI"},{"CODE":"TLAW307L","TITLE":"Property Law","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"P C ABIRAMI"},{"CODE":"TLAW307L","TITLE":"Property Law","TYPE":"TH","CREDITS":3,"SLOT":"E+TE","FACULTY":"ESAKKI\\r\\nAMMAL K"},{"CODE":"TLAW307L","TITLE":"Property Law","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"ESAKKI\\r\\nAMMAL K"},{"CODE":"TLAW307L","TITLE":"Property Law","TYPE":"TH","CREDITS":3,"SLOT":"E+TE","FACULTY":"SHANTHI\\r\\nKRISHNA"},{"CODE":"TLAW307L","TITLE":"Property Law","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SHANTHI\\r\\nKRISHNA"},{"CODE":"TLAW310L","TITLE":"Professional Ethics and\\r\\nProfessional Accounting for Lawyers","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"NIKHIL G"},{"CODE":"TLAW310L","TITLE":"Professional Ethics and Professional Accounting for\\r\\nLawyers","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"SANTHOSH  V"},{"CODE":"TLAW310L","TITLE":"Professional Ethics and Professional Accounting for\\r\\nLawyers","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"NAVYA BENNY"},{"CODE":"TLAW310L","TITLE":"Professional Ethics and\\r\\nProfessional Accounting for Lawyers","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"KOWSHIKAA A S"},{"CODE":"TLAW311L","TITLE":"Intellectual Property Law","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"TANIA\\r\\nSEBASTIAN"},{"CODE":"TLAW311L","TITLE":"Intellectual Property Law","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"VIJAYA BHARATHI RAVIKUMAR"},{"CODE":"TLAW311L","TITLE":"Intellectual Property Law","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SAIJI J S"},{"CODE":"TLAW311L","TITLE":"Intellectual Property Law","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"RAJAVENKAT\\r\\nESAN P R L"},{"CODE":"TLAW311L","TITLE":"Intellectual Property Law","TYPE":"TH","CREDITS":3,"SLOT":"A+TA","FACULTY":"TANIA\\r\\nSEBASTIAN"},{"CODE":"TLAW311L","TITLE":"Intellectual Property Law","TYPE":"TH","CREDITS":3,"SLOT":"A+TA","FACULTY":"VIJAYA BHARATHI RAVIKUMAR"},{"CODE":"TLAW311L","TITLE":"Intellectual Property Law","TYPE":"TH","CREDITS":3,"SLOT":"A+TA","FACULTY":"SAIJI J S"},{"CODE":"TLAW311L","TITLE":"Intellectual Property Law","TYPE":"TH","CREDITS":3,"SLOT":"A+TA","FACULTY":"RAJAVENKAT\\r\\nESAN P R L"},{"CODE":"TLAW404L","TITLE":"Comparative Constitutional Law","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"K KAMBAN\\r\\nSOCRETES"},{"CODE":"TLAW407L","TITLE":"Right to Information","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"SAJI SIVAN S"},{"CODE":"TLAW409L","TITLE":"Media and Law","TYPE":"TH","CREDITS":3,"SLOT":"C+TC","FACULTY":"ARJUN SHAJI"},{"CODE":"TLAW409L","TITLE":"Media and Law","TYPE":"LO","CREDITS":1,"SLOT":"L30+L31","FACULTY":"ARJUN SHAJI"},{"CODE":"TLAW412L","TITLE":"Introduction to International\\r\\nHumanitarian Law","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"SONY RAJ S S"},{"CODE":"TLAW413L","TITLE":"Law Relating to WTO","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"KAVI\\r\\nSHANKAR"},{"CODE":"TLAW416L","TITLE":"Law of the Sea","TYPE":"TH","CREDITS":3,"SLOT":"A+TA","FACULTY":"SEZOLU\\r\\nNYEKHA"},{"CODE":"TLAW416L","TITLE":"Law of the Sea","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SEZOLU\\r\\nNYEKHA"},{"CODE":"TLAW418L","TITLE":"International Refugee Law","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"AYUSHI SRIVASTAVA"},{"CODE":"TLAW420L","TITLE":"Patenting of Life Forms","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"VIJAYA BHARATHI RAVIKUMAR"},{"CODE":"TLAW423L","TITLE":"IPR in Pharma Industry","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"JISHNU J R"},{"CODE":"TLAW424L","TITLE":"Banking Law","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"K NIDHI\\r\\nMOHAN"},{"CODE":"TLAW427L","TITLE":"Insurance Law","TYPE":"TH","CREDITS":3,"SLOT":"C+TC","FACULTY":"ANKIT\\r\\nANAND"},{"CODE":"TLAW427L","TITLE":"Insurance Law","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"ANKIT\\r\\nANAND"},{"CODE":"TLAW428L","TITLE":"Insolvency and Bankruptcy","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"K NIDHI\\r\\nMOHAN"},{"CODE":"TLAW430L","TITLE":"Corporate Governance","TYPE":"TH","CREDITS":3,"SLOT":"C+TC","FACULTY":"JAYENDRA\\r\\nKASTURE"},{"CODE":"TLAW430L","TITLE":"Corporate Governance","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"JAYENDRA\\r\\nKASTURE"},{"CODE":"TLAW431L","TITLE":"Competition Law","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"DULUNG\\r\\nSENGUPTA"},{"CODE":"TLAW432L","TITLE":"Equity and Trust","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"JAYENDRA\\r\\nKASTURE"},{"CODE":"TLAW435L","TITLE":"Prison Administration","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"SAJI SIVAN S"},{"CODE":"TLAW437L","TITLE":"Penology and Victimology","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"GANESAN K"},{"CODE":"TLAW441L","TITLE":"Financial and Systemic Fraud","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"TANMAY ROY"},{"CODE":"TLAW444L","TITLE":"Technology and Law","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"ADITYA S"},{"CODE":"TLAW445L","TITLE":"International Taxation Law","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"VANMATHI\\r\\nM"},{"CODE":"TLAW446L","TITLE":"Business Ethics and Human\\r\\nRights","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"POURNA\\r\\nDHEVI N"},{"CODE":"TLAW446L","TITLE":"Business Ethics and Human\\r\\nRights","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"HELEN P\\r\\nAZYU"},{"CODE":"TLAW446L","TITLE":"Business Ethics and Human\\r\\nRights","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"SHERIN\\r\\nPRIYAN"},{"CODE":"TLAW448L","TITLE":"Indian Legal System","TYPE":"TH","CREDITS":4,"SLOT":"E+TE+TEE","FACULTY":"TANMAY ROY"},{"CODE":"TLAW448L","TITLE":"Indian Legal System","TYPE":"TH","CREDITS":4,"SLOT":"E+TE+TEE","FACULTY":"MANJARI\\r\\nSUGIRTHA A"},{"CODE":"TLAW448L","TITLE":"Indian Legal System","TYPE":"TH","CREDITS":4,"SLOT":"E+TE+TEE","FACULTY":"VANMATHI\\r\\nM"},{"CODE":"TLAW448L","TITLE":"Indian Legal System","TYPE":"TH","CREDITS":4,"SLOT":"E+TE+TEE","FACULTY":"AYUSHI SRIVASTAVA"},{"CODE":"TLAW448L","TITLE":"Indian Legal System","TYPE":"TH","CREDITS":4,"SLOT":"E+TE+TEE","FACULTY":"BERTILA A"},{"CODE":"TLAW452L","TITLE":"Election Law","TYPE":"TH","CREDITS":4,"SLOT":"E+TE+TEE","FACULTY":"MRUDHUL M\\r\\nSHENOY"},{"CODE":"TLAW501L","TITLE":"Sports Law","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"NIKHIL G"},{"CODE":"TLAW502L","TITLE":"Women and Law","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"NAVYA\\r\\nBENNY"},{"CODE":"TLAW503L","TITLE":"Gender, Caste and the Law","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"ASWATHY SUKUMARAN"},{"CODE":"TLAW504L","TITLE":"Rural Governance","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"SHASHIKANT\\r\\nSAURAV"},{"CODE":"TLAW505L","TITLE":"Criminal Justice and Human\\r\\nRights","TYPE":"TH","CREDITS":3,"SLOT":"D+TD","FACULTY":"ABHISHEK\\r\\nRAJ"},{"CODE":"TLAW505L","TITLE":"Criminal Justice and Human\\r\\nRights","TYPE":"LO","CREDITS":1,"SLOT":"L34+L35","FACULTY":"ABHISHEK\\r\\nRAJ"},{"CODE":"TLAW509L","TITLE":"Scientific Evidence in Criminal\\r\\nTrial","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"BIJOY\\r\\nSHARMA"},{"CODE":"TLAW517L","TITLE":"Constitutional Interpretation and Social  Justice","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"ARJUN PHILIP GEORGE"},{"CODE":"TLAW519L","TITLE":"Capital Markets and Securities\\r\\nLaw","TYPE":"TH","CREDITS":3,"SLOT":"E+TE","FACULTY":"POOJA"},{"CODE":"TLAW519L","TITLE":"Capital Markets and Securities\\r\\nLaw","TYPE":"LO","CREDITS":1,"SLOT":"L34+L35","FACULTY":"POOJA"},{"CODE":"TLAW520L","TITLE":"International Commercial\\r\\nArbitration","TYPE":"TH","CREDITS":4,"SLOT":"E+TE+TEE","FACULTY":"ANKIT\\r\\nANAND"},{"CODE":"TLAW522L","TITLE":"Patent Drafting and Specification\\r\\nWriting","TYPE":"TH","CREDITS":4,"SLOT":"E+TE+TEE","FACULTY":"CHANDRIKA\\r\\nMEHTA"},{"CODE":"TLAW523L","TITLE":"Cyber Law","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"ARJUN SHAJI"},{"CODE":"PRES701L","TITLE":"Research Methodology","TYPE":"TH","CREDITS":4,"SLOT":"I4+N4+R5+U2","FACULTY":"SRUTHA\\r\\nKEERTHI B"},{"CODE":"MATR705","TITLE":"Topics in Applicable\\r\\nMathematics","TYPE":"TH","CREDITS":3,"SLOT":"N2+R3+U4","FACULTY":"SUKAVANAM\\r\\nN"},{"CODE":"MATR706","TITLE":"Topics in Advanced Mathematics","TYPE":"TH","CREDITS":3,"SLOT":"N2+R3+U4","FACULTY":"THARASI DILLESWAR\\r\\nRAO"},{"CODE":"PRMC001L","TITLE":"Research And Publication Ethics","TYPE":"TH","CREDITS":2,"SLOT":"I2+M5","FACULTY":"BALAMURUG\\r\\nAN B J"}]');

});

parcelRegister("lyvvK", function(module, exports) {
module.exports = JSON.parse('[{"CODE":"BASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BSTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"F1+TF1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"IASTS102","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"ISTS302P","TITLE":"Advanced Competitive Coding - II","TYPE":"TH","CREDITS":2,"SLOT":"E1+TE1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"MASTS501","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice I","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"MASTS502","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice II","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"MASTS601","TITLE":"Competitive Coding I","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"MASTS602","TITLE":"Competitive Coding II","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"FACE (APT)"},{"CODE":"PASTS501","TITLE":"Qualitative and Quantitative\\r\\nSkills Practice I","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"PASTS602","TITLE":"Competitive Coding II","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"FACE (APT)"},{"CODE":"STS4022","TITLE":"Preparation for Employment","TYPE":"TH","CREDITS":1,"SLOT":"C1+TC1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"UASTS102","TITLE":"Quantitative Skills","TYPE":"TH","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"USTS302P","TITLE":"Advanced Competitive Coding-II","TYPE":"TH","CREDITS":2,"SLOT":"B1+TB1","FACULTY":"ETHNUS\\r\\n(APT)"},{"CODE":"BACHY105","TITLE":"Applied Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MAHALAKSH\\r\\nMI S"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VINU MOHAN A M"},{"CODE":"BACHY107","TITLE":"Applied Chemistry for Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"LAKKOJI\\r\\nSATISH"},{"CODE":"BACHY109","TITLE":"Applied Chemistry for Enginners","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"RAJENDRA\\r\\nKUMAR K"},{"CODE":"BACSE108","TITLE":"Mathematical Foundations of Quantum Technologies","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SAROJ\\r\\nKUMAR DASH"},{"CODE":"BACSE109","TITLE":"Foundations of Quantum\\r\\nMechanics and Technologies","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"DAYASINDHU\\r\\nDEY"},{"CODE":"BAMAT101","TITLE":"Multivariable Calculus and\\r\\nDifferential Equations","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PADMAJA N"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"KRISHNA\\r\\nKUMAR B"},{"CODE":"BAMAT201","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"ASHISH KUMAR\\r\\nNANDI"},{"CODE":"BAMAT202","TITLE":"Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PANKAJ\\r\\nSHUKLA"},{"CODE":"BAMAT203","TITLE":"Linear Algebra and Dynamical\\r\\nSystems","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"RADHA S"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"VIDHYA V"},{"CODE":"BAMAT205","TITLE":"Discrete Mathematics and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SAURABH\\r\\nCHANDRA MAURY"},{"CODE":"BAMAT206","TITLE":"Linear Algebra and Integral Transforms","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD 1","FACULTY":"AVINASH KUMAR\\r\\nMITTAL"},{"CODE":"BAMAT206","TITLE":"Linear Algebra and Integral\\r\\nTransforms","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"POULOMI DE"},{"CODE":"BAMAT207","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PAVITHRA R"},{"CODE":"BAMAT211","TITLE":"Probability Theory and Statistical\\r\\nInference","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"LAKSHMANA\\r\\nN S"},{"CODE":"BAPHY101","TITLE":"Applied Physics for Engineers","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"DEBOTTAM\\r\\nNANDI"},{"CODE":"BAPHY102","TITLE":"Physics for Biologist","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KARTHIKEYA\\r\\nN S"},{"CODE":"BAPHY103","TITLE":"Physics and Mechanics for\\r\\nEngineers","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SANJIT DAS"},{"CODE":"BAPHY105","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PUNITHAVEL\\r\\nAN N"},{"CODE":"BAPHY106","TITLE":"Foundations of Quantum\\r\\nMechanics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RAMKUMAR\\r\\nM C"},{"CODE":"BAPHY107","TITLE":"Physics of Semiconductor\\r\\nDevices","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"A KALAI\\r\\nPRIYA"},{"CODE":"BAPHY109","TITLE":"Physics of Materials in Textile\\r\\nand Fashion","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MANIKANDA\\r\\nN N"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"SAHELI\\r\\nKARMAKAR"},{"CODE":"BMAT102L","TITLE":"Differential Equations and\\r\\nTransforms","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"SARANYA G"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"DURGAPRAS\\r\\nAD P"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KARTHIK S"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"KARTHIK S"},{"CODE":"BMAT205L","TITLE":"Discrete Mathematics and Graph\\r\\nTheory","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"BERIN\\r\\nGREENI A"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NAVAMATHA\\r\\nVAN R"},{"CODE":"IACHY101","TITLE":"Environmental Sciences","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"RAJENDRA\\r\\nKUMAR K"},{"CODE":"IAMAT203","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KOMAL\\r\\nKUMAR"},{"CODE":"IAPHY101","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"G VINITHA"},{"CODE":"ICHY102N","TITLE":"Environmental Sciences","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"ARULMANI S"},{"CODE":"IMAT201L","TITLE":"Complex Variables and Linear\\r\\nAlgebra","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"MINI GHOSH"},{"CODE":"PCHY699J","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"PMDS699J","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"PPHY699J","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"UACHY103","TITLE":"Environmental Sciences","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"PERUMAL D"},{"CODE":"UAMAT102","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"REVATHI G K"},{"CODE":"UHUM151N","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"ALAN G"},{"CODE":"USSC153N","TITLE":"Essence of Traditional\\r\\nKnowledge","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"AJITH I"},{"CODE":"BABIT101","TITLE":"Biochemistry","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SIVAKAMAVA\\r\\nLLI J"},{"CODE":"BABIT102","TITLE":"Microbiology","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"UNNIKRISHN\\r\\nAN B S"},{"CODE":"BACLE103","TITLE":"Mechanics of Solids","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ARUN\\r\\nKUMAR A"},{"CODE":"BACLE104","TITLE":"Waste Management","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SABUMON P\\r\\nC"},{"CODE":"BACLE203","TITLE":"Structural Analysis","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"YAMINI\\r\\nSREEVALLI I"},{"CODE":"BACLE204","TITLE":"Transportation Engineering","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VENKADAVA\\r\\nRAHAN"},{"CODE":"BACLE207","TITLE":"Artificial Intelligence and Machine Learning in Civil\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VASUGI K"},{"CODE":"BACLE301","TITLE":"Construction Materials and\\r\\nTechniques","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"HELEN\\r\\nSANTHI M"},{"CODE":"BACLE313","TITLE":"Environmental Impact Assessment","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"K PALANIVELU"},{"CODE":"BACLE315","TITLE":"Air and Noise pollution control","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ANJALI GOPAKUMAR"},{"CODE":"BACLE319","TITLE":"Essentials for Data Science and\\r\\nAI for Civil Engineers","TYPE":"TH","CREDITS":2,"SLOT":"TB1+TG1","FACULTY":"LT2"},{"CODE":"BACLE417","TITLE":"Sustainability Practices in Design\\r\\nof Buildings","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"LT1"},{"CODE":"BAHUM104","TITLE":"Professional Practices and\\r\\nConstruction Ethics","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"SHANMUGA\\r\\nSUNDARAM"},{"CODE":"BCLE211L","TITLE":"Urban Planning and\\r\\nDevelopment","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SABUMON P\\r\\nC"},{"CODE":"BCLE212L","TITLE":"Natural Disaster Mitigation and\\r\\nManagement","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MOHAN K"},{"CODE":"BCLE214L","TITLE":"Global Warming","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ARUN\\r\\nKUMAR A"},{"CODE":"BCLE215L","TITLE":"Waste Management","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SENTHILPAN\\r\\nDIAN M"},{"CODE":"BCLE216L","TITLE":"Water Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ELAVENIL S"},{"CODE":"BCLE306L","TITLE":"Water Resources Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SARAVANAN\\r\\nK"},{"CODE":"BCLE306P","TITLE":"Water Resources Engineering\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SARAVANAN\\r\\nK"},{"CODE":"BCLE308L","TITLE":"Design of Steel Structures","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KARTHIYAINI\\r\\nS"},{"CODE":"BCLE308P","TITLE":"Steel Structures Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"KARTHIYAINI\\r\\nS"},{"CODE":"BCLE309L","TITLE":"Estimating and Costing","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"VASUGI V"},{"CODE":"BCLE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"ICLE499J","TITLE":"Project II / Internship(one\\r\\nsemester)","TYPE":"TH","CREDITS":20,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MASTE504","TITLE":"Advanced Design of Steel\\r\\nStructures","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"VASUGI K"},{"CODE":"MASTE505","TITLE":"Finite element analysis","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KARTHIKEYA\\r\\nN K"},{"CODE":"MASTE602","TITLE":"Advanced Concrete Materials\\r\\nand Technology","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SENTHILPAN\\r\\nDIAN M"},{"CODE":"MASTE604","TITLE":"Earthquake Resistant Design","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"HELEN\\r\\nSANTHI M"},{"CODE":"MASTE608","TITLE":"Prefabricated Structures","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ELAVENIL S"},{"CODE":"MASTE699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BACSE102","TITLE":"Problem Solving Using Java","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L55+L5 6","FACULTY":"CHENDUR KUMARAN R"},{"CODE":"BACSE103","TITLE":"Computation Structures","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NITHYA DARISINI  P S"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"A2","FACULTY":"MOHAMED\\r\\nIMRAN A"},{"CODE":"BACSE104","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"PALANI THANARAJ K"},{"CODE":"BACSE106","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ANIK\\r\\nGOSWAMI"},{"CODE":"BACSE201","TITLE":"Models of Computation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"KARMEL A"},{"CODE":"BACSE202","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PARKAVI K"},{"CODE":"BACSE203","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PRADEEP K V"},{"CODE":"BACSE204","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"A. K\\r\\nILAVARASI"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial Intelligence and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MAHESWARI S"},{"CODE":"BACSE205","TITLE":"Fundamentals of Artificial\\r\\nIntelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"V BRINDHA"},{"CODE":"BACSE206","TITLE":"Foundations of Artificial\\r\\nIntelligence","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"KHADAR\\r\\nNAWAS K"},{"CODE":"BACSE211","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MUTHUKUM ARAN K"},{"CODE":"BACSE301","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"S . A.\\r\\nSAJIDHA"},{"CODE":"BACSE312","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VIJAYAKUMA\\r\\nR P"},{"CODE":"BACSE319","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NITHYANAND\\r\\nAM P"},{"CODE":"BACSE324","TITLE":"Embedded Systems Architecture","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SRITAMA\\r\\nROY"},{"CODE":"BACSE339","TITLE":"Distributed Ledger Technology","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SANDHYA P"},{"CODE":"BACSE342","TITLE":"Game Design and Development","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAJKUMAR R"},{"CODE":"BACSE344","TITLE":"Cloud Infrastructure and\\r\\nArchitecture","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"PARVATHY A\\r\\nK"},{"CODE":"BACSE345","TITLE":"Cloud Automation Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"PRABHAKAR\\r\\nAN R"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"D1","FACULTY":"HEMILA\\r\\nREXLINE D"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented\\r\\nProgramming Lab","TYPE":"LO","CREDITS":2,"SLOT":"L29+L30+L33+\\r\\nL34","FACULTY":"HEMILA\\r\\nREXLINE D"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"JENILA LIVINGSTON\\r\\nL M"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of\\r\\nAlgorithms","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SENTHIL\\r\\nKUMAR R"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of\\r\\nAlgorithms Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SENTHIL\\r\\nKUMAR R"},{"CODE":"BCSE206L","TITLE":"Foundations of Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GEETHA S"},{"CODE":"BCSE208L","TITLE":"Data Mining","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BCSE208P","TITLE":"Data Mining Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SHERLY A"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SHERLY A"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ANIK\\r\\nGOSWAMI"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"ANIK\\r\\nGOSWAMI"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SHOLA USHA\\r\\nRANI"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SHOLA USHA\\r\\nRANI"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SARAVANAN\\r\\nP"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SRITAMA\\r\\nROY"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SINDHU RAVINDRAN"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MANAS RANJAN\\r\\nPRUSTY"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"MANAS\\r\\nRANJAN PRUSTY"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network\\r\\nSecurity","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KARTHIKA V"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network Security","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SANDOSH SAKKARAPAN\\r\\nI"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network\\r\\nSecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"KARTHIKA V"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network Security Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SANDOSH SAKKARAPAN\\r\\nI"},{"CODE":"BCSE317L","TITLE":"Information Security","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PADMANABA\\r\\nN R"},{"CODE":"BCSE318L","TITLE":"Data Privacy","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"DHANALAKS\\r\\nHMI R"},{"CODE":"BCSE325L","TITLE":"Introduction to Bitcoin","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BENIL T"},{"CODE":"BCSE331L","TITLE":"Exploratory Data Analysis","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"MALINI A"},{"CODE":"BCSE331P","TITLE":"Exploratory Data Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MALINI A"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SWEETLIN HEMALATHA\\r\\nC"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SWEETLIN HEMALATHA\\r\\nC"},{"CODE":"BCSE340L","TITLE":"Penetration Testing and\\r\\nVulnerability Assessment","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PRASAD M"},{"CODE":"BCSE340P","TITLE":"Penetration Testing and Vulnerability Assessment Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PRASAD M"},{"CODE":"BCSE401L","TITLE":"Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ABHIJIT\\r\\nMISHRA"},{"CODE":"BCSE402L","TITLE":"Big Data Analytics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ELAKYA R"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programming","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JENILA LIVINGSTON\\r\\nL M"},{"CODE":"BCSE406L","TITLE":"NoSQL Databases","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SUSEELA S"},{"CODE":"BCSE407L","TITLE":"Computer vision","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VIJAYARAJAN\\r\\nR"},{"CODE":"BCSE408L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PRIYAADHAR\\r\\nSHINI M"},{"CODE":"BCSE409L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUDHAKARA\\r\\nN G"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MALATHI G"},{"CODE":"BCSE417L","TITLE":"Machine vision","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAJARAJESW\\r\\nARI S"},{"CODE":"BCSE417P","TITLE":"Machine Vision Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAJARAJESW\\r\\nARI S"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intelligence","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"RAJIV\\r\\nVINCENT"},{"CODE":"BCSE419L","TITLE":"Speech and Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"BHARADWAJ\\r\\nA KUMAR"},{"CODE":"BCSE419P","TITLE":"Speech and Language Processing\\r\\nlab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"BHARADWAJ\\r\\nA KUMAR"},{"CODE":"BCSE421L","TITLE":"Robotics: Kinematics, Dynamics and Motion Control","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ARUNKUMAR V"},{"CODE":"BCSE423L","TITLE":"Robot Programming","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"SARANYARAJ\\r\\nD"},{"CODE":"BCSE423P","TITLE":"Robot Programming Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SARANYARAJ\\r\\nD"},{"CODE":"BCSE425L","TITLE":"Robotic Perception","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PREM\\r\\nSANKAR"},{"CODE":"BCSE425P","TITLE":"Robotic Perception Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"PREM\\r\\nSANKAR"},{"CODE":"BCSE427L","TITLE":"Cognitive Robotics","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"ARUNKUMAR\\r\\nV"},{"CODE":"BCSE427P","TITLE":"Cognitive Robotics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"ARUNKUMAR\\r\\nV"},{"CODE":"BCSE428L","TITLE":"Autonomous Drones","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SATHIAN D"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SATHIAN D"},{"CODE":"BCSE429L","TITLE":"Cyber Physical Systems Design","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"PRADEEP\\r\\nKUMAR  T S"},{"CODE":"BCSE429P","TITLE":"Cyber Physical System Design\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PRADEEP\\r\\nKUMAR  T S"},{"CODE":"BCSE438L","TITLE":"Malware Analysis and Mitigation\\r\\nTechniques","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUBBULAKSH\\r\\nMI T"},{"CODE":"BCSE438P","TITLE":"Malware Analysis and Mitigation\\r\\nTechniques Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SUBBULAKSH\\r\\nMI T"},{"CODE":"BCSE440L","TITLE":"System Security","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VIJAYAKUMA\\r\\nR K P"},{"CODE":"BCSE441L","TITLE":"Artificial Intelligence for\\r\\nCybersecurity","TYPE":"TH","CREDITS":2,"SLOT":"D1","FACULTY":"PADMANABA\\r\\nN R"},{"CODE":"BCSE441P","TITLE":"Artificial Intelligence for\\r\\nCybersecurity Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"PADMANABA\\r\\nN R"},{"CODE":"BCSE442L","TITLE":"Cyber Threat Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"V. MUTHUMANI\\r\\nKANDAN"},{"CODE":"BCSE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"CSE1908","TITLE":"Capstone Project","TYPE":"TH","CREDITS":16,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"CSE3091","TITLE":"Cloud Ecosystem","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VISWANATH\\r\\nAN V"},{"CODE":"CSE3505","TITLE":"Foundations of Data Analytics","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"TRILOK NATH PANDEY"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"PADMA J"},{"CODE":"CSE4047","TITLE":"Cloud Application Development","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"KOWSIGAN\\r\\nM"},{"CODE":"CSE4067","TITLE":"Bioinformatics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"HEMALATHA\\r\\nK"},{"CODE":"CSE4069","TITLE":"Social Media Analytics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JAYARAM B"},{"CODE":"IACSE201","TITLE":"Structured and Object-Oriented\\r\\nProgramming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"DEEPIKA R"},{"CODE":"IACSE201","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"UMA MAHESWARI\\r\\nJ"},{"CODE":"IACSI101","TITLE":"Data Structures and Algorithms","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"S. BHARATHI RAJA"},{"CODE":"IACSI202","TITLE":"Digital Logic and Computer\\r\\nDesign","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SATHYA SREE\\r\\nJ"},{"CODE":"IACSI301","TITLE":"Microprocessors and\\r\\nMicrocontrollers","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"CHITRA K"},{"CODE":"IACSI301","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"RICHARDS JOE STANISLAUS"},{"CODE":"IACSI302","TITLE":"Data Communication and Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"APPALARAJU MURALIDHA R"},{"CODE":"IACSI302","TITLE":"Data Communication and\\r\\nComputer Networks","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SRIDEVI S"},{"CODE":"IACSI306","TITLE":"Software Engineering Principles\\r\\nand Practices","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"NACHIYAPPA\\r\\nN S"},{"CODE":"IAMDI403","TITLE":"Data Mining","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MAHESWARI\\r\\nN"},{"CODE":"IASWE101","TITLE":"Digital Logic and Microprocessor","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"B. NAGAJAYANT\\r\\nHI"},{"CODE":"IASWE102","TITLE":"Software Engineering","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"BERIN SHALU\\r\\nS"},{"CODE":"IASWE204","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAJALAKSHM\\r\\nI R"},{"CODE":"IASWE205","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ABDUL\\r\\nQUADIR MD"},{"CODE":"IASWE207","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MENAKA\\r\\nPUSHPA A"},{"CODE":"IASWE208","TITLE":"Software Architecture and\\r\\nDesign","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"KUMAR K"},{"CODE":"IBSA304L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"DEEPA NIVETHIKA S"},{"CODE":"IBSA304P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"DEEPA NIVETHIKA S"},{"CODE":"IBSA305L","TITLE":"Big Data Frameworks","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SIVA PRIYA M\\r\\nS"},{"CODE":"IBSA305P","TITLE":"Big Data Frameworks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SIVA PRIYA M\\r\\nS"},{"CODE":"IBSA310L","TITLE":"Network Security and\\r\\nCryptography Fundamentals","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"GANESAN R"},{"CODE":"IBSA409L","TITLE":"Social Media Analytics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"S\\r\\nVIGNESHWA RI"},{"CODE":"IMGT302L","TITLE":"Marketing Management","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SHAMAL S"},{"CODE":"IMGT401L","TITLE":"Organisational Behaviour","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"S DIVYA"},{"CODE":"ISWE206L","TITLE":"Web Technologies","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SANDEEP KUMAR\\r\\nSATAPATHY"},{"CODE":"ISWE206P","TITLE":"Web Technologies Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SANDEEP\\r\\nKUMAR SATAPATHY"},{"CODE":"ISWE210L","TITLE":"R for Data Science","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"ABISHI CHOWDHUR\\r\\nY"},{"CODE":"ISWE305L","TITLE":"Software Testing","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"GANESH N"},{"CODE":"ISWE305P","TITLE":"Software Testing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"GANESH N"},{"CODE":"ISWE307L","TITLE":"Digital Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JOSHAN ATHANESIOU\\r\\nS J"},{"CODE":"ISWE309L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SENTHIL\\r\\nKUMAR A M"},{"CODE":"ISWE310L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ILAKIYASELV\\r\\nAN N"},{"CODE":"ISWE314L","TITLE":"Social Network Analysis","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SINDHU RAVINDRAN"},{"CODE":"ISWE402L","TITLE":"Software Metrics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"UMAMAHES\\r\\nWARI E"},{"CODE":"ISWE403L","TITLE":"Software Configuration\\r\\nManagement","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAMA\\r\\nPRABHA K P"},{"CODE":"ISWE410L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"PRETHIJA G"},{"CODE":"ISWE410P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"PRETHIJA G"},{"CODE":"ISWE411L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ELAKYA R"},{"CODE":"ISWE412L","TITLE":"Block Chain Technologies","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BENIL T"},{"CODE":"ISWE416L","TITLE":"Big Data Analytics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PATTABIRAM\\r\\nAN V"},{"CODE":"ISWE417L","TITLE":"Quantum Computing","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KOWSIGAN\\r\\nM"},{"CODE":"ISWE421L","TITLE":"Cognitive Computing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JAYARAM B"},{"CODE":"ISWE425L","TITLE":"Game Theory and its\\r\\nApplications","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"UMESH K"},{"CODE":"MACSE513","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ANUSHA K"},{"CODE":"MACSE622","TITLE":"Data Engineering and\\r\\nVisualization","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"AMRIT PAL"},{"CODE":"MACSE623","TITLE":"Text and Speech Analytics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ILAKIYASELV\\r\\nAN N"},{"CODE":"MACSE624","TITLE":"Big Data Frameworks and\\r\\nTechnologies","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SUGANESHW\\r\\nARI G"},{"CODE":"MACSE628","TITLE":"Data Privacy and Security","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"JAI VINITA L"},{"CODE":"MACSE629","TITLE":"Deep Learning and Reinforcement Learning","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"A.\\r\\nNAYEEMULL A KHAN"},{"CODE":"MACSE630","TITLE":"Generative AI and Large\\r\\nLanguage Models","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BHARADWAJ\\r\\nA KUMAR"},{"CODE":"MACSE632","TITLE":"Multi-Task and Meta Learning","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"KUMARAN K"},{"CODE":"MACSE634","TITLE":"Responsible Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"PREETHA\\r\\nEVANGELINE D"},{"CODE":"MACSE636","TITLE":"Cybersecurity","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VALLIDEVI K"},{"CODE":"MACSE638","TITLE":"Software Engineering and Modeling","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SATHYARAJA SEKARAN K"},{"CODE":"MACSE639","TITLE":"DevOps","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GAYATHRI\\r\\nDEVI S"},{"CODE":"MACSE640","TITLE":"Full Stack Application and\\r\\nDevelopment","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RAJKUMAR S"},{"CODE":"MACSE698","TITLE":"Internship I/ Dissertation I","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MACSE699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MCSE699J","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MGT3007","TITLE":"Retail  Analytics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ARSHIYA FATHIMA M\\r\\nS"},{"CODE":"MGT4002","TITLE":"Investment and Banking\\r\\nanalytics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUJATHA\\r\\nMANOHAR"},{"CODE":"PAMCA504","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"GRACELINE\\r\\nJASMINE S"},{"CODE":"PAMCA505","TITLE":"Software Engineering","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"DHAVAKUMA\\r\\nR P"},{"CODE":"PAMCA506","TITLE":"Full Stack Web Development","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAJKUMAR S"},{"CODE":"PAMCA601","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SOFTYA\\r\\nSEBASTIAN"},{"CODE":"PAMCA604","TITLE":"Cybersecurity","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"MENAKA\\r\\nPUSHPA A"},{"CODE":"PAMCA605","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"YOGESH C"},{"CODE":"PAMCA606","TITLE":"Generative AI","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"PRAKASH P"},{"CODE":"PAMCA699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"SWE2017","TITLE":"Parallel Programming","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MANJULA V"},{"CODE":"SWE4009","TITLE":"Linux Programming","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SHOLA USHA\\r\\nRANI"},{"CODE":"UACSA104","TITLE":"Object Oriented Programming","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"POONKODI\\r\\nM"},{"CODE":"UACSA105","TITLE":"Data Structures and Algorithms","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"UMMITY SRINIVASA\\r\\nRAO"},{"CODE":"UACSA106","TITLE":"Database Management Systems","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"R JOTHI"},{"CODE":"UCSC205L","TITLE":"Web Development","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUVIDHA RUPESH\\r\\nKUMAR"},{"CODE":"UCSC205P","TITLE":"Web Development Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SUVIDHA\\r\\nRUPESH KUMAR"},{"CODE":"UCSC225L","TITLE":"Cyber Security","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"V. MUTHUMANI\\r\\nKANDAN"},{"CODE":"UCSC226L","TITLE":"Animation and VFX","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PRIYAADHAR\\r\\nSHINI M"},{"CODE":"UCSC312L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAJALAKSHM\\r\\nI V"},{"CODE":"UCSC312P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAJALAKSHM\\r\\nI V"},{"CODE":"UCSC313L","TITLE":"Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KIRUTHIKA S"},{"CODE":"UCSC313P","TITLE":"Image Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"KIRUTHIKA S"},{"CODE":"UCSC317L","TITLE":"Big Data Technologies","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIVA PRIYA M\\r\\nS"},{"CODE":"UCSC317P","TITLE":"Big Data Technologies Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SIVA PRIYA M\\r\\nS"},{"CODE":"UCSC318L","TITLE":"Exploratory Data Analytics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VIGNESH U"},{"CODE":"UCSC318P","TITLE":"Exploratory Data Analytics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"VIGNESH U"},{"CODE":"UCSC398J","TITLE":"Project","TYPE":"TH","CREDITS":4,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BAEEE101","TITLE":"Basic Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PREMALATH\\r\\nA L"},{"CODE":"BAEEE102","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PEER\\r\\nFATHIMA A"},{"CODE":"BAEEE201","TITLE":"Digital Electronics","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"NITHYA VENKATESAN"},{"CODE":"BAEEE203","TITLE":"Microcontrollers and Embedded\\r\\nProgramming","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VIJAYAPRIYA\\r\\nR"},{"CODE":"BAEEE203","TITLE":"Microcontrollers and Embedded Programming","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"INAYATHULL AAH ABDUL KAREEM"},{"CODE":"BAEEE204","TITLE":"Electromagnetic Field Theory","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD 2","FACULTY":"CHENDUR KUMARAN R"},{"CODE":"BAEEE205","TITLE":"Power Systems Engineering","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"ARUL R"},{"CODE":"BAEEE206","TITLE":"Electrical Machines","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"JANANI C"},{"CODE":"BAEEE207","TITLE":"Measurements and\\r\\nInstrumentation","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KAMAL C"},{"CODE":"BAEEE207","TITLE":"Measurements and Instrumentation","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ANANTHA KRISHNAN V"},{"CODE":"BAEEE208","TITLE":"Probability and Stochastic Processes","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"CHENDUR KUMARAN R"},{"CODE":"BAEEE301","TITLE":"Power Electronics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KANIMOZHI\\r\\nG"},{"CODE":"BAEEE302","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"IYSWARYA ANNAPOORA\\r\\nNI K"},{"CODE":"BAEEE304","TITLE":"Power Electronics and Drives","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"M. PRABHAKAR"},{"CODE":"BAEEE305","TITLE":"Electric Power Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MITHU\\r\\nSARKAR"},{"CODE":"BAEEE306","TITLE":"Artificial Intelligence and Machine Learning for Electrical\\r\\nApplications","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SITHARTHAN R"},{"CODE":"BAEEE306","TITLE":"Artificial Intelligence and\\r\\nMachine Learning for Electrical Applications","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SENTHIL KUMAR R"},{"CODE":"BECS201L","TITLE":"Semiconductor Devices and Circuits","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ANANTHA KRISHNAN V"},{"CODE":"BECS201P","TITLE":"Semiconductor Devices and Circuits Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"ANANTHA KRISHNAN V"},{"CODE":"BECS305E","TITLE":"AI and ML for Electrical Systems","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"SRI REVATHI\\r\\nB"},{"CODE":"BECS498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BEEE102L","TITLE":"Basic Electrical and Electronics\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SWETHA R\\r\\nKUMAR"},{"CODE":"BEEE102P","TITLE":"Basic Electrical and Electronics\\r\\nEngineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SWETHA R\\r\\nKUMAR"},{"CODE":"BEEE205L","TITLE":"Electronic Devices and Circuits","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"D V\\r\\nSUDARSANRE DDY"},{"CODE":"BEEE205P","TITLE":"Electronic Devices and Circuits Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"D V SUDARSANRE\\r\\nDDY"},{"CODE":"BEEE210L","TITLE":"Electrical Machine Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"UMAYAL C"},{"CODE":"BEEE211E","TITLE":"VLSI Design","TYPE":"TH","CREDITS":2,"SLOT":"F2","FACULTY":"BINDU B"},{"CODE":"BEEE213L","TITLE":"Embedded Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"INAYATHULL AAH ABDUL KAREEM"},{"CODE":"BEEE214L","TITLE":"Electrical Machines and Drives","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RUPA\\r\\nMISHRA"},{"CODE":"BEEE214P","TITLE":"Electrical Machines and Drives\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"RUPA\\r\\nMISHRA"},{"CODE":"BEEE215L","TITLE":"DC Machines and Transformers","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"SUBHENDU SEKHAR\\r\\nSAHOO"},{"CODE":"BEEE215P","TITLE":"DC Machines and Transformers Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SUBHENDU SEKHAR\\r\\nSAHOO"},{"CODE":"BEEE306L","TITLE":"Power Systems Analysis","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VAITHILINGA\\r\\nM C"},{"CODE":"BEEE306P","TITLE":"Power Systems Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"VAITHILINGA\\r\\nM C"},{"CODE":"BEEE307L","TITLE":"Electric Drives","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"BINU BEN\\r\\nJOSE D R"},{"CODE":"BEEE307P","TITLE":"Power Electronics and Drives Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"BINU BEN\\r\\nJOSE D R"},{"CODE":"BEEE308L","TITLE":"Communication Systems","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PRITAM\\r\\nBHOWMIK"},{"CODE":"BEEE311L","TITLE":"Design of Electrical Installations","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"PEER\\r\\nFATHIMA A"},{"CODE":"BEEE314L","TITLE":"Hybrid and Electric Vehicles","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SREEDEVI V T"},{"CODE":"BEEE405L","TITLE":"Renewable Energy Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SENTHIL\\r\\nKUMAR N"},{"CODE":"BEEE409L","TITLE":"Robotics and Control","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SWETHA R\\r\\nKUMAR"},{"CODE":"BEEE410L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JAMUNA K"},{"CODE":"BEEE411L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SRI REVATHI\\r\\nB"},{"CODE":"BEEE412L","TITLE":"Sensors and Actuators","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"RANJITH R"},{"CODE":"BEEE412P","TITLE":"Sensors and Actuators Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"RANJITH R"},{"CODE":"BEEE423E","TITLE":"Industrial IoT","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MORLA LAKSHMI SIVA SAI\\r\\nKUMAR"},{"CODE":"BEEE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BEIE301L","TITLE":"Biomedical Instrumentation","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SUBBULEKSH\\r\\nMI D"},{"CODE":"MAELM504","TITLE":"Electric Motor Drives","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NILANJAN\\r\\nTEWARI"},{"CODE":"MAELM601","TITLE":"Artificial Intelligence for Electric\\r\\nMobility","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"HEMAMALINI"},{"CODE":"MAELM603","TITLE":"Electric Energy Storage Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"BALAMURUG\\r\\nAN P"},{"CODE":"MAELM604","TITLE":"Connected and Autonomous\\r\\nVehicles","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"NAWIN RA"},{"CODE":"MAELM607","TITLE":"Automotive Functional Safety","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"LENIN N C"},{"CODE":"MAELM699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BAECE101","TITLE":"Signals and Systems","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD\\r\\n2","FACULTY":"ASHIS\\r\\nTRIPATHY"},{"CODE":"BAECE102","TITLE":"Digital Logic Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUBHASHINI\\r\\nN"},{"CODE":"BAECE103","TITLE":"Network Theory","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"SUBHASHINI\\r\\nN"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer\\r\\nArchitecture","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RUPA\\r\\nMISHRA"},{"CODE":"BAECE104","TITLE":"Digital Logic and Computer Architecture","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"JEAN JENIFER NESAM J"},{"CODE":"BAECE202","TITLE":"Engineering Electromagnetics","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"USHA KIRAN KOMMURI"},{"CODE":"BAECE204","TITLE":"Microcontrollers and Embedded C Programming","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JOHN SAHAYA RANI\\r\\nALEX"},{"CODE":"BAECE204","TITLE":"Microcontrollers and Embedded\\r\\nC Programming","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"VIGNESWAR\\r\\nAN T"},{"CODE":"BAECE206","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAMESH R"},{"CODE":"BAECE207","TITLE":"Analog and Digital Communication Systems","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAVI PRAKASH\\r\\nDWIVEDI"},{"CODE":"BAECE207","TITLE":"Analog and Digital\\r\\nCommunication Systems","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SRIVATSAN K"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave\\r\\nEngineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PRIYANKA\\r\\nDAS"},{"CODE":"BAECE301","TITLE":"Antenna and Microwave Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PRASAD JONES CHRISTYDASS\\r\\nS"},{"CODE":"BAECE302","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"AUGUSTA\\r\\nSOPHY BEULET P"},{"CODE":"BAECE309","TITLE":"Speech Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MOHANAPRA\\r\\nSAD K"},{"CODE":"BAECE310","TITLE":"Image and Vision Techniques","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ANNIS\\r\\nFATHIMA A"},{"CODE":"BAEVD101","TITLE":"Electronic Devices","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"TANMOY\\r\\nMAJUMDER"},{"CODE":"BAEVD102","TITLE":"Digital System Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SAURAV\\r\\nGUPTA"},{"CODE":"BAEVD202","TITLE":"Computer Architecture","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ARIVARASI A"},{"CODE":"BAEVD204","TITLE":"Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"CHANDRASEK\\r\\nARAN N"},{"CODE":"BAEVD205","TITLE":"VLSI Circuit Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SASIPRIYA P"},{"CODE":"BAEVD305","TITLE":"CAD for IC Design","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"REENA\\r\\nMONICA P"},{"CODE":"BAEVD403","TITLE":"Device Modeling and\\r\\nCharacterization Techniques","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"LAKSHMI B"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RANJEET\\r\\nKUMAR"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"RANJEET\\r\\nKUMAR"},{"CODE":"BECE201L","TITLE":"Electronic Materials and devices","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"CHANDRASEK\\r\\nARAN N"},{"CODE":"BECE205L","TITLE":"Engineering Electromagnetics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"THIRIPURASU\\r\\nNDARI D"},{"CODE":"BECE206L","TITLE":"Analog Circuits","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RAJU PATEL"},{"CODE":"BECE206P","TITLE":"Analog Circuits Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAJU PATEL"},{"CODE":"BECE303L","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SHAIK AHMADSAID\\r\\nULU"},{"CODE":"BECE303P","TITLE":"VLSI System Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SHAIK\\r\\nAHMADSAID ULU"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and\\r\\nMachine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"VYDEKI D"},{"CODE":"BECE310L","TITLE":"Satellite Communications","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RALPH SAMUEL THANGARAJ"},{"CODE":"BECE311L","TITLE":"Radar Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SAURABH KUMAR SRIVASTAVA"},{"CODE":"BECE312L","TITLE":"Robotics and Automation","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VELMATHI G"},{"CODE":"BECE313L","TITLE":"Information Theory and Coding","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RALPH\\r\\nSAMUEL THANGARAJ"},{"CODE":"BECE317L","TITLE":"Wireless and Mobile\\r\\nCommunications","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RAMESH R"},{"CODE":"BECE317P","TITLE":"Wireless and Mobile\\r\\nCommunications Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"RAMESH R"},{"CODE":"BECE318L","TITLE":"Optical Fiber Communications","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BRINTHA\\r\\nTHERESE  A"},{"CODE":"BECE318P","TITLE":"Optical Fiber Communications\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"BRINTHA\\r\\nTHERESE  A"},{"CODE":"BECE318P","TITLE":"Optical Fiber Communications Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"S SELVENDRAN"},{"CODE":"BECE320E","TITLE":"Embedded C Programming","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"SUMATHI V"},{"CODE":"BECE401L","TITLE":"Computer Communications and\\r\\nNetworks","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KALAIVANAN\\r\\nK"},{"CODE":"BECE401L","TITLE":"Computer Communications and Networks","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"S SIVAKUMAR"},{"CODE":"BECE401P","TITLE":"Computer Communications and\\r\\nNetworks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"KALAIVANAN\\r\\nK"},{"CODE":"BECE401P","TITLE":"Computer Communications and Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"S SIVAKUMAR"},{"CODE":"BECE402L","TITLE":"Communication for Cyber\\r\\nPhysical Systems","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"HEMALATHA\\r\\nK"},{"CODE":"BECE402P","TITLE":"Communication for Cyber\\r\\nPhysical Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"HEMALATHA\\r\\nK"},{"CODE":"BECE407E","TITLE":"ASIC Design","TYPE":"TH","CREDITS":2,"SLOT":"D1","FACULTY":"PRITAM\\r\\nBHATTACHAR JEE"},{"CODE":"BECE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BECM301L","TITLE":"Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DEEPA T"},{"CODE":"BECM301P","TITLE":"Signal Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"DEEPA T"},{"CODE":"BECM498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BEVD304L","TITLE":"CMOS Analog IC Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MD\\r\\nSADULLAH"},{"CODE":"BEVD304P","TITLE":"CMOS Analog IC Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"MD\\r\\nSADULLAH"},{"CODE":"BEVD305L","TITLE":"VLSI Technology","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUNIL\\r\\nKUMAR PRADHAN"},{"CODE":"BEVD305P","TITLE":"VLSI Technology Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SUNIL KUMAR\\r\\nPRADHAN"},{"CODE":"BEVD308L","TITLE":"Low Power VLSI Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RAHUL NARASIMHA\\r\\nN A"},{"CODE":"BEVD309L","TITLE":"Testing of VLSI Circuits","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PAPANASAM\\r\\nE"},{"CODE":"BEVD310L","TITLE":"Embedded System Design with\\r\\nFPGA","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"HARIHARAN I"},{"CODE":"BEVD310L","TITLE":"Embedded System Design with FPGA","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"JEAN JENIFER NESAM J"},{"CODE":"BEVD408L","TITLE":"Verification Methodologies","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SAKTHIVEL S\\r\\nM"},{"CODE":"BEVD498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MAEDS504","TITLE":"In-Vehicle Networking","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"JAYA\\r\\nVIGNESH T"},{"CODE":"MAEDS505","TITLE":"Real Time Operating System","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"DHANUSH R"},{"CODE":"MAEDS606","TITLE":"Intelligent IoT System Design and\\r\\nArchitecture","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"VELMATHI G"},{"CODE":"MAEDS611","TITLE":"5G and Next Generation Wireless Systems for Embedded\\r\\nApplications","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"DESU MOULIKA"},{"CODE":"MAEDS613","TITLE":"Wireless and Mobile\\r\\nCommunication for Embedded Applications","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"BERLIN HENCY V"},{"CODE":"MAEDS699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MAVLD505","TITLE":"ASIC Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PRATHIBA A"},{"CODE":"MAVLD506","TITLE":"VLSI Testing and Testability","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RAVI V"},{"CODE":"MAVLD602","TITLE":"Low Power IC Design","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RAHUL\\r\\nNARASIMHA N A"},{"CODE":"MAVLD603","TITLE":"VLSI Verification Methodologies","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SAKTHIVEL S\\r\\nM"},{"CODE":"MAVLD605","TITLE":"System-on-Chip Design","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"ANITA\\r\\nANGELINE"},{"CODE":"MAVLD699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MEDS699J","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BABMH101","TITLE":"Electronic Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"A BHARATHI SANKAR"},{"CODE":"BABMH201","TITLE":"Electric Drives and Fluid Power","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SANTHOSH N"},{"CODE":"BABMH204","TITLE":"Machine Vision","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MATHIYAZHA\\r\\nGAN R"},{"CODE":"BABMH301","TITLE":"Systems and Control","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SARAVANAK\\r\\nUMAR D"},{"CODE":"BAHUM102","TITLE":"Ethics in Engineering","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SENTHIL\\r\\nKUMAR M"},{"CODE":"BAMEE101","TITLE":"Manufacturing Processes","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ANSHUMAN\\r\\nDAS"},{"CODE":"BAMEE201","TITLE":"Mechanics of Materials","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"CHRISTO\\r\\nMICHAEL T"},{"CODE":"BAMEE204","TITLE":"Fluid Mechanics and Machinery","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SAURABH\\r\\nYADAV"},{"CODE":"BAMEE205","TITLE":"Engineering Innovation and Modelling","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"AYUB\\r\\nAHMED JANVEKAR"},{"CODE":"BAMEE205","TITLE":"Engineering Innovation and\\r\\nModelling","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"SASIKUMAR\\r\\nM"},{"CODE":"BAMEE208","TITLE":"Additive Manufacturing: Processes and Design","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAGHUKIRAN NADIMPALLI"},{"CODE":"BAMEE208","TITLE":"Additive Manufacturing:\\r\\nProcesses and Design","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PRADEEP N"},{"CODE":"BAMEE303","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BALAJI B"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of\\r\\nMachines","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KRISHANU\\r\\nGANGULY"},{"CODE":"BAMEE306","TITLE":"Kinematics and Dynamics of Machines","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SREEKANTH DONDAPATI"},{"CODE":"BAMEE316","TITLE":"Climate Change and Sustainable\\r\\nDevelopment","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"JOSEPH\\r\\nDANIEL"},{"CODE":"BAMEE318","TITLE":"Vehicle Systems Engineering","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"TAMIL\\r\\nSELVAN P"},{"CODE":"BAMEE320","TITLE":"Vehicle Dynamics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"LENIN BABU\\r\\nM C"},{"CODE":"BAMEE322","TITLE":"Industrial Engineering","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"GAJANAND\\r\\nGUPTA"},{"CODE":"BAMEE338","TITLE":"Introduction to Aeronautics","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"VINAYAGAM\\r\\nURTHY G"},{"CODE":"BMEE203L","TITLE":"Engineering Thermodynamics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"PRITAM DAS"},{"CODE":"BMEE205E","TITLE":"Renewable Energy Systems","TYPE":"TH","CREDITS":2,"SLOT":"F2","FACULTY":"PRITAM DAS"},{"CODE":"BMEE206P","TITLE":"Machine Drawing Lab","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L11+L1\\r\\n2","FACULTY":"MOHAN R"},{"CODE":"BMEE210L","TITLE":"Mechatronics and Measurement\\r\\nSystems","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"DEIVANATHA\\r\\nN R"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurement\\r\\nSystems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"DEIVANATHA\\r\\nN R"},{"CODE":"BMEE212L","TITLE":"Quality Control and\\r\\nImprovement","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PONNUSAMY\\r\\nP"},{"CODE":"BMEE215L","TITLE":"Engineering Optimization","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"THANGARAJ\\r\\nM"},{"CODE":"BMEE302L","TITLE":"Metal Casting and Welding","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ANSHUMAN\\r\\nDAS"},{"CODE":"BMEE302P","TITLE":"Metal Casting and Welding Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ANSHUMAN\\r\\nDAS"},{"CODE":"BMEE306L","TITLE":"Computer Aided Design and Finite Element Analysis","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"DAVIDSON JEBASEELAN"},{"CODE":"BMEE306L","TITLE":"Computer Aided Design and\\r\\nFinite Element Analysis","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"TEJDEEP G"},{"CODE":"BMEE306P","TITLE":"Computer Aided Design and\\r\\nFinite Element Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"VENKATACHA\\r\\nLAM G"},{"CODE":"BMEE306P","TITLE":"Computer Aided Design and Finite Element Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"DAVIDSON JEBASEELAN"},{"CODE":"BMEE309L","TITLE":"Lean Manufacturing","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"JOHN RAJAN\\r\\nA"},{"CODE":"BMEE310L","TITLE":"Supply Chain Management","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"VIVEKANAND\\r\\nA A S"},{"CODE":"BMEE326L","TITLE":"Power Plant Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KARUNAMUR\\r\\nTHY K"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles\\r\\nTechnology","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"SHYAM\\r\\nKUMAR M B"},{"CODE":"BMEE404L","TITLE":"Design of Transmission Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"KRISHANU\\r\\nGANGULY"},{"CODE":"BMEE407L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"DEVAPRAKAS\\r\\nAM D"},{"CODE":"BMEE409E","TITLE":"Computational Fluid Dynamics","TYPE":"TH","CREDITS":2,"SLOT":"D1","FACULTY":"SIVAKUMAR\\r\\nR"},{"CODE":"BMEE418L","TITLE":"Materials for Electric and Hybrid\\r\\nElectric Vehicles","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RADHA R"},{"CODE":"BMEE498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BMHA302L","TITLE":"Industrial Automation","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SAKTHIVEL G"},{"CODE":"BMHA302P","TITLE":"Industrial Automation Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SAKTHIVEL G"},{"CODE":"BMHA303L","TITLE":"Industrial Robotics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"L PAVAN\\r\\nKALYAN"},{"CODE":"BMHA303P","TITLE":"Industrial Robotics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"L PAVAN\\r\\nKALYAN"},{"CODE":"BMHA311L","TITLE":"Additive Manufacturing","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"DR.PADMAN ABHAN R M"},{"CODE":"BMHA312L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SARAVANAK\\r\\nUMAR D"},{"CODE":"BMHA313E","TITLE":"Driver Assistance Systems and Autonomous Vehicles","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"G\\r\\nMURALIMOH AN"},{"CODE":"BMHA315L","TITLE":"Augmented Reality and Haptics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ESWARAN M"},{"CODE":"BMHA316L","TITLE":"Machinery Condition Monitoring","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JEGADEESHW\\r\\nARAN R"},{"CODE":"BMHA401L","TITLE":"Computer Integrated\\r\\nManufacturing","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"GAJANAND\\r\\nGUPTA"},{"CODE":"BMHA401P","TITLE":"Computer Integrated\\r\\nManufacturing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"GAJANAND\\r\\nGUPTA"},{"CODE":"BMHA498J","TITLE":"Project-II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MACDM699","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MAMHA50","TITLE":"Industrial Automation","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MAHESWARI\\r\\nC"},{"CODE":"MAMHA50","TITLE":"Artificial Intelligence for\\r\\nMechatronics","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"SUGUMARAN\\r\\nV"},{"CODE":"MAMHA60","TITLE":"Machine Vision for Mechatronics","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"BONDA ATCHUTA GANESH\\r\\nYUVA RAJU"},{"CODE":"MAMHA60","TITLE":"Industrial Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"PRADEEP N"},{"CODE":"MAMHA61","TITLE":"Virtual and Augmented Reality\\r\\nTechnologies","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ESWARAN M"},{"CODE":"MAMHA69","TITLE":"Internship II/ Dissertation II","TYPE":"TH","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BACHY101","TITLE":"Environmental Sciences","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"KIRAN KUMAR TADI"},{"CODE":"BAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ALAMELU C"},{"CODE":"BAENG101","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RASHMI\\r\\nREKHA BORAH"},{"CODE":"BAESP101","TITLE":"Spanish Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"SAVARIAH\\r\\nXAVIER Y C"},{"CODE":"BAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"GOVINDARAJ\\r\\nAN P"},{"CODE":"BAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"JAMUNARAN\\r\\nI M"},{"CODE":"BAHUM101","TITLE":"India Studies","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"VIJAYALAKSH\\r\\nMI V"},{"CODE":"BAHUM103","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"RAJKUMAR R"},{"CODE":"BAHUM106","TITLE":"Micro Economics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SHALINA\\r\\nSUSAN MATHEW"},{"CODE":"BAHUM107","TITLE":"Macro Economics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SATHIS\\r\\nKUMAR G"},{"CODE":"BAHUM108","TITLE":"Public Policy and Administration","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ARUN\\r\\nKUMAR G"},{"CODE":"BAHUM109","TITLE":"Principles of Sociology","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"BINU\\r\\nSAHAYAM D"},{"CODE":"BAHUM110","TITLE":"Sustainability and Society","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ROOPESH O\\r\\nB"},{"CODE":"BAHUM111","TITLE":"Introduction to Psychology","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MAHARISHI R"},{"CODE":"BAHUM112","TITLE":"Psychology in Everyday Life","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"DURGA R P"},{"CODE":"BAHUM113","TITLE":"Indigenous Narratives and\\r\\nKnowledge Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ANUJA RAJ"},{"CODE":"BAHUM114","TITLE":"Literature Through Films","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SUNANDA\\r\\nKAR"},{"CODE":"BAHUM115","TITLE":"Science Fiction Stories of Tomorrow","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RASHMI REKHA\\r\\nBORAH"},{"CODE":"BAHUM115","TITLE":"Science Fiction Stories of\\r\\nTomorrow","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"RAJITHA K"},{"CODE":"BAHUM117","TITLE":"Indian writing in English","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SIVAKAMI B"},{"CODE":"BAHUM119","TITLE":"International Relations","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"GOKUL K S"},{"CODE":"BAHUM251","TITLE":"Indian Constitution","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"TARANG\\r\\nMAHAJAN"},{"CODE":"BAJAP101","TITLE":"Japanese Level I","TYPE":"TH","CREDITS":1,"SLOT":"TE1","FACULTY":"M JAYASHREE\\r\\nDASS"},{"CODE":"BAKOR101","TITLE":"Basic Korean \xe2\u20AC\u201C Level 1 (??\\r\\n???1)","TYPE":"TH","CREDITS":1,"SLOT":"TA1","FACULTY":"JINYOUNG\\r\\nKIM"},{"CODE":"BENG101L","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"HARSHA V"},{"CODE":"BENG101P","TITLE":"Technical English\\r\\nCommunication Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"HARSHA V"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SUBBU\\r\\nLAKSHMI M"},{"CODE":"BHUM101N","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"VIJAYALAKSH\\r\\nMI V"},{"CODE":"BSSC101N","TITLE":"Essence of Traditional\\r\\nKnowledge","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"ROOPESH O\\r\\nB"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"BERTILA A"},{"CODE":"IAENG101","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ALAN G"},{"CODE":"IAESP101","TITLE":"Spanish Level I","TYPE":"TH","CREDITS":1,"SLOT":"TB2","FACULTY":"INL-\\r\\nSPANISH01"},{"CODE":"IAFRE101","TITLE":"French Level I","TYPE":"TH","CREDITS":1,"SLOT":"TB1","FACULTY":"INL-\\r\\nFRENCH02"},{"CODE":"IAGER101","TITLE":"German Level I","TYPE":"TH","CREDITS":1,"SLOT":"TB1","FACULTY":"INL-\\r\\nGERMAN01"},{"CODE":"IAHUM101","TITLE":"India Studies","TYPE":"TH","CREDITS":1,"SLOT":"NIL","FACULTY":"BINU\\r\\nSAHAYAM D"},{"CODE":"IHUM101N","TITLE":"Ethics and Values","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"BINU\\r\\nSAHAYAM D"},{"CODE":"IHUM202L","TITLE":"Rural Development","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VIJAYALAKSH\\r\\nMI V"},{"CODE":"ISSC101N","TITLE":"Essence of Traditional Knowledge","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"TIWARI MAHALAXMI SHIVSHANKA\\r\\nR"},{"CODE":"ISSC102N","TITLE":"Indian Constitution","TYPE":"TH","CREDITS":2,"SLOT":"NIL","FACULTY":"HELEN P\\r\\nAZYU"},{"CODE":"UAENG102","TITLE":"Technical English\\r\\nCommunication","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"RAJASEKARA\\r\\nN V"},{"CODE":"UAFRE101","TITLE":"French","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"GOVINDARAJ\\r\\nAN P"},{"CODE":"BAFST103","TITLE":"Garment Production Machinery","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"VASANTH\\r\\nKUMAR"},{"CODE":"BAFST201","TITLE":"Fashion Illustration","TYPE":"LO","CREDITS":4,"SLOT":"L25+L26+L37+ L38+L39+L40+\\r\\nL55+L56","FACULTY":"CHARMINI B"},{"CODE":"BAFST205","TITLE":"Sports and Recreational Textiles","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RATHINAMO\\r\\nORTHY R"},{"CODE":"BAFST206","TITLE":"Pattern Making and Garment\\r\\nConstruction II","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"MAANVIZHI\\r\\nM"},{"CODE":"BAFST302","TITLE":"Fashion Psychology","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD\\r\\n1","FACULTY":"MAANVIZHI\\r\\nM"},{"CODE":"BAFST316","TITLE":"Global Fashion Marketing and\\r\\nMerchandising","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"RATHINAMO\\r\\nORTHY R"},{"CODE":"BAFST323","TITLE":"Fashion Accessories","TYPE":"TH","CREDITS":2,"SLOT":"D1","FACULTY":"N. GAYATHRI"},{"CODE":"BFST103L","TITLE":"Apparel Machineries","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VASANTH\\r\\nKUMAR"},{"CODE":"BFST210E","TITLE":"Visual Merchandising","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SAROJ K M"},{"CODE":"BFST401L","TITLE":"Textile Processing and Finishing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SELVAKUMA\\r\\nR"},{"CODE":"BFST401P","TITLE":"Textile Processing and Finishing\\r\\nLab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SELVAKUMA\\r\\nR"},{"CODE":"BFST402L","TITLE":"Fabric Structure and Design\\r\\nAnalysis","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"PALANI\\r\\nRAJAN T"},{"CODE":"BFST402P","TITLE":"Fabric Structure and Design\\r\\nAnalysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PALANI\\r\\nRAJAN T"},{"CODE":"BFST403P","TITLE":"Computer Aided Garment Design Lab","TYPE":"LO","CREDITS":3,"SLOT":"L5+L6+L31+L3 2+L49+L50","FACULTY":"RAJA\\r\\nBALASARAS WATHI S"},{"CODE":"BFST404L","TITLE":"Retail Management","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VASANTH\\r\\nKUMAR"},{"CODE":"BFST498J","TITLE":"Project - II / Internship","TYPE":"TH","CREDITS":5,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"MMA3099","TITLE":"Capstone Project","TYPE":"TH","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"BAHUM202","TITLE":"Security Analysis and Portfolio Management","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MOHD\\r\\nHAMMAD NAEEM"},{"CODE":"BAHUM202","TITLE":"Security Analysis and Portfolio\\r\\nManagement","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"BUVANESH C"},{"CODE":"BAHUM203","TITLE":"Options, Futures, and Derivatives","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RAJESH A D J"},{"CODE":"BAHUM204","TITLE":"Fixed Income Securities","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"BUVANESH C"},{"CODE":"BAMGT211","TITLE":"Negotiation and Selling: Tactics\\r\\nand Practice","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"BALAJI J"},{"CODE":"BAMGT213","TITLE":"Content and Brand Storytelling","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SHAMAL S"},{"CODE":"BAMGT215","TITLE":"Emotional Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"NISHA R"},{"CODE":"BAMGT217","TITLE":"FinTech","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SUDARSANA\\r\\nM S K"},{"CODE":"BAMGT221","TITLE":"Personal Wealth Management","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MANU JOSE"},{"CODE":"BMGT101L","TITLE":"Principles of Management","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"NISHA R"},{"CODE":"BMGT102L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ARCHANA\\r\\nSINGH"},{"CODE":"BMGT103L","TITLE":"Organizational Behavior","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SUMATHI G\\r\\nN"},{"CODE":"BMGT104L","TITLE":"Marketing Management","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ANURADHA\\r\\nA"},{"CODE":"BMGT105L","TITLE":"Consumer Behavior","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KISHORE\\r\\nTHOMAS JOHN"},{"CODE":"BMGT106L","TITLE":"Digital Marketing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SHAMAL S"},{"CODE":"BMGT107L","TITLE":"Business Analytics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ANBUMATHI\\r\\nR"},{"CODE":"MGT3006","TITLE":"Neuro Marketing","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"THANGARAJA ARUMUGAM"},{"CODE":"MGT3013","TITLE":"Risk and Fraud Analytics","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAJESH A D J"},{"CODE":"MGT3014","TITLE":"Operations Analytics","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"VADIVEL S M"},{"CODE":"MGT3015","TITLE":"Supply Chain Analytics","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RIJAS B M"},{"CODE":"BAHUM205","TITLE":"Intellectual Property Rights and\\r\\nthe Law","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"BILAL A\\r\\nNAZEER"},{"CODE":"MASTS505","TITLE":"Professional Soft Skills","TYPE":"TH","CREDITS":3,"SLOT":"I2+N1+U4","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"PASTS502","TITLE":"Qualitative and Quantitative\\r\\nSkills II","TYPE":"TH","CREDITS":3,"SLOT":"I2+N1+U4","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"PASTS601","TITLE":"Competitive Coding I","TYPE":"TH","CREDITS":3,"SLOT":"I3+M1+N2","FACULTY":"FACE (APT)"},{"CODE":"PACHY503","TITLE":"Organic Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"M8+N8+R8","FACULTY":"SARAVANAK\\r\\nUMAR R"},{"CODE":"PACHY504","TITLE":"Molecular Spectroscopy","TYPE":"TH","CREDITS":4,"SLOT":"I1+M2+R2+U1","FACULTY":"BALAMURALI\\r\\nM M"},{"CODE":"PACHY506","TITLE":"Analytical Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"I2+M3+U3","FACULTY":"ILAIYARAJA\\r\\nPERUMAL"},{"CODE":"PACHY507","TITLE":"Computational Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"M5+N2+R5","FACULTY":"RAJESHKUM\\r\\nAR T"},{"CODE":"PACHY621","TITLE":"Organometallic Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"I7+M4+R1","FACULTY":"SUNIT\\r\\nKUMAR"},{"CODE":"PAMDS503","TITLE":"Statistical Inference","TYPE":"TH","CREDITS":3,"SLOT":"N4+R3+U2","FACULTY":"UMA MAHESWARI\\r\\nS"},{"CODE":"PAMDS505","TITLE":"Data Mining and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"M4+R1+U6","FACULTY":"SURATH\\r\\nGHOSH"},{"CODE":"PAMDS506","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"I5+M3+R5","FACULTY":"FELIX A"},{"CODE":"PAMDS605","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":4,"SLOT":"I1+N3+R4+U5","FACULTY":"KALIYAPPAN\\r\\nM"},{"CODE":"PAMDS606","TITLE":"Data Structures and Algorithms","TYPE":"TH","CREDITS":3,"SLOT":"I1+R4+U5","FACULTY":"NATHIYA N"},{"CODE":"PAMDS609","TITLE":"Generative AI","TYPE":"TH","CREDITS":4,"SLOT":"I4+M2+R2+U3","FACULTY":"KALIYAPPAN\\r\\nM"},{"CODE":"PAPHY503","TITLE":"Classical Electrodynamics","TYPE":"TH","CREDITS":4,"SLOT":"I3+N3+R6+U5","FACULTY":"SANJIT DAS"},{"CODE":"PAPHY505","TITLE":"Statistical Mechanics","TYPE":"TH","CREDITS":4,"SLOT":"M3+M4+N2+R 4","FACULTY":"KORLEPARA\\r\\nDIVYA BHARATHI"},{"CODE":"PAPHY506","TITLE":"Solid State Physics","TYPE":"TH","CREDITS":3,"SLOT":"M2+R3+U3","FACULTY":"ATANU\\r\\nDUTTA"},{"CODE":"PAPHY602","TITLE":"Nuclear Physics","TYPE":"TH","CREDITS":3,"SLOT":"I6+N4+R5","FACULTY":"DAYASINDHU\\r\\nDEY"},{"CODE":"PAPHY603","TITLE":"Atomic and Molecular Physics","TYPE":"TH","CREDITS":3,"SLOT":"I5+M6+R2","FACULTY":"MANIKANDA\\r\\nN N"},{"CODE":"PAPHY619","TITLE":"Physics of Nanotechnology","TYPE":"TH","CREDITS":3,"SLOT":"I4+M5+U2","FACULTY":"JOHN\\r\\nKENNEDY  L"},{"CODE":"PCHY625P","TITLE":"General Organic & Inorganic\\r\\nChemistry Lab","TYPE":"TH","CREDITS":2,"SLOT":"I7+I8+I9+I10","FACULTY":"SARAVANAK\\r\\nUMAR R"},{"CODE":"PMDS501L","TITLE":"Applied Linear Algebra","TYPE":"TH","CREDITS":3,"SLOT":"I4+N3+U7","FACULTY":"SETHUKUMA\\r\\nRASAMY"},{"CODE":"PMDS503L","TITLE":"Statistical Inference","TYPE":"TH","CREDITS":2,"SLOT":"I2+M5","FACULTY":"MANIVANNA\\r\\nN A"},{"CODE":"PMDS504L","TITLE":"Regression Analysis and Predictive Models","TYPE":"TH","CREDITS":3,"SLOT":"N3+R2+U1","FACULTY":"UMA MAHESWARI\\r\\nS"},{"CODE":"PMDS505L","TITLE":"Data Mining and Machine\\r\\nLearning","TYPE":"TH","CREDITS":3,"SLOT":"I8+R8+U8","FACULTY":"HANNAH\\r\\nGRACE G"},{"CODE":"PMDS605L","TITLE":"Data Structures and Algorithms","TYPE":"TH","CREDITS":3,"SLOT":"I3+N2+U2","FACULTY":"NATHIYA N"},{"CODE":"PMDS606L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"N7+R8+U8","FACULTY":"KALIYAPPAN\\r\\nM"},{"CODE":"PMDS607L","TITLE":"Optimization Techniques","TYPE":"TH","CREDITS":3,"SLOT":"I5+N4+U3","FACULTY":"MANIMARAN\\r\\nJ"},{"CODE":"UACHY101","TITLE":"Environmental Sciences","TYPE":"TH","CREDITS":2,"SLOT":"R3+U2","FACULTY":"SHYAMAPAD\\r\\nA NANDI"},{"CODE":"UAECH203","TITLE":"Mathematics for Economics II","TYPE":"TH","CREDITS":4,"SLOT":"I2+N1+R5+U4","FACULTY":"MUHAMMED NAJEEB K K"},{"CODE":"UCHY101L","TITLE":"Environmental Science","TYPE":"TH","CREDITS":2,"SLOT":"R5+U5","FACULTY":"SUBHAYAN\\r\\nDEY"},{"CODE":"MACSE505","TITLE":"Deep Learning and Gen AI","TYPE":"TH","CREDITS":3,"SLOT":"I4+M4+N4","FACULTY":"VIJAYAPRABA\\r\\nKARAN K"},{"CODE":"MACSE506","TITLE":"Distributed Data Processing","TYPE":"TH","CREDITS":3,"SLOT":"R6+R7+R8","FACULTY":"LTI SCOPE1"},{"CODE":"MACSE509","TITLE":"Applied Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"M2+N4+U5","FACULTY":"KHADAR\\r\\nNAWAS K"},{"CODE":"MACSE510","TITLE":"Generative AI with Large\\r\\nLanguage Models","TYPE":"TH","CREDITS":3,"SLOT":"M6+N3+R6","FACULTY":"JANAKI\\r\\nMEENA M"},{"CODE":"MACSE601","TITLE":"Application Architecture and\\r\\nDeployment","TYPE":"TH","CREDITS":3,"SLOT":"R3+R4+R5","FACULTY":"LTI SCOPE1"},{"CODE":"MACSE604","TITLE":"Edge Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"I5+M3+N7","FACULTY":"RAJESH\\r\\nKUMAR"},{"CODE":"MACSE605","TITLE":"Large Language Models","TYPE":"TH","CREDITS":4,"SLOT":"U1+U2+U3+U\\r\\n5","FACULTY":"LTI SCOPE1"},{"CODE":"MACSE609","TITLE":"Security for Data Science","TYPE":"TH","CREDITS":3,"SLOT":"M7+N8+U3","FACULTY":"SRISAKTHI SARAVANAN"},{"CODE":"MACSE611","TITLE":"Healthcare Analytics","TYPE":"TH","CREDITS":3,"SLOT":"I7+M5+N7","FACULTY":"SANGEETHA\\r\\nN"},{"CODE":"UCSC227E","TITLE":"Python Programming","TYPE":"TH","CREDITS":3,"SLOT":"I3+M1+U5","FACULTY":"RENUKA DEVI\\r\\nR"},{"CODE":"HUM1022","TITLE":"Psychology in Everyday Life","TYPE":"TH","CREDITS":2,"SLOT":"I4+M6","FACULTY":"SAROJ K M"},{"CODE":"STS2012","TITLE":"Aptitude and Reasoning Skills","TYPE":"TH","CREDITS":1,"SLOT":"M4+R2+U1","FACULTY":"FACE (APT)"},{"CODE":"UAECH106","TITLE":"Econometrics I","TYPE":"TH","CREDITS":3,"SLOT":"M5+R4+U3","FACULTY":"MALLIKA\\r\\nSINHA"},{"CODE":"UAECH201","TITLE":"Microeconomics II","TYPE":"TH","CREDITS":4,"SLOT":"I5+M3+N4+R3","FACULTY":"SHALINA SUSAN\\r\\nMATHEW"},{"CODE":"UAECH202","TITLE":"Macroeconomics II","TYPE":"TH","CREDITS":4,"SLOT":"I3+M1+N2+U5","FACULTY":"SATHIS\\r\\nKUMAR G"},{"CODE":"UBBH151L","TITLE":"Verbal Reasoning","TYPE":"TH","CREDITS":1,"SLOT":"R3","FACULTY":"PATCHAINAY\\r\\nAGI S"},{"CODE":"UCCH102L","TITLE":"Macro Economics","TYPE":"TH","CREDITS":4,"SLOT":"I3+M1+N2+U5","FACULTY":"MUHAMMED NAJEEB K K"},{"CODE":"UCSC229E","TITLE":"Structured Query Language (SQL)","TYPE":"TH","CREDITS":3,"SLOT":"I4+M2+N3","FACULTY":"GAYATHRI\\r\\nDEVI S"},{"CODE":"UCSC232E","TITLE":"Analytics with Excel","TYPE":"TH","CREDITS":1,"SLOT":"R5","FACULTY":"SHALINA\\r\\nSUSAN MATHEW"},{"CODE":"UECH206E","TITLE":"Applied Economic Research","TYPE":"TH","CREDITS":1,"SLOT":"U4","FACULTY":"MALLIKA\\r\\nSINHA"},{"CODE":"UECH401L","TITLE":"Advanced Research Methods\\r\\nEconomics","TYPE":"TH","CREDITS":4,"SLOT":"M4+N3+R3+U\\r\\n5","FACULTY":"MALLIKA\\r\\nSINHA"},{"CODE":"UECH402L","TITLE":"Economics of Entrepreneurship","TYPE":"TH","CREDITS":4,"SLOT":"I1+M6+R2+U6","FACULTY":"SARADHA\\r\\nRAJKUMAR"},{"CODE":"UECH403L","TITLE":"Economics of Sustainability","TYPE":"TH","CREDITS":4,"SLOT":"I5+M3+N4+R1","FACULTY":"SARADHA\\r\\nRAJKUMAR"},{"CODE":"UECH404E","TITLE":"Primary Data Analyses for\\r\\nEconomics","TYPE":"TH","CREDITS":2,"SLOT":"I4+M5","FACULTY":"MAGULSHA\\r\\nGEORGE"},{"CODE":"UECH405E","TITLE":"Secondary Data Analyses for\\r\\nEconomics","TYPE":"TH","CREDITS":2,"SLOT":"I3+N2","FACULTY":"JAYARAJ R"},{"CODE":"UENG104L","TITLE":"Writing Across Context","TYPE":"TH","CREDITS":2,"SLOT":"M2+N3","FACULTY":"PATCHAINAY\\r\\nAGI S"},{"CODE":"UFRE102L","TITLE":"French","TYPE":"TH","CREDITS":3,"SLOT":"I2+N1+U4","FACULTY":"PRIYA SINGH"},{"CODE":"UHUM106E","TITLE":"Data Analysis and Visualization","TYPE":"TH","CREDITS":2,"SLOT":"R4+U3","FACULTY":"URJANI CHAKRAVART\\r\\nY"},{"CODE":"ULAS108L","TITLE":"Gender Studies","TYPE":"TH","CREDITS":4,"SLOT":"M4+N5+R2+U 1","FACULTY":"DEVI\\r\\nMEENAKSHI K"},{"CODE":"FSD1001","TITLE":"Fibre to Fabric","TYPE":"TH","CREDITS":3,"SLOT":"M2+R6+U3","FACULTY":"S.VINUSOWN\\r\\nDARYA"},{"CODE":"FSD2003","TITLE":"Childrens wear and Womens wear","TYPE":"TH","CREDITS":4,"SLOT":"I1+I2+I3+M1+ M2+M3+N3+\\r\\nN4","FACULTY":"RAJESH KUMAR K"},{"CODE":"FSD2010","TITLE":"Textile Processing and Finishing","TYPE":"TH","CREDITS":3,"SLOT":"I4+M6+R5","FACULTY":"SELVAKUMA\\r\\nR"},{"CODE":"FSD2020","TITLE":"Psychology of fashion","TYPE":"TH","CREDITS":3,"SLOT":"I6+R3+U5","FACULTY":"BHUVANESH\\r\\nWARI MOHAN"},{"CODE":"FSD2021","TITLE":"Fashion forecasting and trend\\r\\nanalysis","TYPE":"TH","CREDITS":3,"SLOT":"I6+R3+U5","FACULTY":"RAJESH\\r\\nKUMAR K"},{"CODE":"FSD2023","TITLE":"Fashion Photography and\\r\\nmodelling","TYPE":"TH","CREDITS":3,"SLOT":"N1+R1+U2","FACULTY":"JESICA\\r\\nROSHIMA A"},{"CODE":"FSD2026","TITLE":"Fashion Marketing and\\r\\nManagement","TYPE":"TH","CREDITS":3,"SLOT":"M5+R4+U6","FACULTY":"S.VINUSOWN\\r\\nDARYA"},{"CODE":"FSD3001","TITLE":"Digital Fashion Illustration","TYPE":"TH","CREDITS":3,"SLOT":"N2+N3+N4+R\\r\\n1+R2+R3","FACULTY":"S.VINUSOWN\\r\\nDARYA"},{"CODE":"FSD3005","TITLE":"Textile and Apparel Testing","TYPE":"TH","CREDITS":2,"SLOT":"N2+U3","FACULTY":"BHUVANESH\\r\\nWARI MOHAN"},{"CODE":"UAFSD102","TITLE":"Fashion Narratives","TYPE":"TH","CREDITS":3,"SLOT":"I6+M1+U4","FACULTY":"SAROJ K M"},{"CODE":"UAFSD105","TITLE":"Indian Indigenous Textiles","TYPE":"TH","CREDITS":4,"SLOT":"I1+M2+R2+U1","FACULTY":"BANUMATHY\\r\\nS"},{"CODE":"UAFSD201","TITLE":"Textile Studies II","TYPE":"TH","CREDITS":2,"SLOT":"I2+U3","FACULTY":"RAJA\\r\\nBALASARAS WATHI S"},{"CODE":"UAFSD205","TITLE":"Design Studio II: Components Construction and Kids Wear","TYPE":"TH","CREDITS":4,"SLOT":"M4+M5+M6+ R4+R5+R6+U5\\r\\n+U6","FACULTY":"JESICA ROSHIMA A"},{"CODE":"MGT1018","TITLE":"Consumer Behaviour","TYPE":"TH","CREDITS":3,"SLOT":"I5+R6+U4","FACULTY":"BANUMATHY\\r\\nS"},{"CODE":"PAMBA508","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"I5+R6+U6","FACULTY":"REKHAPRIYA DHARSHINI A"},{"CODE":"PAMBA509","TITLE":"Operations Management","TYPE":"TH","CREDITS":3,"SLOT":"I1+M2+N3","FACULTY":"STEPHAN THANGAIAH"},{"CODE":"PAMBA510","TITLE":"Business Research Methods","TYPE":"TH","CREDITS":3,"SLOT":"I1+M2+N3","FACULTY":"THANGARAJA ARUMUGAM"},{"CODE":"PAMBA511","TITLE":"Financial Management","TYPE":"TH","CREDITS":3,"SLOT":"I4+R5+U5","FACULTY":"SHARON\\r\\nSOPHIA"},{"CODE":"PAMBA512","TITLE":"Business Analytics","TYPE":"TH","CREDITS":2,"SLOT":"M5+M6","FACULTY":"PADMAVATH\\r\\nY C"},{"CODE":"PAMBA513","TITLE":"Strategic Management and\\r\\nSustainable Business","TYPE":"TH","CREDITS":3,"SLOT":"N4+R4+U4","FACULTY":"SAJU B"},{"CODE":"PAMBA513","TITLE":"Strategic Management and Sustainable Business","TYPE":"TH","CREDITS":3,"SLOT":"I7+M6+U8","FACULTY":"STEPHAN THANGAIAH"},{"CODE":"PAMBA514","TITLE":"Entrepreneurship and Design\\r\\nThinking","TYPE":"TH","CREDITS":3,"SLOT":"I7+M3+R8","FACULTY":"SUJATHA\\r\\nMANOHAR"},{"CODE":"UBBH104L","TITLE":"Business Law and Ethics","TYPE":"TH","CREDITS":4,"SLOT":"I6+I9+M8+U9","FACULTY":"CHITRA DEVI\\r\\nA"},{"CODE":"UBBH106L","TITLE":"Management Accounting","TYPE":"TH","CREDITS":4,"SLOT":"N7+R9+U4+U\\r\\n8","FACULTY":"CHITRA DEVI\\r\\nN"},{"CODE":"UBBH107L","TITLE":"Macro Economics","TYPE":"TH","CREDITS":4,"SLOT":"I1+M6+R4+U3","FACULTY":"ALLI P"},{"CODE":"UBBH152L","TITLE":"Quantitative Reasoning","TYPE":"TH","CREDITS":1,"SLOT":"N5","FACULTY":"SIXPHRASE(A\\r\\nPT)"},{"CODE":"UBBH158P","TITLE":"Equity Market Analytics","TYPE":"TH","CREDITS":1,"SLOT":"U1+U2","FACULTY":"SREEYA B"},{"CODE":"UBBH206E","TITLE":"Business Analytics & AI","TYPE":"TH","CREDITS":3,"SLOT":"M3+N4+R1","FACULTY":"REEVES\\r\\nWESLEY J"},{"CODE":"UBBH208L","TITLE":"Managing People & Teams at\\r\\nWork","TYPE":"TH","CREDITS":4,"SLOT":"I6+M2+N2+U4","FACULTY":"NISHA R"},{"CODE":"UBBH209L","TITLE":"Managing Innovation","TYPE":"TH","CREDITS":4,"SLOT":"I7+I8+M1+M2","FACULTY":"TISHA MERIAM\\r\\nCHERIAN"},{"CODE":"UBBH213L","TITLE":"Brand Strategies","TYPE":"TH","CREDITS":4,"SLOT":"I7+M1+M7+R 9","FACULTY":"MALAY BHATTACHAR\\r\\nJEE"},{"CODE":"UBBH214L","TITLE":"Digital and Social Media Marketing","TYPE":"TH","CREDITS":4,"SLOT":"I6+M2+N2+U4","FACULTY":"SUDHEER MUHAMMED\\r\\nK M"},{"CODE":"UBBH217E","TITLE":"Advanced Statistics for Data\\r\\nScience","TYPE":"TH","CREDITS":3,"SLOT":"M8+N9+U8","FACULTY":"ANBUMATHI\\r\\nR"},{"CODE":"UBBH218E","TITLE":"Programming in Python","TYPE":"TH","CREDITS":3,"SLOT":"I1+I2+U7","FACULTY":"BHARATH\\r\\nSANKAR S"},{"CODE":"UBBH301L","TITLE":"Strategic Management","TYPE":"TH","CREDITS":4,"SLOT":"I2+M1+N2+U6","FACULTY":"RAJKUMAR MURUGESAN"},{"CODE":"UBBH302L","TITLE":"Business Research Methods","TYPE":"TH","CREDITS":4,"SLOT":"M4+M5+N4+ N5","FACULTY":"ASI VASU DEVA REDDY"},{"CODE":"UBBH303L","TITLE":"Entrepreneurship","TYPE":"TH","CREDITS":4,"SLOT":"I3+N3+R3+U1","FACULTY":"SUJATHA\\r\\nMANOHAR"},{"CODE":"UBBH304L","TITLE":"Global Business Environment","TYPE":"TH","CREDITS":4,"SLOT":"I4+M8+R5+U5","FACULTY":"JOSEPH JEYA ANAND  S"},{"CODE":"UBBH321L","TITLE":"Application of Mathematics in Business","TYPE":"TH","CREDITS":4,"SLOT":"I5+M7+N9+U7","FACULTY":"TISHA MERIAM\\r\\nCHERIAN"},{"CODE":"UBBH497J","TITLE":"Co-Op","TYPE":"TH","CREDITS":8,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"UCCH104L","TITLE":"Business Laws","TYPE":"TH","CREDITS":4,"SLOT":"I1+M6+N6+U2","FACULTY":"BHAVANI J"},{"CODE":"UCCH107L","TITLE":"Corporate Accounting","TYPE":"TH","CREDITS":4,"SLOT":"I2+N1+R5+U4","FACULTY":"SIVAKUMAR\\r\\nK"},{"CODE":"UCCH202L","TITLE":"Cost Accounting","TYPE":"TH","CREDITS":4,"SLOT":"I5+M7+N9+U7","FACULTY":"WASI\\r\\nYAZDANI"},{"CODE":"UCCH205L","TITLE":"Marketing Management","TYPE":"TH","CREDITS":4,"SLOT":"I1+M6+N8+R4","FACULTY":"SUDHEER\\r\\nMUHAMMED K M"},{"CODE":"UCCH206L","TITLE":"Investment Analysis and\\r\\nPortfolio Management","TYPE":"TH","CREDITS":4,"SLOT":"M3+N7+R7+U\\r\\n9","FACULTY":"SIVAKUMAR\\r\\nK"},{"CODE":"UCCH208L","TITLE":"Financial Statement Analysis and\\r\\nReporting","TYPE":"TH","CREDITS":4,"SLOT":"I2+M2+R2+U7","FACULTY":"MANU JOSE"},{"CODE":"UCCH214L","TITLE":"Auditing and Corporate\\r\\nGovernance","TYPE":"TH","CREDITS":4,"SLOT":"I5+M7+N1+R5","FACULTY":"MEENAKSHI\\r\\nSANKARAN"},{"CODE":"UCCH301L","TITLE":"Business Research Methods","TYPE":"TH","CREDITS":4,"SLOT":"I4+M4+R4+U1","FACULTY":"BHAVANI J"},{"CODE":"UCCH302L","TITLE":"Strategic Management","TYPE":"TH","CREDITS":4,"SLOT":"I1+M7+R3+U3","FACULTY":"RAJKUMAR MURUGESAN"},{"CODE":"UCCH303L","TITLE":"Operations Management","TYPE":"TH","CREDITS":4,"SLOT":"I5+M3+N4+R1","FACULTY":"WAQAS NIAZI"},{"CODE":"UCCH304L","TITLE":"FinTech","TYPE":"TH","CREDITS":4,"SLOT":"M5+N9+R7+U\\r\\n2","FACULTY":"MEENAKSHI\\r\\nSANKARAN"},{"CODE":"UCCH305L","TITLE":"Entrepreneurship","TYPE":"TH","CREDITS":4,"SLOT":"I2+N1+R5+U4","FACULTY":"MEKHALA\\r\\nANTONY"},{"CODE":"UCCH497J","TITLE":"Co-Op","TYPE":"TH","CREDITS":8,"SLOT":"NIL","FACULTY":"ACAD\\r\\nFACULTY"},{"CODE":"UCSC214E","TITLE":"Basic Data Visualization","TYPE":"TH","CREDITS":1,"SLOT":"N7","FACULTY":"ARSHIYA FATHIMA M\\r\\nS"},{"CODE":"UECH211L","TITLE":"Security Analysis and Portfolio\\r\\nManagement","TYPE":"TH","CREDITS":4,"SLOT":"I6+M5+R3+U2","FACULTY":"SHARON\\r\\nSOPHIA"},{"CODE":"ULAS106L","TITLE":"Sociology","TYPE":"TH","CREDITS":4,"SLOT":"M4+N5+R2+U\\r\\n1","FACULTY":"FARSANA KP"},{"CODE":"UABVI105","TITLE":"Scripting and Storyboarding","TYPE":"TH","CREDITS":4,"SLOT":"R5+R6","FACULTY":"SITHARA P V"},{"CODE":"UABVI106","TITLE":"Photography","TYPE":"TH","CREDITS":4,"SLOT":"R3+R4","FACULTY":"PADMANABH\\r\\nAN T"},{"CODE":"UABVI107","TITLE":"Visual Arts","TYPE":"TH","CREDITS":4,"SLOT":"U1+U2","FACULTY":"SITHARA P V"},{"CODE":"UAMMA10","TITLE":"Character and Environmental\\r\\nDesign","TYPE":"TH","CREDITS":4,"SLOT":"R5+R6","FACULTY":"THOMAS\\r\\nSMILES K"},{"CODE":"UAMMA10","TITLE":"Graphic Design I","TYPE":"TH","CREDITS":4,"SLOT":"U1+U2","FACULTY":"THOMAS\\r\\nSMILES K"},{"CODE":"UAMMA10","TITLE":"Photography","TYPE":"TH","CREDITS":4,"SLOT":"M7+M8","FACULTY":"GAYATHRI V"},{"CODE":"UAMMA10","TITLE":"Scripting and Storyboarding","TYPE":"TH","CREDITS":4,"SLOT":"M3+M4","FACULTY":"GAYATHRI V"},{"CODE":"TESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"SLOT":"TCCC+TDDD","FACULTY":"SAVARIAH\\r\\nXAVIER Y C"},{"CODE":"TFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"TCCC+TDDD","FACULTY":"INL-\\r\\nFRENCH01"},{"CODE":"TLAW103L","TITLE":"Law of Contracts","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"KESAVAMOO\\r\\nRTHY R"},{"CODE":"TLAW104L","TITLE":"Environmental Law","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"RESHMA\\r\\nSURESH"},{"CODE":"TLAW161L","TITLE":"Colonialism in India","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"SHASHIKANT\\r\\nSAURAV"},{"CODE":"TLAW162L","TITLE":"Principles of Modern\\r\\nGovernment","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"GOKUL K S"},{"CODE":"TLAW182L","TITLE":"English for Lawyers","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"S VIJAYALAKSH\\r\\nMI"},{"CODE":"TLAW184L","TITLE":"Financial Management","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"WASI\\r\\nYAZDANI"},{"CODE":"TLAW188L","TITLE":"Financial Accounting","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"WASI\\r\\nYAZDANI"},{"CODE":"TLAW202L","TITLE":"Law of Crimes- I","TYPE":"TH","CREDITS":4,"SLOT":"E+TE","FACULTY":"ASWATHY SUKUMARAN"},{"CODE":"TLAW206L","TITLE":"Labour and Industrial Law I","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"VIJAYENDRA\\r\\nKUMAR M"},{"CODE":"TLAW207L","TITLE":"Jurisprudence","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"ZAKKARIYA T\\r\\nH"},{"CODE":"TLAW261L","TITLE":"Political Thought: Indian and\\r\\nWestern","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"APD"},{"CODE":"TLAW262L","TITLE":"Public Finance Theory and\\r\\nPractice","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"ARUNA R"},{"CODE":"TLAW263L","TITLE":"Law and Social Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"SANTHOSH  V"},{"CODE":"TLAW264L","TITLE":"Public Administration","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"RAJEESH C S"},{"CODE":"TLAW281L","TITLE":"Operational Research","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"VADIVEL S M"},{"CODE":"TLAW283L","TITLE":"Marketing Management","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"ANU C H"},{"CODE":"TLAW284L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"SRILALITHA R"},{"CODE":"TLAW303L","TITLE":"Family Law-II","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"AMBIKA R\\r\\nNAIR"},{"CODE":"TLAW305L","TITLE":"Public International Law","TYPE":"TH","CREDITS":3,"SLOT":"F+TF","FACULTY":"PREMA E"},{"CODE":"TLAW307L","TITLE":"Property Law","TYPE":"TH","CREDITS":3,"SLOT":"E+TE","FACULTY":"AMBIKA R\\r\\nNAIR"},{"CODE":"TLAW310L","TITLE":"Professional Ethics and\\r\\nProfessional Accounting for Lawyers","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"NIKHIL G"},{"CODE":"TLAW310L","TITLE":"Professional Ethics and Professional Accounting for\\r\\nLawyers","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"SANTHOSH  V"},{"CODE":"TLAW311L","TITLE":"Intellectual Property Law","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"TANIA\\r\\nSEBASTIAN"},{"CODE":"TLAW404L","TITLE":"Comparative Constitutional Law","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"K KAMBAN\\r\\nSOCRETES"},{"CODE":"TLAW407L","TITLE":"Right to Information","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"SAJI SIVAN S"},{"CODE":"TLAW409L","TITLE":"Media and Law","TYPE":"TH","CREDITS":3,"SLOT":"C+TC","FACULTY":"ARJUN SHAJI"},{"CODE":"TLAW412L","TITLE":"Introduction to International\\r\\nHumanitarian Law","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"SONY RAJ S S"},{"CODE":"TLAW413L","TITLE":"Law Relating to WTO","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"KAVI\\r\\nSHANKAR"},{"CODE":"TLAW416L","TITLE":"Law of the Sea","TYPE":"TH","CREDITS":3,"SLOT":"A+TA","FACULTY":"SEZOLU\\r\\nNYEKHA"},{"CODE":"TLAW418L","TITLE":"International Refugee Law","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"AYUSHI SRIVASTAVA"},{"CODE":"TLAW420L","TITLE":"Patenting of Life Forms","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"VIJAYA BHARATHI RAVIKUMAR"},{"CODE":"TLAW423L","TITLE":"IPR in Pharma Industry","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"JISHNU J R"},{"CODE":"TLAW424L","TITLE":"Banking Law","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"K NIDHI\\r\\nMOHAN"},{"CODE":"TLAW427L","TITLE":"Insurance Law","TYPE":"TH","CREDITS":3,"SLOT":"C+TC","FACULTY":"ANKIT\\r\\nANAND"},{"CODE":"TLAW428L","TITLE":"Insolvency and Bankruptcy","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"K NIDHI\\r\\nMOHAN"},{"CODE":"TLAW430L","TITLE":"Corporate Governance","TYPE":"TH","CREDITS":3,"SLOT":"C+TC","FACULTY":"JAYENDRA\\r\\nKASTURE"},{"CODE":"TLAW431L","TITLE":"Competition Law","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"DULUNG\\r\\nSENGUPTA"},{"CODE":"TLAW432L","TITLE":"Equity and Trust","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"JAYENDRA\\r\\nKASTURE"},{"CODE":"TLAW435L","TITLE":"Prison Administration","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"SAJI SIVAN S"},{"CODE":"TLAW437L","TITLE":"Penology and Victimology","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"GANESAN K"},{"CODE":"TLAW441L","TITLE":"Financial and Systemic Fraud","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"TANMAY ROY"},{"CODE":"TLAW444L","TITLE":"Technology and Law","TYPE":"TH","CREDITS":4,"SLOT":"A+TA+TAA","FACULTY":"ADITYA S"},{"CODE":"TLAW445L","TITLE":"International Taxation Law","TYPE":"TH","CREDITS":4,"SLOT":"F+TF+TFF","FACULTY":"VANMATHI\\r\\nM"},{"CODE":"TLAW446L","TITLE":"Business Ethics and Human\\r\\nRights","TYPE":"TH","CREDITS":4,"SLOT":"C+TC+TCC","FACULTY":"POURNA\\r\\nDHEVI N"},{"CODE":"TLAW448L","TITLE":"Indian Legal System","TYPE":"TH","CREDITS":4,"SLOT":"E+TE+TEE","FACULTY":"TANMAY ROY"},{"CODE":"TLAW452L","TITLE":"Election Law","TYPE":"TH","CREDITS":4,"SLOT":"E+TE+TEE","FACULTY":"MRUDHUL M\\r\\nSHENOY"},{"CODE":"TLAW501L","TITLE":"Sports Law","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"NIKHIL G"},{"CODE":"TLAW502L","TITLE":"Women and Law","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"NAVYA\\r\\nBENNY"},{"CODE":"TLAW503L","TITLE":"Gender, Caste and the Law","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"ASWATHY SUKUMARAN"},{"CODE":"TLAW504L","TITLE":"Rural Governance","TYPE":"TH","CREDITS":4,"SLOT":"D+TD+TDD","FACULTY":"SHASHIKANT\\r\\nSAURAV"},{"CODE":"TLAW505L","TITLE":"Criminal Justice and Human\\r\\nRights","TYPE":"TH","CREDITS":3,"SLOT":"D+TD","FACULTY":"ABHISHEK\\r\\nRAJ"},{"CODE":"TLAW509L","TITLE":"Scientific Evidence in Criminal\\r\\nTrial","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"BIJOY\\r\\nSHARMA"},{"CODE":"TLAW517L","TITLE":"Constitutional Interpretation and Social  Justice","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"ARJUN PHILIP GEORGE"},{"CODE":"TLAW519L","TITLE":"Capital Markets and Securities\\r\\nLaw","TYPE":"TH","CREDITS":3,"SLOT":"E+TE","FACULTY":"POOJA"},{"CODE":"TLAW520L","TITLE":"International Commercial\\r\\nArbitration","TYPE":"TH","CREDITS":4,"SLOT":"E+TE+TEE","FACULTY":"ANKIT\\r\\nANAND"},{"CODE":"TLAW522L","TITLE":"Patent Drafting and Specification\\r\\nWriting","TYPE":"TH","CREDITS":4,"SLOT":"E+TE+TEE","FACULTY":"CHANDRIKA\\r\\nMEHTA"},{"CODE":"TLAW523L","TITLE":"Cyber Law","TYPE":"TH","CREDITS":4,"SLOT":"B+TB+TBB","FACULTY":"ARJUN SHAJI"},{"CODE":"PRES701L","TITLE":"Research Methodology","TYPE":"TH","CREDITS":4,"SLOT":"I4+N4+R5+U2","FACULTY":"SRUTHA\\r\\nKEERTHI B"},{"CODE":"MATR705","TITLE":"Topics in Applicable\\r\\nMathematics","TYPE":"TH","CREDITS":3,"SLOT":"N2+R3+U4","FACULTY":"SUKAVANAM\\r\\nN"},{"CODE":"MATR706","TITLE":"Topics in Advanced Mathematics","TYPE":"TH","CREDITS":3,"SLOT":"N2+R3+U4","FACULTY":"THARASI DILLESWAR\\r\\nRAO"},{"CODE":"PRMC001L","TITLE":"Research And Publication Ethics","TYPE":"TH","CREDITS":2,"SLOT":"I2+M5","FACULTY":"BALAMURUG\\r\\nAN B J"}]');

});

parcelRegister("7M6xr", function(module, exports) {
module.exports = JSON.parse('[{"CODE":"BITE306L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":4,"VENUE":"SJT807","SLOT":"A1+TA1+TAA1","FACULTY":"RAGHAVAN R"},{"CODE":"BITE306L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":4,"VENUE":"SJT803","SLOT":"A1+TA1+TAA1","FACULTY":"KURUVA LAKSHMANNA"},{"CODE":"BITE306L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":4,"VENUE":"SJTG24","SLOT":"A1+TA1+TAA1","FACULTY":"CHANDRASEGAR.T"},{"CODE":"BITE306L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":4,"VENUE":"SJT824","SLOT":"A1+TA1+TAA1","FACULTY":"PRADEEPA M"},{"CODE":"BITE306L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":4,"VENUE":"SJT824","SLOT":"A2+TA2+TAA2","FACULTY":"RAGHAVAN R"},{"CODE":"BITE306L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":4,"VENUE":"SJT825","SLOT":"A2+TA2+TAA2","FACULTY":"PRADEEPA M"},{"CODE":"BITE306L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":4,"VENUE":"SJT807","SLOT":"A2+TA2+TAA2","FACULTY":"KURUVA LAKSHMANNA"},{"CODE":"BITE306L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":4,"VENUE":"SJTG24","SLOT":"A2+TA2+TAA2","FACULTY":"CHANDRASEGAR.T"},{"CODE":"BITE412L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"VENUE":"SJT801","SLOT":"A2+TA2","FACULTY":"PRIYA V"},{"CODE":"BITE412L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"VENUE":"SJT825","SLOT":"A1+TA1","FACULTY":"SIVA RAMA KRISHNAN S"},{"CODE":"BITE412L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"VENUE":"SJT823","SLOT":"A1+TA1","FACULTY":"CHANDRA MOULISWARAN S"},{"CODE":"BITE311L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"VENUE":"SJT825","SLOT":"B1+TB1","FACULTY":"PRABHAVATHY P"},{"CODE":"BITE408L","TITLE":"Network Management","TYPE":"TH","CREDITS":3,"VENUE":"SJT823","SLOT":"B2+TB2","FACULTY":"JOTHISH KUMAR M"},{"CODE":"BITE403L","TITLE":"Embedded Systems and IoT","TYPE":"TH","CREDITS":3,"VENUE":"SJT824","SLOT":"C1+TC1","FACULTY":"NITHYA.S"},{"CODE":"BITE403L","TITLE":"Embedded Systems and IoT","TYPE":"TH","CREDITS":3,"VENUE":"SJT823","SLOT":"C1+TC1","FACULTY":"POUNAMBAL M"},{"CODE":"BITE403L","TITLE":"Embedded Systems and IoT","TYPE":"TH","CREDITS":3,"VENUE":"SJT823","SLOT":"C2+TC2","FACULTY":"POUNAMBAL M"},{"CODE":"BITE403L","TITLE":"Embedded Systems and IoT","TYPE":"TH","CREDITS":3,"VENUE":"SJT807","SLOT":"C2+TC2","FACULTY":"RAMPRIYA R S"},{"CODE":"BITE403L","TITLE":"Embedded Systems and IoT","TYPE":"TH","CREDITS":3,"VENUE":"SJT803","SLOT":"C2+TC2","FACULTY":"SWARNA PRIYA R.M"},{"CODE":"BITE403L","TITLE":"Embedded Systems and IoT","TYPE":"TH","CREDITS":3,"VENUE":"SJT807","SLOT":"C1+TC1","FACULTY":"RAMPRIYA R S"},{"CODE":"BITE403L","TITLE":"Embedded Systems and IoT","TYPE":"TH","CREDITS":3,"VENUE":"SJT803","SLOT":"C1+TC1","FACULTY":"SWARNA PRIYA R.M"},{"CODE":"BITE403L","TITLE":"Embedded Systems and IoT","TYPE":"TH","CREDITS":3,"VENUE":"SJT201","SLOT":"C2+TC2","FACULTY":"NITHYA.S"},{"CODE":"BITE403P","TITLE":"Embedded Systems and IoT Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT212","SLOT":"L21+L22","FACULTY":"NITHYA.S"},{"CODE":"BITE403P","TITLE":"Embedded Systems and IoT Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT212","SLOT":"L37+L38","FACULTY":"SWARNA PRIYA R.M"},{"CODE":"BITE403P","TITLE":"Embedded Systems and IoT Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT212","SLOT":"L45+L46","FACULTY":"NITHYA.S"},{"CODE":"BITE403P","TITLE":"Embedded Systems and IoT Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT212","SLOT":"L51+L52","FACULTY":"POUNAMBAL M"},{"CODE":"BITE403P","TITLE":"Embedded Systems and IoT Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT212","SLOT":"L23+L24","FACULTY":"POUNAMBAL M"},{"CODE":"BITE403P","TITLE":"Embedded Systems and IoT Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT212","SLOT":"L5+L6","FACULTY":"SWARNA PRIYA R.M"},{"CODE":"BITE403P","TITLE":"Embedded Systems and IoT Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT212","SLOT":"L31+L32","FACULTY":"RAMPRIYA R S"},{"CODE":"BITE403P","TITLE":"Embedded Systems and IoT Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT212","SLOT":"L15+L16","FACULTY":"RAMPRIYA R S"},{"CODE":"BITE314L","TITLE":"Multimedia Systems","TYPE":"TH","CREDITS":3,"VENUE":"SJT825","SLOT":"C1+TC1","FACULTY":"BALASUBRAMANI M"},{"CODE":"BITE305L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"VENUE":"SJT801","SLOT":"D2+TD2","FACULTY":"TAMIL PRIYA D"},{"CODE":"BITE305L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"VENUE":"SJT824","SLOT":"D2+TD2","FACULTY":"MOHANRAJ G"},{"CODE":"BITE305L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"VENUE":"SJT823","SLOT":"D1+TD1","FACULTY":"TAMIL PRIYA D"},{"CODE":"BITE305L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"VENUE":"SJT825","SLOT":"D1+TD1","FACULTY":"AASEEGHA M D"},{"CODE":"BITE305L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"VENUE":"SJT823","SLOT":"D2+TD2","FACULTY":"SANTHI K"},{"CODE":"BITE305L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"VENUE":"SJT824","SLOT":"D1+TD1","FACULTY":"ANBARASA KUMAR A"},{"CODE":"BITE305L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"VENUE":"SJT807","SLOT":"D2+TD2","FACULTY":"ANBARASA KUMAR A"},{"CODE":"BITE305L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"VENUE":"PRP230","SLOT":"D1+TD1","FACULTY":"RAMESH P.S"},{"CODE":"BITE305P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT216","SLOT":"L57+L58","FACULTY":"AASEEGHA M D"},{"CODE":"BITE305P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT120","SLOT":"L27+L28","FACULTY":"TAMIL PRIYA D"},{"CODE":"BITE305P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT120","SLOT":"L39+L40","FACULTY":"ANBARASA KUMAR A"},{"CODE":"BITE305P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT119","SLOT":"L19+L20","FACULTY":"MOHANRAJ G"},{"CODE":"BITE305P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT120","SLOT":"L29+L30","FACULTY":"SANTHI K"},{"CODE":"BITE305P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT120","SLOT":"L7+L8","FACULTY":"ANBARASA KUMAR A"},{"CODE":"BITE305P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT120","SLOT":"L41+L42","FACULTY":"RAMESH P.S"},{"CODE":"BITE305P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT216","SLOT":"L43+L44","FACULTY":"TAMIL PRIYA D"},{"CODE":"BITE308L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"VENUE":"SJT824","SLOT":"E1+TE1","FACULTY":"HEMALATHA S"},{"CODE":"BITE308L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"VENUE":"SJT825","SLOT":"E2+TE2","FACULTY":"HEMALATHA S"},{"CODE":"BITE308L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"VENUE":"SJT823","SLOT":"E1+TE1","FACULTY":"TAPAN KUMAR DAS"},{"CODE":"BITE308L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"VENUE":"SJT823","SLOT":"E2+TE2","FACULTY":"TAPAN KUMAR DAS"},{"CODE":"BITE308L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"VENUE":"SJT105","SLOT":"E1+TE1","FACULTY":"VALARMATHI B"},{"CODE":"BITE308L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"VENUE":"SJT825","SLOT":"E1+TE1","FACULTY":"SRINIVAS KOPPU"},{"CODE":"BITE308L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"VENUE":"SJT105","SLOT":"E2+TE2","FACULTY":"VALARMATHI B"},{"CODE":"BITE308L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"VENUE":"SJT824","SLOT":"E2+TE2","FACULTY":"SRINIVAS KOPPU"},{"CODE":"BITE308P","TITLE":"Artificial Intelligence Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT122","SLOT":"L29+L30","FACULTY":"SRINIVAS KOPPU"},{"CODE":"BITE308P","TITLE":"Artificial Intelligence Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT122","SLOT":"L47+L48","FACULTY":"VALARMATHI B"},{"CODE":"BITE308P","TITLE":"Artificial Intelligence Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT119","SLOT":"L11+L12","FACULTY":"HEMALATHA S"},{"CODE":"BITE308P","TITLE":"Artificial Intelligence Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT218","SLOT":"L59+L60","FACULTY":"SRINIVAS KOPPU"},{"CODE":"BITE308P","TITLE":"Artificial Intelligence Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT212","SLOT":"L3+L4","FACULTY":"VALARMATHI B"},{"CODE":"BITE308P","TITLE":"Artificial Intelligence Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT218","SLOT":"L33+L34","FACULTY":"HEMALATHA S"},{"CODE":"BITE308P","TITLE":"Artificial Intelligence Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT122","SLOT":"L43+L44","FACULTY":"TAPAN KUMAR DAS"},{"CODE":"BITE308P","TITLE":"Artificial Intelligence Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT218","SLOT":"L27+L28","FACULTY":"TAPAN KUMAR DAS"},{"CODE":"BITE407L","TITLE":"Quantum Computing","TYPE":"TH","CREDITS":3,"VENUE":"SJTG24","SLOT":"E2+TE2","FACULTY":"GANESAN K"},{"CODE":"BITE407L","TITLE":"Quantum Computing","TYPE":"TH","CREDITS":3,"VENUE":"SJTG24","SLOT":"E1+TE1","FACULTY":"ASWANI KUMAR CHERUKURI"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"CDMM103","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"CDMM104","SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"CDMM104","SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"GDN106","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"GDN106","SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"GDN107","SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"GDN107","SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"GDN120","SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"GDN120","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"GDN121","SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"GDN121","SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"GDN122","SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"GDN122","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"GDN123","SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"GDN123","SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"GDNG07","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SJT201","SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SJT201","SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SJT202","SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SJT202","SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SJT204","SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SJT204","SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SJT205","SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SJT205","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SJT208","SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SJT208","SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SJT211","SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SJT211","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SJT211A","SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SMV102","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SMV102","SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SMV218","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SMV218","SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SMV219","SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"SMV219","SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT404","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT404","SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT434","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT434","SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT504","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT504","SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT523","SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT523","SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT524","SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT524","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT530","SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT530","SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT530A","SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT530A","SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT531","SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT531","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT531A","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT531A","SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT630","SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"TT630","SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BITE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"VENUE":"SJT204","SLOT":"G1+TG1","FACULTY":"KARPAGAM S"},{"CODE":"BITE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"VENUE":"SJT205","SLOT":"G1+TG1","FACULTY":"KRISHNAMOORTHY N"},{"CODE":"BITE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"VENUE":"SJT211","SLOT":"G1+TG1","FACULTY":"HARSHITA PATEL"},{"CODE":"BITE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"VENUE":"SJT215","SLOT":"G1+TG1","FACULTY":"VIVEKANANDA GN"},{"CODE":"BITE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"VENUE":"SJT208","SLOT":"G2+TG2","FACULTY":"ARIVUSELVAN K"},{"CODE":"BITE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"VENUE":"SJT201","SLOT":"G2+TG2","FACULTY":"KRISHNAMOORTHY N"},{"CODE":"BITE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"VENUE":"SJT202","SLOT":"G2+TG2","FACULTY":"HARSHITA PATEL"},{"CODE":"BITE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"VENUE":"SJT204","SLOT":"G2+TG2","FACULTY":"VIVEKANANDA GN"},{"CODE":"BITE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJTG18","SLOT":"L43+L44","FACULTY":"KARPAGAM S"},{"CODE":"BITE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT120","SLOT":"L3+L4","FACULTY":"KRISHNAMOORTHY N"},{"CODE":"BITE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT216","SLOT":"L5+L6","FACULTY":"ARIVUSELVAN K"},{"CODE":"BITE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT120","SLOT":"L55+L56","FACULTY":"KRISHNAMOORTHY N"},{"CODE":"BITE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT120","SLOT":"L57+L58","FACULTY":"HARSHITA PATEL"},{"CODE":"BITE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT120","SLOT":"L53+L54","FACULTY":"VIVEKANANDA GN"},{"CODE":"BITE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT120","SLOT":"L13+L14","FACULTY":"VIVEKANANDA GN"},{"CODE":"BITE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT120","SLOT":"L19+L20","FACULTY":"HARSHITA PATEL"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"VENUE":"SMV104","SLOT":"F1","FACULTY":"SHILPI GUPTA"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"VENUE":"SJT604","SLOT":"A2","FACULTY":"ATUL KUMAR"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"VENUE":"CDMM403","SLOT":"B2","FACULTY":"SABYASACHI MISHRA"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"VENUE":"PRP333","SLOT":"G1","FACULTY":"SHILPI GUPTA"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"VENUE":"PRP333","SLOT":"B1","FACULTY":"SHILPI GUPTA"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"VENUE":"CDMM405","SLOT":"A2","FACULTY":"SABYASACHI MISHRA"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"VENUE":"SJT807","SLOT":"F2","FACULTY":"NUPUR MANASI"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"VENUE":"SJT324","SLOT":"A2","FACULTY":"BAISHALI CHOUDHURI"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"VENUE":"CDMM404","SLOT":"B2","FACULTY":"ATUL KUMAR"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"VENUE":"CDMM404","SLOT":"A1","FACULTY":"SHILPI GUPTA"}]');

});

parcelRegister("4YZz6", function(module, exports) {
module.exports = JSON.parse('[{"CODE":"BITE306L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":4,"VENUE":"SJT807","SLOT":"A1+TA1+TAA1","FACULTY":"RAGHAVAN R"},{"CODE":"BITE412L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"VENUE":"SJT801","SLOT":"A2+TA2","FACULTY":"PRIYA V"},{"CODE":"BITE311L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"VENUE":"SJT825","SLOT":"B1+TB1","FACULTY":"PRABHAVATHY P"},{"CODE":"BITE408L","TITLE":"Network Management","TYPE":"TH","CREDITS":3,"VENUE":"SJT823","SLOT":"B2+TB2","FACULTY":"JOTHISH KUMAR M"},{"CODE":"BITE403L","TITLE":"Embedded Systems and IoT","TYPE":"TH","CREDITS":3,"VENUE":"SJT824","SLOT":"C1+TC1","FACULTY":"NITHYA.S"},{"CODE":"BITE403P","TITLE":"Embedded Systems and IoT Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT212","SLOT":"L21+L22","FACULTY":"NITHYA.S"},{"CODE":"BITE314L","TITLE":"Multimedia Systems","TYPE":"TH","CREDITS":3,"VENUE":"SJT825","SLOT":"C1+TC1","FACULTY":"BALASUBRAMANI M"},{"CODE":"BITE305L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"VENUE":"SJT801","SLOT":"D2+TD2","FACULTY":"TAMIL PRIYA D"},{"CODE":"BITE305P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT216","SLOT":"L57+L58","FACULTY":"AASEEGHA M D"},{"CODE":"BITE308L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"VENUE":"SJT824","SLOT":"E1+TE1","FACULTY":"HEMALATHA S"},{"CODE":"BITE308P","TITLE":"Artificial Intelligence Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJT122","SLOT":"L29+L30","FACULTY":"SRINIVAS KOPPU"},{"CODE":"BITE407L","TITLE":"Quantum Computing","TYPE":"TH","CREDITS":3,"VENUE":"SJTG24","SLOT":"E2+TE2","FACULTY":"GANESAN K"},{"CODE":"BSTS301P","TITLE":"Advanced Competitive Coding - I","TYPE":"SS","CREDITS":1.5,"VENUE":"CDMM103","SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BITE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"VENUE":"SJT204","SLOT":"G1+TG1","FACULTY":"KARPAGAM S"},{"CODE":"BITE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"VENUE":"SJTG18","SLOT":"L43+L44","FACULTY":"KARPAGAM S"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"VENUE":"SMV104","SLOT":"F1","FACULTY":"SHILPI GUPTA"}]');

});

parcelRegister("1bsyz", function(module, exports) {
module.exports = JSON.parse('{"theory":[{"start":"8:00 AM","end":"8:50 AM","days":{"tue":"TAA1","wed":"TF1","thu":"TG1","fri":"TCC1","sat":"TE1"}},{"start":"9:00 AM","end":"9:50 AM","days":{"tue":"C1","wed":"B1","thu":"TDD1","fri":"G1","sat":"TC1"}},{"start":"10:00 AM","end":"10:50 AM","days":{"tue":"B1","wed":"C1","thu":"E1","fri":"F1","sat":"TBB1"}},{"start":"11:00 AM","end":"11:50 AM","days":{"tue":"D1","wed":"A1","thu":"F1","fri":"E1","sat":"TA1"}},{"start":"12:00 PM","end":"12:50 PM","days":{"tue":"G1","wed":"D1","thu":"A1","fri":"TB1","sat":"TD1"}},{"lunch":true},{"start":"2:00 PM","end":"2:50 PM","days":{"tue":"G2","wed":"D2","thu":"E2","fri":"TB2","sat":"TD2"}},{"start":"3:00 PM","end":"3:50 PM","days":{"tue":"B2","wed":"C2","thu":"TDD2","fri":"E2","sat":"TC2"}},{"start":"4:00 PM","end":"4:50 PM","days":{"tue":"C2","wed":"A2","thu":"A2","fri":"F2","sat":"TBB2"}},{"start":"5:00 PM","end":"5:50 PM","days":{"tue":"D2","wed":"B2","thu":"F2","fri":"G2","sat":"TA2"}},{"start":"6:00 PM","end":"6:50 PM","days":{"tue":"TAA2","wed":"TF2","thu":"TG2","fri":"TCC2","sat":"TE2"}}],"lab":[{"start":"08:00 AM","end":"08:50 AM","days":{"tue":"L1","wed":"L7","thu":"L13","fri":"L19","sat":"L25"}},{"start":"08:51 AM","end":"09:40 AM","days":{"tue":"L2","wed":"L8","thu":"L14","fri":"L20","sat":"L26"}},{"start":"10:00 AM","end":"10:50 AM","days":{"tue":"L3","wed":"L9","thu":"L15","fri":"L21","sat":"L27"}},{"start":"10:51 AM","end":"11:40 AM","days":{"tue":"L4","wed":"L10","thu":"L16","fri":"L22","sat":"L28"}},{"start":"12:00 AM","end":"12:50 PM","days":{"tue":"L5","wed":"L11","thu":"L17","fri":"L23","sat":"L29"}},{"start":"12:51 PM","end":"1:30 PM","days":{"tue":"L6","wed":"L12","thu":"L18","fri":"L24","sat":"L30"}},{"lunch":true},{"start":"2:00 PM","end":"2:50 PM","days":{"tue":"L31","wed":"L37","thu":"L43","fri":"L49","sat":"L55"}},{"start":"2:51 PM","end":"3:40 PM","days":{"tue":"L32","wed":"L38","thu":"L44","fri":"L50","sat":"L56"}},{"start":"4:00 PM","end":"4:50 PM","days":{"tue":"L33","wed":"L39","thu":"L45","fri":"L51","sat":"L57"}},{"start":"4:51 PM","end":"5:40 PM","days":{"tue":"L34","wed":"L40","thu":"L46","fri":"L52","sat":"L58"}},{"start":"6:00 PM","end":"6:50 PM","days":{"tue":"L35","wed":"L41","thu":"L47","fri":"L53","sat":"L59"}},{"start":"6:51 PM","end":"7:30 PM","days":{"tue":"L36","wed":"L42","thu":"L48","fri":"L54","sat":"L60"}}]}');

});

parcelRegister("hFi8p", function(module, exports) {
module.exports = JSON.parse('{"theory":[{"start":"8:00 AM","end":"8:50 AM","days":{"mon":"A1","tue":"B1","wed":"C1","thu":"D1","fri":"E1"}},{"start":"8:55 AM","end":"9:45 AM","days":{"mon":"F1","tue":"G1","wed":"A1","thu":"B1","fri":"C1"}},{"start":"9:50 AM","end":"10:40 AM","days":{"mon":"D1","tue":"E1","wed":"F1","thu":"G1","fri":"TA1"}},{"start":"10:45 AM","end":"11:35 AM","days":{"mon":"TB1","tue":"TC1","wed":"TD1","thu":"TE1","fri":"TF1"}},{"start":"11:40 AM","end":"12:30 PM","days":{"mon":"TG1","tue":"TAA1","wed":"TBB1","thu":"TCC1","fri":"TDD1"}},{"start":"12:35 PM","end":"1:25 PM","days":{"mon":"S11","fri":"S15"}},{"lunch":true},{"start":"2:00 PM","end":"2:50 PM","days":{"mon":"A2","tue":"B2","wed":"C2","thu":"D2","fri":"E2"}},{"start":"2:55 PM","end":"3:45 PM","days":{"mon":"F2","tue":"G2","wed":"A2","thu":"B2","fri":"C2"}},{"start":"3:50 PM","end":"4:40 PM","days":{"mon":"D2","tue":"E2","wed":"F2","thu":"G2","fri":"TA2"}},{"start":"4:45 PM","end":"5:35 PM","days":{"mon":"TB2","tue":"TC2","wed":"TD2","thu":"TE2","fri":"TF2"}},{"start":"5:40 PM","end":"6:30 PM","days":{"mon":"TG2","tue":"TAA2","wed":"TBB2","thu":"TCC2","fri":"TDD2"}},{"start":"6:35 PM","end":"7:25 PM","days":{"mon":"S3","tue":"S1","wed":"S4","thu":"S2"}}],"lab":[{"start":"08:00 AM","end":"08:50 AM","days":{"mon":"L1","tue":"L7","wed":"L13","thu":"L19","fri":"L25"}},{"start":"08:50 AM","end":"09:40 AM","days":{"mon":"L2","tue":"L8","wed":"L14","thu":"L20","fri":"L26"}},{"start":"09:50 AM","end":"10:40 AM","days":{"mon":"L3","tue":"L9","wed":"L15","thu":"L21","fri":"L27"}},{"start":"10:40 AM","end":"11:30 AM","days":{"mon":"L4","tue":"L10","wed":"L16","thu":"L22","fri":"L28"}},{"start":"11:40 AM","end":"12:30 PM","days":{"mon":"L5","tue":"L11","wed":"L17","thu":"L23","fri":"L29"}},{"start":"12:30 PM","end":"1:20 PM","days":{"mon":"L6","tue":"L12","wed":"L18","thu":"L24","fri":"L30"}},{"lunch":true},{"start":"2:00 PM","end":"2:50 PM","days":{"mon":"L31","tue":"L37","wed":"L43","thu":"L49","fri":"L55"}},{"start":"2:50 PM","end":"3:40 PM","days":{"mon":"L32","tue":"L38","wed":"L44","thu":"L50","fri":"L56"}},{"start":"3:50 PM","end":"4:40 PM","days":{"mon":"L33","tue":"L39","wed":"L45","thu":"L51","fri":"L57"}},{"start":"4:40 PM","end":"5:30 PM","days":{"mon":"L34","tue":"L40","wed":"L46","thu":"L52","fri":"L58"}},{"start":"5:40 PM","end":"6:30 PM","days":{"mon":"L35","tue":"L41","wed":"L47","thu":"L53","fri":"L59"}},{"start":"6:30 PM","end":"7:20 PM","days":{"mon":"L36","tue":"L42","wed":"L48","thu":"L54","fri":"L60"}}]}');

});

parcelRegister("9PGPv", function(module, exports) {
module.exports = JSON.parse('{"theory":[{"start":"8:00 AM","end":"8:50 AM","days":{"mon":"A1","tue":"B1","wed":"C1","thu":"D1","fri":"E1"}},{"start":"9:00 AM","end":"9:50 AM","days":{"mon":"F1","tue":"G1","wed":"A1","thu":"B1","fri":"C1"}},{"start":"10:00 AM","end":"10:50 AM","days":{"mon":"D1","tue":"E1","wed":"F1","thu":"G1","fri":"TA1"}},{"start":"11:00 AM","end":"11:50 AM","days":{"mon":"TB1","tue":"TC1","wed":"V1","thu":"TE1","fri":"TF1"}},{"start":"12:00 PM","end":"12:50 PM","days":{"mon":"TG1","tue":"TAA1","wed":"V2","thu":"TCC1","fri":"TD1"}},{"lunch":true},{"start":"2:00 PM","end":"2:50 PM","days":{"mon":"A2","tue":"B2","wed":"C2","thu":"D2","fri":"E2"}},{"start":"3:00 PM","end":"3:50 PM","days":{"mon":"F2","tue":"G2","wed":"A2","thu":"B2","fri":"C2"}},{"start":"4:00 PM","end":"4:50 PM","days":{"mon":"D2","tue":"E2","wed":"F2","thu":"G2","fri":"TA2"}},{"start":"5:00 PM","end":"5:50 PM","days":{"mon":"TB2","tue":"TC2","wed":"TD2","thu":"TE2","fri":"TF2"}},{"start":"6:00 PM","end":"6:50 PM","days":{"mon":"TG2","tue":"TAA2","wed":"TBB2","thu":"TCC2","fri":"TDD2"}},{"start":"6:51 PM","end":"7:00 PM","days":{}},{"start":"7:01 PM","end":"7:50 PM","days":{"mon":"V3","tue":"V4","wed":"V5","thu":"V6","fri":"V7"}}],"lab":[{"start":"08:00 AM","end":"08:50 AM","days":{"mon":"L1","tue":"L7","wed":"L13","thu":"L19","fri":"L25"}},{"start":"08:51 AM","end":"09:40 AM","days":{"mon":"L2","tue":"L8","wed":"L14","thu":"L20","fri":"L26"}},{"start":"09:51 AM","end":"10:40 AM","days":{"mon":"L3","tue":"L9","wed":"L15","thu":"L21","fri":"L27"}},{"start":"10:41 AM","end":"11:30 AM","days":{"mon":"L4","tue":"L10","wed":"L16","thu":"L22","fri":"L28"}},{"start":"11:40 AM","end":"12:30 PM","days":{"mon":"L5","tue":"L11","wed":"L17","thu":"L23","fri":"L29"}},{"start":"12:31 PM","end":"1:20 PM","days":{"mon":"L6","tue":"L12","wed":"L18","thu":"L24","fri":"L30"}},{"lunch":true},{"start":"2:00 PM","end":"2:50 PM","days":{"mon":"L31","tue":"L37","wed":"L43","thu":"L49","fri":"L55"}},{"start":"2:51 PM","end":"3:40 PM","days":{"mon":"L32","tue":"L38","wed":"L44","thu":"L50","fri":"L56"}},{"start":"3:51 PM","end":"4:40 PM","days":{"mon":"L33","tue":"L39","wed":"L45","thu":"L51","fri":"L57"}},{"start":"4:41 PM","end":"5:30 PM","days":{"mon":"L34","tue":"L40","wed":"L46","thu":"L52","fri":"L58"}},{"start":"5:40 PM","end":"6:30 PM","days":{"mon":"L35","tue":"L41","wed":"L47","thu":"L53","fri":"L59"}},{"start":"6:31 PM","end":"7:20 PM","days":{"mon":"L36","tue":"L42","wed":"L48","thu":"L54","fri":"L60"}}]}');

});

/*
 *  This file contains the events and functions applied to
 *  the document body that is common to all sections or
 *  that doesn't fit into any particular section
 */ 





var $91b00a4bc162400e$exports = {};
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/ (function(f) {
    var g;
    $91b00a4bc162400e$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    "use strict";
                    var Mutation = global1.MutationObserver || global1.WebKitMutationObserver;
                    var scheduleDrain;
                    if (Mutation) {
                        var called = 0;
                        var observer = new Mutation(nextTick);
                        var element = global1.document.createTextNode("");
                        observer.observe(element, {
                            characterData: true
                        });
                        scheduleDrain = function() {
                            element.data = called = ++called % 2;
                        };
                    } else if (!global1.setImmediate && typeof global1.MessageChannel !== "undefined") {
                        var channel = new global1.MessageChannel();
                        channel.port1.onmessage = nextTick;
                        scheduleDrain = function() {
                            channel.port2.postMessage(0);
                        };
                    } else if ("document" in global1 && "onreadystatechange" in global1.document.createElement("script")) scheduleDrain = function() {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var scriptEl = global1.document.createElement("script");
                        scriptEl.onreadystatechange = function() {
                            nextTick();
                            scriptEl.onreadystatechange = null;
                            scriptEl.parentNode.removeChild(scriptEl);
                            scriptEl = null;
                        };
                        global1.document.documentElement.appendChild(scriptEl);
                    };
                    else scheduleDrain = function() {
                        setTimeout(nextTick, 0);
                    };
                    var draining;
                    var queue = [];
                    //named nextTick for less confusing stack traces
                    function nextTick() {
                        draining = true;
                        var i, oldQueue;
                        var len = queue.length;
                        while(len){
                            oldQueue = queue;
                            queue = [];
                            i = -1;
                            while(++i < len)oldQueue[i]();
                            len = queue.length;
                        }
                        draining = false;
                    }
                    module1.exports = immediate;
                    function immediate(task) {
                        if (queue.push(task) === 1 && !draining) scheduleDrain();
                    }
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                var immediate = _dereq_(1);
                /* istanbul ignore next */ function INTERNAL() {}
                var handlers = {};
                var REJECTED = [
                    "REJECTED"
                ];
                var FULFILLED = [
                    "FULFILLED"
                ];
                var PENDING = [
                    "PENDING"
                ];
                module1.exports = Promise1;
                function Promise1(resolver) {
                    if (typeof resolver !== "function") throw new TypeError("resolver must be a function");
                    this.state = PENDING;
                    this.queue = [];
                    this.outcome = void 0;
                    if (resolver !== INTERNAL) safelyResolveThenable(this, resolver);
                }
                Promise1.prototype["catch"] = function(onRejected) {
                    return this.then(null, onRejected);
                };
                Promise1.prototype.then = function(onFulfilled, onRejected) {
                    if (typeof onFulfilled !== "function" && this.state === FULFILLED || typeof onRejected !== "function" && this.state === REJECTED) return this;
                    var promise = new this.constructor(INTERNAL);
                    if (this.state !== PENDING) {
                        var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
                        unwrap(promise, resolver, this.outcome);
                    } else this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
                    return promise;
                };
                function QueueItem(promise, onFulfilled, onRejected) {
                    this.promise = promise;
                    if (typeof onFulfilled === "function") {
                        this.onFulfilled = onFulfilled;
                        this.callFulfilled = this.otherCallFulfilled;
                    }
                    if (typeof onRejected === "function") {
                        this.onRejected = onRejected;
                        this.callRejected = this.otherCallRejected;
                    }
                }
                QueueItem.prototype.callFulfilled = function(value) {
                    handlers.resolve(this.promise, value);
                };
                QueueItem.prototype.otherCallFulfilled = function(value) {
                    unwrap(this.promise, this.onFulfilled, value);
                };
                QueueItem.prototype.callRejected = function(value) {
                    handlers.reject(this.promise, value);
                };
                QueueItem.prototype.otherCallRejected = function(value) {
                    unwrap(this.promise, this.onRejected, value);
                };
                function unwrap(promise, func, value) {
                    immediate(function() {
                        var returnValue;
                        try {
                            returnValue = func(value);
                        } catch (e) {
                            return handlers.reject(promise, e);
                        }
                        if (returnValue === promise) handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
                        else handlers.resolve(promise, returnValue);
                    });
                }
                handlers.resolve = function(self1, value) {
                    var result = tryCatch(getThen, value);
                    if (result.status === "error") return handlers.reject(self1, result.value);
                    var thenable = result.value;
                    if (thenable) safelyResolveThenable(self1, thenable);
                    else {
                        self1.state = FULFILLED;
                        self1.outcome = value;
                        var i = -1;
                        var len = self1.queue.length;
                        while(++i < len)self1.queue[i].callFulfilled(value);
                    }
                    return self1;
                };
                handlers.reject = function(self1, error) {
                    self1.state = REJECTED;
                    self1.outcome = error;
                    var i = -1;
                    var len = self1.queue.length;
                    while(++i < len)self1.queue[i].callRejected(error);
                    return self1;
                };
                function getThen(obj) {
                    // Make sure we only access the accessor once as required by the spec
                    var then = obj && obj.then;
                    if (obj && (typeof obj === "object" || typeof obj === "function") && typeof then === "function") return function appyThen() {
                        then.apply(obj, arguments);
                    };
                }
                function safelyResolveThenable(self1, thenable) {
                    // Either fulfill, reject or reject with error
                    var called = false;
                    function onError(value) {
                        if (called) return;
                        called = true;
                        handlers.reject(self1, value);
                    }
                    function onSuccess(value) {
                        if (called) return;
                        called = true;
                        handlers.resolve(self1, value);
                    }
                    function tryToUnwrap() {
                        thenable(onSuccess, onError);
                    }
                    var result = tryCatch(tryToUnwrap);
                    if (result.status === "error") onError(result.value);
                }
                function tryCatch(func, value) {
                    var out = {};
                    try {
                        out.value = func(value);
                        out.status = "success";
                    } catch (e) {
                        out.status = "error";
                        out.value = e;
                    }
                    return out;
                }
                Promise1.resolve = resolve;
                function resolve(value) {
                    if (value instanceof this) return value;
                    return handlers.resolve(new this(INTERNAL), value);
                }
                Promise1.reject = reject;
                function reject(reason) {
                    var promise = new this(INTERNAL);
                    return handlers.reject(promise, reason);
                }
                Promise1.all = all;
                function all(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var values = new Array(len);
                    var resolved = 0;
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)allResolver(iterable[i], i);
                    return promise;
                    function allResolver(value, i) {
                        self1.resolve(value).then(resolveFromAll, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                        function resolveFromAll(outValue) {
                            values[i] = outValue;
                            if (++resolved === len && !called) {
                                called = true;
                                handlers.resolve(promise, values);
                            }
                        }
                    }
                }
                Promise1.race = race;
                function race(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)resolver(iterable[i]);
                    return promise;
                    function resolver(value) {
                        self1.resolve(value).then(function(response) {
                            if (!called) {
                                called = true;
                                handlers.resolve(promise, response);
                            }
                        }, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                    }
                }
            },
            {
                "1": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    "use strict";
                    if (typeof global1.Promise !== "function") global1.Promise = _dereq_(2);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "2": 2
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                "use strict";
                var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function getIDB() {
                    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */ try {
                        if (typeof indexedDB !== "undefined") return indexedDB;
                        if (typeof webkitIndexedDB !== "undefined") return webkitIndexedDB;
                        if (typeof mozIndexedDB !== "undefined") return mozIndexedDB;
                        if (typeof OIndexedDB !== "undefined") return OIndexedDB;
                        if (typeof msIndexedDB !== "undefined") return msIndexedDB;
                    } catch (e) {
                        return;
                    }
                }
                var idb = getIDB();
                function isIndexedDBValid() {
                    try {
                        // Initialize IndexedDB; fall back to vendor-prefixed versions
                        // if needed.
                        if (!idb || !idb.open) return false;
                        // We mimic PouchDB here;
                        //
                        // We test for openDatabase because IE Mobile identifies itself
                        // as Safari. Oh the lulz...
                        var isSafari = typeof openDatabase !== "undefined" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
                        var hasFetch = typeof fetch === "function" && fetch.toString().indexOf("[native code") !== -1;
                        // Safari <10.1 does not meet our requirements for IDB support
                        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
                        // Safari 10.1 shipped with fetch, we can use that to detect it.
                        // Note: this creates issues with `window.fetch` polyfills and
                        // overrides; see:
                        // https://github.com/localForage/localForage/issues/856
                        return (!isSafari || hasFetch) && typeof indexedDB !== "undefined" && // some outdated implementations of IDB that appear on Samsung
                        // and HTC Android devices <4.4 are missing IDBKeyRange
                        // See: https://github.com/mozilla/localForage/issues/128
                        // See: https://github.com/mozilla/localForage/issues/272
                        typeof IDBKeyRange !== "undefined";
                    } catch (e) {
                        return false;
                    }
                }
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                function createBlob(parts, properties) {
                    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
                    properties = properties || {};
                    try {
                        return new Blob(parts, properties);
                    } catch (e) {
                        if (e.name !== "TypeError") throw e;
                        var Builder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : WebKitBlobBuilder;
                        var builder = new Builder();
                        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
                        return builder.getBlob(properties.type);
                    }
                }
                // This is CommonJS because lie is an external dependency, so Rollup
                // can just ignore it.
                if (typeof Promise === "undefined") // In the "nopromises" build this will just throw if you don't have
                // a global promise object, but it would throw anyway later.
                _dereq_(3);
                var Promise$1 = Promise;
                function executeCallback(promise, callback) {
                    if (callback) promise.then(function(result) {
                        callback(null, result);
                    }, function(error) {
                        callback(error);
                    });
                }
                function executeTwoCallbacks(promise, callback, errorCallback) {
                    if (typeof callback === "function") promise.then(callback);
                    if (typeof errorCallback === "function") promise["catch"](errorCallback);
                }
                function normalizeKey(key) {
                    // Cast the key to a string, as that's all we can set as a key.
                    if (typeof key !== "string") {
                        console.warn(key + " used as a key, but it is not a string.");
                        key = String(key);
                    }
                    return key;
                }
                function getCallback() {
                    if (arguments.length && typeof arguments[arguments.length - 1] === "function") return arguments[arguments.length - 1];
                }
                // Some code originally from async_storage.js in
                // [Gaia](https://github.com/mozilla-b2g/gaia).
                var DETECT_BLOB_SUPPORT_STORE = "local-forage-detect-blob-support";
                var supportsBlobs = void 0;
                var dbContexts = {};
                var toString = Object.prototype.toString;
                // Transaction Modes
                var READ_ONLY = "readonly";
                var READ_WRITE = "readwrite";
                // Transform a binary string to an array buffer, because otherwise
                // weird stuff happens when you try to work with the binary string directly.
                // It is known.
                // From http://stackoverflow.com/questions/14967647/ (continues on next line)
                // encode-decode-image-with-base64-breaks-image (2013-04-21)
                function _binStringToArrayBuffer(bin) {
                    var length = bin.length;
                    var buf = new ArrayBuffer(length);
                    var arr = new Uint8Array(buf);
                    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
                    return buf;
                }
                //
                // Blobs are not supported in all versions of IndexedDB, notably
                // Chrome <37 and Android <5. In those versions, storing a blob will throw.
                //
                // Various other blob bugs exist in Chrome v37-42 (inclusive).
                // Detecting them is expensive and confusing to users, and Chrome 37-42
                // is at very low usage worldwide, so we do a hacky userAgent check instead.
                //
                // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
                // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
                // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
                //
                // Code borrowed from PouchDB. See:
                // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
                //
                function _checkBlobSupportWithoutCaching(idb) {
                    return new Promise$1(function(resolve) {
                        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
                        var blob = createBlob([
                            ""
                        ]);
                        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, "key");
                        txn.onabort = function(e) {
                            // If the transaction aborts now its due to not being able to
                            // write to the database, likely due to the disk being full
                            e.preventDefault();
                            e.stopPropagation();
                            resolve(false);
                        };
                        txn.oncomplete = function() {
                            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                            var matchedEdge = navigator.userAgent.match(/Edge\//);
                            // MS Edge pretends to be Chrome 42:
                            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
                            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
                        };
                    })["catch"](function() {
                        return false; // error, so assume unsupported
                    });
                }
                function _checkBlobSupport(idb) {
                    if (typeof supportsBlobs === "boolean") return Promise$1.resolve(supportsBlobs);
                    return _checkBlobSupportWithoutCaching(idb).then(function(value) {
                        supportsBlobs = value;
                        return supportsBlobs;
                    });
                }
                function _deferReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Create a deferred object representing the current database operation.
                    var deferredOperation = {};
                    deferredOperation.promise = new Promise$1(function(resolve, reject) {
                        deferredOperation.resolve = resolve;
                        deferredOperation.reject = reject;
                    });
                    // Enqueue the deferred operation.
                    dbContext.deferredOperations.push(deferredOperation);
                    // Chain its promise to the database readiness.
                    if (!dbContext.dbReady) dbContext.dbReady = deferredOperation.promise;
                    else dbContext.dbReady = dbContext.dbReady.then(function() {
                        return deferredOperation.promise;
                    });
                }
                function _advanceReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Resolve its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.resolve();
                        return deferredOperation.promise;
                    }
                }
                function _rejectReadiness(dbInfo, err) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Reject its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.reject(err);
                        return deferredOperation.promise;
                    }
                }
                function _getConnection(dbInfo, upgradeNeeded) {
                    return new Promise$1(function(resolve, reject) {
                        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
                        if (dbInfo.db) {
                            if (upgradeNeeded) {
                                _deferReadiness(dbInfo);
                                dbInfo.db.close();
                            } else return resolve(dbInfo.db);
                        }
                        var dbArgs = [
                            dbInfo.name
                        ];
                        if (upgradeNeeded) dbArgs.push(dbInfo.version);
                        var openreq = idb.open.apply(idb, dbArgs);
                        if (upgradeNeeded) openreq.onupgradeneeded = function(e) {
                            var db = openreq.result;
                            try {
                                db.createObjectStore(dbInfo.storeName);
                                if (e.oldVersion <= 1) // Added when support for blob shims was added
                                db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                            } catch (ex) {
                                if (ex.name === "ConstraintError") console.warn('The database "' + dbInfo.name + '"' + " has been upgraded from version " + e.oldVersion + " to version " + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                                else throw ex;
                            }
                        };
                        openreq.onerror = function(e) {
                            e.preventDefault();
                            reject(openreq.error);
                        };
                        openreq.onsuccess = function() {
                            var db = openreq.result;
                            db.onversionchange = function(e) {
                                // Triggered when the database is modified (e.g. adding an objectStore) or
                                // deleted (even when initiated by other sessions in different tabs).
                                // Closing the connection here prevents those operations from being blocked.
                                // If the database is accessed again later by this instance, the connection
                                // will be reopened or the database recreated as needed.
                                e.target.close();
                            };
                            resolve(db);
                            _advanceReadiness(dbInfo);
                        };
                    });
                }
                function _getOriginalConnection(dbInfo) {
                    return _getConnection(dbInfo, false);
                }
                function _getUpgradedConnection(dbInfo) {
                    return _getConnection(dbInfo, true);
                }
                function _isUpgradeNeeded(dbInfo, defaultVersion) {
                    if (!dbInfo.db) return true;
                    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
                    var isDowngrade = dbInfo.version < dbInfo.db.version;
                    var isUpgrade = dbInfo.version > dbInfo.db.version;
                    if (isDowngrade) {
                        // If the version is not the default one
                        // then warn for impossible downgrade.
                        if (dbInfo.version !== defaultVersion) console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + " to version " + dbInfo.version + ".");
                        // Align the versions to prevent errors.
                        dbInfo.version = dbInfo.db.version;
                    }
                    if (isUpgrade || isNewStore) {
                        // If the store is new then increment the version (if needed).
                        // This will trigger an "upgradeneeded" event which is required
                        // for creating a store.
                        if (isNewStore) {
                            var incVersion = dbInfo.db.version + 1;
                            if (incVersion > dbInfo.version) dbInfo.version = incVersion;
                        }
                        return true;
                    }
                    return false;
                }
                // encode a blob for indexeddb engines that don't support blobs
                function _encodeBlob(blob) {
                    return new Promise$1(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onerror = reject;
                        reader.onloadend = function(e) {
                            var base64 = btoa(e.target.result || "");
                            resolve({
                                __local_forage_encoded_blob: true,
                                data: base64,
                                type: blob.type
                            });
                        };
                        reader.readAsBinaryString(blob);
                    });
                }
                // decode an encoded blob
                function _decodeBlob(encodedBlob) {
                    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
                    return createBlob([
                        arrayBuff
                    ], {
                        type: encodedBlob.type
                    });
                }
                // is this one of our fancy encoded blobs?
                function _isEncodedBlob(value) {
                    return value && value.__local_forage_encoded_blob;
                }
                // Specialize the default `ready()` function by making it dependent
                // on the current database operations. Thus, the driver will be actually
                // ready when it's been initialized (default) *and* there are no pending
                // operations on the database (initiated by some other instances).
                function _fullyReady(callback) {
                    var self1 = this;
                    var promise = self1._initReady().then(function() {
                        var dbContext = dbContexts[self1._dbInfo.name];
                        if (dbContext && dbContext.dbReady) return dbContext.dbReady;
                    });
                    executeTwoCallbacks(promise, callback, callback);
                    return promise;
                }
                // Try to establish a new db connection to replace the
                // current one which is broken (i.e. experiencing
                // InvalidStateError while creating a transaction).
                function _tryReconnect(dbInfo) {
                    _deferReadiness(dbInfo);
                    var dbContext = dbContexts[dbInfo.name];
                    var forages = dbContext.forages;
                    for(var i = 0; i < forages.length; i++){
                        var forage = forages[i];
                        if (forage._dbInfo.db) {
                            forage._dbInfo.db.close();
                            forage._dbInfo.db = null;
                        }
                    }
                    dbInfo.db = null;
                    return _getOriginalConnection(dbInfo).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        // store the latest db reference
                        // in case the db was upgraded
                        dbInfo.db = dbContext.db = db;
                        for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                    })["catch"](function(err) {
                        _rejectReadiness(dbInfo, err);
                        throw err;
                    });
                }
                // FF doesn't like Promises (micro-tasks) and IDDB store operations,
                // so we have to do it with callbacks
                function createTransaction(dbInfo, mode, callback, retries) {
                    if (retries === undefined) retries = 1;
                    try {
                        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
                        callback(null, tx);
                    } catch (err) {
                        if (retries > 0 && (!dbInfo.db || err.name === "InvalidStateError" || err.name === "NotFoundError")) return Promise$1.resolve().then(function() {
                            if (!dbInfo.db || err.name === "NotFoundError" && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                                // increase the db version, to create the new ObjectStore
                                if (dbInfo.db) dbInfo.version = dbInfo.db.version + 1;
                                // Reopen the database for upgrading.
                                return _getUpgradedConnection(dbInfo);
                            }
                        }).then(function() {
                            return _tryReconnect(dbInfo).then(function() {
                                createTransaction(dbInfo, mode, callback, retries - 1);
                            });
                        })["catch"](callback);
                        callback(err);
                    }
                }
                function createDbContext() {
                    return {
                        // Running localForages sharing a database.
                        forages: [],
                        // Shared database.
                        db: null,
                        // Database readiness (promise).
                        dbReady: null,
                        // Deferred operations on the database.
                        deferredOperations: []
                    };
                }
                // Open the IndexedDB database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    // Get the current context of the database;
                    var dbContext = dbContexts[dbInfo.name];
                    // ...or create a new context.
                    if (!dbContext) {
                        dbContext = createDbContext();
                        // Register the new context in the global container.
                        dbContexts[dbInfo.name] = dbContext;
                    }
                    // Register itself as a running localForage in the current context.
                    dbContext.forages.push(self1);
                    // Replace the default `ready()` function with the specialized one.
                    if (!self1._initReady) {
                        self1._initReady = self1.ready;
                        self1.ready = _fullyReady;
                    }
                    // Create an array of initialization states of the related localForages.
                    var initPromises = [];
                    function ignoreErrors() {
                        // Don't handle errors here,
                        // just makes sure related localForages aren't pending.
                        return Promise$1.resolve();
                    }
                    for(var j = 0; j < dbContext.forages.length; j++){
                        var forage = dbContext.forages[j];
                        if (forage !== self1) // Don't wait for itself...
                        initPromises.push(forage._initReady()["catch"](ignoreErrors));
                    }
                    // Take a snapshot of the related localForages.
                    var forages = dbContext.forages.slice(0);
                    // Initialize the connection process only when
                    // all the related localForages aren't pending.
                    return Promise$1.all(initPromises).then(function() {
                        dbInfo.db = dbContext.db;
                        // Get the connection or open a new one without upgrade.
                        return _getOriginalConnection(dbInfo);
                    }).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo, self1._defaultConfig.version)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        dbInfo.db = dbContext.db = db;
                        self1._dbInfo = dbInfo;
                        // Share the final connection amongst related localForages.
                        for(var k = 0; k < forages.length; k++){
                            var forage = forages[k];
                            if (forage !== self1) {
                                // Self is already up-to-date.
                                forage._dbInfo.db = dbInfo.db;
                                forage._dbInfo.version = dbInfo.version;
                            }
                        }
                    });
                }
                function getItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.get(key);
                                    req.onsuccess = function() {
                                        var value = req.result;
                                        if (value === undefined) value = null;
                                        if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                        resolve(value);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items stored in database.
                function iterate(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openCursor();
                                    var iterationNumber = 1;
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (cursor) {
                                            var value = cursor.value;
                                            if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                            var result = iterator(value, cursor.key, iterationNumber++);
                                            // when the iterator callback returns any
                                            // (non-`undefined`) value, then we stop
                                            // the iteration immediately
                                            if (result !== void 0) resolve(result);
                                            else cursor["continue"]();
                                        } else resolve();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        var dbInfo;
                        self1.ready().then(function() {
                            dbInfo = self1._dbInfo;
                            if (toString.call(value) === "[object Blob]") return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                                if (blobSupport) return value;
                                return _encodeBlob(value);
                            });
                            return value;
                        }).then(function(value) {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // The reason we don't _save_ null is because IE 10 does
                                    // not support saving the `null` type in IndexedDB. How
                                    // ironic, given the bug below!
                                    // See: https://github.com/mozilla/localForage/issues/161
                                    if (value === null) value = undefined;
                                    var req = store.put(value, key);
                                    transaction.oncomplete = function() {
                                        // Cast to undefined so the value passed to
                                        // callback/promise is the same as what one would get out
                                        // of `getItem()` later. This leads to some weirdness
                                        // (setItem('foo', undefined) will return `null`), but
                                        // it's not my fault localStorage is our baseline and that
                                        // it's weird.
                                        if (value === undefined) value = null;
                                        resolve(value);
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function removeItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // We use a Grunt task to make this safe for IE and some
                                    // versions of Android (including those used by Cordova).
                                    // Normally IE won't like `.delete()` and will insist on
                                    // using `['delete']()`, but we have a build step that
                                    // fixes this for us now.
                                    var req = store["delete"](key);
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onerror = function() {
                                        reject(req.error);
                                    };
                                    // The request will be also be aborted if we've exceeded our storage
                                    // space.
                                    transaction.onabort = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function clear(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.clear();
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function length(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.count();
                                    req.onsuccess = function() {
                                        resolve(req.result);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function key(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        if (n < 0) {
                            resolve(null);
                            return;
                        }
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var advanced = false;
                                    var req = store.openKeyCursor();
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            // this means there weren't enough keys
                                            resolve(null);
                                            return;
                                        }
                                        if (n === 0) // We have the first key, return it if that's what they
                                        // wanted.
                                        resolve(cursor.key);
                                        else if (!advanced) {
                                            // Otherwise, ask the cursor to skip ahead n
                                            // records.
                                            advanced = true;
                                            cursor.advance(n);
                                        } else // When we get here, we've got the nth key.
                                        resolve(cursor.key);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openKeyCursor();
                                    var keys = [];
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            resolve(keys);
                                            return;
                                        }
                                        keys.push(cursor.key);
                                        cursor["continue"]();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else {
                        var isCurrentDb = options.name === currentConfig.name && self1._dbInfo.db;
                        var dbPromise = isCurrentDb ? Promise$1.resolve(self1._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            dbContext.db = db;
                            for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                            return db;
                        });
                        if (!options.storeName) promise = dbPromise.then(function(db) {
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                            }
                            var dropDBPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.deleteDatabase(options.name);
                                req.onerror = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    reject(req.error);
                                };
                                req.onblocked = function() {
                                    // Closing all open connections in onversionchange handler should prevent this situation, but if
                                    // we do get here, it just means the request remains pending - eventually it will succeed or error
                                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    resolve(db);
                                };
                            });
                            return dropDBPromise.then(function(db) {
                                dbContext.db = db;
                                for(var i = 0; i < forages.length; i++){
                                    var _forage = forages[i];
                                    _advanceReadiness(_forage._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                        else promise = dbPromise.then(function(db) {
                            if (!db.objectStoreNames.contains(options.storeName)) return;
                            var newVersion = db.version + 1;
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                                forage._dbInfo.version = newVersion;
                            }
                            var dropObjectPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.open(options.name, newVersion);
                                req.onerror = function(err) {
                                    var db = req.result;
                                    db.close();
                                    reject(err);
                                };
                                req.onupgradeneeded = function() {
                                    var db = req.result;
                                    db.deleteObjectStore(options.storeName);
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    db.close();
                                    resolve(db);
                                };
                            });
                            return dropObjectPromise.then(function(db) {
                                dbContext.db = db;
                                for(var j = 0; j < forages.length; j++){
                                    var _forage2 = forages[j];
                                    _forage2._dbInfo.db = db;
                                    _advanceReadiness(_forage2._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                    }
                    executeCallback(promise, callback);
                    return promise;
                }
                var asyncStorage = {
                    _driver: "asyncStorage",
                    _initStorage: _initStorage,
                    _support: isIndexedDBValid(),
                    iterate: iterate,
                    getItem: getItem,
                    setItem: setItem,
                    removeItem: removeItem,
                    clear: clear,
                    length: length,
                    key: key,
                    keys: keys,
                    dropInstance: dropInstance
                };
                function isWebSQLValid() {
                    return typeof openDatabase === "function";
                }
                // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
                // it to Base64, so this is how we store it to prevent very strange errors with less
                // verbose ways of binary <-> string data storage.
                var BASE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                var BLOB_TYPE_PREFIX = "~~local_forage_type~";
                var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
                var SERIALIZED_MARKER = "__lfsc__:";
                var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
                // OMG the serializations!
                var TYPE_ARRAYBUFFER = "arbf";
                var TYPE_BLOB = "blob";
                var TYPE_INT8ARRAY = "si08";
                var TYPE_UINT8ARRAY = "ui08";
                var TYPE_UINT8CLAMPEDARRAY = "uic8";
                var TYPE_INT16ARRAY = "si16";
                var TYPE_INT32ARRAY = "si32";
                var TYPE_UINT16ARRAY = "ur16";
                var TYPE_UINT32ARRAY = "ui32";
                var TYPE_FLOAT32ARRAY = "fl32";
                var TYPE_FLOAT64ARRAY = "fl64";
                var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
                var toString$1 = Object.prototype.toString;
                function stringToBuffer(serializedString) {
                    // Fill the string into a ArrayBuffer.
                    var bufferLength = serializedString.length * 0.75;
                    var len = serializedString.length;
                    var i;
                    var p = 0;
                    var encoded1, encoded2, encoded3, encoded4;
                    if (serializedString[serializedString.length - 1] === "=") {
                        bufferLength--;
                        if (serializedString[serializedString.length - 2] === "=") bufferLength--;
                    }
                    var buffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(buffer);
                    for(i = 0; i < len; i += 4){
                        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
                        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
                        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
                        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
                        /*jslint bitwise: true */ bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return buffer;
                }
                // Converts a buffer to a string to store, serialized, in the backend
                // storage library.
                function bufferToString(buffer) {
                    // base64-arraybuffer
                    var bytes = new Uint8Array(buffer);
                    var base64String = "";
                    var i;
                    for(i = 0; i < bytes.length; i += 3){
                        /*jslint bitwise: true */ base64String += BASE_CHARS[bytes[i] >> 2];
                        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64String += BASE_CHARS[bytes[i + 2] & 63];
                    }
                    if (bytes.length % 3 === 2) base64String = base64String.substring(0, base64String.length - 1) + "=";
                    else if (bytes.length % 3 === 1) base64String = base64String.substring(0, base64String.length - 2) + "==";
                    return base64String;
                }
                // Serialize a value, afterwards executing a callback (which usually
                // instructs the `setItem()` callback/promise to be executed). This is how
                // we store binary data with localStorage.
                function serialize(value, callback) {
                    var valueType = "";
                    if (value) valueType = toString$1.call(value);
                    // Cannot use `value instanceof ArrayBuffer` or such here, as these
                    // checks fail when running the tests using casper.js...
                    //
                    // TODO: See why those tests fail and use a better solution.
                    if (value && (valueType === "[object ArrayBuffer]" || value.buffer && toString$1.call(value.buffer) === "[object ArrayBuffer]")) {
                        // Convert binary arrays to a string and prefix the string with
                        // a special marker.
                        var buffer;
                        var marker = SERIALIZED_MARKER;
                        if (value instanceof ArrayBuffer) {
                            buffer = value;
                            marker += TYPE_ARRAYBUFFER;
                        } else {
                            buffer = value.buffer;
                            if (valueType === "[object Int8Array]") marker += TYPE_INT8ARRAY;
                            else if (valueType === "[object Uint8Array]") marker += TYPE_UINT8ARRAY;
                            else if (valueType === "[object Uint8ClampedArray]") marker += TYPE_UINT8CLAMPEDARRAY;
                            else if (valueType === "[object Int16Array]") marker += TYPE_INT16ARRAY;
                            else if (valueType === "[object Uint16Array]") marker += TYPE_UINT16ARRAY;
                            else if (valueType === "[object Int32Array]") marker += TYPE_INT32ARRAY;
                            else if (valueType === "[object Uint32Array]") marker += TYPE_UINT32ARRAY;
                            else if (valueType === "[object Float32Array]") marker += TYPE_FLOAT32ARRAY;
                            else if (valueType === "[object Float64Array]") marker += TYPE_FLOAT64ARRAY;
                            else callback(new Error("Failed to get type for BinaryArray"));
                        }
                        callback(marker + bufferToString(buffer));
                    } else if (valueType === "[object Blob]") {
                        // Conver the blob to a binaryArray and then to a string.
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            // Backwards-compatible prefix for the blob type.
                            var str = BLOB_TYPE_PREFIX + value.type + "~" + bufferToString(this.result);
                            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
                        };
                        fileReader.readAsArrayBuffer(value);
                    } else try {
                        callback(JSON.stringify(value));
                    } catch (e) {
                        console.error("Couldn't convert value into a JSON string: ", value);
                        callback(null, e);
                    }
                }
                // Deserialize data we've inserted into a value column/field. We place
                // special markers into our strings to mark them as encoded; this isn't
                // as nice as a meta field, but it's the only sane thing we can do whilst
                // keeping localStorage support intact.
                //
                // Oftentimes this will just deserialize JSON content, but if we have a
                // special marker (SERIALIZED_MARKER, defined above), we will extract
                // some kind of arraybuffer/binary data/typed array out of the string.
                function deserialize(value) {
                    // If we haven't marked this string as being specially serialized (i.e.
                    // something other than serialized JSON), we can just return it and be
                    // done with it.
                    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) return JSON.parse(value);
                    // The following code deals with deserializing some kind of Blob or
                    // TypedArray. First we separate out the type of data we're dealing
                    // with from the data itself.
                    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
                    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
                    var blobType;
                    // Backwards-compatible blob type serialization strategy.
                    // DBs created with older versions of localForage will simply not have the blob type.
                    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
                        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
                        blobType = matcher[1];
                        serializedString = serializedString.substring(matcher[0].length);
                    }
                    var buffer = stringToBuffer(serializedString);
                    // Return the right type based on the code/type set during
                    // serialization.
                    switch(type){
                        case TYPE_ARRAYBUFFER:
                            return buffer;
                        case TYPE_BLOB:
                            return createBlob([
                                buffer
                            ], {
                                type: blobType
                            });
                        case TYPE_INT8ARRAY:
                            return new Int8Array(buffer);
                        case TYPE_UINT8ARRAY:
                            return new Uint8Array(buffer);
                        case TYPE_UINT8CLAMPEDARRAY:
                            return new Uint8ClampedArray(buffer);
                        case TYPE_INT16ARRAY:
                            return new Int16Array(buffer);
                        case TYPE_UINT16ARRAY:
                            return new Uint16Array(buffer);
                        case TYPE_INT32ARRAY:
                            return new Int32Array(buffer);
                        case TYPE_UINT32ARRAY:
                            return new Uint32Array(buffer);
                        case TYPE_FLOAT32ARRAY:
                            return new Float32Array(buffer);
                        case TYPE_FLOAT64ARRAY:
                            return new Float64Array(buffer);
                        default:
                            throw new Error("Unkown type: " + type);
                    }
                }
                var localforageSerializer = {
                    serialize: serialize,
                    deserialize: deserialize,
                    stringToBuffer: stringToBuffer,
                    bufferToString: bufferToString
                };
                /*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ function createDbTable(t, dbInfo, callback, errorCallback) {
                    t.executeSql("CREATE TABLE IF NOT EXISTS " + dbInfo.storeName + " " + "(id INTEGER PRIMARY KEY, key unique, value)", [], callback, errorCallback);
                }
                // Open the WebSQL database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage$1(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = typeof options[i] !== "string" ? options[i].toString() : options[i];
                    var dbInfoPromise = new Promise$1(function(resolve, reject) {
                        // Open the database; the openDatabase API will automatically
                        // create it for us if it doesn't exist.
                        try {
                            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
                        } catch (e) {
                            return reject(e);
                        }
                        // Create our key/value table if it doesn't exist.
                        dbInfo.db.transaction(function(t) {
                            createDbTable(t, dbInfo, function() {
                                self1._dbInfo = dbInfo;
                                resolve();
                            }, function(t, error) {
                                reject(error);
                            });
                        }, reject);
                    });
                    dbInfo.serializer = localforageSerializer;
                    return dbInfoPromise;
                }
                function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
                    t.executeSql(sqlStatement, args, callback, function(t, error) {
                        if (error.code === error.SYNTAX_ERR) t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [
                            dbInfo.storeName
                        ], function(t, results) {
                            if (!results.rows.length) // if the table is missing (was deleted)
                            // re-create it table and retry
                            createDbTable(t, dbInfo, function() {
                                t.executeSql(sqlStatement, args, callback, errorCallback);
                            }, errorCallback);
                            else errorCallback(t, error);
                        }, errorCallback);
                        else errorCallback(t, error);
                    }, errorCallback);
                }
                function getItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName + " WHERE key = ? LIMIT 1", [
                                    key
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).value : null;
                                    // Check to see if this is serialized content we need to
                                    // unpack.
                                    if (result) result = dbInfo.serializer.deserialize(result);
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function iterate$1(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName, [], function(t, results) {
                                    var rows = results.rows;
                                    var length = rows.length;
                                    for(var i = 0; i < length; i++){
                                        var item = rows.item(i);
                                        var result = item.value;
                                        // Check to see if this is serialized content
                                        // we need to unpack.
                                        if (result) result = dbInfo.serializer.deserialize(result);
                                        result = iterator(result, item.key, i + 1);
                                        // void(0) prevents problems with redefinition
                                        // of `undefined`.
                                        if (result !== void 0) {
                                            resolve(result);
                                            return;
                                        }
                                    }
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function _setItem(key, value, callback, retriesLeft) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            // The localStorage API doesn't return undefined values in an
                            // "expected" way, so undefined is always cast to null in all
                            // drivers. See: https://github.com/mozilla/localForage/pull/42
                            if (value === undefined) value = null;
                            // Save the original value to pass to the callback.
                            var originalValue = value;
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else dbInfo.db.transaction(function(t) {
                                    tryExecuteSql(t, dbInfo, "INSERT OR REPLACE INTO " + dbInfo.storeName + " " + "(key, value) VALUES (?, ?)", [
                                        key,
                                        value
                                    ], function() {
                                        resolve(originalValue);
                                    }, function(t, error) {
                                        reject(error);
                                    });
                                }, function(sqlError) {
                                    // The transaction failed; check
                                    // to see if it's a quota error.
                                    if (sqlError.code === sqlError.QUOTA_ERR) {
                                        // We reject the callback outright for now, but
                                        // it's worth trying to re-run the transaction.
                                        // Even if the user accepts the prompt to use
                                        // more storage on Safari, this error will
                                        // be called.
                                        //
                                        // Try to re-run the transaction.
                                        if (retriesLeft > 0) {
                                            resolve(_setItem.apply(self1, [
                                                key,
                                                originalValue,
                                                callback,
                                                retriesLeft - 1
                                            ]));
                                            return;
                                        }
                                        reject(sqlError);
                                    }
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem$1(key, value, callback) {
                    return _setItem.apply(this, [
                        key,
                        value,
                        callback,
                        1
                    ]);
                }
                function removeItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName + " WHERE key = ?", [
                                    key
                                ], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Deletes every item in the table.
                // TODO: Find out if this resets the AUTO_INCREMENT number.
                function clear$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName, [], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Does a simple `COUNT(key)` to get the number of items stored in
                // localForage.
                function length$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                // Ahhh, SQL makes this one soooooo easy.
                                tryExecuteSql(t, dbInfo, "SELECT COUNT(key) as c FROM " + dbInfo.storeName, [], function(t, results) {
                                    var result = results.rows.item(0).c;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Return the key located at key index X; essentially gets the key from a
                // `WHERE id = ?`. This is the most efficient way I can think to implement
                // this rarely-used (in my experience) part of the API, but it can seem
                // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
                // the ID of each key will change every time it's updated. Perhaps a stored
                // procedure for the `setItem()` SQL would solve this problem?
                // TODO: Don't change ID on `setItem()`.
                function key$1(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName + " WHERE id = ? LIMIT 1", [
                                    n + 1
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).key : null;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName, [], function(t, results) {
                                    var keys = [];
                                    for(var i = 0; i < results.rows.length; i++)keys.push(results.rows.item(i).key);
                                    resolve(keys);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // https://www.w3.org/TR/webdatabase/#databases
                // > There is no way to enumerate or delete the databases available for an origin from this API.
                function getAllStoreNames(db) {
                    return new Promise$1(function(resolve, reject) {
                        db.transaction(function(t) {
                            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t, results) {
                                var storeNames = [];
                                for(var i = 0; i < results.rows.length; i++)storeNames.push(results.rows.item(i).name);
                                resolve({
                                    db: db,
                                    storeNames: storeNames
                                });
                            }, function(t, error) {
                                reject(error);
                            });
                        }, function(sqlError) {
                            reject(sqlError);
                        });
                    });
                }
                function dropInstance$1(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else promise = new Promise$1(function(resolve) {
                        var db;
                        if (options.name === currentConfig.name) // use the db reference of the current instance
                        db = self1._dbInfo.db;
                        else db = openDatabase(options.name, "", "", 0);
                        if (!options.storeName) // drop all database tables
                        resolve(getAllStoreNames(db));
                        else resolve({
                            db: db,
                            storeNames: [
                                options.storeName
                            ]
                        });
                    }).then(function(operationInfo) {
                        return new Promise$1(function(resolve, reject) {
                            operationInfo.db.transaction(function(t) {
                                function dropTable(storeName) {
                                    return new Promise$1(function(resolve, reject) {
                                        t.executeSql("DROP TABLE IF EXISTS " + storeName, [], function() {
                                            resolve();
                                        }, function(t, error) {
                                            reject(error);
                                        });
                                    });
                                }
                                var operations = [];
                                for(var i = 0, len = operationInfo.storeNames.length; i < len; i++)operations.push(dropTable(operationInfo.storeNames[i]));
                                Promise$1.all(operations).then(function() {
                                    resolve();
                                })["catch"](function(e) {
                                    reject(e);
                                });
                            }, function(sqlError) {
                                reject(sqlError);
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var webSQLStorage = {
                    _driver: "webSQLStorage",
                    _initStorage: _initStorage$1,
                    _support: isWebSQLValid(),
                    iterate: iterate$1,
                    getItem: getItem$1,
                    setItem: setItem$1,
                    removeItem: removeItem$1,
                    clear: clear$1,
                    length: length$1,
                    key: key$1,
                    keys: keys$1,
                    dropInstance: dropInstance$1
                };
                function isLocalStorageValid() {
                    try {
                        return typeof localStorage !== "undefined" && "setItem" in localStorage && // in IE8 typeof localStorage.setItem === 'object'
                        !!localStorage.setItem;
                    } catch (e) {
                        return false;
                    }
                }
                function _getKeyPrefix(options, defaultConfig) {
                    var keyPrefix = options.name + "/";
                    if (options.storeName !== defaultConfig.storeName) keyPrefix += options.storeName + "/";
                    return keyPrefix;
                }
                // Check if localStorage throws when saving an item
                function checkIfLocalStorageThrows() {
                    var localStorageTestKey = "_localforage_support_test";
                    try {
                        localStorage.setItem(localStorageTestKey, true);
                        localStorage.removeItem(localStorageTestKey);
                        return false;
                    } catch (e) {
                        return true;
                    }
                }
                // Check if localStorage is usable and allows to save an item
                // This method checks if localStorage is usable in Safari Private Browsing
                // mode, or in any other case where the available quota for localStorage
                // is 0 and there wasn't any saved items yet.
                function _isLocalStorageUsable() {
                    return !checkIfLocalStorageThrows() || localStorage.length > 0;
                }
                // Config the localStorage backend, using options set in the config.
                function _initStorage$2(options) {
                    var self1 = this;
                    var dbInfo = {};
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    dbInfo.keyPrefix = _getKeyPrefix(options, self1._defaultConfig);
                    if (!_isLocalStorageUsable()) return Promise$1.reject();
                    self1._dbInfo = dbInfo;
                    dbInfo.serializer = localforageSerializer;
                    return Promise$1.resolve();
                }
                // Remove all keys from the datastore, effectively destroying all data in
                // the app's key/value store!
                function clear$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var keyPrefix = self1._dbInfo.keyPrefix;
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Retrieve an item from the store. Unlike the original async_storage
                // library in Gaia, we don't modify return values at all. If a key's value
                // is `undefined`, we pass that value to the callback function.
                function getItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result = localStorage.getItem(dbInfo.keyPrefix + key);
                        // If a result was found, parse it from the serialized
                        // string into a JS object. If result isn't truthy, the key
                        // is likely undefined and we'll pass it straight to the
                        // callback.
                        if (result) result = dbInfo.serializer.deserialize(result);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items in the store.
                function iterate$2(iterator, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var keyPrefix = dbInfo.keyPrefix;
                        var keyPrefixLength = keyPrefix.length;
                        var length = localStorage.length;
                        // We use a dedicated iterator instead of the `i` variable below
                        // so other keys we fetch in localStorage aren't counted in
                        // the `iterationNumber` argument passed to the `iterate()`
                        // callback.
                        //
                        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
                        var iterationNumber = 1;
                        for(var i = 0; i < length; i++){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) !== 0) continue;
                            var value = localStorage.getItem(key);
                            // If a result was found, parse it from the serialized
                            // string into a JS object. If result isn't truthy, the
                            // key is likely undefined and we'll pass it straight
                            // to the iterator.
                            if (value) value = dbInfo.serializer.deserialize(value);
                            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
                            if (value !== void 0) return value;
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Same as localStorage's key() method, except takes a callback.
                function key$2(n, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result;
                        try {
                            result = localStorage.key(n);
                        } catch (error) {
                            result = null;
                        }
                        // Remove the prefix from the key, if a key is found.
                        if (result) result = result.substring(dbInfo.keyPrefix.length);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var length = localStorage.length;
                        var keys = [];
                        for(var i = 0; i < length; i++){
                            var itemKey = localStorage.key(i);
                            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                        }
                        return keys;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Supply the number of keys in the datastore to the callback function.
                function length$2(callback) {
                    var self1 = this;
                    var promise = self1.keys().then(function(keys) {
                        return keys.length;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Remove an item from the store, nice and simple.
                function removeItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        localStorage.removeItem(dbInfo.keyPrefix + key);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Set a key's value and run an optional callback once the value is set.
                // Unlike Gaia's implementation, the callback function is passed the value,
                // in case you want to operate on that value only after you're sure it
                // saved, or something like that.
                function setItem$2(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        // Convert undefined values to null.
                        // https://github.com/mozilla/localForage/pull/42
                        if (value === undefined) value = null;
                        // Save the original value to pass to the callback.
                        var originalValue = value;
                        return new Promise$1(function(resolve, reject) {
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else try {
                                    localStorage.setItem(dbInfo.keyPrefix + key, value);
                                    resolve(originalValue);
                                } catch (e) {
                                    // localStorage capacity exceeded.
                                    // TODO: Make this a specific error/event.
                                    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") reject(e);
                                    reject(e);
                                }
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance$2(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        var currentConfig = this.config();
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else promise = new Promise$1(function(resolve) {
                        if (!options.storeName) resolve(options.name + "/");
                        else resolve(_getKeyPrefix(options, self1._defaultConfig));
                    }).then(function(keyPrefix) {
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var localStorageWrapper = {
                    _driver: "localStorageWrapper",
                    _initStorage: _initStorage$2,
                    _support: isLocalStorageValid(),
                    iterate: iterate$2,
                    getItem: getItem$2,
                    setItem: setItem$2,
                    removeItem: removeItem$2,
                    clear: clear$2,
                    length: length$2,
                    key: key$2,
                    keys: keys$2,
                    dropInstance: dropInstance$2
                };
                var sameValue = function sameValue(x, y) {
                    return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
                };
                var includes = function includes(array, searchElement) {
                    var len = array.length;
                    var i = 0;
                    while(i < len){
                        if (sameValue(array[i], searchElement)) return true;
                        i++;
                    }
                    return false;
                };
                var isArray = Array.isArray || function(arg) {
                    return Object.prototype.toString.call(arg) === "[object Array]";
                };
                // Drivers are stored here when `defineDriver()` is called.
                // They are shared across all instances of localForage.
                var DefinedDrivers = {};
                var DriverSupport = {};
                var DefaultDrivers = {
                    INDEXEDDB: asyncStorage,
                    WEBSQL: webSQLStorage,
                    LOCALSTORAGE: localStorageWrapper
                };
                var DefaultDriverOrder = [
                    DefaultDrivers.INDEXEDDB._driver,
                    DefaultDrivers.WEBSQL._driver,
                    DefaultDrivers.LOCALSTORAGE._driver
                ];
                var OptionalDriverMethods = [
                    "dropInstance"
                ];
                var LibraryMethods = [
                    "clear",
                    "getItem",
                    "iterate",
                    "key",
                    "keys",
                    "length",
                    "removeItem",
                    "setItem"
                ].concat(OptionalDriverMethods);
                var DefaultConfig = {
                    description: "",
                    driver: DefaultDriverOrder.slice(),
                    name: "localforage",
                    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
                    // we can use without a prompt.
                    size: 4980736,
                    storeName: "keyvaluepairs",
                    version: 1.0
                };
                function callWhenReady(localForageInstance, libraryMethod) {
                    localForageInstance[libraryMethod] = function() {
                        var _args = arguments;
                        return localForageInstance.ready().then(function() {
                            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
                        });
                    };
                }
                function extend() {
                    for(var i = 1; i < arguments.length; i++){
                        var arg = arguments[i];
                        if (arg) {
                            for(var _key in arg)if (arg.hasOwnProperty(_key)) {
                                if (isArray(arg[_key])) arguments[0][_key] = arg[_key].slice();
                                else arguments[0][_key] = arg[_key];
                            }
                        }
                    }
                    return arguments[0];
                }
                var LocalForage = function() {
                    function LocalForage(options) {
                        _classCallCheck(this, LocalForage);
                        for(var driverTypeKey in DefaultDrivers)if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                            var driver = DefaultDrivers[driverTypeKey];
                            var driverName = driver._driver;
                            this[driverTypeKey] = driverName;
                            if (!DefinedDrivers[driverName]) // we don't need to wait for the promise,
                            // since the default drivers can be defined
                            // in a blocking manner
                            this.defineDriver(driver);
                        }
                        this._defaultConfig = extend({}, DefaultConfig);
                        this._config = extend({}, this._defaultConfig, options);
                        this._driverSet = null;
                        this._initDriver = null;
                        this._ready = false;
                        this._dbInfo = null;
                        this._wrapLibraryMethodsWithReady();
                        this.setDriver(this._config.driver)["catch"](function() {});
                    }
                    // Set any config values for localForage; can be called anytime before
                    // the first API call (e.g. `getItem`, `setItem`).
                    // We loop through options so we don't overwrite existing config
                    // values.
                    LocalForage.prototype.config = function config(options) {
                        // If the options argument is an object, we use it to set values.
                        // Otherwise, we return either a specified config value or all
                        // config values.
                        if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object") {
                            // If localforage is ready and fully initialized, we can't set
                            // any new configuration values. Instead, we return an error.
                            if (this._ready) return new Error("Can't call config() after localforage has been used.");
                            for(var i in options){
                                if (i === "storeName") options[i] = options[i].replace(/\W/g, "_");
                                if (i === "version" && typeof options[i] !== "number") return new Error("Database version must be a number.");
                                this._config[i] = options[i];
                            }
                            // after all config options are set and
                            // the driver option is used, try setting it
                            if ("driver" in options && options.driver) return this.setDriver(this._config.driver);
                            return true;
                        } else if (typeof options === "string") return this._config[options];
                        else return this._config;
                    };
                    // Used to define a custom driver, shared across all instances of
                    // localForage.
                    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
                        var promise = new Promise$1(function(resolve, reject) {
                            try {
                                var driverName = driverObject._driver;
                                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                                // A driver name should be defined and not overlap with the
                                // library-defined, default drivers.
                                if (!driverObject._driver) {
                                    reject(complianceError);
                                    return;
                                }
                                var driverMethods = LibraryMethods.concat("_initStorage");
                                for(var i = 0, len = driverMethods.length; i < len; i++){
                                    var driverMethodName = driverMethods[i];
                                    // when the property is there,
                                    // it should be a method even when optional
                                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== "function") {
                                        reject(complianceError);
                                        return;
                                    }
                                }
                                var configureMissingMethods = function configureMissingMethods() {
                                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                                        return function() {
                                            var error = new Error("Method " + methodName + " is not implemented by the current driver");
                                            var promise = Promise$1.reject(error);
                                            executeCallback(promise, arguments[arguments.length - 1]);
                                            return promise;
                                        };
                                    };
                                    for(var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++){
                                        var optionalDriverMethod = OptionalDriverMethods[_i];
                                        if (!driverObject[optionalDriverMethod]) driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                                    }
                                };
                                configureMissingMethods();
                                var setDriverSupport = function setDriverSupport(support) {
                                    if (DefinedDrivers[driverName]) console.info("Redefining LocalForage driver: " + driverName);
                                    DefinedDrivers[driverName] = driverObject;
                                    DriverSupport[driverName] = support;
                                    // don't use a then, so that we can define
                                    // drivers that have simple _support methods
                                    // in a blocking manner
                                    resolve();
                                };
                                if ("_support" in driverObject) {
                                    if (driverObject._support && typeof driverObject._support === "function") driverObject._support().then(setDriverSupport, reject);
                                    else setDriverSupport(!!driverObject._support);
                                } else setDriverSupport(true);
                            } catch (e) {
                                reject(e);
                            }
                        });
                        executeTwoCallbacks(promise, callback, errorCallback);
                        return promise;
                    };
                    LocalForage.prototype.driver = function driver() {
                        return this._driver || null;
                    };
                    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
                        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error("Driver not found."));
                        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
                        return getDriverPromise;
                    };
                    LocalForage.prototype.getSerializer = function getSerializer(callback) {
                        var serializerPromise = Promise$1.resolve(localforageSerializer);
                        executeTwoCallbacks(serializerPromise, callback);
                        return serializerPromise;
                    };
                    LocalForage.prototype.ready = function ready(callback) {
                        var self1 = this;
                        var promise = self1._driverSet.then(function() {
                            if (self1._ready === null) self1._ready = self1._initDriver();
                            return self1._ready;
                        });
                        executeTwoCallbacks(promise, callback, callback);
                        return promise;
                    };
                    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
                        var self1 = this;
                        if (!isArray(drivers)) drivers = [
                            drivers
                        ];
                        var supportedDrivers = this._getSupportedDrivers(drivers);
                        function setDriverToConfig() {
                            self1._config.driver = self1.driver();
                        }
                        function extendSelfWithDriver(driver) {
                            self1._extend(driver);
                            setDriverToConfig();
                            self1._ready = self1._initStorage(self1._config);
                            return self1._ready;
                        }
                        function initDriver(supportedDrivers) {
                            return function() {
                                var currentDriverIndex = 0;
                                function driverPromiseLoop() {
                                    while(currentDriverIndex < supportedDrivers.length){
                                        var driverName = supportedDrivers[currentDriverIndex];
                                        currentDriverIndex++;
                                        self1._dbInfo = null;
                                        self1._ready = null;
                                        return self1.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                                    }
                                    setDriverToConfig();
                                    var error = new Error("No available storage method found.");
                                    self1._driverSet = Promise$1.reject(error);
                                    return self1._driverSet;
                                }
                                return driverPromiseLoop();
                            };
                        }
                        // There might be a driver initialization in progress
                        // so wait for it to finish in order to avoid a possible
                        // race condition to set _dbInfo
                        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                            return Promise$1.resolve();
                        }) : Promise$1.resolve();
                        this._driverSet = oldDriverSetDone.then(function() {
                            var driverName = supportedDrivers[0];
                            self1._dbInfo = null;
                            self1._ready = null;
                            return self1.getDriver(driverName).then(function(driver) {
                                self1._driver = driver._driver;
                                setDriverToConfig();
                                self1._wrapLibraryMethodsWithReady();
                                self1._initDriver = initDriver(supportedDrivers);
                            });
                        })["catch"](function() {
                            setDriverToConfig();
                            var error = new Error("No available storage method found.");
                            self1._driverSet = Promise$1.reject(error);
                            return self1._driverSet;
                        });
                        executeTwoCallbacks(this._driverSet, callback, errorCallback);
                        return this._driverSet;
                    };
                    LocalForage.prototype.supports = function supports(driverName) {
                        return !!DriverSupport[driverName];
                    };
                    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
                        extend(this, libraryMethodsAndProperties);
                    };
                    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
                        var supportedDrivers = [];
                        for(var i = 0, len = drivers.length; i < len; i++){
                            var driverName = drivers[i];
                            if (this.supports(driverName)) supportedDrivers.push(driverName);
                        }
                        return supportedDrivers;
                    };
                    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
                        // Add a stub for each driver API method that delays the call to the
                        // corresponding driver method until localForage is ready. These stubs
                        // will be replaced by the driver methods as soon as the driver is
                        // loaded, so there is no performance impact.
                        for(var i = 0, len = LibraryMethods.length; i < len; i++)callWhenReady(this, LibraryMethods[i]);
                    };
                    LocalForage.prototype.createInstance = function createInstance(options) {
                        return new LocalForage(options);
                    };
                    return LocalForage;
                }();
                // The actual localForage object that we expose as a module or via a
                // global. It's extended by pulling in one of our other libraries.
                var localforage_js = new LocalForage();
                module1.exports = localforage_js;
            },
            {
                "3": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});


/*
 *  This file if for attaching variables to the DOM window object
 *  so that the same instance can be accessed by the entire application.
 */ 
var $ef6Fp = parcelRequire("ef6Fp");
var $e68dce13187de0df$exports = {};

$parcel$export($e68dce13187de0df$exports, "Alert", function () { return $e68dce13187de0df$export$caec2af78bcc877f; });
$parcel$export($e68dce13187de0df$exports, "Button", function () { return $e68dce13187de0df$export$353f5b6fc5456de1; });
$parcel$export($e68dce13187de0df$exports, "Carousel", function () { return $e68dce13187de0df$export$144901db2ea8e967; });
$parcel$export($e68dce13187de0df$exports, "Collapse", function () { return $e68dce13187de0df$export$78768a9af065a7b; });
$parcel$export($e68dce13187de0df$exports, "Dropdown", function () { return $e68dce13187de0df$export$931cbfb6bfb85fc; });
$parcel$export($e68dce13187de0df$exports, "Modal", function () { return $e68dce13187de0df$export$2b77a92f1a5ad772; });
$parcel$export($e68dce13187de0df$exports, "Offcanvas", function () { return $e68dce13187de0df$export$591ca0244c9dfcd4; });
$parcel$export($e68dce13187de0df$exports, "Tooltip", function () { return $e68dce13187de0df$export$28c660c63b792dea; });
$parcel$export($e68dce13187de0df$exports, "Popover", function () { return $e68dce13187de0df$export$5b6b19405a83ff9d; });
$parcel$export($e68dce13187de0df$exports, "ScrollSpy", function () { return $e68dce13187de0df$export$a6472a5298a374be; });
$parcel$export($e68dce13187de0df$exports, "Tab", function () { return $e68dce13187de0df$export$3e41faf802a29e71; });
$parcel$export($e68dce13187de0df$exports, "Toast", function () { return $e68dce13187de0df$export$8d8dc7d5f743331b; });
/*!
  * Bootstrap v5.3.7 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $d2054e51bcbb5869$exports = {};

$parcel$export($d2054e51bcbb5869$exports, "popperGenerator", function () { return $71ef57343cb7fe80$export$ed5e13716264f202; });
$parcel$export($d2054e51bcbb5869$exports, "detectOverflow", function () { return $f6c22a64aaa2baab$export$2e2bcd8739ae039; });
$parcel$export($d2054e51bcbb5869$exports, "createPopperBase", function () { return $71ef57343cb7fe80$export$8f7491d57c8f97a9; });
$parcel$export($d2054e51bcbb5869$exports, "createPopper", function () { return $a612f657457739c4$export$8f7491d57c8f97a9; });
$parcel$export($d2054e51bcbb5869$exports, "createPopperLite", function () { return $e657264122dce00f$export$8f7491d57c8f97a9; });
var $0e1a1c588b81aabe$exports = {};

$parcel$export($0e1a1c588b81aabe$exports, "top", function () { return $0e1a1c588b81aabe$export$1e95b668f3b82d; });
$parcel$export($0e1a1c588b81aabe$exports, "bottom", function () { return $0e1a1c588b81aabe$export$40e543e69a8b3fbb; });
$parcel$export($0e1a1c588b81aabe$exports, "right", function () { return $0e1a1c588b81aabe$export$79ffe56a765070d2; });
$parcel$export($0e1a1c588b81aabe$exports, "left", function () { return $0e1a1c588b81aabe$export$eabcd2c8791e7bf4; });
$parcel$export($0e1a1c588b81aabe$exports, "auto", function () { return $0e1a1c588b81aabe$export$dfb5619354ba860; });
$parcel$export($0e1a1c588b81aabe$exports, "basePlacements", function () { return $0e1a1c588b81aabe$export$aec2ce47c367b8c3; });
$parcel$export($0e1a1c588b81aabe$exports, "start", function () { return $0e1a1c588b81aabe$export$b3571188c770cc5a; });
$parcel$export($0e1a1c588b81aabe$exports, "end", function () { return $0e1a1c588b81aabe$export$bd5df0f255a350f8; });
$parcel$export($0e1a1c588b81aabe$exports, "clippingParents", function () { return $0e1a1c588b81aabe$export$390fd549c5303b4d; });
$parcel$export($0e1a1c588b81aabe$exports, "viewport", function () { return $0e1a1c588b81aabe$export$d7b7311ec04a3e8f; });
$parcel$export($0e1a1c588b81aabe$exports, "popper", function () { return $0e1a1c588b81aabe$export$ae5ab1c730825774; });
$parcel$export($0e1a1c588b81aabe$exports, "reference", function () { return $0e1a1c588b81aabe$export$ca50aac9f3ba507f; });
$parcel$export($0e1a1c588b81aabe$exports, "variationPlacements", function () { return $0e1a1c588b81aabe$export$368f9a87e87fa4e1; });
$parcel$export($0e1a1c588b81aabe$exports, "placements", function () { return $0e1a1c588b81aabe$export$803cd8101b6c182b; });
$parcel$export($0e1a1c588b81aabe$exports, "beforeRead", function () { return $0e1a1c588b81aabe$export$421679a7c3d56e; });
$parcel$export($0e1a1c588b81aabe$exports, "read", function () { return $0e1a1c588b81aabe$export$aafa59e2e03f2942; });
$parcel$export($0e1a1c588b81aabe$exports, "afterRead", function () { return $0e1a1c588b81aabe$export$6964f6c886723980; });
$parcel$export($0e1a1c588b81aabe$exports, "beforeMain", function () { return $0e1a1c588b81aabe$export$c65e99957a05207c; });
$parcel$export($0e1a1c588b81aabe$exports, "main", function () { return $0e1a1c588b81aabe$export$f22da7240b7add18; });
$parcel$export($0e1a1c588b81aabe$exports, "afterMain", function () { return $0e1a1c588b81aabe$export$bab79516f2d662fe; });
$parcel$export($0e1a1c588b81aabe$exports, "beforeWrite", function () { return $0e1a1c588b81aabe$export$8d4d2d70e7d46032; });
$parcel$export($0e1a1c588b81aabe$exports, "write", function () { return $0e1a1c588b81aabe$export$68d8715fc104d294; });
$parcel$export($0e1a1c588b81aabe$exports, "afterWrite", function () { return $0e1a1c588b81aabe$export$70a6e5159acce2e6; });
$parcel$export($0e1a1c588b81aabe$exports, "modifierPhases", function () { return $0e1a1c588b81aabe$export$d087d3878fdf71d5; });
var $0e1a1c588b81aabe$export$1e95b668f3b82d = "top";
var $0e1a1c588b81aabe$export$40e543e69a8b3fbb = "bottom";
var $0e1a1c588b81aabe$export$79ffe56a765070d2 = "right";
var $0e1a1c588b81aabe$export$eabcd2c8791e7bf4 = "left";
var $0e1a1c588b81aabe$export$dfb5619354ba860 = "auto";
var $0e1a1c588b81aabe$export$aec2ce47c367b8c3 = [
    $0e1a1c588b81aabe$export$1e95b668f3b82d,
    $0e1a1c588b81aabe$export$40e543e69a8b3fbb,
    $0e1a1c588b81aabe$export$79ffe56a765070d2,
    $0e1a1c588b81aabe$export$eabcd2c8791e7bf4
];
var $0e1a1c588b81aabe$export$b3571188c770cc5a = "start";
var $0e1a1c588b81aabe$export$bd5df0f255a350f8 = "end";
var $0e1a1c588b81aabe$export$390fd549c5303b4d = "clippingParents";
var $0e1a1c588b81aabe$export$d7b7311ec04a3e8f = "viewport";
var $0e1a1c588b81aabe$export$ae5ab1c730825774 = "popper";
var $0e1a1c588b81aabe$export$ca50aac9f3ba507f = "reference";
var $0e1a1c588b81aabe$export$368f9a87e87fa4e1 = /*#__PURE__*/ $0e1a1c588b81aabe$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $0e1a1c588b81aabe$export$b3571188c770cc5a,
        placement + "-" + $0e1a1c588b81aabe$export$bd5df0f255a350f8
    ]);
}, []);
var $0e1a1c588b81aabe$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($0e1a1c588b81aabe$export$aec2ce47c367b8c3, [
    $0e1a1c588b81aabe$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $0e1a1c588b81aabe$export$b3571188c770cc5a,
        placement + "-" + $0e1a1c588b81aabe$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $0e1a1c588b81aabe$export$421679a7c3d56e = "beforeRead";
var $0e1a1c588b81aabe$export$aafa59e2e03f2942 = "read";
var $0e1a1c588b81aabe$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $0e1a1c588b81aabe$export$c65e99957a05207c = "beforeMain";
var $0e1a1c588b81aabe$export$f22da7240b7add18 = "main";
var $0e1a1c588b81aabe$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $0e1a1c588b81aabe$export$8d4d2d70e7d46032 = "beforeWrite";
var $0e1a1c588b81aabe$export$68d8715fc104d294 = "write";
var $0e1a1c588b81aabe$export$70a6e5159acce2e6 = "afterWrite";
var $0e1a1c588b81aabe$export$d087d3878fdf71d5 = [
    $0e1a1c588b81aabe$export$421679a7c3d56e,
    $0e1a1c588b81aabe$export$aafa59e2e03f2942,
    $0e1a1c588b81aabe$export$6964f6c886723980,
    $0e1a1c588b81aabe$export$c65e99957a05207c,
    $0e1a1c588b81aabe$export$f22da7240b7add18,
    $0e1a1c588b81aabe$export$bab79516f2d662fe,
    $0e1a1c588b81aabe$export$8d4d2d70e7d46032,
    $0e1a1c588b81aabe$export$68d8715fc104d294,
    $0e1a1c588b81aabe$export$70a6e5159acce2e6
];


var $d289c9f3818799f2$exports = {};

$parcel$export($d289c9f3818799f2$exports, "applyStyles", function () { return $7e5f2254b36aee18$export$2e2bcd8739ae039; });
$parcel$export($d289c9f3818799f2$exports, "arrow", function () { return $0bd936701c8428d9$export$2e2bcd8739ae039; });
$parcel$export($d289c9f3818799f2$exports, "computeStyles", function () { return $dbf040557e31de8e$export$2e2bcd8739ae039; });
$parcel$export($d289c9f3818799f2$exports, "eventListeners", function () { return $3c49f311be497e5a$export$2e2bcd8739ae039; });
$parcel$export($d289c9f3818799f2$exports, "flip", function () { return $5ed0490c8f3d53a6$export$2e2bcd8739ae039; });
$parcel$export($d289c9f3818799f2$exports, "hide", function () { return $f2292b920c780f8e$export$2e2bcd8739ae039; });
$parcel$export($d289c9f3818799f2$exports, "offset", function () { return $9db28e4bdcfb5be3$export$2e2bcd8739ae039; });
$parcel$export($d289c9f3818799f2$exports, "popperOffsets", function () { return $8bb19b1108bfbd23$export$2e2bcd8739ae039; });
$parcel$export($d289c9f3818799f2$exports, "preventOverflow", function () { return $62c02c785105a949$export$2e2bcd8739ae039; });
function $e27392302b71e321$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $77c4a780d1255ed3$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $bdf26b98830ff718$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $77c4a780d1255ed3$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $bdf26b98830ff718$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $77c4a780d1255ed3$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $bdf26b98830ff718$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $77c4a780d1255ed3$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $7e5f2254b36aee18$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $bdf26b98830ff718$export$1b3bfaa9684536aa)(element) || !(0, $e27392302b71e321$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7e5f2254b36aee18$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $bdf26b98830ff718$export$1b3bfaa9684536aa)(element) || !(0, $e27392302b71e321$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7e5f2254b36aee18$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7e5f2254b36aee18$var$applyStyles,
    effect: $7e5f2254b36aee18$var$effect,
    requires: [
        "computeStyles"
    ]
};



function $a803059de6c210a1$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}



var $31b09f69cc6e4c5f$export$8960430cfd85939f = Math.max;
var $31b09f69cc6e4c5f$export$96ec731ed4dcb222 = Math.min;
var $31b09f69cc6e4c5f$export$2077e0241d6afd3c = Math.round;



function $d133c97f6f104ad2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $a148951d0573e7e7$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $d133c97f6f104ad2$export$2e2bcd8739ae039)());
}


function $1465881bb528e2ed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $bdf26b98830ff718$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $31b09f69cc6e4c5f$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $31b09f69cc6e4c5f$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $bdf26b98830ff718$export$45a5e7f76e0caa8d)(element) ? (0, $77c4a780d1255ed3$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $a148951d0573e7e7$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $f8c0cfe990e95d63$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1465881bb528e2ed$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $a22e6f92da686ab3$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $bdf26b98830ff718$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $5aae4f3d8b98cc91$export$2e2bcd8739ae039(element) {
    return (0, $77c4a780d1255ed3$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $dd849a618ea29518$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $e27392302b71e321$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0779c0d87b2cdb0b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $bdf26b98830ff718$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $232f19d6cd1ae630$export$2e2bcd8739ae039(element) {
    if ((0, $e27392302b71e321$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $bdf26b98830ff718$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0779c0d87b2cdb0b$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $dab625b74292c723$var$getTrueOffsetParent(element) {
    if (!(0, $bdf26b98830ff718$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5aae4f3d8b98cc91$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $dab625b74292c723$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $d133c97f6f104ad2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $d133c97f6f104ad2$export$2e2bcd8739ae039)());
    if (isIE && (0, $bdf26b98830ff718$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5aae4f3d8b98cc91$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $232f19d6cd1ae630$export$2e2bcd8739ae039)(element);
    if ((0, $bdf26b98830ff718$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $bdf26b98830ff718$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $e27392302b71e321$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $5aae4f3d8b98cc91$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $dab625b74292c723$export$2e2bcd8739ae039(element) {
    var window = (0, $77c4a780d1255ed3$export$2e2bcd8739ae039)(element);
    var offsetParent = $dab625b74292c723$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $dd849a618ea29518$export$2e2bcd8739ae039)(offsetParent) && (0, $5aae4f3d8b98cc91$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $dab625b74292c723$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $e27392302b71e321$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $e27392302b71e321$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $5aae4f3d8b98cc91$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $dab625b74292c723$var$getContainingBlock(element) || window;
}


function $f16d9f83ea560eda$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $19d13a19f57d68ea$export$f28d906d67a997f3(min, value, max) {
    return (0, $31b09f69cc6e4c5f$export$8960430cfd85939f)(min, (0, $31b09f69cc6e4c5f$export$96ec731ed4dcb222)(value, max));
}
function $19d13a19f57d68ea$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $19d13a19f57d68ea$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $b783e3ecb93628e6$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $e1f291828b2b0691$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $b783e3ecb93628e6$export$2e2bcd8739ae039)(), paddingObject);
}


function $d52f4da3c201eb96$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $0bd936701c8428d9$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $e1f291828b2b0691$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $d52f4da3c201eb96$export$2e2bcd8739ae039)(padding, (0, $0e1a1c588b81aabe$export$aec2ce47c367b8c3)));
};
function $0bd936701c8428d9$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $a803059de6c210a1$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $f16d9f83ea560eda$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $0e1a1c588b81aabe$export$eabcd2c8791e7bf4),
        (0, $0e1a1c588b81aabe$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0bd936701c8428d9$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $f8c0cfe990e95d63$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $0e1a1c588b81aabe$export$1e95b668f3b82d) : (0, $0e1a1c588b81aabe$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $0e1a1c588b81aabe$export$40e543e69a8b3fbb) : (0, $0e1a1c588b81aabe$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $dab625b74292c723$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $19d13a19f57d68ea$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0bd936701c8428d9$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $a22e6f92da686ab3$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0bd936701c8428d9$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $0bd936701c8428d9$var$arrow,
    effect: $0bd936701c8428d9$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $ef5229a457a72de8$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $dbf040557e31de8e$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $dbf040557e31de8e$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $31b09f69cc6e4c5f$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $31b09f69cc6e4c5f$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $dbf040557e31de8e$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $0e1a1c588b81aabe$export$eabcd2c8791e7bf4);
    var sideY = (0, $0e1a1c588b81aabe$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $dab625b74292c723$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $77c4a780d1255ed3$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0779c0d87b2cdb0b$export$2e2bcd8739ae039)(popper);
            if ((0, $5aae4f3d8b98cc91$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $0e1a1c588b81aabe$export$1e95b668f3b82d) || (placement === (0, $0e1a1c588b81aabe$export$eabcd2c8791e7bf4) || placement === (0, $0e1a1c588b81aabe$export$79ffe56a765070d2)) && variation === (0, $0e1a1c588b81aabe$export$bd5df0f255a350f8)) {
            sideY = (0, $0e1a1c588b81aabe$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $0e1a1c588b81aabe$export$eabcd2c8791e7bf4) || (placement === (0, $0e1a1c588b81aabe$export$1e95b668f3b82d) || placement === (0, $0e1a1c588b81aabe$export$40e543e69a8b3fbb)) && variation === (0, $0e1a1c588b81aabe$export$bd5df0f255a350f8)) {
            sideX = (0, $0e1a1c588b81aabe$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $dbf040557e31de8e$var$unsetSides);
    var _ref4 = roundOffsets === true ? $dbf040557e31de8e$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $77c4a780d1255ed3$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $dbf040557e31de8e$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $a803059de6c210a1$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $ef5229a457a72de8$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $dbf040557e31de8e$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $dbf040557e31de8e$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $dbf040557e31de8e$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $dbf040557e31de8e$var$computeStyles,
    data: {}
};



var $3c49f311be497e5a$var$passive = {
    passive: true
};
function $3c49f311be497e5a$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $77c4a780d1255ed3$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $3c49f311be497e5a$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $3c49f311be497e5a$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $3c49f311be497e5a$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $3c49f311be497e5a$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $3c49f311be497e5a$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $3c49f311be497e5a$var$effect,
    data: {}
};


var $40a0f1152ac72367$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $40a0f1152ac72367$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $40a0f1152ac72367$var$hash[matched];
    });
}



var $e0280c29f8546c01$var$hash = {
    start: "end",
    end: "start"
};
function $e0280c29f8546c01$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $e0280c29f8546c01$var$hash[matched];
    });
}








function $c484758836a797f6$export$2e2bcd8739ae039(node) {
    var win = (0, $77c4a780d1255ed3$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $6bcc2a973563c351$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1465881bb528e2ed$export$2e2bcd8739ae039)((0, $0779c0d87b2cdb0b$export$2e2bcd8739ae039)(element)).left + (0, $c484758836a797f6$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $dbc47ea5a2e3730c$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $77c4a780d1255ed3$export$2e2bcd8739ae039)(element);
    var html = (0, $0779c0d87b2cdb0b$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $a148951d0573e7e7$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $6bcc2a973563c351$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $4013ff5d004bc6fc$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0779c0d87b2cdb0b$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $c484758836a797f6$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $31b09f69cc6e4c5f$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $31b09f69cc6e4c5f$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $6bcc2a973563c351$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5aae4f3d8b98cc91$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $31b09f69cc6e4c5f$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $a88d285dfd855467$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5aae4f3d8b98cc91$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $2b880cb8a8777048$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $e27392302b71e321$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $bdf26b98830ff718$export$1b3bfaa9684536aa)(node) && (0, $a88d285dfd855467$export$2e2bcd8739ae039)(node)) return node;
    return $2b880cb8a8777048$export$2e2bcd8739ae039((0, $232f19d6cd1ae630$export$2e2bcd8739ae039)(node));
}





function $735a87954448ab50$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2b880cb8a8777048$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $77c4a780d1255ed3$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $a88d285dfd855467$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($735a87954448ab50$export$2e2bcd8739ae039((0, $232f19d6cd1ae630$export$2e2bcd8739ae039)(target)));
}










function $abe9ec1efa8a18ad$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $761b4851d41aaad4$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1465881bb528e2ed$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $761b4851d41aaad4$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $0e1a1c588b81aabe$export$d7b7311ec04a3e8f) ? (0, $abe9ec1efa8a18ad$export$2e2bcd8739ae039)((0, $dbc47ea5a2e3730c$export$2e2bcd8739ae039)(element, strategy)) : (0, $bdf26b98830ff718$export$45a5e7f76e0caa8d)(clippingParent) ? $761b4851d41aaad4$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $abe9ec1efa8a18ad$export$2e2bcd8739ae039)((0, $4013ff5d004bc6fc$export$2e2bcd8739ae039)((0, $0779c0d87b2cdb0b$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $761b4851d41aaad4$var$getClippingParents(element) {
    var clippingParents = (0, $735a87954448ab50$export$2e2bcd8739ae039)((0, $232f19d6cd1ae630$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $5aae4f3d8b98cc91$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $bdf26b98830ff718$export$1b3bfaa9684536aa)(element) ? (0, $dab625b74292c723$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $bdf26b98830ff718$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $bdf26b98830ff718$export$45a5e7f76e0caa8d)(clippingParent) && (0, $a22e6f92da686ab3$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $e27392302b71e321$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $761b4851d41aaad4$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $761b4851d41aaad4$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $761b4851d41aaad4$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $31b09f69cc6e4c5f$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $31b09f69cc6e4c5f$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $31b09f69cc6e4c5f$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $31b09f69cc6e4c5f$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $761b4851d41aaad4$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $a87e7bface968199$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $a803059de6c210a1$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $ef5229a457a72de8$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $0e1a1c588b81aabe$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $0e1a1c588b81aabe$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $0e1a1c588b81aabe$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $0e1a1c588b81aabe$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $f16d9f83ea560eda$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $0e1a1c588b81aabe$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $0e1a1c588b81aabe$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $f6c22a64aaa2baab$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $0e1a1c588b81aabe$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $0e1a1c588b81aabe$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $0e1a1c588b81aabe$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $e1f291828b2b0691$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $d52f4da3c201eb96$export$2e2bcd8739ae039)(padding, (0, $0e1a1c588b81aabe$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $0e1a1c588b81aabe$export$ae5ab1c730825774) ? (0, $0e1a1c588b81aabe$export$ca50aac9f3ba507f) : (0, $0e1a1c588b81aabe$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $761b4851d41aaad4$export$2e2bcd8739ae039)((0, $bdf26b98830ff718$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0779c0d87b2cdb0b$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1465881bb528e2ed$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $a87e7bface968199$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $abe9ec1efa8a18ad$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $0e1a1c588b81aabe$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $0e1a1c588b81aabe$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $0e1a1c588b81aabe$export$79ffe56a765070d2),
                (0, $0e1a1c588b81aabe$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $0e1a1c588b81aabe$export$1e95b668f3b82d),
                (0, $0e1a1c588b81aabe$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $948b912ed4611063$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $0e1a1c588b81aabe$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $ef5229a457a72de8$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $0e1a1c588b81aabe$export$368f9a87e87fa4e1) : (0, $0e1a1c588b81aabe$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $ef5229a457a72de8$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $0e1a1c588b81aabe$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f6c22a64aaa2baab$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $a803059de6c210a1$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $5ed0490c8f3d53a6$var$getExpandedFallbackPlacements(placement) {
    if ((0, $a803059de6c210a1$export$2e2bcd8739ae039)(placement) === (0, $0e1a1c588b81aabe$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $40a0f1152ac72367$export$2e2bcd8739ae039)(placement);
    return [
        (0, $e0280c29f8546c01$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $e0280c29f8546c01$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $5ed0490c8f3d53a6$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $a803059de6c210a1$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $40a0f1152ac72367$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $5ed0490c8f3d53a6$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $a803059de6c210a1$export$2e2bcd8739ae039)(placement) === (0, $0e1a1c588b81aabe$export$dfb5619354ba860) ? (0, $948b912ed4611063$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $a803059de6c210a1$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $ef5229a457a72de8$export$2e2bcd8739ae039)(placement) === (0, $0e1a1c588b81aabe$export$b3571188c770cc5a);
        var isVertical = [
            (0, $0e1a1c588b81aabe$export$1e95b668f3b82d),
            (0, $0e1a1c588b81aabe$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $f6c22a64aaa2baab$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $0e1a1c588b81aabe$export$79ffe56a765070d2) : (0, $0e1a1c588b81aabe$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $0e1a1c588b81aabe$export$40e543e69a8b3fbb) : (0, $0e1a1c588b81aabe$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $40a0f1152ac72367$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $40a0f1152ac72367$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $5ed0490c8f3d53a6$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $5ed0490c8f3d53a6$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $f2292b920c780f8e$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $f2292b920c780f8e$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $0e1a1c588b81aabe$export$1e95b668f3b82d),
        (0, $0e1a1c588b81aabe$export$79ffe56a765070d2),
        (0, $0e1a1c588b81aabe$export$40e543e69a8b3fbb),
        (0, $0e1a1c588b81aabe$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $f2292b920c780f8e$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f6c22a64aaa2baab$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $f6c22a64aaa2baab$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $f2292b920c780f8e$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $f2292b920c780f8e$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $f2292b920c780f8e$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $f2292b920c780f8e$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $f2292b920c780f8e$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $f2292b920c780f8e$var$hide
};




function $9db28e4bdcfb5be3$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $a803059de6c210a1$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $0e1a1c588b81aabe$export$eabcd2c8791e7bf4),
        (0, $0e1a1c588b81aabe$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $0e1a1c588b81aabe$export$eabcd2c8791e7bf4),
        (0, $0e1a1c588b81aabe$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $9db28e4bdcfb5be3$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $0e1a1c588b81aabe$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $9db28e4bdcfb5be3$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9db28e4bdcfb5be3$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $9db28e4bdcfb5be3$var$offset
};



function $8bb19b1108bfbd23$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $a87e7bface968199$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8bb19b1108bfbd23$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8bb19b1108bfbd23$var$popperOffsets,
    data: {}
};





function $8abcfaa6c2daf6b1$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $62c02c785105a949$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f6c22a64aaa2baab$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $a803059de6c210a1$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $ef5229a457a72de8$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $f16d9f83ea560eda$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $8abcfaa6c2daf6b1$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $0e1a1c588b81aabe$export$1e95b668f3b82d) : (0, $0e1a1c588b81aabe$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $0e1a1c588b81aabe$export$40e543e69a8b3fbb) : (0, $0e1a1c588b81aabe$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $0e1a1c588b81aabe$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $0e1a1c588b81aabe$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $f8c0cfe990e95d63$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $b783e3ecb93628e6$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $19d13a19f57d68ea$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $dab625b74292c723$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $19d13a19f57d68ea$export$f28d906d67a997f3)(tether ? (0, $31b09f69cc6e4c5f$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $31b09f69cc6e4c5f$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $0e1a1c588b81aabe$export$1e95b668f3b82d) : (0, $0e1a1c588b81aabe$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $0e1a1c588b81aabe$export$40e543e69a8b3fbb) : (0, $0e1a1c588b81aabe$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $0e1a1c588b81aabe$export$1e95b668f3b82d),
            (0, $0e1a1c588b81aabe$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $19d13a19f57d68ea$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $19d13a19f57d68ea$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $62c02c785105a949$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $62c02c785105a949$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};








function $fa6d3d8002a119e3$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $08beb36b4fa5a343$export$2e2bcd8739ae039(node) {
    if (node === (0, $77c4a780d1255ed3$export$2e2bcd8739ae039)(node) || !(0, $bdf26b98830ff718$export$1b3bfaa9684536aa)(node)) return (0, $c484758836a797f6$export$2e2bcd8739ae039)(node);
    else return (0, $fa6d3d8002a119e3$export$2e2bcd8739ae039)(node);
}








function $777b03e54ff3e782$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $31b09f69cc6e4c5f$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $31b09f69cc6e4c5f$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $777b03e54ff3e782$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $bdf26b98830ff718$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $bdf26b98830ff718$export$1b3bfaa9684536aa)(offsetParent) && $777b03e54ff3e782$var$isElementScaled(offsetParent);
    var documentElement = (0, $0779c0d87b2cdb0b$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $1465881bb528e2ed$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $e27392302b71e321$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $a88d285dfd855467$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $08beb36b4fa5a343$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $bdf26b98830ff718$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $1465881bb528e2ed$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $6bcc2a973563c351$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $aee714d165a62f10$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $aee714d165a62f10$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $aee714d165a62f10$var$order(modifiers); // order based on phase
    return (0, $0e1a1c588b81aabe$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $0a0596d1a4ed6853$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $3f21cb96ddce0107$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $71ef57343cb7fe80$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $71ef57343cb7fe80$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $71ef57343cb7fe80$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $71ef57343cb7fe80$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $71ef57343cb7fe80$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $bdf26b98830ff718$export$45a5e7f76e0caa8d)(reference) ? (0, $735a87954448ab50$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $735a87954448ab50$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $735a87954448ab50$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $aee714d165a62f10$export$2e2bcd8739ae039)((0, $3f21cb96ddce0107$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$71ef57343cb7fe80$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $777b03e54ff3e782$export$2e2bcd8739ae039)(reference, (0, $dab625b74292c723$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $f8c0cfe990e95d63$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $0a0596d1a4ed6853$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$71ef57343cb7fe80$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $71ef57343cb7fe80$export$8f7491d57c8f97a9 = /*#__PURE__*/ $71ef57343cb7fe80$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $a612f657457739c4$export$d34966752335dd47 = [
    (0, $3c49f311be497e5a$export$2e2bcd8739ae039),
    (0, $8bb19b1108bfbd23$export$2e2bcd8739ae039),
    (0, $dbf040557e31de8e$export$2e2bcd8739ae039),
    (0, $7e5f2254b36aee18$export$2e2bcd8739ae039),
    (0, $9db28e4bdcfb5be3$export$2e2bcd8739ae039),
    (0, $5ed0490c8f3d53a6$export$2e2bcd8739ae039),
    (0, $62c02c785105a949$export$2e2bcd8739ae039),
    (0, $0bd936701c8428d9$export$2e2bcd8739ae039),
    (0, $f2292b920c780f8e$export$2e2bcd8739ae039)
];
var $a612f657457739c4$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $71ef57343cb7fe80$export$ed5e13716264f202)({
    defaultModifiers: $a612f657457739c4$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $e657264122dce00f$export$d34966752335dd47 = [
    (0, $3c49f311be497e5a$export$2e2bcd8739ae039),
    (0, $8bb19b1108bfbd23$export$2e2bcd8739ae039),
    (0, $dbf040557e31de8e$export$2e2bcd8739ae039),
    (0, $7e5f2254b36aee18$export$2e2bcd8739ae039)
];
var $e657264122dce00f$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $71ef57343cb7fe80$export$ed5e13716264f202)({
    defaultModifiers: $e657264122dce00f$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($d2054e51bcbb5869$exports, $0e1a1c588b81aabe$exports);
$parcel$exportWildcard($d2054e51bcbb5869$exports, $d289c9f3818799f2$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$elementMap = new Map();
const $e68dce13187de0df$var$Data = {
    set (element, key, instance) {
        if (!$e68dce13187de0df$var$elementMap.has(element)) $e68dce13187de0df$var$elementMap.set(element, new Map());
        const instanceMap = $e68dce13187de0df$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($e68dce13187de0df$var$elementMap.has(element)) return $e68dce13187de0df$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$e68dce13187de0df$var$elementMap.has(element)) return;
        const instanceMap = $e68dce13187de0df$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $e68dce13187de0df$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e68dce13187de0df$var$MAX_UID = 1000000;
const $e68dce13187de0df$var$MILLISECONDS_MULTIPLIER = 1000;
const $e68dce13187de0df$var$TRANSITION_END = "transitionend";
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $e68dce13187de0df$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $e68dce13187de0df$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $e68dce13187de0df$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $e68dce13187de0df$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $e68dce13187de0df$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $e68dce13187de0df$var$MILLISECONDS_MULTIPLIER;
};
const $e68dce13187de0df$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($e68dce13187de0df$var$TRANSITION_END));
};
const $e68dce13187de0df$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $e68dce13187de0df$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($e68dce13187de0df$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector($e68dce13187de0df$var$parseSelector(object));
    return null;
};
const $e68dce13187de0df$var$isVisible = (element)=>{
    if (!$e68dce13187de0df$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $e68dce13187de0df$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const $e68dce13187de0df$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $e68dce13187de0df$var$findShadowRoot(element.parentNode);
};
const $e68dce13187de0df$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $e68dce13187de0df$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $e68dce13187de0df$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const $e68dce13187de0df$var$DOMContentLoadedCallbacks = [];
const $e68dce13187de0df$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!$e68dce13187de0df$var$DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of $e68dce13187de0df$var$DOMContentLoadedCallbacks)callback();
        });
        $e68dce13187de0df$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $e68dce13187de0df$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $e68dce13187de0df$var$defineJQueryPlugin = (plugin)=>{
    $e68dce13187de0df$var$onDOMContentLoaded(()=>{
        const $ = $e68dce13187de0df$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $e68dce13187de0df$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback.call(...args) : defaultValue;
};
const $e68dce13187de0df$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $e68dce13187de0df$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $e68dce13187de0df$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($e68dce13187de0df$var$TRANSITION_END, handler);
        $e68dce13187de0df$var$execute(callback);
    };
    transitionElement.addEventListener($e68dce13187de0df$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $e68dce13187de0df$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $e68dce13187de0df$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $e68dce13187de0df$var$stripNameRegex = /\..*/;
const $e68dce13187de0df$var$stripUidRegex = /::\d+$/;
const $e68dce13187de0df$var$eventRegistry = {}; // Events storage
let $e68dce13187de0df$var$uidEvent = 1;
const $e68dce13187de0df$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $e68dce13187de0df$var$nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function $e68dce13187de0df$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$e68dce13187de0df$var$uidEvent++}` || element.uidEvent || $e68dce13187de0df$var$uidEvent++;
}
function $e68dce13187de0df$var$getElementEvents(element) {
    const uid = $e68dce13187de0df$var$makeEventUid(element);
    element.uidEvent = uid;
    $e68dce13187de0df$var$eventRegistry[uid] = $e68dce13187de0df$var$eventRegistry[uid] || {};
    return $e68dce13187de0df$var$eventRegistry[uid];
}
function $e68dce13187de0df$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $e68dce13187de0df$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $e68dce13187de0df$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $e68dce13187de0df$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $e68dce13187de0df$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $e68dce13187de0df$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $e68dce13187de0df$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $e68dce13187de0df$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $e68dce13187de0df$var$getTypeEvent(originalTypeEvent);
    if (!$e68dce13187de0df$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $e68dce13187de0df$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = $e68dce13187de0df$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $e68dce13187de0df$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $e68dce13187de0df$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $e68dce13187de0df$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $e68dce13187de0df$var$makeEventUid(callable, originalTypeEvent.replace($e68dce13187de0df$var$namespaceRegex, ""));
    const fn = isDelegated ? $e68dce13187de0df$var$bootstrapDelegationHandler(element, handler, callable) : $e68dce13187de0df$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $e68dce13187de0df$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $e68dce13187de0df$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $e68dce13187de0df$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $e68dce13187de0df$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $e68dce13187de0df$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($e68dce13187de0df$var$stripNameRegex, "");
    return $e68dce13187de0df$var$customEvents[event] || event;
}
const $e68dce13187de0df$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $e68dce13187de0df$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $e68dce13187de0df$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = $e68dce13187de0df$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $e68dce13187de0df$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $e68dce13187de0df$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$e68dce13187de0df$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($e68dce13187de0df$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $e68dce13187de0df$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = $e68dce13187de0df$var$getjQuery();
        const typeEvent = $e68dce13187de0df$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $e68dce13187de0df$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $e68dce13187de0df$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $e68dce13187de0df$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $e68dce13187de0df$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $e68dce13187de0df$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$e68dce13187de0df$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$e68dce13187de0df$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $e68dce13187de0df$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $e68dce13187de0df$var$normalizeData(element.getAttribute(`data-bs-${$e68dce13187de0df$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $e68dce13187de0df$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $e68dce13187de0df$var$isElement(element) ? $e68dce13187de0df$var$Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$e68dce13187de0df$var$isElement(element) ? $e68dce13187de0df$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $e68dce13187de0df$var$isElement(value) ? "element" : $e68dce13187de0df$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$VERSION = "5.3.7";
/**
 * Class definition
 */ class $e68dce13187de0df$var$BaseComponent extends $e68dce13187de0df$var$Config {
    constructor(element, config){
        super();
        element = $e68dce13187de0df$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $e68dce13187de0df$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $e68dce13187de0df$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $e68dce13187de0df$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $e68dce13187de0df$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $e68dce13187de0df$var$Data.get($e68dce13187de0df$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $e68dce13187de0df$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e68dce13187de0df$var$getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href");
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(",").map((sel)=>$e68dce13187de0df$var$parseSelector(sel)).join(",") : null;
};
const $e68dce13187de0df$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!$e68dce13187de0df$var$isDisabled(el) && $e68dce13187de0df$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $e68dce13187de0df$var$getSelector(element);
        if (selector) return $e68dce13187de0df$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $e68dce13187de0df$var$getSelector(element);
        return selector ? $e68dce13187de0df$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $e68dce13187de0df$var$getSelector(element);
        return selector ? $e68dce13187de0df$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e68dce13187de0df$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $e68dce13187de0df$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($e68dce13187de0df$var$isDisabled(this)) return;
        const target = $e68dce13187de0df$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$f = "alert";
const $e68dce13187de0df$var$DATA_KEY$a = "bs.alert";
const $e68dce13187de0df$var$EVENT_KEY$b = `.${$e68dce13187de0df$var$DATA_KEY$a}`;
const $e68dce13187de0df$var$EVENT_CLOSE = `close${$e68dce13187de0df$var$EVENT_KEY$b}`;
const $e68dce13187de0df$var$EVENT_CLOSED = `closed${$e68dce13187de0df$var$EVENT_KEY$b}`;
const $e68dce13187de0df$var$CLASS_NAME_FADE$5 = "fade";
const $e68dce13187de0df$var$CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class $e68dce13187de0df$export$caec2af78bcc877f extends $e68dce13187de0df$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e68dce13187de0df$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($e68dce13187de0df$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($e68dce13187de0df$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e68dce13187de0df$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e68dce13187de0df$var$enableDismissTrigger($e68dce13187de0df$export$caec2af78bcc877f, "close");
/**
 * jQuery
 */ $e68dce13187de0df$var$defineJQueryPlugin($e68dce13187de0df$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$e = "button";
const $e68dce13187de0df$var$DATA_KEY$9 = "bs.button";
const $e68dce13187de0df$var$EVENT_KEY$a = `.${$e68dce13187de0df$var$DATA_KEY$9}`;
const $e68dce13187de0df$var$DATA_API_KEY$6 = ".data-api";
const $e68dce13187de0df$var$CLASS_NAME_ACTIVE$3 = "active";
const $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $e68dce13187de0df$var$EVENT_CLICK_DATA_API$6 = `click${$e68dce13187de0df$var$EVENT_KEY$a}${$e68dce13187de0df$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $e68dce13187de0df$export$353f5b6fc5456de1 extends $e68dce13187de0df$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e68dce13187de0df$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($e68dce13187de0df$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e68dce13187de0df$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e68dce13187de0df$var$EventHandler.on(document, $e68dce13187de0df$var$EVENT_CLICK_DATA_API$6, $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$5);
    const data = $e68dce13187de0df$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $e68dce13187de0df$var$defineJQueryPlugin($e68dce13187de0df$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$d = "swipe";
const $e68dce13187de0df$var$EVENT_KEY$9 = ".bs.swipe";
const $e68dce13187de0df$var$EVENT_TOUCHSTART = `touchstart${$e68dce13187de0df$var$EVENT_KEY$9}`;
const $e68dce13187de0df$var$EVENT_TOUCHMOVE = `touchmove${$e68dce13187de0df$var$EVENT_KEY$9}`;
const $e68dce13187de0df$var$EVENT_TOUCHEND = `touchend${$e68dce13187de0df$var$EVENT_KEY$9}`;
const $e68dce13187de0df$var$EVENT_POINTERDOWN = `pointerdown${$e68dce13187de0df$var$EVENT_KEY$9}`;
const $e68dce13187de0df$var$EVENT_POINTERUP = `pointerup${$e68dce13187de0df$var$EVENT_KEY$9}`;
const $e68dce13187de0df$var$POINTER_TYPE_TOUCH = "touch";
const $e68dce13187de0df$var$POINTER_TYPE_PEN = "pen";
const $e68dce13187de0df$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $e68dce13187de0df$var$SWIPE_THRESHOLD = 40;
const $e68dce13187de0df$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $e68dce13187de0df$var$DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class $e68dce13187de0df$var$Swipe extends $e68dce13187de0df$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$e68dce13187de0df$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $e68dce13187de0df$var$Default$c;
    }
    static get DefaultType() {
        return $e68dce13187de0df$var$DefaultType$c;
    }
    static get NAME() {
        return $e68dce13187de0df$var$NAME$d;
    }
    // Public
    dispose() {
        $e68dce13187de0df$var$EventHandler.off(this._element, $e68dce13187de0df$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $e68dce13187de0df$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $e68dce13187de0df$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $e68dce13187de0df$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $e68dce13187de0df$var$POINTER_TYPE_PEN || event.pointerType === $e68dce13187de0df$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$c = "carousel";
const $e68dce13187de0df$var$DATA_KEY$8 = "bs.carousel";
const $e68dce13187de0df$var$EVENT_KEY$8 = `.${$e68dce13187de0df$var$DATA_KEY$8}`;
const $e68dce13187de0df$var$DATA_API_KEY$5 = ".data-api";
const $e68dce13187de0df$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $e68dce13187de0df$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $e68dce13187de0df$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $e68dce13187de0df$var$ORDER_NEXT = "next";
const $e68dce13187de0df$var$ORDER_PREV = "prev";
const $e68dce13187de0df$var$DIRECTION_LEFT = "left";
const $e68dce13187de0df$var$DIRECTION_RIGHT = "right";
const $e68dce13187de0df$var$EVENT_SLIDE = `slide${$e68dce13187de0df$var$EVENT_KEY$8}`;
const $e68dce13187de0df$var$EVENT_SLID = `slid${$e68dce13187de0df$var$EVENT_KEY$8}`;
const $e68dce13187de0df$var$EVENT_KEYDOWN$1 = `keydown${$e68dce13187de0df$var$EVENT_KEY$8}`;
const $e68dce13187de0df$var$EVENT_MOUSEENTER$1 = `mouseenter${$e68dce13187de0df$var$EVENT_KEY$8}`;
const $e68dce13187de0df$var$EVENT_MOUSELEAVE$1 = `mouseleave${$e68dce13187de0df$var$EVENT_KEY$8}`;
const $e68dce13187de0df$var$EVENT_DRAG_START = `dragstart${$e68dce13187de0df$var$EVENT_KEY$8}`;
const $e68dce13187de0df$var$EVENT_LOAD_DATA_API$3 = `load${$e68dce13187de0df$var$EVENT_KEY$8}${$e68dce13187de0df$var$DATA_API_KEY$5}`;
const $e68dce13187de0df$var$EVENT_CLICK_DATA_API$5 = `click${$e68dce13187de0df$var$EVENT_KEY$8}${$e68dce13187de0df$var$DATA_API_KEY$5}`;
const $e68dce13187de0df$var$CLASS_NAME_CAROUSEL = "carousel";
const $e68dce13187de0df$var$CLASS_NAME_ACTIVE$2 = "active";
const $e68dce13187de0df$var$CLASS_NAME_SLIDE = "slide";
const $e68dce13187de0df$var$CLASS_NAME_END = "carousel-item-end";
const $e68dce13187de0df$var$CLASS_NAME_START = "carousel-item-start";
const $e68dce13187de0df$var$CLASS_NAME_NEXT = "carousel-item-next";
const $e68dce13187de0df$var$CLASS_NAME_PREV = "carousel-item-prev";
const $e68dce13187de0df$var$SELECTOR_ACTIVE = ".active";
const $e68dce13187de0df$var$SELECTOR_ITEM = ".carousel-item";
const $e68dce13187de0df$var$SELECTOR_ACTIVE_ITEM = $e68dce13187de0df$var$SELECTOR_ACTIVE + $e68dce13187de0df$var$SELECTOR_ITEM;
const $e68dce13187de0df$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $e68dce13187de0df$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $e68dce13187de0df$var$SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const $e68dce13187de0df$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $e68dce13187de0df$var$KEY_TO_DIRECTION = {
    [$e68dce13187de0df$var$ARROW_LEFT_KEY$1]: $e68dce13187de0df$var$DIRECTION_RIGHT,
    [$e68dce13187de0df$var$ARROW_RIGHT_KEY$1]: $e68dce13187de0df$var$DIRECTION_LEFT
};
const $e68dce13187de0df$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $e68dce13187de0df$var$DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class $e68dce13187de0df$export$144901db2ea8e967 extends $e68dce13187de0df$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $e68dce13187de0df$var$SelectorEngine.findOne($e68dce13187de0df$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $e68dce13187de0df$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $e68dce13187de0df$var$Default$b;
    }
    static get DefaultType() {
        return $e68dce13187de0df$var$DefaultType$b;
    }
    static get NAME() {
        return $e68dce13187de0df$var$NAME$c;
    }
    // Public
    next() {
        this._slide($e68dce13187de0df$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $e68dce13187de0df$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($e68dce13187de0df$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $e68dce13187de0df$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $e68dce13187de0df$var$EventHandler.one(this._element, $e68dce13187de0df$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $e68dce13187de0df$var$EventHandler.one(this._element, $e68dce13187de0df$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $e68dce13187de0df$var$ORDER_NEXT : $e68dce13187de0df$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $e68dce13187de0df$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $e68dce13187de0df$var$SelectorEngine.find($e68dce13187de0df$var$SELECTOR_ITEM_IMG, this._element))$e68dce13187de0df$var$EventHandler.on(img, $e68dce13187de0df$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $e68dce13187de0df$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($e68dce13187de0df$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($e68dce13187de0df$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $e68dce13187de0df$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $e68dce13187de0df$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $e68dce13187de0df$var$SelectorEngine.findOne($e68dce13187de0df$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($e68dce13187de0df$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $e68dce13187de0df$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($e68dce13187de0df$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $e68dce13187de0df$var$ORDER_NEXT;
        const nextElement = element || $e68dce13187de0df$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $e68dce13187de0df$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($e68dce13187de0df$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $e68dce13187de0df$var$CLASS_NAME_START : $e68dce13187de0df$var$CLASS_NAME_END;
        const orderClassName = isNext ? $e68dce13187de0df$var$CLASS_NAME_NEXT : $e68dce13187de0df$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $e68dce13187de0df$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($e68dce13187de0df$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($e68dce13187de0df$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($e68dce13187de0df$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($e68dce13187de0df$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $e68dce13187de0df$var$SelectorEngine.findOne($e68dce13187de0df$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $e68dce13187de0df$var$SelectorEngine.find($e68dce13187de0df$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($e68dce13187de0df$var$isRTL()) return direction === $e68dce13187de0df$var$DIRECTION_LEFT ? $e68dce13187de0df$var$ORDER_PREV : $e68dce13187de0df$var$ORDER_NEXT;
        return direction === $e68dce13187de0df$var$DIRECTION_LEFT ? $e68dce13187de0df$var$ORDER_NEXT : $e68dce13187de0df$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($e68dce13187de0df$var$isRTL()) return order === $e68dce13187de0df$var$ORDER_PREV ? $e68dce13187de0df$var$DIRECTION_LEFT : $e68dce13187de0df$var$DIRECTION_RIGHT;
        return order === $e68dce13187de0df$var$ORDER_PREV ? $e68dce13187de0df$var$DIRECTION_RIGHT : $e68dce13187de0df$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e68dce13187de0df$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e68dce13187de0df$var$EventHandler.on(document, $e68dce13187de0df$var$EVENT_CLICK_DATA_API$5, $e68dce13187de0df$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $e68dce13187de0df$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($e68dce13187de0df$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $e68dce13187de0df$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($e68dce13187de0df$var$Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$e68dce13187de0df$var$EventHandler.on(window, $e68dce13187de0df$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $e68dce13187de0df$var$SelectorEngine.find($e68dce13187de0df$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$e68dce13187de0df$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $e68dce13187de0df$var$defineJQueryPlugin($e68dce13187de0df$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$b = "collapse";
const $e68dce13187de0df$var$DATA_KEY$7 = "bs.collapse";
const $e68dce13187de0df$var$EVENT_KEY$7 = `.${$e68dce13187de0df$var$DATA_KEY$7}`;
const $e68dce13187de0df$var$DATA_API_KEY$4 = ".data-api";
const $e68dce13187de0df$var$EVENT_SHOW$6 = `show${$e68dce13187de0df$var$EVENT_KEY$7}`;
const $e68dce13187de0df$var$EVENT_SHOWN$6 = `shown${$e68dce13187de0df$var$EVENT_KEY$7}`;
const $e68dce13187de0df$var$EVENT_HIDE$6 = `hide${$e68dce13187de0df$var$EVENT_KEY$7}`;
const $e68dce13187de0df$var$EVENT_HIDDEN$6 = `hidden${$e68dce13187de0df$var$EVENT_KEY$7}`;
const $e68dce13187de0df$var$EVENT_CLICK_DATA_API$4 = `click${$e68dce13187de0df$var$EVENT_KEY$7}${$e68dce13187de0df$var$DATA_API_KEY$4}`;
const $e68dce13187de0df$var$CLASS_NAME_SHOW$7 = "show";
const $e68dce13187de0df$var$CLASS_NAME_COLLAPSE = "collapse";
const $e68dce13187de0df$var$CLASS_NAME_COLLAPSING = "collapsing";
const $e68dce13187de0df$var$CLASS_NAME_COLLAPSED = "collapsed";
const $e68dce13187de0df$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$e68dce13187de0df$var$CLASS_NAME_COLLAPSE} .${$e68dce13187de0df$var$CLASS_NAME_COLLAPSE}`;
const $e68dce13187de0df$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $e68dce13187de0df$var$WIDTH = "width";
const $e68dce13187de0df$var$HEIGHT = "height";
const $e68dce13187de0df$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $e68dce13187de0df$var$Default$a = {
    parent: null,
    toggle: true
};
const $e68dce13187de0df$var$DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class $e68dce13187de0df$export$78768a9af065a7b extends $e68dce13187de0df$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $e68dce13187de0df$var$SelectorEngine.find($e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $e68dce13187de0df$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $e68dce13187de0df$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $e68dce13187de0df$var$Default$a;
    }
    static get DefaultType() {
        return $e68dce13187de0df$var$DefaultType$a;
    }
    static get NAME() {
        return $e68dce13187de0df$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($e68dce13187de0df$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$e68dce13187de0df$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($e68dce13187de0df$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e68dce13187de0df$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_COLLAPSE, $e68dce13187de0df$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $e68dce13187de0df$var$reflow(this._element);
        this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($e68dce13187de0df$var$CLASS_NAME_COLLAPSE, $e68dce13187de0df$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $e68dce13187de0df$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e68dce13187de0df$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_COLLAPSE);
            $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($e68dce13187de0df$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $e68dce13187de0df$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($e68dce13187de0df$var$CLASS_NAME_HORIZONTAL) ? $e68dce13187de0df$var$WIDTH : $e68dce13187de0df$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $e68dce13187de0df$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $e68dce13187de0df$var$SelectorEngine.find($e68dce13187de0df$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $e68dce13187de0df$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($e68dce13187de0df$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $e68dce13187de0df$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e68dce13187de0df$var$EventHandler.on(document, $e68dce13187de0df$var$EVENT_CLICK_DATA_API$4, $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    for (const element of $e68dce13187de0df$var$SelectorEngine.getMultipleElementsFromSelector(this))$e68dce13187de0df$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $e68dce13187de0df$var$defineJQueryPlugin($e68dce13187de0df$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$a = "dropdown";
const $e68dce13187de0df$var$DATA_KEY$6 = "bs.dropdown";
const $e68dce13187de0df$var$EVENT_KEY$6 = `.${$e68dce13187de0df$var$DATA_KEY$6}`;
const $e68dce13187de0df$var$DATA_API_KEY$3 = ".data-api";
const $e68dce13187de0df$var$ESCAPE_KEY$2 = "Escape";
const $e68dce13187de0df$var$TAB_KEY$1 = "Tab";
const $e68dce13187de0df$var$ARROW_UP_KEY$1 = "ArrowUp";
const $e68dce13187de0df$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $e68dce13187de0df$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $e68dce13187de0df$var$EVENT_HIDE$5 = `hide${$e68dce13187de0df$var$EVENT_KEY$6}`;
const $e68dce13187de0df$var$EVENT_HIDDEN$5 = `hidden${$e68dce13187de0df$var$EVENT_KEY$6}`;
const $e68dce13187de0df$var$EVENT_SHOW$5 = `show${$e68dce13187de0df$var$EVENT_KEY$6}`;
const $e68dce13187de0df$var$EVENT_SHOWN$5 = `shown${$e68dce13187de0df$var$EVENT_KEY$6}`;
const $e68dce13187de0df$var$EVENT_CLICK_DATA_API$3 = `click${$e68dce13187de0df$var$EVENT_KEY$6}${$e68dce13187de0df$var$DATA_API_KEY$3}`;
const $e68dce13187de0df$var$EVENT_KEYDOWN_DATA_API = `keydown${$e68dce13187de0df$var$EVENT_KEY$6}${$e68dce13187de0df$var$DATA_API_KEY$3}`;
const $e68dce13187de0df$var$EVENT_KEYUP_DATA_API = `keyup${$e68dce13187de0df$var$EVENT_KEY$6}${$e68dce13187de0df$var$DATA_API_KEY$3}`;
const $e68dce13187de0df$var$CLASS_NAME_SHOW$6 = "show";
const $e68dce13187de0df$var$CLASS_NAME_DROPUP = "dropup";
const $e68dce13187de0df$var$CLASS_NAME_DROPEND = "dropend";
const $e68dce13187de0df$var$CLASS_NAME_DROPSTART = "dropstart";
const $e68dce13187de0df$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $e68dce13187de0df$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$3}.${$e68dce13187de0df$var$CLASS_NAME_SHOW$6}`;
const $e68dce13187de0df$var$SELECTOR_MENU = ".dropdown-menu";
const $e68dce13187de0df$var$SELECTOR_NAVBAR = ".navbar";
const $e68dce13187de0df$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $e68dce13187de0df$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $e68dce13187de0df$var$PLACEMENT_TOP = $e68dce13187de0df$var$isRTL() ? "top-end" : "top-start";
const $e68dce13187de0df$var$PLACEMENT_TOPEND = $e68dce13187de0df$var$isRTL() ? "top-start" : "top-end";
const $e68dce13187de0df$var$PLACEMENT_BOTTOM = $e68dce13187de0df$var$isRTL() ? "bottom-end" : "bottom-start";
const $e68dce13187de0df$var$PLACEMENT_BOTTOMEND = $e68dce13187de0df$var$isRTL() ? "bottom-start" : "bottom-end";
const $e68dce13187de0df$var$PLACEMENT_RIGHT = $e68dce13187de0df$var$isRTL() ? "left-start" : "right-start";
const $e68dce13187de0df$var$PLACEMENT_LEFT = $e68dce13187de0df$var$isRTL() ? "right-start" : "left-start";
const $e68dce13187de0df$var$PLACEMENT_TOPCENTER = "top";
const $e68dce13187de0df$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $e68dce13187de0df$var$Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $e68dce13187de0df$var$DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class $e68dce13187de0df$export$931cbfb6bfb85fc extends $e68dce13187de0df$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $e68dce13187de0df$var$SelectorEngine.next(this._element, $e68dce13187de0df$var$SELECTOR_MENU)[0] || $e68dce13187de0df$var$SelectorEngine.prev(this._element, $e68dce13187de0df$var$SELECTOR_MENU)[0] || $e68dce13187de0df$var$SelectorEngine.findOne($e68dce13187de0df$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $e68dce13187de0df$var$Default$9;
    }
    static get DefaultType() {
        return $e68dce13187de0df$var$DefaultType$9;
    }
    static get NAME() {
        return $e68dce13187de0df$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($e68dce13187de0df$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest($e68dce13187de0df$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$e68dce13187de0df$var$EventHandler.on(element, "mouseover", $e68dce13187de0df$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($e68dce13187de0df$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_SHOW$6);
        $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($e68dce13187de0df$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e68dce13187de0df$var$EventHandler.off(element, "mouseover", $e68dce13187de0df$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($e68dce13187de0df$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($e68dce13187de0df$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        $e68dce13187de0df$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_HIDDEN$5, relatedTarget);
        // Explicitly return focus to the trigger element
        this._element.focus();
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$e68dce13187de0df$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$e68dce13187de0df$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $d2054e51bcbb5869$exports === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org/docs/v2/)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($e68dce13187de0df$var$isElement(this._config.reference)) referenceElement = $e68dce13187de0df$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $d2054e51bcbb5869$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($e68dce13187de0df$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($e68dce13187de0df$var$CLASS_NAME_DROPEND)) return $e68dce13187de0df$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($e68dce13187de0df$var$CLASS_NAME_DROPSTART)) return $e68dce13187de0df$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($e68dce13187de0df$var$CLASS_NAME_DROPUP_CENTER)) return $e68dce13187de0df$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($e68dce13187de0df$var$CLASS_NAME_DROPDOWN_CENTER)) return $e68dce13187de0df$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains($e68dce13187de0df$var$CLASS_NAME_DROPUP)) return isEnd ? $e68dce13187de0df$var$PLACEMENT_TOPEND : $e68dce13187de0df$var$PLACEMENT_TOP;
        return isEnd ? $e68dce13187de0df$var$PLACEMENT_BOTTOMEND : $e68dce13187de0df$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($e68dce13187de0df$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            $e68dce13187de0df$var$Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$e68dce13187de0df$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $e68dce13187de0df$var$SelectorEngine.find($e68dce13187de0df$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$e68dce13187de0df$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $e68dce13187de0df$var$getNextActiveElement(items, target, key === $e68dce13187de0df$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e68dce13187de0df$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $e68dce13187de0df$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $e68dce13187de0df$var$TAB_KEY$1) return;
        const openToggles = $e68dce13187de0df$var$SelectorEngine.find($e68dce13187de0df$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $e68dce13187de0df$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $e68dce13187de0df$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $e68dce13187de0df$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $e68dce13187de0df$var$ARROW_UP_KEY$1,
            $e68dce13187de0df$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$3) ? this : $e68dce13187de0df$var$SelectorEngine.prev(this, $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$3)[0] || $e68dce13187de0df$var$SelectorEngine.next(this, $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$3)[0] || $e68dce13187de0df$var$SelectorEngine.findOne($e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $e68dce13187de0df$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $e68dce13187de0df$var$EventHandler.on(document, $e68dce13187de0df$var$EVENT_KEYDOWN_DATA_API, $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$3, $e68dce13187de0df$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e68dce13187de0df$var$EventHandler.on(document, $e68dce13187de0df$var$EVENT_KEYDOWN_DATA_API, $e68dce13187de0df$var$SELECTOR_MENU, $e68dce13187de0df$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e68dce13187de0df$var$EventHandler.on(document, $e68dce13187de0df$var$EVENT_CLICK_DATA_API$3, $e68dce13187de0df$export$931cbfb6bfb85fc.clearMenus);
$e68dce13187de0df$var$EventHandler.on(document, $e68dce13187de0df$var$EVENT_KEYUP_DATA_API, $e68dce13187de0df$export$931cbfb6bfb85fc.clearMenus);
$e68dce13187de0df$var$EventHandler.on(document, $e68dce13187de0df$var$EVENT_CLICK_DATA_API$3, $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $e68dce13187de0df$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $e68dce13187de0df$var$defineJQueryPlugin($e68dce13187de0df$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$9 = "backdrop";
const $e68dce13187de0df$var$CLASS_NAME_FADE$4 = "fade";
const $e68dce13187de0df$var$CLASS_NAME_SHOW$5 = "show";
const $e68dce13187de0df$var$EVENT_MOUSEDOWN = `mousedown.bs.${$e68dce13187de0df$var$NAME$9}`;
const $e68dce13187de0df$var$Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const $e68dce13187de0df$var$DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class $e68dce13187de0df$var$Backdrop extends $e68dce13187de0df$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $e68dce13187de0df$var$Default$8;
    }
    static get DefaultType() {
        return $e68dce13187de0df$var$DefaultType$8;
    }
    static get NAME() {
        return $e68dce13187de0df$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $e68dce13187de0df$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $e68dce13187de0df$var$reflow(element);
        element.classList.add($e68dce13187de0df$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $e68dce13187de0df$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $e68dce13187de0df$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($e68dce13187de0df$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $e68dce13187de0df$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $e68dce13187de0df$var$EventHandler.off(this._element, $e68dce13187de0df$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($e68dce13187de0df$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $e68dce13187de0df$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $e68dce13187de0df$var$EventHandler.on(element, $e68dce13187de0df$var$EVENT_MOUSEDOWN, ()=>{
            $e68dce13187de0df$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $e68dce13187de0df$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$8 = "focustrap";
const $e68dce13187de0df$var$DATA_KEY$5 = "bs.focustrap";
const $e68dce13187de0df$var$EVENT_KEY$5 = `.${$e68dce13187de0df$var$DATA_KEY$5}`;
const $e68dce13187de0df$var$EVENT_FOCUSIN$2 = `focusin${$e68dce13187de0df$var$EVENT_KEY$5}`;
const $e68dce13187de0df$var$EVENT_KEYDOWN_TAB = `keydown.tab${$e68dce13187de0df$var$EVENT_KEY$5}`;
const $e68dce13187de0df$var$TAB_KEY = "Tab";
const $e68dce13187de0df$var$TAB_NAV_FORWARD = "forward";
const $e68dce13187de0df$var$TAB_NAV_BACKWARD = "backward";
const $e68dce13187de0df$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $e68dce13187de0df$var$DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class $e68dce13187de0df$var$FocusTrap extends $e68dce13187de0df$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $e68dce13187de0df$var$Default$7;
    }
    static get DefaultType() {
        return $e68dce13187de0df$var$DefaultType$7;
    }
    static get NAME() {
        return $e68dce13187de0df$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $e68dce13187de0df$var$EventHandler.off(document, $e68dce13187de0df$var$EVENT_KEY$5); // guard against infinite focus loop
        $e68dce13187de0df$var$EventHandler.on(document, $e68dce13187de0df$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $e68dce13187de0df$var$EventHandler.on(document, $e68dce13187de0df$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $e68dce13187de0df$var$EventHandler.off(document, $e68dce13187de0df$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $e68dce13187de0df$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $e68dce13187de0df$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $e68dce13187de0df$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $e68dce13187de0df$var$TAB_NAV_BACKWARD : $e68dce13187de0df$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $e68dce13187de0df$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $e68dce13187de0df$var$PROPERTY_PADDING = "padding-right";
const $e68dce13187de0df$var$PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class $e68dce13187de0df$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $e68dce13187de0df$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($e68dce13187de0df$var$SELECTOR_FIXED_CONTENT, $e68dce13187de0df$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($e68dce13187de0df$var$SELECTOR_STICKY_CONTENT, $e68dce13187de0df$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $e68dce13187de0df$var$PROPERTY_PADDING);
        this._resetElementAttributes($e68dce13187de0df$var$SELECTOR_FIXED_CONTENT, $e68dce13187de0df$var$PROPERTY_PADDING);
        this._resetElementAttributes($e68dce13187de0df$var$SELECTOR_STICKY_CONTENT, $e68dce13187de0df$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $e68dce13187de0df$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $e68dce13187de0df$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $e68dce13187de0df$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($e68dce13187de0df$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $e68dce13187de0df$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$7 = "modal";
const $e68dce13187de0df$var$DATA_KEY$4 = "bs.modal";
const $e68dce13187de0df$var$EVENT_KEY$4 = `.${$e68dce13187de0df$var$DATA_KEY$4}`;
const $e68dce13187de0df$var$DATA_API_KEY$2 = ".data-api";
const $e68dce13187de0df$var$ESCAPE_KEY$1 = "Escape";
const $e68dce13187de0df$var$EVENT_HIDE$4 = `hide${$e68dce13187de0df$var$EVENT_KEY$4}`;
const $e68dce13187de0df$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$e68dce13187de0df$var$EVENT_KEY$4}`;
const $e68dce13187de0df$var$EVENT_HIDDEN$4 = `hidden${$e68dce13187de0df$var$EVENT_KEY$4}`;
const $e68dce13187de0df$var$EVENT_SHOW$4 = `show${$e68dce13187de0df$var$EVENT_KEY$4}`;
const $e68dce13187de0df$var$EVENT_SHOWN$4 = `shown${$e68dce13187de0df$var$EVENT_KEY$4}`;
const $e68dce13187de0df$var$EVENT_RESIZE$1 = `resize${$e68dce13187de0df$var$EVENT_KEY$4}`;
const $e68dce13187de0df$var$EVENT_CLICK_DISMISS = `click.dismiss${$e68dce13187de0df$var$EVENT_KEY$4}`;
const $e68dce13187de0df$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$e68dce13187de0df$var$EVENT_KEY$4}`;
const $e68dce13187de0df$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$e68dce13187de0df$var$EVENT_KEY$4}`;
const $e68dce13187de0df$var$EVENT_CLICK_DATA_API$2 = `click${$e68dce13187de0df$var$EVENT_KEY$4}${$e68dce13187de0df$var$DATA_API_KEY$2}`;
const $e68dce13187de0df$var$CLASS_NAME_OPEN = "modal-open";
const $e68dce13187de0df$var$CLASS_NAME_FADE$3 = "fade";
const $e68dce13187de0df$var$CLASS_NAME_SHOW$4 = "show";
const $e68dce13187de0df$var$CLASS_NAME_STATIC = "modal-static";
const $e68dce13187de0df$var$OPEN_SELECTOR$1 = ".modal.show";
const $e68dce13187de0df$var$SELECTOR_DIALOG = ".modal-dialog";
const $e68dce13187de0df$var$SELECTOR_MODAL_BODY = ".modal-body";
const $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $e68dce13187de0df$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $e68dce13187de0df$var$DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class $e68dce13187de0df$export$2b77a92f1a5ad772 extends $e68dce13187de0df$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $e68dce13187de0df$var$SelectorEngine.findOne($e68dce13187de0df$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $e68dce13187de0df$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e68dce13187de0df$var$Default$6;
    }
    static get DefaultType() {
        return $e68dce13187de0df$var$DefaultType$6;
    }
    static get NAME() {
        return $e68dce13187de0df$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($e68dce13187de0df$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($e68dce13187de0df$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $e68dce13187de0df$var$EventHandler.off(window, $e68dce13187de0df$var$EVENT_KEY$4);
        $e68dce13187de0df$var$EventHandler.off(this._dialog, $e68dce13187de0df$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $e68dce13187de0df$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $e68dce13187de0df$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $e68dce13187de0df$var$SelectorEngine.findOne($e68dce13187de0df$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $e68dce13187de0df$var$reflow(this._element);
        this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $e68dce13187de0df$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $e68dce13187de0df$var$EventHandler.on(window, $e68dce13187de0df$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $e68dce13187de0df$var$EventHandler.one(this._element, $e68dce13187de0df$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($e68dce13187de0df$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($e68dce13187de0df$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains($e68dce13187de0df$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($e68dce13187de0df$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $e68dce13187de0df$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $e68dce13187de0df$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $e68dce13187de0df$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $e68dce13187de0df$var$EventHandler.on(document, $e68dce13187de0df$var$EVENT_CLICK_DATA_API$2, $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $e68dce13187de0df$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    $e68dce13187de0df$var$EventHandler.one(target, $e68dce13187de0df$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $e68dce13187de0df$var$EventHandler.one(target, $e68dce13187de0df$var$EVENT_HIDDEN$4, ()=>{
            if ($e68dce13187de0df$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $e68dce13187de0df$var$SelectorEngine.findOne($e68dce13187de0df$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $e68dce13187de0df$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $e68dce13187de0df$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$e68dce13187de0df$var$enableDismissTrigger($e68dce13187de0df$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $e68dce13187de0df$var$defineJQueryPlugin($e68dce13187de0df$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$6 = "offcanvas";
const $e68dce13187de0df$var$DATA_KEY$3 = "bs.offcanvas";
const $e68dce13187de0df$var$EVENT_KEY$3 = `.${$e68dce13187de0df$var$DATA_KEY$3}`;
const $e68dce13187de0df$var$DATA_API_KEY$1 = ".data-api";
const $e68dce13187de0df$var$EVENT_LOAD_DATA_API$2 = `load${$e68dce13187de0df$var$EVENT_KEY$3}${$e68dce13187de0df$var$DATA_API_KEY$1}`;
const $e68dce13187de0df$var$ESCAPE_KEY = "Escape";
const $e68dce13187de0df$var$CLASS_NAME_SHOW$3 = "show";
const $e68dce13187de0df$var$CLASS_NAME_SHOWING$1 = "showing";
const $e68dce13187de0df$var$CLASS_NAME_HIDING = "hiding";
const $e68dce13187de0df$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $e68dce13187de0df$var$OPEN_SELECTOR = ".offcanvas.show";
const $e68dce13187de0df$var$EVENT_SHOW$3 = `show${$e68dce13187de0df$var$EVENT_KEY$3}`;
const $e68dce13187de0df$var$EVENT_SHOWN$3 = `shown${$e68dce13187de0df$var$EVENT_KEY$3}`;
const $e68dce13187de0df$var$EVENT_HIDE$3 = `hide${$e68dce13187de0df$var$EVENT_KEY$3}`;
const $e68dce13187de0df$var$EVENT_HIDE_PREVENTED = `hidePrevented${$e68dce13187de0df$var$EVENT_KEY$3}`;
const $e68dce13187de0df$var$EVENT_HIDDEN$3 = `hidden${$e68dce13187de0df$var$EVENT_KEY$3}`;
const $e68dce13187de0df$var$EVENT_RESIZE = `resize${$e68dce13187de0df$var$EVENT_KEY$3}`;
const $e68dce13187de0df$var$EVENT_CLICK_DATA_API$1 = `click${$e68dce13187de0df$var$EVENT_KEY$3}${$e68dce13187de0df$var$DATA_API_KEY$1}`;
const $e68dce13187de0df$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$e68dce13187de0df$var$EVENT_KEY$3}`;
const $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $e68dce13187de0df$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $e68dce13187de0df$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class $e68dce13187de0df$export$591ca0244c9dfcd4 extends $e68dce13187de0df$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e68dce13187de0df$var$Default$5;
    }
    static get DefaultType() {
        return $e68dce13187de0df$var$DefaultType$5;
    }
    static get NAME() {
        return $e68dce13187de0df$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $e68dce13187de0df$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($e68dce13187de0df$var$CLASS_NAME_SHOWING$1);
            $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($e68dce13187de0df$var$CLASS_NAME_SHOW$3, $e68dce13187de0df$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $e68dce13187de0df$var$ScrollBarHelper().reset();
            $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $e68dce13187de0df$var$Backdrop({
            className: $e68dce13187de0df$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $e68dce13187de0df$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $e68dce13187de0df$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e68dce13187de0df$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e68dce13187de0df$var$EventHandler.on(document, $e68dce13187de0df$var$EVENT_CLICK_DATA_API$1, $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $e68dce13187de0df$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($e68dce13187de0df$var$isDisabled(this)) return;
    $e68dce13187de0df$var$EventHandler.one(target, $e68dce13187de0df$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($e68dce13187de0df$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $e68dce13187de0df$var$SelectorEngine.findOne($e68dce13187de0df$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $e68dce13187de0df$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $e68dce13187de0df$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$e68dce13187de0df$var$EventHandler.on(window, $e68dce13187de0df$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $e68dce13187de0df$var$SelectorEngine.find($e68dce13187de0df$var$OPEN_SELECTOR))$e68dce13187de0df$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$e68dce13187de0df$var$EventHandler.on(window, $e68dce13187de0df$var$EVENT_RESIZE, ()=>{
    for (const element of $e68dce13187de0df$var$SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") $e68dce13187de0df$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$e68dce13187de0df$var$enableDismissTrigger($e68dce13187de0df$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $e68dce13187de0df$var$defineJQueryPlugin($e68dce13187de0df$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $e68dce13187de0df$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $e68dce13187de0df$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $e68dce13187de0df$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $e68dce13187de0df$var$uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $e68dce13187de0df$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $e68dce13187de0df$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($e68dce13187de0df$var$uriAttributes.has(attributeName)) return Boolean($e68dce13187de0df$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $e68dce13187de0df$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$e68dce13187de0df$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$5 = "TemplateFactory";
const $e68dce13187de0df$var$Default$4 = {
    allowList: $e68dce13187de0df$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $e68dce13187de0df$var$DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $e68dce13187de0df$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class $e68dce13187de0df$var$TemplateFactory extends $e68dce13187de0df$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $e68dce13187de0df$var$Default$4;
    }
    static get DefaultType() {
        return $e68dce13187de0df$var$DefaultType$4;
    }
    static get NAME() {
        return $e68dce13187de0df$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $e68dce13187de0df$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $e68dce13187de0df$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($e68dce13187de0df$var$isElement(content)) {
            this._putElementInTemplate($e68dce13187de0df$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $e68dce13187de0df$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $e68dce13187de0df$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$4 = "tooltip";
const $e68dce13187de0df$var$DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $e68dce13187de0df$var$CLASS_NAME_FADE$2 = "fade";
const $e68dce13187de0df$var$CLASS_NAME_MODAL = "modal";
const $e68dce13187de0df$var$CLASS_NAME_SHOW$2 = "show";
const $e68dce13187de0df$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $e68dce13187de0df$var$SELECTOR_MODAL = `.${$e68dce13187de0df$var$CLASS_NAME_MODAL}`;
const $e68dce13187de0df$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $e68dce13187de0df$var$TRIGGER_HOVER = "hover";
const $e68dce13187de0df$var$TRIGGER_FOCUS = "focus";
const $e68dce13187de0df$var$TRIGGER_CLICK = "click";
const $e68dce13187de0df$var$TRIGGER_MANUAL = "manual";
const $e68dce13187de0df$var$EVENT_HIDE$2 = "hide";
const $e68dce13187de0df$var$EVENT_HIDDEN$2 = "hidden";
const $e68dce13187de0df$var$EVENT_SHOW$2 = "show";
const $e68dce13187de0df$var$EVENT_SHOWN$2 = "shown";
const $e68dce13187de0df$var$EVENT_INSERTED = "inserted";
const $e68dce13187de0df$var$EVENT_CLICK$1 = "click";
const $e68dce13187de0df$var$EVENT_FOCUSIN$1 = "focusin";
const $e68dce13187de0df$var$EVENT_FOCUSOUT$1 = "focusout";
const $e68dce13187de0df$var$EVENT_MOUSEENTER = "mouseenter";
const $e68dce13187de0df$var$EVENT_MOUSELEAVE = "mouseleave";
const $e68dce13187de0df$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $e68dce13187de0df$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $e68dce13187de0df$var$isRTL() ? "right" : "left"
};
const $e68dce13187de0df$var$Default$3 = {
    allowList: $e68dce13187de0df$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $e68dce13187de0df$var$DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class $e68dce13187de0df$export$28c660c63b792dea extends $e68dce13187de0df$var$BaseComponent {
    constructor(element, config){
        if (typeof $d2054e51bcbb5869$exports === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org/docs/v2/)");
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $e68dce13187de0df$var$Default$3;
    }
    static get DefaultType() {
        return $e68dce13187de0df$var$DefaultType$3;
    }
    static get NAME() {
        return $e68dce13187de0df$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $e68dce13187de0df$var$EventHandler.off(this._element.closest($e68dce13187de0df$var$SELECTOR_MODAL), $e68dce13187de0df$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $e68dce13187de0df$var$EventHandler.trigger(this._element, this.constructor.eventName($e68dce13187de0df$var$EVENT_SHOW$2));
        const shadowRoot = $e68dce13187de0df$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $e68dce13187de0df$var$EventHandler.trigger(this._element, this.constructor.eventName($e68dce13187de0df$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($e68dce13187de0df$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e68dce13187de0df$var$EventHandler.on(element, "mouseover", $e68dce13187de0df$var$noop);
        const complete = ()=>{
            $e68dce13187de0df$var$EventHandler.trigger(this._element, this.constructor.eventName($e68dce13187de0df$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $e68dce13187de0df$var$EventHandler.trigger(this._element, this.constructor.eventName($e68dce13187de0df$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($e68dce13187de0df$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e68dce13187de0df$var$EventHandler.off(element, "mouseover", $e68dce13187de0df$var$noop);
        this._activeTrigger[$e68dce13187de0df$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$e68dce13187de0df$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$e68dce13187de0df$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $e68dce13187de0df$var$EventHandler.trigger(this._element, this.constructor.eventName($e68dce13187de0df$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($e68dce13187de0df$var$CLASS_NAME_FADE$2, $e68dce13187de0df$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $e68dce13187de0df$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($e68dce13187de0df$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $e68dce13187de0df$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$e68dce13187de0df$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($e68dce13187de0df$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($e68dce13187de0df$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $e68dce13187de0df$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $e68dce13187de0df$var$AttachmentMap[placement.toUpperCase()];
        return $d2054e51bcbb5869$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $e68dce13187de0df$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$e68dce13187de0df$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $e68dce13187de0df$var$EventHandler.on(this._element, this.constructor.eventName($e68dce13187de0df$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$e68dce13187de0df$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$e68dce13187de0df$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $e68dce13187de0df$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $e68dce13187de0df$var$TRIGGER_HOVER ? this.constructor.eventName($e68dce13187de0df$var$EVENT_MOUSEENTER) : this.constructor.eventName($e68dce13187de0df$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $e68dce13187de0df$var$TRIGGER_HOVER ? this.constructor.eventName($e68dce13187de0df$var$EVENT_MOUSELEAVE) : this.constructor.eventName($e68dce13187de0df$var$EVENT_FOCUSOUT$1);
                $e68dce13187de0df$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $e68dce13187de0df$var$TRIGGER_FOCUS : $e68dce13187de0df$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $e68dce13187de0df$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $e68dce13187de0df$var$TRIGGER_FOCUS : $e68dce13187de0df$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $e68dce13187de0df$var$EventHandler.on(this._element.closest($e68dce13187de0df$var$SELECTOR_MODAL), $e68dce13187de0df$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $e68dce13187de0df$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($e68dce13187de0df$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $e68dce13187de0df$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e68dce13187de0df$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e68dce13187de0df$var$defineJQueryPlugin($e68dce13187de0df$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$3 = "popover";
const $e68dce13187de0df$var$SELECTOR_TITLE = ".popover-header";
const $e68dce13187de0df$var$SELECTOR_CONTENT = ".popover-body";
const $e68dce13187de0df$var$Default$2 = {
    ...$e68dce13187de0df$export$28c660c63b792dea.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $e68dce13187de0df$var$DefaultType$2 = {
    ...$e68dce13187de0df$export$28c660c63b792dea.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class $e68dce13187de0df$export$5b6b19405a83ff9d extends $e68dce13187de0df$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $e68dce13187de0df$var$Default$2;
    }
    static get DefaultType() {
        return $e68dce13187de0df$var$DefaultType$2;
    }
    static get NAME() {
        return $e68dce13187de0df$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$e68dce13187de0df$var$SELECTOR_TITLE]: this._getTitle(),
            [$e68dce13187de0df$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e68dce13187de0df$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e68dce13187de0df$var$defineJQueryPlugin($e68dce13187de0df$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$2 = "scrollspy";
const $e68dce13187de0df$var$DATA_KEY$2 = "bs.scrollspy";
const $e68dce13187de0df$var$EVENT_KEY$2 = `.${$e68dce13187de0df$var$DATA_KEY$2}`;
const $e68dce13187de0df$var$DATA_API_KEY = ".data-api";
const $e68dce13187de0df$var$EVENT_ACTIVATE = `activate${$e68dce13187de0df$var$EVENT_KEY$2}`;
const $e68dce13187de0df$var$EVENT_CLICK = `click${$e68dce13187de0df$var$EVENT_KEY$2}`;
const $e68dce13187de0df$var$EVENT_LOAD_DATA_API$1 = `load${$e68dce13187de0df$var$EVENT_KEY$2}${$e68dce13187de0df$var$DATA_API_KEY}`;
const $e68dce13187de0df$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $e68dce13187de0df$var$CLASS_NAME_ACTIVE$1 = "active";
const $e68dce13187de0df$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $e68dce13187de0df$var$SELECTOR_TARGET_LINKS = "[href]";
const $e68dce13187de0df$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $e68dce13187de0df$var$SELECTOR_NAV_LINKS = ".nav-link";
const $e68dce13187de0df$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $e68dce13187de0df$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $e68dce13187de0df$var$SELECTOR_LINK_ITEMS = `${$e68dce13187de0df$var$SELECTOR_NAV_LINKS}, ${$e68dce13187de0df$var$SELECTOR_NAV_ITEMS} > ${$e68dce13187de0df$var$SELECTOR_NAV_LINKS}, ${$e68dce13187de0df$var$SELECTOR_LIST_ITEMS}`;
const $e68dce13187de0df$var$SELECTOR_DROPDOWN = ".dropdown";
const $e68dce13187de0df$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $e68dce13187de0df$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $e68dce13187de0df$var$DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class $e68dce13187de0df$export$a6472a5298a374be extends $e68dce13187de0df$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $e68dce13187de0df$var$Default$1;
    }
    static get DefaultType() {
        return $e68dce13187de0df$var$DefaultType$1;
    }
    static get NAME() {
        return $e68dce13187de0df$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $e68dce13187de0df$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $e68dce13187de0df$var$EventHandler.off(this._config.target, $e68dce13187de0df$var$EVENT_CLICK);
        $e68dce13187de0df$var$EventHandler.on(this._config.target, $e68dce13187de0df$var$EVENT_CLICK, $e68dce13187de0df$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $e68dce13187de0df$var$SelectorEngine.find($e68dce13187de0df$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $e68dce13187de0df$var$isDisabled(anchor)) continue;
            const observableSection = $e68dce13187de0df$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($e68dce13187de0df$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($e68dce13187de0df$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($e68dce13187de0df$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $e68dce13187de0df$var$SelectorEngine.findOne($e68dce13187de0df$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($e68dce13187de0df$var$SELECTOR_DROPDOWN)).classList.add($e68dce13187de0df$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $e68dce13187de0df$var$SelectorEngine.parents(target, $e68dce13187de0df$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $e68dce13187de0df$var$SelectorEngine.prev(listGroup, $e68dce13187de0df$var$SELECTOR_LINK_ITEMS))item.classList.add($e68dce13187de0df$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($e68dce13187de0df$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $e68dce13187de0df$var$SelectorEngine.find(`${$e68dce13187de0df$var$SELECTOR_TARGET_LINKS}.${$e68dce13187de0df$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($e68dce13187de0df$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e68dce13187de0df$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e68dce13187de0df$var$EventHandler.on(window, $e68dce13187de0df$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $e68dce13187de0df$var$SelectorEngine.find($e68dce13187de0df$var$SELECTOR_DATA_SPY))$e68dce13187de0df$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $e68dce13187de0df$var$defineJQueryPlugin($e68dce13187de0df$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME$1 = "tab";
const $e68dce13187de0df$var$DATA_KEY$1 = "bs.tab";
const $e68dce13187de0df$var$EVENT_KEY$1 = `.${$e68dce13187de0df$var$DATA_KEY$1}`;
const $e68dce13187de0df$var$EVENT_HIDE$1 = `hide${$e68dce13187de0df$var$EVENT_KEY$1}`;
const $e68dce13187de0df$var$EVENT_HIDDEN$1 = `hidden${$e68dce13187de0df$var$EVENT_KEY$1}`;
const $e68dce13187de0df$var$EVENT_SHOW$1 = `show${$e68dce13187de0df$var$EVENT_KEY$1}`;
const $e68dce13187de0df$var$EVENT_SHOWN$1 = `shown${$e68dce13187de0df$var$EVENT_KEY$1}`;
const $e68dce13187de0df$var$EVENT_CLICK_DATA_API = `click${$e68dce13187de0df$var$EVENT_KEY$1}`;
const $e68dce13187de0df$var$EVENT_KEYDOWN = `keydown${$e68dce13187de0df$var$EVENT_KEY$1}`;
const $e68dce13187de0df$var$EVENT_LOAD_DATA_API = `load${$e68dce13187de0df$var$EVENT_KEY$1}`;
const $e68dce13187de0df$var$ARROW_LEFT_KEY = "ArrowLeft";
const $e68dce13187de0df$var$ARROW_RIGHT_KEY = "ArrowRight";
const $e68dce13187de0df$var$ARROW_UP_KEY = "ArrowUp";
const $e68dce13187de0df$var$ARROW_DOWN_KEY = "ArrowDown";
const $e68dce13187de0df$var$HOME_KEY = "Home";
const $e68dce13187de0df$var$END_KEY = "End";
const $e68dce13187de0df$var$CLASS_NAME_ACTIVE = "active";
const $e68dce13187de0df$var$CLASS_NAME_FADE$1 = "fade";
const $e68dce13187de0df$var$CLASS_NAME_SHOW$1 = "show";
const $e68dce13187de0df$var$CLASS_DROPDOWN = "dropdown";
const $e68dce13187de0df$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $e68dce13187de0df$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $e68dce13187de0df$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$e68dce13187de0df$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $e68dce13187de0df$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $e68dce13187de0df$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $e68dce13187de0df$var$SELECTOR_INNER = `.nav-link${$e68dce13187de0df$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$e68dce13187de0df$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$e68dce13187de0df$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $e68dce13187de0df$var$SELECTOR_INNER_ELEM = `${$e68dce13187de0df$var$SELECTOR_INNER}, ${$e68dce13187de0df$var$SELECTOR_DATA_TOGGLE}`;
const $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$e68dce13187de0df$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$e68dce13187de0df$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$e68dce13187de0df$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $e68dce13187de0df$export$3e41faf802a29e71 extends $e68dce13187de0df$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($e68dce13187de0df$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $e68dce13187de0df$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $e68dce13187de0df$var$EventHandler.trigger(active, $e68dce13187de0df$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $e68dce13187de0df$var$EventHandler.trigger(innerElem, $e68dce13187de0df$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($e68dce13187de0df$var$CLASS_NAME_ACTIVE);
        this._activate($e68dce13187de0df$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add($e68dce13187de0df$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            $e68dce13187de0df$var$EventHandler.trigger(element, $e68dce13187de0df$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e68dce13187de0df$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($e68dce13187de0df$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($e68dce13187de0df$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove($e68dce13187de0df$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            $e68dce13187de0df$var$EventHandler.trigger(element, $e68dce13187de0df$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e68dce13187de0df$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $e68dce13187de0df$var$ARROW_LEFT_KEY,
            $e68dce13187de0df$var$ARROW_RIGHT_KEY,
            $e68dce13187de0df$var$ARROW_UP_KEY,
            $e68dce13187de0df$var$ARROW_DOWN_KEY,
            $e68dce13187de0df$var$HOME_KEY,
            $e68dce13187de0df$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$e68dce13187de0df$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $e68dce13187de0df$var$HOME_KEY,
            $e68dce13187de0df$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $e68dce13187de0df$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $e68dce13187de0df$var$ARROW_RIGHT_KEY,
                $e68dce13187de0df$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $e68dce13187de0df$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $e68dce13187de0df$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $e68dce13187de0df$var$SelectorEngine.find($e68dce13187de0df$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $e68dce13187de0df$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($e68dce13187de0df$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $e68dce13187de0df$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($e68dce13187de0df$var$SELECTOR_DROPDOWN_TOGGLE, $e68dce13187de0df$var$CLASS_NAME_ACTIVE);
        toggle($e68dce13187de0df$var$SELECTOR_DROPDOWN_MENU, $e68dce13187de0df$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($e68dce13187de0df$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($e68dce13187de0df$var$SELECTOR_INNER_ELEM) ? elem : $e68dce13187de0df$var$SelectorEngine.findOne($e68dce13187de0df$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($e68dce13187de0df$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e68dce13187de0df$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e68dce13187de0df$var$EventHandler.on(document, $e68dce13187de0df$var$EVENT_CLICK_DATA_API, $e68dce13187de0df$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($e68dce13187de0df$var$isDisabled(this)) return;
    $e68dce13187de0df$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $e68dce13187de0df$var$EventHandler.on(window, $e68dce13187de0df$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $e68dce13187de0df$var$SelectorEngine.find($e68dce13187de0df$var$SELECTOR_DATA_TOGGLE_ACTIVE))$e68dce13187de0df$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $e68dce13187de0df$var$defineJQueryPlugin($e68dce13187de0df$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e68dce13187de0df$var$NAME = "toast";
const $e68dce13187de0df$var$DATA_KEY = "bs.toast";
const $e68dce13187de0df$var$EVENT_KEY = `.${$e68dce13187de0df$var$DATA_KEY}`;
const $e68dce13187de0df$var$EVENT_MOUSEOVER = `mouseover${$e68dce13187de0df$var$EVENT_KEY}`;
const $e68dce13187de0df$var$EVENT_MOUSEOUT = `mouseout${$e68dce13187de0df$var$EVENT_KEY}`;
const $e68dce13187de0df$var$EVENT_FOCUSIN = `focusin${$e68dce13187de0df$var$EVENT_KEY}`;
const $e68dce13187de0df$var$EVENT_FOCUSOUT = `focusout${$e68dce13187de0df$var$EVENT_KEY}`;
const $e68dce13187de0df$var$EVENT_HIDE = `hide${$e68dce13187de0df$var$EVENT_KEY}`;
const $e68dce13187de0df$var$EVENT_HIDDEN = `hidden${$e68dce13187de0df$var$EVENT_KEY}`;
const $e68dce13187de0df$var$EVENT_SHOW = `show${$e68dce13187de0df$var$EVENT_KEY}`;
const $e68dce13187de0df$var$EVENT_SHOWN = `shown${$e68dce13187de0df$var$EVENT_KEY}`;
const $e68dce13187de0df$var$CLASS_NAME_FADE = "fade";
const $e68dce13187de0df$var$CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const $e68dce13187de0df$var$CLASS_NAME_SHOW = "show";
const $e68dce13187de0df$var$CLASS_NAME_SHOWING = "showing";
const $e68dce13187de0df$var$DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $e68dce13187de0df$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $e68dce13187de0df$export$8d8dc7d5f743331b extends $e68dce13187de0df$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $e68dce13187de0df$var$Default;
    }
    static get DefaultType() {
        return $e68dce13187de0df$var$DefaultType;
    }
    static get NAME() {
        return $e68dce13187de0df$var$NAME;
    }
    // Public
    show() {
        const showEvent = $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($e68dce13187de0df$var$CLASS_NAME_SHOWING);
            $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($e68dce13187de0df$var$CLASS_NAME_HIDE); // @deprecated
        $e68dce13187de0df$var$reflow(this._element);
        this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_SHOW, $e68dce13187de0df$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($e68dce13187de0df$var$CLASS_NAME_SHOWING, $e68dce13187de0df$var$CLASS_NAME_SHOW);
            $e68dce13187de0df$var$EventHandler.trigger(this._element, $e68dce13187de0df$var$EVENT_HIDDEN);
        };
        this._element.classList.add($e68dce13187de0df$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($e68dce13187de0df$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($e68dce13187de0df$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $e68dce13187de0df$var$EventHandler.on(this._element, $e68dce13187de0df$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e68dce13187de0df$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $e68dce13187de0df$var$enableDismissTrigger($e68dce13187de0df$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $e68dce13187de0df$var$defineJQueryPlugin($e68dce13187de0df$export$8d8dc7d5f743331b);


window.$ = window.jQuery = $ef6Fp;
window.bootstrap = $e68dce13187de0df$exports;
var $a87acd9af021f8e7$export$2e2bcd8739ae039 = {
    $: $,
    bootstrap: $e68dce13187de0df$exports
};


/*
 *  This file contains the events and functions applied to
 *  the course panel
 */ 

/*
 * easy-autocomplete
 * jQuery plugin for autocompletion
 * 
 * @author Łukasz Pawełczak (http://github.com/pawelczak)
 * @version 1.3.5
 * Copyright  License: 
 */ /*
 * EasyAutocomplete - Configuration 
 */ var $e6fe0b74a9f00150$var$EasyAutocomplete = function(scope) {
    scope.Configuration = function Configuration(options) {
        var defaults = {
            data: "list-required",
            url: "list-required",
            dataType: "json",
            listLocation: function(data) {
                return data;
            },
            xmlElementName: "",
            getValue: function(element) {
                return element;
            },
            autocompleteOff: true,
            placeholder: false,
            ajaxCallback: function() {},
            matchResponseProperty: false,
            list: {
                sort: {
                    enabled: false,
                    method: function(a, b) {
                        a = defaults.getValue(a);
                        b = defaults.getValue(b);
                        if (a < b) return -1;
                        if (a > b) return 1;
                        return 0;
                    }
                },
                maxNumberOfElements: 6,
                hideOnEmptyPhrase: true,
                match: {
                    enabled: false,
                    caseSensitive: false,
                    method: function(element, phrase) {
                        if (element.search(phrase) > -1) return true;
                        else return false;
                    }
                },
                showAnimation: {
                    type: "normal",
                    time: 400,
                    callback: function() {}
                },
                hideAnimation: {
                    type: "normal",
                    time: 400,
                    callback: function() {}
                },
                /* Events */ onClickEvent: function() {},
                onSelectItemEvent: function() {},
                onLoadEvent: function() {},
                onChooseEvent: function() {},
                onKeyEnterEvent: function() {},
                onMouseOverEvent: function() {},
                onMouseOutEvent: function() {},
                onShowListEvent: function() {},
                onHideListEvent: function() {}
            },
            highlightPhrase: true,
            theme: "",
            cssClasses: "",
            minCharNumber: 0,
            requestDelay: 0,
            adjustWidth: true,
            ajaxSettings: {},
            preparePostData: function(data, inputPhrase) {
                return data;
            },
            loggerEnabled: true,
            template: "",
            categoriesAssigned: false,
            categories: [
                {
                    maxNumberOfElements: 4
                }
            ]
        };
        var externalObjects = [
            "ajaxSettings",
            "template"
        ];
        this.get = function(propertyName) {
            return defaults[propertyName];
        };
        this.equals = function(name, value) {
            if (isAssigned(name)) {
                if (defaults[name] === value) return true;
            }
            return false;
        };
        this.checkDataUrlProperties = function() {
            if (defaults.url === "list-required" && defaults.data === "list-required") return false;
            return true;
        };
        this.checkRequiredProperties = function() {
            for(var propertyName in defaults)if (defaults[propertyName] === "required") {
                logger.error("Option " + propertyName + " must be defined");
                return false;
            }
            return true;
        };
        this.printPropertiesThatDoesntExist = function(consol, optionsToCheck) {
            printPropertiesThatDoesntExist(consol, optionsToCheck);
        };
        prepareDefaults();
        mergeOptions();
        if (defaults.loggerEnabled === true) printPropertiesThatDoesntExist(console, options);
        addAjaxSettings();
        processAfterMerge();
        function prepareDefaults() {
            if (options.dataType === "xml") {
                if (!options.getValue) options.getValue = function(element) {
                    return $(element).text();
                };
                if (!options.list) options.list = {};
                if (!options.list.sort) options.list.sort = {};
                options.list.sort.method = function(a, b) {
                    a = options.getValue(a);
                    b = options.getValue(b);
                    if (a < b) return -1;
                    if (a > b) return 1;
                    return 0;
                };
                if (!options.list.match) options.list.match = {};
                options.list.match.method = function(element, phrase) {
                    if (element.search(phrase) > -1) return true;
                    else return false;
                };
            }
            if (options.categories !== undefined && options.categories instanceof Array) {
                var categories = [];
                for(var i = 0, length = options.categories.length; i < length; i += 1){
                    var category = options.categories[i];
                    for(var property in defaults.categories[0])if (category[property] === undefined) category[property] = defaults.categories[0][property];
                    categories.push(category);
                }
                options.categories = categories;
            }
        }
        function mergeOptions() {
            defaults = mergeObjects(defaults, options);
            function mergeObjects(source, target) {
                var mergedObject = source || {};
                for(var propertyName in source)if (target[propertyName] !== undefined && target[propertyName] !== null) {
                    if (typeof target[propertyName] !== "object" || target[propertyName] instanceof Array) mergedObject[propertyName] = target[propertyName];
                    else mergeObjects(source[propertyName], target[propertyName]);
                }
                /* If data is an object */ if (target.data !== undefined && target.data !== null && typeof target.data === "object") mergedObject.data = target.data;
                return mergedObject;
            }
        }
        function processAfterMerge() {
            if (defaults.url !== "list-required" && typeof defaults.url !== "function") {
                var defaultUrl = defaults.url;
                defaults.url = function() {
                    return defaultUrl;
                };
            }
            if (defaults.ajaxSettings.url !== undefined && typeof defaults.ajaxSettings.url !== "function") {
                var defaultUrl = defaults.ajaxSettings.url;
                defaults.ajaxSettings.url = function() {
                    return defaultUrl;
                };
            }
            if (typeof defaults.listLocation === "string") {
                var defaultlistLocation = defaults.listLocation;
                if (defaults.dataType.toUpperCase() === "XML") defaults.listLocation = function(data) {
                    return $(data).find(defaultlistLocation);
                };
                else defaults.listLocation = function(data) {
                    return data[defaultlistLocation];
                };
            }
            if (typeof defaults.getValue === "string") {
                var defaultsGetValue = defaults.getValue;
                defaults.getValue = function(element) {
                    return element[defaultsGetValue];
                };
            }
            if (options.categories !== undefined) defaults.categoriesAssigned = true;
        }
        function addAjaxSettings() {
            if (options.ajaxSettings !== undefined && typeof options.ajaxSettings === "object") defaults.ajaxSettings = options.ajaxSettings;
            else defaults.ajaxSettings = {};
        }
        function isAssigned(name) {
            if (defaults[name] !== undefined && defaults[name] !== null) return true;
            else return false;
        }
        function printPropertiesThatDoesntExist(consol, optionsToCheck) {
            checkPropertiesIfExist(defaults, optionsToCheck);
            function checkPropertiesIfExist(source, target) {
                for(var property in target){
                    if (source[property] === undefined) consol.log("Property '" + property + "' does not exist in EasyAutocomplete options API.");
                    if (typeof source[property] === "object" && $.inArray(property, externalObjects) === -1) checkPropertiesIfExist(source[property], target[property]);
                }
            }
        }
    };
    return scope;
}($e6fe0b74a9f00150$var$EasyAutocomplete || {});
/*
 * EasyAutocomplete - Logger 
 */ var $e6fe0b74a9f00150$var$EasyAutocomplete = function(scope) {
    scope.Logger = function Logger() {
        this.error = function(message) {
            console.log("ERROR: " + message);
        };
        this.warning = function(message) {
            console.log("WARNING: " + message);
        };
    };
    return scope;
}($e6fe0b74a9f00150$var$EasyAutocomplete || {});
/*
 * EasyAutocomplete - Constans
 */ var $e6fe0b74a9f00150$var$EasyAutocomplete = function(scope) {
    scope.Constans = function Constans() {
        var constants = {
            CONTAINER_CLASS: "easy-autocomplete-container",
            CONTAINER_ID: "eac-container-",
            WRAPPER_CSS_CLASS: "easy-autocomplete"
        };
        this.getValue = function(propertyName) {
            return constants[propertyName];
        };
    };
    return scope;
}($e6fe0b74a9f00150$var$EasyAutocomplete || {});
/*
 * EasyAutocomplete - ListBuilderService 
 *
 * @author Łukasz Pawełczak 
 *
 */ var $e6fe0b74a9f00150$var$EasyAutocomplete = function(scope) {
    scope.ListBuilderService = function ListBuilderService(configuration, proccessResponseData) {
        this.init = function(data) {
            var listBuilder = [], builder = {};
            builder.data = configuration.get("listLocation")(data);
            builder.getValue = configuration.get("getValue");
            builder.maxListSize = configuration.get("list").maxNumberOfElements;
            listBuilder.push(builder);
            return listBuilder;
        };
        this.updateCategories = function(listBuilder, data) {
            if (configuration.get("categoriesAssigned")) {
                listBuilder = [];
                for(var i = 0; i < configuration.get("categories").length; i += 1){
                    var builder = convertToListBuilder(configuration.get("categories")[i], data);
                    listBuilder.push(builder);
                }
            }
            return listBuilder;
        };
        this.convertXml = function(listBuilder) {
            if (configuration.get("dataType").toUpperCase() === "XML") for(var i = 0; i < listBuilder.length; i += 1)listBuilder[i].data = convertXmlToList(listBuilder[i]);
            return listBuilder;
        };
        this.processData = function(listBuilder, inputPhrase) {
            for(var i = 0, length = listBuilder.length; i < length; i += 1)listBuilder[i].data = proccessResponseData(configuration, listBuilder[i], inputPhrase);
            return listBuilder;
        };
        this.checkIfDataExists = function(listBuilders) {
            for(var i = 0, length = listBuilders.length; i < length; i += 1)if (listBuilders[i].data !== undefined && listBuilders[i].data instanceof Array) {
                if (listBuilders[i].data.length > 0) return true;
            }
            return false;
        };
        function convertToListBuilder(category, data) {
            var builder = {};
            if (configuration.get("dataType").toUpperCase() === "XML") builder = convertXmlToListBuilder();
            else builder = convertDataToListBuilder();
            if (category.header !== undefined) builder.header = category.header;
            if (category.maxNumberOfElements !== undefined) builder.maxNumberOfElements = category.maxNumberOfElements;
            if (configuration.get("list").maxNumberOfElements !== undefined) builder.maxListSize = configuration.get("list").maxNumberOfElements;
            if (category.getValue !== undefined) {
                if (typeof category.getValue === "string") {
                    var defaultsGetValue = category.getValue;
                    builder.getValue = function(element) {
                        return element[defaultsGetValue];
                    };
                } else if (typeof category.getValue === "function") builder.getValue = category.getValue;
            } else builder.getValue = configuration.get("getValue");
            return builder;
            function convertXmlToListBuilder() {
                var builder = {}, listLocation;
                if (category.xmlElementName !== undefined) builder.xmlElementName = category.xmlElementName;
                if (category.listLocation !== undefined) listLocation = category.listLocation;
                else if (configuration.get("listLocation") !== undefined) listLocation = configuration.get("listLocation");
                if (listLocation !== undefined) {
                    if (typeof listLocation === "string") builder.data = $(data).find(listLocation);
                    else if (typeof listLocation === "function") builder.data = listLocation(data);
                } else builder.data = data;
                return builder;
            }
            function convertDataToListBuilder() {
                var builder = {};
                if (category.listLocation !== undefined) {
                    if (typeof category.listLocation === "string") builder.data = data[category.listLocation];
                    else if (typeof category.listLocation === "function") builder.data = category.listLocation(data);
                } else builder.data = data;
                return builder;
            }
        }
        function convertXmlToList(builder) {
            var simpleList = [];
            if (builder.xmlElementName === undefined) builder.xmlElementName = configuration.get("xmlElementName");
            $(builder.data).find(builder.xmlElementName).each(function() {
                simpleList.push(this);
            });
            return simpleList;
        }
    };
    return scope;
}($e6fe0b74a9f00150$var$EasyAutocomplete || {});
/*
 * EasyAutocomplete - Data proccess module
 *
 * Process list to display:
 * - sort 
 * - decrease number to specific number
 * - show only matching list
 *
 */ var $e6fe0b74a9f00150$var$EasyAutocomplete = function(scope) {
    scope.proccess = function proccessData(config, listBuilder, phrase) {
        scope.proccess.match = match;
        var list = listBuilder.data, inputPhrase = phrase; //TODO REFACTOR
        list = findMatch(list, inputPhrase);
        list = reduceElementsInList(list);
        list = sort(list);
        return list;
        function findMatch(list, phrase) {
            var preparedList = [], value = "";
            if (config.get("list").match.enabled) for(var i = 0, length = list.length; i < length; i += 1){
                value = config.get("getValue")(list[i]);
                if (match(value, phrase)) preparedList.push(list[i]);
            }
            else preparedList = list;
            return preparedList;
        }
        function match(value, phrase) {
            if (!config.get("list").match.caseSensitive) {
                if (typeof value === "string") value = value.toLowerCase();
                phrase = phrase.toLowerCase();
            }
            if (config.get("list").match.method(value, phrase)) return true;
            else return false;
        }
        function reduceElementsInList(list) {
            if (listBuilder.maxNumberOfElements !== undefined && list.length > listBuilder.maxNumberOfElements) list = list.slice(0, listBuilder.maxNumberOfElements);
            return list;
        }
        function sort(list) {
            if (config.get("list").sort.enabled) list.sort(config.get("list").sort.method);
            return list;
        }
    };
    return scope;
}($e6fe0b74a9f00150$var$EasyAutocomplete || {});
/*
 * EasyAutocomplete - Template 
 *
 * 
 *
 */ var $e6fe0b74a9f00150$var$EasyAutocomplete = function(scope) {
    scope.Template = function Template(options) {
        var genericTemplates = {
            basic: {
                type: "basic",
                method: function(element) {
                    return element;
                },
                cssClass: ""
            },
            description: {
                type: "description",
                fields: {
                    description: "description"
                },
                method: function(element) {
                    return element + " - description";
                },
                cssClass: "eac-description"
            },
            iconLeft: {
                type: "iconLeft",
                fields: {
                    icon: ""
                },
                method: function(element) {
                    return element;
                },
                cssClass: "eac-icon-left"
            },
            iconRight: {
                type: "iconRight",
                fields: {
                    iconSrc: ""
                },
                method: function(element) {
                    return element;
                },
                cssClass: "eac-icon-right"
            },
            links: {
                type: "links",
                fields: {
                    link: ""
                },
                method: function(element) {
                    return element;
                },
                cssClass: ""
            },
            custom: {
                type: "custom",
                method: function() {},
                cssClass: ""
            }
        }, /*
		 * Converts method with {{text}} to function
		 */ convertTemplateToMethod = function(template) {
            var _fields = template.fields, buildMethod;
            if (template.type === "description") {
                buildMethod = genericTemplates.description.method;
                if (typeof _fields.description === "string") buildMethod = function(elementValue, element) {
                    return elementValue + " - <span>" + element[_fields.description] + "</span>";
                };
                else if (typeof _fields.description === "function") buildMethod = function(elementValue, element) {
                    return elementValue + " - <span>" + _fields.description(element) + "</span>";
                };
                return buildMethod;
            }
            if (template.type === "iconRight") {
                if (typeof _fields.iconSrc === "string") buildMethod = function(elementValue, element) {
                    return elementValue + "<img class='eac-icon' src='" + element[_fields.iconSrc] + "' />";
                };
                else if (typeof _fields.iconSrc === "function") buildMethod = function(elementValue, element) {
                    return elementValue + "<img class='eac-icon' src='" + _fields.iconSrc(element) + "' />";
                };
                return buildMethod;
            }
            if (template.type === "iconLeft") {
                if (typeof _fields.iconSrc === "string") buildMethod = function(elementValue, element) {
                    return "<img class='eac-icon' src='" + element[_fields.iconSrc] + "' />" + elementValue;
                };
                else if (typeof _fields.iconSrc === "function") buildMethod = function(elementValue, element) {
                    return "<img class='eac-icon' src='" + _fields.iconSrc(element) + "' />" + elementValue;
                };
                return buildMethod;
            }
            if (template.type === "links") {
                if (typeof _fields.link === "string") buildMethod = function(elementValue, element) {
                    return "<a href='" + element[_fields.link] + "' >" + elementValue + "</a>";
                };
                else if (typeof _fields.link === "function") buildMethod = function(elementValue, element) {
                    return "<a href='" + _fields.link(element) + "' >" + elementValue + "</a>";
                };
                return buildMethod;
            }
            if (template.type === "custom") return template.method;
            return genericTemplates.basic.method;
        }, prepareBuildMethod = function(options) {
            if (!options || !options.type) return genericTemplates.basic.method;
            if (options.type && genericTemplates[options.type]) return convertTemplateToMethod(options);
            else return genericTemplates.basic.method;
        }, templateClass = function(options) {
            var emptyStringFunction = function() {
                return "";
            };
            if (!options || !options.type) return emptyStringFunction;
            if (options.type && genericTemplates[options.type]) return function() {
                var _cssClass = genericTemplates[options.type].cssClass;
                return function() {
                    return _cssClass;
                };
            }();
            else return emptyStringFunction;
        };
        this.getTemplateClass = templateClass(options);
        this.build = prepareBuildMethod(options);
    };
    return scope;
}($e6fe0b74a9f00150$var$EasyAutocomplete || {});
/*
 * EasyAutocomplete - jQuery plugin for autocompletion
 *
 */ var $e6fe0b74a9f00150$var$EasyAutocomplete = function(scope) {
    scope.main = function Core($input, options) {
        var module = {
            name: "EasyAutocomplete",
            shortcut: "eac"
        };
        var consts = new scope.Constans(), config = new scope.Configuration(options), logger1 = new scope.Logger(), template = new scope.Template(options.template), listBuilderService = new scope.ListBuilderService(config, scope.proccess), checkParam = config.equals, $field = $input, $container = "", elementsList = [], selectedElement = -1, requestDelayTimeoutId;
        scope.consts = consts;
        this.getConstants = function() {
            return consts;
        };
        this.getConfiguration = function() {
            return config;
        };
        this.getContainer = function() {
            return $container;
        };
        this.getSelectedItemIndex = function() {
            return selectedElement;
        };
        this.getItems = function() {
            return elementsList;
        };
        this.getItemData = function(index) {
            if (elementsList.length < index || elementsList[index] === undefined) return -1;
            else return elementsList[index];
        };
        this.getSelectedItemData = function() {
            return this.getItemData(selectedElement);
        };
        this.build = function() {
            prepareField();
        };
        this.init = function() {
            init();
        };
        function init() {
            if ($field.length === 0) {
                logger1.error("Input field doesn't exist.");
                return;
            }
            if (!config.checkDataUrlProperties()) {
                logger1.error("One of options variables 'data' or 'url' must be defined.");
                return;
            }
            if (!config.checkRequiredProperties()) {
                logger1.error("Will not work without mentioned properties.");
                return;
            }
            prepareField();
            bindEvents();
        }
        function prepareField() {
            if ($field.parent().hasClass(consts.getValue("WRAPPER_CSS_CLASS"))) {
                removeContainer();
                removeWrapper();
            }
            createWrapper();
            createContainer();
            $container = $("#" + getContainerId());
            if (config.get("placeholder")) $field.attr("placeholder", config.get("placeholder"));
            function createWrapper() {
                var $wrapper = $("<div>"), classes = consts.getValue("WRAPPER_CSS_CLASS");
                if (config.get("theme") && config.get("theme") !== "") classes += " eac-" + config.get("theme");
                if (config.get("cssClasses") && config.get("cssClasses") !== "") classes += " " + config.get("cssClasses");
                if (template.getTemplateClass() !== "") classes += " " + template.getTemplateClass();
                $wrapper.addClass(classes);
                $field.wrap($wrapper);
                if (config.get("adjustWidth") === true) adjustWrapperWidth();
            }
            function adjustWrapperWidth() {
                var fieldWidth = $field.outerWidth();
                $field.parent().css("width", fieldWidth);
            }
            function removeWrapper() {
                $field.unwrap();
            }
            function createContainer() {
                var $elements_container = $("<div>").addClass(consts.getValue("CONTAINER_CLASS"));
                $elements_container.attr("id", getContainerId()).prepend($("<ul>"));
                (function() {
                    $elements_container/* List show animation */ .on("show.eac", function() {
                        switch(config.get("list").showAnimation.type){
                            case "slide":
                                var animationTime = config.get("list").showAnimation.time, callback = config.get("list").showAnimation.callback;
                                $elements_container.find("ul").slideDown(animationTime, callback);
                                break;
                            case "fade":
                                var animationTime = config.get("list").showAnimation.time, callback = config.get("list").showAnimation.callback;
                                $elements_container.find("ul").fadeIn(animationTime), callback;
                                break;
                            default:
                                $elements_container.find("ul").show();
                                break;
                        }
                        config.get("list").onShowListEvent();
                    })/* List hide animation */ .on("hide.eac", function() {
                        switch(config.get("list").hideAnimation.type){
                            case "slide":
                                var animationTime = config.get("list").hideAnimation.time, callback = config.get("list").hideAnimation.callback;
                                $elements_container.find("ul").slideUp(animationTime, callback);
                                break;
                            case "fade":
                                var animationTime = config.get("list").hideAnimation.time, callback = config.get("list").hideAnimation.callback;
                                $elements_container.find("ul").fadeOut(animationTime, callback);
                                break;
                            default:
                                $elements_container.find("ul").hide();
                                break;
                        }
                        config.get("list").onHideListEvent();
                    }).on("selectElement.eac", function() {
                        $elements_container.find("ul li").removeClass("selected");
                        $elements_container.find("ul li").eq(selectedElement).addClass("selected");
                        config.get("list").onSelectItemEvent();
                    }).on("loadElements.eac", function(event, listBuilders, phrase) {
                        var $item = "", $listContainer = $elements_container.find("ul");
                        $listContainer.empty().detach();
                        elementsList = [];
                        var counter = 0;
                        for(var builderIndex = 0, listBuildersLength = listBuilders.length; builderIndex < listBuildersLength; builderIndex += 1){
                            var listData = listBuilders[builderIndex].data;
                            if (listData.length === 0) continue;
                            if (listBuilders[builderIndex].header !== undefined && listBuilders[builderIndex].header.length > 0) $listContainer.append("<div class='eac-category' >" + listBuilders[builderIndex].header + "</div>");
                            for(var i = 0, listDataLength = listData.length; i < listDataLength && counter < listBuilders[builderIndex].maxListSize; i += 1){
                                $item = $("<li><div class='eac-item'></div></li>");
                                (function() {
                                    var j = i, itemCounter = counter, elementsValue = listBuilders[builderIndex].getValue(listData[j]);
                                    $item.find(" > div").on("click", function() {
                                        $field.val(elementsValue).trigger("change");
                                        selectedElement = itemCounter;
                                        selectElement(itemCounter);
                                        config.get("list").onClickEvent();
                                        config.get("list").onChooseEvent();
                                    }).mouseover(function() {
                                        selectedElement = itemCounter;
                                        selectElement(itemCounter);
                                        config.get("list").onMouseOverEvent();
                                    }).mouseout(function() {
                                        config.get("list").onMouseOutEvent();
                                    }).html(template.build(highlight(elementsValue, phrase), listData[j]));
                                })();
                                $listContainer.append($item);
                                elementsList.push(listData[i]);
                                counter += 1;
                            }
                        }
                        $elements_container.append($listContainer);
                        config.get("list").onLoadEvent();
                    });
                })();
                $field.after($elements_container);
            }
            function removeContainer() {
                $field.next("." + consts.getValue("CONTAINER_CLASS")).remove();
            }
            function highlight(string, phrase) {
                if (config.get("highlightPhrase") && phrase !== "") return highlightPhrase(string, phrase);
                else return string;
            }
            function escapeRegExp(str) {
                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
            }
            function highlightPhrase(string, phrase) {
                var escapedPhrase = escapeRegExp(phrase);
                return (string + "").replace(new RegExp("(" + escapedPhrase + ")", "gi"), "<b>$1</b>");
            }
        }
        function getContainerId() {
            var elementId1 = $field.attr("id");
            elementId1 = consts.getValue("CONTAINER_ID") + elementId1;
            return elementId1;
        }
        function bindEvents() {
            bindAllEvents();
            function bindAllEvents() {
                if (checkParam("autocompleteOff", true)) removeAutocomplete();
                bindFocusOut();
                bindKeyup();
                bindKeydown();
                bindKeypress();
                bindFocus();
                bindBlur();
            }
            function bindFocusOut() {
                $field.focusout(function() {
                    var fieldValue = $field.val(), phrase;
                    if (!config.get("list").match.caseSensitive) fieldValue = fieldValue.toLowerCase();
                    for(var i = 0, length = elementsList.length; i < length; i += 1){
                        phrase = config.get("getValue")(elementsList[i]);
                        if (!config.get("list").match.caseSensitive) phrase = phrase.toLowerCase();
                        if (phrase === fieldValue) {
                            selectedElement = i;
                            selectElement(selectedElement);
                            return;
                        }
                    }
                });
            }
            function bindKeyup() {
                $field.off("keyup").keyup(function(event) {
                    switch(event.keyCode){
                        case 27:
                            hideContainer();
                            loseFieldFocus();
                            break;
                        case 38:
                            event.preventDefault();
                            if (elementsList.length > 0 && selectedElement > 0) {
                                selectedElement -= 1;
                                $field.val(config.get("getValue")(elementsList[selectedElement]));
                                selectElement(selectedElement);
                            }
                            break;
                        case 40:
                            event.preventDefault();
                            if (elementsList.length > 0 && selectedElement < elementsList.length - 1) {
                                selectedElement += 1;
                                $field.val(config.get("getValue")(elementsList[selectedElement]));
                                selectElement(selectedElement);
                            }
                            break;
                        default:
                            if (event.keyCode > 40 || event.keyCode === 8) {
                                var inputPhrase = $field.val();
                                if (!(config.get("list").hideOnEmptyPhrase === true && event.keyCode === 8 && inputPhrase === "")) {
                                    if (config.get("requestDelay") > 0) {
                                        if (requestDelayTimeoutId !== undefined) clearTimeout(requestDelayTimeoutId);
                                        requestDelayTimeoutId = setTimeout(function() {
                                            loadData(inputPhrase);
                                        }, config.get("requestDelay"));
                                    } else loadData(inputPhrase);
                                } else hideContainer();
                            }
                            break;
                    }
                    function loadData(inputPhrase) {
                        if (inputPhrase.length < config.get("minCharNumber")) return;
                        if (config.get("data") !== "list-required") {
                            var data = config.get("data");
                            var listBuilders = listBuilderService.init(data);
                            listBuilders = listBuilderService.updateCategories(listBuilders, data);
                            listBuilders = listBuilderService.processData(listBuilders, inputPhrase);
                            loadElements(listBuilders, inputPhrase);
                            if ($field.parent().find("li").length > 0) showContainer();
                            else hideContainer();
                        }
                        var settings = createAjaxSettings();
                        if (settings.url === undefined || settings.url === "") settings.url = config.get("url");
                        if (settings.dataType === undefined || settings.dataType === "") settings.dataType = config.get("dataType");
                        if (settings.url !== undefined && settings.url !== "list-required") {
                            settings.url = settings.url(inputPhrase);
                            settings.data = config.get("preparePostData")(settings.data, inputPhrase);
                            $.ajax(settings).done(function(data) {
                                var listBuilders = listBuilderService.init(data);
                                listBuilders = listBuilderService.updateCategories(listBuilders, data);
                                listBuilders = listBuilderService.convertXml(listBuilders);
                                if (checkInputPhraseMatchResponse(inputPhrase, data)) {
                                    listBuilders = listBuilderService.processData(listBuilders, inputPhrase);
                                    loadElements(listBuilders, inputPhrase);
                                }
                                if (listBuilderService.checkIfDataExists(listBuilders) && $field.parent().find("li").length > 0) showContainer();
                                else hideContainer();
                                config.get("ajaxCallback")();
                            }).fail(function() {
                                logger1.warning("Fail to load response data");
                            }).always(function() {});
                        }
                        function createAjaxSettings() {
                            var settings = {}, ajaxSettings = config.get("ajaxSettings") || {};
                            for(var set in ajaxSettings)settings[set] = ajaxSettings[set];
                            return settings;
                        }
                        function checkInputPhraseMatchResponse(inputPhrase, data) {
                            if (config.get("matchResponseProperty") !== false) {
                                if (typeof config.get("matchResponseProperty") === "string") return data[config.get("matchResponseProperty")] === inputPhrase;
                                if (typeof config.get("matchResponseProperty") === "function") return config.get("matchResponseProperty")(data) === inputPhrase;
                                return true;
                            } else return true;
                        }
                    }
                });
            }
            function bindKeydown() {
                $field.on("keydown", function(evt) {
                    evt = evt || window.event;
                    var keyCode = evt.keyCode;
                    if (keyCode === 38) {
                        suppressKeypress = true;
                        return false;
                    }
                }).keydown(function(event) {
                    if (event.keyCode === 13 && selectedElement > -1) {
                        $field.val(config.get("getValue")(elementsList[selectedElement]));
                        config.get("list").onKeyEnterEvent();
                        config.get("list").onChooseEvent();
                        selectedElement = -1;
                        hideContainer();
                        event.preventDefault();
                    }
                });
            }
            function bindKeypress() {
                $field.off("keypress");
            }
            function bindFocus() {
                $field.focus(function() {
                    if ($field.val() !== "" && elementsList.length > 0) {
                        selectedElement = -1;
                        showContainer();
                    }
                });
            }
            function bindBlur() {
                $field.blur(function() {
                    setTimeout(function() {
                        selectedElement = -1;
                        hideContainer();
                    }, 250);
                });
            }
            function removeAutocomplete() {
                $field.attr("autocomplete", "off");
            }
        }
        function showContainer() {
            $container.trigger("show.eac");
        }
        function hideContainer() {
            $container.trigger("hide.eac");
        }
        function selectElement(index) {
            $container.trigger("selectElement.eac", index);
        }
        function loadElements(list, phrase) {
            $container.trigger("loadElements.eac", [
                list,
                phrase
            ]);
        }
        function loseFieldFocus() {
            $field.trigger("blur");
        }
    };
    scope.eacHandles = [];
    scope.getHandle = function(id) {
        return scope.eacHandles[id];
    };
    scope.inputHasId = function(input) {
        if ($(input).attr("id") !== undefined && $(input).attr("id").length > 0) return true;
        else return false;
    };
    scope.assignRandomId = function(input) {
        var fieldId = "";
        do fieldId = "eac-" + Math.floor(Math.random() * 10000);
        while ($("#" + fieldId).length !== 0);
        elementId = scope.consts.getValue("CONTAINER_ID") + fieldId;
        $(input).attr("id", fieldId);
    };
    scope.setHandle = function(handle, id) {
        scope.eacHandles[id] = handle;
    };
    return scope;
}($e6fe0b74a9f00150$var$EasyAutocomplete || {});
(function($1) {
    $1.fn.easyAutocomplete = function(options) {
        return this.each(function() {
            var $this = $1(this), eacHandle = new $e6fe0b74a9f00150$var$EasyAutocomplete.main($this, options);
            if (!$e6fe0b74a9f00150$var$EasyAutocomplete.inputHasId($this)) $e6fe0b74a9f00150$var$EasyAutocomplete.assignRandomId($this);
            eacHandle.init();
            $e6fe0b74a9f00150$var$EasyAutocomplete.setHandle(eacHandle, $this.attr("id"));
        });
    };
    $1.fn.getSelectedItemIndex = function() {
        var inputId = $1(this).attr("id");
        if (inputId !== undefined) return $e6fe0b74a9f00150$var$EasyAutocomplete.getHandle(inputId).getSelectedItemIndex();
        return -1;
    };
    $1.fn.getItems = function() {
        var inputId = $1(this).attr("id");
        if (inputId !== undefined) return $e6fe0b74a9f00150$var$EasyAutocomplete.getHandle(inputId).getItems();
        return -1;
    };
    $1.fn.getItemData = function(index) {
        var inputId = $1(this).attr("id");
        if (inputId !== undefined && index > -1) return $e6fe0b74a9f00150$var$EasyAutocomplete.getHandle(inputId).getItemData(index);
        return -1;
    };
    $1.fn.getSelectedItemData = function() {
        var inputId = $1(this).attr("id");
        if (inputId !== undefined) return $e6fe0b74a9f00150$var$EasyAutocomplete.getHandle(inputId).getSelectedItemData();
        return -1;
    };
})(jQuery);


var $d381ea15c3f54d0e$exports = {};

/*!
  * Bootstrap v4.6.0 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global1, factory) {
    factory($d381ea15c3f54d0e$exports, (parcelRequire("ef6Fp")));
})($d381ea15c3f54d0e$exports, function(exports1, $) {
    "use strict";
    function _interopDefaultLegacy(e) {
        return e && typeof e === "object" && "default" in e ? e : {
            "default": e
        };
    }
    var $__default = /*#__PURE__*/ _interopDefaultLegacy($);
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.0): util.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Private TransitionEnd Helpers
   * ------------------------------------------------------------------------
   */ var TRANSITION_END = "transitionend";
    var MAX_UID = 1000000;
    var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)
    function toType(obj) {
        if (obj === null || typeof obj === "undefined") return "" + obj;
        return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    }
    function getSpecialTransitionEndEvent() {
        return {
            bindType: TRANSITION_END,
            delegateType: TRANSITION_END,
            handle: function handle(event) {
                if ($__default["default"](event.target).is(this)) return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
                return undefined;
            }
        };
    }
    function transitionEndEmulator(duration) {
        var _this = this;
        var called = false;
        $__default["default"](this).one(Util.TRANSITION_END, function() {
            called = true;
        });
        setTimeout(function() {
            if (!called) Util.triggerTransitionEnd(_this);
        }, duration);
        return this;
    }
    function setTransitionEndSupport() {
        $__default["default"].fn.emulateTransitionEnd = transitionEndEmulator;
        $__default["default"].event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
    /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */ var Util = {
        TRANSITION_END: "bsTransitionEnd",
        getUID: function getUID(prefix) {
            do prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
            while (document.getElementById(prefix));
            return prefix;
        },
        getSelectorFromElement: function getSelectorFromElement(element) {
            var selector = element.getAttribute("data-target");
            if (!selector || selector === "#") {
                var hrefAttr = element.getAttribute("href");
                selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : "";
            }
            try {
                return document.querySelector(selector) ? selector : null;
            } catch (_) {
                return null;
            }
        },
        getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
            if (!element) return 0;
             // Get transition-duration of the element
            var transitionDuration = $__default["default"](element).css("transition-duration");
            var transitionDelay = $__default["default"](element).css("transition-delay");
            var floatTransitionDuration = parseFloat(transitionDuration);
            var floatTransitionDelay = parseFloat(transitionDelay); // Return 0 if element or transition duration is not found
            if (!floatTransitionDuration && !floatTransitionDelay) return 0;
             // If multiple durations are defined, take the first
            transitionDuration = transitionDuration.split(",")[0];
            transitionDelay = transitionDelay.split(",")[0];
            return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
        },
        reflow: function reflow(element) {
            return element.offsetHeight;
        },
        triggerTransitionEnd: function triggerTransitionEnd(element) {
            $__default["default"](element).trigger(TRANSITION_END);
        },
        supportsTransitionEnd: function supportsTransitionEnd() {
            return Boolean(TRANSITION_END);
        },
        isElement: function isElement(obj) {
            return (obj[0] || obj).nodeType;
        },
        typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
            for(var property in configTypes)if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
                var expectedTypes = configTypes[property];
                var value = config[property];
                var valueType = value && Util.isElement(value) ? "element" : toType(value);
                if (!new RegExp(expectedTypes).test(valueType)) throw new Error(componentName.toUpperCase() + ": " + ('Option "' + property + '" provided type "' + valueType + '" ') + ('but expected type "' + expectedTypes + '".'));
            }
        },
        findShadowRoot: function findShadowRoot(element) {
            if (!document.documentElement.attachShadow) return null;
             // Can find the shadow root otherwise it'll return the document
            if (typeof element.getRootNode === "function") {
                var root = element.getRootNode();
                return root instanceof ShadowRoot ? root : null;
            }
            if (element instanceof ShadowRoot) return element;
             // when we don't find a shadow root
            if (!element.parentNode) return null;
            return Util.findShadowRoot(element.parentNode);
        },
        jQueryDetection: function jQueryDetection() {
            if (typeof $__default["default"] === "undefined") throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
            var version = $__default["default"].fn.jquery.split(" ")[0].split(".");
            var minMajor = 1;
            var ltMajor = 2;
            var minMinor = 9;
            var minPatch = 1;
            var maxMajor = 4;
            if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0");
        }
    };
    Util.jQueryDetection();
    setTransitionEndSupport();
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME = "alert";
    var VERSION = "4.6.0";
    var DATA_KEY = "bs.alert";
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = ".data-api";
    var JQUERY_NO_CONFLICT = $__default["default"].fn[NAME];
    var SELECTOR_DISMISS = '[data-dismiss="alert"]';
    var EVENT_CLOSE = "close" + EVENT_KEY;
    var EVENT_CLOSED = "closed" + EVENT_KEY;
    var EVENT_CLICK_DATA_API = "click" + EVENT_KEY + DATA_API_KEY;
    var CLASS_NAME_ALERT = "alert";
    var CLASS_NAME_FADE = "fade";
    var CLASS_NAME_SHOW = "show";
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Alert = /*#__PURE__*/ function() {
        function Alert(element) {
            this._element = element;
        } // Getters
        var _proto = Alert.prototype;
        // Public
        _proto.close = function close(element) {
            var rootElement = this._element;
            if (element) rootElement = this._getRootElement(element);
            var customEvent = this._triggerCloseEvent(rootElement);
            if (customEvent.isDefaultPrevented()) return;
            this._removeElement(rootElement);
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY);
            this._element = null;
        } // Private
        ;
        _proto._getRootElement = function _getRootElement(element) {
            var selector = Util.getSelectorFromElement(element);
            var parent = false;
            if (selector) parent = document.querySelector(selector);
            if (!parent) parent = $__default["default"](element).closest("." + CLASS_NAME_ALERT)[0];
            return parent;
        };
        _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
            var closeEvent = $__default["default"].Event(EVENT_CLOSE);
            $__default["default"](element).trigger(closeEvent);
            return closeEvent;
        };
        _proto._removeElement = function _removeElement(element) {
            var _this = this;
            $__default["default"](element).removeClass(CLASS_NAME_SHOW);
            if (!$__default["default"](element).hasClass(CLASS_NAME_FADE)) {
                this._destroyElement(element);
                return;
            }
            var transitionDuration = Util.getTransitionDurationFromElement(element);
            $__default["default"](element).one(Util.TRANSITION_END, function(event) {
                return _this._destroyElement(element, event);
            }).emulateTransitionEnd(transitionDuration);
        };
        _proto._destroyElement = function _destroyElement(element) {
            $__default["default"](element).detach().trigger(EVENT_CLOSED).remove();
        } // Static
        ;
        Alert._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY);
                if (!data) {
                    data = new Alert(this);
                    $element.data(DATA_KEY, data);
                }
                if (config === "close") data[config](this);
            });
        };
        Alert._handleDismiss = function _handleDismiss(alertInstance) {
            return function(event) {
                if (event) event.preventDefault();
                alertInstance.close(this);
            };
        };
        _createClass(Alert, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION;
                }
            }
        ]);
        return Alert;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API, SELECTOR_DISMISS, Alert._handleDismiss(new Alert()));
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME] = Alert._jQueryInterface;
    $__default["default"].fn[NAME].Constructor = Alert;
    $__default["default"].fn[NAME].noConflict = function() {
        $__default["default"].fn[NAME] = JQUERY_NO_CONFLICT;
        return Alert._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$1 = "button";
    var VERSION$1 = "4.6.0";
    var DATA_KEY$1 = "bs.button";
    var EVENT_KEY$1 = "." + DATA_KEY$1;
    var DATA_API_KEY$1 = ".data-api";
    var JQUERY_NO_CONFLICT$1 = $__default["default"].fn[NAME$1];
    var CLASS_NAME_ACTIVE = "active";
    var CLASS_NAME_BUTTON = "btn";
    var CLASS_NAME_FOCUS = "focus";
    var SELECTOR_DATA_TOGGLE_CARROT = '[data-toggle^="button"]';
    var SELECTOR_DATA_TOGGLES = '[data-toggle="buttons"]';
    var SELECTOR_DATA_TOGGLE = '[data-toggle="button"]';
    var SELECTOR_DATA_TOGGLES_BUTTONS = '[data-toggle="buttons"] .btn';
    var SELECTOR_INPUT = 'input:not([type="hidden"])';
    var SELECTOR_ACTIVE = ".active";
    var SELECTOR_BUTTON = ".btn";
    var EVENT_CLICK_DATA_API$1 = "click" + EVENT_KEY$1 + DATA_API_KEY$1;
    var EVENT_FOCUS_BLUR_DATA_API = "focus" + EVENT_KEY$1 + DATA_API_KEY$1 + " " + ("blur" + EVENT_KEY$1 + DATA_API_KEY$1);
    var EVENT_LOAD_DATA_API = "load" + EVENT_KEY$1 + DATA_API_KEY$1;
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Button = /*#__PURE__*/ function() {
        function Button(element) {
            this._element = element;
            this.shouldAvoidTriggerChange = false;
        } // Getters
        var _proto = Button.prototype;
        // Public
        _proto.toggle = function toggle() {
            var triggerChangeEvent = true;
            var addAriaPressed = true;
            var rootElement = $__default["default"](this._element).closest(SELECTOR_DATA_TOGGLES)[0];
            if (rootElement) {
                var input = this._element.querySelector(SELECTOR_INPUT);
                if (input) {
                    if (input.type === "radio") {
                        if (input.checked && this._element.classList.contains(CLASS_NAME_ACTIVE)) triggerChangeEvent = false;
                        else {
                            var activeElement = rootElement.querySelector(SELECTOR_ACTIVE);
                            if (activeElement) $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE);
                        }
                    }
                    if (triggerChangeEvent) {
                        // if it's not a radio button or checkbox don't add a pointless/invalid checked property to the input
                        if (input.type === "checkbox" || input.type === "radio") input.checked = !this._element.classList.contains(CLASS_NAME_ACTIVE);
                        if (!this.shouldAvoidTriggerChange) $__default["default"](input).trigger("change");
                    }
                    input.focus();
                    addAriaPressed = false;
                }
            }
            if (!(this._element.hasAttribute("disabled") || this._element.classList.contains("disabled"))) {
                if (addAriaPressed) this._element.setAttribute("aria-pressed", !this._element.classList.contains(CLASS_NAME_ACTIVE));
                if (triggerChangeEvent) $__default["default"](this._element).toggleClass(CLASS_NAME_ACTIVE);
            }
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$1);
            this._element = null;
        } // Static
        ;
        Button._jQueryInterface = function _jQueryInterface(config, avoidTriggerChange) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$1);
                if (!data) {
                    data = new Button(this);
                    $element.data(DATA_KEY$1, data);
                }
                data.shouldAvoidTriggerChange = avoidTriggerChange;
                if (config === "toggle") data[config]();
            });
        };
        _createClass(Button, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$1;
                }
            }
        ]);
        return Button;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE_CARROT, function(event) {
        var button = event.target;
        var initialButton = button;
        if (!$__default["default"](button).hasClass(CLASS_NAME_BUTTON)) button = $__default["default"](button).closest(SELECTOR_BUTTON)[0];
        if (!button || button.hasAttribute("disabled") || button.classList.contains("disabled")) event.preventDefault(); // work around Firefox bug #1540995
        else {
            var inputBtn = button.querySelector(SELECTOR_INPUT);
            if (inputBtn && (inputBtn.hasAttribute("disabled") || inputBtn.classList.contains("disabled"))) {
                event.preventDefault(); // work around Firefox bug #1540995
                return;
            }
            if (initialButton.tagName === "INPUT" || button.tagName !== "LABEL") Button._jQueryInterface.call($__default["default"](button), "toggle", initialButton.tagName === "INPUT");
        }
    }).on(EVENT_FOCUS_BLUR_DATA_API, SELECTOR_DATA_TOGGLE_CARROT, function(event) {
        var button = $__default["default"](event.target).closest(SELECTOR_BUTTON)[0];
        $__default["default"](button).toggleClass(CLASS_NAME_FOCUS, /^focus(in)?$/.test(event.type));
    });
    $__default["default"](window).on(EVENT_LOAD_DATA_API, function() {
        // ensure correct active class is set to match the controls' actual values/states
        // find all checkboxes/readio buttons inside data-toggle groups
        var buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLES_BUTTONS));
        for(var i = 0, len = buttons.length; i < len; i++){
            var button = buttons[i];
            var input = button.querySelector(SELECTOR_INPUT);
            if (input.checked || input.hasAttribute("checked")) button.classList.add(CLASS_NAME_ACTIVE);
            else button.classList.remove(CLASS_NAME_ACTIVE);
        } // find all button toggles
        buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE));
        for(var _i = 0, _len = buttons.length; _i < _len; _i++){
            var _button = buttons[_i];
            if (_button.getAttribute("aria-pressed") === "true") _button.classList.add(CLASS_NAME_ACTIVE);
            else _button.classList.remove(CLASS_NAME_ACTIVE);
        }
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$1] = Button._jQueryInterface;
    $__default["default"].fn[NAME$1].Constructor = Button;
    $__default["default"].fn[NAME$1].noConflict = function() {
        $__default["default"].fn[NAME$1] = JQUERY_NO_CONFLICT$1;
        return Button._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$2 = "carousel";
    var VERSION$2 = "4.6.0";
    var DATA_KEY$2 = "bs.carousel";
    var EVENT_KEY$2 = "." + DATA_KEY$2;
    var DATA_API_KEY$2 = ".data-api";
    var JQUERY_NO_CONFLICT$2 = $__default["default"].fn[NAME$2];
    var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key
    var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key
    var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
    var SWIPE_THRESHOLD = 40;
    var Default = {
        interval: 5000,
        keyboard: true,
        slide: false,
        pause: "hover",
        wrap: true,
        touch: true
    };
    var DefaultType = {
        interval: "(number|boolean)",
        keyboard: "boolean",
        slide: "(boolean|string)",
        pause: "(string|boolean)",
        wrap: "boolean",
        touch: "boolean"
    };
    var DIRECTION_NEXT = "next";
    var DIRECTION_PREV = "prev";
    var DIRECTION_LEFT = "left";
    var DIRECTION_RIGHT = "right";
    var EVENT_SLIDE = "slide" + EVENT_KEY$2;
    var EVENT_SLID = "slid" + EVENT_KEY$2;
    var EVENT_KEYDOWN = "keydown" + EVENT_KEY$2;
    var EVENT_MOUSEENTER = "mouseenter" + EVENT_KEY$2;
    var EVENT_MOUSELEAVE = "mouseleave" + EVENT_KEY$2;
    var EVENT_TOUCHSTART = "touchstart" + EVENT_KEY$2;
    var EVENT_TOUCHMOVE = "touchmove" + EVENT_KEY$2;
    var EVENT_TOUCHEND = "touchend" + EVENT_KEY$2;
    var EVENT_POINTERDOWN = "pointerdown" + EVENT_KEY$2;
    var EVENT_POINTERUP = "pointerup" + EVENT_KEY$2;
    var EVENT_DRAG_START = "dragstart" + EVENT_KEY$2;
    var EVENT_LOAD_DATA_API$1 = "load" + EVENT_KEY$2 + DATA_API_KEY$2;
    var EVENT_CLICK_DATA_API$2 = "click" + EVENT_KEY$2 + DATA_API_KEY$2;
    var CLASS_NAME_CAROUSEL = "carousel";
    var CLASS_NAME_ACTIVE$1 = "active";
    var CLASS_NAME_SLIDE = "slide";
    var CLASS_NAME_RIGHT = "carousel-item-right";
    var CLASS_NAME_LEFT = "carousel-item-left";
    var CLASS_NAME_NEXT = "carousel-item-next";
    var CLASS_NAME_PREV = "carousel-item-prev";
    var CLASS_NAME_POINTER_EVENT = "pointer-event";
    var SELECTOR_ACTIVE$1 = ".active";
    var SELECTOR_ACTIVE_ITEM = ".active.carousel-item";
    var SELECTOR_ITEM = ".carousel-item";
    var SELECTOR_ITEM_IMG = ".carousel-item img";
    var SELECTOR_NEXT_PREV = ".carousel-item-next, .carousel-item-prev";
    var SELECTOR_INDICATORS = ".carousel-indicators";
    var SELECTOR_DATA_SLIDE = "[data-slide], [data-slide-to]";
    var SELECTOR_DATA_RIDE = '[data-ride="carousel"]';
    var PointerType = {
        TOUCH: "touch",
        PEN: "pen"
    };
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Carousel = /*#__PURE__*/ function() {
        function Carousel(element, config) {
            this._items = null;
            this._interval = null;
            this._activeElement = null;
            this._isPaused = false;
            this._isSliding = false;
            this.touchTimeout = null;
            this.touchStartX = 0;
            this.touchDeltaX = 0;
            this._config = this._getConfig(config);
            this._element = element;
            this._indicatorsElement = this._element.querySelector(SELECTOR_INDICATORS);
            this._touchSupported = "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
            this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent);
            this._addEventListeners();
        } // Getters
        var _proto = Carousel.prototype;
        // Public
        _proto.next = function next() {
            if (!this._isSliding) this._slide(DIRECTION_NEXT);
        };
        _proto.nextWhenVisible = function nextWhenVisible() {
            var $element = $__default["default"](this._element); // Don't call next when the page isn't visible
            // or the carousel or its parent isn't visible
            if (!document.hidden && $element.is(":visible") && $element.css("visibility") !== "hidden") this.next();
        };
        _proto.prev = function prev() {
            if (!this._isSliding) this._slide(DIRECTION_PREV);
        };
        _proto.pause = function pause(event) {
            if (!event) this._isPaused = true;
            if (this._element.querySelector(SELECTOR_NEXT_PREV)) {
                Util.triggerTransitionEnd(this._element);
                this.cycle(true);
            }
            clearInterval(this._interval);
            this._interval = null;
        };
        _proto.cycle = function cycle(event) {
            if (!event) this._isPaused = false;
            if (this._interval) {
                clearInterval(this._interval);
                this._interval = null;
            }
            if (this._config.interval && !this._isPaused) {
                this._updateInterval();
                this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
            }
        };
        _proto.to = function to(index) {
            var _this = this;
            this._activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            var activeIndex = this._getItemIndex(this._activeElement);
            if (index > this._items.length - 1 || index < 0) return;
            if (this._isSliding) {
                $__default["default"](this._element).one(EVENT_SLID, function() {
                    return _this.to(index);
                });
                return;
            }
            if (activeIndex === index) {
                this.pause();
                this.cycle();
                return;
            }
            var direction = index > activeIndex ? DIRECTION_NEXT : DIRECTION_PREV;
            this._slide(direction, this._items[index]);
        };
        _proto.dispose = function dispose() {
            $__default["default"](this._element).off(EVENT_KEY$2);
            $__default["default"].removeData(this._element, DATA_KEY$2);
            this._items = null;
            this._config = null;
            this._element = null;
            this._interval = null;
            this._isPaused = null;
            this._isSliding = null;
            this._activeElement = null;
            this._indicatorsElement = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default, config);
            Util.typeCheckConfig(NAME$2, config, DefaultType);
            return config;
        };
        _proto._handleSwipe = function _handleSwipe() {
            var absDeltax = Math.abs(this.touchDeltaX);
            if (absDeltax <= SWIPE_THRESHOLD) return;
            var direction = absDeltax / this.touchDeltaX;
            this.touchDeltaX = 0; // swipe left
            if (direction > 0) this.prev();
             // swipe right
            if (direction < 0) this.next();
        };
        _proto._addEventListeners = function _addEventListeners() {
            var _this2 = this;
            if (this._config.keyboard) $__default["default"](this._element).on(EVENT_KEYDOWN, function(event) {
                return _this2._keydown(event);
            });
            if (this._config.pause === "hover") $__default["default"](this._element).on(EVENT_MOUSEENTER, function(event) {
                return _this2.pause(event);
            }).on(EVENT_MOUSELEAVE, function(event) {
                return _this2.cycle(event);
            });
            if (this._config.touch) this._addTouchEventListeners();
        };
        _proto._addTouchEventListeners = function _addTouchEventListeners() {
            var _this3 = this;
            if (!this._touchSupported) return;
            var start = function start(event) {
                if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) _this3.touchStartX = event.originalEvent.clientX;
                else if (!_this3._pointerEvent) _this3.touchStartX = event.originalEvent.touches[0].clientX;
            };
            var move = function move(event) {
                // ensure swiping with one touch and not pinching
                if (event.originalEvent.touches && event.originalEvent.touches.length > 1) _this3.touchDeltaX = 0;
                else _this3.touchDeltaX = event.originalEvent.touches[0].clientX - _this3.touchStartX;
            };
            var end = function end(event) {
                if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) _this3.touchDeltaX = event.originalEvent.clientX - _this3.touchStartX;
                _this3._handleSwipe();
                if (_this3._config.pause === "hover") {
                    // If it's a touch-enabled device, mouseenter/leave are fired as
                    // part of the mouse compatibility events on first tap - the carousel
                    // would stop cycling until user tapped out of it;
                    // here, we listen for touchend, explicitly pause the carousel
                    // (as if it's the second time we tap on it, mouseenter compat event
                    // is NOT fired) and after a timeout (to allow for mouse compatibility
                    // events to fire) we explicitly restart cycling
                    _this3.pause();
                    if (_this3.touchTimeout) clearTimeout(_this3.touchTimeout);
                    _this3.touchTimeout = setTimeout(function(event) {
                        return _this3.cycle(event);
                    }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
                }
            };
            $__default["default"](this._element.querySelectorAll(SELECTOR_ITEM_IMG)).on(EVENT_DRAG_START, function(e) {
                return e.preventDefault();
            });
            if (this._pointerEvent) {
                $__default["default"](this._element).on(EVENT_POINTERDOWN, function(event) {
                    return start(event);
                });
                $__default["default"](this._element).on(EVENT_POINTERUP, function(event) {
                    return end(event);
                });
                this._element.classList.add(CLASS_NAME_POINTER_EVENT);
            } else {
                $__default["default"](this._element).on(EVENT_TOUCHSTART, function(event) {
                    return start(event);
                });
                $__default["default"](this._element).on(EVENT_TOUCHMOVE, function(event) {
                    return move(event);
                });
                $__default["default"](this._element).on(EVENT_TOUCHEND, function(event) {
                    return end(event);
                });
            }
        };
        _proto._keydown = function _keydown(event) {
            if (/input|textarea/i.test(event.target.tagName)) return;
            switch(event.which){
                case ARROW_LEFT_KEYCODE:
                    event.preventDefault();
                    this.prev();
                    break;
                case ARROW_RIGHT_KEYCODE:
                    event.preventDefault();
                    this.next();
                    break;
            }
        };
        _proto._getItemIndex = function _getItemIndex(element) {
            this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(SELECTOR_ITEM)) : [];
            return this._items.indexOf(element);
        };
        _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
            var isNextDirection = direction === DIRECTION_NEXT;
            var isPrevDirection = direction === DIRECTION_PREV;
            var activeIndex = this._getItemIndex(activeElement);
            var lastItemIndex = this._items.length - 1;
            var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;
            if (isGoingToWrap && !this._config.wrap) return activeElement;
            var delta = direction === DIRECTION_PREV ? -1 : 1;
            var itemIndex = (activeIndex + delta) % this._items.length;
            return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
        };
        _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
            var targetIndex = this._getItemIndex(relatedTarget);
            var fromIndex = this._getItemIndex(this._element.querySelector(SELECTOR_ACTIVE_ITEM));
            var slideEvent = $__default["default"].Event(EVENT_SLIDE, {
                relatedTarget: relatedTarget,
                direction: eventDirectionName,
                from: fromIndex,
                to: targetIndex
            });
            $__default["default"](this._element).trigger(slideEvent);
            return slideEvent;
        };
        _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
            if (this._indicatorsElement) {
                var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(SELECTOR_ACTIVE$1));
                $__default["default"](indicators).removeClass(CLASS_NAME_ACTIVE$1);
                var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];
                if (nextIndicator) $__default["default"](nextIndicator).addClass(CLASS_NAME_ACTIVE$1);
            }
        };
        _proto._updateInterval = function _updateInterval() {
            var element = this._activeElement || this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            if (!element) return;
            var elementInterval = parseInt(element.getAttribute("data-interval"), 10);
            if (elementInterval) {
                this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
                this._config.interval = elementInterval;
            } else this._config.interval = this._config.defaultInterval || this._config.interval;
        };
        _proto._slide = function _slide(direction, element) {
            var _this4 = this;
            var activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            var activeElementIndex = this._getItemIndex(activeElement);
            var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);
            var nextElementIndex = this._getItemIndex(nextElement);
            var isCycling = Boolean(this._interval);
            var directionalClassName;
            var orderClassName;
            var eventDirectionName;
            if (direction === DIRECTION_NEXT) {
                directionalClassName = CLASS_NAME_LEFT;
                orderClassName = CLASS_NAME_NEXT;
                eventDirectionName = DIRECTION_LEFT;
            } else {
                directionalClassName = CLASS_NAME_RIGHT;
                orderClassName = CLASS_NAME_PREV;
                eventDirectionName = DIRECTION_RIGHT;
            }
            if (nextElement && $__default["default"](nextElement).hasClass(CLASS_NAME_ACTIVE$1)) {
                this._isSliding = false;
                return;
            }
            var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);
            if (slideEvent.isDefaultPrevented()) return;
            if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
            return;
            this._isSliding = true;
            if (isCycling) this.pause();
            this._setActiveIndicatorElement(nextElement);
            this._activeElement = nextElement;
            var slidEvent = $__default["default"].Event(EVENT_SLID, {
                relatedTarget: nextElement,
                direction: eventDirectionName,
                from: activeElementIndex,
                to: nextElementIndex
            });
            if ($__default["default"](this._element).hasClass(CLASS_NAME_SLIDE)) {
                $__default["default"](nextElement).addClass(orderClassName);
                Util.reflow(nextElement);
                $__default["default"](activeElement).addClass(directionalClassName);
                $__default["default"](nextElement).addClass(directionalClassName);
                var transitionDuration = Util.getTransitionDurationFromElement(activeElement);
                $__default["default"](activeElement).one(Util.TRANSITION_END, function() {
                    $__default["default"](nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(CLASS_NAME_ACTIVE$1);
                    $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$1 + " " + orderClassName + " " + directionalClassName);
                    _this4._isSliding = false;
                    setTimeout(function() {
                        return $__default["default"](_this4._element).trigger(slidEvent);
                    }, 0);
                }).emulateTransitionEnd(transitionDuration);
            } else {
                $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$1);
                $__default["default"](nextElement).addClass(CLASS_NAME_ACTIVE$1);
                this._isSliding = false;
                $__default["default"](this._element).trigger(slidEvent);
            }
            if (isCycling) this.cycle();
        } // Static
        ;
        Carousel._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$2);
                var _config = _extends({}, Default, $__default["default"](this).data());
                if (typeof config === "object") _config = _extends({}, _config, config);
                var action = typeof config === "string" ? config : _config.slide;
                if (!data) {
                    data = new Carousel(this, _config);
                    $__default["default"](this).data(DATA_KEY$2, data);
                }
                if (typeof config === "number") data.to(config);
                else if (typeof action === "string") {
                    if (typeof data[action] === "undefined") throw new TypeError('No method named "' + action + '"');
                    data[action]();
                } else if (_config.interval && _config.ride) {
                    data.pause();
                    data.cycle();
                }
            });
        };
        Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
            var selector = Util.getSelectorFromElement(this);
            if (!selector) return;
            var target = $__default["default"](selector)[0];
            if (!target || !$__default["default"](target).hasClass(CLASS_NAME_CAROUSEL)) return;
            var config = _extends({}, $__default["default"](target).data(), $__default["default"](this).data());
            var slideIndex = this.getAttribute("data-slide-to");
            if (slideIndex) config.interval = false;
            Carousel._jQueryInterface.call($__default["default"](target), config);
            if (slideIndex) $__default["default"](target).data(DATA_KEY$2).to(slideIndex);
            event.preventDefault();
        };
        _createClass(Carousel, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$2;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default;
                }
            }
        ]);
        return Carousel;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$2, SELECTOR_DATA_SLIDE, Carousel._dataApiClickHandler);
    $__default["default"](window).on(EVENT_LOAD_DATA_API$1, function() {
        var carousels = [].slice.call(document.querySelectorAll(SELECTOR_DATA_RIDE));
        for(var i = 0, len = carousels.length; i < len; i++){
            var $carousel = $__default["default"](carousels[i]);
            Carousel._jQueryInterface.call($carousel, $carousel.data());
        }
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$2] = Carousel._jQueryInterface;
    $__default["default"].fn[NAME$2].Constructor = Carousel;
    $__default["default"].fn[NAME$2].noConflict = function() {
        $__default["default"].fn[NAME$2] = JQUERY_NO_CONFLICT$2;
        return Carousel._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$3 = "collapse";
    var VERSION$3 = "4.6.0";
    var DATA_KEY$3 = "bs.collapse";
    var EVENT_KEY$3 = "." + DATA_KEY$3;
    var DATA_API_KEY$3 = ".data-api";
    var JQUERY_NO_CONFLICT$3 = $__default["default"].fn[NAME$3];
    var Default$1 = {
        toggle: true,
        parent: ""
    };
    var DefaultType$1 = {
        toggle: "boolean",
        parent: "(string|element)"
    };
    var EVENT_SHOW = "show" + EVENT_KEY$3;
    var EVENT_SHOWN = "shown" + EVENT_KEY$3;
    var EVENT_HIDE = "hide" + EVENT_KEY$3;
    var EVENT_HIDDEN = "hidden" + EVENT_KEY$3;
    var EVENT_CLICK_DATA_API$3 = "click" + EVENT_KEY$3 + DATA_API_KEY$3;
    var CLASS_NAME_SHOW$1 = "show";
    var CLASS_NAME_COLLAPSE = "collapse";
    var CLASS_NAME_COLLAPSING = "collapsing";
    var CLASS_NAME_COLLAPSED = "collapsed";
    var DIMENSION_WIDTH = "width";
    var DIMENSION_HEIGHT = "height";
    var SELECTOR_ACTIVES = ".show, .collapsing";
    var SELECTOR_DATA_TOGGLE$1 = '[data-toggle="collapse"]';
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Collapse = /*#__PURE__*/ function() {
        function Collapse(element, config) {
            this._isTransitioning = false;
            this._element = element;
            this._config = this._getConfig(config);
            this._triggerArray = [].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#' + element.id + '"],' + ('[data-toggle="collapse"][data-target="#' + element.id + '"]')));
            var toggleList = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$1));
            for(var i = 0, len = toggleList.length; i < len; i++){
                var elem = toggleList[i];
                var selector = Util.getSelectorFromElement(elem);
                var filterElement = [].slice.call(document.querySelectorAll(selector)).filter(function(foundElem) {
                    return foundElem === element;
                });
                if (selector !== null && filterElement.length > 0) {
                    this._selector = selector;
                    this._triggerArray.push(elem);
                }
            }
            this._parent = this._config.parent ? this._getParent() : null;
            if (!this._config.parent) this._addAriaAndCollapsedClass(this._element, this._triggerArray);
            if (this._config.toggle) this.toggle();
        } // Getters
        var _proto = Collapse.prototype;
        // Public
        _proto.toggle = function toggle() {
            if ($__default["default"](this._element).hasClass(CLASS_NAME_SHOW$1)) this.hide();
            else this.show();
        };
        _proto.show = function show() {
            var _this = this;
            if (this._isTransitioning || $__default["default"](this._element).hasClass(CLASS_NAME_SHOW$1)) return;
            var actives;
            var activesData;
            if (this._parent) {
                actives = [].slice.call(this._parent.querySelectorAll(SELECTOR_ACTIVES)).filter(function(elem) {
                    if (typeof _this._config.parent === "string") return elem.getAttribute("data-parent") === _this._config.parent;
                    return elem.classList.contains(CLASS_NAME_COLLAPSE);
                });
                if (actives.length === 0) actives = null;
            }
            if (actives) {
                activesData = $__default["default"](actives).not(this._selector).data(DATA_KEY$3);
                if (activesData && activesData._isTransitioning) return;
            }
            var startEvent = $__default["default"].Event(EVENT_SHOW);
            $__default["default"](this._element).trigger(startEvent);
            if (startEvent.isDefaultPrevented()) return;
            if (actives) {
                Collapse._jQueryInterface.call($__default["default"](actives).not(this._selector), "hide");
                if (!activesData) $__default["default"](actives).data(DATA_KEY$3, null);
            }
            var dimension = this._getDimension();
            $__default["default"](this._element).removeClass(CLASS_NAME_COLLAPSE).addClass(CLASS_NAME_COLLAPSING);
            this._element.style[dimension] = 0;
            if (this._triggerArray.length) $__default["default"](this._triggerArray).removeClass(CLASS_NAME_COLLAPSED).attr("aria-expanded", true);
            this.setTransitioning(true);
            var complete = function complete() {
                $__default["default"](_this._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$1);
                _this._element.style[dimension] = "";
                _this.setTransitioning(false);
                $__default["default"](_this._element).trigger(EVENT_SHOWN);
            };
            var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
            var scrollSize = "scroll" + capitalizedDimension;
            var transitionDuration = Util.getTransitionDurationFromElement(this._element);
            $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            this._element.style[dimension] = this._element[scrollSize] + "px";
        };
        _proto.hide = function hide() {
            var _this2 = this;
            if (this._isTransitioning || !$__default["default"](this._element).hasClass(CLASS_NAME_SHOW$1)) return;
            var startEvent = $__default["default"].Event(EVENT_HIDE);
            $__default["default"](this._element).trigger(startEvent);
            if (startEvent.isDefaultPrevented()) return;
            var dimension = this._getDimension();
            this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
            Util.reflow(this._element);
            $__default["default"](this._element).addClass(CLASS_NAME_COLLAPSING).removeClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$1);
            var triggerArrayLength = this._triggerArray.length;
            if (triggerArrayLength > 0) for(var i = 0; i < triggerArrayLength; i++){
                var trigger = this._triggerArray[i];
                var selector = Util.getSelectorFromElement(trigger);
                if (selector !== null) {
                    var $elem = $__default["default"]([].slice.call(document.querySelectorAll(selector)));
                    if (!$elem.hasClass(CLASS_NAME_SHOW$1)) $__default["default"](trigger).addClass(CLASS_NAME_COLLAPSED).attr("aria-expanded", false);
                }
            }
            this.setTransitioning(true);
            var complete = function complete() {
                _this2.setTransitioning(false);
                $__default["default"](_this2._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE).trigger(EVENT_HIDDEN);
            };
            this._element.style[dimension] = "";
            var transitionDuration = Util.getTransitionDurationFromElement(this._element);
            $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        };
        _proto.setTransitioning = function setTransitioning(isTransitioning) {
            this._isTransitioning = isTransitioning;
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$3);
            this._config = null;
            this._parent = null;
            this._element = null;
            this._triggerArray = null;
            this._isTransitioning = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$1, config);
            config.toggle = Boolean(config.toggle); // Coerce string values
            Util.typeCheckConfig(NAME$3, config, DefaultType$1);
            return config;
        };
        _proto._getDimension = function _getDimension() {
            var hasWidth = $__default["default"](this._element).hasClass(DIMENSION_WIDTH);
            return hasWidth ? DIMENSION_WIDTH : DIMENSION_HEIGHT;
        };
        _proto._getParent = function _getParent() {
            var _this3 = this;
            var parent;
            if (Util.isElement(this._config.parent)) {
                parent = this._config.parent; // It's a jQuery object
                if (typeof this._config.parent.jquery !== "undefined") parent = this._config.parent[0];
            } else parent = document.querySelector(this._config.parent);
            var selector = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]';
            var children = [].slice.call(parent.querySelectorAll(selector));
            $__default["default"](children).each(function(i, element) {
                _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [
                    element
                ]);
            });
            return parent;
        };
        _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
            var isOpen = $__default["default"](element).hasClass(CLASS_NAME_SHOW$1);
            if (triggerArray.length) $__default["default"](triggerArray).toggleClass(CLASS_NAME_COLLAPSED, !isOpen).attr("aria-expanded", isOpen);
        } // Static
        ;
        Collapse._getTargetFromElement = function _getTargetFromElement(element) {
            var selector = Util.getSelectorFromElement(element);
            return selector ? document.querySelector(selector) : null;
        };
        Collapse._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$3);
                var _config = _extends({}, Default$1, $element.data(), typeof config === "object" && config ? config : {});
                if (!data && _config.toggle && typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
                if (!data) {
                    data = new Collapse(this, _config);
                    $element.data(DATA_KEY$3, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Collapse, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$3;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$1;
                }
            }
        ]);
        return Collapse;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$1, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.currentTarget.tagName === "A") event.preventDefault();
        var $trigger = $__default["default"](this);
        var selector = Util.getSelectorFromElement(this);
        var selectors = [].slice.call(document.querySelectorAll(selector));
        $__default["default"](selectors).each(function() {
            var $target = $__default["default"](this);
            var data = $target.data(DATA_KEY$3);
            var config = data ? "toggle" : $trigger.data();
            Collapse._jQueryInterface.call($target, config);
        });
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$3] = Collapse._jQueryInterface;
    $__default["default"].fn[NAME$3].Constructor = Collapse;
    $__default["default"].fn[NAME$3].noConflict = function() {
        $__default["default"].fn[NAME$3] = JQUERY_NO_CONFLICT$3;
        return Collapse._jQueryInterface;
    };
    /**!
   * @fileOverview Kickass library to create and place poppers near their reference elements.
   * @version 1.16.1
   * @license
   * Copyright (c) 2016 Federico Zivolo and contributors
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   */ var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && typeof navigator !== "undefined";
    var timeoutDuration = function() {
        var longerTimeoutBrowsers = [
            "Edge",
            "Trident",
            "Firefox"
        ];
        for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
            if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
        }
        return 0;
    }();
    function microtaskDebounce(fn) {
        var called = false;
        return function() {
            if (called) return;
            called = true;
            window.Promise.resolve().then(function() {
                called = false;
                fn();
            });
        };
    }
    function taskDebounce(fn) {
        var scheduled = false;
        return function() {
            if (!scheduled) {
                scheduled = true;
                setTimeout(function() {
                    scheduled = false;
                    fn();
                }, timeoutDuration);
            }
        };
    }
    var supportsMicroTasks = isBrowser && window.Promise;
    /**
  * Create a debounced version of a method, that's asynchronously deferred
  * but called in the minimum time possible.
  *
  * @method
  * @memberof Popper.Utils
  * @argument {Function} fn
  * @returns {Function}
  */ var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
    /**
   * Check if the given variable is a function
   * @method
   * @memberof Popper.Utils
   * @argument {Any} functionToCheck - variable to check
   * @returns {Boolean} answer to: is a function?
   */ function isFunction(functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
    }
    /**
   * Get CSS computed property of the given element
   * @method
   * @memberof Popper.Utils
   * @argument {Eement} element
   * @argument {String} property
   */ function getStyleComputedProperty(element, property) {
        if (element.nodeType !== 1) return [];
        // NOTE: 1 DOM access here
        var window1 = element.ownerDocument.defaultView;
        var css = window1.getComputedStyle(element, null);
        return property ? css[property] : css;
    }
    /**
   * Returns the parentNode or the host of the element
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Element} parent
   */ function getParentNode(element) {
        if (element.nodeName === "HTML") return element;
        return element.parentNode || element.host;
    }
    /**
   * Returns the scrolling parent of the given element
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Element} scroll parent
   */ function getScrollParent(element) {
        // Return body, `getScroll` will take care to get the correct `scrollTop` from it
        if (!element) return document.body;
        switch(element.nodeName){
            case "HTML":
            case "BODY":
                return element.ownerDocument.body;
            case "#document":
                return element.body;
        }
        // Firefox want us to check `-x` and `-y` variations as well
        var _getStyleComputedProp = getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
        if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
        return getScrollParent(getParentNode(element));
    }
    /**
   * Returns the reference node of the reference object, or the reference object itself.
   * @method
   * @memberof Popper.Utils
   * @param {Element|Object} reference - the reference element (the popper will be relative to this)
   * @returns {Element} parent
   */ function getReferenceNode(reference) {
        return reference && reference.referenceNode ? reference.referenceNode : reference;
    }
    var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
    var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
    /**
   * Determines if the browser is Internet Explorer
   * @method
   * @memberof Popper.Utils
   * @param {Number} version to check
   * @returns {Boolean} isIE
   */ function isIE(version) {
        if (version === 11) return isIE11;
        if (version === 10) return isIE10;
        return isIE11 || isIE10;
    }
    /**
   * Returns the offset parent of the given element
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Element} offset parent
   */ function getOffsetParent(element) {
        if (!element) return document.documentElement;
        var noOffsetParent = isIE(10) ? document.body : null;
        // NOTE: 1 DOM access here
        var offsetParent = element.offsetParent || null;
        // Skip hidden elements which don't have an offsetParent
        while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
        var nodeName = offsetParent && offsetParent.nodeName;
        if (!nodeName || nodeName === "BODY" || nodeName === "HTML") return element ? element.ownerDocument.documentElement : document.documentElement;
        // .offsetParent will return the closest TH, TD or TABLE in case
        // no offsetParent is present, I hate this job...
        if ([
            "TH",
            "TD",
            "TABLE"
        ].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, "position") === "static") return getOffsetParent(offsetParent);
        return offsetParent;
    }
    function isOffsetContainer(element) {
        var nodeName = element.nodeName;
        if (nodeName === "BODY") return false;
        return nodeName === "HTML" || getOffsetParent(element.firstElementChild) === element;
    }
    /**
   * Finds the root node (document, shadowDOM root) of the given element
   * @method
   * @memberof Popper.Utils
   * @argument {Element} node
   * @returns {Element} root node
   */ function getRoot(node) {
        if (node.parentNode !== null) return getRoot(node.parentNode);
        return node;
    }
    /**
   * Finds the offset parent common to the two provided nodes
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element1
   * @argument {Element} element2
   * @returns {Element} common offset parent
   */ function findCommonOffsetParent(element1, element2) {
        // This check is needed to avoid errors in case one of the elements isn't defined for any reason
        if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
        // Here we make sure to give as "start" the element that comes first in the DOM
        var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
        var start = order ? element1 : element2;
        var end = order ? element2 : element1;
        // Get common ancestor container
        var range = document.createRange();
        range.setStart(start, 0);
        range.setEnd(end, 0);
        var commonAncestorContainer = range.commonAncestorContainer;
        // Both nodes are inside #document
        if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
            if (isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
            return getOffsetParent(commonAncestorContainer);
        }
        // one of the nodes is inside shadowDOM, find which one
        var element1root = getRoot(element1);
        if (element1root.host) return findCommonOffsetParent(element1root.host, element2);
        else return findCommonOffsetParent(element1, getRoot(element2).host);
    }
    /**
   * Gets the scroll value of the given element in the given side (top and left)
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @argument {String} side `top` or `left`
   * @returns {number} amount of scrolled pixels
   */ function getScroll(element) {
        var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "top";
        var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
        var nodeName = element.nodeName;
        if (nodeName === "BODY" || nodeName === "HTML") {
            var html = element.ownerDocument.documentElement;
            var scrollingElement = element.ownerDocument.scrollingElement || html;
            return scrollingElement[upperSide];
        }
        return element[upperSide];
    }
    /*
   * Sum or subtract the element scroll values (left and top) from a given rect object
   * @method
   * @memberof Popper.Utils
   * @param {Object} rect - Rect object you want to change
   * @param {HTMLElement} element - The element from the function reads the scroll values
   * @param {Boolean} subtract - set to true if you want to subtract the scroll values
   * @return {Object} rect - The modifier rect object
   */ function includeScroll(rect, element) {
        var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var scrollTop = getScroll(element, "top");
        var scrollLeft = getScroll(element, "left");
        var modifier = subtract ? -1 : 1;
        rect.top += scrollTop * modifier;
        rect.bottom += scrollTop * modifier;
        rect.left += scrollLeft * modifier;
        rect.right += scrollLeft * modifier;
        return rect;
    }
    /*
   * Helper to detect borders of a given element
   * @method
   * @memberof Popper.Utils
   * @param {CSSStyleDeclaration} styles
   * Result of `getStyleComputedProperty` on the given element
   * @param {String} axis - `x` or `y`
   * @return {number} borders - The borders size of the given axis
   */ function getBordersSize(styles, axis) {
        var sideA = axis === "x" ? "Left" : "Top";
        var sideB = sideA === "Left" ? "Right" : "Bottom";
        return parseFloat(styles["border" + sideA + "Width"]) + parseFloat(styles["border" + sideB + "Width"]);
    }
    function getSize(axis, body, html, computedStyle) {
        return Math.max(body["offset" + axis], body["scroll" + axis], html["client" + axis], html["offset" + axis], html["scroll" + axis], isIE(10) ? parseInt(html["offset" + axis]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Top" : "Left")]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Bottom" : "Right")]) : 0);
    }
    function getWindowSizes(document1) {
        var body = document1.body;
        var html = document1.documentElement;
        var computedStyle = isIE(10) && getComputedStyle(html);
        return {
            height: getSize("Height", body, html, computedStyle),
            width: getSize("Width", body, html, computedStyle)
        };
    }
    var classCallCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var defineProperty = function(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    };
    var _extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    /**
   * Given element offsets, generate an output similar to getBoundingClientRect
   * @method
   * @memberof Popper.Utils
   * @argument {Object} offsets
   * @returns {Object} ClientRect like output
   */ function getClientRect(offsets) {
        return _extends$1({}, offsets, {
            right: offsets.left + offsets.width,
            bottom: offsets.top + offsets.height
        });
    }
    /**
   * Get bounding client rect of given element
   * @method
   * @memberof Popper.Utils
   * @param {HTMLElement} element
   * @return {Object} client rect
   */ function getBoundingClientRect(element) {
        var rect = {};
        // IE10 10 FIX: Please, don't ask, the element isn't
        // considered in DOM in some circumstances...
        // This isn't reproducible in IE10 compatibility mode of IE11
        try {
            if (isIE(10)) {
                rect = element.getBoundingClientRect();
                var scrollTop = getScroll(element, "top");
                var scrollLeft = getScroll(element, "left");
                rect.top += scrollTop;
                rect.left += scrollLeft;
                rect.bottom += scrollTop;
                rect.right += scrollLeft;
            } else rect = element.getBoundingClientRect();
        } catch (e) {}
        var result = {
            left: rect.left,
            top: rect.top,
            width: rect.right - rect.left,
            height: rect.bottom - rect.top
        };
        // subtract scrollbar size from sizes
        var sizes = element.nodeName === "HTML" ? getWindowSizes(element.ownerDocument) : {};
        var width = sizes.width || element.clientWidth || result.width;
        var height = sizes.height || element.clientHeight || result.height;
        var horizScrollbar = element.offsetWidth - width;
        var vertScrollbar = element.offsetHeight - height;
        // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
        // we make this check conditional for performance reasons
        if (horizScrollbar || vertScrollbar) {
            var styles = getStyleComputedProperty(element);
            horizScrollbar -= getBordersSize(styles, "x");
            vertScrollbar -= getBordersSize(styles, "y");
            result.width -= horizScrollbar;
            result.height -= vertScrollbar;
        }
        return getClientRect(result);
    }
    function getOffsetRectRelativeToArbitraryNode(children, parent) {
        var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isIE10 = isIE(10);
        var isHTML = parent.nodeName === "HTML";
        var childrenRect = getBoundingClientRect(children);
        var parentRect = getBoundingClientRect(parent);
        var scrollParent = getScrollParent(children);
        var styles = getStyleComputedProperty(parent);
        var borderTopWidth = parseFloat(styles.borderTopWidth);
        var borderLeftWidth = parseFloat(styles.borderLeftWidth);
        // In cases where the parent is fixed, we must ignore negative scroll in offset calc
        if (fixedPosition && isHTML) {
            parentRect.top = Math.max(parentRect.top, 0);
            parentRect.left = Math.max(parentRect.left, 0);
        }
        var offsets = getClientRect({
            top: childrenRect.top - parentRect.top - borderTopWidth,
            left: childrenRect.left - parentRect.left - borderLeftWidth,
            width: childrenRect.width,
            height: childrenRect.height
        });
        offsets.marginTop = 0;
        offsets.marginLeft = 0;
        // Subtract margins of documentElement in case it's being used as parent
        // we do this only on HTML because it's the only element that behaves
        // differently when margins are applied to it. The margins are included in
        // the box of the documentElement, in the other cases not.
        if (!isIE10 && isHTML) {
            var marginTop = parseFloat(styles.marginTop);
            var marginLeft = parseFloat(styles.marginLeft);
            offsets.top -= borderTopWidth - marginTop;
            offsets.bottom -= borderTopWidth - marginTop;
            offsets.left -= borderLeftWidth - marginLeft;
            offsets.right -= borderLeftWidth - marginLeft;
            // Attach marginTop and marginLeft because in some circumstances we may need them
            offsets.marginTop = marginTop;
            offsets.marginLeft = marginLeft;
        }
        if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== "BODY") offsets = includeScroll(offsets, parent);
        return offsets;
    }
    function getViewportOffsetRectRelativeToArtbitraryNode(element) {
        var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var html = element.ownerDocument.documentElement;
        var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
        var width = Math.max(html.clientWidth, window.innerWidth || 0);
        var height = Math.max(html.clientHeight, window.innerHeight || 0);
        var scrollTop = !excludeScroll ? getScroll(html) : 0;
        var scrollLeft = !excludeScroll ? getScroll(html, "left") : 0;
        var offset = {
            top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
            left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
            width: width,
            height: height
        };
        return getClientRect(offset);
    }
    /**
   * Check if the given element is fixed or is inside a fixed parent
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @argument {Element} customContainer
   * @returns {Boolean} answer to "isFixed?"
   */ function isFixed(element) {
        var nodeName = element.nodeName;
        if (nodeName === "BODY" || nodeName === "HTML") return false;
        if (getStyleComputedProperty(element, "position") === "fixed") return true;
        var parentNode = getParentNode(element);
        if (!parentNode) return false;
        return isFixed(parentNode);
    }
    /**
   * Finds the first parent of an element that has a transformed property defined
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Element} first transformed parent or documentElement
   */ function getFixedPositionOffsetParent(element) {
        // This check is needed to avoid errors in case one of the elements isn't defined for any reason
        if (!element || !element.parentElement || isIE()) return document.documentElement;
        var el = element.parentElement;
        while(el && getStyleComputedProperty(el, "transform") === "none")el = el.parentElement;
        return el || document.documentElement;
    }
    /**
   * Computed the boundaries limits and return them
   * @method
   * @memberof Popper.Utils
   * @param {HTMLElement} popper
   * @param {HTMLElement} reference
   * @param {number} padding
   * @param {HTMLElement} boundariesElement - Element used to define the boundaries
   * @param {Boolean} fixedPosition - Is in fixed position mode
   * @returns {Object} Coordinates of the boundaries
   */ function getBoundaries(popper, reference, padding, boundariesElement) {
        var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        // NOTE: 1 DOM access here
        var boundaries = {
            top: 0,
            left: 0
        };
        var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
        // Handle viewport case
        if (boundariesElement === "viewport") boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
        else {
            // Handle other cases based on DOM element used as boundaries
            var boundariesNode = void 0;
            if (boundariesElement === "scrollParent") {
                boundariesNode = getScrollParent(getParentNode(reference));
                if (boundariesNode.nodeName === "BODY") boundariesNode = popper.ownerDocument.documentElement;
            } else if (boundariesElement === "window") boundariesNode = popper.ownerDocument.documentElement;
            else boundariesNode = boundariesElement;
            var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
            // In case of HTML, we need a different computation
            if (boundariesNode.nodeName === "HTML" && !isFixed(offsetParent)) {
                var _getWindowSizes = getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
                boundaries.top += offsets.top - offsets.marginTop;
                boundaries.bottom = height + offsets.top;
                boundaries.left += offsets.left - offsets.marginLeft;
                boundaries.right = width + offsets.left;
            } else // for all the other DOM elements, this one is good
            boundaries = offsets;
        }
        // Add paddings
        padding = padding || 0;
        var isPaddingNumber = typeof padding === "number";
        boundaries.left += isPaddingNumber ? padding : padding.left || 0;
        boundaries.top += isPaddingNumber ? padding : padding.top || 0;
        boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
        boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
        return boundaries;
    }
    function getArea(_ref) {
        var width = _ref.width, height = _ref.height;
        return width * height;
    }
    /**
   * Utility used to transform the `auto` placement to the placement with more
   * available space.
   * @method
   * @memberof Popper.Utils
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
        var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
        if (placement.indexOf("auto") === -1) return placement;
        var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
        var rects = {
            top: {
                width: boundaries.width,
                height: refRect.top - boundaries.top
            },
            right: {
                width: boundaries.right - refRect.right,
                height: boundaries.height
            },
            bottom: {
                width: boundaries.width,
                height: boundaries.bottom - refRect.bottom
            },
            left: {
                width: refRect.left - boundaries.left,
                height: boundaries.height
            }
        };
        var sortedAreas = Object.keys(rects).map(function(key) {
            return _extends$1({
                key: key
            }, rects[key], {
                area: getArea(rects[key])
            });
        }).sort(function(a, b) {
            return b.area - a.area;
        });
        var filteredAreas = sortedAreas.filter(function(_ref2) {
            var width = _ref2.width, height = _ref2.height;
            return width >= popper.clientWidth && height >= popper.clientHeight;
        });
        var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
        var variation = placement.split("-")[1];
        return computedPlacement + (variation ? "-" + variation : "");
    }
    /**
   * Get offsets to the reference element
   * @method
   * @memberof Popper.Utils
   * @param {Object} state
   * @param {Element} popper - the popper element
   * @param {Element} reference - the reference element (the popper will be relative to this)
   * @param {Element} fixedPosition - is in fixed position mode
   * @returns {Object} An object containing the offsets which will be applied to the popper
   */ function getReferenceOffsets(state, popper, reference) {
        var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
        return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
    }
    /**
   * Get the outer sizes of the given element (offset size + margins)
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Object} object containing width and height properties
   */ function getOuterSizes(element) {
        var window1 = element.ownerDocument.defaultView;
        var styles = window1.getComputedStyle(element);
        var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
        var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
        var result = {
            width: element.offsetWidth + y,
            height: element.offsetHeight + x
        };
        return result;
    }
    /**
   * Get the opposite placement of the given one
   * @method
   * @memberof Popper.Utils
   * @argument {String} placement
   * @returns {String} flipped placement
   */ function getOppositePlacement(placement) {
        var hash = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom"
        };
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return hash[matched];
        });
    }
    /**
   * Get offsets to the popper
   * @method
   * @memberof Popper.Utils
   * @param {Object} position - CSS position the Popper will get applied
   * @param {HTMLElement} popper - the popper element
   * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
   * @param {String} placement - one of the valid placement options
   * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
   */ function getPopperOffsets(popper, referenceOffsets, placement) {
        placement = placement.split("-")[0];
        // Get popper node sizes
        var popperRect = getOuterSizes(popper);
        // Add position, width and height to our offsets object
        var popperOffsets = {
            width: popperRect.width,
            height: popperRect.height
        };
        // depending by the popper placement we have to compute its offsets slightly differently
        var isHoriz = [
            "right",
            "left"
        ].indexOf(placement) !== -1;
        var mainSide = isHoriz ? "top" : "left";
        var secondarySide = isHoriz ? "left" : "top";
        var measurement = isHoriz ? "height" : "width";
        var secondaryMeasurement = !isHoriz ? "height" : "width";
        popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
        if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
        else popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
        return popperOffsets;
    }
    /**
   * Mimics the `find` method of Array
   * @method
   * @memberof Popper.Utils
   * @argument {Array} arr
   * @argument prop
   * @argument value
   * @returns index or -1
   */ function find(arr, check) {
        // use native find if supported
        if (Array.prototype.find) return arr.find(check);
        // use `filter` to obtain the same behavior of `find`
        return arr.filter(check)[0];
    }
    /**
   * Return the index of the matching object
   * @method
   * @memberof Popper.Utils
   * @argument {Array} arr
   * @argument prop
   * @argument value
   * @returns index or -1
   */ function findIndex(arr, prop, value) {
        // use native findIndex if supported
        if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
            return cur[prop] === value;
        });
        // use `find` + `indexOf` if `findIndex` isn't supported
        var match = find(arr, function(obj) {
            return obj[prop] === value;
        });
        return arr.indexOf(match);
    }
    /**
   * Loop trough the list of modifiers and run them in order,
   * each of them will then edit the data object.
   * @method
   * @memberof Popper.Utils
   * @param {dataObject} data
   * @param {Array} modifiers
   * @param {String} ends - Optional modifier name used as stopper
   * @returns {dataObject}
   */ function runModifiers(modifiers, data, ends) {
        var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, "name", ends));
        modifiersToRun.forEach(function(modifier) {
            if (modifier["function"]) // eslint-disable-line dot-notation
            console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
            var fn = modifier["function"] || modifier.fn; // eslint-disable-line dot-notation
            if (modifier.enabled && isFunction(fn)) {
                // Add properties to offsets to make them a complete clientRect object
                // we do this before each modifier to make sure the previous one doesn't
                // mess with these values
                data.offsets.popper = getClientRect(data.offsets.popper);
                data.offsets.reference = getClientRect(data.offsets.reference);
                data = fn(data, modifier);
            }
        });
        return data;
    }
    /**
   * Updates the position of the popper, computing the new offsets and applying
   * the new style.<br />
   * Prefer `scheduleUpdate` over `update` because of performance reasons.
   * @method
   * @memberof Popper
   */ function update() {
        // if popper is destroyed, don't perform any further update
        if (this.state.isDestroyed) return;
        var data = {
            instance: this,
            styles: {},
            arrowStyles: {},
            attributes: {},
            flipped: false,
            offsets: {}
        };
        // compute reference element offsets
        data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
        // compute auto placement, store placement inside the data object,
        // modifiers will be able to edit `placement` if needed
        // and refer to originalPlacement to know the original value
        data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
        // store the computed placement inside `originalPlacement`
        data.originalPlacement = data.placement;
        data.positionFixed = this.options.positionFixed;
        // compute the popper offsets
        data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
        data.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute";
        // run the modifiers
        data = runModifiers(this.modifiers, data);
        // the first `update` will call `onCreate` callback
        // the other ones will call `onUpdate` callback
        if (!this.state.isCreated) {
            this.state.isCreated = true;
            this.options.onCreate(data);
        } else this.options.onUpdate(data);
    }
    /**
   * Helper used to know if the given modifier is enabled.
   * @method
   * @memberof Popper.Utils
   * @returns {Boolean}
   */ function isModifierEnabled(modifiers, modifierName) {
        return modifiers.some(function(_ref) {
            var name = _ref.name, enabled = _ref.enabled;
            return enabled && name === modifierName;
        });
    }
    /**
   * Get the prefixed supported property name
   * @method
   * @memberof Popper.Utils
   * @argument {String} property (camelCase)
   * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
   */ function getSupportedPropertyName(property) {
        var prefixes = [
            false,
            "ms",
            "Webkit",
            "Moz",
            "O"
        ];
        var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
        for(var i = 0; i < prefixes.length; i++){
            var prefix = prefixes[i];
            var toCheck = prefix ? "" + prefix + upperProp : property;
            if (typeof document.body.style[toCheck] !== "undefined") return toCheck;
        }
        return null;
    }
    /**
   * Destroys the popper.
   * @method
   * @memberof Popper
   */ function destroy() {
        this.state.isDestroyed = true;
        // touch DOM only if `applyStyle` modifier is enabled
        if (isModifierEnabled(this.modifiers, "applyStyle")) {
            this.popper.removeAttribute("x-placement");
            this.popper.style.position = "";
            this.popper.style.top = "";
            this.popper.style.left = "";
            this.popper.style.right = "";
            this.popper.style.bottom = "";
            this.popper.style.willChange = "";
            this.popper.style[getSupportedPropertyName("transform")] = "";
        }
        this.disableEventListeners();
        // remove the popper if user explicitly asked for the deletion on destroy
        // do not use `remove` because IE11 doesn't support it
        if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
        return this;
    }
    /**
   * Get the window associated with the element
   * @argument {Element} element
   * @returns {Window}
   */ function getWindow(element) {
        var ownerDocument = element.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView : window;
    }
    function attachToScrollParents(scrollParent, event, callback, scrollParents) {
        var isBody = scrollParent.nodeName === "BODY";
        var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
        target.addEventListener(event, callback, {
            passive: true
        });
        if (!isBody) attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
        scrollParents.push(target);
    }
    /**
   * Setup needed event listeners used to update the popper position
   * @method
   * @memberof Popper.Utils
   * @private
   */ function setupEventListeners(reference, options, state, updateBound) {
        // Resize event listener on window
        state.updateBound = updateBound;
        getWindow(reference).addEventListener("resize", state.updateBound, {
            passive: true
        });
        // Scroll event listener on scroll parents
        var scrollElement = getScrollParent(reference);
        attachToScrollParents(scrollElement, "scroll", state.updateBound, state.scrollParents);
        state.scrollElement = scrollElement;
        state.eventsEnabled = true;
        return state;
    }
    /**
   * It will add resize/scroll events and start recalculating
   * position of the popper element when they are triggered.
   * @method
   * @memberof Popper
   */ function enableEventListeners() {
        if (!this.state.eventsEnabled) this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
    }
    /**
   * Remove event listeners used to update the popper position
   * @method
   * @memberof Popper.Utils
   * @private
   */ function removeEventListeners(reference, state) {
        // Remove resize event listener on window
        getWindow(reference).removeEventListener("resize", state.updateBound);
        // Remove scroll event listener on scroll parents
        state.scrollParents.forEach(function(target) {
            target.removeEventListener("scroll", state.updateBound);
        });
        // Reset state
        state.updateBound = null;
        state.scrollParents = [];
        state.scrollElement = null;
        state.eventsEnabled = false;
        return state;
    }
    /**
   * It will remove resize/scroll events and won't recalculate popper position
   * when they are triggered. It also won't trigger `onUpdate` callback anymore,
   * unless you call `update` method manually.
   * @method
   * @memberof Popper
   */ function disableEventListeners() {
        if (this.state.eventsEnabled) {
            cancelAnimationFrame(this.scheduleUpdate);
            this.state = removeEventListeners(this.reference, this.state);
        }
    }
    /**
   * Tells if a given input is a number
   * @method
   * @memberof Popper.Utils
   * @param {*} input to check
   * @return {Boolean}
   */ function isNumeric(n) {
        return n !== "" && !isNaN(parseFloat(n)) && isFinite(n);
    }
    /**
   * Set the style to the given popper
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element - Element to apply the style to
   * @argument {Object} styles
   * Object with a list of properties and values which will be applied to the element
   */ function setStyles(element, styles) {
        Object.keys(styles).forEach(function(prop) {
            var unit = "";
            // add unit if the value is numeric and is one of the following
            if ([
                "width",
                "height",
                "top",
                "right",
                "bottom",
                "left"
            ].indexOf(prop) !== -1 && isNumeric(styles[prop])) unit = "px";
            element.style[prop] = styles[prop] + unit;
        });
    }
    /**
   * Set the attributes to the given popper
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element - Element to apply the attributes to
   * @argument {Object} styles
   * Object with a list of properties and values which will be applied to the element
   */ function setAttributes(element, attributes) {
        Object.keys(attributes).forEach(function(prop) {
            var value = attributes[prop];
            if (value !== false) element.setAttribute(prop, attributes[prop]);
            else element.removeAttribute(prop);
        });
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} data.styles - List of style properties - values to apply to popper element
   * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The same data object
   */ function applyStyle(data) {
        // any property present in `data.styles` will be applied to the popper,
        // in this way we can make the 3rd party modifiers add custom styles to it
        // Be aware, modifiers could override the properties defined in the previous
        // lines of this modifier!
        setStyles(data.instance.popper, data.styles);
        // any property present in `data.attributes` will be applied to the popper,
        // they will be set as HTML attributes of the element
        setAttributes(data.instance.popper, data.attributes);
        // if arrowElement is defined and arrowStyles has some properties
        if (data.arrowElement && Object.keys(data.arrowStyles).length) setStyles(data.arrowElement, data.arrowStyles);
        return data;
    }
    /**
   * Set the x-placement attribute before everything else because it could be used
   * to add margins to the popper margins needs to be calculated to get the
   * correct popper offsets.
   * @method
   * @memberof Popper.modifiers
   * @param {HTMLElement} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper
   * @param {Object} options - Popper.js options
   */ function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
        // compute reference element offsets
        var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
        // compute auto placement, store placement inside the data object,
        // modifiers will be able to edit `placement` if needed
        // and refer to originalPlacement to know the original value
        var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
        popper.setAttribute("x-placement", placement);
        // Apply `position` to popper before anything else because
        // without the position applied we can't guarantee correct computations
        setStyles(popper, {
            position: options.positionFixed ? "fixed" : "absolute"
        });
        return options;
    }
    /**
   * @function
   * @memberof Popper.Utils
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Boolean} shouldRound - If the offsets should be rounded at all
   * @returns {Object} The popper's position offsets rounded
   *
   * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
   * good as it can be within reason.
   * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
   *
   * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
   * as well on High DPI screens).
   *
   * Firefox prefers no rounding for positioning and does not have blurriness on
   * high DPI screens.
   *
   * Only horizontal placement and left/right values need to be considered.
   */ function getRoundedOffsets(data, shouldRound) {
        var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var round = Math.round, floor = Math.floor;
        var noRound = function noRound(v) {
            return v;
        };
        var referenceWidth = round(reference.width);
        var popperWidth = round(popper.width);
        var isVertical = [
            "left",
            "right"
        ].indexOf(data.placement) !== -1;
        var isVariation = data.placement.indexOf("-") !== -1;
        var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
        var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
        var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
        var verticalToInteger = !shouldRound ? noRound : round;
        return {
            left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
            top: verticalToInteger(popper.top),
            bottom: verticalToInteger(popper.bottom),
            right: horizontalToInteger(popper.right)
        };
    }
    var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function computeStyle(data, options) {
        var x = options.x, y = options.y;
        var popper = data.offsets.popper;
        // Remove this legacy support in Popper.js v2
        var legacyGpuAccelerationOption = find(data.instance.modifiers, function(modifier) {
            return modifier.name === "applyStyle";
        }).gpuAcceleration;
        if (legacyGpuAccelerationOption !== undefined) console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
        var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
        var offsetParent = getOffsetParent(data.instance.popper);
        var offsetParentRect = getBoundingClientRect(offsetParent);
        // Styles
        var styles = {
            position: popper.position
        };
        var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
        var sideA = x === "bottom" ? "top" : "bottom";
        var sideB = y === "right" ? "left" : "right";
        // if gpuAcceleration is set to `true` and transform is supported,
        //  we use `translate3d` to apply the position to the popper we
        // automatically use the supported prefixed version if needed
        var prefixedProperty = getSupportedPropertyName("transform");
        // now, let's make a step back and look at this code closely (wtf?)
        // If the content of the popper grows once it's been positioned, it
        // may happen that the popper gets misplaced because of the new content
        // overflowing its reference element
        // To avoid this problem, we provide two options (x and y), which allow
        // the consumer to define the offset origin.
        // If we position a popper on top of a reference element, we can set
        // `x` to `top` to make the popper grow towards its top instead of
        // its bottom.
        var left = void 0, top = void 0;
        if (sideA === "bottom") {
            // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
            // and not the bottom of the html element
            if (offsetParent.nodeName === "HTML") top = -offsetParent.clientHeight + offsets.bottom;
            else top = -offsetParentRect.height + offsets.bottom;
        } else top = offsets.top;
        if (sideB === "right") {
            if (offsetParent.nodeName === "HTML") left = -offsetParent.clientWidth + offsets.right;
            else left = -offsetParentRect.width + offsets.right;
        } else left = offsets.left;
        if (gpuAcceleration && prefixedProperty) {
            styles[prefixedProperty] = "translate3d(" + left + "px, " + top + "px, 0)";
            styles[sideA] = 0;
            styles[sideB] = 0;
            styles.willChange = "transform";
        } else {
            // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
            var invertTop = sideA === "bottom" ? -1 : 1;
            var invertLeft = sideB === "right" ? -1 : 1;
            styles[sideA] = top * invertTop;
            styles[sideB] = left * invertLeft;
            styles.willChange = sideA + ", " + sideB;
        }
        // Attributes
        var attributes = {
            "x-placement": data.placement
        };
        // Update `data` attributes, styles and arrowStyles
        data.attributes = _extends$1({}, attributes, data.attributes);
        data.styles = _extends$1({}, styles, data.styles);
        data.arrowStyles = _extends$1({}, data.offsets.arrow, data.arrowStyles);
        return data;
    }
    /**
   * Helper used to know if the given modifier depends from another one.<br />
   * It checks if the needed modifier is listed and enabled.
   * @method
   * @memberof Popper.Utils
   * @param {Array} modifiers - list of modifiers
   * @param {String} requestingName - name of requesting modifier
   * @param {String} requestedName - name of requested modifier
   * @returns {Boolean}
   */ function isModifierRequired(modifiers, requestingName, requestedName) {
        var requesting = find(modifiers, function(_ref) {
            var name = _ref.name;
            return name === requestingName;
        });
        var isRequired = !!requesting && modifiers.some(function(modifier) {
            return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
        });
        if (!isRequired) {
            var _requesting = "`" + requestingName + "`";
            var requested = "`" + requestedName + "`";
            console.warn(requested + " modifier is required by " + _requesting + " modifier in order to work, be sure to include it before " + _requesting + "!");
        }
        return isRequired;
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function arrow(data, options) {
        var _data$offsets$arrow;
        // arrow depends on keepTogether in order to work
        if (!isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) return data;
        var arrowElement = options.element;
        // if arrowElement is a string, suppose it's a CSS selector
        if (typeof arrowElement === "string") {
            arrowElement = data.instance.popper.querySelector(arrowElement);
            // if arrowElement is not found, don't run the modifier
            if (!arrowElement) return data;
        } else // if the arrowElement isn't a query selector we must check that the
        // provided DOM node is child of its popper node
        if (!data.instance.popper.contains(arrowElement)) {
            console.warn("WARNING: `arrow.element` must be child of its popper element!");
            return data;
        }
        var placement = data.placement.split("-")[0];
        var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var isVertical = [
            "left",
            "right"
        ].indexOf(placement) !== -1;
        var len = isVertical ? "height" : "width";
        var sideCapitalized = isVertical ? "Top" : "Left";
        var side = sideCapitalized.toLowerCase();
        var altSide = isVertical ? "left" : "top";
        var opSide = isVertical ? "bottom" : "right";
        var arrowElementSize = getOuterSizes(arrowElement)[len];
        //
        // extends keepTogether behavior making sure the popper and its
        // reference have enough pixels in conjunction
        //
        // top/left side
        if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
        // bottom/right side
        if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
        data.offsets.popper = getClientRect(data.offsets.popper);
        // compute center of the popper
        var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
        // Compute the sideValue using the updated popper offsets
        // take popper margin in account because we don't have this info available
        var css = getStyleComputedProperty(data.instance.popper);
        var popperMarginSide = parseFloat(css["margin" + sideCapitalized]);
        var popperBorderSide = parseFloat(css["border" + sideCapitalized + "Width"]);
        var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
        // prevent arrowElement from being placed not contiguously to its popper
        sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
        data.arrowElement = arrowElement;
        data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ""), _data$offsets$arrow);
        return data;
    }
    /**
   * Get the opposite placement variation of the given one
   * @method
   * @memberof Popper.Utils
   * @argument {String} placement variation
   * @returns {String} flipped placement variation
   */ function getOppositeVariation(variation) {
        if (variation === "end") return "start";
        else if (variation === "start") return "end";
        return variation;
    }
    /**
   * List of accepted placements to use as values of the `placement` option.<br />
   * Valid placements are:
   * - `auto`
   * - `top`
   * - `right`
   * - `bottom`
   * - `left`
   *
   * Each placement can have a variation from this list:
   * - `-start`
   * - `-end`
   *
   * Variations are interpreted easily if you think of them as the left to right
   * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
   * is right.<br />
   * Vertically (`left` and `right`), `start` is top and `end` is bottom.
   *
   * Some valid examples are:
   * - `top-end` (on top of reference, right aligned)
   * - `right-start` (on right of reference, top aligned)
   * - `bottom` (on bottom, centered)
   * - `auto-end` (on the side with more space available, alignment depends by placement)
   *
   * @static
   * @type {Array}
   * @enum {String}
   * @readonly
   * @method placements
   * @memberof Popper
   */ var placements = [
        "auto-start",
        "auto",
        "auto-end",
        "top-start",
        "top",
        "top-end",
        "right-start",
        "right",
        "right-end",
        "bottom-end",
        "bottom",
        "bottom-start",
        "left-end",
        "left",
        "left-start"
    ];
    // Get rid of `auto` `auto-start` and `auto-end`
    var validPlacements = placements.slice(3);
    /**
   * Given an initial placement, returns all the subsequent placements
   * clockwise (or counter-clockwise).
   *
   * @method
   * @memberof Popper.Utils
   * @argument {String} placement - A valid placement (it accepts variations)
   * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
   * @returns {Array} placements including their variations
   */ function clockwise(placement) {
        var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var index = validPlacements.indexOf(placement);
        var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
        return counter ? arr.reverse() : arr;
    }
    var BEHAVIORS = {
        FLIP: "flip",
        CLOCKWISE: "clockwise",
        COUNTERCLOCKWISE: "counterclockwise"
    };
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function flip(data, options) {
        // if `inner` modifier is enabled, we can't use the `flip` modifier
        if (isModifierEnabled(data.instance.modifiers, "inner")) return data;
        if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
        return data;
        var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
        var placement = data.placement.split("-")[0];
        var placementOpposite = getOppositePlacement(placement);
        var variation = data.placement.split("-")[1] || "";
        var flipOrder = [];
        switch(options.behavior){
            case BEHAVIORS.FLIP:
                flipOrder = [
                    placement,
                    placementOpposite
                ];
                break;
            case BEHAVIORS.CLOCKWISE:
                flipOrder = clockwise(placement);
                break;
            case BEHAVIORS.COUNTERCLOCKWISE:
                flipOrder = clockwise(placement, true);
                break;
            default:
                flipOrder = options.behavior;
        }
        flipOrder.forEach(function(step, index) {
            if (placement !== step || flipOrder.length === index + 1) return data;
            placement = data.placement.split("-")[0];
            placementOpposite = getOppositePlacement(placement);
            var popperOffsets = data.offsets.popper;
            var refOffsets = data.offsets.reference;
            // using floor because the reference offsets may contain decimals we are not going to consider here
            var floor = Math.floor;
            var overlapsRef = placement === "left" && floor(popperOffsets.right) > floor(refOffsets.left) || placement === "right" && floor(popperOffsets.left) < floor(refOffsets.right) || placement === "top" && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === "bottom" && floor(popperOffsets.top) < floor(refOffsets.bottom);
            var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
            var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
            var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
            var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
            var overflowsBoundaries = placement === "left" && overflowsLeft || placement === "right" && overflowsRight || placement === "top" && overflowsTop || placement === "bottom" && overflowsBottom;
            // flip the variation if required
            var isVertical = [
                "top",
                "bottom"
            ].indexOf(placement) !== -1;
            // flips variation if reference element overflows boundaries
            var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === "start" && overflowsLeft || isVertical && variation === "end" && overflowsRight || !isVertical && variation === "start" && overflowsTop || !isVertical && variation === "end" && overflowsBottom);
            // flips variation if popper content overflows boundaries
            var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === "start" && overflowsRight || isVertical && variation === "end" && overflowsLeft || !isVertical && variation === "start" && overflowsBottom || !isVertical && variation === "end" && overflowsTop);
            var flippedVariation = flippedVariationByRef || flippedVariationByContent;
            if (overlapsRef || overflowsBoundaries || flippedVariation) {
                // this boolean to detect any flip loop
                data.flipped = true;
                if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
                if (flippedVariation) variation = getOppositeVariation(variation);
                data.placement = placement + (variation ? "-" + variation : "");
                // this object contains `position`, we want to preserve it along with
                // any additional property we may add in the future
                data.offsets.popper = _extends$1({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
                data = runModifiers(data.instance.modifiers, data, "flip");
            }
        });
        return data;
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function keepTogether(data) {
        var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var placement = data.placement.split("-")[0];
        var floor = Math.floor;
        var isVertical = [
            "top",
            "bottom"
        ].indexOf(placement) !== -1;
        var side = isVertical ? "right" : "bottom";
        var opSide = isVertical ? "left" : "top";
        var measurement = isVertical ? "width" : "height";
        if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
        if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
        return data;
    }
    /**
   * Converts a string containing value + unit into a px value number
   * @function
   * @memberof {modifiers~offset}
   * @private
   * @argument {String} str - Value + unit string
   * @argument {String} measurement - `height` or `width`
   * @argument {Object} popperOffsets
   * @argument {Object} referenceOffsets
   * @returns {Number|String}
   * Value in pixels, or original string if no values were extracted
   */ function toValue(str, measurement, popperOffsets, referenceOffsets) {
        // separate value from unit
        var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
        var value = +split[1];
        var unit = split[2];
        // If it's not a number it's an operator, I guess
        if (!value) return str;
        if (unit.indexOf("%") === 0) {
            var element = void 0;
            switch(unit){
                case "%p":
                    element = popperOffsets;
                    break;
                case "%":
                case "%r":
                default:
                    element = referenceOffsets;
            }
            var rect = getClientRect(element);
            return rect[measurement] / 100 * value;
        } else if (unit === "vh" || unit === "vw") {
            // if is a vh or vw, we calculate the size based on the viewport
            var size = void 0;
            if (unit === "vh") size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            return size / 100 * value;
        } else // if is an explicit pixel unit, we get rid of the unit and keep the value
        // if is an implicit unit, it's px, and we return just the value
        return value;
    }
    /**
   * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
   * @function
   * @memberof {modifiers~offset}
   * @private
   * @argument {String} offset
   * @argument {Object} popperOffsets
   * @argument {Object} referenceOffsets
   * @argument {String} basePlacement
   * @returns {Array} a two cells array with x and y offsets in numbers
   */ function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
        var offsets = [
            0,
            0
        ];
        // Use height if placement is left or right and index is 0 otherwise use width
        // in this way the first offset will use an axis and the second one
        // will use the other one
        var useHeight = [
            "right",
            "left"
        ].indexOf(basePlacement) !== -1;
        // Split the offset string to obtain a list of values and operands
        // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
        var fragments = offset.split(/(\+|\-)/).map(function(frag) {
            return frag.trim();
        });
        // Detect if the offset string contains a pair of values or a single one
        // they could be separated by comma or space
        var divider = fragments.indexOf(find(fragments, function(frag) {
            return frag.search(/,|\s/) !== -1;
        }));
        if (fragments[divider] && fragments[divider].indexOf(",") === -1) console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
        // If divider is found, we divide the list of values and operands to divide
        // them by ofset X and Y.
        var splitRegex = /\s*,\s*|\s+/;
        var ops = divider !== -1 ? [
            fragments.slice(0, divider).concat([
                fragments[divider].split(splitRegex)[0]
            ]),
            [
                fragments[divider].split(splitRegex)[1]
            ].concat(fragments.slice(divider + 1))
        ] : [
            fragments
        ];
        // Convert the values with units to absolute pixels to allow our computations
        ops = ops.map(function(op, index) {
            // Most of the units rely on the orientation of the popper
            var measurement = (index === 1 ? !useHeight : useHeight) ? "height" : "width";
            var mergeWithPrevious = false;
            return op// This aggregates any `+` or `-` sign that aren't considered operators
            // e.g.: 10 + +5 => [10, +, +5]
            .reduce(function(a, b) {
                if (a[a.length - 1] === "" && [
                    "+",
                    "-"
                ].indexOf(b) !== -1) {
                    a[a.length - 1] = b;
                    mergeWithPrevious = true;
                    return a;
                } else if (mergeWithPrevious) {
                    a[a.length - 1] += b;
                    mergeWithPrevious = false;
                    return a;
                } else return a.concat(b);
            }, [])// Here we convert the string values into number values (in px)
            .map(function(str) {
                return toValue(str, measurement, popperOffsets, referenceOffsets);
            });
        });
        // Loop trough the offsets arrays and execute the operations
        ops.forEach(function(op, index) {
            op.forEach(function(frag, index2) {
                if (isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === "-" ? -1 : 1);
            });
        });
        return offsets;
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @argument {Number|String} options.offset=0
   * The offset value as described in the modifier description
   * @returns {Object} The data object, properly modified
   */ function offset(data, _ref) {
        var offset = _ref.offset;
        var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var basePlacement = placement.split("-")[0];
        var offsets = void 0;
        if (isNumeric(+offset)) offsets = [
            +offset,
            0
        ];
        else offsets = parseOffset(offset, popper, reference, basePlacement);
        if (basePlacement === "left") {
            popper.top += offsets[0];
            popper.left -= offsets[1];
        } else if (basePlacement === "right") {
            popper.top += offsets[0];
            popper.left += offsets[1];
        } else if (basePlacement === "top") {
            popper.left += offsets[0];
            popper.top -= offsets[1];
        } else if (basePlacement === "bottom") {
            popper.left += offsets[0];
            popper.top += offsets[1];
        }
        data.popper = popper;
        return data;
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function preventOverflow(data, options) {
        var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
        // If offsetParent is the reference element, we really want to
        // go one step up and use the next offsetParent as reference to
        // avoid to make this modifier completely useless and look like broken
        if (data.instance.reference === boundariesElement) boundariesElement = getOffsetParent(boundariesElement);
        // NOTE: DOM access here
        // resets the popper's position so that the document size can be calculated excluding
        // the size of the popper element itself
        var transformProp = getSupportedPropertyName("transform");
        var popperStyles = data.instance.popper.style; // assignment to help minification
        var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
        popperStyles.top = "";
        popperStyles.left = "";
        popperStyles[transformProp] = "";
        var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
        // NOTE: DOM access here
        // restores the original style properties after the offsets have been computed
        popperStyles.top = top;
        popperStyles.left = left;
        popperStyles[transformProp] = transform;
        options.boundaries = boundaries;
        var order = options.priority;
        var popper = data.offsets.popper;
        var check = {
            primary: function primary(placement) {
                var value = popper[placement];
                if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
                return defineProperty({}, placement, value);
            },
            secondary: function secondary(placement) {
                var mainSide = placement === "right" ? "left" : "top";
                var value = popper[mainSide];
                if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === "right" ? popper.width : popper.height));
                return defineProperty({}, mainSide, value);
            }
        };
        order.forEach(function(placement) {
            var side = [
                "left",
                "top"
            ].indexOf(placement) !== -1 ? "primary" : "secondary";
            popper = _extends$1({}, popper, check[side](placement));
        });
        data.offsets.popper = popper;
        return data;
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function shift(data) {
        var placement = data.placement;
        var basePlacement = placement.split("-")[0];
        var shiftvariation = placement.split("-")[1];
        // if shift shiftvariation is specified, run the modifier
        if (shiftvariation) {
            var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
            var isVertical = [
                "bottom",
                "top"
            ].indexOf(basePlacement) !== -1;
            var side = isVertical ? "left" : "top";
            var measurement = isVertical ? "width" : "height";
            var shiftOffsets = {
                start: defineProperty({}, side, reference[side]),
                end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
            };
            data.offsets.popper = _extends$1({}, popper, shiftOffsets[shiftvariation]);
        }
        return data;
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function hide(data) {
        if (!isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")) return data;
        var refRect = data.offsets.reference;
        var bound = find(data.instance.modifiers, function(modifier) {
            return modifier.name === "preventOverflow";
        }).boundaries;
        if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
            // Avoid unnecessary DOM access if visibility hasn't changed
            if (data.hide === true) return data;
            data.hide = true;
            data.attributes["x-out-of-boundaries"] = "";
        } else {
            // Avoid unnecessary DOM access if visibility hasn't changed
            if (data.hide === false) return data;
            data.hide = false;
            data.attributes["x-out-of-boundaries"] = false;
        }
        return data;
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function inner(data) {
        var placement = data.placement;
        var basePlacement = placement.split("-")[0];
        var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var isHoriz = [
            "left",
            "right"
        ].indexOf(basePlacement) !== -1;
        var subtractLength = [
            "top",
            "left"
        ].indexOf(basePlacement) === -1;
        popper[isHoriz ? "left" : "top"] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
        data.placement = getOppositePlacement(placement);
        data.offsets.popper = getClientRect(popper);
        return data;
    }
    /**
   * Modifier function, each modifier can have a function of this type assigned
   * to its `fn` property.<br />
   * These functions will be called on each update, this means that you must
   * make sure they are performant enough to avoid performance bottlenecks.
   *
   * @function ModifierFn
   * @argument {dataObject} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {dataObject} The data object, properly modified
   */ /**
   * Modifiers are plugins used to alter the behavior of your poppers.<br />
   * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
   * needed by the library.
   *
   * Usually you don't want to override the `order`, `fn` and `onLoad` props.
   * All the other properties are configurations that could be tweaked.
   * @namespace modifiers
   */ var modifiers = {
        /**
     * Modifier used to shift the popper on the start or end of its reference
     * element.<br />
     * It will read the variation of the `placement` property.<br />
     * It can be one either `-end` or `-start`.
     * @memberof modifiers
     * @inner
     */ shift: {
            /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: shift
        },
        /**
     * The `offset` modifier can shift your popper on both its axis.
     *
     * It accepts the following units:
     * - `px` or unit-less, interpreted as pixels
     * - `%` or `%r`, percentage relative to the length of the reference element
     * - `%p`, percentage relative to the length of the popper element
     * - `vw`, CSS viewport width unit
     * - `vh`, CSS viewport height unit
     *
     * For length is intended the main axis relative to the placement of the popper.<br />
     * This means that if the placement is `top` or `bottom`, the length will be the
     * `width`. In case of `left` or `right`, it will be the `height`.
     *
     * You can provide a single value (as `Number` or `String`), or a pair of values
     * as `String` divided by a comma or one (or more) white spaces.<br />
     * The latter is a deprecated method because it leads to confusion and will be
     * removed in v2.<br />
     * Additionally, it accepts additions and subtractions between different units.
     * Note that multiplications and divisions aren't supported.
     *
     * Valid examples are:
     * ```
     * 10
     * '10%'
     * '10, 10'
     * '10%, 10'
     * '10 + 10%'
     * '10 - 5vh + 3%'
     * '-10px + 5vh, 5px - 6%'
     * ```
     * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
     * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
     * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
     *
     * @memberof modifiers
     * @inner
     */ offset: {
            /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: offset,
            /** @prop {Number|String} offset=0
       * The offset value as described in the modifier description
       */ offset: 0
        },
        /**
     * Modifier used to prevent the popper from being positioned outside the boundary.
     *
     * A scenario exists where the reference itself is not within the boundaries.<br />
     * We can say it has "escaped the boundaries" — or just "escaped".<br />
     * In this case we need to decide whether the popper should either:
     *
     * - detach from the reference and remain "trapped" in the boundaries, or
     * - if it should ignore the boundary and "escape with its reference"
     *
     * When `escapeWithReference` is set to`true` and reference is completely
     * outside its boundaries, the popper will overflow (or completely leave)
     * the boundaries in order to remain attached to the edge of the reference.
     *
     * @memberof modifiers
     * @inner
     */ preventOverflow: {
            /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: preventOverflow,
            /**
       * @prop {Array} [priority=['left','right','top','bottom']]
       * Popper will try to prevent overflow following these priorities by default,
       * then, it could overflow on the left and on top of the `boundariesElement`
       */ priority: [
                "left",
                "right",
                "top",
                "bottom"
            ],
            /**
       * @prop {number} padding=5
       * Amount of pixel used to define a minimum distance between the boundaries
       * and the popper. This makes sure the popper always has a little padding
       * between the edges of its container
       */ padding: 5,
            /**
       * @prop {String|HTMLElement} boundariesElement='scrollParent'
       * Boundaries used by the modifier. Can be `scrollParent`, `window`,
       * `viewport` or any DOM element.
       */ boundariesElement: "scrollParent"
        },
        /**
     * Modifier used to make sure the reference and its popper stay near each other
     * without leaving any gap between the two. Especially useful when the arrow is
     * enabled and you want to ensure that it points to its reference element.
     * It cares only about the first axis. You can still have poppers with margin
     * between the popper and its reference element.
     * @memberof modifiers
     * @inner
     */ keepTogether: {
            /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: keepTogether
        },
        /**
     * This modifier is used to move the `arrowElement` of the popper to make
     * sure it is positioned between the reference element and its popper element.
     * It will read the outer size of the `arrowElement` node to detect how many
     * pixels of conjunction are needed.
     *
     * It has no effect if no `arrowElement` is provided.
     * @memberof modifiers
     * @inner
     */ arrow: {
            /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: arrow,
            /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: "[x-arrow]"
        },
        /**
     * Modifier used to flip the popper's placement when it starts to overlap its
     * reference element.
     *
     * Requires the `preventOverflow` modifier before it in order to work.
     *
     * **NOTE:** this modifier will interrupt the current update cycle and will
     * restart it if it detects the need to flip the placement.
     * @memberof modifiers
     * @inner
     */ flip: {
            /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: flip,
            /**
       * @prop {String|Array} behavior='flip'
       * The behavior used to change the popper's placement. It can be one of
       * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
       * placements (with optional variations)
       */ behavior: "flip",
            /**
       * @prop {number} padding=5
       * The popper will flip if it hits the edges of the `boundariesElement`
       */ padding: 5,
            /**
       * @prop {String|HTMLElement} boundariesElement='viewport'
       * The element which will define the boundaries of the popper position.
       * The popper will never be placed outside of the defined boundaries
       * (except if `keepTogether` is enabled)
       */ boundariesElement: "viewport",
            /**
       * @prop {Boolean} flipVariations=false
       * The popper will switch placement variation between `-start` and `-end` when
       * the reference element overlaps its boundaries.
       *
       * The original placement should have a set variation.
       */ flipVariations: false,
            /**
       * @prop {Boolean} flipVariationsByContent=false
       * The popper will switch placement variation between `-start` and `-end` when
       * the popper element overlaps its reference boundaries.
       *
       * The original placement should have a set variation.
       */ flipVariationsByContent: false
        },
        /**
     * Modifier used to make the popper flow toward the inner of the reference element.
     * By default, when this modifier is disabled, the popper will be placed outside
     * the reference element.
     * @memberof modifiers
     * @inner
     */ inner: {
            /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
            /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
            /** @prop {ModifierFn} */ fn: inner
        },
        /**
     * Modifier used to hide the popper when its reference element is outside of the
     * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
     * be used to hide with a CSS selector the popper when its reference is
     * out of boundaries.
     *
     * Requires the `preventOverflow` modifier before it in order to work.
     * @memberof modifiers
     * @inner
     */ hide: {
            /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: hide
        },
        /**
     * Computes the style that will be applied to the popper element to gets
     * properly positioned.
     *
     * Note that this modifier will not touch the DOM, it just prepares the styles
     * so that `applyStyle` modifier can apply it. This separation is useful
     * in case you need to replace `applyStyle` with a custom implementation.
     *
     * This modifier has `850` as `order` value to maintain backward compatibility
     * with previous versions of Popper.js. Expect the modifiers ordering method
     * to change in future major versions of the library.
     *
     * @memberof modifiers
     * @inner
     */ computeStyle: {
            /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: computeStyle,
            /**
       * @prop {Boolean} gpuAcceleration=true
       * If true, it uses the CSS 3D transformation to position the popper.
       * Otherwise, it will use the `top` and `left` properties
       */ gpuAcceleration: true,
            /**
       * @prop {string} [x='bottom']
       * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
       * Change this if your popper should grow in a direction different from `bottom`
       */ x: "bottom",
            /**
       * @prop {string} [x='left']
       * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
       * Change this if your popper should grow in a direction different from `right`
       */ y: "right"
        },
        /**
     * Applies the computed styles to the popper element.
     *
     * All the DOM manipulations are limited to this modifier. This is useful in case
     * you want to integrate Popper.js inside a framework or view library and you
     * want to delegate all the DOM manipulations to it.
     *
     * Note that if you disable this modifier, you must make sure the popper element
     * has its position set to `absolute` before Popper.js can do its work!
     *
     * Just disable this modifier and define your own to achieve the desired effect.
     *
     * @memberof modifiers
     * @inner
     */ applyStyle: {
            /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: applyStyle,
            /** @prop {Function} */ onLoad: applyStyleOnLoad,
            /**
       * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
       * @prop {Boolean} gpuAcceleration=true
       * If true, it uses the CSS 3D transformation to position the popper.
       * Otherwise, it will use the `top` and `left` properties
       */ gpuAcceleration: undefined
        }
    };
    /**
   * The `dataObject` is an object containing all the information used by Popper.js.
   * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
   * @name dataObject
   * @property {Object} data.instance The Popper.js instance
   * @property {String} data.placement Placement applied to popper
   * @property {String} data.originalPlacement Placement originally defined on init
   * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
   * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
   * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
   * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
   * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
   * @property {Object} data.boundaries Offsets of the popper boundaries
   * @property {Object} data.offsets The measurements of popper, reference and arrow elements
   * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
   * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
   * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
   */ /**
   * Default options provided to Popper.js constructor.<br />
   * These can be overridden using the `options` argument of Popper.js.<br />
   * To override an option, simply pass an object with the same
   * structure of the `options` object, as the 3rd argument. For example:
   * ```
   * new Popper(ref, pop, {
   *   modifiers: {
   *     preventOverflow: { enabled: false }
   *   }
   * })
   * ```
   * @type {Object}
   * @static
   * @memberof Popper
   */ var Defaults = {
        /**
     * Popper's placement.
     * @prop {Popper.placements} placement='bottom'
     */ placement: "bottom",
        /**
     * Set this to true if you want popper to position it self in 'fixed' mode
     * @prop {Boolean} positionFixed=false
     */ positionFixed: false,
        /**
     * Whether events (resize, scroll) are initially enabled.
     * @prop {Boolean} eventsEnabled=true
     */ eventsEnabled: true,
        /**
     * Set to true if you want to automatically remove the popper when
     * you call the `destroy` method.
     * @prop {Boolean} removeOnDestroy=false
     */ removeOnDestroy: false,
        /**
     * Callback called when the popper is created.<br />
     * By default, it is set to no-op.<br />
     * Access Popper.js instance with `data.instance`.
     * @prop {onCreate}
     */ onCreate: function onCreate() {},
        /**
     * Callback called when the popper is updated. This callback is not called
     * on the initialization/creation of the popper, but only on subsequent
     * updates.<br />
     * By default, it is set to no-op.<br />
     * Access Popper.js instance with `data.instance`.
     * @prop {onUpdate}
     */ onUpdate: function onUpdate() {},
        /**
     * List of modifiers used to modify the offsets before they are applied to the popper.
     * They provide most of the functionalities of Popper.js.
     * @prop {modifiers}
     */ modifiers: modifiers
    };
    /**
   * @callback onCreate
   * @param {dataObject} data
   */ /**
   * @callback onUpdate
   * @param {dataObject} data
   */ // Utils
    // Methods
    var Popper = function() {
        /**
     * Creates a new Popper.js instance.
     * @class Popper
     * @param {Element|referenceObject} reference - The reference element used to position the popper
     * @param {Element} popper - The HTML / XML element used as the popper
     * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
     * @return {Object} instance - The generated Popper.js instance
     */ function Popper(reference, popper) {
            var _this = this;
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            classCallCheck(this, Popper);
            this.scheduleUpdate = function() {
                return requestAnimationFrame(_this.update);
            };
            // make update() debounced, so that it only runs at most once-per-tick
            this.update = debounce(this.update.bind(this));
            // with {} we create a new object with the options inside it
            this.options = _extends$1({}, Popper.Defaults, options);
            // init state
            this.state = {
                isDestroyed: false,
                isCreated: false,
                scrollParents: []
            };
            // get reference and popper elements (allow jQuery wrappers)
            this.reference = reference && reference.jquery ? reference[0] : reference;
            this.popper = popper && popper.jquery ? popper[0] : popper;
            // Deep merge modifiers options
            this.options.modifiers = {};
            Object.keys(_extends$1({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
                _this.options.modifiers[name] = _extends$1({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
            });
            // Refactoring modifiers' list (Object => Array)
            this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
                return _extends$1({
                    name: name
                }, _this.options.modifiers[name]);
            })// sort the modifiers by order
            .sort(function(a, b) {
                return a.order - b.order;
            });
            // modifiers have the ability to execute arbitrary code when Popper.js get inited
            // such code is executed in the same order of its modifier
            // they could add new properties to their options configuration
            // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
            this.modifiers.forEach(function(modifierOptions) {
                if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
            });
            // fire the first update to position the popper in the right place
            this.update();
            var eventsEnabled = this.options.eventsEnabled;
            if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
            this.enableEventListeners();
            this.state.eventsEnabled = eventsEnabled;
        }
        // We can't use class properties because they don't get listed in the
        // class prototype and break stuff like Sinon stubs
        createClass(Popper, [
            {
                key: "update",
                value: function update$$1() {
                    return update.call(this);
                }
            },
            {
                key: "destroy",
                value: function destroy$$1() {
                    return destroy.call(this);
                }
            },
            {
                key: "enableEventListeners",
                value: function enableEventListeners$$1() {
                    return enableEventListeners.call(this);
                }
            },
            {
                key: "disableEventListeners",
                value: function disableEventListeners$$1() {
                    return disableEventListeners.call(this);
                }
            }
        ]);
        return Popper;
    }();
    /**
   * The `referenceObject` is an object that provides an interface compatible with Popper.js
   * and lets you use it as replacement of a real DOM node.<br />
   * You can use this method to position a popper relatively to a set of coordinates
   * in case you don't have a DOM node to use as reference.
   *
   * ```
   * new Popper(referenceObject, popperNode);
   * ```
   *
   * NB: This feature isn't supported in Internet Explorer 10.
   * @name referenceObject
   * @property {Function} data.getBoundingClientRect
   * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
   * @property {number} data.clientWidth
   * An ES6 getter that will return the width of the virtual reference element.
   * @property {number} data.clientHeight
   * An ES6 getter that will return the height of the virtual reference element.
   */ Popper.Utils = (typeof window !== "undefined" ? window : $parcel$global).PopperUtils;
    Popper.placements = placements;
    Popper.Defaults = Defaults;
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$4 = "dropdown";
    var VERSION$4 = "4.6.0";
    var DATA_KEY$4 = "bs.dropdown";
    var EVENT_KEY$4 = "." + DATA_KEY$4;
    var DATA_API_KEY$4 = ".data-api";
    var JQUERY_NO_CONFLICT$4 = $__default["default"].fn[NAME$4];
    var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
    var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key
    var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key
    var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
    var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
    var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)
    var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE);
    var EVENT_HIDE$1 = "hide" + EVENT_KEY$4;
    var EVENT_HIDDEN$1 = "hidden" + EVENT_KEY$4;
    var EVENT_SHOW$1 = "show" + EVENT_KEY$4;
    var EVENT_SHOWN$1 = "shown" + EVENT_KEY$4;
    var EVENT_CLICK = "click" + EVENT_KEY$4;
    var EVENT_CLICK_DATA_API$4 = "click" + EVENT_KEY$4 + DATA_API_KEY$4;
    var EVENT_KEYDOWN_DATA_API = "keydown" + EVENT_KEY$4 + DATA_API_KEY$4;
    var EVENT_KEYUP_DATA_API = "keyup" + EVENT_KEY$4 + DATA_API_KEY$4;
    var CLASS_NAME_DISABLED = "disabled";
    var CLASS_NAME_SHOW$2 = "show";
    var CLASS_NAME_DROPUP = "dropup";
    var CLASS_NAME_DROPRIGHT = "dropright";
    var CLASS_NAME_DROPLEFT = "dropleft";
    var CLASS_NAME_MENURIGHT = "dropdown-menu-right";
    var CLASS_NAME_POSITION_STATIC = "position-static";
    var SELECTOR_DATA_TOGGLE$2 = '[data-toggle="dropdown"]';
    var SELECTOR_FORM_CHILD = ".dropdown form";
    var SELECTOR_MENU = ".dropdown-menu";
    var SELECTOR_NAVBAR_NAV = ".navbar-nav";
    var SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
    var PLACEMENT_TOP = "top-start";
    var PLACEMENT_TOPEND = "top-end";
    var PLACEMENT_BOTTOM = "bottom-start";
    var PLACEMENT_BOTTOMEND = "bottom-end";
    var PLACEMENT_RIGHT = "right-start";
    var PLACEMENT_LEFT = "left-start";
    var Default$2 = {
        offset: 0,
        flip: true,
        boundary: "scrollParent",
        reference: "toggle",
        display: "dynamic",
        popperConfig: null
    };
    var DefaultType$2 = {
        offset: "(number|string|function)",
        flip: "boolean",
        boundary: "(string|element)",
        reference: "(string|element)",
        display: "string",
        popperConfig: "(null|object)"
    };
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Dropdown = /*#__PURE__*/ function() {
        function Dropdown(element, config) {
            this._element = element;
            this._popper = null;
            this._config = this._getConfig(config);
            this._menu = this._getMenuElement();
            this._inNavbar = this._detectNavbar();
            this._addEventListeners();
        } // Getters
        var _proto = Dropdown.prototype;
        // Public
        _proto.toggle = function toggle() {
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED)) return;
            var isActive = $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$2);
            Dropdown._clearMenus();
            if (isActive) return;
            this.show(true);
        };
        _proto.show = function show(usePopper) {
            if (usePopper === void 0) usePopper = false;
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED) || $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$2)) return;
            var relatedTarget = {
                relatedTarget: this._element
            };
            var showEvent = $__default["default"].Event(EVENT_SHOW$1, relatedTarget);
            var parent = Dropdown._getParentFromElement(this._element);
            $__default["default"](parent).trigger(showEvent);
            if (showEvent.isDefaultPrevented()) return;
             // Totally disable Popper for Dropdowns in Navbar
            if (!this._inNavbar && usePopper) {
                /**
         * Check for Popper dependency
         * Popper - https://popper.js.org
         */ if (typeof Popper === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
                var referenceElement = this._element;
                if (this._config.reference === "parent") referenceElement = parent;
                else if (Util.isElement(this._config.reference)) {
                    referenceElement = this._config.reference; // Check if it's jQuery element
                    if (typeof this._config.reference.jquery !== "undefined") referenceElement = this._config.reference[0];
                } // If boundary is not `scrollParent`, then set position to `static`
                // to allow the menu to "escape" the scroll parent's boundaries
                // https://github.com/twbs/bootstrap/issues/24251
                if (this._config.boundary !== "scrollParent") $__default["default"](parent).addClass(CLASS_NAME_POSITION_STATIC);
                this._popper = new Popper(referenceElement, this._menu, this._getPopperConfig());
            } // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ("ontouchstart" in document.documentElement && $__default["default"](parent).closest(SELECTOR_NAVBAR_NAV).length === 0) $__default["default"](document.body).children().on("mouseover", null, $__default["default"].noop);
            this._element.focus();
            this._element.setAttribute("aria-expanded", true);
            $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$2);
            $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$2).trigger($__default["default"].Event(EVENT_SHOWN$1, relatedTarget));
        };
        _proto.hide = function hide() {
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED) || !$__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$2)) return;
            var relatedTarget = {
                relatedTarget: this._element
            };
            var hideEvent = $__default["default"].Event(EVENT_HIDE$1, relatedTarget);
            var parent = Dropdown._getParentFromElement(this._element);
            $__default["default"](parent).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            if (this._popper) this._popper.destroy();
            $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$2);
            $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$2).trigger($__default["default"].Event(EVENT_HIDDEN$1, relatedTarget));
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$4);
            $__default["default"](this._element).off(EVENT_KEY$4);
            this._element = null;
            this._menu = null;
            if (this._popper !== null) {
                this._popper.destroy();
                this._popper = null;
            }
        };
        _proto.update = function update() {
            this._inNavbar = this._detectNavbar();
            if (this._popper !== null) this._popper.scheduleUpdate();
        } // Private
        ;
        _proto._addEventListeners = function _addEventListeners() {
            var _this = this;
            $__default["default"](this._element).on(EVENT_CLICK, function(event) {
                event.preventDefault();
                event.stopPropagation();
                _this.toggle();
            });
        };
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, this.constructor.Default, $__default["default"](this._element).data(), config);
            Util.typeCheckConfig(NAME$4, config, this.constructor.DefaultType);
            return config;
        };
        _proto._getMenuElement = function _getMenuElement() {
            if (!this._menu) {
                var parent = Dropdown._getParentFromElement(this._element);
                if (parent) this._menu = parent.querySelector(SELECTOR_MENU);
            }
            return this._menu;
        };
        _proto._getPlacement = function _getPlacement() {
            var $parentDropdown = $__default["default"](this._element.parentNode);
            var placement = PLACEMENT_BOTTOM; // Handle dropup
            if ($parentDropdown.hasClass(CLASS_NAME_DROPUP)) placement = $__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT) ? PLACEMENT_TOPEND : PLACEMENT_TOP;
            else if ($parentDropdown.hasClass(CLASS_NAME_DROPRIGHT)) placement = PLACEMENT_RIGHT;
            else if ($parentDropdown.hasClass(CLASS_NAME_DROPLEFT)) placement = PLACEMENT_LEFT;
            else if ($__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT)) placement = PLACEMENT_BOTTOMEND;
            return placement;
        };
        _proto._detectNavbar = function _detectNavbar() {
            return $__default["default"](this._element).closest(".navbar").length > 0;
        };
        _proto._getOffset = function _getOffset() {
            var _this2 = this;
            var offset = {};
            if (typeof this._config.offset === "function") offset.fn = function(data) {
                data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets, _this2._element) || {});
                return data;
            };
            else offset.offset = this._config.offset;
            return offset;
        };
        _proto._getPopperConfig = function _getPopperConfig() {
            var popperConfig = {
                placement: this._getPlacement(),
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        enabled: this._config.flip
                    },
                    preventOverflow: {
                        boundariesElement: this._config.boundary
                    }
                }
            }; // Disable Popper if we have a static display
            if (this._config.display === "static") popperConfig.modifiers.applyStyle = {
                enabled: false
            };
            return _extends({}, popperConfig, this._config.popperConfig);
        } // Static
        ;
        Dropdown._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$4);
                var _config = typeof config === "object" ? config : null;
                if (!data) {
                    data = new Dropdown(this, _config);
                    $__default["default"](this).data(DATA_KEY$4, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        Dropdown._clearMenus = function _clearMenus(event) {
            if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === "keyup" && event.which !== TAB_KEYCODE)) return;
            var toggles = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$2));
            for(var i = 0, len = toggles.length; i < len; i++){
                var parent = Dropdown._getParentFromElement(toggles[i]);
                var context = $__default["default"](toggles[i]).data(DATA_KEY$4);
                var relatedTarget = {
                    relatedTarget: toggles[i]
                };
                if (event && event.type === "click") relatedTarget.clickEvent = event;
                if (!context) continue;
                var dropdownMenu = context._menu;
                if (!$__default["default"](parent).hasClass(CLASS_NAME_SHOW$2)) continue;
                if (event && (event.type === "click" && /input|textarea/i.test(event.target.tagName) || event.type === "keyup" && event.which === TAB_KEYCODE) && $__default["default"].contains(parent, event.target)) continue;
                var hideEvent = $__default["default"].Event(EVENT_HIDE$1, relatedTarget);
                $__default["default"](parent).trigger(hideEvent);
                if (hideEvent.isDefaultPrevented()) continue;
                 // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ("ontouchstart" in document.documentElement) $__default["default"](document.body).children().off("mouseover", null, $__default["default"].noop);
                toggles[i].setAttribute("aria-expanded", "false");
                if (context._popper) context._popper.destroy();
                $__default["default"](dropdownMenu).removeClass(CLASS_NAME_SHOW$2);
                $__default["default"](parent).removeClass(CLASS_NAME_SHOW$2).trigger($__default["default"].Event(EVENT_HIDDEN$1, relatedTarget));
            }
        };
        Dropdown._getParentFromElement = function _getParentFromElement(element) {
            var parent;
            var selector = Util.getSelectorFromElement(element);
            if (selector) parent = document.querySelector(selector);
            return parent || element.parentNode;
        } // eslint-disable-next-line complexity
        ;
        Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
            // If not input/textarea:
            //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
            // If input/textarea:
            //  - If space key => not a dropdown command
            //  - If key is other than escape
            //    - If key is not up or down => not a dropdown command
            //    - If trigger inside the menu => not a dropdown command
            if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $__default["default"](event.target).closest(SELECTOR_MENU).length) : !REGEXP_KEYDOWN.test(event.which)) return;
            if (this.disabled || $__default["default"](this).hasClass(CLASS_NAME_DISABLED)) return;
            var parent = Dropdown._getParentFromElement(this);
            var isActive = $__default["default"](parent).hasClass(CLASS_NAME_SHOW$2);
            if (!isActive && event.which === ESCAPE_KEYCODE) return;
            event.preventDefault();
            event.stopPropagation();
            if (!isActive || event.which === ESCAPE_KEYCODE || event.which === SPACE_KEYCODE) {
                if (event.which === ESCAPE_KEYCODE) $__default["default"](parent.querySelector(SELECTOR_DATA_TOGGLE$2)).trigger("focus");
                $__default["default"](this).trigger("click");
                return;
            }
            var items = [].slice.call(parent.querySelectorAll(SELECTOR_VISIBLE_ITEMS)).filter(function(item) {
                return $__default["default"](item).is(":visible");
            });
            if (items.length === 0) return;
            var index = items.indexOf(event.target);
            if (event.which === ARROW_UP_KEYCODE && index > 0) // Up
            index--;
            if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) // Down
            index++;
            if (index < 0) index = 0;
            items[index].focus();
        };
        _createClass(Dropdown, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$4;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$2;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$2;
                }
            }
        ]);
        return Dropdown;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](document).on(EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$2, Dropdown._dataApiKeydownHandler).on(EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown._dataApiKeydownHandler).on(EVENT_CLICK_DATA_API$4 + " " + EVENT_KEYUP_DATA_API, Dropdown._clearMenus).on(EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$2, function(event) {
        event.preventDefault();
        event.stopPropagation();
        Dropdown._jQueryInterface.call($__default["default"](this), "toggle");
    }).on(EVENT_CLICK_DATA_API$4, SELECTOR_FORM_CHILD, function(e) {
        e.stopPropagation();
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$4] = Dropdown._jQueryInterface;
    $__default["default"].fn[NAME$4].Constructor = Dropdown;
    $__default["default"].fn[NAME$4].noConflict = function() {
        $__default["default"].fn[NAME$4] = JQUERY_NO_CONFLICT$4;
        return Dropdown._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$5 = "modal";
    var VERSION$5 = "4.6.0";
    var DATA_KEY$5 = "bs.modal";
    var EVENT_KEY$5 = "." + DATA_KEY$5;
    var DATA_API_KEY$5 = ".data-api";
    var JQUERY_NO_CONFLICT$5 = $__default["default"].fn[NAME$5];
    var ESCAPE_KEYCODE$1 = 27; // KeyboardEvent.which value for Escape (Esc) key
    var Default$3 = {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: true
    };
    var DefaultType$3 = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        focus: "boolean",
        show: "boolean"
    };
    var EVENT_HIDE$2 = "hide" + EVENT_KEY$5;
    var EVENT_HIDE_PREVENTED = "hidePrevented" + EVENT_KEY$5;
    var EVENT_HIDDEN$2 = "hidden" + EVENT_KEY$5;
    var EVENT_SHOW$2 = "show" + EVENT_KEY$5;
    var EVENT_SHOWN$2 = "shown" + EVENT_KEY$5;
    var EVENT_FOCUSIN = "focusin" + EVENT_KEY$5;
    var EVENT_RESIZE = "resize" + EVENT_KEY$5;
    var EVENT_CLICK_DISMISS = "click.dismiss" + EVENT_KEY$5;
    var EVENT_KEYDOWN_DISMISS = "keydown.dismiss" + EVENT_KEY$5;
    var EVENT_MOUSEUP_DISMISS = "mouseup.dismiss" + EVENT_KEY$5;
    var EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss" + EVENT_KEY$5;
    var EVENT_CLICK_DATA_API$5 = "click" + EVENT_KEY$5 + DATA_API_KEY$5;
    var CLASS_NAME_SCROLLABLE = "modal-dialog-scrollable";
    var CLASS_NAME_SCROLLBAR_MEASURER = "modal-scrollbar-measure";
    var CLASS_NAME_BACKDROP = "modal-backdrop";
    var CLASS_NAME_OPEN = "modal-open";
    var CLASS_NAME_FADE$1 = "fade";
    var CLASS_NAME_SHOW$3 = "show";
    var CLASS_NAME_STATIC = "modal-static";
    var SELECTOR_DIALOG = ".modal-dialog";
    var SELECTOR_MODAL_BODY = ".modal-body";
    var SELECTOR_DATA_TOGGLE$3 = '[data-toggle="modal"]';
    var SELECTOR_DATA_DISMISS = '[data-dismiss="modal"]';
    var SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
    var SELECTOR_STICKY_CONTENT = ".sticky-top";
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Modal = /*#__PURE__*/ function() {
        function Modal(element, config) {
            this._config = this._getConfig(config);
            this._element = element;
            this._dialog = element.querySelector(SELECTOR_DIALOG);
            this._backdrop = null;
            this._isShown = false;
            this._isBodyOverflowing = false;
            this._ignoreBackdropClick = false;
            this._isTransitioning = false;
            this._scrollbarWidth = 0;
        } // Getters
        var _proto = Modal.prototype;
        // Public
        _proto.toggle = function toggle(relatedTarget) {
            return this._isShown ? this.hide() : this.show(relatedTarget);
        };
        _proto.show = function show(relatedTarget) {
            var _this = this;
            if (this._isShown || this._isTransitioning) return;
            if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$1)) this._isTransitioning = true;
            var showEvent = $__default["default"].Event(EVENT_SHOW$2, {
                relatedTarget: relatedTarget
            });
            $__default["default"](this._element).trigger(showEvent);
            if (this._isShown || showEvent.isDefaultPrevented()) return;
            this._isShown = true;
            this._checkScrollbar();
            this._setScrollbar();
            this._adjustDialog();
            this._setEscapeEvent();
            this._setResizeEvent();
            $__default["default"](this._element).on(EVENT_CLICK_DISMISS, SELECTOR_DATA_DISMISS, function(event) {
                return _this.hide(event);
            });
            $__default["default"](this._dialog).on(EVENT_MOUSEDOWN_DISMISS, function() {
                $__default["default"](_this._element).one(EVENT_MOUSEUP_DISMISS, function(event) {
                    if ($__default["default"](event.target).is(_this._element)) _this._ignoreBackdropClick = true;
                });
            });
            this._showBackdrop(function() {
                return _this._showElement(relatedTarget);
            });
        };
        _proto.hide = function hide(event) {
            var _this2 = this;
            if (event) event.preventDefault();
            if (!this._isShown || this._isTransitioning) return;
            var hideEvent = $__default["default"].Event(EVENT_HIDE$2);
            $__default["default"](this._element).trigger(hideEvent);
            if (!this._isShown || hideEvent.isDefaultPrevented()) return;
            this._isShown = false;
            var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$1);
            if (transition) this._isTransitioning = true;
            this._setEscapeEvent();
            this._setResizeEvent();
            $__default["default"](document).off(EVENT_FOCUSIN);
            $__default["default"](this._element).removeClass(CLASS_NAME_SHOW$3);
            $__default["default"](this._element).off(EVENT_CLICK_DISMISS);
            $__default["default"](this._dialog).off(EVENT_MOUSEDOWN_DISMISS);
            if (transition) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, function(event) {
                    return _this2._hideModal(event);
                }).emulateTransitionEnd(transitionDuration);
            } else this._hideModal();
        };
        _proto.dispose = function dispose() {
            [
                window,
                this._element,
                this._dialog
            ].forEach(function(htmlElement) {
                return $__default["default"](htmlElement).off(EVENT_KEY$5);
            });
            /**
       * `document` has 2 events `EVENT_FOCUSIN` and `EVENT_CLICK_DATA_API`
       * Do not move `document` in `htmlElements` array
       * It will remove `EVENT_CLICK_DATA_API` event that should remain
       */ $__default["default"](document).off(EVENT_FOCUSIN);
            $__default["default"].removeData(this._element, DATA_KEY$5);
            this._config = null;
            this._element = null;
            this._dialog = null;
            this._backdrop = null;
            this._isShown = null;
            this._isBodyOverflowing = null;
            this._ignoreBackdropClick = null;
            this._isTransitioning = null;
            this._scrollbarWidth = null;
        };
        _proto.handleUpdate = function handleUpdate() {
            this._adjustDialog();
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$3, config);
            Util.typeCheckConfig(NAME$5, config, DefaultType$3);
            return config;
        };
        _proto._triggerBackdropTransition = function _triggerBackdropTransition() {
            var _this3 = this;
            var hideEventPrevented = $__default["default"].Event(EVENT_HIDE_PREVENTED);
            $__default["default"](this._element).trigger(hideEventPrevented);
            if (hideEventPrevented.isDefaultPrevented()) return;
            var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            if (!isModalOverflowing) this._element.style.overflowY = "hidden";
            this._element.classList.add(CLASS_NAME_STATIC);
            var modalTransitionDuration = Util.getTransitionDurationFromElement(this._dialog);
            $__default["default"](this._element).off(Util.TRANSITION_END);
            $__default["default"](this._element).one(Util.TRANSITION_END, function() {
                _this3._element.classList.remove(CLASS_NAME_STATIC);
                if (!isModalOverflowing) $__default["default"](_this3._element).one(Util.TRANSITION_END, function() {
                    _this3._element.style.overflowY = "";
                }).emulateTransitionEnd(_this3._element, modalTransitionDuration);
            }).emulateTransitionEnd(modalTransitionDuration);
            this._element.focus();
        };
        _proto._showElement = function _showElement(relatedTarget) {
            var _this4 = this;
            var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$1);
            var modalBody = this._dialog ? this._dialog.querySelector(SELECTOR_MODAL_BODY) : null;
            if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) // Don't move modal's DOM position
            document.body.appendChild(this._element);
            this._element.style.display = "block";
            this._element.removeAttribute("aria-hidden");
            this._element.setAttribute("aria-modal", true);
            this._element.setAttribute("role", "dialog");
            if ($__default["default"](this._dialog).hasClass(CLASS_NAME_SCROLLABLE) && modalBody) modalBody.scrollTop = 0;
            else this._element.scrollTop = 0;
            if (transition) Util.reflow(this._element);
            $__default["default"](this._element).addClass(CLASS_NAME_SHOW$3);
            if (this._config.focus) this._enforceFocus();
            var shownEvent = $__default["default"].Event(EVENT_SHOWN$2, {
                relatedTarget: relatedTarget
            });
            var transitionComplete = function transitionComplete() {
                if (_this4._config.focus) _this4._element.focus();
                _this4._isTransitioning = false;
                $__default["default"](_this4._element).trigger(shownEvent);
            };
            if (transition) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._dialog);
                $__default["default"](this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
            } else transitionComplete();
        };
        _proto._enforceFocus = function _enforceFocus() {
            var _this5 = this;
            $__default["default"](document).off(EVENT_FOCUSIN) // Guard against infinite focus loop
            .on(EVENT_FOCUSIN, function(event) {
                if (document !== event.target && _this5._element !== event.target && $__default["default"](_this5._element).has(event.target).length === 0) _this5._element.focus();
            });
        };
        _proto._setEscapeEvent = function _setEscapeEvent() {
            var _this6 = this;
            if (this._isShown) $__default["default"](this._element).on(EVENT_KEYDOWN_DISMISS, function(event) {
                if (_this6._config.keyboard && event.which === ESCAPE_KEYCODE$1) {
                    event.preventDefault();
                    _this6.hide();
                } else if (!_this6._config.keyboard && event.which === ESCAPE_KEYCODE$1) _this6._triggerBackdropTransition();
            });
            else if (!this._isShown) $__default["default"](this._element).off(EVENT_KEYDOWN_DISMISS);
        };
        _proto._setResizeEvent = function _setResizeEvent() {
            var _this7 = this;
            if (this._isShown) $__default["default"](window).on(EVENT_RESIZE, function(event) {
                return _this7.handleUpdate(event);
            });
            else $__default["default"](window).off(EVENT_RESIZE);
        };
        _proto._hideModal = function _hideModal() {
            var _this8 = this;
            this._element.style.display = "none";
            this._element.setAttribute("aria-hidden", true);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            this._isTransitioning = false;
            this._showBackdrop(function() {
                $__default["default"](document.body).removeClass(CLASS_NAME_OPEN);
                _this8._resetAdjustments();
                _this8._resetScrollbar();
                $__default["default"](_this8._element).trigger(EVENT_HIDDEN$2);
            });
        };
        _proto._removeBackdrop = function _removeBackdrop() {
            if (this._backdrop) {
                $__default["default"](this._backdrop).remove();
                this._backdrop = null;
            }
        };
        _proto._showBackdrop = function _showBackdrop(callback) {
            var _this9 = this;
            var animate = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$1) ? CLASS_NAME_FADE$1 : "";
            if (this._isShown && this._config.backdrop) {
                this._backdrop = document.createElement("div");
                this._backdrop.className = CLASS_NAME_BACKDROP;
                if (animate) this._backdrop.classList.add(animate);
                $__default["default"](this._backdrop).appendTo(document.body);
                $__default["default"](this._element).on(EVENT_CLICK_DISMISS, function(event) {
                    if (_this9._ignoreBackdropClick) {
                        _this9._ignoreBackdropClick = false;
                        return;
                    }
                    if (event.target !== event.currentTarget) return;
                    if (_this9._config.backdrop === "static") _this9._triggerBackdropTransition();
                    else _this9.hide();
                });
                if (animate) Util.reflow(this._backdrop);
                $__default["default"](this._backdrop).addClass(CLASS_NAME_SHOW$3);
                if (!callback) return;
                if (!animate) {
                    callback();
                    return;
                }
                var backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
                $__default["default"](this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
            } else if (!this._isShown && this._backdrop) {
                $__default["default"](this._backdrop).removeClass(CLASS_NAME_SHOW$3);
                var callbackRemove = function callbackRemove() {
                    _this9._removeBackdrop();
                    if (callback) callback();
                };
                if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$1)) {
                    var _backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
                    $__default["default"](this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
                } else callbackRemove();
            } else if (callback) callback();
        } // ----------------------------------------------------------------------
        ;
        _proto._adjustDialog = function _adjustDialog() {
            var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            if (!this._isBodyOverflowing && isModalOverflowing) this._element.style.paddingLeft = this._scrollbarWidth + "px";
            if (this._isBodyOverflowing && !isModalOverflowing) this._element.style.paddingRight = this._scrollbarWidth + "px";
        };
        _proto._resetAdjustments = function _resetAdjustments() {
            this._element.style.paddingLeft = "";
            this._element.style.paddingRight = "";
        };
        _proto._checkScrollbar = function _checkScrollbar() {
            var rect = document.body.getBoundingClientRect();
            this._isBodyOverflowing = Math.round(rect.left + rect.right) < window.innerWidth;
            this._scrollbarWidth = this._getScrollbarWidth();
        };
        _proto._setScrollbar = function _setScrollbar() {
            var _this10 = this;
            if (this._isBodyOverflowing) {
                // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
                var stickyContent = [].slice.call(document.querySelectorAll(SELECTOR_STICKY_CONTENT)); // Adjust fixed content padding
                $__default["default"](fixedContent).each(function(index, element) {
                    var actualPadding = element.style.paddingRight;
                    var calculatedPadding = $__default["default"](element).css("padding-right");
                    $__default["default"](element).data("padding-right", actualPadding).css("padding-right", parseFloat(calculatedPadding) + _this10._scrollbarWidth + "px");
                }); // Adjust sticky content margin
                $__default["default"](stickyContent).each(function(index, element) {
                    var actualMargin = element.style.marginRight;
                    var calculatedMargin = $__default["default"](element).css("margin-right");
                    $__default["default"](element).data("margin-right", actualMargin).css("margin-right", parseFloat(calculatedMargin) - _this10._scrollbarWidth + "px");
                }); // Adjust body padding
                var actualPadding = document.body.style.paddingRight;
                var calculatedPadding = $__default["default"](document.body).css("padding-right");
                $__default["default"](document.body).data("padding-right", actualPadding).css("padding-right", parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
            }
            $__default["default"](document.body).addClass(CLASS_NAME_OPEN);
        };
        _proto._resetScrollbar = function _resetScrollbar() {
            // Restore fixed content padding
            var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
            $__default["default"](fixedContent).each(function(index, element) {
                var padding = $__default["default"](element).data("padding-right");
                $__default["default"](element).removeData("padding-right");
                element.style.paddingRight = padding ? padding : "";
            }); // Restore sticky content
            var elements = [].slice.call(document.querySelectorAll("" + SELECTOR_STICKY_CONTENT));
            $__default["default"](elements).each(function(index, element) {
                var margin = $__default["default"](element).data("margin-right");
                if (typeof margin !== "undefined") $__default["default"](element).css("margin-right", margin).removeData("margin-right");
            }); // Restore body padding
            var padding = $__default["default"](document.body).data("padding-right");
            $__default["default"](document.body).removeData("padding-right");
            document.body.style.paddingRight = padding ? padding : "";
        };
        _proto._getScrollbarWidth = function _getScrollbarWidth() {
            // thx d.walsh
            var scrollDiv = document.createElement("div");
            scrollDiv.className = CLASS_NAME_SCROLLBAR_MEASURER;
            document.body.appendChild(scrollDiv);
            var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
            return scrollbarWidth;
        } // Static
        ;
        Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$5);
                var _config = _extends({}, Default$3, $__default["default"](this).data(), typeof config === "object" && config ? config : {});
                if (!data) {
                    data = new Modal(this, _config);
                    $__default["default"](this).data(DATA_KEY$5, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config](relatedTarget);
                } else if (_config.show) data.show(relatedTarget);
            });
        };
        _createClass(Modal, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$5;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$3;
                }
            }
        ]);
        return Modal;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$5, SELECTOR_DATA_TOGGLE$3, function(event) {
        var _this11 = this;
        var target;
        var selector = Util.getSelectorFromElement(this);
        if (selector) target = document.querySelector(selector);
        var config = $__default["default"](target).data(DATA_KEY$5) ? "toggle" : _extends({}, $__default["default"](target).data(), $__default["default"](this).data());
        if (this.tagName === "A" || this.tagName === "AREA") event.preventDefault();
        var $target = $__default["default"](target).one(EVENT_SHOW$2, function(showEvent) {
            if (showEvent.isDefaultPrevented()) // Only register focus restorer if modal will actually get shown
            return;
            $target.one(EVENT_HIDDEN$2, function() {
                if ($__default["default"](_this11).is(":visible")) _this11.focus();
            });
        });
        Modal._jQueryInterface.call($__default["default"](target), config, this);
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$5] = Modal._jQueryInterface;
    $__default["default"].fn[NAME$5].Constructor = Modal;
    $__default["default"].fn[NAME$5].noConflict = function() {
        $__default["default"].fn[NAME$5] = JQUERY_NO_CONFLICT$5;
        return Modal._jQueryInterface;
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.0): tools/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ var uriAttrs = [
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href"
    ];
    var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
    var DefaultWhitelist = {
        // Global attributes allowed on any supplied element below.
        "*": [
            "class",
            "dir",
            "id",
            "lang",
            "role",
            ARIA_ATTRIBUTE_PATTERN
        ],
        a: [
            "target",
            "href",
            "title",
            "rel"
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        div: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            "src",
            "srcset",
            "alt",
            "title",
            "width",
            "height"
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    };
    /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */ var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^#&/:?]*(?:[#/?]|$))/gi;
    /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */ var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;
    function allowedAttribute(attr, allowedAttributeList) {
        var attrName = attr.nodeName.toLowerCase();
        if (allowedAttributeList.indexOf(attrName) !== -1) {
            if (uriAttrs.indexOf(attrName) !== -1) return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
            return true;
        }
        var regExp = allowedAttributeList.filter(function(attrRegex) {
            return attrRegex instanceof RegExp;
        }); // Check if a regular expression validates the attribute.
        for(var i = 0, len = regExp.length; i < len; i++){
            if (attrName.match(regExp[i])) return true;
        }
        return false;
    }
    function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
        if (unsafeHtml.length === 0) return unsafeHtml;
        if (sanitizeFn && typeof sanitizeFn === "function") return sanitizeFn(unsafeHtml);
        var domParser = new window.DOMParser();
        var createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
        var whitelistKeys = Object.keys(whiteList);
        var elements = [].slice.call(createdDocument.body.querySelectorAll("*"));
        var _loop = function _loop(i, len) {
            var el = elements[i];
            var elName = el.nodeName.toLowerCase();
            if (whitelistKeys.indexOf(el.nodeName.toLowerCase()) === -1) {
                el.parentNode.removeChild(el);
                return "continue";
            }
            var attributeList = [].slice.call(el.attributes);
            var whitelistedAttributes = [].concat(whiteList["*"] || [], whiteList[elName] || []);
            attributeList.forEach(function(attr) {
                if (!allowedAttribute(attr, whitelistedAttributes)) el.removeAttribute(attr.nodeName);
            });
        };
        for(var i = 0, len = elements.length; i < len; i++){
            var _ret = _loop(i);
            if (_ret === "continue") continue;
        }
        return createdDocument.body.innerHTML;
    }
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$6 = "tooltip";
    var VERSION$6 = "4.6.0";
    var DATA_KEY$6 = "bs.tooltip";
    var EVENT_KEY$6 = "." + DATA_KEY$6;
    var JQUERY_NO_CONFLICT$6 = $__default["default"].fn[NAME$6];
    var CLASS_PREFIX = "bs-tooltip";
    var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", "g");
    var DISALLOWED_ATTRIBUTES = [
        "sanitize",
        "whiteList",
        "sanitizeFn"
    ];
    var DefaultType$4 = {
        animation: "boolean",
        template: "string",
        title: "(string|element|function)",
        trigger: "string",
        delay: "(number|object)",
        html: "boolean",
        selector: "(string|boolean)",
        placement: "(string|function)",
        offset: "(number|string|function)",
        container: "(string|element|boolean)",
        fallbackPlacement: "(string|array)",
        boundary: "(string|element)",
        customClass: "(string|function)",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        whiteList: "object",
        popperConfig: "(null|object)"
    };
    var AttachmentMap = {
        AUTO: "auto",
        TOP: "top",
        RIGHT: "right",
        BOTTOM: "bottom",
        LEFT: "left"
    };
    var Default$4 = {
        animation: true,
        template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: false,
        selector: false,
        placement: "top",
        offset: 0,
        container: false,
        fallbackPlacement: "flip",
        boundary: "scrollParent",
        customClass: "",
        sanitize: true,
        sanitizeFn: null,
        whiteList: DefaultWhitelist,
        popperConfig: null
    };
    var HOVER_STATE_SHOW = "show";
    var HOVER_STATE_OUT = "out";
    var Event = {
        HIDE: "hide" + EVENT_KEY$6,
        HIDDEN: "hidden" + EVENT_KEY$6,
        SHOW: "show" + EVENT_KEY$6,
        SHOWN: "shown" + EVENT_KEY$6,
        INSERTED: "inserted" + EVENT_KEY$6,
        CLICK: "click" + EVENT_KEY$6,
        FOCUSIN: "focusin" + EVENT_KEY$6,
        FOCUSOUT: "focusout" + EVENT_KEY$6,
        MOUSEENTER: "mouseenter" + EVENT_KEY$6,
        MOUSELEAVE: "mouseleave" + EVENT_KEY$6
    };
    var CLASS_NAME_FADE$2 = "fade";
    var CLASS_NAME_SHOW$4 = "show";
    var SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
    var SELECTOR_ARROW = ".arrow";
    var TRIGGER_HOVER = "hover";
    var TRIGGER_FOCUS = "focus";
    var TRIGGER_CLICK = "click";
    var TRIGGER_MANUAL = "manual";
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Tooltip = /*#__PURE__*/ function() {
        function Tooltip(element, config) {
            if (typeof Popper === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
             // private
            this._isEnabled = true;
            this._timeout = 0;
            this._hoverState = "";
            this._activeTrigger = {};
            this._popper = null; // Protected
            this.element = element;
            this.config = this._getConfig(config);
            this.tip = null;
            this._setListeners();
        } // Getters
        var _proto = Tooltip.prototype;
        // Public
        _proto.enable = function enable() {
            this._isEnabled = true;
        };
        _proto.disable = function disable() {
            this._isEnabled = false;
        };
        _proto.toggleEnabled = function toggleEnabled() {
            this._isEnabled = !this._isEnabled;
        };
        _proto.toggle = function toggle(event) {
            if (!this._isEnabled) return;
            if (event) {
                var dataKey = this.constructor.DATA_KEY;
                var context = $__default["default"](event.currentTarget).data(dataKey);
                if (!context) {
                    context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                    $__default["default"](event.currentTarget).data(dataKey, context);
                }
                context._activeTrigger.click = !context._activeTrigger.click;
                if (context._isWithActiveTrigger()) context._enter(null, context);
                else context._leave(null, context);
            } else {
                if ($__default["default"](this.getTipElement()).hasClass(CLASS_NAME_SHOW$4)) {
                    this._leave(null, this);
                    return;
                }
                this._enter(null, this);
            }
        };
        _proto.dispose = function dispose() {
            clearTimeout(this._timeout);
            $__default["default"].removeData(this.element, this.constructor.DATA_KEY);
            $__default["default"](this.element).off(this.constructor.EVENT_KEY);
            $__default["default"](this.element).closest(".modal").off("hide.bs.modal", this._hideModalHandler);
            if (this.tip) $__default["default"](this.tip).remove();
            this._isEnabled = null;
            this._timeout = null;
            this._hoverState = null;
            this._activeTrigger = null;
            if (this._popper) this._popper.destroy();
            this._popper = null;
            this.element = null;
            this.config = null;
            this.tip = null;
        };
        _proto.show = function show() {
            var _this = this;
            if ($__default["default"](this.element).css("display") === "none") throw new Error("Please use show on visible elements");
            var showEvent = $__default["default"].Event(this.constructor.Event.SHOW);
            if (this.isWithContent() && this._isEnabled) {
                $__default["default"](this.element).trigger(showEvent);
                var shadowRoot = Util.findShadowRoot(this.element);
                var isInTheDom = $__default["default"].contains(shadowRoot !== null ? shadowRoot : this.element.ownerDocument.documentElement, this.element);
                if (showEvent.isDefaultPrevented() || !isInTheDom) return;
                var tip = this.getTipElement();
                var tipId = Util.getUID(this.constructor.NAME);
                tip.setAttribute("id", tipId);
                this.element.setAttribute("aria-describedby", tipId);
                this.setContent();
                if (this.config.animation) $__default["default"](tip).addClass(CLASS_NAME_FADE$2);
                var placement = typeof this.config.placement === "function" ? this.config.placement.call(this, tip, this.element) : this.config.placement;
                var attachment = this._getAttachment(placement);
                this.addAttachmentClass(attachment);
                var container = this._getContainer();
                $__default["default"](tip).data(this.constructor.DATA_KEY, this);
                if (!$__default["default"].contains(this.element.ownerDocument.documentElement, this.tip)) $__default["default"](tip).appendTo(container);
                $__default["default"](this.element).trigger(this.constructor.Event.INSERTED);
                this._popper = new Popper(this.element, tip, this._getPopperConfig(attachment));
                $__default["default"](tip).addClass(CLASS_NAME_SHOW$4);
                $__default["default"](tip).addClass(this.config.customClass); // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ("ontouchstart" in document.documentElement) $__default["default"](document.body).children().on("mouseover", null, $__default["default"].noop);
                var complete = function complete() {
                    if (_this.config.animation) _this._fixTransition();
                    var prevHoverState = _this._hoverState;
                    _this._hoverState = null;
                    $__default["default"](_this.element).trigger(_this.constructor.Event.SHOWN);
                    if (prevHoverState === HOVER_STATE_OUT) _this._leave(null, _this);
                };
                if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$2)) {
                    var transitionDuration = Util.getTransitionDurationFromElement(this.tip);
                    $__default["default"](this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
                } else complete();
            }
        };
        _proto.hide = function hide(callback) {
            var _this2 = this;
            var tip = this.getTipElement();
            var hideEvent = $__default["default"].Event(this.constructor.Event.HIDE);
            var complete = function complete() {
                if (_this2._hoverState !== HOVER_STATE_SHOW && tip.parentNode) tip.parentNode.removeChild(tip);
                _this2._cleanTipClass();
                _this2.element.removeAttribute("aria-describedby");
                $__default["default"](_this2.element).trigger(_this2.constructor.Event.HIDDEN);
                if (_this2._popper !== null) _this2._popper.destroy();
                if (callback) callback();
            };
            $__default["default"](this.element).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            $__default["default"](tip).removeClass(CLASS_NAME_SHOW$4); // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ("ontouchstart" in document.documentElement) $__default["default"](document.body).children().off("mouseover", null, $__default["default"].noop);
            this._activeTrigger[TRIGGER_CLICK] = false;
            this._activeTrigger[TRIGGER_FOCUS] = false;
            this._activeTrigger[TRIGGER_HOVER] = false;
            if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$2)) {
                var transitionDuration = Util.getTransitionDurationFromElement(tip);
                $__default["default"](tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
            this._hoverState = "";
        };
        _proto.update = function update() {
            if (this._popper !== null) this._popper.scheduleUpdate();
        } // Protected
        ;
        _proto.isWithContent = function isWithContent() {
            return Boolean(this.getTitle());
        };
        _proto.addAttachmentClass = function addAttachmentClass(attachment) {
            $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
        };
        _proto.getTipElement = function getTipElement() {
            this.tip = this.tip || $__default["default"](this.config.template)[0];
            return this.tip;
        };
        _proto.setContent = function setContent() {
            var tip = this.getTipElement();
            this.setElementContent($__default["default"](tip.querySelectorAll(SELECTOR_TOOLTIP_INNER)), this.getTitle());
            $__default["default"](tip).removeClass(CLASS_NAME_FADE$2 + " " + CLASS_NAME_SHOW$4);
        };
        _proto.setElementContent = function setElementContent($element, content) {
            if (typeof content === "object" && (content.nodeType || content.jquery)) {
                // Content is a DOM node or a jQuery
                if (this.config.html) {
                    if (!$__default["default"](content).parent().is($element)) $element.empty().append(content);
                } else $element.text($__default["default"](content).text());
                return;
            }
            if (this.config.html) {
                if (this.config.sanitize) content = sanitizeHtml(content, this.config.whiteList, this.config.sanitizeFn);
                $element.html(content);
            } else $element.text(content);
        };
        _proto.getTitle = function getTitle() {
            var title = this.element.getAttribute("data-original-title");
            if (!title) title = typeof this.config.title === "function" ? this.config.title.call(this.element) : this.config.title;
            return title;
        } // Private
        ;
        _proto._getPopperConfig = function _getPopperConfig(attachment) {
            var _this3 = this;
            var defaultBsConfig = {
                placement: attachment,
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        behavior: this.config.fallbackPlacement
                    },
                    arrow: {
                        element: SELECTOR_ARROW
                    },
                    preventOverflow: {
                        boundariesElement: this.config.boundary
                    }
                },
                onCreate: function onCreate(data) {
                    if (data.originalPlacement !== data.placement) _this3._handlePopperPlacementChange(data);
                },
                onUpdate: function onUpdate(data) {
                    return _this3._handlePopperPlacementChange(data);
                }
            };
            return _extends({}, defaultBsConfig, this.config.popperConfig);
        };
        _proto._getOffset = function _getOffset() {
            var _this4 = this;
            var offset = {};
            if (typeof this.config.offset === "function") offset.fn = function(data) {
                data.offsets = _extends({}, data.offsets, _this4.config.offset(data.offsets, _this4.element) || {});
                return data;
            };
            else offset.offset = this.config.offset;
            return offset;
        };
        _proto._getContainer = function _getContainer() {
            if (this.config.container === false) return document.body;
            if (Util.isElement(this.config.container)) return $__default["default"](this.config.container);
            return $__default["default"](document).find(this.config.container);
        };
        _proto._getAttachment = function _getAttachment(placement) {
            return AttachmentMap[placement.toUpperCase()];
        };
        _proto._setListeners = function _setListeners() {
            var _this5 = this;
            var triggers = this.config.trigger.split(" ");
            triggers.forEach(function(trigger) {
                if (trigger === "click") $__default["default"](_this5.element).on(_this5.constructor.Event.CLICK, _this5.config.selector, function(event) {
                    return _this5.toggle(event);
                });
                else if (trigger !== TRIGGER_MANUAL) {
                    var eventIn = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSEENTER : _this5.constructor.Event.FOCUSIN;
                    var eventOut = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSELEAVE : _this5.constructor.Event.FOCUSOUT;
                    $__default["default"](_this5.element).on(eventIn, _this5.config.selector, function(event) {
                        return _this5._enter(event);
                    }).on(eventOut, _this5.config.selector, function(event) {
                        return _this5._leave(event);
                    });
                }
            });
            this._hideModalHandler = function() {
                if (_this5.element) _this5.hide();
            };
            $__default["default"](this.element).closest(".modal").on("hide.bs.modal", this._hideModalHandler);
            if (this.config.selector) this.config = _extends({}, this.config, {
                trigger: "manual",
                selector: ""
            });
            else this._fixTitle();
        };
        _proto._fixTitle = function _fixTitle() {
            var titleType = typeof this.element.getAttribute("data-original-title");
            if (this.element.getAttribute("title") || titleType !== "string") {
                this.element.setAttribute("data-original-title", this.element.getAttribute("title") || "");
                this.element.setAttribute("title", "");
            }
        };
        _proto._enter = function _enter(event, context) {
            var dataKey = this.constructor.DATA_KEY;
            context = context || $__default["default"](event.currentTarget).data(dataKey);
            if (!context) {
                context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                $__default["default"](event.currentTarget).data(dataKey, context);
            }
            if (event) context._activeTrigger[event.type === "focusin" ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
            if ($__default["default"](context.getTipElement()).hasClass(CLASS_NAME_SHOW$4) || context._hoverState === HOVER_STATE_SHOW) {
                context._hoverState = HOVER_STATE_SHOW;
                return;
            }
            clearTimeout(context._timeout);
            context._hoverState = HOVER_STATE_SHOW;
            if (!context.config.delay || !context.config.delay.show) {
                context.show();
                return;
            }
            context._timeout = setTimeout(function() {
                if (context._hoverState === HOVER_STATE_SHOW) context.show();
            }, context.config.delay.show);
        };
        _proto._leave = function _leave(event, context) {
            var dataKey = this.constructor.DATA_KEY;
            context = context || $__default["default"](event.currentTarget).data(dataKey);
            if (!context) {
                context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                $__default["default"](event.currentTarget).data(dataKey, context);
            }
            if (event) context._activeTrigger[event.type === "focusout" ? TRIGGER_FOCUS : TRIGGER_HOVER] = false;
            if (context._isWithActiveTrigger()) return;
            clearTimeout(context._timeout);
            context._hoverState = HOVER_STATE_OUT;
            if (!context.config.delay || !context.config.delay.hide) {
                context.hide();
                return;
            }
            context._timeout = setTimeout(function() {
                if (context._hoverState === HOVER_STATE_OUT) context.hide();
            }, context.config.delay.hide);
        };
        _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
            for(var trigger in this._activeTrigger){
                if (this._activeTrigger[trigger]) return true;
            }
            return false;
        };
        _proto._getConfig = function _getConfig(config) {
            var dataAttributes = $__default["default"](this.element).data();
            Object.keys(dataAttributes).forEach(function(dataAttr) {
                if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) delete dataAttributes[dataAttr];
            });
            config = _extends({}, this.constructor.Default, dataAttributes, typeof config === "object" && config ? config : {});
            if (typeof config.delay === "number") config.delay = {
                show: config.delay,
                hide: config.delay
            };
            if (typeof config.title === "number") config.title = config.title.toString();
            if (typeof config.content === "number") config.content = config.content.toString();
            Util.typeCheckConfig(NAME$6, config, this.constructor.DefaultType);
            if (config.sanitize) config.template = sanitizeHtml(config.template, config.whiteList, config.sanitizeFn);
            return config;
        };
        _proto._getDelegateConfig = function _getDelegateConfig() {
            var config = {};
            if (this.config) {
                for(var key in this.config)if (this.constructor.Default[key] !== this.config[key]) config[key] = this.config[key];
            }
            return config;
        };
        _proto._cleanTipClass = function _cleanTipClass() {
            var $tip = $__default["default"](this.getTipElement());
            var tabClass = $tip.attr("class").match(BSCLS_PREFIX_REGEX);
            if (tabClass !== null && tabClass.length) $tip.removeClass(tabClass.join(""));
        };
        _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(popperData) {
            this.tip = popperData.instance.popper;
            this._cleanTipClass();
            this.addAttachmentClass(this._getAttachment(popperData.placement));
        };
        _proto._fixTransition = function _fixTransition() {
            var tip = this.getTipElement();
            var initConfigAnimation = this.config.animation;
            if (tip.getAttribute("x-placement") !== null) return;
            $__default["default"](tip).removeClass(CLASS_NAME_FADE$2);
            this.config.animation = false;
            this.hide();
            this.show();
            this.config.animation = initConfigAnimation;
        } // Static
        ;
        Tooltip._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$6);
                var _config = typeof config === "object" && config;
                if (!data && /dispose|hide/.test(config)) return;
                if (!data) {
                    data = new Tooltip(this, _config);
                    $element.data(DATA_KEY$6, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Tooltip, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$6;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$4;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$6;
                }
            },
            {
                key: "DATA_KEY",
                get: function get() {
                    return DATA_KEY$6;
                }
            },
            {
                key: "Event",
                get: function get() {
                    return Event;
                }
            },
            {
                key: "EVENT_KEY",
                get: function get() {
                    return EVENT_KEY$6;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$4;
                }
            }
        ]);
        return Tooltip;
    }();
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$6] = Tooltip._jQueryInterface;
    $__default["default"].fn[NAME$6].Constructor = Tooltip;
    $__default["default"].fn[NAME$6].noConflict = function() {
        $__default["default"].fn[NAME$6] = JQUERY_NO_CONFLICT$6;
        return Tooltip._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$7 = "popover";
    var VERSION$7 = "4.6.0";
    var DATA_KEY$7 = "bs.popover";
    var EVENT_KEY$7 = "." + DATA_KEY$7;
    var JQUERY_NO_CONFLICT$7 = $__default["default"].fn[NAME$7];
    var CLASS_PREFIX$1 = "bs-popover";
    var BSCLS_PREFIX_REGEX$1 = new RegExp("(^|\\s)" + CLASS_PREFIX$1 + "\\S+", "g");
    var Default$5 = _extends({}, Tooltip.Default, {
        placement: "right",
        trigger: "click",
        content: "",
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    });
    var DefaultType$5 = _extends({}, Tooltip.DefaultType, {
        content: "(string|element|function)"
    });
    var CLASS_NAME_FADE$3 = "fade";
    var CLASS_NAME_SHOW$5 = "show";
    var SELECTOR_TITLE = ".popover-header";
    var SELECTOR_CONTENT = ".popover-body";
    var Event$1 = {
        HIDE: "hide" + EVENT_KEY$7,
        HIDDEN: "hidden" + EVENT_KEY$7,
        SHOW: "show" + EVENT_KEY$7,
        SHOWN: "shown" + EVENT_KEY$7,
        INSERTED: "inserted" + EVENT_KEY$7,
        CLICK: "click" + EVENT_KEY$7,
        FOCUSIN: "focusin" + EVENT_KEY$7,
        FOCUSOUT: "focusout" + EVENT_KEY$7,
        MOUSEENTER: "mouseenter" + EVENT_KEY$7,
        MOUSELEAVE: "mouseleave" + EVENT_KEY$7
    };
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Popover = /*#__PURE__*/ function(_Tooltip) {
        _inheritsLoose(Popover, _Tooltip);
        function Popover() {
            return _Tooltip.apply(this, arguments) || this;
        }
        var _proto = Popover.prototype;
        // Overrides
        _proto.isWithContent = function isWithContent() {
            return this.getTitle() || this._getContent();
        };
        _proto.addAttachmentClass = function addAttachmentClass(attachment) {
            $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX$1 + "-" + attachment);
        };
        _proto.getTipElement = function getTipElement() {
            this.tip = this.tip || $__default["default"](this.config.template)[0];
            return this.tip;
        };
        _proto.setContent = function setContent() {
            var $tip = $__default["default"](this.getTipElement()); // We use append for html objects to maintain js events
            this.setElementContent($tip.find(SELECTOR_TITLE), this.getTitle());
            var content = this._getContent();
            if (typeof content === "function") content = content.call(this.element);
            this.setElementContent($tip.find(SELECTOR_CONTENT), content);
            $tip.removeClass(CLASS_NAME_FADE$3 + " " + CLASS_NAME_SHOW$5);
        } // Private
        ;
        _proto._getContent = function _getContent() {
            return this.element.getAttribute("data-content") || this.config.content;
        };
        _proto._cleanTipClass = function _cleanTipClass() {
            var $tip = $__default["default"](this.getTipElement());
            var tabClass = $tip.attr("class").match(BSCLS_PREFIX_REGEX$1);
            if (tabClass !== null && tabClass.length > 0) $tip.removeClass(tabClass.join(""));
        } // Static
        ;
        Popover._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$7);
                var _config = typeof config === "object" ? config : null;
                if (!data && /dispose|hide/.test(config)) return;
                if (!data) {
                    data = new Popover(this, _config);
                    $__default["default"](this).data(DATA_KEY$7, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Popover, null, [
            {
                key: "VERSION",
                // Getters
                get: function get() {
                    return VERSION$7;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$5;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$7;
                }
            },
            {
                key: "DATA_KEY",
                get: function get() {
                    return DATA_KEY$7;
                }
            },
            {
                key: "Event",
                get: function get() {
                    return Event$1;
                }
            },
            {
                key: "EVENT_KEY",
                get: function get() {
                    return EVENT_KEY$7;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$5;
                }
            }
        ]);
        return Popover;
    }(Tooltip);
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$7] = Popover._jQueryInterface;
    $__default["default"].fn[NAME$7].Constructor = Popover;
    $__default["default"].fn[NAME$7].noConflict = function() {
        $__default["default"].fn[NAME$7] = JQUERY_NO_CONFLICT$7;
        return Popover._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$8 = "scrollspy";
    var VERSION$8 = "4.6.0";
    var DATA_KEY$8 = "bs.scrollspy";
    var EVENT_KEY$8 = "." + DATA_KEY$8;
    var DATA_API_KEY$6 = ".data-api";
    var JQUERY_NO_CONFLICT$8 = $__default["default"].fn[NAME$8];
    var Default$6 = {
        offset: 10,
        method: "auto",
        target: ""
    };
    var DefaultType$6 = {
        offset: "number",
        method: "string",
        target: "(string|element)"
    };
    var EVENT_ACTIVATE = "activate" + EVENT_KEY$8;
    var EVENT_SCROLL = "scroll" + EVENT_KEY$8;
    var EVENT_LOAD_DATA_API$2 = "load" + EVENT_KEY$8 + DATA_API_KEY$6;
    var CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
    var CLASS_NAME_ACTIVE$2 = "active";
    var SELECTOR_DATA_SPY = '[data-spy="scroll"]';
    var SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
    var SELECTOR_NAV_LINKS = ".nav-link";
    var SELECTOR_NAV_ITEMS = ".nav-item";
    var SELECTOR_LIST_ITEMS = ".list-group-item";
    var SELECTOR_DROPDOWN = ".dropdown";
    var SELECTOR_DROPDOWN_ITEMS = ".dropdown-item";
    var SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
    var METHOD_OFFSET = "offset";
    var METHOD_POSITION = "position";
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var ScrollSpy = /*#__PURE__*/ function() {
        function ScrollSpy(element, config) {
            var _this = this;
            this._element = element;
            this._scrollElement = element.tagName === "BODY" ? window : element;
            this._config = this._getConfig(config);
            this._selector = this._config.target + " " + SELECTOR_NAV_LINKS + "," + (this._config.target + " " + SELECTOR_LIST_ITEMS + ",") + (this._config.target + " " + SELECTOR_DROPDOWN_ITEMS);
            this._offsets = [];
            this._targets = [];
            this._activeTarget = null;
            this._scrollHeight = 0;
            $__default["default"](this._scrollElement).on(EVENT_SCROLL, function(event) {
                return _this._process(event);
            });
            this.refresh();
            this._process();
        } // Getters
        var _proto = ScrollSpy.prototype;
        // Public
        _proto.refresh = function refresh() {
            var _this2 = this;
            var autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
            var offsetMethod = this._config.method === "auto" ? autoMethod : this._config.method;
            var offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
            this._offsets = [];
            this._targets = [];
            this._scrollHeight = this._getScrollHeight();
            var targets = [].slice.call(document.querySelectorAll(this._selector));
            targets.map(function(element) {
                var target;
                var targetSelector = Util.getSelectorFromElement(element);
                if (targetSelector) target = document.querySelector(targetSelector);
                if (target) {
                    var targetBCR = target.getBoundingClientRect();
                    if (targetBCR.width || targetBCR.height) // TODO (fat): remove sketch reliance on jQuery position/offset
                    return [
                        $__default["default"](target)[offsetMethod]().top + offsetBase,
                        targetSelector
                    ];
                }
                return null;
            }).filter(function(item) {
                return item;
            }).sort(function(a, b) {
                return a[0] - b[0];
            }).forEach(function(item) {
                _this2._offsets.push(item[0]);
                _this2._targets.push(item[1]);
            });
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$8);
            $__default["default"](this._scrollElement).off(EVENT_KEY$8);
            this._element = null;
            this._scrollElement = null;
            this._config = null;
            this._selector = null;
            this._offsets = null;
            this._targets = null;
            this._activeTarget = null;
            this._scrollHeight = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$6, typeof config === "object" && config ? config : {});
            if (typeof config.target !== "string" && Util.isElement(config.target)) {
                var id = $__default["default"](config.target).attr("id");
                if (!id) {
                    id = Util.getUID(NAME$8);
                    $__default["default"](config.target).attr("id", id);
                }
                config.target = "#" + id;
            }
            Util.typeCheckConfig(NAME$8, config, DefaultType$6);
            return config;
        };
        _proto._getScrollTop = function _getScrollTop() {
            return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
        };
        _proto._getScrollHeight = function _getScrollHeight() {
            return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        };
        _proto._getOffsetHeight = function _getOffsetHeight() {
            return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
        };
        _proto._process = function _process() {
            var scrollTop = this._getScrollTop() + this._config.offset;
            var scrollHeight = this._getScrollHeight();
            var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();
            if (this._scrollHeight !== scrollHeight) this.refresh();
            if (scrollTop >= maxScroll) {
                var target = this._targets[this._targets.length - 1];
                if (this._activeTarget !== target) this._activate(target);
                return;
            }
            if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
                this._activeTarget = null;
                this._clear();
                return;
            }
            for(var i = this._offsets.length; i--;){
                var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === "undefined" || scrollTop < this._offsets[i + 1]);
                if (isActiveTarget) this._activate(this._targets[i]);
            }
        };
        _proto._activate = function _activate(target) {
            this._activeTarget = target;
            this._clear();
            var queries = this._selector.split(",").map(function(selector) {
                return selector + '[data-target="' + target + '"],' + selector + '[href="' + target + '"]';
            });
            var $link = $__default["default"]([].slice.call(document.querySelectorAll(queries.join(","))));
            if ($link.hasClass(CLASS_NAME_DROPDOWN_ITEM)) {
                $link.closest(SELECTOR_DROPDOWN).find(SELECTOR_DROPDOWN_TOGGLE).addClass(CLASS_NAME_ACTIVE$2);
                $link.addClass(CLASS_NAME_ACTIVE$2);
            } else {
                // Set triggered link as active
                $link.addClass(CLASS_NAME_ACTIVE$2); // Set triggered links parents as active
                // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                $link.parents(SELECTOR_NAV_LIST_GROUP).prev(SELECTOR_NAV_LINKS + ", " + SELECTOR_LIST_ITEMS).addClass(CLASS_NAME_ACTIVE$2); // Handle special case when .nav-link is inside .nav-item
                $link.parents(SELECTOR_NAV_LIST_GROUP).prev(SELECTOR_NAV_ITEMS).children(SELECTOR_NAV_LINKS).addClass(CLASS_NAME_ACTIVE$2);
            }
            $__default["default"](this._scrollElement).trigger(EVENT_ACTIVATE, {
                relatedTarget: target
            });
        };
        _proto._clear = function _clear() {
            [].slice.call(document.querySelectorAll(this._selector)).filter(function(node) {
                return node.classList.contains(CLASS_NAME_ACTIVE$2);
            }).forEach(function(node) {
                return node.classList.remove(CLASS_NAME_ACTIVE$2);
            });
        } // Static
        ;
        ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$8);
                var _config = typeof config === "object" && config;
                if (!data) {
                    data = new ScrollSpy(this, _config);
                    $__default["default"](this).data(DATA_KEY$8, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(ScrollSpy, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$8;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$6;
                }
            }
        ]);
        return ScrollSpy;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](window).on(EVENT_LOAD_DATA_API$2, function() {
        var scrollSpys = [].slice.call(document.querySelectorAll(SELECTOR_DATA_SPY));
        var scrollSpysLength = scrollSpys.length;
        for(var i = scrollSpysLength; i--;){
            var $spy = $__default["default"](scrollSpys[i]);
            ScrollSpy._jQueryInterface.call($spy, $spy.data());
        }
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$8] = ScrollSpy._jQueryInterface;
    $__default["default"].fn[NAME$8].Constructor = ScrollSpy;
    $__default["default"].fn[NAME$8].noConflict = function() {
        $__default["default"].fn[NAME$8] = JQUERY_NO_CONFLICT$8;
        return ScrollSpy._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$9 = "tab";
    var VERSION$9 = "4.6.0";
    var DATA_KEY$9 = "bs.tab";
    var EVENT_KEY$9 = "." + DATA_KEY$9;
    var DATA_API_KEY$7 = ".data-api";
    var JQUERY_NO_CONFLICT$9 = $__default["default"].fn[NAME$9];
    var EVENT_HIDE$3 = "hide" + EVENT_KEY$9;
    var EVENT_HIDDEN$3 = "hidden" + EVENT_KEY$9;
    var EVENT_SHOW$3 = "show" + EVENT_KEY$9;
    var EVENT_SHOWN$3 = "shown" + EVENT_KEY$9;
    var EVENT_CLICK_DATA_API$6 = "click" + EVENT_KEY$9 + DATA_API_KEY$7;
    var CLASS_NAME_DROPDOWN_MENU = "dropdown-menu";
    var CLASS_NAME_ACTIVE$3 = "active";
    var CLASS_NAME_DISABLED$1 = "disabled";
    var CLASS_NAME_FADE$4 = "fade";
    var CLASS_NAME_SHOW$6 = "show";
    var SELECTOR_DROPDOWN$1 = ".dropdown";
    var SELECTOR_NAV_LIST_GROUP$1 = ".nav, .list-group";
    var SELECTOR_ACTIVE$2 = ".active";
    var SELECTOR_ACTIVE_UL = "> li > .active";
    var SELECTOR_DATA_TOGGLE$4 = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]';
    var SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
    var SELECTOR_DROPDOWN_ACTIVE_CHILD = "> .dropdown-menu .active";
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Tab = /*#__PURE__*/ function() {
        function Tab(element) {
            this._element = element;
        } // Getters
        var _proto = Tab.prototype;
        // Public
        _proto.show = function show() {
            var _this = this;
            if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $__default["default"](this._element).hasClass(CLASS_NAME_ACTIVE$3) || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1)) return;
            var target;
            var previous;
            var listElement = $__default["default"](this._element).closest(SELECTOR_NAV_LIST_GROUP$1)[0];
            var selector = Util.getSelectorFromElement(this._element);
            if (listElement) {
                var itemSelector = listElement.nodeName === "UL" || listElement.nodeName === "OL" ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE$2;
                previous = $__default["default"].makeArray($__default["default"](listElement).find(itemSelector));
                previous = previous[previous.length - 1];
            }
            var hideEvent = $__default["default"].Event(EVENT_HIDE$3, {
                relatedTarget: this._element
            });
            var showEvent = $__default["default"].Event(EVENT_SHOW$3, {
                relatedTarget: previous
            });
            if (previous) $__default["default"](previous).trigger(hideEvent);
            $__default["default"](this._element).trigger(showEvent);
            if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return;
            if (selector) target = document.querySelector(selector);
            this._activate(this._element, listElement);
            var complete = function complete() {
                var hiddenEvent = $__default["default"].Event(EVENT_HIDDEN$3, {
                    relatedTarget: _this._element
                });
                var shownEvent = $__default["default"].Event(EVENT_SHOWN$3, {
                    relatedTarget: previous
                });
                $__default["default"](previous).trigger(hiddenEvent);
                $__default["default"](_this._element).trigger(shownEvent);
            };
            if (target) this._activate(target, target.parentNode, complete);
            else complete();
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$9);
            this._element = null;
        } // Private
        ;
        _proto._activate = function _activate(element, container, callback) {
            var _this2 = this;
            var activeElements = container && (container.nodeName === "UL" || container.nodeName === "OL") ? $__default["default"](container).find(SELECTOR_ACTIVE_UL) : $__default["default"](container).children(SELECTOR_ACTIVE$2);
            var active = activeElements[0];
            var isTransitioning = callback && active && $__default["default"](active).hasClass(CLASS_NAME_FADE$4);
            var complete = function complete() {
                return _this2._transitionComplete(element, active, callback);
            };
            if (active && isTransitioning) {
                var transitionDuration = Util.getTransitionDurationFromElement(active);
                $__default["default"](active).removeClass(CLASS_NAME_SHOW$6).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto._transitionComplete = function _transitionComplete(element, active, callback) {
            if (active) {
                $__default["default"](active).removeClass(CLASS_NAME_ACTIVE$3);
                var dropdownChild = $__default["default"](active.parentNode).find(SELECTOR_DROPDOWN_ACTIVE_CHILD)[0];
                if (dropdownChild) $__default["default"](dropdownChild).removeClass(CLASS_NAME_ACTIVE$3);
                if (active.getAttribute("role") === "tab") active.setAttribute("aria-selected", false);
            }
            $__default["default"](element).addClass(CLASS_NAME_ACTIVE$3);
            if (element.getAttribute("role") === "tab") element.setAttribute("aria-selected", true);
            Util.reflow(element);
            if (element.classList.contains(CLASS_NAME_FADE$4)) element.classList.add(CLASS_NAME_SHOW$6);
            if (element.parentNode && $__default["default"](element.parentNode).hasClass(CLASS_NAME_DROPDOWN_MENU)) {
                var dropdownElement = $__default["default"](element).closest(SELECTOR_DROPDOWN$1)[0];
                if (dropdownElement) {
                    var dropdownToggleList = [].slice.call(dropdownElement.querySelectorAll(SELECTOR_DROPDOWN_TOGGLE$1));
                    $__default["default"](dropdownToggleList).addClass(CLASS_NAME_ACTIVE$3);
                }
                element.setAttribute("aria-expanded", true);
            }
            if (callback) callback();
        } // Static
        ;
        Tab._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $this = $__default["default"](this);
                var data = $this.data(DATA_KEY$9);
                if (!data) {
                    data = new Tab(this);
                    $this.data(DATA_KEY$9, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Tab, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$9;
                }
            }
        ]);
        return Tab;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$6, SELECTOR_DATA_TOGGLE$4, function(event) {
        event.preventDefault();
        Tab._jQueryInterface.call($__default["default"](this), "show");
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$9] = Tab._jQueryInterface;
    $__default["default"].fn[NAME$9].Constructor = Tab;
    $__default["default"].fn[NAME$9].noConflict = function() {
        $__default["default"].fn[NAME$9] = JQUERY_NO_CONFLICT$9;
        return Tab._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$a = "toast";
    var VERSION$a = "4.6.0";
    var DATA_KEY$a = "bs.toast";
    var EVENT_KEY$a = "." + DATA_KEY$a;
    var JQUERY_NO_CONFLICT$a = $__default["default"].fn[NAME$a];
    var EVENT_CLICK_DISMISS$1 = "click.dismiss" + EVENT_KEY$a;
    var EVENT_HIDE$4 = "hide" + EVENT_KEY$a;
    var EVENT_HIDDEN$4 = "hidden" + EVENT_KEY$a;
    var EVENT_SHOW$4 = "show" + EVENT_KEY$a;
    var EVENT_SHOWN$4 = "shown" + EVENT_KEY$a;
    var CLASS_NAME_FADE$5 = "fade";
    var CLASS_NAME_HIDE = "hide";
    var CLASS_NAME_SHOW$7 = "show";
    var CLASS_NAME_SHOWING = "showing";
    var DefaultType$7 = {
        animation: "boolean",
        autohide: "boolean",
        delay: "number"
    };
    var Default$7 = {
        animation: true,
        autohide: true,
        delay: 500
    };
    var SELECTOR_DATA_DISMISS$1 = '[data-dismiss="toast"]';
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Toast = /*#__PURE__*/ function() {
        function Toast(element, config) {
            this._element = element;
            this._config = this._getConfig(config);
            this._timeout = null;
            this._setListeners();
        } // Getters
        var _proto = Toast.prototype;
        // Public
        _proto.show = function show() {
            var _this = this;
            var showEvent = $__default["default"].Event(EVENT_SHOW$4);
            $__default["default"](this._element).trigger(showEvent);
            if (showEvent.isDefaultPrevented()) return;
            this._clearTimeout();
            if (this._config.animation) this._element.classList.add(CLASS_NAME_FADE$5);
            var complete = function complete() {
                _this._element.classList.remove(CLASS_NAME_SHOWING);
                _this._element.classList.add(CLASS_NAME_SHOW$7);
                $__default["default"](_this._element).trigger(EVENT_SHOWN$4);
                if (_this._config.autohide) _this._timeout = setTimeout(function() {
                    _this.hide();
                }, _this._config.delay);
            };
            this._element.classList.remove(CLASS_NAME_HIDE);
            Util.reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOWING);
            if (this._config.animation) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto.hide = function hide() {
            if (!this._element.classList.contains(CLASS_NAME_SHOW$7)) return;
            var hideEvent = $__default["default"].Event(EVENT_HIDE$4);
            $__default["default"](this._element).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            this._close();
        };
        _proto.dispose = function dispose() {
            this._clearTimeout();
            if (this._element.classList.contains(CLASS_NAME_SHOW$7)) this._element.classList.remove(CLASS_NAME_SHOW$7);
            $__default["default"](this._element).off(EVENT_CLICK_DISMISS$1);
            $__default["default"].removeData(this._element, DATA_KEY$a);
            this._element = null;
            this._config = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$7, $__default["default"](this._element).data(), typeof config === "object" && config ? config : {});
            Util.typeCheckConfig(NAME$a, config, this.constructor.DefaultType);
            return config;
        };
        _proto._setListeners = function _setListeners() {
            var _this2 = this;
            $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, SELECTOR_DATA_DISMISS$1, function() {
                return _this2.hide();
            });
        };
        _proto._close = function _close() {
            var _this3 = this;
            var complete = function complete() {
                _this3._element.classList.add(CLASS_NAME_HIDE);
                $__default["default"](_this3._element).trigger(EVENT_HIDDEN$4);
            };
            this._element.classList.remove(CLASS_NAME_SHOW$7);
            if (this._config.animation) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto._clearTimeout = function _clearTimeout() {
            clearTimeout(this._timeout);
            this._timeout = null;
        } // Static
        ;
        Toast._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$a);
                var _config = typeof config === "object" && config;
                if (!data) {
                    data = new Toast(this, _config);
                    $element.data(DATA_KEY$a, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config](this);
                }
            });
        };
        _createClass(Toast, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$a;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$7;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$7;
                }
            }
        ]);
        return Toast;
    }();
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$a] = Toast._jQueryInterface;
    $__default["default"].fn[NAME$a].Constructor = Toast;
    $__default["default"].fn[NAME$a].noConflict = function() {
        $__default["default"].fn[NAME$a] = JQUERY_NO_CONFLICT$a;
        return Toast._jQueryInterface;
    };
    exports1.Alert = Alert;
    exports1.Button = Button;
    exports1.Carousel = Carousel;
    exports1.Collapse = Collapse;
    exports1.Dropdown = Dropdown;
    exports1.Modal = Modal;
    exports1.Popover = Popover;
    exports1.Scrollspy = ScrollSpy;
    exports1.Tab = Tab;
    exports1.Toast = Toast;
    exports1.Tooltip = Tooltip;
    exports1.Util = Util;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


var $281952584ed073af$exports = {};

/*!
 * Bootstrap-select v1.13.18 (https://developer.snapappointments.com/bootstrap-select)
 *
 * Copyright 2012-2020 SnapAppointments, LLC
 * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)
 */ (function(root, factory) {
    if (root === undefined && window !== undefined) root = window;
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module unless amdModuleId is set
    define([
        "jquery"
    ], function(a0) {
        return factory(a0);
    });
    else if (0, $281952584ed073af$exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    $281952584ed073af$exports = factory((parcelRequire("ef6Fp")));
    else factory(root["jQuery"]);
})($281952584ed073af$exports, function(jQuery) {
    (function($) {
        "use strict";
        var DISALLOWED_ATTRIBUTES = [
            "sanitize",
            "whiteList",
            "sanitizeFn"
        ];
        var uriAttrs = [
            "background",
            "cite",
            "href",
            "itemtype",
            "longdesc",
            "poster",
            "src",
            "xlink:href"
        ];
        var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
        var DefaultWhitelist = {
            // Global attributes allowed on any supplied element below.
            "*": [
                "class",
                "dir",
                "id",
                "lang",
                "role",
                "tabindex",
                "style",
                ARIA_ATTRIBUTE_PATTERN
            ],
            a: [
                "target",
                "href",
                "title",
                "rel"
            ],
            area: [],
            b: [],
            br: [],
            col: [],
            code: [],
            div: [],
            em: [],
            hr: [],
            h1: [],
            h2: [],
            h3: [],
            h4: [],
            h5: [],
            h6: [],
            i: [],
            img: [
                "src",
                "alt",
                "title",
                "width",
                "height"
            ],
            li: [],
            ol: [],
            p: [],
            pre: [],
            s: [],
            small: [],
            span: [],
            sub: [],
            sup: [],
            strong: [],
            u: [],
            ul: []
        };
        /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */ var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
        /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */ var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;
        function allowedAttribute(attr, allowedAttributeList) {
            var attrName = attr.nodeName.toLowerCase();
            if ($.inArray(attrName, allowedAttributeList) !== -1) {
                if ($.inArray(attrName, uriAttrs) !== -1) return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
                return true;
            }
            var regExp = $(allowedAttributeList).filter(function(index, value) {
                return value instanceof RegExp;
            });
            // Check if a regular expression validates the attribute.
            for(var i = 0, l = regExp.length; i < l; i++){
                if (attrName.match(regExp[i])) return true;
            }
            return false;
        }
        function sanitizeHtml(unsafeElements, whiteList, sanitizeFn) {
            if (sanitizeFn && typeof sanitizeFn === "function") return sanitizeFn(unsafeElements);
            var whitelistKeys = Object.keys(whiteList);
            for(var i = 0, len = unsafeElements.length; i < len; i++){
                var elements = unsafeElements[i].querySelectorAll("*");
                for(var j = 0, len2 = elements.length; j < len2; j++){
                    var el = elements[j];
                    var elName = el.nodeName.toLowerCase();
                    if (whitelistKeys.indexOf(elName) === -1) {
                        el.parentNode.removeChild(el);
                        continue;
                    }
                    var attributeList = [].slice.call(el.attributes);
                    var whitelistedAttributes = [].concat(whiteList["*"] || [], whiteList[elName] || []);
                    for(var k = 0, len3 = attributeList.length; k < len3; k++){
                        var attr = attributeList[k];
                        if (!allowedAttribute(attr, whitelistedAttributes)) el.removeAttribute(attr.nodeName);
                    }
                }
            }
        }
        // Polyfill for browsers with no classList support
        // Remove in v2
        if (!("classList" in document.createElement("_"))) (function(view) {
            if (!("Element" in view)) return;
            var classListProp = "classList", protoProp = "prototype", elemCtrProto = view.Element[protoProp], objCtr = Object, classListGetter = function() {
                var $elem = $(this);
                return {
                    add: function(classes) {
                        classes = Array.prototype.slice.call(arguments).join(" ");
                        return $elem.addClass(classes);
                    },
                    remove: function(classes) {
                        classes = Array.prototype.slice.call(arguments).join(" ");
                        return $elem.removeClass(classes);
                    },
                    toggle: function(classes, force) {
                        return $elem.toggleClass(classes, force);
                    },
                    contains: function(classes) {
                        return $elem.hasClass(classes);
                    }
                };
            };
            if (objCtr.defineProperty) {
                var classListPropDesc = {
                    get: classListGetter,
                    enumerable: true,
                    configurable: true
                };
                try {
                    objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                } catch (ex) {
                    // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
                    // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
                    if (ex.number === undefined || ex.number === -2146823252) {
                        classListPropDesc.enumerable = false;
                        objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                    }
                }
            } else if (objCtr[protoProp].__defineGetter__) elemCtrProto.__defineGetter__(classListProp, classListGetter);
        })(window);
        var testElement = document.createElement("_");
        testElement.classList.add("c1", "c2");
        if (!testElement.classList.contains("c2")) {
            var _add = DOMTokenList.prototype.add, _remove = DOMTokenList.prototype.remove;
            DOMTokenList.prototype.add = function() {
                Array.prototype.forEach.call(arguments, _add.bind(this));
            };
            DOMTokenList.prototype.remove = function() {
                Array.prototype.forEach.call(arguments, _remove.bind(this));
            };
        }
        testElement.classList.toggle("c3", false);
        // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
        // support the second argument.
        if (testElement.classList.contains("c3")) {
            var _toggle = DOMTokenList.prototype.toggle;
            DOMTokenList.prototype.toggle = function(token, force) {
                if (1 in arguments && !this.contains(token) === !force) return force;
                else return _toggle.call(this, token);
            };
        }
        testElement = null;
        // shallow array comparison
        function isEqual(array1, array2) {
            return array1.length === array2.length && array1.every(function(element, index) {
                return element === array2[index];
            });
        }
        // <editor-fold desc="Shims">
        if (!String.prototype.startsWith) (function() {
            "use strict"; // needed to support `apply`/`call` with `undefined`/`null`
            var defineProperty = function() {
                // IE 8 only supports `Object.defineProperty` on DOM elements
                try {
                    var object = {};
                    var $defineProperty = Object.defineProperty;
                    var result = $defineProperty(object, object, object) && $defineProperty;
                } catch (error) {}
                return result;
            }();
            var toString = {}.toString;
            var startsWith = function(search) {
                if (this == null) throw new TypeError();
                var string = String(this);
                if (search && toString.call(search) == "[object RegExp]") throw new TypeError();
                var stringLength = string.length;
                var searchString = String(search);
                var searchLength = searchString.length;
                var position = arguments.length > 1 ? arguments[1] : undefined;
                // `ToInteger`
                var pos = position ? Number(position) : 0;
                if (pos != pos) pos = 0;
                var start = Math.min(Math.max(pos, 0), stringLength);
                // Avoid the `indexOf` call if no match is possible
                if (searchLength + start > stringLength) return false;
                var index = -1;
                while(++index < searchLength){
                    if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) return false;
                }
                return true;
            };
            if (defineProperty) defineProperty(String.prototype, "startsWith", {
                "value": startsWith,
                "configurable": true,
                "writable": true
            });
            else String.prototype.startsWith = startsWith;
        })();
        if (!Object.keys) Object.keys = function(o, k, r // result array
        ) {
            // initialize object and result
            r = [];
            // iterate over object keys
            for(k in o)// fill result array with non-prototypical keys
            r.hasOwnProperty.call(o, k) && r.push(k);
            // return result
            return r;
        };
        if (HTMLSelectElement && !HTMLSelectElement.prototype.hasOwnProperty("selectedOptions")) Object.defineProperty(HTMLSelectElement.prototype, "selectedOptions", {
            get: function() {
                return this.querySelectorAll(":checked");
            }
        });
        function getSelectedOptions(select, ignoreDisabled) {
            var selectedOptions = select.selectedOptions, options = [], opt;
            if (ignoreDisabled) {
                for(var i = 0, len = selectedOptions.length; i < len; i++){
                    opt = selectedOptions[i];
                    if (!(opt.disabled || opt.parentNode.tagName === "OPTGROUP" && opt.parentNode.disabled)) options.push(opt);
                }
                return options;
            }
            return selectedOptions;
        }
        // much faster than $.val()
        function getSelectValues(select, selectedOptions) {
            var value = [], options = selectedOptions || select.selectedOptions, opt;
            for(var i = 0, len = options.length; i < len; i++){
                opt = options[i];
                if (!(opt.disabled || opt.parentNode.tagName === "OPTGROUP" && opt.parentNode.disabled)) value.push(opt.value);
            }
            if (!select.multiple) return !value.length ? null : value[0];
            return value;
        }
        // set data-selected on select element if the value has been programmatically selected
        // prior to initialization of bootstrap-select
        // * consider removing or replacing an alternative method *
        var valHooks = {
            useDefault: false,
            _set: $.valHooks.select.set
        };
        $.valHooks.select.set = function(elem, value) {
            if (value && !valHooks.useDefault) $(elem).data("selected", true);
            return valHooks._set.apply(this, arguments);
        };
        var changedArguments = null;
        var EventIsSupported = function() {
            try {
                new Event("change");
                return true;
            } catch (e) {
                return false;
            }
        }();
        $.fn.triggerNative = function(eventName) {
            var el = this[0], event;
            if (el.dispatchEvent) {
                if (EventIsSupported) // For modern browsers
                event = new Event(eventName, {
                    bubbles: true
                });
                else {
                    // For IE since it doesn't support Event constructor
                    event = document.createEvent("Event");
                    event.initEvent(eventName, true, false);
                }
                el.dispatchEvent(event);
            } else if (el.fireEvent) {
                event = document.createEventObject();
                event.eventType = eventName;
                el.fireEvent("on" + eventName, event);
            } else // fall back to jQuery.trigger
            this.trigger(eventName);
        };
        // </editor-fold>
        function stringSearch(li, searchString, method, normalize) {
            var stringTypes = [
                "display",
                "subtext",
                "tokens"
            ], searchSuccess = false;
            for(var i = 0; i < stringTypes.length; i++){
                var stringType = stringTypes[i], string = li[stringType];
                if (string) {
                    string = string.toString();
                    // Strip HTML tags. This isn't perfect, but it's much faster than any other method
                    if (stringType === "display") string = string.replace(/<[^>]+>/g, "");
                    if (normalize) string = normalizeToBase(string);
                    string = string.toUpperCase();
                    if (method === "contains") searchSuccess = string.indexOf(searchString) >= 0;
                    else searchSuccess = string.startsWith(searchString);
                    if (searchSuccess) break;
                }
            }
            return searchSuccess;
        }
        function toInteger(value) {
            return parseInt(value, 10) || 0;
        }
        // Borrowed from Lodash (_.deburr)
        /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
            // Latin-1 Supplement block.
            "\xc0": "A",
            "\xc1": "A",
            "\xc2": "A",
            "\xc3": "A",
            "\xc4": "A",
            "\xc5": "A",
            "\xe0": "a",
            "\xe1": "a",
            "\xe2": "a",
            "\xe3": "a",
            "\xe4": "a",
            "\xe5": "a",
            "\xc7": "C",
            "\xe7": "c",
            "\xd0": "D",
            "\xf0": "d",
            "\xc8": "E",
            "\xc9": "E",
            "\xca": "E",
            "\xcb": "E",
            "\xe8": "e",
            "\xe9": "e",
            "\xea": "e",
            "\xeb": "e",
            "\xcc": "I",
            "\xcd": "I",
            "\xce": "I",
            "\xcf": "I",
            "\xec": "i",
            "\xed": "i",
            "\xee": "i",
            "\xef": "i",
            "\xd1": "N",
            "\xf1": "n",
            "\xd2": "O",
            "\xd3": "O",
            "\xd4": "O",
            "\xd5": "O",
            "\xd6": "O",
            "\xd8": "O",
            "\xf2": "o",
            "\xf3": "o",
            "\xf4": "o",
            "\xf5": "o",
            "\xf6": "o",
            "\xf8": "o",
            "\xd9": "U",
            "\xda": "U",
            "\xdb": "U",
            "\xdc": "U",
            "\xf9": "u",
            "\xfa": "u",
            "\xfb": "u",
            "\xfc": "u",
            "\xdd": "Y",
            "\xfd": "y",
            "\xff": "y",
            "\xc6": "Ae",
            "\xe6": "ae",
            "\xde": "Th",
            "\xfe": "th",
            "\xdf": "ss",
            // Latin Extended-A block.
            "\u0100": "A",
            "\u0102": "A",
            "\u0104": "A",
            "\u0101": "a",
            "\u0103": "a",
            "\u0105": "a",
            "\u0106": "C",
            "\u0108": "C",
            "\u010A": "C",
            "\u010C": "C",
            "\u0107": "c",
            "\u0109": "c",
            "\u010B": "c",
            "\u010D": "c",
            "\u010E": "D",
            "\u0110": "D",
            "\u010F": "d",
            "\u0111": "d",
            "\u0112": "E",
            "\u0114": "E",
            "\u0116": "E",
            "\u0118": "E",
            "\u011A": "E",
            "\u0113": "e",
            "\u0115": "e",
            "\u0117": "e",
            "\u0119": "e",
            "\u011B": "e",
            "\u011C": "G",
            "\u011E": "G",
            "\u0120": "G",
            "\u0122": "G",
            "\u011D": "g",
            "\u011F": "g",
            "\u0121": "g",
            "\u0123": "g",
            "\u0124": "H",
            "\u0126": "H",
            "\u0125": "h",
            "\u0127": "h",
            "\u0128": "I",
            "\u012A": "I",
            "\u012C": "I",
            "\u012E": "I",
            "\u0130": "I",
            "\u0129": "i",
            "\u012B": "i",
            "\u012D": "i",
            "\u012F": "i",
            "\u0131": "i",
            "\u0134": "J",
            "\u0135": "j",
            "\u0136": "K",
            "\u0137": "k",
            "\u0138": "k",
            "\u0139": "L",
            "\u013B": "L",
            "\u013D": "L",
            "\u013F": "L",
            "\u0141": "L",
            "\u013A": "l",
            "\u013C": "l",
            "\u013E": "l",
            "\u0140": "l",
            "\u0142": "l",
            "\u0143": "N",
            "\u0145": "N",
            "\u0147": "N",
            "\u014A": "N",
            "\u0144": "n",
            "\u0146": "n",
            "\u0148": "n",
            "\u014B": "n",
            "\u014C": "O",
            "\u014E": "O",
            "\u0150": "O",
            "\u014D": "o",
            "\u014F": "o",
            "\u0151": "o",
            "\u0154": "R",
            "\u0156": "R",
            "\u0158": "R",
            "\u0155": "r",
            "\u0157": "r",
            "\u0159": "r",
            "\u015A": "S",
            "\u015C": "S",
            "\u015E": "S",
            "\u0160": "S",
            "\u015B": "s",
            "\u015D": "s",
            "\u015F": "s",
            "\u0161": "s",
            "\u0162": "T",
            "\u0164": "T",
            "\u0166": "T",
            "\u0163": "t",
            "\u0165": "t",
            "\u0167": "t",
            "\u0168": "U",
            "\u016A": "U",
            "\u016C": "U",
            "\u016E": "U",
            "\u0170": "U",
            "\u0172": "U",
            "\u0169": "u",
            "\u016B": "u",
            "\u016D": "u",
            "\u016F": "u",
            "\u0171": "u",
            "\u0173": "u",
            "\u0174": "W",
            "\u0175": "w",
            "\u0176": "Y",
            "\u0177": "y",
            "\u0178": "Y",
            "\u0179": "Z",
            "\u017B": "Z",
            "\u017D": "Z",
            "\u017A": "z",
            "\u017C": "z",
            "\u017E": "z",
            "\u0132": "IJ",
            "\u0133": "ij",
            "\u0152": "Oe",
            "\u0153": "oe",
            "\u0149": "'n",
            "\u017F": "s"
        };
        /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
        /** Used to compose unicode character classes. */ var rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboMarksExtendedRange = "\\u1ab0-\\u1aff", rsComboMarksSupplementRange = "\\u1dc0-\\u1dff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange + rsComboMarksExtendedRange + rsComboMarksSupplementRange;
        /** Used to compose unicode capture groups. */ var rsCombo = "[" + rsComboRange + "]";
        /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
        function deburrLetter(key) {
            return deburredLetters[key];
        }
        function normalizeToBase(string) {
            string = string.toString();
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        // List of HTML entities for escaping.
        var escapeMap = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "`": "&#x60;"
        };
        // Functions for escaping and unescaping strings to/from HTML interpolation.
        var createEscaper = function(map) {
            var escaper = function(match) {
                return map[match];
            };
            // Regexes for identifying a key that needs to be escaped.
            var source = "(?:" + Object.keys(map).join("|") + ")";
            var testRegexp = RegExp(source);
            var replaceRegexp = RegExp(source, "g");
            return function(string) {
                string = string == null ? "" : "" + string;
                return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
            };
        };
        var htmlEscape = createEscaper(escapeMap);
        /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var keyCodeMap = {
            32: " ",
            48: "0",
            49: "1",
            50: "2",
            51: "3",
            52: "4",
            53: "5",
            54: "6",
            55: "7",
            56: "8",
            57: "9",
            59: ";",
            65: "A",
            66: "B",
            67: "C",
            68: "D",
            69: "E",
            70: "F",
            71: "G",
            72: "H",
            73: "I",
            74: "J",
            75: "K",
            76: "L",
            77: "M",
            78: "N",
            79: "O",
            80: "P",
            81: "Q",
            82: "R",
            83: "S",
            84: "T",
            85: "U",
            86: "V",
            87: "W",
            88: "X",
            89: "Y",
            90: "Z",
            96: "0",
            97: "1",
            98: "2",
            99: "3",
            100: "4",
            101: "5",
            102: "6",
            103: "7",
            104: "8",
            105: "9"
        };
        var keyCodes = {
            ESCAPE: 27,
            ENTER: 13,
            SPACE: 32,
            TAB: 9,
            ARROW_UP: 38,
            ARROW_DOWN: 40 // KeyboardEvent.which value for down arrow key
        };
        var version = {
            success: false,
            major: "3"
        };
        try {
            version.full = ($.fn.dropdown.Constructor.VERSION || "").split(" ")[0].split(".");
            version.major = version.full[0];
            version.success = true;
        } catch (err) {
        // do nothing
        }
        var selectId = 0;
        var EVENT_KEY = ".bs.select";
        var classNames = {
            DISABLED: "disabled",
            DIVIDER: "divider",
            SHOW: "open",
            DROPUP: "dropup",
            MENU: "dropdown-menu",
            MENURIGHT: "dropdown-menu-right",
            MENULEFT: "dropdown-menu-left",
            // to-do: replace with more advanced template/customization options
            BUTTONCLASS: "btn-default",
            POPOVERHEADER: "popover-title",
            ICONBASE: "glyphicon",
            TICKICON: "glyphicon-ok"
        };
        var Selector = {
            MENU: "." + classNames.MENU
        };
        var elementTemplates = {
            div: document.createElement("div"),
            span: document.createElement("span"),
            i: document.createElement("i"),
            subtext: document.createElement("small"),
            a: document.createElement("a"),
            li: document.createElement("li"),
            whitespace: document.createTextNode("\xa0"),
            fragment: document.createDocumentFragment()
        };
        elementTemplates.noResults = elementTemplates.li.cloneNode(false);
        elementTemplates.noResults.className = "no-results";
        elementTemplates.a.setAttribute("role", "option");
        elementTemplates.a.className = "dropdown-item";
        elementTemplates.subtext.className = "text-muted";
        elementTemplates.text = elementTemplates.span.cloneNode(false);
        elementTemplates.text.className = "text";
        elementTemplates.checkMark = elementTemplates.span.cloneNode(false);
        var REGEXP_ARROW = new RegExp(keyCodes.ARROW_UP + "|" + keyCodes.ARROW_DOWN);
        var REGEXP_TAB_OR_ESCAPE = new RegExp("^" + keyCodes.TAB + "$|" + keyCodes.ESCAPE);
        var generateOption = {
            li: function(content, classes, optgroup) {
                var li = elementTemplates.li.cloneNode(false);
                if (content) {
                    if (content.nodeType === 1 || content.nodeType === 11) li.appendChild(content);
                    else li.innerHTML = content;
                }
                if (typeof classes !== "undefined" && classes !== "") li.className = classes;
                if (typeof optgroup !== "undefined" && optgroup !== null) li.classList.add("optgroup-" + optgroup);
                return li;
            },
            a: function(text, classes, inline) {
                var a = elementTemplates.a.cloneNode(true);
                if (text) {
                    if (text.nodeType === 11) a.appendChild(text);
                    else a.insertAdjacentHTML("beforeend", text);
                }
                if (typeof classes !== "undefined" && classes !== "") a.classList.add.apply(a.classList, classes.split(/\s+/));
                if (inline) a.setAttribute("style", inline);
                return a;
            },
            text: function(options, useFragment) {
                var textElement = elementTemplates.text.cloneNode(false), subtextElement, iconElement;
                if (options.content) textElement.innerHTML = options.content;
                else {
                    textElement.textContent = options.text;
                    if (options.icon) {
                        var whitespace = elementTemplates.whitespace.cloneNode(false);
                        // need to use <i> for icons in the button to prevent a breaking change
                        // note: switch to span in next major release
                        iconElement = (useFragment === true ? elementTemplates.i : elementTemplates.span).cloneNode(false);
                        iconElement.className = this.options.iconBase + " " + options.icon;
                        elementTemplates.fragment.appendChild(iconElement);
                        elementTemplates.fragment.appendChild(whitespace);
                    }
                    if (options.subtext) {
                        subtextElement = elementTemplates.subtext.cloneNode(false);
                        subtextElement.textContent = options.subtext;
                        textElement.appendChild(subtextElement);
                    }
                }
                if (useFragment === true) while(textElement.childNodes.length > 0)elementTemplates.fragment.appendChild(textElement.childNodes[0]);
                else elementTemplates.fragment.appendChild(textElement);
                return elementTemplates.fragment;
            },
            label: function(options) {
                var textElement = elementTemplates.text.cloneNode(false), subtextElement, iconElement;
                textElement.innerHTML = options.display;
                if (options.icon) {
                    var whitespace = elementTemplates.whitespace.cloneNode(false);
                    iconElement = elementTemplates.span.cloneNode(false);
                    iconElement.className = this.options.iconBase + " " + options.icon;
                    elementTemplates.fragment.appendChild(iconElement);
                    elementTemplates.fragment.appendChild(whitespace);
                }
                if (options.subtext) {
                    subtextElement = elementTemplates.subtext.cloneNode(false);
                    subtextElement.textContent = options.subtext;
                    textElement.appendChild(subtextElement);
                }
                elementTemplates.fragment.appendChild(textElement);
                return elementTemplates.fragment;
            }
        };
        function showNoResults(searchMatch, searchValue) {
            if (!searchMatch.length) {
                elementTemplates.noResults.innerHTML = this.options.noneResultsText.replace("{0}", '"' + htmlEscape(searchValue) + '"');
                this.$menuInner[0].firstChild.appendChild(elementTemplates.noResults);
            }
        }
        var Selectpicker = function(element, options) {
            var that = this;
            // bootstrap-select has been initialized - revert valHooks.select.set back to its original function
            if (!valHooks.useDefault) {
                $.valHooks.select.set = valHooks._set;
                valHooks.useDefault = true;
            }
            this.$element = $(element);
            this.$newElement = null;
            this.$button = null;
            this.$menu = null;
            this.options = options;
            this.selectpicker = {
                main: {},
                search: {},
                current: {},
                view: {},
                isSearching: false,
                keydown: {
                    keyHistory: "",
                    resetKeyHistory: {
                        start: function() {
                            return setTimeout(function() {
                                that.selectpicker.keydown.keyHistory = "";
                            }, 800);
                        }
                    }
                }
            };
            this.sizeInfo = {};
            // If we have no title yet, try to pull it from the html title attribute (jQuery doesnt' pick it up as it's not a
            // data-attribute)
            if (this.options.title === null) this.options.title = this.$element.attr("title");
            // Format window padding
            var winPad = this.options.windowPadding;
            if (typeof winPad === "number") this.options.windowPadding = [
                winPad,
                winPad,
                winPad,
                winPad
            ];
            // Expose public methods
            this.val = Selectpicker.prototype.val;
            this.render = Selectpicker.prototype.render;
            this.refresh = Selectpicker.prototype.refresh;
            this.setStyle = Selectpicker.prototype.setStyle;
            this.selectAll = Selectpicker.prototype.selectAll;
            this.deselectAll = Selectpicker.prototype.deselectAll;
            this.destroy = Selectpicker.prototype.destroy;
            this.remove = Selectpicker.prototype.remove;
            this.show = Selectpicker.prototype.show;
            this.hide = Selectpicker.prototype.hide;
            this.init();
        };
        Selectpicker.VERSION = "1.13.18";
        // part of this is duplicated in i18n/defaults-en_US.js. Make sure to update both.
        Selectpicker.DEFAULTS = {
            noneSelectedText: "Nothing selected",
            noneResultsText: "No results matched {0}",
            countSelectedText: function(numSelected, numTotal) {
                return numSelected == 1 ? "{0} item selected" : "{0} items selected";
            },
            maxOptionsText: function(numAll, numGroup) {
                return [
                    numAll == 1 ? "Limit reached ({n} item max)" : "Limit reached ({n} items max)",
                    numGroup == 1 ? "Group limit reached ({n} item max)" : "Group limit reached ({n} items max)"
                ];
            },
            selectAllText: "Select All",
            deselectAllText: "Deselect All",
            doneButton: false,
            doneButtonText: "Close",
            multipleSeparator: ", ",
            styleBase: "btn",
            style: classNames.BUTTONCLASS,
            size: "auto",
            title: null,
            selectedTextFormat: "values",
            width: false,
            container: false,
            hideDisabled: false,
            showSubtext: false,
            showIcon: true,
            showContent: true,
            dropupAuto: true,
            header: false,
            liveSearch: false,
            liveSearchPlaceholder: null,
            liveSearchNormalize: false,
            liveSearchStyle: "contains",
            actionsBox: false,
            iconBase: classNames.ICONBASE,
            tickIcon: classNames.TICKICON,
            showTick: false,
            template: {
                caret: '<span class="caret"></span>'
            },
            maxOptions: false,
            mobile: false,
            selectOnTab: false,
            dropdownAlignRight: false,
            windowPadding: 0,
            virtualScroll: 600,
            display: false,
            sanitize: true,
            sanitizeFn: null,
            whiteList: DefaultWhitelist
        };
        Selectpicker.prototype = {
            constructor: Selectpicker,
            init: function() {
                var that = this, id = this.$element.attr("id"), element = this.$element[0], form = element.form;
                selectId++;
                this.selectId = "bs-select-" + selectId;
                element.classList.add("bs-select-hidden");
                this.multiple = this.$element.prop("multiple");
                this.autofocus = this.$element.prop("autofocus");
                if (element.classList.contains("show-tick")) this.options.showTick = true;
                this.$newElement = this.createDropdown();
                this.buildData();
                this.$element.after(this.$newElement).prependTo(this.$newElement);
                // ensure select is associated with form element if it got unlinked after moving it inside newElement
                if (form && element.form === null) {
                    if (!form.id) form.id = "form-" + this.selectId;
                    element.setAttribute("form", form.id);
                }
                this.$button = this.$newElement.children("button");
                this.$menu = this.$newElement.children(Selector.MENU);
                this.$menuInner = this.$menu.children(".inner");
                this.$searchbox = this.$menu.find("input");
                element.classList.remove("bs-select-hidden");
                if (this.options.dropdownAlignRight === true) this.$menu[0].classList.add(classNames.MENURIGHT);
                if (typeof id !== "undefined") this.$button.attr("data-id", id);
                this.checkDisabled();
                this.clickListener();
                if (this.options.liveSearch) {
                    this.liveSearchListener();
                    this.focusedParent = this.$searchbox[0];
                } else this.focusedParent = this.$menuInner[0];
                this.setStyle();
                this.render();
                this.setWidth();
                if (this.options.container) this.selectPosition();
                else this.$element.on("hide" + EVENT_KEY, function() {
                    if (that.isVirtual()) {
                        // empty menu on close
                        var menuInner = that.$menuInner[0], emptyMenu = menuInner.firstChild.cloneNode(false);
                        // replace the existing UL with an empty one - this is faster than $.empty() or innerHTML = ''
                        menuInner.replaceChild(emptyMenu, menuInner.firstChild);
                        menuInner.scrollTop = 0;
                    }
                });
                this.$menu.data("this", this);
                this.$newElement.data("this", this);
                if (this.options.mobile) this.mobile();
                this.$newElement.on({
                    "hide.bs.dropdown": function(e) {
                        that.$element.trigger("hide" + EVENT_KEY, e);
                    },
                    "hidden.bs.dropdown": function(e) {
                        that.$element.trigger("hidden" + EVENT_KEY, e);
                    },
                    "show.bs.dropdown": function(e) {
                        that.$element.trigger("show" + EVENT_KEY, e);
                    },
                    "shown.bs.dropdown": function(e) {
                        that.$element.trigger("shown" + EVENT_KEY, e);
                    }
                });
                if (element.hasAttribute("required")) this.$element.on("invalid" + EVENT_KEY, function() {
                    that.$button[0].classList.add("bs-invalid");
                    that.$element.on("shown" + EVENT_KEY + ".invalid", function() {
                        that.$element.val(that.$element.val()) // set the value to hide the validation message in Chrome when menu is opened
                        .off("shown" + EVENT_KEY + ".invalid");
                    }).on("rendered" + EVENT_KEY, function() {
                        // if select is no longer invalid, remove the bs-invalid class
                        if (this.validity.valid) that.$button[0].classList.remove("bs-invalid");
                        that.$element.off("rendered" + EVENT_KEY);
                    });
                    that.$button.on("blur" + EVENT_KEY, function() {
                        that.$element.trigger("focus").trigger("blur");
                        that.$button.off("blur" + EVENT_KEY);
                    });
                });
                setTimeout(function() {
                    that.buildList();
                    that.$element.trigger("loaded" + EVENT_KEY);
                });
            },
            createDropdown: function() {
                // Options
                // If we are multiple or showTick option is set, then add the show-tick class
                var showTick = this.multiple || this.options.showTick ? " show-tick" : "", multiselectable = this.multiple ? ' aria-multiselectable="true"' : "", inputGroup = "", autofocus = this.autofocus ? " autofocus" : "";
                if (version.major < 4 && this.$element.parent().hasClass("input-group")) inputGroup = " input-group-btn";
                // Elements
                var drop, header = "", searchbox = "", actionsbox = "", donebutton = "";
                if (this.options.header) header = '<div class="' + classNames.POPOVERHEADER + '">' + '<button type="button" class="close" aria-hidden="true">&times;</button>' + this.options.header + "</div>";
                if (this.options.liveSearch) searchbox = '<div class="bs-searchbox"><input type="search" class="form-control" autocomplete="off"' + (this.options.liveSearchPlaceholder === null ? "" : ' placeholder="' + htmlEscape(this.options.liveSearchPlaceholder) + '"') + ' role="combobox" aria-label="Search" aria-controls="' + this.selectId + '" aria-autocomplete="list">' + "</div>";
                if (this.multiple && this.options.actionsBox) actionsbox = '<div class="bs-actionsbox"><div class="btn-group btn-group-sm btn-block"><button type="button" class="actions-btn bs-select-all btn ' + classNames.BUTTONCLASS + '">' + this.options.selectAllText + "</button>" + '<button type="button" class="actions-btn bs-deselect-all btn ' + classNames.BUTTONCLASS + '">' + this.options.deselectAllText + "</button>" + "</div>" + "</div>";
                if (this.multiple && this.options.doneButton) donebutton = '<div class="bs-donebutton"><div class="btn-group btn-block"><button type="button" class="btn btn-sm ' + classNames.BUTTONCLASS + '">' + this.options.doneButtonText + "</button>" + "</div>" + "</div>";
                drop = '<div class="dropdown bootstrap-select' + showTick + inputGroup + '">' + '<button type="button" tabindex="-1" class="' + this.options.styleBase + ' dropdown-toggle" ' + (this.options.display === "static" ? 'data-display="static"' : "") + 'data-toggle="dropdown"' + autofocus + ' role="combobox" aria-owns="' + this.selectId + '" aria-haspopup="listbox" aria-expanded="false">' + '<div class="filter-option">' + '<div class="filter-option-inner">' + '<div class="filter-option-inner-inner"></div>' + "</div> " + "</div>" + (version.major === "4" ? "" : '<span class="bs-caret">' + this.options.template.caret + "</span>") + "</button>" + '<div class="' + classNames.MENU + " " + (version.major === "4" ? "" : classNames.SHOW) + '">' + header + searchbox + actionsbox + '<div class="inner ' + classNames.SHOW + '" role="listbox" id="' + this.selectId + '" tabindex="-1" ' + multiselectable + ">" + '<ul class="' + classNames.MENU + " inner " + (version.major === "4" ? classNames.SHOW : "") + '" role="presentation">' + "</ul>" + "</div>" + donebutton + "</div>" + "</div>";
                return $(drop);
            },
            setPositionData: function() {
                this.selectpicker.view.canHighlight = [];
                this.selectpicker.view.size = 0;
                this.selectpicker.view.firstHighlightIndex = false;
                for(var i = 0; i < this.selectpicker.current.data.length; i++){
                    var li = this.selectpicker.current.data[i], canHighlight = true;
                    if (li.type === "divider") {
                        canHighlight = false;
                        li.height = this.sizeInfo.dividerHeight;
                    } else if (li.type === "optgroup-label") {
                        canHighlight = false;
                        li.height = this.sizeInfo.dropdownHeaderHeight;
                    } else li.height = this.sizeInfo.liHeight;
                    if (li.disabled) canHighlight = false;
                    this.selectpicker.view.canHighlight.push(canHighlight);
                    if (canHighlight) {
                        this.selectpicker.view.size++;
                        li.posinset = this.selectpicker.view.size;
                        if (this.selectpicker.view.firstHighlightIndex === false) this.selectpicker.view.firstHighlightIndex = i;
                    }
                    li.position = (i === 0 ? 0 : this.selectpicker.current.data[i - 1].position) + li.height;
                }
            },
            isVirtual: function() {
                return this.options.virtualScroll !== false && this.selectpicker.main.elements.length >= this.options.virtualScroll || this.options.virtualScroll === true;
            },
            createView: function(isSearching, setSize, refresh) {
                var that = this, scrollTop = 0, active = [], selected, prevActive;
                this.selectpicker.isSearching = isSearching;
                this.selectpicker.current = isSearching ? this.selectpicker.search : this.selectpicker.main;
                this.setPositionData();
                if (setSize) {
                    if (refresh) scrollTop = this.$menuInner[0].scrollTop;
                    else if (!that.multiple) {
                        var element = that.$element[0], selectedIndex = (element.options[element.selectedIndex] || {}).liIndex;
                        if (typeof selectedIndex === "number" && that.options.size !== false) {
                            var selectedData = that.selectpicker.main.data[selectedIndex], position = selectedData && selectedData.position;
                            if (position) scrollTop = position - (that.sizeInfo.menuInnerHeight + that.sizeInfo.liHeight) / 2;
                        }
                    }
                }
                scroll(scrollTop, true);
                this.$menuInner.off("scroll.createView").on("scroll.createView", function(e, updateValue) {
                    if (!that.noScroll) scroll(this.scrollTop, updateValue);
                    that.noScroll = false;
                });
                function scroll(scrollTop, init) {
                    var size = that.selectpicker.current.elements.length, chunks = [], chunkSize, chunkCount, firstChunk, lastChunk, currentChunk, prevPositions, positionIsDifferent, previousElements, menuIsDifferent = true, isVirtual = that.isVirtual();
                    that.selectpicker.view.scrollTop = scrollTop;
                    chunkSize = Math.ceil(that.sizeInfo.menuInnerHeight / that.sizeInfo.liHeight * 1.5); // number of options in a chunk
                    chunkCount = Math.round(size / chunkSize) || 1; // number of chunks
                    for(var i = 0; i < chunkCount; i++){
                        var endOfChunk = (i + 1) * chunkSize;
                        if (i === chunkCount - 1) endOfChunk = size;
                        chunks[i] = [
                            i * chunkSize + (!i ? 0 : 1),
                            endOfChunk
                        ];
                        if (!size) break;
                        if (currentChunk === undefined && scrollTop - 1 <= that.selectpicker.current.data[endOfChunk - 1].position - that.sizeInfo.menuInnerHeight) currentChunk = i;
                    }
                    if (currentChunk === undefined) currentChunk = 0;
                    prevPositions = [
                        that.selectpicker.view.position0,
                        that.selectpicker.view.position1
                    ];
                    // always display previous, current, and next chunks
                    firstChunk = Math.max(0, currentChunk - 1);
                    lastChunk = Math.min(chunkCount - 1, currentChunk + 1);
                    that.selectpicker.view.position0 = isVirtual === false ? 0 : Math.max(0, chunks[firstChunk][0]) || 0;
                    that.selectpicker.view.position1 = isVirtual === false ? size : Math.min(size, chunks[lastChunk][1]) || 0;
                    positionIsDifferent = prevPositions[0] !== that.selectpicker.view.position0 || prevPositions[1] !== that.selectpicker.view.position1;
                    if (that.activeIndex !== undefined) {
                        prevActive = that.selectpicker.main.elements[that.prevActiveIndex];
                        active = that.selectpicker.main.elements[that.activeIndex];
                        selected = that.selectpicker.main.elements[that.selectedIndex];
                        if (init) {
                            if (that.activeIndex !== that.selectedIndex) that.defocusItem(active);
                            that.activeIndex = undefined;
                        }
                        if (that.activeIndex && that.activeIndex !== that.selectedIndex) that.defocusItem(selected);
                    }
                    if (that.prevActiveIndex !== undefined && that.prevActiveIndex !== that.activeIndex && that.prevActiveIndex !== that.selectedIndex) that.defocusItem(prevActive);
                    if (init || positionIsDifferent) {
                        previousElements = that.selectpicker.view.visibleElements ? that.selectpicker.view.visibleElements.slice() : [];
                        if (isVirtual === false) that.selectpicker.view.visibleElements = that.selectpicker.current.elements;
                        else that.selectpicker.view.visibleElements = that.selectpicker.current.elements.slice(that.selectpicker.view.position0, that.selectpicker.view.position1);
                        that.setOptionStatus();
                        // if searching, check to make sure the list has actually been updated before updating DOM
                        // this prevents unnecessary repaints
                        if (isSearching || isVirtual === false && init) menuIsDifferent = !isEqual(previousElements, that.selectpicker.view.visibleElements);
                        // if virtual scroll is disabled and not searching,
                        // menu should never need to be updated more than once
                        if ((init || isVirtual === true) && menuIsDifferent) {
                            var menuInner = that.$menuInner[0], menuFragment = document.createDocumentFragment(), emptyMenu = menuInner.firstChild.cloneNode(false), marginTop, marginBottom, elements = that.selectpicker.view.visibleElements, toSanitize = [];
                            // replace the existing UL with an empty one - this is faster than $.empty()
                            menuInner.replaceChild(emptyMenu, menuInner.firstChild);
                            for(var i = 0, visibleElementsLen = elements.length; i < visibleElementsLen; i++){
                                var element = elements[i], elText, elementData;
                                if (that.options.sanitize) {
                                    elText = element.lastChild;
                                    if (elText) {
                                        elementData = that.selectpicker.current.data[i + that.selectpicker.view.position0];
                                        if (elementData && elementData.content && !elementData.sanitized) {
                                            toSanitize.push(elText);
                                            elementData.sanitized = true;
                                        }
                                    }
                                }
                                menuFragment.appendChild(element);
                            }
                            if (that.options.sanitize && toSanitize.length) sanitizeHtml(toSanitize, that.options.whiteList, that.options.sanitizeFn);
                            if (isVirtual === true) {
                                marginTop = that.selectpicker.view.position0 === 0 ? 0 : that.selectpicker.current.data[that.selectpicker.view.position0 - 1].position;
                                marginBottom = that.selectpicker.view.position1 > size - 1 ? 0 : that.selectpicker.current.data[size - 1].position - that.selectpicker.current.data[that.selectpicker.view.position1 - 1].position;
                                menuInner.firstChild.style.marginTop = marginTop + "px";
                                menuInner.firstChild.style.marginBottom = marginBottom + "px";
                            } else {
                                menuInner.firstChild.style.marginTop = 0;
                                menuInner.firstChild.style.marginBottom = 0;
                            }
                            menuInner.firstChild.appendChild(menuFragment);
                            // if an option is encountered that is wider than the current menu width, update the menu width accordingly
                            // switch to ResizeObserver with increased browser support
                            if (isVirtual === true && that.sizeInfo.hasScrollBar) {
                                var menuInnerInnerWidth = menuInner.firstChild.offsetWidth;
                                if (init && menuInnerInnerWidth < that.sizeInfo.menuInnerInnerWidth && that.sizeInfo.totalMenuWidth > that.sizeInfo.selectWidth) menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + "px";
                                else if (menuInnerInnerWidth > that.sizeInfo.menuInnerInnerWidth) {
                                    // set to 0 to get actual width of menu
                                    that.$menu[0].style.minWidth = 0;
                                    var actualMenuWidth = menuInner.firstChild.offsetWidth;
                                    if (actualMenuWidth > that.sizeInfo.menuInnerInnerWidth) {
                                        that.sizeInfo.menuInnerInnerWidth = actualMenuWidth;
                                        menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + "px";
                                    }
                                    // reset to default CSS styling
                                    that.$menu[0].style.minWidth = "";
                                }
                            }
                        }
                    }
                    that.prevActiveIndex = that.activeIndex;
                    if (!that.options.liveSearch) that.$menuInner.trigger("focus");
                    else if (isSearching && init) {
                        var index = 0, newActive;
                        if (!that.selectpicker.view.canHighlight[index]) index = 1 + that.selectpicker.view.canHighlight.slice(1).indexOf(true);
                        newActive = that.selectpicker.view.visibleElements[index];
                        that.defocusItem(that.selectpicker.view.currentActive);
                        that.activeIndex = (that.selectpicker.current.data[index] || {}).index;
                        that.focusItem(newActive);
                    }
                }
                $(window).off("resize" + EVENT_KEY + "." + this.selectId + ".createView").on("resize" + EVENT_KEY + "." + this.selectId + ".createView", function() {
                    var isActive = that.$newElement.hasClass(classNames.SHOW);
                    if (isActive) scroll(that.$menuInner[0].scrollTop);
                });
            },
            focusItem: function(li, liData, noStyle) {
                if (li) {
                    liData = liData || this.selectpicker.main.data[this.activeIndex];
                    var a = li.firstChild;
                    if (a) {
                        a.setAttribute("aria-setsize", this.selectpicker.view.size);
                        a.setAttribute("aria-posinset", liData.posinset);
                        if (noStyle !== true) {
                            this.focusedParent.setAttribute("aria-activedescendant", a.id);
                            li.classList.add("active");
                            a.classList.add("active");
                        }
                    }
                }
            },
            defocusItem: function(li) {
                if (li) {
                    li.classList.remove("active");
                    if (li.firstChild) li.firstChild.classList.remove("active");
                }
            },
            setPlaceholder: function() {
                var that = this, updateIndex = false;
                if (this.options.title && !this.multiple) {
                    if (!this.selectpicker.view.titleOption) this.selectpicker.view.titleOption = document.createElement("option");
                    // this option doesn't create a new <li> element, but does add a new option at the start,
                    // so startIndex should increase to prevent having to check every option for the bs-title-option class
                    updateIndex = true;
                    var element = this.$element[0], selectTitleOption = false, titleNotAppended = !this.selectpicker.view.titleOption.parentNode, selectedIndex = element.selectedIndex, selectedOption = element.options[selectedIndex], navigation = window.performance && window.performance.getEntriesByType("navigation"), // Safari doesn't support getEntriesByType('navigation') - fall back to performance.navigation
                    isNotBackForward = navigation && navigation.length ? navigation[0].type !== "back_forward" : window.performance.navigation.type !== 2;
                    if (titleNotAppended) {
                        // Use native JS to prepend option (faster)
                        this.selectpicker.view.titleOption.className = "bs-title-option";
                        this.selectpicker.view.titleOption.value = "";
                        // Check if selected or data-selected attribute is already set on an option. If not, select the titleOption option.
                        // the selected item may have been changed by user or programmatically before the bootstrap select plugin runs,
                        // if so, the select will have the data-selected attribute
                        selectTitleOption = !selectedOption || selectedIndex === 0 && selectedOption.defaultSelected === false && this.$element.data("selected") === undefined;
                    }
                    if (titleNotAppended || this.selectpicker.view.titleOption.index !== 0) element.insertBefore(this.selectpicker.view.titleOption, element.firstChild);
                    // Set selected *after* appending to select,
                    // otherwise the option doesn't get selected in IE
                    // set using selectedIndex, as setting the selected attr to true here doesn't work in IE11
                    if (selectTitleOption && isNotBackForward) element.selectedIndex = 0;
                    else if (document.readyState !== "complete") // if navigation type is back_forward, there's a chance the select will have its value set by BFCache
                    // wait for that value to be set, then run render again
                    window.addEventListener("pageshow", function() {
                        if (that.selectpicker.view.displayedValue !== element.value) that.render();
                    });
                }
                return updateIndex;
            },
            buildData: function() {
                var optionSelector = ':not([hidden]):not([data-hidden="true"])', mainData = [], optID = 0, startIndex = this.setPlaceholder() ? 1 : 0; // append the titleOption if necessary and skip the first option in the loop
                if (this.options.hideDisabled) optionSelector += ":not(:disabled)";
                var selectOptions = this.$element[0].querySelectorAll("select > *" + optionSelector);
                function addDivider(config) {
                    var previousData = mainData[mainData.length - 1];
                    // ensure optgroup doesn't create back-to-back dividers
                    if (previousData && previousData.type === "divider" && (previousData.optID || config.optID)) return;
                    config = config || {};
                    config.type = "divider";
                    mainData.push(config);
                }
                function addOption(option, config) {
                    config = config || {};
                    config.divider = option.getAttribute("data-divider") === "true";
                    if (config.divider) addDivider({
                        optID: config.optID
                    });
                    else {
                        var liIndex = mainData.length, cssText = option.style.cssText, inlineStyle = cssText ? htmlEscape(cssText) : "", optionClass = (option.className || "") + (config.optgroupClass || "");
                        if (config.optID) optionClass = "opt " + optionClass;
                        config.optionClass = optionClass.trim();
                        config.inlineStyle = inlineStyle;
                        config.text = option.textContent;
                        config.content = option.getAttribute("data-content");
                        config.tokens = option.getAttribute("data-tokens");
                        config.subtext = option.getAttribute("data-subtext");
                        config.icon = option.getAttribute("data-icon");
                        option.liIndex = liIndex;
                        config.display = config.content || config.text;
                        config.type = "option";
                        config.index = liIndex;
                        config.option = option;
                        config.selected = !!option.selected;
                        config.disabled = config.disabled || !!option.disabled;
                        mainData.push(config);
                    }
                }
                function addOptgroup(index, selectOptions) {
                    var optgroup = selectOptions[index], // skip placeholder option
                    previous = index - 1 < startIndex ? false : selectOptions[index - 1], next = selectOptions[index + 1], options = optgroup.querySelectorAll("option" + optionSelector);
                    if (!options.length) return;
                    var config = {
                        display: htmlEscape(optgroup.label),
                        subtext: optgroup.getAttribute("data-subtext"),
                        icon: optgroup.getAttribute("data-icon"),
                        type: "optgroup-label",
                        optgroupClass: " " + (optgroup.className || "")
                    }, headerIndex, lastIndex;
                    optID++;
                    if (previous) addDivider({
                        optID: optID
                    });
                    config.optID = optID;
                    mainData.push(config);
                    for(var j = 0, len = options.length; j < len; j++){
                        var option = options[j];
                        if (j === 0) {
                            headerIndex = mainData.length - 1;
                            lastIndex = headerIndex + len;
                        }
                        addOption(option, {
                            headerIndex: headerIndex,
                            lastIndex: lastIndex,
                            optID: config.optID,
                            optgroupClass: config.optgroupClass,
                            disabled: optgroup.disabled
                        });
                    }
                    if (next) addDivider({
                        optID: optID
                    });
                }
                for(var len = selectOptions.length, i = startIndex; i < len; i++){
                    var item = selectOptions[i];
                    if (item.tagName !== "OPTGROUP") addOption(item, {});
                    else addOptgroup(i, selectOptions);
                }
                this.selectpicker.main.data = this.selectpicker.current.data = mainData;
            },
            buildList: function() {
                var that = this, selectData = this.selectpicker.main.data, mainElements = [], widestOptionLength = 0;
                if ((that.options.showTick || that.multiple) && !elementTemplates.checkMark.parentNode) {
                    elementTemplates.checkMark.className = this.options.iconBase + " " + that.options.tickIcon + " check-mark";
                    elementTemplates.a.appendChild(elementTemplates.checkMark);
                }
                function buildElement(item) {
                    var liElement, combinedLength = 0;
                    switch(item.type){
                        case "divider":
                            liElement = generateOption.li(false, classNames.DIVIDER, item.optID ? item.optID + "div" : undefined);
                            break;
                        case "option":
                            liElement = generateOption.li(generateOption.a(generateOption.text.call(that, item), item.optionClass, item.inlineStyle), "", item.optID);
                            if (liElement.firstChild) liElement.firstChild.id = that.selectId + "-" + item.index;
                            break;
                        case "optgroup-label":
                            liElement = generateOption.li(generateOption.label.call(that, item), "dropdown-header" + item.optgroupClass, item.optID);
                            break;
                    }
                    item.element = liElement;
                    mainElements.push(liElement);
                    // count the number of characters in the option - not perfect, but should work in most cases
                    if (item.display) combinedLength += item.display.length;
                    if (item.subtext) combinedLength += item.subtext.length;
                    // if there is an icon, ensure this option's width is checked
                    if (item.icon) combinedLength += 1;
                    if (combinedLength > widestOptionLength) {
                        widestOptionLength = combinedLength;
                        // guess which option is the widest
                        // use this when calculating menu width
                        // not perfect, but it's fast, and the width will be updating accordingly when scrolling
                        that.selectpicker.view.widestOption = mainElements[mainElements.length - 1];
                    }
                }
                for(var len = selectData.length, i = 0; i < len; i++){
                    var item = selectData[i];
                    buildElement(item);
                }
                this.selectpicker.main.elements = this.selectpicker.current.elements = mainElements;
            },
            findLis: function() {
                return this.$menuInner.find(".inner > li");
            },
            render: function() {
                var that = this, element = this.$element[0], // ensure titleOption is appended and selected (if necessary) before getting selectedOptions
                placeholderSelected = this.setPlaceholder() && element.selectedIndex === 0, selectedOptions = getSelectedOptions(element, this.options.hideDisabled), selectedCount = selectedOptions.length, button = this.$button[0], buttonInner = button.querySelector(".filter-option-inner-inner"), multipleSeparator = document.createTextNode(this.options.multipleSeparator), titleFragment = elementTemplates.fragment.cloneNode(false), showCount, countMax, hasContent = false;
                button.classList.toggle("bs-placeholder", that.multiple ? !selectedCount : !getSelectValues(element, selectedOptions));
                if (!that.multiple && selectedOptions.length === 1) that.selectpicker.view.displayedValue = getSelectValues(element, selectedOptions);
                if (this.options.selectedTextFormat === "static") titleFragment = generateOption.text.call(this, {
                    text: this.options.title
                }, true);
                else {
                    showCount = this.multiple && this.options.selectedTextFormat.indexOf("count") !== -1 && selectedCount > 1;
                    // determine if the number of selected options will be shown (showCount === true)
                    if (showCount) {
                        countMax = this.options.selectedTextFormat.split(">");
                        showCount = countMax.length > 1 && selectedCount > countMax[1] || countMax.length === 1 && selectedCount >= 2;
                    }
                    // only loop through all selected options if the count won't be shown
                    if (showCount === false) {
                        if (!placeholderSelected) {
                            for(var selectedIndex = 0; selectedIndex < selectedCount; selectedIndex++){
                                if (selectedIndex < 50) {
                                    var option = selectedOptions[selectedIndex], thisData = this.selectpicker.main.data[option.liIndex], titleOptions = {};
                                    if (this.multiple && selectedIndex > 0) titleFragment.appendChild(multipleSeparator.cloneNode(false));
                                    if (option.title) titleOptions.text = option.title;
                                    else if (thisData) {
                                        if (thisData.content && that.options.showContent) {
                                            titleOptions.content = thisData.content.toString();
                                            hasContent = true;
                                        } else {
                                            if (that.options.showIcon) titleOptions.icon = thisData.icon;
                                            if (that.options.showSubtext && !that.multiple && thisData.subtext) titleOptions.subtext = " " + thisData.subtext;
                                            titleOptions.text = option.textContent.trim();
                                        }
                                    }
                                    titleFragment.appendChild(generateOption.text.call(this, titleOptions, true));
                                } else break;
                            }
                            // add ellipsis
                            if (selectedCount > 49) titleFragment.appendChild(document.createTextNode("..."));
                        }
                    } else {
                        var optionSelector = ':not([hidden]):not([data-hidden="true"]):not([data-divider="true"])';
                        if (this.options.hideDisabled) optionSelector += ":not(:disabled)";
                        // If this is a multiselect, and selectedTextFormat is count, then show 1 of 2 selected, etc.
                        var totalCount = this.$element[0].querySelectorAll("select > option" + optionSelector + ", optgroup" + optionSelector + " option" + optionSelector).length, tr8nText = typeof this.options.countSelectedText === "function" ? this.options.countSelectedText(selectedCount, totalCount) : this.options.countSelectedText;
                        titleFragment = generateOption.text.call(this, {
                            text: tr8nText.replace("{0}", selectedCount.toString()).replace("{1}", totalCount.toString())
                        }, true);
                    }
                }
                if (this.options.title == undefined) // use .attr to ensure undefined is returned if title attribute is not set
                this.options.title = this.$element.attr("title");
                // If the select doesn't have a title, then use the default, or if nothing is set at all, use noneSelectedText
                if (!titleFragment.childNodes.length) titleFragment = generateOption.text.call(this, {
                    text: typeof this.options.title !== "undefined" ? this.options.title : this.options.noneSelectedText
                }, true);
                // strip all HTML tags and trim the result, then unescape any escaped tags
                button.title = titleFragment.textContent.replace(/<[^>]*>?/g, "").trim();
                if (this.options.sanitize && hasContent) sanitizeHtml([
                    titleFragment
                ], that.options.whiteList, that.options.sanitizeFn);
                buttonInner.innerHTML = "";
                buttonInner.appendChild(titleFragment);
                if (version.major < 4 && this.$newElement[0].classList.contains("bs3-has-addon")) {
                    var filterExpand = button.querySelector(".filter-expand"), clone = buttonInner.cloneNode(true);
                    clone.className = "filter-expand";
                    if (filterExpand) button.replaceChild(clone, filterExpand);
                    else button.appendChild(clone);
                }
                this.$element.trigger("rendered" + EVENT_KEY);
            },
            /**
     * @param [style]
     * @param [status]
     */ setStyle: function(newStyle, status) {
                var button = this.$button[0], newElement = this.$newElement[0], style = this.options.style.trim(), buttonClass;
                if (this.$element.attr("class")) this.$newElement.addClass(this.$element.attr("class").replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi, ""));
                if (version.major < 4) {
                    newElement.classList.add("bs3");
                    if (newElement.parentNode.classList && newElement.parentNode.classList.contains("input-group") && (newElement.previousElementSibling || newElement.nextElementSibling) && (newElement.previousElementSibling || newElement.nextElementSibling).classList.contains("input-group-addon")) newElement.classList.add("bs3-has-addon");
                }
                if (newStyle) buttonClass = newStyle.trim();
                else buttonClass = style;
                if (status == "add") {
                    if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(" "));
                } else if (status == "remove") {
                    if (buttonClass) button.classList.remove.apply(button.classList, buttonClass.split(" "));
                } else {
                    if (style) button.classList.remove.apply(button.classList, style.split(" "));
                    if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(" "));
                }
            },
            liHeight: function(refresh) {
                if (!refresh && (this.options.size === false || Object.keys(this.sizeInfo).length)) return;
                var newElement = elementTemplates.div.cloneNode(false), menu = elementTemplates.div.cloneNode(false), menuInner = elementTemplates.div.cloneNode(false), menuInnerInner = document.createElement("ul"), divider = elementTemplates.li.cloneNode(false), dropdownHeader = elementTemplates.li.cloneNode(false), li, a = elementTemplates.a.cloneNode(false), text = elementTemplates.span.cloneNode(false), header = this.options.header && this.$menu.find("." + classNames.POPOVERHEADER).length > 0 ? this.$menu.find("." + classNames.POPOVERHEADER)[0].cloneNode(true) : null, search = this.options.liveSearch ? elementTemplates.div.cloneNode(false) : null, actions = this.options.actionsBox && this.multiple && this.$menu.find(".bs-actionsbox").length > 0 ? this.$menu.find(".bs-actionsbox")[0].cloneNode(true) : null, doneButton = this.options.doneButton && this.multiple && this.$menu.find(".bs-donebutton").length > 0 ? this.$menu.find(".bs-donebutton")[0].cloneNode(true) : null, firstOption = this.$element.find("option")[0];
                this.sizeInfo.selectWidth = this.$newElement[0].offsetWidth;
                text.className = "text";
                a.className = "dropdown-item " + (firstOption ? firstOption.className : "");
                newElement.className = this.$menu[0].parentNode.className + " " + classNames.SHOW;
                newElement.style.width = 0; // ensure button width doesn't affect natural width of menu when calculating
                if (this.options.width === "auto") menu.style.minWidth = 0;
                menu.className = classNames.MENU + " " + classNames.SHOW;
                menuInner.className = "inner " + classNames.SHOW;
                menuInnerInner.className = classNames.MENU + " inner " + (version.major === "4" ? classNames.SHOW : "");
                divider.className = classNames.DIVIDER;
                dropdownHeader.className = "dropdown-header";
                text.appendChild(document.createTextNode("\u200B"));
                if (this.selectpicker.current.data.length) for(var i = 0; i < this.selectpicker.current.data.length; i++){
                    var data = this.selectpicker.current.data[i];
                    if (data.type === "option") {
                        li = data.element;
                        break;
                    }
                }
                else {
                    li = elementTemplates.li.cloneNode(false);
                    a.appendChild(text);
                    li.appendChild(a);
                }
                dropdownHeader.appendChild(text.cloneNode(true));
                if (this.selectpicker.view.widestOption) menuInnerInner.appendChild(this.selectpicker.view.widestOption.cloneNode(true));
                menuInnerInner.appendChild(li);
                menuInnerInner.appendChild(divider);
                menuInnerInner.appendChild(dropdownHeader);
                if (header) menu.appendChild(header);
                if (search) {
                    var input = document.createElement("input");
                    search.className = "bs-searchbox";
                    input.className = "form-control";
                    search.appendChild(input);
                    menu.appendChild(search);
                }
                if (actions) menu.appendChild(actions);
                menuInner.appendChild(menuInnerInner);
                menu.appendChild(menuInner);
                if (doneButton) menu.appendChild(doneButton);
                newElement.appendChild(menu);
                document.body.appendChild(newElement);
                var liHeight = li.offsetHeight, dropdownHeaderHeight = dropdownHeader ? dropdownHeader.offsetHeight : 0, headerHeight = header ? header.offsetHeight : 0, searchHeight = search ? search.offsetHeight : 0, actionsHeight = actions ? actions.offsetHeight : 0, doneButtonHeight = doneButton ? doneButton.offsetHeight : 0, dividerHeight = $(divider).outerHeight(true), // fall back to jQuery if getComputedStyle is not supported
                menuStyle = window.getComputedStyle ? window.getComputedStyle(menu) : false, menuWidth = menu.offsetWidth, $menu = menuStyle ? null : $(menu), menuPadding = {
                    vert: toInteger(menuStyle ? menuStyle.paddingTop : $menu.css("paddingTop")) + toInteger(menuStyle ? menuStyle.paddingBottom : $menu.css("paddingBottom")) + toInteger(menuStyle ? menuStyle.borderTopWidth : $menu.css("borderTopWidth")) + toInteger(menuStyle ? menuStyle.borderBottomWidth : $menu.css("borderBottomWidth")),
                    horiz: toInteger(menuStyle ? menuStyle.paddingLeft : $menu.css("paddingLeft")) + toInteger(menuStyle ? menuStyle.paddingRight : $menu.css("paddingRight")) + toInteger(menuStyle ? menuStyle.borderLeftWidth : $menu.css("borderLeftWidth")) + toInteger(menuStyle ? menuStyle.borderRightWidth : $menu.css("borderRightWidth"))
                }, menuExtras = {
                    vert: menuPadding.vert + toInteger(menuStyle ? menuStyle.marginTop : $menu.css("marginTop")) + toInteger(menuStyle ? menuStyle.marginBottom : $menu.css("marginBottom")) + 2,
                    horiz: menuPadding.horiz + toInteger(menuStyle ? menuStyle.marginLeft : $menu.css("marginLeft")) + toInteger(menuStyle ? menuStyle.marginRight : $menu.css("marginRight")) + 2
                }, scrollBarWidth;
                menuInner.style.overflowY = "scroll";
                scrollBarWidth = menu.offsetWidth - menuWidth;
                document.body.removeChild(newElement);
                this.sizeInfo.liHeight = liHeight;
                this.sizeInfo.dropdownHeaderHeight = dropdownHeaderHeight;
                this.sizeInfo.headerHeight = headerHeight;
                this.sizeInfo.searchHeight = searchHeight;
                this.sizeInfo.actionsHeight = actionsHeight;
                this.sizeInfo.doneButtonHeight = doneButtonHeight;
                this.sizeInfo.dividerHeight = dividerHeight;
                this.sizeInfo.menuPadding = menuPadding;
                this.sizeInfo.menuExtras = menuExtras;
                this.sizeInfo.menuWidth = menuWidth;
                this.sizeInfo.menuInnerInnerWidth = menuWidth - menuPadding.horiz;
                this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth;
                this.sizeInfo.scrollBarWidth = scrollBarWidth;
                this.sizeInfo.selectHeight = this.$newElement[0].offsetHeight;
                this.setPositionData();
            },
            getSelectPosition: function() {
                var that = this, $window = $(window), pos = that.$newElement.offset(), $container = $(that.options.container), containerPos;
                if (that.options.container && $container.length && !$container.is("body")) {
                    containerPos = $container.offset();
                    containerPos.top += parseInt($container.css("borderTopWidth"));
                    containerPos.left += parseInt($container.css("borderLeftWidth"));
                } else containerPos = {
                    top: 0,
                    left: 0
                };
                var winPad = that.options.windowPadding;
                this.sizeInfo.selectOffsetTop = pos.top - containerPos.top - $window.scrollTop();
                this.sizeInfo.selectOffsetBot = $window.height() - this.sizeInfo.selectOffsetTop - this.sizeInfo.selectHeight - containerPos.top - winPad[2];
                this.sizeInfo.selectOffsetLeft = pos.left - containerPos.left - $window.scrollLeft();
                this.sizeInfo.selectOffsetRight = $window.width() - this.sizeInfo.selectOffsetLeft - this.sizeInfo.selectWidth - containerPos.left - winPad[1];
                this.sizeInfo.selectOffsetTop -= winPad[0];
                this.sizeInfo.selectOffsetLeft -= winPad[3];
            },
            setMenuSize: function(isAuto) {
                this.getSelectPosition();
                var selectWidth = this.sizeInfo.selectWidth, liHeight = this.sizeInfo.liHeight, headerHeight = this.sizeInfo.headerHeight, searchHeight = this.sizeInfo.searchHeight, actionsHeight = this.sizeInfo.actionsHeight, doneButtonHeight = this.sizeInfo.doneButtonHeight, divHeight = this.sizeInfo.dividerHeight, menuPadding = this.sizeInfo.menuPadding, menuInnerHeight, menuHeight, divLength = 0, minHeight, _minHeight, maxHeight, menuInnerMinHeight, estimate, isDropup;
                if (this.options.dropupAuto) {
                    // Get the estimated height of the menu without scrollbars.
                    // This is useful for smaller menus, where there might be plenty of room
                    // below the button without setting dropup, but we can't know
                    // the exact height of the menu until createView is called later
                    estimate = liHeight * this.selectpicker.current.elements.length + menuPadding.vert;
                    isDropup = this.sizeInfo.selectOffsetTop - this.sizeInfo.selectOffsetBot > this.sizeInfo.menuExtras.vert && estimate + this.sizeInfo.menuExtras.vert + 50 > this.sizeInfo.selectOffsetBot;
                    // ensure dropup doesn't change while searching (so menu doesn't bounce back and forth)
                    if (this.selectpicker.isSearching === true) isDropup = this.selectpicker.dropup;
                    this.$newElement.toggleClass(classNames.DROPUP, isDropup);
                    this.selectpicker.dropup = isDropup;
                }
                if (this.options.size === "auto") {
                    _minHeight = this.selectpicker.current.elements.length > 3 ? this.sizeInfo.liHeight * 3 + this.sizeInfo.menuExtras.vert - 2 : 0;
                    menuHeight = this.sizeInfo.selectOffsetBot - this.sizeInfo.menuExtras.vert;
                    minHeight = _minHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
                    menuInnerMinHeight = Math.max(_minHeight - menuPadding.vert, 0);
                    if (this.$newElement.hasClass(classNames.DROPUP)) menuHeight = this.sizeInfo.selectOffsetTop - this.sizeInfo.menuExtras.vert;
                    maxHeight = menuHeight;
                    menuInnerHeight = menuHeight - headerHeight - searchHeight - actionsHeight - doneButtonHeight - menuPadding.vert;
                } else if (this.options.size && this.options.size != "auto" && this.selectpicker.current.elements.length > this.options.size) {
                    for(var i = 0; i < this.options.size; i++)if (this.selectpicker.current.data[i].type === "divider") divLength++;
                    menuHeight = liHeight * this.options.size + divLength * divHeight + menuPadding.vert;
                    menuInnerHeight = menuHeight - menuPadding.vert;
                    maxHeight = menuHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
                    minHeight = menuInnerMinHeight = "";
                }
                this.$menu.css({
                    "max-height": maxHeight + "px",
                    "overflow": "hidden",
                    "min-height": minHeight + "px"
                });
                this.$menuInner.css({
                    "max-height": menuInnerHeight + "px",
                    "overflow-y": "auto",
                    "min-height": menuInnerMinHeight + "px"
                });
                // ensure menuInnerHeight is always a positive number to prevent issues calculating chunkSize in createView
                this.sizeInfo.menuInnerHeight = Math.max(menuInnerHeight, 1);
                if (this.selectpicker.current.data.length && this.selectpicker.current.data[this.selectpicker.current.data.length - 1].position > this.sizeInfo.menuInnerHeight) {
                    this.sizeInfo.hasScrollBar = true;
                    this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth + this.sizeInfo.scrollBarWidth;
                }
                if (this.options.dropdownAlignRight === "auto") this.$menu.toggleClass(classNames.MENURIGHT, this.sizeInfo.selectOffsetLeft > this.sizeInfo.selectOffsetRight && this.sizeInfo.selectOffsetRight < this.sizeInfo.totalMenuWidth - selectWidth);
                if (this.dropdown && this.dropdown._popper) this.dropdown._popper.update();
            },
            setSize: function(refresh) {
                this.liHeight(refresh);
                if (this.options.header) this.$menu.css("padding-top", 0);
                if (this.options.size !== false) {
                    var that = this, $window = $(window);
                    this.setMenuSize();
                    if (this.options.liveSearch) this.$searchbox.off("input.setMenuSize propertychange.setMenuSize").on("input.setMenuSize propertychange.setMenuSize", function() {
                        return that.setMenuSize();
                    });
                    if (this.options.size === "auto") $window.off("resize" + EVENT_KEY + "." + this.selectId + ".setMenuSize" + " scroll" + EVENT_KEY + "." + this.selectId + ".setMenuSize").on("resize" + EVENT_KEY + "." + this.selectId + ".setMenuSize" + " scroll" + EVENT_KEY + "." + this.selectId + ".setMenuSize", function() {
                        return that.setMenuSize();
                    });
                    else if (this.options.size && this.options.size != "auto" && this.selectpicker.current.elements.length > this.options.size) $window.off("resize" + EVENT_KEY + "." + this.selectId + ".setMenuSize" + " scroll" + EVENT_KEY + "." + this.selectId + ".setMenuSize");
                }
                this.createView(false, true, refresh);
            },
            setWidth: function() {
                var that = this;
                if (this.options.width === "auto") requestAnimationFrame(function() {
                    that.$menu.css("min-width", "0");
                    that.$element.on("loaded" + EVENT_KEY, function() {
                        that.liHeight();
                        that.setMenuSize();
                        // Get correct width if element is hidden
                        var $selectClone = that.$newElement.clone().appendTo("body"), btnWidth = $selectClone.css("width", "auto").children("button").outerWidth();
                        $selectClone.remove();
                        // Set width to whatever's larger, button title or longest option
                        that.sizeInfo.selectWidth = Math.max(that.sizeInfo.totalMenuWidth, btnWidth);
                        that.$newElement.css("width", that.sizeInfo.selectWidth + "px");
                    });
                });
                else if (this.options.width === "fit") {
                    // Remove inline min-width so width can be changed from 'auto'
                    this.$menu.css("min-width", "");
                    this.$newElement.css("width", "").addClass("fit-width");
                } else if (this.options.width) {
                    // Remove inline min-width so width can be changed from 'auto'
                    this.$menu.css("min-width", "");
                    this.$newElement.css("width", this.options.width);
                } else {
                    // Remove inline min-width/width so width can be changed
                    this.$menu.css("min-width", "");
                    this.$newElement.css("width", "");
                }
                // Remove fit-width class if width is changed programmatically
                if (this.$newElement.hasClass("fit-width") && this.options.width !== "fit") this.$newElement[0].classList.remove("fit-width");
            },
            selectPosition: function() {
                this.$bsContainer = $('<div class="bs-container" />');
                var that = this, $container = $(this.options.container), pos, containerPos, actualHeight, getPlacement = function($element) {
                    var containerPosition = {}, // fall back to dropdown's default display setting if display is not manually set
                    display = that.options.display || // Bootstrap 3 doesn't have $.fn.dropdown.Constructor.Default
                    ($.fn.dropdown.Constructor.Default ? $.fn.dropdown.Constructor.Default.display : false);
                    that.$bsContainer.addClass($element.attr("class").replace(/form-control|fit-width/gi, "")).toggleClass(classNames.DROPUP, $element.hasClass(classNames.DROPUP));
                    pos = $element.offset();
                    if (!$container.is("body")) {
                        containerPos = $container.offset();
                        containerPos.top += parseInt($container.css("borderTopWidth")) - $container.scrollTop();
                        containerPos.left += parseInt($container.css("borderLeftWidth")) - $container.scrollLeft();
                    } else containerPos = {
                        top: 0,
                        left: 0
                    };
                    actualHeight = $element.hasClass(classNames.DROPUP) ? 0 : $element[0].offsetHeight;
                    // Bootstrap 4+ uses Popper for menu positioning
                    if (version.major < 4 || display === "static") {
                        containerPosition.top = pos.top - containerPos.top + actualHeight;
                        containerPosition.left = pos.left - containerPos.left;
                    }
                    containerPosition.width = $element[0].offsetWidth;
                    that.$bsContainer.css(containerPosition);
                };
                this.$button.on("click.bs.dropdown.data-api", function() {
                    if (that.isDisabled()) return;
                    getPlacement(that.$newElement);
                    that.$bsContainer.appendTo(that.options.container).toggleClass(classNames.SHOW, !that.$button.hasClass(classNames.SHOW)).append(that.$menu);
                });
                $(window).off("resize" + EVENT_KEY + "." + this.selectId + " scroll" + EVENT_KEY + "." + this.selectId).on("resize" + EVENT_KEY + "." + this.selectId + " scroll" + EVENT_KEY + "." + this.selectId, function() {
                    var isActive = that.$newElement.hasClass(classNames.SHOW);
                    if (isActive) getPlacement(that.$newElement);
                });
                this.$element.on("hide" + EVENT_KEY, function() {
                    that.$menu.data("height", that.$menu.height());
                    that.$bsContainer.detach();
                });
            },
            setOptionStatus: function(selectedOnly) {
                var that = this;
                that.noScroll = false;
                if (that.selectpicker.view.visibleElements && that.selectpicker.view.visibleElements.length) for(var i = 0; i < that.selectpicker.view.visibleElements.length; i++){
                    var liData = that.selectpicker.current.data[i + that.selectpicker.view.position0], option = liData.option;
                    if (option) {
                        if (selectedOnly !== true) that.setDisabled(liData.index, liData.disabled);
                        that.setSelected(liData.index, option.selected);
                    }
                }
            },
            /**
     * @param {number} index - the index of the option that is being changed
     * @param {boolean} selected - true if the option is being selected, false if being deselected
     */ setSelected: function(index, selected) {
                var li = this.selectpicker.main.elements[index], liData = this.selectpicker.main.data[index], activeIndexIsSet = this.activeIndex !== undefined, thisIsActive = this.activeIndex === index, prevActive, a, // if current option is already active
                // OR
                // if the current option is being selected, it's NOT multiple, and
                // activeIndex is undefined:
                //  - when the menu is first being opened, OR
                //  - after a search has been performed, OR
                //  - when retainActive is false when selecting a new option (i.e. index of the newly selected option is not the same as the current activeIndex)
                keepActive = thisIsActive || selected && !this.multiple && !activeIndexIsSet;
                liData.selected = selected;
                a = li.firstChild;
                if (selected) this.selectedIndex = index;
                li.classList.toggle("selected", selected);
                if (keepActive) {
                    this.focusItem(li, liData);
                    this.selectpicker.view.currentActive = li;
                    this.activeIndex = index;
                } else this.defocusItem(li);
                if (a) {
                    a.classList.toggle("selected", selected);
                    if (selected) a.setAttribute("aria-selected", true);
                    else if (this.multiple) a.setAttribute("aria-selected", false);
                    else a.removeAttribute("aria-selected");
                }
                if (!keepActive && !activeIndexIsSet && selected && this.prevActiveIndex !== undefined) {
                    prevActive = this.selectpicker.main.elements[this.prevActiveIndex];
                    this.defocusItem(prevActive);
                }
            },
            /**
     * @param {number} index - the index of the option that is being disabled
     * @param {boolean} disabled - true if the option is being disabled, false if being enabled
     */ setDisabled: function(index, disabled) {
                var li = this.selectpicker.main.elements[index], a;
                this.selectpicker.main.data[index].disabled = disabled;
                a = li.firstChild;
                li.classList.toggle(classNames.DISABLED, disabled);
                if (a) {
                    if (version.major === "4") a.classList.toggle(classNames.DISABLED, disabled);
                    if (disabled) {
                        a.setAttribute("aria-disabled", disabled);
                        a.setAttribute("tabindex", -1);
                    } else {
                        a.removeAttribute("aria-disabled");
                        a.setAttribute("tabindex", 0);
                    }
                }
            },
            isDisabled: function() {
                return this.$element[0].disabled;
            },
            checkDisabled: function() {
                if (this.isDisabled()) {
                    this.$newElement[0].classList.add(classNames.DISABLED);
                    this.$button.addClass(classNames.DISABLED).attr("aria-disabled", true);
                } else if (this.$button[0].classList.contains(classNames.DISABLED)) {
                    this.$newElement[0].classList.remove(classNames.DISABLED);
                    this.$button.removeClass(classNames.DISABLED).attr("aria-disabled", false);
                }
            },
            clickListener: function() {
                var that = this, $document = $(document);
                $document.data("spaceSelect", false);
                this.$button.on("keyup", function(e) {
                    if (/(32)/.test(e.keyCode.toString(10)) && $document.data("spaceSelect")) {
                        e.preventDefault();
                        $document.data("spaceSelect", false);
                    }
                });
                this.$newElement.on("show.bs.dropdown", function() {
                    if (version.major > 3 && !that.dropdown) {
                        that.dropdown = that.$button.data("bs.dropdown");
                        that.dropdown._menu = that.$menu[0];
                    }
                });
                this.$button.on("click.bs.dropdown.data-api", function() {
                    if (!that.$newElement.hasClass(classNames.SHOW)) that.setSize();
                });
                function setFocus() {
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else that.$menuInner.trigger("focus");
                }
                function checkPopperExists() {
                    if (that.dropdown && that.dropdown._popper && that.dropdown._popper.state.isCreated) setFocus();
                    else requestAnimationFrame(checkPopperExists);
                }
                this.$element.on("shown" + EVENT_KEY, function() {
                    if (that.$menuInner[0].scrollTop !== that.selectpicker.view.scrollTop) that.$menuInner[0].scrollTop = that.selectpicker.view.scrollTop;
                    if (version.major > 3) requestAnimationFrame(checkPopperExists);
                    else setFocus();
                });
                // ensure posinset and setsize are correct before selecting an option via a click
                this.$menuInner.on("mouseenter", "li a", function(e) {
                    var hoverLi = this.parentElement, position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0, index = Array.prototype.indexOf.call(hoverLi.parentElement.children, hoverLi), hoverData = that.selectpicker.current.data[index + position0];
                    that.focusItem(hoverLi, hoverData, true);
                });
                this.$menuInner.on("click", "li a", function(e, retainActive) {
                    var $this = $(this), element = that.$element[0], position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0, clickedData = that.selectpicker.current.data[$this.parent().index() + position0], clickedIndex = clickedData.index, prevValue = getSelectValues(element), prevIndex = element.selectedIndex, prevOption = element.options[prevIndex], triggerChange = true;
                    // Don't close on multi choice menu
                    if (that.multiple && that.options.maxOptions !== 1) e.stopPropagation();
                    e.preventDefault();
                    // Don't run if the select is disabled
                    if (!that.isDisabled() && !$this.parent().hasClass(classNames.DISABLED)) {
                        var option = clickedData.option, $option = $(option), state = option.selected, $optgroup = $option.parent("optgroup"), $optgroupOptions = $optgroup.find("option"), maxOptions = that.options.maxOptions, maxOptionsGrp = $optgroup.data("maxOptions") || false;
                        if (clickedIndex === that.activeIndex) retainActive = true;
                        if (!retainActive) {
                            that.prevActiveIndex = that.activeIndex;
                            that.activeIndex = undefined;
                        }
                        if (!that.multiple) {
                            if (prevOption) prevOption.selected = false;
                            option.selected = true;
                            that.setSelected(clickedIndex, true);
                        } else {
                            option.selected = !state;
                            that.setSelected(clickedIndex, !state);
                            that.focusedParent.focus();
                            if (maxOptions !== false || maxOptionsGrp !== false) {
                                var maxReached = maxOptions < getSelectedOptions(element).length, maxReachedGrp = maxOptionsGrp < $optgroup.find("option:selected").length;
                                if (maxOptions && maxReached || maxOptionsGrp && maxReachedGrp) {
                                    if (maxOptions && maxOptions == 1) {
                                        element.selectedIndex = -1;
                                        option.selected = true;
                                        that.setOptionStatus(true);
                                    } else if (maxOptionsGrp && maxOptionsGrp == 1) {
                                        for(var i = 0; i < $optgroupOptions.length; i++){
                                            var _option = $optgroupOptions[i];
                                            _option.selected = false;
                                            that.setSelected(_option.liIndex, false);
                                        }
                                        option.selected = true;
                                        that.setSelected(clickedIndex, true);
                                    } else {
                                        var maxOptionsText = typeof that.options.maxOptionsText === "string" ? [
                                            that.options.maxOptionsText,
                                            that.options.maxOptionsText
                                        ] : that.options.maxOptionsText, maxOptionsArr = typeof maxOptionsText === "function" ? maxOptionsText(maxOptions, maxOptionsGrp) : maxOptionsText, maxTxt = maxOptionsArr[0].replace("{n}", maxOptions), maxTxtGrp = maxOptionsArr[1].replace("{n}", maxOptionsGrp), $notify = $('<div class="notify"></div>');
                                        // If {var} is set in array, replace it
                                        /** @deprecated */ if (maxOptionsArr[2]) {
                                            maxTxt = maxTxt.replace("{var}", maxOptionsArr[2][maxOptions > 1 ? 0 : 1]);
                                            maxTxtGrp = maxTxtGrp.replace("{var}", maxOptionsArr[2][maxOptionsGrp > 1 ? 0 : 1]);
                                        }
                                        option.selected = false;
                                        that.$menu.append($notify);
                                        if (maxOptions && maxReached) {
                                            $notify.append($("<div>" + maxTxt + "</div>"));
                                            triggerChange = false;
                                            that.$element.trigger("maxReached" + EVENT_KEY);
                                        }
                                        if (maxOptionsGrp && maxReachedGrp) {
                                            $notify.append($("<div>" + maxTxtGrp + "</div>"));
                                            triggerChange = false;
                                            that.$element.trigger("maxReachedGrp" + EVENT_KEY);
                                        }
                                        setTimeout(function() {
                                            that.setSelected(clickedIndex, false);
                                        }, 10);
                                        $notify[0].classList.add("fadeOut");
                                        setTimeout(function() {
                                            $notify.remove();
                                        }, 1050);
                                    }
                                }
                            }
                        }
                        if (!that.multiple || that.multiple && that.options.maxOptions === 1) that.$button.trigger("focus");
                        else if (that.options.liveSearch) that.$searchbox.trigger("focus");
                        // Trigger select 'change'
                        if (triggerChange) {
                            if (that.multiple || prevIndex !== element.selectedIndex) {
                                // $option.prop('selected') is current option state (selected/unselected). prevValue is the value of the select prior to being changed.
                                changedArguments = [
                                    option.index,
                                    $option.prop("selected"),
                                    prevValue
                                ];
                                that.$element.triggerNative("change");
                            }
                        }
                    }
                });
                this.$menu.on("click", "li." + classNames.DISABLED + " a, ." + classNames.POPOVERHEADER + ", ." + classNames.POPOVERHEADER + " :not(.close)", function(e) {
                    if (e.currentTarget == this) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (that.options.liveSearch && !$(e.target).hasClass("close")) that.$searchbox.trigger("focus");
                        else that.$button.trigger("focus");
                    }
                });
                this.$menuInner.on("click", ".divider, .dropdown-header", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else that.$button.trigger("focus");
                });
                this.$menu.on("click", "." + classNames.POPOVERHEADER + " .close", function() {
                    that.$button.trigger("click");
                });
                this.$searchbox.on("click", function(e) {
                    e.stopPropagation();
                });
                this.$menu.on("click", ".actions-btn", function(e) {
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else that.$button.trigger("focus");
                    e.preventDefault();
                    e.stopPropagation();
                    if ($(this).hasClass("bs-select-all")) that.selectAll();
                    else that.deselectAll();
                });
                this.$button.on("focus" + EVENT_KEY, function(e) {
                    var tabindex = that.$element[0].getAttribute("tabindex");
                    // only change when button is actually focused
                    if (tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
                        // apply select element's tabindex to ensure correct order is followed when tabbing to the next element
                        this.setAttribute("tabindex", tabindex);
                        // set element's tabindex to -1 to allow for reverse tabbing
                        that.$element[0].setAttribute("tabindex", -1);
                        that.selectpicker.view.tabindex = tabindex;
                    }
                }).on("blur" + EVENT_KEY, function(e) {
                    // revert everything to original tabindex
                    if (that.selectpicker.view.tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
                        that.$element[0].setAttribute("tabindex", that.selectpicker.view.tabindex);
                        this.setAttribute("tabindex", -1);
                        that.selectpicker.view.tabindex = undefined;
                    }
                });
                this.$element.on("change" + EVENT_KEY, function() {
                    that.render();
                    that.$element.trigger("changed" + EVENT_KEY, changedArguments);
                    changedArguments = null;
                }).on("focus" + EVENT_KEY, function() {
                    if (!that.options.mobile) that.$button[0].focus();
                });
            },
            liveSearchListener: function() {
                var that = this;
                this.$button.on("click.bs.dropdown.data-api", function() {
                    if (!!that.$searchbox.val()) {
                        that.$searchbox.val("");
                        that.selectpicker.search.previousValue = undefined;
                    }
                });
                this.$searchbox.on("click.bs.dropdown.data-api focus.bs.dropdown.data-api touchend.bs.dropdown.data-api", function(e) {
                    e.stopPropagation();
                });
                this.$searchbox.on("input propertychange", function() {
                    var searchValue = that.$searchbox[0].value;
                    that.selectpicker.search.elements = [];
                    that.selectpicker.search.data = [];
                    if (searchValue) {
                        var i, searchMatch = [], q = searchValue.toUpperCase(), cache = {}, cacheArr = [], searchStyle = that._searchStyle(), normalizeSearch = that.options.liveSearchNormalize;
                        if (normalizeSearch) q = normalizeToBase(q);
                        for(var i = 0; i < that.selectpicker.main.data.length; i++){
                            var li = that.selectpicker.main.data[i];
                            if (!cache[i]) cache[i] = stringSearch(li, q, searchStyle, normalizeSearch);
                            if (cache[i] && li.headerIndex !== undefined && cacheArr.indexOf(li.headerIndex) === -1) {
                                if (li.headerIndex > 0) {
                                    cache[li.headerIndex - 1] = true;
                                    cacheArr.push(li.headerIndex - 1);
                                }
                                cache[li.headerIndex] = true;
                                cacheArr.push(li.headerIndex);
                                cache[li.lastIndex + 1] = true;
                            }
                            if (cache[i] && li.type !== "optgroup-label") cacheArr.push(i);
                        }
                        for(var i = 0, cacheLen = cacheArr.length; i < cacheLen; i++){
                            var index = cacheArr[i], prevIndex = cacheArr[i - 1], li = that.selectpicker.main.data[index], liPrev = that.selectpicker.main.data[prevIndex];
                            if (li.type !== "divider" || li.type === "divider" && liPrev && liPrev.type !== "divider" && cacheLen - 1 !== i) {
                                that.selectpicker.search.data.push(li);
                                searchMatch.push(that.selectpicker.main.elements[index]);
                            }
                        }
                        that.activeIndex = undefined;
                        that.noScroll = true;
                        that.$menuInner.scrollTop(0);
                        that.selectpicker.search.elements = searchMatch;
                        that.createView(true);
                        showNoResults.call(that, searchMatch, searchValue);
                    } else if (that.selectpicker.search.previousValue) {
                        that.$menuInner.scrollTop(0);
                        that.createView(false);
                    }
                    that.selectpicker.search.previousValue = searchValue;
                });
            },
            _searchStyle: function() {
                return this.options.liveSearchStyle || "contains";
            },
            val: function(value) {
                var element = this.$element[0];
                if (typeof value !== "undefined") {
                    var prevValue = getSelectValues(element);
                    changedArguments = [
                        null,
                        null,
                        prevValue
                    ];
                    this.$element.val(value).trigger("changed" + EVENT_KEY, changedArguments);
                    if (this.$newElement.hasClass(classNames.SHOW)) {
                        if (this.multiple) this.setOptionStatus(true);
                        else {
                            var liSelectedIndex = (element.options[element.selectedIndex] || {}).liIndex;
                            if (typeof liSelectedIndex === "number") {
                                this.setSelected(this.selectedIndex, false);
                                this.setSelected(liSelectedIndex, true);
                            }
                        }
                    }
                    this.render();
                    changedArguments = null;
                    return this.$element;
                } else return this.$element.val();
            },
            changeAll: function(status) {
                if (!this.multiple) return;
                if (typeof status === "undefined") status = true;
                var element = this.$element[0], previousSelected = 0, currentSelected = 0, prevValue = getSelectValues(element);
                element.classList.add("bs-select-hidden");
                for(var i = 0, data = this.selectpicker.current.data, len = data.length; i < len; i++){
                    var liData = data[i], option = liData.option;
                    if (option && !liData.disabled && liData.type !== "divider") {
                        if (liData.selected) previousSelected++;
                        option.selected = status;
                        if (status === true) currentSelected++;
                    }
                }
                element.classList.remove("bs-select-hidden");
                if (previousSelected === currentSelected) return;
                this.setOptionStatus();
                changedArguments = [
                    null,
                    null,
                    prevValue
                ];
                this.$element.triggerNative("change");
            },
            selectAll: function() {
                return this.changeAll(true);
            },
            deselectAll: function() {
                return this.changeAll(false);
            },
            toggle: function(e) {
                e = e || window.event;
                if (e) e.stopPropagation();
                this.$button.trigger("click.bs.dropdown.data-api");
            },
            keydown: function(e) {
                var $this = $(this), isToggle = $this.hasClass("dropdown-toggle"), $parent = isToggle ? $this.closest(".dropdown") : $this.closest(Selector.MENU), that = $parent.data("this"), $items = that.findLis(), index, isActive, liActive, activeLi, offset, updateScroll = false, downOnTab = e.which === keyCodes.TAB && !isToggle && !that.options.selectOnTab, isArrowKey = REGEXP_ARROW.test(e.which) || downOnTab, scrollTop = that.$menuInner[0].scrollTop, isVirtual = that.isVirtual(), position0 = isVirtual === true ? that.selectpicker.view.position0 : 0;
                // do nothing if a function key is pressed
                if (e.which >= 112 && e.which <= 123) return;
                isActive = that.$newElement.hasClass(classNames.SHOW);
                if (!isActive && (isArrowKey || e.which >= 48 && e.which <= 57 || e.which >= 96 && e.which <= 105 || e.which >= 65 && e.which <= 90)) {
                    that.$button.trigger("click.bs.dropdown.data-api");
                    if (that.options.liveSearch) {
                        that.$searchbox.trigger("focus");
                        return;
                    }
                }
                if (e.which === keyCodes.ESCAPE && isActive) {
                    e.preventDefault();
                    that.$button.trigger("click.bs.dropdown.data-api").trigger("focus");
                }
                if (isArrowKey) {
                    if (!$items.length) return;
                    liActive = that.selectpicker.main.elements[that.activeIndex];
                    index = liActive ? Array.prototype.indexOf.call(liActive.parentElement.children, liActive) : -1;
                    if (index !== -1) that.defocusItem(liActive);
                    if (e.which === keyCodes.ARROW_UP) {
                        if (index !== -1) index--;
                        if (index + position0 < 0) index += $items.length;
                        if (!that.selectpicker.view.canHighlight[index + position0]) {
                            index = that.selectpicker.view.canHighlight.slice(0, index + position0).lastIndexOf(true) - position0;
                            if (index === -1) index = $items.length - 1;
                        }
                    } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) {
                        index++;
                        if (index + position0 >= that.selectpicker.view.canHighlight.length) index = that.selectpicker.view.firstHighlightIndex;
                        if (!that.selectpicker.view.canHighlight[index + position0]) index = index + 1 + that.selectpicker.view.canHighlight.slice(index + position0 + 1).indexOf(true);
                    }
                    e.preventDefault();
                    var liActiveIndex = position0 + index;
                    if (e.which === keyCodes.ARROW_UP) {
                        // scroll to bottom and highlight last option
                        if (position0 === 0 && index === $items.length - 1) {
                            that.$menuInner[0].scrollTop = that.$menuInner[0].scrollHeight;
                            liActiveIndex = that.selectpicker.current.elements.length - 1;
                        } else {
                            activeLi = that.selectpicker.current.data[liActiveIndex];
                            offset = activeLi.position - activeLi.height;
                            updateScroll = offset < scrollTop;
                        }
                    } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) {
                        // scroll to top and highlight first option
                        if (index === that.selectpicker.view.firstHighlightIndex) {
                            that.$menuInner[0].scrollTop = 0;
                            liActiveIndex = that.selectpicker.view.firstHighlightIndex;
                        } else {
                            activeLi = that.selectpicker.current.data[liActiveIndex];
                            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
                            updateScroll = offset > scrollTop;
                        }
                    }
                    liActive = that.selectpicker.current.elements[liActiveIndex];
                    that.activeIndex = that.selectpicker.current.data[liActiveIndex].index;
                    that.focusItem(liActive);
                    that.selectpicker.view.currentActive = liActive;
                    if (updateScroll) that.$menuInner[0].scrollTop = offset;
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else $this.trigger("focus");
                } else if (!$this.is("input") && !REGEXP_TAB_OR_ESCAPE.test(e.which) || e.which === keyCodes.SPACE && that.selectpicker.keydown.keyHistory) {
                    var searchMatch, matches = [], keyHistory;
                    e.preventDefault();
                    that.selectpicker.keydown.keyHistory += keyCodeMap[e.which];
                    if (that.selectpicker.keydown.resetKeyHistory.cancel) clearTimeout(that.selectpicker.keydown.resetKeyHistory.cancel);
                    that.selectpicker.keydown.resetKeyHistory.cancel = that.selectpicker.keydown.resetKeyHistory.start();
                    keyHistory = that.selectpicker.keydown.keyHistory;
                    // if all letters are the same, set keyHistory to just the first character when searching
                    if (/^(.)\1+$/.test(keyHistory)) keyHistory = keyHistory.charAt(0);
                    // find matches
                    for(var i = 0; i < that.selectpicker.current.data.length; i++){
                        var li = that.selectpicker.current.data[i], hasMatch;
                        hasMatch = stringSearch(li, keyHistory, "startsWith", true);
                        if (hasMatch && that.selectpicker.view.canHighlight[i]) matches.push(li.index);
                    }
                    if (matches.length) {
                        var matchIndex = 0;
                        $items.removeClass("active").find("a").removeClass("active");
                        // either only one key has been pressed or they are all the same key
                        if (keyHistory.length === 1) {
                            matchIndex = matches.indexOf(that.activeIndex);
                            if (matchIndex === -1 || matchIndex === matches.length - 1) matchIndex = 0;
                            else matchIndex++;
                        }
                        searchMatch = matches[matchIndex];
                        activeLi = that.selectpicker.main.data[searchMatch];
                        if (scrollTop - activeLi.position > 0) {
                            offset = activeLi.position - activeLi.height;
                            updateScroll = true;
                        } else {
                            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
                            // if the option is already visible at the current scroll position, just keep it the same
                            updateScroll = activeLi.position > scrollTop + that.sizeInfo.menuInnerHeight;
                        }
                        liActive = that.selectpicker.main.elements[searchMatch];
                        that.activeIndex = matches[matchIndex];
                        that.focusItem(liActive);
                        if (liActive) liActive.firstChild.focus();
                        if (updateScroll) that.$menuInner[0].scrollTop = offset;
                        $this.trigger("focus");
                    }
                }
                // Select focused option if "Enter", "Spacebar" or "Tab" (when selectOnTab is true) are pressed inside the menu.
                if (isActive && (e.which === keyCodes.SPACE && !that.selectpicker.keydown.keyHistory || e.which === keyCodes.ENTER || e.which === keyCodes.TAB && that.options.selectOnTab)) {
                    if (e.which !== keyCodes.SPACE) e.preventDefault();
                    if (!that.options.liveSearch || e.which !== keyCodes.SPACE) {
                        that.$menuInner.find(".active a").trigger("click", true); // retain active class
                        $this.trigger("focus");
                        if (!that.options.liveSearch) {
                            // Prevent screen from scrolling if the user hits the spacebar
                            e.preventDefault();
                            // Fixes spacebar selection of dropdown items in FF & IE
                            $(document).data("spaceSelect", true);
                        }
                    }
                }
            },
            mobile: function() {
                // ensure mobile is set to true if mobile function is called after init
                this.options.mobile = true;
                this.$element[0].classList.add("mobile-device");
            },
            refresh: function() {
                // update options if data attributes have been changed
                var config = $.extend({}, this.options, this.$element.data());
                this.options = config;
                this.checkDisabled();
                this.buildData();
                this.setStyle();
                this.render();
                this.buildList();
                this.setWidth();
                this.setSize(true);
                this.$element.trigger("refreshed" + EVENT_KEY);
            },
            hide: function() {
                this.$newElement.hide();
            },
            show: function() {
                this.$newElement.show();
            },
            remove: function() {
                this.$newElement.remove();
                this.$element.remove();
            },
            destroy: function() {
                this.$newElement.before(this.$element).remove();
                if (this.$bsContainer) this.$bsContainer.remove();
                else this.$menu.remove();
                if (this.selectpicker.view.titleOption && this.selectpicker.view.titleOption.parentNode) this.selectpicker.view.titleOption.parentNode.removeChild(this.selectpicker.view.titleOption);
                this.$element.off(EVENT_KEY).removeData("selectpicker").removeClass("bs-select-hidden selectpicker");
                $(window).off(EVENT_KEY + "." + this.selectId);
            }
        };
        // SELECTPICKER PLUGIN DEFINITION
        // ==============================
        function Plugin(option) {
            // get the args of the outer function..
            var args = arguments;
            // The arguments of the function are explicitly re-defined from the argument list, because the shift causes them
            // to get lost/corrupted in android 2.3 and IE9 #715 #775
            var _option = option;
            [].shift.apply(args);
            // if the version was not set successfully
            if (!version.success) {
                // try to retreive it again
                try {
                    version.full = ($.fn.dropdown.Constructor.VERSION || "").split(" ")[0].split(".");
                } catch (err) {
                    // fall back to use BootstrapVersion if set
                    if (Selectpicker.BootstrapVersion) version.full = Selectpicker.BootstrapVersion.split(" ")[0].split(".");
                    else {
                        version.full = [
                            version.major,
                            "0",
                            "0"
                        ];
                        console.warn("There was an issue retrieving Bootstrap's version. Ensure Bootstrap is being loaded before bootstrap-select and there is no namespace collision. If loading Bootstrap asynchronously, the version may need to be manually specified via $.fn.selectpicker.Constructor.BootstrapVersion.", err);
                    }
                }
                version.major = version.full[0];
                version.success = true;
            }
            if (version.major === "4") {
                // some defaults need to be changed if using Bootstrap 4
                // check to see if they have already been manually changed before forcing them to update
                var toUpdate = [];
                if (Selectpicker.DEFAULTS.style === classNames.BUTTONCLASS) toUpdate.push({
                    name: "style",
                    className: "BUTTONCLASS"
                });
                if (Selectpicker.DEFAULTS.iconBase === classNames.ICONBASE) toUpdate.push({
                    name: "iconBase",
                    className: "ICONBASE"
                });
                if (Selectpicker.DEFAULTS.tickIcon === classNames.TICKICON) toUpdate.push({
                    name: "tickIcon",
                    className: "TICKICON"
                });
                classNames.DIVIDER = "dropdown-divider";
                classNames.SHOW = "show";
                classNames.BUTTONCLASS = "btn-light";
                classNames.POPOVERHEADER = "popover-header";
                classNames.ICONBASE = "";
                classNames.TICKICON = "bs-ok-default";
                for(var i = 0; i < toUpdate.length; i++){
                    var option = toUpdate[i];
                    Selectpicker.DEFAULTS[option.name] = classNames[option.className];
                }
            }
            var value;
            var chain = this.each(function() {
                var $this = $(this);
                if ($this.is("select")) {
                    var data = $this.data("selectpicker"), options = typeof _option == "object" && _option;
                    if (!data) {
                        var dataAttributes = $this.data();
                        for(var dataAttr in dataAttributes)if (Object.prototype.hasOwnProperty.call(dataAttributes, dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) delete dataAttributes[dataAttr];
                        var config = $.extend({}, Selectpicker.DEFAULTS, $.fn.selectpicker.defaults || {}, dataAttributes, options);
                        config.template = $.extend({}, Selectpicker.DEFAULTS.template, $.fn.selectpicker.defaults ? $.fn.selectpicker.defaults.template : {}, dataAttributes.template, options.template);
                        $this.data("selectpicker", data = new Selectpicker(this, config));
                    } else if (options) {
                        for(var i in options)if (Object.prototype.hasOwnProperty.call(options, i)) data.options[i] = options[i];
                    }
                    if (typeof _option == "string") {
                        if (data[_option] instanceof Function) value = data[_option].apply(data, args);
                        else value = data.options[_option];
                    }
                }
            });
            if (typeof value !== "undefined") // noinspection JSUnusedAssignment
            return value;
            else return chain;
        }
        var old = $.fn.selectpicker;
        $.fn.selectpicker = Plugin;
        $.fn.selectpicker.Constructor = Selectpicker;
        // SELECTPICKER NO CONFLICT
        // ========================
        $.fn.selectpicker.noConflict = function() {
            $.fn.selectpicker = old;
            return this;
        };
        // get Bootstrap's keydown event handler for either Bootstrap 4 or Bootstrap 3
        function keydownHandler() {
            if ($.fn.dropdown) {
                // wait to define until function is called in case Bootstrap isn't loaded yet
                var bootstrapKeydown = $.fn.dropdown.Constructor._dataApiKeydownHandler || $.fn.dropdown.Constructor.prototype.keydown;
                return bootstrapKeydown.apply(this, arguments);
            }
        }
        $(document).off("keydown.bs.dropdown.data-api").on("keydown.bs.dropdown.data-api", ':not(.bootstrap-select) > [data-toggle="dropdown"]', keydownHandler).on("keydown.bs.dropdown.data-api", ":not(.bootstrap-select) > .dropdown-menu", keydownHandler).on("keydown" + EVENT_KEY, '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', Selectpicker.prototype.keydown).on("focusin.modal", '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', function(e) {
            e.stopPropagation();
        });
        // SELECTPICKER DATA-API
        // =====================
        $(window).on("load" + EVENT_KEY + ".data-api", function() {
            $(".selectpicker").each(function() {
                var $selectpicker = $(this);
                Plugin.call($selectpicker, $selectpicker.data());
            });
        });
    })(jQuery);
});


$(()=>{
    /*
        Event to listen to changes in the slot filter
     */ $("#slot-filter").on("changed.bs.select", function(e, clickedIndex, isSelected, previousValue) {
        /*
            If Select All / Deselect All is clicked, isSelected will be null
         */ if (isSelected === null) {
            $("#slot-buttons button").show();
            return;
        }
        // If the current state has no selected items, show everything
        if (previousValue.length === 1 && !isSelected) {
            $("#slot-buttons button").show();
            return;
        }
        // If the previous state had nothing selected, hide everything
        // and display the selected option
        if (previousValue.length === 0) $("#slot-buttons button").hide();
        var option = $("option", this)[clickedIndex].value;
        if (isSelected) $("#slot-buttons button:not(:visible)").each(function() {
            if ($(this).data("slot") === option) $(this).show();
        });
        else $("#slot-buttons button:visible").each(function() {
            if ($(this).data("slot") === option) $(this).hide();
        });
        if ($("#slot-buttons button.selected:not(:visible)").length > 0) {
            $("#slot-buttons button.selected").removeClass("selected");
            $("#advanced-options input").val("");
        }
    });
    // Hack to turn off auto focus, should be removed when
    // the bug in bootstrap-select is fixed
    $("#filter-by-slot").on("change", function() {
        $(this).siblings(".dropdown-menu").children(".bs-searchbox").children('input[type="search"]').trigger("blur");
    });
    /*
        Click event for the slot buttons
     */ $("#slot-buttons").on("click", "button", function() {
        $(".slot-button.selected").removeClass("selected");
        $(this).attr("class", "slot-button selected");
        var slot = $(this).data("slot");
        var faculty = $(this).data("faculty");
        var type = $(this).data("type");
        var venue = $(this).data("venue");
        var credits = $(this).data("credits");
        $("#slot-input").val(slot);
        $("#faculty-input").val(faculty);
        $("#venue-input").val(venue);
        $("#credits-input").val(credits);
        $("#is-project-input").val(type === "EPJ" ? "true" : "false");
    });
    /*
        Double click event to quickly add a course
     */ $("#slot-buttons").on("dblclick", "button", function() {
        $("#add-course-button").trigger("click");
        $(this).trigger("blur");
    });
    /*
        Click event to toggle advanced options
     */ $("#advanced-toggle").on("click", function() {
        if ($(this).attr("data-state") === "enabled") {
            $(this).text("Show Advanced Options");
            $(this).attr("class", "btn btn-outline-secondary");
            $(this).attr("data-state", "disabled");
        } else {
            $(this).text("Hide Advanced Options");
            $(this).attr("class", "btn btn-secondary");
            $(this).attr("data-state", "enabled");
        }
        $("#advanced-options").slideToggle();
    });
    /*
        Click event to clear the panel
     */ $("#clear-panel-button").on("click", function() {
        clearPanel();
    });
    /*
        Click event to add a course
     */ $("#add-course-button").on("click", function() {
        var course = $("#course-input").val().trim().split("-");
        var faculty = $("#faculty-input").val().trim();
        var slotString = $("#slot-input").val().toUpperCase().trim();
        var venue = $("#venue-input").val().trim();
        var credits = $("#credits-input").val().trim();
        var isProject = $("#is-project-input").val();
        // Reset is-project-input once read
        $("#is-project-input").val("false");
        if (course[0] == "") {
            $("#course-input").trigger("focus");
            return;
        }
        if (slotString == "") {
            if ($("#advanced-toggle").attr("data-state") != "enabled") $("#advanced-toggle").trigger("click");
            $("#slot-input").trigger("focus");
            return;
        }
        var slots = function() {
            var arr = [];
            try {
                slotString.split(/\s*\+\s*/).forEach(function(el) {
                    if (el && $("." + el)) arr.push(el);
                });
            } catch (error) {
                arr = [];
            }
            return arr;
        }();
        var courseId = 0;
        if (activeTable.data.length != 0) {
            var lastAddedCourse = activeTable.data[activeTable.data.length - 1];
            courseId = lastAddedCourse.courseId + 1;
        }
        var courseCode = course[0].trim();
        var courseTitle = course.slice(1).join("-").trim();
        var courseData = {
            courseId: courseId,
            courseCode: courseCode,
            courseTitle: courseTitle,
            faculty: faculty,
            slots: slots,
            venue: venue,
            credits: credits,
            isProject: isProject
        };
        activeTable.data.push(courseData);
        addCourseToCourseList(courseData);
        addCourseToTimetable(courseData);
    });
});
const $8f59ae824258cdb7$var$courses_data = {
    courses: [],
    all_data: []
};






/*
    Function to get the courses based on the selected campus
 */ window.getCourses = ()=>{
    if (window.campus == "AP") {
        $8f59ae824258cdb7$var$courses_data.all_data = (parcelRequire("jowe3"));
        $8f59ae824258cdb7$var$courses_data.courses = (parcelRequire("4n35S"));
    } else if (window.campus == "Chennai") {
        $8f59ae824258cdb7$var$courses_data.all_data = (parcelRequire("6V6Os"));
        $8f59ae824258cdb7$var$courses_data.courses = (parcelRequire("lyvvK"));
    } else {
        $8f59ae824258cdb7$var$courses_data.all_data = (parcelRequire("7M6xr"));
        $8f59ae824258cdb7$var$courses_data.courses = (parcelRequire("4YZz6"));
    }
    $8f59ae824258cdb7$var$initializeAutocomplete();
};
/*
    Function to fill the course input with unique courses
 */ function $8f59ae824258cdb7$var$initializeAutocomplete() {
    const courseOptions = {
        data: $8f59ae824258cdb7$var$courses_data.courses,
        getValue: function(el) {
            return el.CODE + " - " + el.TITLE;
        },
        list: {
            match: {
                enabled: true
            },
            maxNumberOfElements: 10,
            onSelectItemEvent: function() {
                var title = $("#course-input").getSelectedItemData().TITLE;
                var code = $("#course-input").getSelectedItemData().CODE;
                $("#course-input").val(code + " - " + title);
                addSlotButtons(code);
            }
        }
    };
    $("#course-input").easyAutocomplete(courseOptions);
    $("div .easy-autocomplete").removeAttr("style");
}
/*
    Function to build a slot button
 */ function $8f59ae824258cdb7$var$buildSlotButton(courseData) {
    var $slotButton = $('<button class="slot-button" type="button"></button>');
    var $h6 = $('<h6 class="slot-button-heading"></h6>');
    var $p = $('<p class="slot-button-text"></p>');
    $h6.text(courseData.SLOT);
    $p.text([
        courseData.FACULTY,
        courseData.VENUE,
        courseData.TYPE
    ].filter(function(el) {
        if (el != "") return el;
    }).join(" | "));
    $slotButton.append($h6);
    $slotButton.append($p);
    $slotButton.data("code", courseData.CODE);
    $slotButton.data("title", courseData.TITLE);
    $slotButton.data("slot", courseData.SLOT);
    $slotButton.data("faculty", courseData.FACULTY);
    $slotButton.data("type", courseData.TYPE);
    $slotButton.data("venue", courseData.VENUE);
    $slotButton.data("credits", courseData.CREDITS);
    return $slotButton;
}
/*
    Function to add slot buttons and filter options
 */ window.addSlotButtons = (courseCode)=>{
    $("#slot-buttons").html("");
    $8f59ae824258cdb7$var$resetFilters();
    var theorySlotGroup = [];
    var labSlotGroup = [];
    $.each($8f59ae824258cdb7$var$courses_data.all_data, function(key, value) {
        if (value.CODE === courseCode) {
            var $slotButton = $8f59ae824258cdb7$var$buildSlotButton(value);
            // Checking if the slot belongs to lab or theory
            if (value.SLOT[0] === "L") {
                if (labSlotGroup.indexOf(value.SLOT) === -1) labSlotGroup.push(value.SLOT);
            } else if (theorySlotGroup.indexOf(value.SLOT) === -1) theorySlotGroup.push(value.SLOT);
            // Injecting the slot button to the document body
            $("#slot-buttons").append($slotButton);
        }
    });
    /*
        Adding the theory slots to the filter
     */ if (theorySlotGroup.length) {
        var $theorySlotGroup = $('<optgroup label="Theory"></optgroup>');
        theorySlotGroup.forEach(function(el) {
            var $option = $(`<option value="${el}">${el}</option>`);
            $theorySlotGroup.append($option);
        });
        $("#slot-filter").append($theorySlotGroup);
    }
    /*
        Adding the lab slots to the filter
     */ if (labSlotGroup.length) {
        var $labSlotGroup = $('<optgroup label="Lab"></optgroup>');
        labSlotGroup.forEach(function(el) {
            var $option = $(`<option value="${el}">${el}</option>`);
            $labSlotGroup.append($option);
        });
        $("#slot-filter").append($labSlotGroup);
    }
    if ($("#slot-filter option").length) $("#slot-filter").prop("disabled", false);
    else $("#slot-filter").prop("disabled", true);
    $("#slot-filter").selectpicker("refresh");
};
/*
    Function to reset all filters, deletes all filter options
 */ function $8f59ae824258cdb7$var$resetFilters() {
    // Resetting the slot filter
    $("#slot-filter").html("");
    $("#slot-filter").prop("disabled", true);
    $("#slot-filter").selectpicker("refresh");
}
/*
    Function to clear the course panel
 */ window.clearPanel = ()=>{
    $("#course-panel input").val("");
    $("#slot-buttons").html("");
    $8f59ae824258cdb7$var$resetFilters();
};


/*
 *  This file contains the events and functions applied to
 *  the timetable
 */ 
var $c84fe0b6641299f2$exports = {};
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $c84fe0b6641299f2$exports = factory();
})($c84fe0b6641299f2$exports, function() {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = "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";
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = "!";
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = "strict";
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                "normal",
                "auto",
                "loose"
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === "strict" ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: "normal",
            wordBreak: "normal"
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === "break-all" || options.wordBreak === "break-word") classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === "undefined" ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ""
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = "";
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = "";
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = "";
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === "undefined" ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== "undefined" ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case "rem":
            case "em":
                return 16 * token.number; // TODO use correct font-size
            case "px":
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = "deg";
    var GRAD = "grad";
    var RAD = "rad";
    var TURN = "turn";
    var angle = {
        name: "angle",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(" ");
        switch(sideOrCorner){
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case "to top":
            case "bottom":
                return deg(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case "to right":
            case "left":
                return deg(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case "to bottom":
            case "top":
                return deg(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case "to left":
            case "right":
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: "color",
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === "undefined") throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== "undefined") return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: "background-clip",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === "number" ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === "to") {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    "top",
                    "left",
                    "right",
                    "bottom"
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === "linear") {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === "from") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === "to") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === "color-stop") {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = "closest-side";
    var FARTHEST_SIDE = "farthest-side";
    var CLOSEST_CORNER = "closest-corner";
    var FARTHEST_CORNER = "farthest-corner";
    var CIRCLE = "circle";
    var ELLIPSE = "ellipse";
    var COVER = "cover";
    var CONTAIN = "contain";
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case "center":
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case "top":
                            case "left":
                                position.push(ZERO_LENGTH);
                                return acc;
                            case "right":
                            case "bottom":
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case "at":
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case "center":
                        position.push(FIFTY_PERCENT);
                        return false;
                    case "top":
                    case "left":
                        position.push(ZERO_LENGTH);
                        return false;
                    case "right":
                    case "bottom":
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: "image",
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === "undefined") throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === "none") && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        "linear-gradient": linearGradient,
        "-moz-linear-gradient": prefixLinearGradient,
        "-ms-linear-gradient": prefixLinearGradient,
        "-o-linear-gradient": prefixLinearGradient,
        "-webkit-linear-gradient": prefixLinearGradient,
        "radial-gradient": radialGradient,
        "-moz-radial-gradient": prefixRadialGradient,
        "-ms-radial-gradient": prefixRadialGradient,
        "-o-radial-gradient": prefixRadialGradient,
        "-webkit-radial-gradient": prefixRadialGradient,
        "-webkit-gradient": webkitGradient
    };
    var backgroundImage = {
        name: "background-image",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: "background-origin",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: "background-position",
        initialValue: "0% 0%",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: "background-repeat",
        initialValue: "repeat",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(" ");
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case "no-repeat":
                return 1 /* NO_REPEAT */ ;
            case "repeat-x":
            case "repeat no-repeat":
                return 2 /* REPEAT_X */ ;
            case "repeat-y":
            case "no-repeat repeat":
                return 3 /* REPEAT_Y */ ;
            case "repeat":
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: "background-size",
        initialValue: "0",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: "transparent",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "color"
        };
    };
    var borderTopColor = borderColorForSide("top");
    var borderRightColor = borderColorForSide("right");
    var borderBottomColor = borderColorForSide("bottom");
    var borderLeftColor = borderColorForSide("left");
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: "0 0",
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide("top-left");
    var borderTopRightRadius = borderRadiusForSide("top-right");
    var borderBottomRightRadius = borderRadiusForSide("bottom-right");
    var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: "solid",
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case "none":
                        return 0 /* NONE */ ;
                    case "dashed":
                        return 2 /* DASHED */ ;
                    case "dotted":
                        return 3 /* DOTTED */ ;
                    case "double":
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide("top");
    var borderRightStyle = borderStyleForSide("right");
    var borderBottomStyle = borderStyleForSide("bottom");
    var borderLeftStyle = borderStyleForSide("left");
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: "0",
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide("top");
    var borderRightWidth = borderWidthForSide("right");
    var borderBottomWidth = borderWidthForSide("bottom");
    var borderLeftWidth = borderWidthForSide("left");
    var color = {
        name: "color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var direction = {
        name: "direction",
        initialValue: "ltr",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case "rtl":
                    return 1 /* RTL */ ;
                case "ltr":
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: "display",
        initialValue: "inline-block",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case "block":
            case "-webkit-box":
                return 2 /* BLOCK */ ;
            case "inline":
                return 4 /* INLINE */ ;
            case "run-in":
                return 8 /* RUN_IN */ ;
            case "flow":
                return 16 /* FLOW */ ;
            case "flow-root":
                return 32 /* FLOW_ROOT */ ;
            case "table":
                return 64 /* TABLE */ ;
            case "flex":
            case "-webkit-flex":
                return 128 /* FLEX */ ;
            case "grid":
            case "-ms-grid":
                return 256 /* GRID */ ;
            case "ruby":
                return 512 /* RUBY */ ;
            case "subgrid":
                return 1024 /* SUBGRID */ ;
            case "list-item":
                return 2048 /* LIST_ITEM */ ;
            case "table-row-group":
                return 4096 /* TABLE_ROW_GROUP */ ;
            case "table-header-group":
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case "table-footer-group":
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case "table-row":
                return 32768 /* TABLE_ROW */ ;
            case "table-cell":
                return 65536 /* TABLE_CELL */ ;
            case "table-column-group":
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case "table-column":
                return 262144 /* TABLE_COLUMN */ ;
            case "table-caption":
                return 524288 /* TABLE_CAPTION */ ;
            case "ruby-base":
                return 1048576 /* RUBY_BASE */ ;
            case "ruby-text":
                return 2097152 /* RUBY_TEXT */ ;
            case "ruby-base-container":
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case "ruby-text-container":
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case "contents":
                return 16777216 /* CONTENTS */ ;
            case "inline-block":
                return 33554432 /* INLINE_BLOCK */ ;
            case "inline-list-item":
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case "inline-table":
                return 134217728 /* INLINE_TABLE */ ;
            case "inline-flex":
                return 268435456 /* INLINE_FLEX */ ;
            case "inline-grid":
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: "float",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case "left":
                    return 1 /* LEFT */ ;
                case "right":
                    return 2 /* RIGHT */ ;
                case "inline-start":
                    return 3 /* INLINE_START */ ;
                case "inline-end":
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: "letter-spacing",
        initialValue: "0",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "normal") return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: "line-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case "strict":
                    return LINE_BREAK.STRICT;
                case "normal":
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: "line-height",
        initialValue: "normal",
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === "normal") return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: "list-style-image",
        initialValue: "none",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: "list-style-position",
        initialValue: "outside",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "inside":
                    return 0 /* INSIDE */ ;
                case "outside":
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: "list-style-type",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case "disc":
                    return 0 /* DISC */ ;
                case "circle":
                    return 1 /* CIRCLE */ ;
                case "square":
                    return 2 /* SQUARE */ ;
                case "decimal":
                    return 3 /* DECIMAL */ ;
                case "cjk-decimal":
                    return 4 /* CJK_DECIMAL */ ;
                case "decimal-leading-zero":
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case "lower-roman":
                    return 6 /* LOWER_ROMAN */ ;
                case "upper-roman":
                    return 7 /* UPPER_ROMAN */ ;
                case "lower-greek":
                    return 8 /* LOWER_GREEK */ ;
                case "lower-alpha":
                    return 9 /* LOWER_ALPHA */ ;
                case "upper-alpha":
                    return 10 /* UPPER_ALPHA */ ;
                case "arabic-indic":
                    return 11 /* ARABIC_INDIC */ ;
                case "armenian":
                    return 12 /* ARMENIAN */ ;
                case "bengali":
                    return 13 /* BENGALI */ ;
                case "cambodian":
                    return 14 /* CAMBODIAN */ ;
                case "cjk-earthly-branch":
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case "cjk-heavenly-stem":
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case "cjk-ideographic":
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case "devanagari":
                    return 18 /* DEVANAGARI */ ;
                case "ethiopic-numeric":
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case "georgian":
                    return 20 /* GEORGIAN */ ;
                case "gujarati":
                    return 21 /* GUJARATI */ ;
                case "gurmukhi":
                    return 22 /* GURMUKHI */ ;
                case "hebrew":
                    return 22 /* HEBREW */ ;
                case "hiragana":
                    return 23 /* HIRAGANA */ ;
                case "hiragana-iroha":
                    return 24 /* HIRAGANA_IROHA */ ;
                case "japanese-formal":
                    return 25 /* JAPANESE_FORMAL */ ;
                case "japanese-informal":
                    return 26 /* JAPANESE_INFORMAL */ ;
                case "kannada":
                    return 27 /* KANNADA */ ;
                case "katakana":
                    return 28 /* KATAKANA */ ;
                case "katakana-iroha":
                    return 29 /* KATAKANA_IROHA */ ;
                case "khmer":
                    return 30 /* KHMER */ ;
                case "korean-hangul-formal":
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case "korean-hanja-formal":
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case "korean-hanja-informal":
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case "lao":
                    return 34 /* LAO */ ;
                case "lower-armenian":
                    return 35 /* LOWER_ARMENIAN */ ;
                case "malayalam":
                    return 36 /* MALAYALAM */ ;
                case "mongolian":
                    return 37 /* MONGOLIAN */ ;
                case "myanmar":
                    return 38 /* MYANMAR */ ;
                case "oriya":
                    return 39 /* ORIYA */ ;
                case "persian":
                    return 40 /* PERSIAN */ ;
                case "simp-chinese-formal":
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case "simp-chinese-informal":
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case "tamil":
                    return 43 /* TAMIL */ ;
                case "telugu":
                    return 44 /* TELUGU */ ;
                case "thai":
                    return 45 /* THAI */ ;
                case "tibetan":
                    return 46 /* TIBETAN */ ;
                case "trad-chinese-formal":
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case "trad-chinese-informal":
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case "upper-armenian":
                    return 49 /* UPPER_ARMENIAN */ ;
                case "disclosure-open":
                    return 50 /* DISCLOSURE_OPEN */ ;
                case "disclosure-closed":
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case "none":
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: "0",
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide("top");
    var marginRight = marginForSide("right");
    var marginBottom = marginForSide("bottom");
    var marginLeft = marginForSide("left");
    var overflow = {
        name: "overflow",
        initialValue: "visible",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case "hidden":
                        return 1 /* HIDDEN */ ;
                    case "scroll":
                        return 2 /* SCROLL */ ;
                    case "clip":
                        return 3 /* CLIP */ ;
                    case "auto":
                        return 4 /* AUTO */ ;
                    case "visible":
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: "overflow-wrap",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "break-word":
                    return "break-word" /* BREAK_WORD */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: "0",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "length-percentage"
        };
    };
    var paddingTop = paddingForSide("top");
    var paddingRight = paddingForSide("right");
    var paddingBottom = paddingForSide("bottom");
    var paddingLeft = paddingForSide("left");
    var textAlign = {
        name: "text-align",
        initialValue: "left",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case "right":
                    return 2 /* RIGHT */ ;
                case "center":
                case "justify":
                    return 1 /* CENTER */ ;
                case "left":
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: "position",
        initialValue: "static",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "relative":
                    return 1 /* RELATIVE */ ;
                case "absolute":
                    return 2 /* ABSOLUTE */ ;
                case "fixed":
                    return 3 /* FIXED */ ;
                case "sticky":
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: "text-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: "text-transform",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case "uppercase":
                    return 2 /* UPPERCASE */ ;
                case "lowercase":
                    return 1 /* LOWERCASE */ ;
                case "capitalize":
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: "transform",
        initialValue: "none",
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === "undefined") throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: "transform-origin",
        initialValue: "50% 50%",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: "visible",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case "hidden":
                    return 1 /* HIDDEN */ ;
                case "collapse":
                    return 2 /* COLLAPSE */ ;
                case "visible":
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: "word-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case "break-all":
                    return WORD_BREAK.BREAK_ALL;
                case "keep-all":
                    return WORD_BREAK.KEEP_ALL;
                case "normal":
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: "z-index",
        initialValue: "auto",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: "time",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case "s":
                    return 1000 * value.number;
                case "ms":
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: "opacity",
        initialValue: "1",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var textDecorationLine = {
        name: "text-decoration-line",
        initialValue: "none",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case "underline":
                        return 1 /* UNDERLINE */ ;
                    case "overline":
                        return 2 /* OVERLINE */ ;
                    case "line-through":
                        return 3 /* LINE_THROUGH */ ;
                    case "none":
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: "",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(" "));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(" "));
            return results.map(function(result) {
                return result.indexOf(" ") === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: "0",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "length"
    };
    var fontWeight = {
        name: "font-weight",
        initialValue: "normal",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case "bold":
                    return 700;
                case "normal":
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: "font-variant",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: "font-style",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "oblique":
                    return "oblique" /* OBLIQUE */ ;
                case "italic":
                    return "italic" /* ITALIC */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: "content",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: "counter-increment",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: "counter-reset",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== "none") {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: "duration",
        initialValue: "0s",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: "quotes",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return "";
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return "";
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: "box-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, "inset")) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: "paint-order",
        initialValue: "normal",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case "stroke":
                        layers.push(1 /* STROKE */ );
                        break;
                    case "fill":
                        layers.push(0 /* FILL */ );
                        break;
                    case "markers":
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: "currentcolor",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: "0",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case "angle":
                        return angle.parse(context, parser.parseComponentValue());
                    case "color":
                        return color$1.parse(context, parser.parseComponentValue());
                    case "image":
                        return image.parse(context, parser.parseComponentValue());
                    case "length":
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case "length-percentage":
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case "time":
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = "data-html2canvas-debug";
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case "all":
                return 1 /* ALL */ ;
            case "clone":
                return 2 /* CLONE */ ;
            case "parse":
                return 3 /* PARSE */ ;
            case "render":
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = "0s";
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = "none";
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = "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";
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement("boundtest");
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = "block";
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement("boundtest");
        testElement.style.width = "50px";
        testElement.style.display = "block";
        testElement.style.fontSize = "12px";
        testElement.style.letterSpacing = "0px";
        testElement.style.wordSpacing = "0px";
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== "undefined";
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === "string";
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement("canvas");
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext("2d");
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = "rgb(0, 255, 0)";
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = "red";
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement("div");
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(xmlns, "svg");
        var foreignObject = document.createElementNS(xmlns, "foreignObject");
        svg.setAttributeNS(null, "width", width.toString());
        svg.setAttributeNS(null, "height", height.toString());
        foreignObject.setAttributeNS(null, "width", "100%");
        foreignObject.setAttributeNS(null, "height", "100%");
        foreignObject.setAttributeNS(null, "x", x.toString());
        foreignObject.setAttributeNS(null, "y", y.toString());
        foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = "withCredentials" in new XMLHttpRequest();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== "undefined" && Intl.Segmenter);
            Object.defineProperty(FEATURES, "SUPPORT_NATIVE_TEXT_SEGMENTATION", {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement("html2canvaswrapper");
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error("Node has no owner document");
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "grapheme"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "word"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? "break-word" : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = "";
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = "";
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute("width", bounds.width + "px");
            img.setAttribute("height", bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: "px",
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join("\u2022") : node.value;
        return value.length === 0 ? node.placeholder || "" : value;
    };
    var CHECKBOX = "checkbox";
    var RADIO = "radio";
    var PASSWORD = "password";
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || "" : "";
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        "OL",
        "UL",
        "MENU"
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== "undefined" && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === "object";
    };
    var isLIElement = function(node) {
        return node.tagName === "LI";
    };
    var isOLElement = function(node) {
        return node.tagName === "OL";
    };
    var isInputElement = function(node) {
        return node.tagName === "INPUT";
    };
    var isHTMLElement = function(node) {
        return node.tagName === "HTML";
    };
    var isSVGElement = function(node) {
        return node.tagName === "svg";
    };
    var isBodyElement = function(node) {
        return node.tagName === "BODY";
    };
    var isCanvasElement = function(node) {
        return node.tagName === "CANVAS";
    };
    var isVideoElement = function(node) {
        return node.tagName === "VIDEO";
    };
    var isImageElement = function(node) {
        return node.tagName === "IMG";
    };
    var isIFrameElement = function(node) {
        return node.tagName === "IFRAME";
    };
    var isStyleElement = function(node) {
        return node.tagName === "STYLE";
    };
    var isScriptElement = function(node) {
        return node.tagName === "SCRIPT";
    };
    var isTextareaElement = function(node) {
        return node.tagName === "TEXTAREA";
    };
    var isSelectElement = function(node) {
        return node.tagName === "SELECT";
    };
    var isSlotElement = function(node) {
        return node.tagName === "SLOT";
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf("-") > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            "M",
            "CM",
            "D",
            "CD",
            "C",
            "XC",
            "L",
            "XL",
            "X",
            "IX",
            "V",
            "IV",
            "I"
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, "") + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = "";
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = ". ";
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : "") + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? ". " : "";
        var cjkSuffix = appendSuffix ? "\u3001" : "";
        var koreanSuffix = appendSuffix ? ", " : "";
        var spaceSuffix = appendSuffix ? " " : "";
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error("Cloned element does not have an owner document");
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn("Unable to restore scroll position for cloned document");
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === "undefined") return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === "function") return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = "";
                }
                if (clone.loading === "lazy") clone.loading = "eager";
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement("html2canvascustomelement");
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === "string") return css + rule.cssText;
                        return css;
                    }, "");
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error("Unable to access cssRules property", e);
                if (e.name !== "SecurityError") throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement("img");
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext("2d");
                var clonedCtx = clonedCanvas.getContext("2d");
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext("webgl2")) !== null && _a !== void 0 ? _a : canvas.getContext("webgl");
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement("canvas");
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext("2d");
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement("canvas");
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === "function") {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = "none";
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ":before");
                var styleAfter = window1.getComputedStyle(node, ":after");
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement("html2canvaspseudoelement");
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement("img");
                    img.src = token.value;
                    img.style.opacity = "1";
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === "attr") {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ""));
                    } else if (token.name === "counter") {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === "counters") {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : "";
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case "open-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case "close-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement("iframe");
        cloneIframeContainer.className = "html2canvas-container";
        cloneIframeContainer.style.visibility = "hidden";
        cloneIframeContainer.style.position = "fixed";
        cloneIframeContainer.style.left = "-10000px";
        cloneIframeContainer.style.top = "0px";
        cloneIframeContainer.style.border = "0";
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = "no"; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        "all",
        "d",
        "content" // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = "";
        if (doctype) {
            str += "<!DOCTYPE ";
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += '"' + doctype.publicId + '"';
            if (doctype.systemId) str += '"' + doctype.systemId + '"';
            str += ">";
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ":before";
    var PSEUDO_AFTER = ":after";
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
    var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement("style");
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return "about:blank";
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement("a");
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = "about:blank";
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = "anonymous";
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== "undefined";
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error("No proxy defined");
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === "text") resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener("load", function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener("error", function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
                xhr.open("GET", "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== "text" && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === "blob";
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === "number";
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === "undefined") return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    var SAMPLE_TEXT = "Hidden Text";
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement("div");
            var img = this._document.createElement("img");
            var span = this._document.createElement("span");
            var body = this._document.body;
            container.style.visibility = "hidden";
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = "0";
            container.style.padding = "0";
            container.style.whiteSpace = "nowrap";
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = "0";
            img.style.padding = "0";
            img.style.verticalAlign = "baseline";
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = "0";
            span.style.padding = "0";
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = "normal";
            img.style.verticalAlign = "super";
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === "undefined") this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = "bottom";
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === "normal" || variant === "small-caps";
            }).join("");
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(", ");
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(" "),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? "rtl" : "ltr";
                    this.ctx.textAlign = "left";
                    this.ctx.textBaseline = "alphabetic";
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = "";
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = "";
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = "miter";
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = "left";
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "middle";
                                this.ctx.textAlign = "right";
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = "bottom";
                                this.ctx.textAlign = "left";
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement("canvas");
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), "repeat");
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext("2d");
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, "repeat");
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = "round";
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return "center";
            case 2 /* RIGHT */ :
                return "right";
            case 0 /* LEFT */ :
            default:
                return "left";
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        "-apple-system",
        "system-ui"
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.debug === "function") // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== "undefined" && window.console && typeof console.info === "function") // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.warn === "function") // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.error === "function") // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== "undefined") CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== "object") return [
                            2 /*return*/ ,
                            Promise.reject("Invalid element provided as first argument")
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === "string" ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});


function $e221fff87d6175c8$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e221fff87d6175c8$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e221fff87d6175c8$export$2e2bcd8739ae039(o);
}


function $80b4c3ccb779c2ef$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $19ceb4b948ed0026$export$2e2bcd8739ae039(value) {
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $e221fff87d6175c8$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $9c2b165b510dd21e$export$2e2bcd8739ae039(argument) {
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $e221fff87d6175c8$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $bbed3101da2e9911$export$2e2bcd8739ae039(dirtyDate) {
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $19ceb4b948ed0026$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $9c2b165b510dd21e$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $0988f1038f8d89b9$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $4bb05d4102ebda70$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $0988f1038f8d89b9$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $0988f1038f8d89b9$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $6beebaf1bcabe2c3$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $4bb05d4102ebda70$export$2e2bcd8739ae039)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}


var $01028f93e961c19e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $01028f93e961c19e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $01028f93e961c19e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $01028f93e961c19e$export$2e2bcd8739ae039 = $01028f93e961c19e$var$formatDistance;


function $734390db23b1f08f$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $2da63a000a0ba300$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $2da63a000a0ba300$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $2da63a000a0ba300$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $2da63a000a0ba300$var$formatLong = {
    date: (0, $734390db23b1f08f$export$2e2bcd8739ae039)({
        formats: $2da63a000a0ba300$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $734390db23b1f08f$export$2e2bcd8739ae039)({
        formats: $2da63a000a0ba300$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $734390db23b1f08f$export$2e2bcd8739ae039)({
        formats: $2da63a000a0ba300$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $2da63a000a0ba300$export$2e2bcd8739ae039 = $2da63a000a0ba300$var$formatLong;


var $13beb15340fff4b8$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $13beb15340fff4b8$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $13beb15340fff4b8$var$formatRelativeLocale[token];
};
var $13beb15340fff4b8$export$2e2bcd8739ae039 = $13beb15340fff4b8$var$formatRelative;


function $deab9ed4b04d66f9$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $c2eba5caf9877537$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $c2eba5caf9877537$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $c2eba5caf9877537$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $c2eba5caf9877537$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $c2eba5caf9877537$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $c2eba5caf9877537$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $c2eba5caf9877537$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $c2eba5caf9877537$var$localize = {
    ordinalNumber: $c2eba5caf9877537$var$ordinalNumber,
    era: (0, $deab9ed4b04d66f9$export$2e2bcd8739ae039)({
        values: $c2eba5caf9877537$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $deab9ed4b04d66f9$export$2e2bcd8739ae039)({
        values: $c2eba5caf9877537$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $deab9ed4b04d66f9$export$2e2bcd8739ae039)({
        values: $c2eba5caf9877537$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $deab9ed4b04d66f9$export$2e2bcd8739ae039)({
        values: $c2eba5caf9877537$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $deab9ed4b04d66f9$export$2e2bcd8739ae039)({
        values: $c2eba5caf9877537$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c2eba5caf9877537$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $c2eba5caf9877537$export$2e2bcd8739ae039 = $c2eba5caf9877537$var$localize;


function $8be78051df4038a2$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $8be78051df4038a2$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $8be78051df4038a2$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $8be78051df4038a2$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $8be78051df4038a2$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $253481e36d51c1d4$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $350a7b5a99e82af8$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $350a7b5a99e82af8$var$parseOrdinalNumberPattern = /\d+/i;
var $350a7b5a99e82af8$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $350a7b5a99e82af8$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $350a7b5a99e82af8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $350a7b5a99e82af8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $350a7b5a99e82af8$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $350a7b5a99e82af8$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $350a7b5a99e82af8$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $350a7b5a99e82af8$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $350a7b5a99e82af8$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $350a7b5a99e82af8$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $350a7b5a99e82af8$var$match = {
    ordinalNumber: (0, $253481e36d51c1d4$export$2e2bcd8739ae039)({
        matchPattern: $350a7b5a99e82af8$var$matchOrdinalNumberPattern,
        parsePattern: $350a7b5a99e82af8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $8be78051df4038a2$export$2e2bcd8739ae039)({
        matchPatterns: $350a7b5a99e82af8$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $350a7b5a99e82af8$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $8be78051df4038a2$export$2e2bcd8739ae039)({
        matchPatterns: $350a7b5a99e82af8$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $350a7b5a99e82af8$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $8be78051df4038a2$export$2e2bcd8739ae039)({
        matchPatterns: $350a7b5a99e82af8$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $350a7b5a99e82af8$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $8be78051df4038a2$export$2e2bcd8739ae039)({
        matchPatterns: $350a7b5a99e82af8$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $350a7b5a99e82af8$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $8be78051df4038a2$export$2e2bcd8739ae039)({
        matchPatterns: $350a7b5a99e82af8$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $350a7b5a99e82af8$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $350a7b5a99e82af8$export$2e2bcd8739ae039 = $350a7b5a99e82af8$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $68451cdaf1e593e4$var$locale = {
    code: "en-US",
    formatDistance: (0, $01028f93e961c19e$export$2e2bcd8739ae039),
    formatLong: (0, $2da63a000a0ba300$export$2e2bcd8739ae039),
    formatRelative: (0, $13beb15340fff4b8$export$2e2bcd8739ae039),
    localize: (0, $c2eba5caf9877537$export$2e2bcd8739ae039),
    match: (0, $350a7b5a99e82af8$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $68451cdaf1e593e4$export$2e2bcd8739ae039 = $68451cdaf1e593e4$var$locale;


var $1b5efa73fdc4356f$export$2e2bcd8739ae039 = (0, $68451cdaf1e593e4$export$2e2bcd8739ae039);


function $ad3649d9608c2678$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $88262025fe007edf$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $9c2b165b510dd21e$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $ad3649d9608c2678$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $dc2616a64907fd75$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $ad3649d9608c2678$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $88262025fe007edf$export$2e2bcd8739ae039)(dirtyDate, -amount);
}



function $a221826184943773$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}


var $c72a2888774e8f15$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $c72a2888774e8f15$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $c72a2888774e8f15$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $c72a2888774e8f15$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $c72a2888774e8f15$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $c72a2888774e8f15$var$timeLongFormatter(timePattern, formatLong));
};
var $c72a2888774e8f15$var$longFormatters = {
    p: $c72a2888774e8f15$var$timeLongFormatter,
    P: $c72a2888774e8f15$var$dateTimeLongFormatter
};
var $c72a2888774e8f15$export$2e2bcd8739ae039 = $c72a2888774e8f15$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $e5f31cca4f8140a6$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $c754a94f0960b678$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $c754a94f0960b678$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $c754a94f0960b678$export$c6cc36aa33304772(token) {
    return $c754a94f0960b678$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $c754a94f0960b678$export$c6b49d6dceb604a1(token) {
    return $c754a94f0960b678$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $c754a94f0960b678$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}




function $a486191628b12b1b$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $62b7fe028d31a6f2$export$2e2bcd8739ae039(t, e) {
    return $62b7fe028d31a6f2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $62b7fe028d31a6f2$export$2e2bcd8739ae039(t, e);
}


function $3c2e54d4ff6577ae$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $62b7fe028d31a6f2$export$2e2bcd8739ae039)(t, e);
}


function $5e9699fb34d1fb40$export$2e2bcd8739ae039(t) {
    return $5e9699fb34d1fb40$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $5e9699fb34d1fb40$export$2e2bcd8739ae039(t);
}


function $4603c7d260b3e657$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4603c7d260b3e657$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $0e01763acd908c24$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $e221fff87d6175c8$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $a486191628b12b1b$export$2e2bcd8739ae039)(t);
}


function $2a46a474d490f687$export$2e2bcd8739ae039(t) {
    var r = (0, $4603c7d260b3e657$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $5e9699fb34d1fb40$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $5e9699fb34d1fb40$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $0e01763acd908c24$export$2e2bcd8739ae039)(this, e);
    };
}


function $a91f15d2fb6c159a$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}




function $a0791d9653803f8c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $e221fff87d6175c8$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $e221fff87d6175c8$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $9cdf2d7ef820c089$export$2e2bcd8739ae039(t) {
    var i = (0, $a0791d9653803f8c$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $e221fff87d6175c8$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f6b3103f3a6b4c21$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $9cdf2d7ef820c089$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $f6b3103f3a6b4c21$export$2e2bcd8739ae039(e, r, t) {
    return r && $f6b3103f3a6b4c21$var$_defineProperties(e.prototype, r), t && $f6b3103f3a6b4c21$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $805b79df5be0f849$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $9cdf2d7ef820c089$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


var $7831aa7ef3a0a6f9$var$TIMEZONE_UNIT_PRIORITY = 10;
var $7831aa7ef3a0a6f9$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, Setter);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)(this, "subPriority", 0);
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $7831aa7ef3a0a6f9$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($7831aa7ef3a0a6f9$export$81d53e3678089a6);
var $7831aa7ef3a0a6f9$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this2), "priority", $7831aa7ef3a0a6f9$var$TIMEZONE_UNIT_PRIORITY);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($7831aa7ef3a0a6f9$export$81d53e3678089a6);












var $2c4c0edf87ad4fe8$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, Parser);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)(this, "incompatibleTokens", void 0);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)(this, "subPriority", void 0);
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $7831aa7ef3a0a6f9$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $3789e910161744a1$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 140);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));









/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $2e0ed4474ecdc01c$export$dfd9b671c89acc8e = 7;
var $2e0ed4474ecdc01c$export$3913210603d8e9ae = 365.2425;
var $2e0ed4474ecdc01c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $2e0ed4474ecdc01c$export$91246f0b9bd9beff = 60000;
var $2e0ed4474ecdc01c$export$7f72910d6dfd237a = 3600000;
var $2e0ed4474ecdc01c$export$397c2d5776aa9055 = 1000;
var $2e0ed4474ecdc01c$export$4dec998e48f9c246 = -$2e0ed4474ecdc01c$export$81caae6e1cc7a622;
var $2e0ed4474ecdc01c$export$f2f5ae5a8e2d8f9f = 60;
var $2e0ed4474ecdc01c$export$3c58128db900d44e = 3;
var $2e0ed4474ecdc01c$export$80d7e435f744f319 = 12;
var $2e0ed4474ecdc01c$export$4db7641526e3241f = 4;
var $2e0ed4474ecdc01c$export$698aec755e92c695 = 3600;
var $2e0ed4474ecdc01c$export$a77c1a7ebebe2a5a = 60;
var $2e0ed4474ecdc01c$export$815a9362476d2fe3 = $2e0ed4474ecdc01c$export$698aec755e92c695 * 24;
var $2e0ed4474ecdc01c$export$34804a017b31e2fe = $2e0ed4474ecdc01c$export$815a9362476d2fe3 * 7;
var $2e0ed4474ecdc01c$export$7271e9e3478110d1 = $2e0ed4474ecdc01c$export$815a9362476d2fe3 * $2e0ed4474ecdc01c$export$3913210603d8e9ae;
var $2e0ed4474ecdc01c$export$8e6600bbdee7dabb = $2e0ed4474ecdc01c$export$7271e9e3478110d1 / 12;
var $2e0ed4474ecdc01c$export$be1dccf2de902d31 = $2e0ed4474ecdc01c$export$8e6600bbdee7dabb * 3;


var $c8feed2ac0ad9975$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $c8feed2ac0ad9975$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $cbb9ca549968aa7d$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $cbb9ca549968aa7d$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $2e0ed4474ecdc01c$export$7f72910d6dfd237a) + minutes * (0, $2e0ed4474ecdc01c$export$91246f0b9bd9beff) + seconds * (0, $2e0ed4474ecdc01c$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $cbb9ca549968aa7d$export$d931c43c4608a164(dateString) {
    return $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $cbb9ca549968aa7d$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $cbb9ca549968aa7d$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $cbb9ca549968aa7d$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $cbb9ca549968aa7d$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $cbb9ca549968aa7d$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $e111a772966cafb7$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)((0, $cbb9ca549968aa7d$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "yo":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)((0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $cbb9ca549968aa7d$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));















var $1db99d30c18893ee$var$defaultOptions = {};
function $1db99d30c18893ee$export$430a3269e24b912e() {
    return $1db99d30c18893ee$var$defaultOptions;
}
function $1db99d30c18893ee$export$95365be1b0704abc(newOptions) {
    $1db99d30c18893ee$var$defaultOptions = newOptions;
}


function $f2f385e83994dbb9$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1db99d30c18893ee$export$430a3269e24b912e)();
    var weekStartsOn = (0, $ad3649d9608c2678$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $9c2b165b510dd21e$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}




function $7521b4bf63e83352$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $9c2b165b510dd21e$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $1db99d30c18893ee$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $ad3649d9608c2678$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $f2f385e83994dbb9$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $f2f385e83994dbb9$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}



var $910dc70bfde0e4ac$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)((0, $cbb9ca549968aa7d$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)((0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $7521b4bf63e83352$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $cbb9ca549968aa7d$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $f2f385e83994dbb9$export$2e2bcd8739ae039)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $f2f385e83994dbb9$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));












function $8c43d03720e6873d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $9c2b165b510dd21e$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}


var $571eedb9cdbf79fc$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, $cbb9ca549968aa7d$export$2c9307b2e29c533c)(4, dateString);
                return (0, $cbb9ca549968aa7d$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $8c43d03720e6873d$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));










var $d73cf9284edb7282$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, $cbb9ca549968aa7d$export$2c9307b2e29c533c)(4, dateString);
                return (0, $cbb9ca549968aa7d$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));










var $b5a164c32a795b2e$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));










var $ed1f9d6e6003de29$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));











var $0acb98b948fdc90b$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 110);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)((0, $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388)((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)((0, $cbb9ca549968aa7d$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));











var $0d5767664cd6b80b$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 110);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)((0, $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388)((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)((0, $cbb9ca549968aa7d$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));




















function $a77a0ec7e8030af0$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1db99d30c18893ee$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $ad3649d9608c2678$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $7521b4bf63e83352$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $f2f385e83994dbb9$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $3b05a9dfba65f265$var$MILLISECONDS_IN_WEEK = 604800000;
function $3b05a9dfba65f265$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $9c2b165b510dd21e$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $f2f385e83994dbb9$export$2e2bcd8739ae039)(date, options).getTime() - (0, $a77a0ec7e8030af0$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $3b05a9dfba65f265$var$MILLISECONDS_IN_WEEK) + 1;
}



function $d5eaadc18b1154f7$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $9c2b165b510dd21e$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $ad3649d9608c2678$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $3b05a9dfba65f265$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $914ac38ccb92a604$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388)((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $f2f385e83994dbb9$export$2e2bcd8739ae039)((0, $d5eaadc18b1154f7$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));


















function $41655138ad4fad39$export$2e2bcd8739ae039(dirtyDate) {
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $9c2b165b510dd21e$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $8c43d03720e6873d$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $8c43d03720e6873d$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $9a0897094af70985$export$2e2bcd8739ae039(dirtyDate) {
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $41655138ad4fad39$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $8c43d03720e6873d$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $04e4ebb0f2890dc2$var$MILLISECONDS_IN_WEEK = 604800000;
function $04e4ebb0f2890dc2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $9c2b165b510dd21e$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $8c43d03720e6873d$export$2e2bcd8739ae039)(date).getTime() - (0, $9a0897094af70985$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $04e4ebb0f2890dc2$var$MILLISECONDS_IN_WEEK) + 1;
}



function $5f56d4b3f70c4bc6$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $9c2b165b510dd21e$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $ad3649d9608c2678$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $04e4ebb0f2890dc2$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $f45a047692757b9c$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388)((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $8c43d03720e6873d$export$2e2bcd8739ae039)((0, $5f56d4b3f70c4bc6$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));











var $f453fbd72b197b13$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $f453fbd72b197b13$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $f453fbd72b197b13$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "subPriority", 1);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388)((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $cbb9ca549968aa7d$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $f453fbd72b197b13$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $f453fbd72b197b13$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));











var $9191688d93978a4a$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "subpriority", 1);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388)((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $cbb9ca549968aa7d$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));













function $7039d6041541d19c$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $1db99d30c18893ee$export$430a3269e24b912e)();
    var weekStartsOn = (0, $ad3649d9608c2678$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $9c2b165b510dd21e$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $ad3649d9608c2678$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $14793ae6acdb06eb$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $7039d6041541d19c$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));











var $a179ec311baf4853$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)((0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $7039d6041541d19c$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));











var $64342c9459fc2f83$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)((0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $7039d6041541d19c$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));













function $4299db2758a533eb$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $ad3649d9608c2678$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $9c2b165b510dd21e$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $f251ffbb94230453$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $4299db2758a533eb$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));










var $69b34af17776880d$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $cbb9ca549968aa7d$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));










var $e894982c5812acd2$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $cbb9ca549968aa7d$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));










var $25c9e7d41d2ab662$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $cbb9ca549968aa7d$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));











var $6fefc946553452d4$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388)((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));











var $366601288be95142$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388)((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));











var $13a85c62e9183c0c$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388)((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));











var $1a48e939163cd4f6$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388)((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));











var $405a3ed5f17ba77a$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 60);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388)((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));











var $1a9fc6104f25b8d7$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 50);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, $cbb9ca549968aa7d$export$cc7cc9e2a3ff9388)((0, $c8feed2ac0ad9975$export$c123ee06d9da8480).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));










var $f770d9a3bf88d3c4$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 30);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $cbb9ca549968aa7d$export$4f84e3a82c7b538)((0, $cbb9ca549968aa7d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));











var $8aa11a91916604d7$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, $cbb9ca549968aa7d$export$6497f4c0ecdfba8e)((0, $c8feed2ac0ad9975$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, $cbb9ca549968aa7d$export$6497f4c0ecdfba8e)((0, $c8feed2ac0ad9975$export$a7ee192b982af9c1).basic, dateString);
                    case "XXXX":
                        return (0, $cbb9ca549968aa7d$export$6497f4c0ecdfba8e)((0, $c8feed2ac0ad9975$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, $cbb9ca549968aa7d$export$6497f4c0ecdfba8e)((0, $c8feed2ac0ad9975$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, $cbb9ca549968aa7d$export$6497f4c0ecdfba8e)((0, $c8feed2ac0ad9975$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));











var $c3d4a74491ad24dc$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, $cbb9ca549968aa7d$export$6497f4c0ecdfba8e)((0, $c8feed2ac0ad9975$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, $cbb9ca549968aa7d$export$6497f4c0ecdfba8e)((0, $c8feed2ac0ad9975$export$a7ee192b982af9c1).basic, dateString);
                    case "xxxx":
                        return (0, $cbb9ca549968aa7d$export$6497f4c0ecdfba8e)((0, $c8feed2ac0ad9975$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, $cbb9ca549968aa7d$export$6497f4c0ecdfba8e)((0, $c8feed2ac0ad9975$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, $cbb9ca549968aa7d$export$6497f4c0ecdfba8e)((0, $c8feed2ac0ad9975$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));










var $b36651a51e1f9edd$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 40);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $cbb9ca549968aa7d$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));










var $ade68d1538867fa1$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $3c2e54d4ff6577ae$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $2a46a474d490f687$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $a91f15d2fb6c159a$export$2e2bcd8739ae039)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "priority", 20);
        (0, $805b79df5be0f849$export$2e2bcd8739ae039)((0, $a486191628b12b1b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $f6b3103f3a6b4c21$export$2e2bcd8739ae039)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $cbb9ca549968aa7d$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $2c4c0edf87ad4fe8$export$7acfa6ed01010e37));


var $720ab42d5c99e9c0$export$19131010e7fd8373 = {
    G: new (0, $3789e910161744a1$export$8e5a1d3f85a9688)(),
    y: new (0, $e111a772966cafb7$export$48d352de7cd4a988)(),
    Y: new (0, $910dc70bfde0e4ac$export$b8ef38dfcf05d5db)(),
    R: new (0, $571eedb9cdbf79fc$export$951d1df011fde06f)(),
    u: new (0, $d73cf9284edb7282$export$bad9d2ea38e8f1a)(),
    Q: new (0, $b5a164c32a795b2e$export$5cb0f701186dde1d)(),
    q: new (0, $ed1f9d6e6003de29$export$300c0c2990e20e6d)(),
    M: new (0, $0acb98b948fdc90b$export$400dd8b40ef138a3)(),
    L: new (0, $0d5767664cd6b80b$export$1d7eaa53eaa5deba)(),
    w: new (0, $914ac38ccb92a604$export$c4005ffc174e07c0)(),
    I: new (0, $f45a047692757b9c$export$6fc8dbedd560a6af)(),
    d: new (0, $f453fbd72b197b13$export$e8d4b28a20981dd2)(),
    D: new (0, $9191688d93978a4a$export$6cfe0d613455f615)(),
    E: new (0, $14793ae6acdb06eb$export$1b03c8b76262f7bd)(),
    e: new (0, $a179ec311baf4853$export$44d1c127ab42c480)(),
    c: new (0, $64342c9459fc2f83$export$e447a647caaaec1d)(),
    i: new (0, $f251ffbb94230453$export$693fb1e525095b2a)(),
    a: new (0, $69b34af17776880d$export$8d1e08492351df91)(),
    b: new (0, $e894982c5812acd2$export$73ca2bd0a17d273)(),
    B: new (0, $25c9e7d41d2ab662$export$bb9212adf05373db)(),
    h: new (0, $6fefc946553452d4$export$8a04050a727a1756)(),
    H: new (0, $366601288be95142$export$e56f4dea2c3e56dd)(),
    K: new (0, $13a85c62e9183c0c$export$cbbe855312f87d77)(),
    k: new (0, $1a48e939163cd4f6$export$6008046d2b34b6a5)(),
    m: new (0, $405a3ed5f17ba77a$export$2b52670d9e2be53)(),
    s: new (0, $1a9fc6104f25b8d7$export$94d46d540cf1366a)(),
    S: new (0, $f770d9a3bf88d3c4$export$b8e6f8b2d70893b1)(),
    X: new (0, $8aa11a91916604d7$export$104d901d49fea29b)(),
    x: new (0, $c3d4a74491ad24dc$export$12910e5204b52b9)(),
    t: new (0, $b36651a51e1f9edd$export$2cd8bf877a05e96)(),
    T: new (0, $ade68d1538867fa1$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $338daac72deadbf8$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $338daac72deadbf8$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $338daac72deadbf8$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $338daac72deadbf8$var$doubleQuoteRegExp = /''/g;
var $338daac72deadbf8$var$notWhitespaceRegExp = /\S/;
var $338daac72deadbf8$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $338daac72deadbf8$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $80b4c3ccb779c2ef$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $1db99d30c18893ee$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $1b5efa73fdc4356f$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, $ad3649d9608c2678$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $ad3649d9608c2678$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, $9c2b165b510dd21e$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $7831aa7ef3a0a6f9$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($338daac72deadbf8$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $c72a2888774e8f15$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $c72a2888774e8f15$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($338daac72deadbf8$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $6beebaf1bcabe2c3$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $c754a94f0960b678$export$c6b49d6dceb604a1)(token)) (0, $c754a94f0960b678$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $c754a94f0960b678$export$c6cc36aa33304772)(token)) (0, $c754a94f0960b678$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $720ab42d5c99e9c0$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($338daac72deadbf8$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $338daac72deadbf8$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $e221fff87d6175c8$export$2e2bcd8739ae039)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $338daac72deadbf8$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $9c2b165b510dd21e$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $dc2616a64907fd75$export$2e2bcd8739ae039)(date, (0, $e5f31cca4f8140a6$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $6beebaf1bcabe2c3$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $a221826184943773$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $338daac72deadbf8$var$cleanEscapedString(input) {
    return input.match($338daac72deadbf8$var$escapedStringRegExp)[1].replace($338daac72deadbf8$var$doubleQuoteRegExp, "'");
}


var $8994485710ee5faa$var$timetableStorage = [
    {
        id: 0,
        name: "Default Table",
        data: [],
        quick: []
    }
];
window.activeTable = $8994485710ee5faa$var$timetableStorage[0];
$(()=>{
    /*
        Click event for the add table button
     */ $("#tt-picker-add").on("click", function() {
        var newTableId = $8994485710ee5faa$var$timetableStorage[$8994485710ee5faa$var$timetableStorage.length - 1].id + 1;
        var newTableName = "Table " + newTableId;
        $8994485710ee5faa$var$timetableStorage.push({
            id: newTableId,
            name: newTableName,
            data: [],
            quick: []
        });
        $8994485710ee5faa$var$addTableToPicker(newTableId, newTableName);
        $8994485710ee5faa$var$switchTable(newTableId);
        $8994485710ee5faa$var$updateLocalForage();
    });
    /*
        Click event for the timetable picker dropdown labels
     */ $("#tt-picker-dropdown").on("click", ".tt-picker-label", function() {
        var selectedTableId = Number($(this).children("a").data("table-id"));
        $8994485710ee5faa$var$switchTable(selectedTableId);
    });
    /*
        Click event to set the data attribute before opening the rename modal
     */ $("#tt-picker-dropdown").on("click", ".tt-picker-rename", function() {
        var $a = $(this).closest("li").find("a:first");
        var tableId = Number($a.data("table-id"));
        var tableName = $a.text();
        $("#table-name").val(tableName).trigger("focus");
        $("#rename-tt-button").data("table-id", tableId);
    });
    /*
        Click event for the rename button in the rename modal
     */ $("#rename-tt-button").on("click", function() {
        var tableId = $(this).data("table-id");
        var tableName = $("#table-name").val().trim();
        if (tableName == "") tableName = "Untitled Table";
        $8994485710ee5faa$var$renameTable(tableId, tableName);
    });
    /*
        Keydown event for the input table name field in the rename modal
     */ $("#table-name").on("keydown", function(e) {
        if (e.key == "Enter") $("#rename-tt-button").trigger("click");
    });
    /*
        Click event to set the data attribute before opening the delete modal
     */ $("#tt-picker-dropdown").on("click", ".tt-picker-delete", function() {
        var tableId = Number($(this).closest("li").find("a:first").data("table-id"));
        $("#delete-tt-button").data("table-id", tableId);
    });
    /*
        Click event for the delete button in the delete modal
     */ $("#delete-tt-button").on("click", function() {
        var tableId = $(this).data("table-id");
        $8994485710ee5faa$var$deleteTable(tableId);
        if ($8994485710ee5faa$var$timetableStorage.length == 1) $("#tt-picker-dropdown .tt-picker-delete").first().remove();
    });
    /*
        Click event for the download timetable button in the download modal
     */ $("#download-tt-button").on("click", function() {
        var buttonText = $(this).html();
        $(this).html(`<span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                ></span>&nbsp;&nbsp;Please Wait`).attr("disabled", true);
        const width = $("#timetable")[0].scrollWidth;
        var $layout = $("<div></div>").css({
            padding: "2rem",
            position: "absolute",
            top: 0,
            left: `calc(-${width}px - 4rem)`
        });
        $layout = $8994485710ee5faa$var$appendHeader($layout, width);
        const $timetableClone = $("#timetable").clone().css({
            width: width
        });
        $("table", $timetableClone).css({
            margin: 0
        });
        $("tr", $timetableClone).css({
            border: "none"
        });
        $layout.append($timetableClone);
        $("body").append($layout);
        (0, (/*@__PURE__*/$parcel$interopDefault($c84fe0b6641299f2$exports)))($layout[0], {
            scrollX: -window.scrollX,
            scrollY: -window.scrollY
        }).then((canvas)=>{
            $layout.remove();
            $(this).html(buttonText).attr("disabled", false);
            var $a = $("<a></a>").css({
                display: "none"
            }).attr("href", canvas.toDataURL("image/jpeg")).attr("download", `FFCS On The Go ${activeTable.name} (Timetable).jpg`);
            $("body").append($a);
            $a[0].click();
            $a.remove();
        });
    });
    /*
        Click event for the download course list button in the download modal
     */ $("#download-course-list-button").on("click", function() {
        var buttonText = $(this).html();
        $(this).html(`<span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                ></span>&nbsp;&nbsp;Please Wait`).attr("disabled", true);
        const width = $("#course-list")[0].scrollWidth;
        var $layout = $("<div></div>").css({
            padding: "2rem",
            position: "absolute",
            top: 0,
            left: `calc(-${width}px - 4rem)`
        });
        $layout = $8994485710ee5faa$var$appendHeader($layout, width);
        const $courseListClone = $("#course-list").clone().css({
            width: width,
            border: "1px solid var(--table-border-color)",
            "border-bottom": "none"
        });
        $("table", $courseListClone).css({
            margin: 0
        });
        $("tr", $courseListClone).css({
            border: "none"
        }).each(function() {
            if ($(this).children().length == 1) return;
            $("th:last-child", this).remove();
            $("td:last-child", this).remove();
        });
        $layout.append($courseListClone);
        $("body").append($layout);
        (0, (/*@__PURE__*/$parcel$interopDefault($c84fe0b6641299f2$exports)))($layout[0], {
            scrollX: -window.scrollX,
            scrollY: -window.scrollY
        }).then((canvas)=>{
            $layout.remove();
            $(this).html(buttonText).attr("disabled", false);
            var $a = $("<a></a>").css({
                display: "none"
            }).attr("href", canvas.toDataURL("image/jpeg")).attr("download", `FFCS On The Go ${activeTable.name} (Course List).jpg`);
            $("body").append($a);
            $a[0].click();
            $a.remove();
        });
    });
    /*
        Click event for the quick visualization button
     */ $("#quick-toggle").on("click", function() {
        if ($(this).attr("data-state") == "enabled") {
            $("i", this).prop("class", "fas fa-eye");
            $("span", this).html("&nbsp;&nbsp;Enable Quick Visualization");
            $(this).attr("data-state", "disabled");
            $("#timetable .highlight:not(:has(div))").removeClass("highlight");
        } else {
            $("i", this).prop("class", "fas fa-eye-slash");
            $("span", this).html("&nbsp;&nbsp;Disable Quick Visualization");
            $(this).attr("data-state", "enabled");
            activeTable.quick.forEach((el)=>$("#timetable").find("tr").eq(el[0]).find("td").eq(el[1]).addClass("highlight"));
        }
        $(".quick-buttons").slideToggle();
    });
    /*
        Click event for the reset button in the reset modal
     */ $("#reset-tt-button").on("click", function() {
        resetPage();
        activeTable.data = [];
        $8994485710ee5faa$var$updateLocalForage();
    });
});
/*
    Function to add a header to the images
 */ function $8994485710ee5faa$var$appendHeader($layout, width) {
    const $header = $("<div></div>").css({
        width: width,
        "margin-bottom": "1rem"
    }).append($("<h3>FFCS On The Go</h3>").css({
        margin: 0,
        display: "inline",
        color: "#9c27b0",
        "font-weight": "bold"
    })).append($(`<h3>${campus} Campus</h3>`).css({
        margin: 0,
        display: "inline",
        color: "#707070",
        float: "right"
    })).append($("<hr>").css({
        "border-color": "#000000",
        "border-width": "2px"
    }));
    const $title = $(`<h4>${activeTable.name}</h4>`).css({
        "margin-bottom": "1rem",
        width: width,
        "text-align": "center"
    });
    return $layout.append($header).append($title);
}
/*
    Function to update the saved data
 */ function $8994485710ee5faa$var$updateLocalForage() {
    (0, (/*@__PURE__*/$parcel$interopDefault($91b00a4bc162400e$exports))).setItem("timetableStorage", $8994485710ee5faa$var$timetableStorage).catch(console.error);
}
/*
    Function to get the table index
 */ function $8994485710ee5faa$var$getTableIndex(id) {
    return $8994485710ee5faa$var$timetableStorage.findIndex((el)=>el.id == id);
}
/*
    Function to fill the timetable and course list
 */ function $8994485710ee5faa$var$fillPage() {
    $.each(activeTable.data, function(index, courseData) {
        addCourseToCourseList(courseData);
        addCourseToTimetable(courseData);
    });
    $.each(activeTable.quick, function(index, el) {
        var $el = $("#timetable").find("tr").eq(el[0]).find("td").eq(el[1]);
        var slot = $el.get(0).classList[1];
        $(`.quick-buttons .${slot}-tile`).addClass("highlight");
        if ($("#quick-toggle").attr("data-state") == "enabled") $el.addClass("highlight");
    });
}
/*
    Function to change the active table
 */ function $8994485710ee5faa$var$switchTable(tableId) {
    resetPage();
    activeTable = $8994485710ee5faa$var$timetableStorage[$8994485710ee5faa$var$getTableIndex(tableId)];
    $8994485710ee5faa$var$updatePickerLabel(activeTable.name);
    $8994485710ee5faa$var$fillPage();
}
/*
    Function to rename the timetable picker label
 */ function $8994485710ee5faa$var$updatePickerLabel(tableName) {
    $("#tt-picker-button").text(tableName);
}
/*
    Function to delete a table
 */ function $8994485710ee5faa$var$deleteTable(tableId) {
    var tableIndex = $8994485710ee5faa$var$getTableIndex(tableId);
    $8994485710ee5faa$var$timetableStorage.splice(tableIndex, 1);
    $8994485710ee5faa$var$updateLocalForage();
    // Check if the active table is deleted
    if (activeTable.id == tableId) {
        if (tableIndex == 0) $8994485710ee5faa$var$switchTable($8994485710ee5faa$var$timetableStorage[0].id);
        else $8994485710ee5faa$var$switchTable($8994485710ee5faa$var$timetableStorage[tableIndex - 1].id);
    }
    // Removing the timetable picker item
    $("#tt-picker-dropdown .tt-picker-label").find(`[data-table-id="${tableId}"]`).closest("li").remove();
}
/*
    Function to rename a table
 */ function $8994485710ee5faa$var$renameTable(tableId, tableName) {
    var tableIndex = $8994485710ee5faa$var$getTableIndex(tableId);
    $8994485710ee5faa$var$timetableStorage[tableIndex].name = tableName;
    $8994485710ee5faa$var$updateLocalForage();
    // Check if the active table is renamed
    if (activeTable.id == tableId) $8994485710ee5faa$var$updatePickerLabel(tableName);
    // Renaming the timetable picker item
    $("#tt-picker-dropdown .tt-picker-label").find(`[data-table-id="${tableId}"]`).text(tableName);
}
/*
    Function to add a table to the timetable picker
 */ function $8994485710ee5faa$var$addTableToPicker(tableId, tableName) {
    $("#tt-picker-dropdown").append(`<li>
            <table class="dropdown-item">
                <td class="tt-picker-label">
                    <a href="JavaScript:void(0);" data-table-id="${tableId}"
                        >${tableName}</a
                    >
                </td>
                <td>
                    <a
                        class="tt-picker-rename"
                        href="JavaScript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#rename-modal"
                        ><i class="fas fa-pencil-alt"></i
                    ></a
                    ><a
                        class="tt-picker-delete"
                        href="JavaScript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-modal"
                        ><i class="fas fa-trash"></i
                    ></a>
                </td>
            </table>
        </li>`);
    if ($8994485710ee5faa$var$timetableStorage.length == 2) $("#tt-picker-dropdown .tt-picker-rename").first().after(`<a
                    class="tt-picker-delete"
                    href="JavaScript:void(0);"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                    ><i class="fas fa-trash"></i
                ></a>`);
}
/*
    Function to check if slots are clashing
 */ function $8994485710ee5faa$var$checkSlotClash() {
    $("#timetable tr td").removeClass("clash");
    $("#course-list tr").removeClass("table-danger");
    const $theoryHours = $("#theory td:not(.lunch)");
    const $labHours = $("#lab td:not(.lunch)");
    $("#timetable tr").each(function() {
        $(".highlight", this).each(function() {
            const index = $(this).index();
            var currentEnd, nextStart;
            if ($("div", this).data("is-lab")) {
                currentEnd = (0, $338daac72deadbf8$export$2e2bcd8739ae039)($labHours.eq(index).data("end"), "h:mm aa", new Date());
                if (!(0, $bbed3101da2e9911$export$2e2bcd8739ae039)(currentEnd)) currentEnd = (0, $338daac72deadbf8$export$2e2bcd8739ae039)($labHours.eq(index).data("end"), "HH:mm", new Date());
            } else if ($("div", this).data("is-theory")) {
                currentEnd = (0, $338daac72deadbf8$export$2e2bcd8739ae039)($theoryHours.eq(index).data("end"), "h:mm aa", new Date());
                if (!(0, $bbed3101da2e9911$export$2e2bcd8739ae039)(currentEnd)) currentEnd = (0, $338daac72deadbf8$export$2e2bcd8739ae039)($theoryHours.eq(index).data("end"), "HH:mm", new Date());
            }
            if ($("div", $(this).next()).data("is-lab")) {
                nextStart = (0, $338daac72deadbf8$export$2e2bcd8739ae039)($labHours.eq(index + 1).data("start"), "h:mm aa", new Date());
                if (!(0, $bbed3101da2e9911$export$2e2bcd8739ae039)(nextStart)) nextStart = (0, $338daac72deadbf8$export$2e2bcd8739ae039)($labHours.eq(index + 1).data("start"), "HH:mm", new Date());
            } else if ($("div", this).data("is-theory")) {
                nextStart = (0, $338daac72deadbf8$export$2e2bcd8739ae039)($theoryHours.eq(index + 1).data("start"), "h:mm aa", new Date());
                if (!(0, $bbed3101da2e9911$export$2e2bcd8739ae039)(nextStart)) nextStart = (0, $338daac72deadbf8$export$2e2bcd8739ae039)($theoryHours.eq(index + 1).data("start"), "HH:mm", new Date());
            }
            if ($("div", this).length > 1) {
                $(this).addClass("clash");
                $("div", this).each(function() {
                    const dataCourse = $(this).data("course");
                    $(`#course-list tr[data-course=${dataCourse}]`).addClass("table-danger");
                });
            }
            if (nextStart && nextStart < currentEnd) {
                $(this).addClass("clash");
                $(this).next().addClass("clash");
                const dataCourse = $("div", this).data("course");
                $(`#course-list tr[data-course=${dataCourse}]`).addClass("table-danger");
                $("div", $(this).next()).each(function() {
                    const dataCourse = $(this).data("course");
                    $(`#course-list tr[data-course=${dataCourse}]`).addClass("table-danger");
                });
            }
        });
    });
}
/*
    Function to initialize quick visualization
 */ function $8994485710ee5faa$var$initializeQuickVisualization() {
    /*
        Click event for the quick visualization buttons
     */ $('.quick-buttons *[class*="-tile"]').on("click", function() {
        var slot = this.classList[0].split("-")[0];
        if (!$(`#timetable .${slot}`).hasClass("clash") && $(`#timetable .${slot}`).children("div").length == 0) {
            var slots = [];
            $(`#timetable .${slot}`).each((i, el)=>{
                var row = $(el).parent().index();
                var column = $(el).index();
                slots.push([
                    row,
                    column
                ]);
            });
            if ($(this).hasClass("highlight")) {
                $(`#timetable .${slot}`).removeClass("highlight");
                activeTable.quick = activeTable.quick.filter((el)=>{
                    for(var i = 0; i < slots.length; ++i){
                        if (el[0] == slots[i][0] && el[1] == slots[i][1]) return false;
                    }
                    return true;
                });
            } else {
                $(`#timetable .${slot}`).addClass("highlight");
                activeTable.quick.push(...slots);
            }
            $(this).toggleClass("highlight");
            $8994485710ee5faa$var$updateLocalForage();
        }
    });
    /*
        Click event for the periods when quick visualization is enabled
     */ $("#timetable .period:not([disabled])").on("click", function() {
        if ($("#quick-toggle").attr("data-state") == "enabled" && !$(this).hasClass("clash") && $(this).children("div").length == 0) {
            var slot = this.classList[1];
            var row = $(this).parent().index();
            var column = $(this).index();
            $(this).toggleClass("highlight");
            if (!$(this).hasClass("highlight")) activeTable.quick = activeTable.quick.filter((el)=>el[0] != row || el[1] != column);
            else activeTable.quick.push([
                row,
                column
            ]);
            if ($(`#timetable .${slot}`).not(".highlight").length == 0) $(`.quick-buttons .${slot}-tile`).addClass("highlight");
            else $(`.quick-buttons .${slot}-tile`).removeClass("highlight");
            $8994485710ee5faa$var$updateLocalForage();
        }
    });
}



/*
    Function to initialize the timetable
 */ window.initializeTimetable = ()=>{
    var timetable;
    $("#timetable tr").slice(2).hide();
    $("#timetable tr td:not(:first-child)").remove();
    if (window.campus == "AP") timetable = (parcelRequire("1bsyz"));
    else if (window.campus == "Chennai") timetable = (parcelRequire("hFi8p"));
    else timetable = (parcelRequire("9PGPv"));
    var theory = timetable.theory, lab = timetable.lab;
    var theoryIndex = 0, labIndex = 0;
    var $quickButtons = $(".quick-buttons").eq(0); // Morning slot quick buttons
    while(theoryIndex < theory.length || labIndex < lab.length){
        const theorySlots = theory[theoryIndex];
        const labSlots = lab[labIndex];
        if (theorySlots && labSlots && !theorySlots.days && !labSlots.days) {
            $("#timetable tr:first").append('<td class="lunch" style="width: 8px;" rowspan="9">L<br />U<br />N<br />C<br />H</td>');
            $quickButtons = $(".quick-buttons").eq(1); // Afternoon slot quick buttons
            ++theoryIndex;
            ++labIndex;
            continue;
        }
        const $theoryHour = $('<td class="theory-hour"></td>');
        const $labHour = $('<td class="lab-hour"></td>');
        if (theorySlots && theorySlots.start && theorySlots.end) {
            $theoryHour.html(`${theorySlots.start}<br />to<br />${theorySlots.end}`);
            $theoryHour.data("start", theorySlots.start);
            $theoryHour.data("end", theorySlots.end);
        }
        if (labSlots && labSlots.start && labSlots.end) {
            $labHour.html(`${labSlots.start}<br />to<br />${labSlots.end}`);
            $labHour.data("start", labSlots.start);
            $labHour.data("end", labSlots.end);
        }
        $("#theory").append($theoryHour);
        $("#lab").append($labHour);
        const days = [
            "mon",
            "tue",
            "wed",
            "thu",
            "fri",
            "sat",
            "sun"
        ];
        for(var i = 0; i < days.length; ++i){
            const $period = $('<td class="period"></td>');
            const day = days[i];
            if (theorySlots && theorySlots.days && day in theorySlots.days) {
                const slot = theorySlots.days[day];
                $period.text(slot);
                $period.addClass(slot);
                $(`#${day}`).show();
                // Add quick buttons for theory slots
                if (!$(`.${slot}-tile`).get(0)) {
                    var index = slot.replace(/[^A-Z]/gi, "").length - 1;
                    while(index >= $quickButtons.find("tr").length)$quickButtons.find("table").append("<tr></tr>");
                    $quickButtons.find("tr").eq(index).append(`<button class="${slot}-tile btn quick-button">${slot}</button>`);
                }
            }
            if (labSlots && labSlots.days && day in labSlots.days) {
                const slot = labSlots.days[day];
                $period.text(($period.text() != "" ? $period.text() + " / " : "") + slot);
                $period.addClass(slot);
                $(`#${day}`).show();
            }
            if ($period.text() == "") $period.attr("disabled", true);
            $(`#${day}`).append($period);
        }
        if (theorySlots && !theorySlots.lunch) ++theoryIndex;
        if (labSlots && !labSlots.lunch) ++labIndex;
    }
    $8994485710ee5faa$var$initializeQuickVisualization();
    /*
        Getting saved data from localforage
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91b00a4bc162400e$exports))).getItem("timetableStorage").then(function(storedValue) {
        $8994485710ee5faa$var$timetableStorage = storedValue || $8994485710ee5faa$var$timetableStorage;
        activeTable = $8994485710ee5faa$var$timetableStorage[0];
        $8994485710ee5faa$var$updatePickerLabel(activeTable.name);
        $8994485710ee5faa$var$fillPage();
        // Renaming the 'Default Table' option
        $("#tt-picker-dropdown .tt-picker-label a").first().attr("data-table-id", activeTable.id).text(activeTable.name);
        $8994485710ee5faa$var$timetableStorage.slice(1).forEach(function(table) {
            $8994485710ee5faa$var$addTableToPicker(table.id, table.name);
        });
    }).catch(console.error);
};
/*
    Function to add a course to the timetable
 */ window.addCourseToTimetable = (courseData)=>{
    courseData.slots.forEach(function(slot) {
        var $divElement = $(`<div 
                data-course="course${courseData.courseId}"
                >${courseData.courseCode}${courseData.venue != "" ? "-" + courseData.venue : ""}</div
            >`);
        if (courseData.slots[0][0] == "L") $divElement.data("is-lab", true);
        else $divElement.data("is-theory", true);
        $(`#timetable tr .${slot}`).addClass("highlight").append($divElement);
        $(`.quick-buttons .${slot}-tile`).addClass("highlight");
    });
    $8994485710ee5faa$var$checkSlotClash();
    $8994485710ee5faa$var$updateLocalForage();
};
/*
    Function to remove a course from the timetable
 */ window.removeCourseFromTimetable = (course)=>{
    $(`#timetable tr td div[data-course="${course}"]`).parent().each(function() {
        if ($(this).children().length != 1) return;
        $(this).removeClass("highlight");
        var slot = this.classList[1];
        if (!$(`.quick-buttons .${slot}-tile`).hasClass("highlight")) return;
        var row = $(this).parent().index();
        var column = $(this).index();
        for(var i = 0; i < activeTable.quick.length; ++i){
            var el = activeTable.quick[i];
            if (el[0] == row && el[1] == column) {
                if ($("#quick-toggle").attr("data-state") == "enabled") $(this).addClass("highlight");
                return;
            }
        }
        $(`.quick-buttons .${slot}-tile`).removeClass("highlight");
    });
    $(`#timetable tr td div[data-course="${course}"]`).remove();
    $8994485710ee5faa$var$checkSlotClash();
    $8994485710ee5faa$var$updateLocalForage();
};
/*
    Function to clear the timetable from the body but not delete it's data
 */ window.clearTimetable = ()=>{
    $("#timetable .period").removeClass("highlight clash");
    $('.quick-buttons *[class*="-tile"]').removeClass("highlight");
    if ($("#timetable tr div[data-course]")) $("#timetable tr div[data-course]").remove();
};


/*
 *  This file contains the events and functions applied to
 *  the course list
 */ $(()=>{
    /*
        Click event to sort the course list
     */ $("#course-list th:not(:last)").on("click", function() {
        var isAscending = false, isDescending = false;
        var $items = $66dff647916ae086$var$retrieveColumnItems($(this));
        if ($(this).hasClass("ascending")) isAscending = true;
        else if ($(this).hasClass("descending")) isDescending = true;
        $("#course-list th").removeClass("ascending descending");
        // Sort the course list in ascending, descending or the default order
        if (!isAscending && !isDescending) {
            $items.sort(function(a, b) {
                return $(a).text() > $(b).text() ? 1 : -1;
            });
            $(this).addClass("ascending");
        } else if (isAscending && !isDescending) {
            $items.sort(function(a, b) {
                return $(a).text() < $(b).text() ? 1 : -1;
            });
            $(this).addClass("descending");
        } else $items.sort(function(a, b) {
            return $(a).parent().data("course") > $(b).parent().data("course") ? 1 : -1;
        });
        var sortedRows = $items.map(function(i, item) {
            return $(item).parent()[0];
        });
        $("#course-list tbody tr").remove();
        $("#course-list tbody").append(sortedRows);
    });
    /*
        Click event to delete a course from the course list
     */ $("#course-list").on("click", ".close", function() {
        var course = $(this).closest("tr").attr("data-course");
        $66dff647916ae086$var$removeCourseFromCourseList(course);
        removeCourseFromTimetable(course);
        var courseId = Number(course.split(/(\d+)/)[1]);
        for(var i = 0; i < activeTable.data.length; ++i)if (activeTable.data[i].courseId == courseId) {
            activeTable.data.splice(i, 1);
            break;
        }
    });
    /*
        Double click event to add a course beck to the panel
     */ $("#course-list").on("dblclick", "tbody tr", function(e) {
        var slotString = $(this).find("td").not("[colspan]").eq($66dff647916ae086$var$getColumnIndex("Slot")).text();
        var courseCode = $(this).find("td").eq($66dff647916ae086$var$getColumnIndex("Course Code")).text();
        var courseTitle = $(this).find("td").eq($66dff647916ae086$var$getColumnIndex("Course Title")).text();
        var faculty = $(this).find("td").eq($66dff647916ae086$var$getColumnIndex("Faculty")).text();
        var venue = $(this).find("td").eq($66dff647916ae086$var$getColumnIndex("Venue")).text();
        var credits = $(this).find("td").eq($66dff647916ae086$var$getColumnIndex("Credits")).text();
        $("#course-input").val(courseCode + " - " + courseTitle);
        $("#faculty-input").val(faculty);
        $("#slot-input").val(slotString);
        $("#venue-input").val(venue);
        $("#credits-input").val(credits);
        addSlotButtons(courseCode);
        // Scroll back to the course panel and delete the course
        $("html, body").animate({
            scrollTop: 0
        }).promise().done(()=>{
            $(this).find(".close").trigger("click");
        });
    });
});
/*
    Function to get a columns index from the course list
 */ function $66dff647916ae086$var$getColumnIndex(column) {
    var columns = Array.from($("#course-list th"), function(el) {
        return el.innerText;
    });
    return columns.indexOf(column.innerText || column);
}
/*
    Function to retrive items from a column in the course list
 */ function $66dff647916ae086$var$retrieveColumnItems($column) {
    var index = $66dff647916ae086$var$getColumnIndex($column.text());
    var $rows = $("#course-list tbody tr");
    var items = $rows.map(function(i, row) {
        return $(row).find("td")[index];
    });
    return items;
}
/*
    Function to update the total credits
 */ function $66dff647916ae086$var$updateCredits() {
    var totalCredits = 0;
    $("#course-list tbody tr").each(function() {
        totalCredits += Number($(this).children("td").eq($66dff647916ae086$var$getColumnIndex("Credits")).text());
    });
    $("#total-credits").text(totalCredits);
}
/*
    Function to insert a course into the course list
 */ window.addCourseToCourseList = (courseData)=>{
    var $courseListItem = $(`<tr
            data-course="course${courseData.courseId}"
            data-is-project="${courseData.isProject}"
        >
            <td>${courseData.slots.join("+")}</td>
            <td>${courseData.courseCode}</td>
            <td>${courseData.courseTitle}</td>
            <td>${courseData.faculty}</td>
            <td>${courseData.venue}</td>
            <td>${courseData.credits}</td>
            <td><i class="fas fa-times close"></i></td>
        </tr>`);
    var nextRow = null;
    var sortedColumn = $("#course-list th.ascending")[0] || $("#course-list th.descending")[0];
    var isAscending = $("#course-list th.ascending")[0] != undefined;
    /*
        If the course list is sorted, the course should be
        inserted at the appropriate position
     */ if (sortedColumn != undefined) {
        var index = $66dff647916ae086$var$getColumnIndex(sortedColumn);
        var $items = $66dff647916ae086$var$retrieveColumnItems($(sortedColumn));
        var currentItem = $courseListItem.find("td")[index];
        for(var i = 0; i < $items.length; i++){
            var item = $items[i];
            if (isAscending) {
                if ($(currentItem).text() <= $(item).text()) {
                    nextRow = $(item).parent();
                    break;
                }
            } else if ($(currentItem).text() >= $(item).text()) {
                nextRow = $(item).parent();
                break;
            }
        }
    }
    if (nextRow === null) $("#course-list tbody").append($courseListItem);
    else nextRow.before($courseListItem);
    $66dff647916ae086$var$updateCredits();
};
/*
    Function to remove a course
 */ function $66dff647916ae086$var$removeCourseFromCourseList(course) {
    $(`#course-list tbody tr[data-course="${course}"]`).remove();
    $66dff647916ae086$var$updateCredits();
}
/*
    Function to clear the course list from the body but not delete it's data
 */ window.clearCourseList = ()=>{
    if ($("#course-list tbody tr[data-course]")) $("#course-list tbody tr[data-course]").remove();
    $66dff647916ae086$var$updateCredits();
};


/*
    Function to set a cookie
 */ function $f0d18cd633613c2b$export$110700823644f4a6(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    var expires = "expires=" + d.toUTCString();
    if (document.cookie === "") document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    else document.cookie = document.cookie + ";" + cname + "=" + cvalue + ";" + expires + ";path=/";
}
function $f0d18cd633613c2b$export$4be65e66cfa2648a(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}
function $f0d18cd633613c2b$export$8cd2d8d9c69a6721() {
    if ("createTouch" in document) try {
        var ignore = /:hover/;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            for(var j = sheet.cssRules.length - 1; j >= 0; j--){
                var rule = sheet.cssRules[j];
                if (rule.type === CSSRule.STYLE_RULE && ignore.test(rule.selectorText)) sheet.deleteRule(j);
            }
        }
    } catch (error) {
        console.error(error);
    }
}


var $5aba746af488a002$exports = {};
$5aba746af488a002$exports = JSON.parse('{"name":"FFCSonTheGo","version":"1.0.0","lastUpdate":{"vellore":"Fall Semester 2026-27","chennai":"Winter Semester 2026-27","ap":"Fall Semester 2023-24"},"repository":"https://github.com/vatz88/FFCSonTheGo.git","author":"Vatsal Joshi <vatz88@gmail.com>","license":"GPL-3.0","private":true,"scripts":{"start":"yarn convert && yarn start:noconvert","start:noconvert":"parcel src/index.html","build:sw":"workbox generateSW ./src/workbox-config.js","build":"yarn convert && parcel build src/index.html && yarn build:sw","convert":"node util/convert_xlsx_to_json.js && node util/convert_json_to_data.js","test":"jest tests","prepare":"husky install"},"engines":{"node":"^20"},"browserslist":"> 0.5%, last 2 versions, not dead","dependencies":{"@fortawesome/fontawesome-free":"^6.4.2","@parcel/core":"^2.10.1","@parcel/packager-raw-url":"2.10.1","@parcel/transformer-sass":"2.10.1","@parcel/transformer-webmanifest":"2.10.1","@popperjs/core":"^2.11.8","@sentry/browser":"^7.119.1","bootstrap":"^5.3.7","bootstrap-select":"^1.13.18","bootstrap4":"npm:bootstrap@4.6.0","date-fns":"^2.30.0","easy-autocomplete":"1.3.5","html2canvas":"^1.4.1","jquery":"3.7.1","localforage":"^1.10.0","parcel":"^2.10.1","sass":"^1.69.5","workbox-cli":"^7.0.0","xlsx":"^0.18.5"},"devDependencies":{"husky":"^8.0.0","jest":"^29.7.0","prettier":"^2.8.8","pretty-quick":"^3.1.3"}}');


const $2cf9f8a7d0fd8c79$var$lastUpdate = $5aba746af488a002$exports.lastUpdate;
$(function() {
    /*
        Remove focus from quick buttons once clicked
     */ $(".quick-buttons .btn").on("click", function() {
        $(this).trigger("blur");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($91b00a4bc162400e$exports))).getItem("campus").then((campus)=>{
        window.location.hash = campus || "#Vellore";
        switchCampus();
        /*
            Event to listen for hash changes
         */ $(window).on("hashchange", ()=>{
            if (window.location.hash === `#${window.campus}`) return;
            new bootstrap.Modal($("#switch-campus-modal").get(0)).show();
        });
    });
    $f0d18cd633613c2b$export$8cd2d8d9c69a6721();
});
/*
    Function to switch campuses
 */ window.switchCampus = ()=>{
    if (window.location.hash.toLowerCase() === "#ap") {
        $("#campus").text("AP Campus");
        $("#last-update").text($2cf9f8a7d0fd8c79$var$lastUpdate.ap);
        window.location.hash = "#AP";
        window.campus = "AP";
    } else if (window.location.hash.toLowerCase() === "#chennai") {
        $("#campus").text("Chennai Campus");
        $("#last-update").text($2cf9f8a7d0fd8c79$var$lastUpdate.chennai);
        window.location.hash = "#Chennai";
        window.campus = "Chennai";
    } else if (window.location.hash.toLowerCase() === "#vellore") {
        $("#campus").text("Vellore Campus");
        $("#last-update").text($2cf9f8a7d0fd8c79$var$lastUpdate.vellore);
        window.location.hash = "#Vellore";
        window.campus = "Vellore";
    } else window.location.hash = `#${window.campus}`;
    (0, (/*@__PURE__*/$parcel$interopDefault($91b00a4bc162400e$exports))).getItem("campus").then((campus)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($91b00a4bc162400e$exports))).setItem("campus", window.campus).catch(console.error);
        if (campus && campus != window.campus) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91b00a4bc162400e$exports))).removeItem("timetableStorage").then(window.location.reload());
            return;
        }
        getCourses();
        initializeTimetable();
    });
};
/*
    Redirect to the GitHub page when Ctrl + U is clicked
    instead of showing the page source code
 */ document.onkeydown = function(e) {
    if (e.ctrlKey && e.key == "u") {
        window.open("https://github.com/vatz88/FFCSonTheGo");
        return false;
    } else return true;
};
/*
    Function to clear all sections
 */ window.resetPage = ()=>{
    clearPanel();
    clearTimetable();
    clearCourseList();
};
/*
    Prompt add to home screen
 */ window.addEventListener("beforeinstallprompt", (e)=>{
    ga("send", {
        hitType: "event",
        eventCategory: "A2H",
        eventAction: "Seen",
        eventLabel: `A2H Shown`
    });
    e.userChoice.then((choiceResult)=>{
        ga("send", {
            hitType: "event",
            eventCategory: "A2H",
            eventAction: "click",
            eventLabel: `A2H ${choiceResult.outcome}`
        });
    });
});

})();
//# sourceMappingURL=index.4eb48a67.js.map
